(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 492);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("react-styleable");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = require("immutable");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target) {
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(307);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	if(options.attrs.type === undefined) {
		options.attrs.type = "text/css";
	}
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var elementTypes;
(function (elementTypes) {
    /** a collection of multiple elements */
    elementTypes["group"] = "group";
    /** indicates a new page on a form */
    elementTypes["page"] = "page";
    elementTypes["heading"] = "heading";
    elementTypes["help"] = "help";
    elementTypes["text"] = "text";
    elementTypes["textArea"] = "textArea";
    elementTypes["duration"] = "duration";
    elementTypes["email"] = "email";
    elementTypes["number"] = "number";
    elementTypes["date"] = "date";
    elementTypes["phone"] = "tel";
    elementTypes["checkbox"] = "checkbox";
    /** a drop-down list */
    elementTypes["select"] = "select";
    /** a likert scale display */
    elementTypes["likert"] = "likert";
    /** a radio button display. also covers the milestone comparison type */
    elementTypes["radio"] = "radio";
    /** a country's way to number you. SSN, for example. */
    elementTypes["nationalId"] = "nationalId";
    elementTypes["time"] = "time";
    elementTypes["attachment"] = "attachment";
    elementTypes["electronicSignature"] = "electronicSignature";
    elementTypes["gisCoordinates"] = "gisCoordinates";
    elementTypes["postalCode"] = "postalCode";
    /** a text element that can specify valid sets of characters  */
    elementTypes["specialText"] = "specialText";
    /** displays label text as markdown */
    elementTypes["html"] = "html-label";
    /** displays information about an email that was sent */
    elementTypes["emailNotification"] = "emailNotification";
    elementTypes["ignore"] = "ignore";
    elementTypes["unsupported"] = "unsupported";
    elementTypes["undefined"] = "unknown";
})(elementTypes = exports.elementTypes || (exports.elementTypes = {}));
/** ISO 3166 alpha-3 (3 char) country codes, used especially by postal organizations */
var countryCodes;
(function (countryCodes) {
    countryCodes["UnitedKingdom"] = "GBR";
    countryCodes["Canada"] = "CAN";
    countryCodes["UnitedStates"] = "USA";
})(countryCodes = exports.countryCodes || (exports.countryCodes = {}));
/** used for date validation */
var CountryEnum;
(function (CountryEnum) {
    CountryEnum["Canada"] = "CA";
    CountryEnum["UnitedKingdom"] = "UK";
    CountryEnum["UnitedStates"] = "US";
})(CountryEnum = exports.CountryEnum || (exports.CountryEnum = {}));
var numericElementTypes;
(function (numericElementTypes) {
    numericElementTypes["RAW_NUMBER"] = "raw";
    numericElementTypes["PERCENTAGE"] = "percentage";
    numericElementTypes["MONEY"] = "money";
    numericElementTypes["UNDEFINED"] = "undefined";
})(numericElementTypes = exports.numericElementTypes || (exports.numericElementTypes = {}));
var nationalIdTypes;
(function (nationalIdTypes) {
    nationalIdTypes["SSN"] = "ssn";
    nationalIdTypes["SIN"] = "sin";
})(nationalIdTypes = exports.nationalIdTypes || (exports.nationalIdTypes = {}));
var timePeriod;
(function (timePeriod) {
    timePeriod["AM"] = "AM";
    timePeriod["PM"] = "PM";
})(timePeriod = exports.timePeriod || (exports.timePeriod = {}));
/** This defines different default styles that the GroupElement can have. TODO: expand in PP-1431 */
var groupTypes;
(function (groupTypes) {
    /** This will have a default style that indents the subElements and changes their label to a field label */
    groupTypes["INDENTED"] = "indented";
    /** This will have a default style that places the subElements on a single row and changes their label to a field label */
    groupTypes["INLINE"] = "inline";
    /** This will add no default style, this forces the user to manually set the styles for this element */
    groupTypes["CUSTOM"] = "custom";
})(groupTypes = exports.groupTypes || (exports.groupTypes = {}));
/** Determines how the signature element behaves and saves data. */
var electronicSignatureModes;
(function (electronicSignatureModes) {
    /** Data output is in ETO's proprietary coordinate format */
    electronicSignatureModes["ETO"] = "eto";
    /** Data output is an image URL */
    electronicSignatureModes["APRICOT"] = "apricot";
})(electronicSignatureModes = exports.electronicSignatureModes || (exports.electronicSignatureModes = {}));
/** This defines allowed types of text that can be entered on a SpecialTextElement */
var specialTextTypes;
(function (specialTextTypes) {
    /** This will allow any kind of text to be entered */
    specialTextTypes["ANY"] = "any";
    /** this will allow only numbers to be entered */
    specialTextTypes["NUMERIC"] = "numeric";
    /** this will allow only letters to be entered */
    specialTextTypes["ALPHA"] = "alpha";
    /** this will allow only letters and numbers to be entered */
    specialTextTypes["ALPHA_NUMERIC"] = "alphaNumeric";
})(specialTextTypes = exports.specialTextTypes || (exports.specialTextTypes = {}));
/** These are different ways that subElements of a group element  */
var requireType;
(function (requireType) {
    /** all subElements will be required */
    requireType["ALL"] = "require.all";
    /** only some of the subElements will be required */
    requireType["SOME"] = "require.some";
    /** completing any of the subElements will satisfy the required definition */
    requireType["ANY"] = "require.any";
})(requireType = exports.requireType || (exports.requireType = {}));
/** These are different ways that subElements of a group element  */
var dataFormatType;
(function (dataFormatType) {
    /** the group element does not have a representation of the combined element value */
    dataFormatType["NONE"] = "data-format.none";
    /** group has a multiple choice element and a text other option that combine to be the complete value*/
    dataFormatType["MULTIPLE_CHOICE_OTHER"] = "data-format.mc-other";
    /** group has a zip code and an extension, that combine into a single string value */
    dataFormatType["ZIP_EXTENSION"] = "data-format.zip-extension";
})(dataFormatType = exports.dataFormatType || (exports.dataFormatType = {}));
//# sourceMappingURL=form-constants.js.map

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("classnames");

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var rulesEngine = __webpack_require__(156);
exports.rulesEngine = rulesEngine;
var validation = __webpack_require__(163);
exports.validation = validation;
var formDefinition = __webpack_require__(17);
exports.formDefinition = formDefinition;
var utilities = __webpack_require__(22);
exports.utilities = utilities;
var adapters = __webpack_require__(119);
exports.adapters = adapters;
//# sourceMappingURL=index.js.map

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var defaultElementStyles = {
    group: 'ssg-forms-element validated-section',
    label: 'ssg-forms-label',
    labelWrapper: 'tooltip-group',
    requiredIndicator: 'ssg-forms-required-indicator',
    inputWrapper: '',
    tooltipGroup: 'tooltip-group',
    inlineErrorDisplay: '',
};
exports.defaultElementStyles = defaultElementStyles;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var descriptors = __webpack_require__(19);
exports.descriptors = descriptors;
var tabs_1 = __webpack_require__(411);
exports.InPlaceTabsComponent = tabs_1.InPlaceTabsComponent;
exports.TabsComponent = tabs_1.TabsComponent;
exports.defaultTabsStyle = tabs_1.defaultTabsStyle;
var copy_button_1 = __webpack_require__(371);
exports.CopyButton = copy_button_1.CopyButton;
var modal_1 = __webpack_require__(388);
exports.ModalWindow = modal_1.ModalWindow;
var save_button_1 = __webpack_require__(35);
exports.SaveButton = save_button_1.SaveButton;
var cancel_button_1 = __webpack_require__(363);
exports.CancelButton = cancel_button_1.CancelButton;
var paging_control_1 = __webpack_require__(111);
exports.PagingControl = paging_control_1.PagingControl;
exports.defaultPagingControlStyle = paging_control_1.defaultPagingControlStyle;
var table_1 = __webpack_require__(114);
exports.Table = table_1.Table;
exports.defaultTableStyle = table_1.defaultTableStyle;
var paged_list_1 = __webpack_require__(397);
exports.PagedList = paged_list_1.PagedList;
exports.pagingActions = paged_list_1.pagingActions;
exports.pagingReducer = paged_list_1.pagingReducer;
var accessibility_helper_functions_1 = __webpack_require__(32);
exports.trapFocus = accessibility_helper_functions_1.trapFocus;
exports.subElementNavigation = accessibility_helper_functions_1.subElementNavigation;
exports.isInsideElement = accessibility_helper_functions_1.isInsideElement;
exports.isFocusable = accessibility_helper_functions_1.isFocusable;
var attachment_helper_functions_1 = __webpack_require__(360);
exports.processDownloadedAttachment = attachment_helper_functions_1.processDownloadedAttachment;
exports.getAttachmentData = attachment_helper_functions_1.getAttachmentData;
var custom_icon_1 = __webpack_require__(18);
exports.CustomIcon = custom_icon_1.CustomIcon;
exports.CustomIconSet = custom_icon_1.CustomIconSet;
var accessibility_notifications_1 = __webpack_require__(102);
exports.accessibilityNotificationsEmitter = accessibility_notifications_1.accessibilityNotificationsEmitter;
exports.AccessibilityNotifications = accessibility_notifications_1.AccessibilityNotifications;
var tooltip_1 = __webpack_require__(413);
exports.TooltipDisplay = tooltip_1.TooltipDisplay;
var confirm_modal_1 = __webpack_require__(368);
exports.ConfirmModalWindow = confirm_modal_1.ConfirmModalWindow;
var loading_pane_1 = __webpack_require__(380);
exports.LoadingPane = loading_pane_1.LoadingPane;
var widget_1 = __webpack_require__(416);
exports.Widget = widget_1.Widget;
var search_1 = __webpack_require__(405);
exports.SearchBar = search_1.SearchBar;
exports.HighlightText = search_1.HighlightText;
exports.searchUtilities = search_1.searchUtilities;
var image_display_1 = __webpack_require__(379);
exports.ImageDisplay = image_display_1.ImageDisplay;
var wizard_1 = __webpack_require__(419);
exports.Wizard = wizard_1.Wizard;
var menu_1 = __webpack_require__(383);
exports.Menu = menu_1.Menu;
exports.MenuButton = menu_1.MenuButton;
var navigation_1 = __webpack_require__(392);
exports.Header = navigation_1.Header;
exports.Nav = navigation_1.Nav;
exports.NavSection = navigation_1.NavSection;
exports.SsgNavLink = navigation_1.SsgNavLink;
exports.navIconStyle = navigation_1.navIconStyle;
exports.Application = navigation_1.Application;
var collapsible_section_1 = __webpack_require__(365);
exports.CollapsibleSection = collapsible_section_1.CollapsibleSection;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inline_warning_list_1 = __webpack_require__(315);
exports.InlineWarningList = inline_warning_list_1.default;
var inline_warning_1 = __webpack_require__(316);
exports.InlineWarning = inline_warning_1.default;
var form_error_1 = __webpack_require__(312);
exports.FormError = form_error_1.FormError;
var collapsible_error_display_1 = __webpack_require__(310);
exports.CollapsibleErrorDisplay = collapsible_error_display_1.CollapsibleErrorDisplay;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var element_error_display_1 = __webpack_require__(311);
var ssg_forms_processing_1 = __webpack_require__(7);
var immutable_1 = __webpack_require__(2);
/**
 * Function that determines which inline errors that should be displayed for the respective form element. It makes this determination
 * on the element's value and showValue properties.
 * @param errors list of errors associated with the element
 * @param showErrors whether or not this element's errors should be shown
 * @param hasValue whether or not the element has a value response - 'inline' type errors not shown when value has not been set
 */
function getElementErrorDisplay(errors, showErrors, hasValue) {
    var globalTypes = errors && errors.filter(function (err) { return err.type === ssg_forms_processing_1.validation.errorTypes.global; });
    var inlineTypes = errors && errors.filter(function (err) { return err.type === ssg_forms_processing_1.validation.errorTypes.inline; });
    var globalErrors = immutable_1.List(globalTypes);
    var inlineErrors = immutable_1.List(inlineTypes);
    var displayErrors;
    if (showErrors && !globalErrors.isEmpty()) {
        displayErrors = globalErrors.toList();
    }
    else if (globalErrors.isEmpty() && !inlineErrors.isEmpty() && hasValue) {
        displayErrors = inlineErrors.toList();
    }
    var errorIds = '';
    displayErrors && displayErrors.forEach(function (error) { return errorIds += (error.id + ' '); });
    var errorDisplay = new element_error_display_1.default(displayErrors, errorIds);
    return errorDisplay;
}
exports.getElementErrorDisplay = getElementErrorDisplay;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var form_element_base_1 = __webpack_require__(40);
exports.defaultValues = __assign({}, form_element_base_1.defaultValues, { isRequired: false, readOnly: false, autoComplete: "on", tooltip: '' });
//# sourceMappingURL=form-input-element-base.js.map

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fas", function() { return _iconsCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prefix", function() { return prefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAd", function() { return faAd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAddressBook", function() { return faAddressBook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAddressCard", function() { return faAddressCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAdjust", function() { return faAdjust; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAirFreshener", function() { return faAirFreshener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAlignCenter", function() { return faAlignCenter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAlignJustify", function() { return faAlignJustify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAlignLeft", function() { return faAlignLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAlignRight", function() { return faAlignRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAllergies", function() { return faAllergies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAmbulance", function() { return faAmbulance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAmericanSignLanguageInterpreting", function() { return faAmericanSignLanguageInterpreting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAnchor", function() { return faAnchor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAngleDoubleDown", function() { return faAngleDoubleDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAngleDoubleLeft", function() { return faAngleDoubleLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAngleDoubleRight", function() { return faAngleDoubleRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAngleDoubleUp", function() { return faAngleDoubleUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAngleDown", function() { return faAngleDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAngleLeft", function() { return faAngleLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAngleRight", function() { return faAngleRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAngleUp", function() { return faAngleUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAngry", function() { return faAngry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAnkh", function() { return faAnkh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAppleAlt", function() { return faAppleAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faArchive", function() { return faArchive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faArchway", function() { return faArchway; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faArrowAltCircleDown", function() { return faArrowAltCircleDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faArrowAltCircleLeft", function() { return faArrowAltCircleLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faArrowAltCircleRight", function() { return faArrowAltCircleRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faArrowAltCircleUp", function() { return faArrowAltCircleUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faArrowCircleDown", function() { return faArrowCircleDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faArrowCircleLeft", function() { return faArrowCircleLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faArrowCircleRight", function() { return faArrowCircleRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faArrowCircleUp", function() { return faArrowCircleUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faArrowDown", function() { return faArrowDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faArrowLeft", function() { return faArrowLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faArrowRight", function() { return faArrowRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faArrowUp", function() { return faArrowUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faArrowsAlt", function() { return faArrowsAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faArrowsAltH", function() { return faArrowsAltH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faArrowsAltV", function() { return faArrowsAltV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAssistiveListeningSystems", function() { return faAssistiveListeningSystems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAsterisk", function() { return faAsterisk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAt", function() { return faAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAtlas", function() { return faAtlas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAtom", function() { return faAtom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAudioDescription", function() { return faAudioDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faAward", function() { return faAward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBackspace", function() { return faBackspace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBackward", function() { return faBackward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBalanceScale", function() { return faBalanceScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBan", function() { return faBan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBandAid", function() { return faBandAid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBarcode", function() { return faBarcode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBars", function() { return faBars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBaseballBall", function() { return faBaseballBall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBasketballBall", function() { return faBasketballBall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBath", function() { return faBath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBatteryEmpty", function() { return faBatteryEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBatteryFull", function() { return faBatteryFull; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBatteryHalf", function() { return faBatteryHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBatteryQuarter", function() { return faBatteryQuarter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBatteryThreeQuarters", function() { return faBatteryThreeQuarters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBed", function() { return faBed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBeer", function() { return faBeer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBell", function() { return faBell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBellSlash", function() { return faBellSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBezierCurve", function() { return faBezierCurve; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBible", function() { return faBible; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBicycle", function() { return faBicycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBinoculars", function() { return faBinoculars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBirthdayCake", function() { return faBirthdayCake; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBlender", function() { return faBlender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBlind", function() { return faBlind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBold", function() { return faBold; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBolt", function() { return faBolt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBomb", function() { return faBomb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBone", function() { return faBone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBong", function() { return faBong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBook", function() { return faBook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBookOpen", function() { return faBookOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBookReader", function() { return faBookReader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBookmark", function() { return faBookmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBowlingBall", function() { return faBowlingBall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBox", function() { return faBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBoxOpen", function() { return faBoxOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBoxes", function() { return faBoxes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBraille", function() { return faBraille; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBrain", function() { return faBrain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBriefcase", function() { return faBriefcase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBriefcaseMedical", function() { return faBriefcaseMedical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBroadcastTower", function() { return faBroadcastTower; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBroom", function() { return faBroom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBrush", function() { return faBrush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBug", function() { return faBug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBuilding", function() { return faBuilding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBullhorn", function() { return faBullhorn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBullseye", function() { return faBullseye; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBurn", function() { return faBurn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBus", function() { return faBus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBusAlt", function() { return faBusAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faBusinessTime", function() { return faBusinessTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCalculator", function() { return faCalculator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCalendar", function() { return faCalendar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCalendarAlt", function() { return faCalendarAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCalendarCheck", function() { return faCalendarCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCalendarMinus", function() { return faCalendarMinus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCalendarPlus", function() { return faCalendarPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCalendarTimes", function() { return faCalendarTimes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCamera", function() { return faCamera; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCameraRetro", function() { return faCameraRetro; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCannabis", function() { return faCannabis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCapsules", function() { return faCapsules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCar", function() { return faCar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCarAlt", function() { return faCarAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCarBattery", function() { return faCarBattery; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCarCrash", function() { return faCarCrash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCarSide", function() { return faCarSide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCaretDown", function() { return faCaretDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCaretLeft", function() { return faCaretLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCaretRight", function() { return faCaretRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCaretSquareDown", function() { return faCaretSquareDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCaretSquareLeft", function() { return faCaretSquareLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCaretSquareRight", function() { return faCaretSquareRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCaretSquareUp", function() { return faCaretSquareUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCaretUp", function() { return faCaretUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCartArrowDown", function() { return faCartArrowDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCartPlus", function() { return faCartPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCertificate", function() { return faCertificate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChalkboard", function() { return faChalkboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChalkboardTeacher", function() { return faChalkboardTeacher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChargingStation", function() { return faChargingStation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChartArea", function() { return faChartArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChartBar", function() { return faChartBar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChartLine", function() { return faChartLine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChartPie", function() { return faChartPie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCheck", function() { return faCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCheckCircle", function() { return faCheckCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCheckDouble", function() { return faCheckDouble; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCheckSquare", function() { return faCheckSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChess", function() { return faChess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChessBishop", function() { return faChessBishop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChessBoard", function() { return faChessBoard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChessKing", function() { return faChessKing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChessKnight", function() { return faChessKnight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChessPawn", function() { return faChessPawn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChessQueen", function() { return faChessQueen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChessRook", function() { return faChessRook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChevronCircleDown", function() { return faChevronCircleDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChevronCircleLeft", function() { return faChevronCircleLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChevronCircleRight", function() { return faChevronCircleRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChevronCircleUp", function() { return faChevronCircleUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChevronDown", function() { return faChevronDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChevronLeft", function() { return faChevronLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChevronRight", function() { return faChevronRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChevronUp", function() { return faChevronUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChild", function() { return faChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faChurch", function() { return faChurch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCircle", function() { return faCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCircleNotch", function() { return faCircleNotch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCity", function() { return faCity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faClipboard", function() { return faClipboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faClipboardCheck", function() { return faClipboardCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faClipboardList", function() { return faClipboardList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faClock", function() { return faClock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faClone", function() { return faClone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faClosedCaptioning", function() { return faClosedCaptioning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCloud", function() { return faCloud; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCloudDownloadAlt", function() { return faCloudDownloadAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCloudUploadAlt", function() { return faCloudUploadAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCocktail", function() { return faCocktail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCode", function() { return faCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCodeBranch", function() { return faCodeBranch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCoffee", function() { return faCoffee; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCog", function() { return faCog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCogs", function() { return faCogs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCoins", function() { return faCoins; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faColumns", function() { return faColumns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faComment", function() { return faComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCommentAlt", function() { return faCommentAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCommentDollar", function() { return faCommentDollar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCommentDots", function() { return faCommentDots; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCommentSlash", function() { return faCommentSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faComments", function() { return faComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCommentsDollar", function() { return faCommentsDollar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCompactDisc", function() { return faCompactDisc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCompass", function() { return faCompass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCompress", function() { return faCompress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faConciergeBell", function() { return faConciergeBell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCookie", function() { return faCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCookieBite", function() { return faCookieBite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCopy", function() { return faCopy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCopyright", function() { return faCopyright; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCouch", function() { return faCouch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCreditCard", function() { return faCreditCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCrop", function() { return faCrop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCropAlt", function() { return faCropAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCross", function() { return faCross; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCrosshairs", function() { return faCrosshairs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCrow", function() { return faCrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCrown", function() { return faCrown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCube", function() { return faCube; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCubes", function() { return faCubes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faCut", function() { return faCut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDatabase", function() { return faDatabase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDeaf", function() { return faDeaf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDesktop", function() { return faDesktop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDharmachakra", function() { return faDharmachakra; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDiagnoses", function() { return faDiagnoses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDice", function() { return faDice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDiceFive", function() { return faDiceFive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDiceFour", function() { return faDiceFour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDiceOne", function() { return faDiceOne; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDiceSix", function() { return faDiceSix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDiceThree", function() { return faDiceThree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDiceTwo", function() { return faDiceTwo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDigitalTachograph", function() { return faDigitalTachograph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDirections", function() { return faDirections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDivide", function() { return faDivide; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDizzy", function() { return faDizzy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDna", function() { return faDna; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDollarSign", function() { return faDollarSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDolly", function() { return faDolly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDollyFlatbed", function() { return faDollyFlatbed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDonate", function() { return faDonate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDoorClosed", function() { return faDoorClosed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDoorOpen", function() { return faDoorOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDotCircle", function() { return faDotCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDove", function() { return faDove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDownload", function() { return faDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDraftingCompass", function() { return faDraftingCompass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDrawPolygon", function() { return faDrawPolygon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDrum", function() { return faDrum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDrumSteelpan", function() { return faDrumSteelpan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faDumbbell", function() { return faDumbbell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faEdit", function() { return faEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faEject", function() { return faEject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faEllipsisH", function() { return faEllipsisH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faEllipsisV", function() { return faEllipsisV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faEnvelope", function() { return faEnvelope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faEnvelopeOpen", function() { return faEnvelopeOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faEnvelopeOpenText", function() { return faEnvelopeOpenText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faEnvelopeSquare", function() { return faEnvelopeSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faEquals", function() { return faEquals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faEraser", function() { return faEraser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faEuroSign", function() { return faEuroSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faExchangeAlt", function() { return faExchangeAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faExclamation", function() { return faExclamation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faExclamationCircle", function() { return faExclamationCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faExclamationTriangle", function() { return faExclamationTriangle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faExpand", function() { return faExpand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faExpandArrowsAlt", function() { return faExpandArrowsAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faExternalLinkAlt", function() { return faExternalLinkAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faExternalLinkSquareAlt", function() { return faExternalLinkSquareAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faEye", function() { return faEye; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faEyeDropper", function() { return faEyeDropper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faEyeSlash", function() { return faEyeSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFastBackward", function() { return faFastBackward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFastForward", function() { return faFastForward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFax", function() { return faFax; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFeather", function() { return faFeather; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFeatherAlt", function() { return faFeatherAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFemale", function() { return faFemale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFighterJet", function() { return faFighterJet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFile", function() { return faFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileAlt", function() { return faFileAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileArchive", function() { return faFileArchive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileAudio", function() { return faFileAudio; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileCode", function() { return faFileCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileContract", function() { return faFileContract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileDownload", function() { return faFileDownload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileExcel", function() { return faFileExcel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileExport", function() { return faFileExport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileImage", function() { return faFileImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileImport", function() { return faFileImport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileInvoice", function() { return faFileInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileInvoiceDollar", function() { return faFileInvoiceDollar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileMedical", function() { return faFileMedical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileMedicalAlt", function() { return faFileMedicalAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFilePdf", function() { return faFilePdf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFilePowerpoint", function() { return faFilePowerpoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFilePrescription", function() { return faFilePrescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileSignature", function() { return faFileSignature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileUpload", function() { return faFileUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileVideo", function() { return faFileVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFileWord", function() { return faFileWord; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFill", function() { return faFill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFillDrip", function() { return faFillDrip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFilm", function() { return faFilm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFilter", function() { return faFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFingerprint", function() { return faFingerprint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFire", function() { return faFire; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFireExtinguisher", function() { return faFireExtinguisher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFirstAid", function() { return faFirstAid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFish", function() { return faFish; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFlag", function() { return faFlag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFlagCheckered", function() { return faFlagCheckered; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFlask", function() { return faFlask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFlushed", function() { return faFlushed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFolder", function() { return faFolder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFolderMinus", function() { return faFolderMinus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFolderOpen", function() { return faFolderOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFolderPlus", function() { return faFolderPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFont", function() { return faFont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFontAwesomeLogoFull", function() { return faFontAwesomeLogoFull; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFootballBall", function() { return faFootballBall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faForward", function() { return faForward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFrog", function() { return faFrog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFrown", function() { return faFrown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFrownOpen", function() { return faFrownOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFunnelDollar", function() { return faFunnelDollar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faFutbol", function() { return faFutbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGamepad", function() { return faGamepad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGasPump", function() { return faGasPump; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGavel", function() { return faGavel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGem", function() { return faGem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGenderless", function() { return faGenderless; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGift", function() { return faGift; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGlassMartini", function() { return faGlassMartini; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGlassMartiniAlt", function() { return faGlassMartiniAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGlasses", function() { return faGlasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGlobe", function() { return faGlobe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGlobeAfrica", function() { return faGlobeAfrica; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGlobeAmericas", function() { return faGlobeAmericas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGlobeAsia", function() { return faGlobeAsia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGolfBall", function() { return faGolfBall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGopuram", function() { return faGopuram; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGraduationCap", function() { return faGraduationCap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGreaterThan", function() { return faGreaterThan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGreaterThanEqual", function() { return faGreaterThanEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGrimace", function() { return faGrimace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGrin", function() { return faGrin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGrinAlt", function() { return faGrinAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGrinBeam", function() { return faGrinBeam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGrinBeamSweat", function() { return faGrinBeamSweat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGrinHearts", function() { return faGrinHearts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGrinSquint", function() { return faGrinSquint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGrinSquintTears", function() { return faGrinSquintTears; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGrinStars", function() { return faGrinStars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGrinTears", function() { return faGrinTears; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGrinTongue", function() { return faGrinTongue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGrinTongueSquint", function() { return faGrinTongueSquint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGrinTongueWink", function() { return faGrinTongueWink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGrinWink", function() { return faGrinWink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGripHorizontal", function() { return faGripHorizontal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faGripVertical", function() { return faGripVertical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHSquare", function() { return faHSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHamsa", function() { return faHamsa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHandHolding", function() { return faHandHolding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHandHoldingHeart", function() { return faHandHoldingHeart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHandHoldingUsd", function() { return faHandHoldingUsd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHandLizard", function() { return faHandLizard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHandPaper", function() { return faHandPaper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHandPeace", function() { return faHandPeace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHandPointDown", function() { return faHandPointDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHandPointLeft", function() { return faHandPointLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHandPointRight", function() { return faHandPointRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHandPointUp", function() { return faHandPointUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHandPointer", function() { return faHandPointer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHandRock", function() { return faHandRock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHandScissors", function() { return faHandScissors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHandSpock", function() { return faHandSpock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHands", function() { return faHands; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHandsHelping", function() { return faHandsHelping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHandshake", function() { return faHandshake; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHashtag", function() { return faHashtag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHaykal", function() { return faHaykal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHdd", function() { return faHdd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHeading", function() { return faHeading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHeadphones", function() { return faHeadphones; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHeadphonesAlt", function() { return faHeadphonesAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHeadset", function() { return faHeadset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHeart", function() { return faHeart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHeartbeat", function() { return faHeartbeat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHelicopter", function() { return faHelicopter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHighlighter", function() { return faHighlighter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHistory", function() { return faHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHockeyPuck", function() { return faHockeyPuck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHome", function() { return faHome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHospital", function() { return faHospital; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHospitalAlt", function() { return faHospitalAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHospitalSymbol", function() { return faHospitalSymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHotTub", function() { return faHotTub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHotel", function() { return faHotel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHourglass", function() { return faHourglass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHourglassEnd", function() { return faHourglassEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHourglassHalf", function() { return faHourglassHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faHourglassStart", function() { return faHourglassStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faICursor", function() { return faICursor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faIdBadge", function() { return faIdBadge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faIdCard", function() { return faIdCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faIdCardAlt", function() { return faIdCardAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faImage", function() { return faImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faImages", function() { return faImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faInbox", function() { return faInbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faIndent", function() { return faIndent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faIndustry", function() { return faIndustry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faInfinity", function() { return faInfinity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faInfo", function() { return faInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faInfoCircle", function() { return faInfoCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faItalic", function() { return faItalic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faJedi", function() { return faJedi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faJoint", function() { return faJoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faJournalWhills", function() { return faJournalWhills; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faKaaba", function() { return faKaaba; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faKey", function() { return faKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faKeyboard", function() { return faKeyboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faKhanda", function() { return faKhanda; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faKiss", function() { return faKiss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faKissBeam", function() { return faKissBeam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faKissWinkHeart", function() { return faKissWinkHeart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faKiwiBird", function() { return faKiwiBird; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLandmark", function() { return faLandmark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLanguage", function() { return faLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLaptop", function() { return faLaptop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLaptopCode", function() { return faLaptopCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLaugh", function() { return faLaugh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLaughBeam", function() { return faLaughBeam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLaughSquint", function() { return faLaughSquint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLaughWink", function() { return faLaughWink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLayerGroup", function() { return faLayerGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLeaf", function() { return faLeaf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLemon", function() { return faLemon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLessThan", function() { return faLessThan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLessThanEqual", function() { return faLessThanEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLevelDownAlt", function() { return faLevelDownAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLevelUpAlt", function() { return faLevelUpAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLifeRing", function() { return faLifeRing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLightbulb", function() { return faLightbulb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLink", function() { return faLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLiraSign", function() { return faLiraSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faList", function() { return faList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faListAlt", function() { return faListAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faListOl", function() { return faListOl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faListUl", function() { return faListUl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLocationArrow", function() { return faLocationArrow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLock", function() { return faLock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLockOpen", function() { return faLockOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLongArrowAltDown", function() { return faLongArrowAltDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLongArrowAltLeft", function() { return faLongArrowAltLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLongArrowAltRight", function() { return faLongArrowAltRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLongArrowAltUp", function() { return faLongArrowAltUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLowVision", function() { return faLowVision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faLuggageCart", function() { return faLuggageCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMagic", function() { return faMagic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMagnet", function() { return faMagnet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMailBulk", function() { return faMailBulk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMale", function() { return faMale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMap", function() { return faMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMapMarked", function() { return faMapMarked; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMapMarkedAlt", function() { return faMapMarkedAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMapMarker", function() { return faMapMarker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMapMarkerAlt", function() { return faMapMarkerAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMapPin", function() { return faMapPin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMapSigns", function() { return faMapSigns; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMarker", function() { return faMarker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMars", function() { return faMars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMarsDouble", function() { return faMarsDouble; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMarsStroke", function() { return faMarsStroke; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMarsStrokeH", function() { return faMarsStrokeH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMarsStrokeV", function() { return faMarsStrokeV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMedal", function() { return faMedal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMedkit", function() { return faMedkit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMeh", function() { return faMeh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMehBlank", function() { return faMehBlank; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMehRollingEyes", function() { return faMehRollingEyes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMemory", function() { return faMemory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMenorah", function() { return faMenorah; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMercury", function() { return faMercury; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMicrochip", function() { return faMicrochip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMicrophone", function() { return faMicrophone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMicrophoneAlt", function() { return faMicrophoneAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMicrophoneAltSlash", function() { return faMicrophoneAltSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMicrophoneSlash", function() { return faMicrophoneSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMicroscope", function() { return faMicroscope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMinus", function() { return faMinus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMinusCircle", function() { return faMinusCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMinusSquare", function() { return faMinusSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMobile", function() { return faMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMobileAlt", function() { return faMobileAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMoneyBill", function() { return faMoneyBill; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMoneyBillAlt", function() { return faMoneyBillAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMoneyBillWave", function() { return faMoneyBillWave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMoneyBillWaveAlt", function() { return faMoneyBillWaveAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMoneyCheck", function() { return faMoneyCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMoneyCheckAlt", function() { return faMoneyCheckAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMonument", function() { return faMonument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMoon", function() { return faMoon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMortarPestle", function() { return faMortarPestle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMosque", function() { return faMosque; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMotorcycle", function() { return faMotorcycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMousePointer", function() { return faMousePointer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faMusic", function() { return faMusic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faNeuter", function() { return faNeuter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faNewspaper", function() { return faNewspaper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faNotEqual", function() { return faNotEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faNotesMedical", function() { return faNotesMedical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faObjectGroup", function() { return faObjectGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faObjectUngroup", function() { return faObjectUngroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faOilCan", function() { return faOilCan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faOm", function() { return faOm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faOutdent", function() { return faOutdent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPaintBrush", function() { return faPaintBrush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPaintRoller", function() { return faPaintRoller; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPalette", function() { return faPalette; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPallet", function() { return faPallet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPaperPlane", function() { return faPaperPlane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPaperclip", function() { return faPaperclip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faParachuteBox", function() { return faParachuteBox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faParagraph", function() { return faParagraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faParking", function() { return faParking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPassport", function() { return faPassport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPastafarianism", function() { return faPastafarianism; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPaste", function() { return faPaste; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPause", function() { return faPause; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPauseCircle", function() { return faPauseCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPaw", function() { return faPaw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPeace", function() { return faPeace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPen", function() { return faPen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPenAlt", function() { return faPenAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPenFancy", function() { return faPenFancy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPenNib", function() { return faPenNib; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPenSquare", function() { return faPenSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPencilAlt", function() { return faPencilAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPencilRuler", function() { return faPencilRuler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPeopleCarry", function() { return faPeopleCarry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPercent", function() { return faPercent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPercentage", function() { return faPercentage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPhone", function() { return faPhone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPhoneSlash", function() { return faPhoneSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPhoneSquare", function() { return faPhoneSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPhoneVolume", function() { return faPhoneVolume; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPiggyBank", function() { return faPiggyBank; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPills", function() { return faPills; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPlaceOfWorship", function() { return faPlaceOfWorship; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPlane", function() { return faPlane; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPlaneArrival", function() { return faPlaneArrival; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPlaneDeparture", function() { return faPlaneDeparture; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPlay", function() { return faPlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPlayCircle", function() { return faPlayCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPlug", function() { return faPlug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPlus", function() { return faPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPlusCircle", function() { return faPlusCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPlusSquare", function() { return faPlusSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPodcast", function() { return faPodcast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPoll", function() { return faPoll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPollH", function() { return faPollH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPoo", function() { return faPoo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPoop", function() { return faPoop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPortrait", function() { return faPortrait; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPoundSign", function() { return faPoundSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPowerOff", function() { return faPowerOff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPray", function() { return faPray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPrayingHands", function() { return faPrayingHands; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPrescription", function() { return faPrescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPrescriptionBottle", function() { return faPrescriptionBottle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPrescriptionBottleAlt", function() { return faPrescriptionBottleAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPrint", function() { return faPrint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faProcedures", function() { return faProcedures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faProjectDiagram", function() { return faProjectDiagram; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faPuzzlePiece", function() { return faPuzzlePiece; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faQrcode", function() { return faQrcode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faQuestion", function() { return faQuestion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faQuestionCircle", function() { return faQuestionCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faQuidditch", function() { return faQuidditch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faQuoteLeft", function() { return faQuoteLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faQuoteRight", function() { return faQuoteRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faQuran", function() { return faQuran; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRandom", function() { return faRandom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faReceipt", function() { return faReceipt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRecycle", function() { return faRecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRedo", function() { return faRedo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRedoAlt", function() { return faRedoAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRegistered", function() { return faRegistered; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faReply", function() { return faReply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faReplyAll", function() { return faReplyAll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRetweet", function() { return faRetweet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRibbon", function() { return faRibbon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRoad", function() { return faRoad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRobot", function() { return faRobot; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRocket", function() { return faRocket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRoute", function() { return faRoute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRss", function() { return faRss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRssSquare", function() { return faRssSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRubleSign", function() { return faRubleSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRuler", function() { return faRuler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRulerCombined", function() { return faRulerCombined; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRulerHorizontal", function() { return faRulerHorizontal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRulerVertical", function() { return faRulerVertical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faRupeeSign", function() { return faRupeeSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSadCry", function() { return faSadCry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSadTear", function() { return faSadTear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSave", function() { return faSave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSchool", function() { return faSchool; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faScrewdriver", function() { return faScrewdriver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSearch", function() { return faSearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSearchDollar", function() { return faSearchDollar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSearchLocation", function() { return faSearchLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSearchMinus", function() { return faSearchMinus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSearchPlus", function() { return faSearchPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSeedling", function() { return faSeedling; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faServer", function() { return faServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faShapes", function() { return faShapes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faShare", function() { return faShare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faShareAlt", function() { return faShareAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faShareAltSquare", function() { return faShareAltSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faShareSquare", function() { return faShareSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faShekelSign", function() { return faShekelSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faShieldAlt", function() { return faShieldAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faShip", function() { return faShip; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faShippingFast", function() { return faShippingFast; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faShoePrints", function() { return faShoePrints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faShoppingBag", function() { return faShoppingBag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faShoppingBasket", function() { return faShoppingBasket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faShoppingCart", function() { return faShoppingCart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faShower", function() { return faShower; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faShuttleVan", function() { return faShuttleVan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSign", function() { return faSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSignInAlt", function() { return faSignInAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSignLanguage", function() { return faSignLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSignOutAlt", function() { return faSignOutAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSignal", function() { return faSignal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSignature", function() { return faSignature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSitemap", function() { return faSitemap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSkull", function() { return faSkull; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSlidersH", function() { return faSlidersH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSmile", function() { return faSmile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSmileBeam", function() { return faSmileBeam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSmileWink", function() { return faSmileWink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSmoking", function() { return faSmoking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSmokingBan", function() { return faSmokingBan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSnowflake", function() { return faSnowflake; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSocks", function() { return faSocks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSolarPanel", function() { return faSolarPanel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSort", function() { return faSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSortAlphaDown", function() { return faSortAlphaDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSortAlphaUp", function() { return faSortAlphaUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSortAmountDown", function() { return faSortAmountDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSortAmountUp", function() { return faSortAmountUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSortDown", function() { return faSortDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSortNumericDown", function() { return faSortNumericDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSortNumericUp", function() { return faSortNumericUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSortUp", function() { return faSortUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSpa", function() { return faSpa; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSpaceShuttle", function() { return faSpaceShuttle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSpinner", function() { return faSpinner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSplotch", function() { return faSplotch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSprayCan", function() { return faSprayCan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSquare", function() { return faSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSquareFull", function() { return faSquareFull; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSquareRootAlt", function() { return faSquareRootAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStamp", function() { return faStamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStar", function() { return faStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStarAndCrescent", function() { return faStarAndCrescent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStarHalf", function() { return faStarHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStarHalfAlt", function() { return faStarHalfAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStarOfDavid", function() { return faStarOfDavid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStarOfLife", function() { return faStarOfLife; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStepBackward", function() { return faStepBackward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStepForward", function() { return faStepForward; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStethoscope", function() { return faStethoscope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStickyNote", function() { return faStickyNote; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStop", function() { return faStop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStopCircle", function() { return faStopCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStopwatch", function() { return faStopwatch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStore", function() { return faStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStoreAlt", function() { return faStoreAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStream", function() { return faStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStreetView", function() { return faStreetView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStrikethrough", function() { return faStrikethrough; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faStroopwafel", function() { return faStroopwafel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSubscript", function() { return faSubscript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSubway", function() { return faSubway; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSuitcase", function() { return faSuitcase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSuitcaseRolling", function() { return faSuitcaseRolling; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSun", function() { return faSun; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSuperscript", function() { return faSuperscript; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSurprise", function() { return faSurprise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSwatchbook", function() { return faSwatchbook; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSwimmer", function() { return faSwimmer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSwimmingPool", function() { return faSwimmingPool; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSynagogue", function() { return faSynagogue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSync", function() { return faSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSyncAlt", function() { return faSyncAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faSyringe", function() { return faSyringe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTable", function() { return faTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTableTennis", function() { return faTableTennis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTablet", function() { return faTablet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTabletAlt", function() { return faTabletAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTablets", function() { return faTablets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTachometerAlt", function() { return faTachometerAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTag", function() { return faTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTags", function() { return faTags; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTape", function() { return faTape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTasks", function() { return faTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTaxi", function() { return faTaxi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTeeth", function() { return faTeeth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTeethOpen", function() { return faTeethOpen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTerminal", function() { return faTerminal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTextHeight", function() { return faTextHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTextWidth", function() { return faTextWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTh", function() { return faTh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faThLarge", function() { return faThLarge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faThList", function() { return faThList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTheaterMasks", function() { return faTheaterMasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faThermometer", function() { return faThermometer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faThermometerEmpty", function() { return faThermometerEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faThermometerFull", function() { return faThermometerFull; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faThermometerHalf", function() { return faThermometerHalf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faThermometerQuarter", function() { return faThermometerQuarter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faThermometerThreeQuarters", function() { return faThermometerThreeQuarters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faThumbsDown", function() { return faThumbsDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faThumbsUp", function() { return faThumbsUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faThumbtack", function() { return faThumbtack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTicketAlt", function() { return faTicketAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTimes", function() { return faTimes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTimesCircle", function() { return faTimesCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTint", function() { return faTint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTintSlash", function() { return faTintSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTired", function() { return faTired; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faToggleOff", function() { return faToggleOff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faToggleOn", function() { return faToggleOn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faToolbox", function() { return faToolbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTooth", function() { return faTooth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTorah", function() { return faTorah; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faToriiGate", function() { return faToriiGate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTrademark", function() { return faTrademark; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTrafficLight", function() { return faTrafficLight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTrain", function() { return faTrain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTransgender", function() { return faTransgender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTransgenderAlt", function() { return faTransgenderAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTrash", function() { return faTrash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTrashAlt", function() { return faTrashAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTree", function() { return faTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTrophy", function() { return faTrophy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTruck", function() { return faTruck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTruckLoading", function() { return faTruckLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTruckMonster", function() { return faTruckMonster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTruckMoving", function() { return faTruckMoving; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTruckPickup", function() { return faTruckPickup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTshirt", function() { return faTshirt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTty", function() { return faTty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faTv", function() { return faTv; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUmbrella", function() { return faUmbrella; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUmbrellaBeach", function() { return faUmbrellaBeach; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUnderline", function() { return faUnderline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUndo", function() { return faUndo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUndoAlt", function() { return faUndoAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUniversalAccess", function() { return faUniversalAccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUniversity", function() { return faUniversity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUnlink", function() { return faUnlink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUnlock", function() { return faUnlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUnlockAlt", function() { return faUnlockAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUpload", function() { return faUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUser", function() { return faUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserAlt", function() { return faUserAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserAltSlash", function() { return faUserAltSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserAstronaut", function() { return faUserAstronaut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserCheck", function() { return faUserCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserCircle", function() { return faUserCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserClock", function() { return faUserClock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserCog", function() { return faUserCog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserEdit", function() { return faUserEdit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserFriends", function() { return faUserFriends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserGraduate", function() { return faUserGraduate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserLock", function() { return faUserLock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserMd", function() { return faUserMd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserMinus", function() { return faUserMinus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserNinja", function() { return faUserNinja; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserPlus", function() { return faUserPlus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserSecret", function() { return faUserSecret; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserShield", function() { return faUserShield; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserSlash", function() { return faUserSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserTag", function() { return faUserTag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserTie", function() { return faUserTie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUserTimes", function() { return faUserTimes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUsers", function() { return faUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUsersCog", function() { return faUsersCog; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUtensilSpoon", function() { return faUtensilSpoon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faUtensils", function() { return faUtensils; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faVectorSquare", function() { return faVectorSquare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faVenus", function() { return faVenus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faVenusDouble", function() { return faVenusDouble; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faVenusMars", function() { return faVenusMars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faVial", function() { return faVial; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faVials", function() { return faVials; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faVideo", function() { return faVideo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faVideoSlash", function() { return faVideoSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faVihara", function() { return faVihara; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faVolleyballBall", function() { return faVolleyballBall; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faVolumeDown", function() { return faVolumeDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faVolumeOff", function() { return faVolumeOff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faVolumeUp", function() { return faVolumeUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faWalking", function() { return faWalking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faWallet", function() { return faWallet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faWarehouse", function() { return faWarehouse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faWeight", function() { return faWeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faWeightHanging", function() { return faWeightHanging; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faWheelchair", function() { return faWheelchair; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faWifi", function() { return faWifi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faWindowClose", function() { return faWindowClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faWindowMaximize", function() { return faWindowMaximize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faWindowMinimize", function() { return faWindowMinimize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faWindowRestore", function() { return faWindowRestore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faWineGlass", function() { return faWineGlass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faWineGlassAlt", function() { return faWineGlassAlt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faWonSign", function() { return faWonSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faWrench", function() { return faWrench; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faXRay", function() { return faXRay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faYenSign", function() { return faYenSign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faYinYang", function() { return faYinYang; });
/*!
 * Font Awesome Free 5.3.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
var prefix = "fas";
var faAd = { prefix: 'fas', iconName: 'ad', icon: [512, 512, [], "f641", "M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"] };
var faAddressBook = { prefix: 'fas', iconName: 'address-book', icon: [448, 512, [], "f2b9", "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"] };
var faAddressCard = { prefix: 'fas', iconName: 'address-card', icon: [576, 512, [], "f2bb", "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"] };
var faAdjust = { prefix: 'fas', iconName: 'adjust', icon: [512, 512, [], "f042", "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"] };
var faAirFreshener = { prefix: 'fas', iconName: 'air-freshener', icon: [384, 512, [], "f5d0", "M378.94 321.41L284.7 224h49.22c15.3 0 23.66-16.6 13.86-27.53L234.45 69.96c3.43-6.61 5.55-14 5.55-21.96 0-26.51-21.49-48-48-48s-48 21.49-48 48c0 7.96 2.12 15.35 5.55 21.96L36.22 196.47C26.42 207.4 34.78 224 50.08 224H99.3L5.06 321.41C-6.69 333.56 3.34 352 21.7 352H160v32H48c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h288c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16H224v-32h138.3c18.36 0 28.39-18.44 16.64-30.59zM192 31.98c8.85 0 16.02 7.17 16.02 16.02 0 8.84-7.17 16.02-16.02 16.02S175.98 56.84 175.98 48c0-8.85 7.17-16.02 16.02-16.02zM304 432v32H80v-32h224z"] };
var faAlignCenter = { prefix: 'fas', iconName: 'align-center', icon: [448, 512, [], "f037", "M352 44v40c0 8.837-7.163 16-16 16H112c-8.837 0-16-7.163-16-16V44c0-8.837 7.163-16 16-16h224c8.837 0 16 7.163 16 16zM16 228h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 256h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm320-200H112c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16h224c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16z"] };
var faAlignJustify = { prefix: 'fas', iconName: 'align-justify', icon: [448, 512, [], "f039", "M0 84V44c0-8.837 7.163-16 16-16h416c8.837 0 16 7.163 16 16v40c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16zm16 144h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 256h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0-128h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"] };
var faAlignLeft = { prefix: 'fas', iconName: 'align-left', icon: [448, 512, [], "f036", "M288 44v40c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V44c0-8.837 7.163-16 16-16h256c8.837 0 16 7.163 16 16zM0 172v40c0 8.837 7.163 16 16 16h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16zm16 312h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm256-200H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16h256c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16z"] };
var faAlignRight = { prefix: 'fas', iconName: 'align-right', icon: [448, 512, [], "f038", "M160 84V44c0-8.837 7.163-16 16-16h256c8.837 0 16 7.163 16 16v40c0 8.837-7.163 16-16 16H176c-8.837 0-16-7.163-16-16zM16 228h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 256h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm160-128h256c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H176c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"] };
var faAllergies = { prefix: 'fas', iconName: 'allergies', icon: [448, 512, [], "f461", "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"] };
var faAmbulance = { prefix: 'fas', iconName: 'ambulance', icon: [640, 512, [], "f0f9", "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"] };
var faAmericanSignLanguageInterpreting = { prefix: 'fas', iconName: 'american-sign-language-interpreting', icon: [640, 512, [], "f2a3", "M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"] };
var faAnchor = { prefix: 'fas', iconName: 'anchor', icon: [576, 512, [], "f13d", "M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"] };
var faAngleDoubleDown = { prefix: 'fas', iconName: 'angle-double-down', icon: [320, 512, [], "f103", "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"] };
var faAngleDoubleLeft = { prefix: 'fas', iconName: 'angle-double-left', icon: [448, 512, [], "f100", "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"] };
var faAngleDoubleRight = { prefix: 'fas', iconName: 'angle-double-right', icon: [448, 512, [], "f101", "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"] };
var faAngleDoubleUp = { prefix: 'fas', iconName: 'angle-double-up', icon: [320, 512, [], "f102", "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"] };
var faAngleDown = { prefix: 'fas', iconName: 'angle-down', icon: [320, 512, [], "f107", "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"] };
var faAngleLeft = { prefix: 'fas', iconName: 'angle-left', icon: [256, 512, [], "f104", "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"] };
var faAngleRight = { prefix: 'fas', iconName: 'angle-right', icon: [256, 512, [], "f105", "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"] };
var faAngleUp = { prefix: 'fas', iconName: 'angle-up', icon: [320, 512, [], "f106", "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"] };
var faAngry = { prefix: 'fas', iconName: 'angry', icon: [496, 512, [], "f556", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"] };
var faAnkh = { prefix: 'fas', iconName: 'ankh', icon: [320, 512, [], "f644", "M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"] };
var faAppleAlt = { prefix: 'fas', iconName: 'apple-alt', icon: [448, 512, [], "f5d1", "M351.18 129.15c-35.53-6.25-98.06 14.36-127.18 30.81-29.12-16.45-91.66-37.07-127.19-30.81-81.24 14.3-107.42 124.49-93.09 205.6C18.05 415.86 65.02 512 160.41 512c12.06 0 24.12-4.61 34.44-10.34 18.08-10.03 40.23-10.03 58.31 0 10.32 5.73 22.38 10.34 34.43 10.34 95.39 0 142.36-96.14 156.68-177.25 14.33-81.11-11.83-191.3-93.09-205.6zm-55.55-41.53C326.19 57.06 319.35.65 319.35.65s-56.41-6.85-86.97 23.72c-30.57 30.57-23.72 86.97-23.72 86.97s56.4 6.85 86.97-23.72z"] };
var faArchive = { prefix: 'fas', iconName: 'archive', icon: [512, 512, [], "f187", "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"] };
var faArchway = { prefix: 'fas', iconName: 'archway', icon: [576, 512, [], "f557", "M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"] };
var faArrowAltCircleDown = { prefix: 'fas', iconName: 'arrow-alt-circle-down', icon: [512, 512, [], "f358", "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"] };
var faArrowAltCircleLeft = { prefix: 'fas', iconName: 'arrow-alt-circle-left', icon: [512, 512, [], "f359", "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"] };
var faArrowAltCircleRight = { prefix: 'fas', iconName: 'arrow-alt-circle-right', icon: [512, 512, [], "f35a", "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"] };
var faArrowAltCircleUp = { prefix: 'fas', iconName: 'arrow-alt-circle-up', icon: [512, 512, [], "f35b", "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"] };
var faArrowCircleDown = { prefix: 'fas', iconName: 'arrow-circle-down', icon: [512, 512, [], "f0ab", "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"] };
var faArrowCircleLeft = { prefix: 'fas', iconName: 'arrow-circle-left', icon: [512, 512, [], "f0a8", "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"] };
var faArrowCircleRight = { prefix: 'fas', iconName: 'arrow-circle-right', icon: [512, 512, [], "f0a9", "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"] };
var faArrowCircleUp = { prefix: 'fas', iconName: 'arrow-circle-up', icon: [512, 512, [], "f0aa", "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"] };
var faArrowDown = { prefix: 'fas', iconName: 'arrow-down', icon: [448, 512, [], "f063", "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"] };
var faArrowLeft = { prefix: 'fas', iconName: 'arrow-left', icon: [448, 512, [], "f060", "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"] };
var faArrowRight = { prefix: 'fas', iconName: 'arrow-right', icon: [448, 512, [], "f061", "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"] };
var faArrowUp = { prefix: 'fas', iconName: 'arrow-up', icon: [448, 512, [], "f062", "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"] };
var faArrowsAlt = { prefix: 'fas', iconName: 'arrows-alt', icon: [512, 512, [], "f0b2", "M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"] };
var faArrowsAltH = { prefix: 'fas', iconName: 'arrows-alt-h', icon: [512, 512, [], "f337", "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"] };
var faArrowsAltV = { prefix: 'fas', iconName: 'arrows-alt-v', icon: [256, 512, [], "f338", "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"] };
var faAssistiveListeningSystems = { prefix: 'fas', iconName: 'assistive-listening-systems', icon: [512, 512, [], "f2a2", "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"] };
var faAsterisk = { prefix: 'fas', iconName: 'asterisk', icon: [512, 512, [], "f069", "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"] };
var faAt = { prefix: 'fas', iconName: 'at', icon: [512, 512, [], "f1fa", "M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"] };
var faAtlas = { prefix: 'fas', iconName: 'atlas', icon: [448, 512, [], "f558", "M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"] };
var faAtom = { prefix: 'fas', iconName: 'atom', icon: [448, 512, [], "f5d2", "M413.03 256c40.13-54.89 41.51-98.62 25.14-128-10.91-19.52-40.54-50.73-116.33-41.88C300.36 34.89 267.64 0 224 0s-76.36 34.89-97.84 86.12C50.43 77.34 20.73 108.48 9.83 128c-16.38 29.4-15 73.09 25.14 128-40.13 54.89-41.51 98.62-25.14 128 29.21 52.34 101.68 43.58 116.33 41.88C147.63 477.1 180.36 512 224 512s76.37-34.9 97.84-86.12c14.64 1.7 87.11 10.46 116.33-41.88 16.38-29.4 15-73.09-25.14-128zM63.38 352c-4.03-7.21-.19-24.8 14.95-48.29 6.96 6.53 14.2 12.89 21.87 19.18 1.71 13.71 4 27.08 6.76 40.08-24.56.89-39.89-4.37-43.58-10.97zm36.82-162.88c-7.66 6.29-14.9 12.65-21.87 19.18-15.13-23.5-18.97-41.09-14.95-48.3 3.41-6.14 16.39-11.47 37.92-11.47 1.71 0 3.87.3 5.69.37a472.191 472.191 0 0 0-6.79 40.22zM224 64c9.47 0 22.2 13.52 33.86 37.26-11.19 3.7-22.44 8-33.86 12.86-11.42-4.86-22.67-9.16-33.86-12.86C201.8 77.52 214.53 64 224 64zm0 384c-9.47 0-22.2-13.52-33.86-37.26 11.19-3.7 22.44-8 33.86-12.86 11.42 4.86 22.67 9.16 33.86 12.86C246.2 434.48 233.47 448 224 448zm62.5-157.33c-26.7 19.08-46.14 29.33-62.5 37.48-16.35-8.14-35.8-18.41-62.5-37.48-1.99-27.79-1.99-41.54 0-69.33 26.67-19.05 46.13-29.32 62.5-37.48 16.39 8.17 35.86 18.44 62.5 37.48 1.98 27.78 1.99 41.53 0 69.33zM384.62 352c-3.67 6.62-19 11.82-43.58 10.95 2.76-13 5.05-26.37 6.76-40.06 7.66-6.29 14.9-12.65 21.87-19.18 15.13 23.49 18.97 41.08 14.95 48.29zm-14.95-143.71c-6.96-6.53-14.2-12.89-21.87-19.18a473.535 473.535 0 0 0-6.79-40.22c1.82-.07 3.97-.37 5.69-.37 21.52 0 34.51 5.34 37.92 11.47 4.02 7.22.18 24.81-14.95 48.3zM224 224c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"] };
var faAudioDescription = { prefix: 'fas', iconName: 'audio-description', icon: [512, 512, [], "f29e", "M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"] };
var faAward = { prefix: 'fas', iconName: 'award', icon: [384, 512, [], "f559", "M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"] };
var faBackspace = { prefix: 'fas', iconName: 'backspace', icon: [640, 512, [], "f55a", "M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"] };
var faBackward = { prefix: 'fas', iconName: 'backward', icon: [512, 512, [], "f04a", "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"] };
var faBalanceScale = { prefix: 'fas', iconName: 'balance-scale', icon: [640, 512, [], "f24e", "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"] };
var faBan = { prefix: 'fas', iconName: 'ban', icon: [512, 512, [], "f05e", "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"] };
var faBandAid = { prefix: 'fas', iconName: 'band-aid', icon: [640, 512, [], "f462", "M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"] };
var faBarcode = { prefix: 'fas', iconName: 'barcode', icon: [512, 512, [], "f02a", "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"] };
var faBars = { prefix: 'fas', iconName: 'bars', icon: [448, 512, [], "f0c9", "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"] };
var faBaseballBall = { prefix: 'fas', iconName: 'baseball-ball', icon: [496, 512, [], "f433", "M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"] };
var faBasketballBall = { prefix: 'fas', iconName: 'basketball-ball', icon: [496, 512, [], "f434", "M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"] };
var faBath = { prefix: 'fas', iconName: 'bath', icon: [512, 512, [], "f2cd", "M488 256H80V112c0-17.645 14.355-32 32-32 11.351 0 21.332 5.945 27.015 14.88-16.492 25.207-14.687 59.576 6.838 83.035-4.176 4.713-4.021 11.916.491 16.428l11.314 11.314c4.686 4.686 12.284 4.686 16.971 0l95.03-95.029c4.686-4.686 4.686-12.284 0-16.971l-11.314-11.314c-4.512-4.512-11.715-4.666-16.428-.491-17.949-16.469-42.294-21.429-64.178-15.365C163.281 45.667 139.212 32 112 32c-44.112 0-80 35.888-80 80v144h-8c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h8v32c0 28.43 12.362 53.969 32 71.547V456c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-8h256v8c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-32.453c19.638-17.578 32-43.117 32-71.547v-32h8c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"] };
var faBatteryEmpty = { prefix: 'fas', iconName: 'battery-empty', icon: [640, 512, [], "f244", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"] };
var faBatteryFull = { prefix: 'fas', iconName: 'battery-full', icon: [640, 512, [], "f240", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"] };
var faBatteryHalf = { prefix: 'fas', iconName: 'battery-half', icon: [640, 512, [], "f242", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"] };
var faBatteryQuarter = { prefix: 'fas', iconName: 'battery-quarter', icon: [640, 512, [], "f243", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"] };
var faBatteryThreeQuarters = { prefix: 'fas', iconName: 'battery-three-quarters', icon: [640, 512, [], "f241", "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"] };
var faBed = { prefix: 'fas', iconName: 'bed', icon: [640, 512, [], "f236", "M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"] };
var faBeer = { prefix: 'fas', iconName: 'beer', icon: [448, 512, [], "f0fc", "M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"] };
var faBell = { prefix: 'fas', iconName: 'bell', icon: [448, 512, [], "f0f3", "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"] };
var faBellSlash = { prefix: 'fas', iconName: 'bell-slash', icon: [640, 512, [], "f1f6", "M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"] };
var faBezierCurve = { prefix: 'fas', iconName: 'bezier-curve', icon: [640, 512, [], "f55b", "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"] };
var faBible = { prefix: 'fas', iconName: 'bible', icon: [448, 512, [], "f647", "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"] };
var faBicycle = { prefix: 'fas', iconName: 'bicycle', icon: [640, 512, [], "f206", "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"] };
var faBinoculars = { prefix: 'fas', iconName: 'binoculars', icon: [512, 512, [], "f1e5", "M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"] };
var faBirthdayCake = { prefix: 'fas', iconName: 'birthday-cake', icon: [448, 512, [], "f1fd", "M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"] };
var faBlender = { prefix: 'fas', iconName: 'blender', icon: [512, 512, [], "f517", "M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"] };
var faBlind = { prefix: 'fas', iconName: 'blind', icon: [384, 512, [], "f29d", "M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"] };
var faBold = { prefix: 'fas', iconName: 'bold', icon: [384, 512, [], "f032", "M304.793 243.891c33.639-18.537 53.657-54.16 53.657-95.693 0-48.236-26.25-87.626-68.626-104.179C265.138 34.01 240.849 32 209.661 32H24c-8.837 0-16 7.163-16 16v33.049c0 8.837 7.163 16 16 16h33.113v318.53H24c-8.837 0-16 7.163-16 16V464c0 8.837 7.163 16 16 16h195.69c24.203 0 44.834-1.289 66.866-7.584C337.52 457.193 376 410.647 376 350.014c0-52.168-26.573-91.684-71.207-106.123zM142.217 100.809h67.444c16.294 0 27.536 2.019 37.525 6.717 15.828 8.479 24.906 26.502 24.906 49.446 0 35.029-20.32 56.79-53.029 56.79h-76.846V100.809zm112.642 305.475c-10.14 4.056-22.677 4.907-31.409 4.907h-81.233V281.943h84.367c39.645 0 63.057 25.38 63.057 63.057.001 28.425-13.66 52.483-34.782 61.284z"] };
var faBolt = { prefix: 'fas', iconName: 'bolt', icon: [320, 512, [], "f0e7", "M295.973 160H180.572L215.19 30.184C219.25 14.956 207.756 0 192 0H56C43.971 0 33.8 8.905 32.211 20.828l-31.996 240C-1.704 275.217 9.504 288 24.004 288h118.701L96.646 482.466C93.05 497.649 104.659 512 119.992 512c8.35 0 16.376-4.374 20.778-11.978l175.973-303.997c9.244-15.967-2.288-36.025-20.77-36.025z"] };
var faBomb = { prefix: 'fas', iconName: 'bomb', icon: [512, 512, [], "f1e2", "M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"] };
var faBone = { prefix: 'fas', iconName: 'bone', icon: [640, 512, [], "f5d7", "M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"] };
var faBong = { prefix: 'fas', iconName: 'bong', icon: [448, 512, [], "f55c", "M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"] };
var faBook = { prefix: 'fas', iconName: 'book', icon: [448, 512, [], "f02d", "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"] };
var faBookOpen = { prefix: 'fas', iconName: 'book-open', icon: [576, 512, [], "f518", "M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"] };
var faBookReader = { prefix: 'fas', iconName: 'book-reader', icon: [512, 512, [], "f5da", "M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"] };
var faBookmark = { prefix: 'fas', iconName: 'bookmark', icon: [384, 512, [], "f02e", "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"] };
var faBowlingBall = { prefix: 'fas', iconName: 'bowling-ball', icon: [496, 512, [], "f436", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"] };
var faBox = { prefix: 'fas', iconName: 'box', icon: [512, 512, [], "f466", "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"] };
var faBoxOpen = { prefix: 'fas', iconName: 'box-open', icon: [640, 512, [], "f49e", "M53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9zm585.1 102.8L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9z"] };
var faBoxes = { prefix: 'fas', iconName: 'boxes', icon: [576, 512, [], "f468", "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"] };
var faBraille = { prefix: 'fas', iconName: 'braille', icon: [640, 512, [], "f2a1", "M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"] };
var faBrain = { prefix: 'fas', iconName: 'brain', icon: [576, 512, [], "f5dc", "M208 0c-29.87 0-54.74 20.55-61.8 48.22-.75-.02-1.45-.22-2.2-.22-35.34 0-64 28.65-64 64 0 4.84.64 9.51 1.66 14.04C52.54 138 32 166.57 32 200c0 12.58 3.16 24.32 8.34 34.91C16.34 248.72 0 274.33 0 304c0 33.34 20.42 61.88 49.42 73.89-.9 4.57-1.42 9.28-1.42 14.11 0 39.76 32.23 72 72 72 4.12 0 8.1-.55 12.03-1.21C141.61 491.31 168.25 512 200 512c39.77 0 72-32.24 72-72V205.45c-10.91 8.98-23.98 15.45-38.36 18.39-4.97 1.02-9.64-2.82-9.64-7.89v-16.18c0-3.57 2.35-6.78 5.8-7.66 24.2-6.16 42.2-27.95 42.2-54.04V64c0-35.35-28.66-64-64-64zm368 304c0-29.67-16.34-55.28-40.34-69.09 5.17-10.59 8.34-22.33 8.34-34.91 0-33.43-20.54-62-49.66-73.96 1.02-4.53 1.66-9.2 1.66-14.04 0-35.35-28.66-64-64-64-.75 0-1.45.2-2.2.22C422.74 20.55 397.87 0 368 0c-35.34 0-64 28.65-64 64v74.07c0 26.09 17.99 47.88 42.2 54.04 3.46.88 5.8 4.09 5.8 7.66v16.18c0 5.07-4.68 8.91-9.64 7.89-14.38-2.94-27.44-9.41-38.36-18.39V440c0 39.76 32.23 72 72 72 31.75 0 58.39-20.69 67.97-49.21 3.93.67 7.91 1.21 12.03 1.21 39.77 0 72-32.24 72-72 0-4.83-.52-9.54-1.42-14.11 29-12.01 49.42-40.55 49.42-73.89z"] };
var faBriefcase = { prefix: 'fas', iconName: 'briefcase', icon: [512, 512, [], "f0b1", "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"] };
var faBriefcaseMedical = { prefix: 'fas', iconName: 'briefcase-medical', icon: [512, 512, [], "f469", "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"] };
var faBroadcastTower = { prefix: 'fas', iconName: 'broadcast-tower', icon: [640, 512, [], "f519", "M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"] };
var faBroom = { prefix: 'fas', iconName: 'broom', icon: [512, 512, [], "f51a", "M10.8 247.2C-.7 251.8-3.7 266.7 5 275.4l54.8 54.8 73.2-24.4-24.4 73.2 128 128c8.8 8.8 23.6 5.7 28.2-5.8l98.1-243.7-108.4-108.4-243.7 98.1zM507.3 27.3L484.7 4.7c-6.2-6.3-16.4-6.3-22.6 0L359.8 106.9l-40.4-40.4c-4.2-4.3-11.4-3-13.9 2.5l-27.2 58.6 106.1 106.1 58.6-27.2c5.4-2.5 6.7-9.7 2.5-13.9l-40.4-40.4L507.3 49.9c6.3-6.2 6.3-16.3 0-22.6z"] };
var faBrush = { prefix: 'fas', iconName: 'brush', icon: [384, 512, [], "f55d", "M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"] };
var faBug = { prefix: 'fas', iconName: 'bug', icon: [512, 512, [], "f188", "M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"] };
var faBuilding = { prefix: 'fas', iconName: 'building', icon: [448, 512, [], "f1ad", "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"] };
var faBullhorn = { prefix: 'fas', iconName: 'bullhorn', icon: [576, 512, [], "f0a1", "M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"] };
var faBullseye = { prefix: 'fas', iconName: 'bullseye', icon: [496, 512, [], "f140", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"] };
var faBurn = { prefix: 'fas', iconName: 'burn', icon: [384, 512, [], "f46a", "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"] };
var faBus = { prefix: 'fas', iconName: 'bus', icon: [512, 512, [], "f207", "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"] };
var faBusAlt = { prefix: 'fas', iconName: 'bus-alt', icon: [512, 512, [], "f55e", "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"] };
var faBusinessTime = { prefix: 'fas', iconName: 'business-time', icon: [640, 512, [], "f64a", "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"] };
var faCalculator = { prefix: 'fas', iconName: 'calculator', icon: [448, 512, [], "f1ec", "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"] };
var faCalendar = { prefix: 'fas', iconName: 'calendar', icon: [448, 512, [], "f133", "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"] };
var faCalendarAlt = { prefix: 'fas', iconName: 'calendar-alt', icon: [448, 512, [], "f073", "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm116 204c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40zm0-128c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40zm128 128c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40zm0-128c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40zm128 128c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40zm0-128c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-40z"] };
var faCalendarCheck = { prefix: 'fas', iconName: 'calendar-check', icon: [448, 512, [], "f274", "M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"] };
var faCalendarMinus = { prefix: 'fas', iconName: 'calendar-minus', icon: [448, 512, [], "f272", "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"] };
var faCalendarPlus = { prefix: 'fas', iconName: 'calendar-plus', icon: [448, 512, [], "f271", "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"] };
var faCalendarTimes = { prefix: 'fas', iconName: 'calendar-times', icon: [448, 512, [], "f273", "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"] };
var faCamera = { prefix: 'fas', iconName: 'camera', icon: [512, 512, [], "f030", "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"] };
var faCameraRetro = { prefix: 'fas', iconName: 'camera-retro', icon: [512, 512, [], "f083", "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"] };
var faCannabis = { prefix: 'fas', iconName: 'cannabis', icon: [512, 512, [], "f55f", "M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"] };
var faCapsules = { prefix: 'fas', iconName: 'capsules', icon: [576, 512, [], "f46b", "M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"] };
var faCar = { prefix: 'fas', iconName: 'car', icon: [512, 512, [], "f1b9", "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"] };
var faCarAlt = { prefix: 'fas', iconName: 'car-alt', icon: [480, 512, [], "f5de", "M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"] };
var faCarBattery = { prefix: 'fas', iconName: 'car-battery', icon: [512, 512, [], "f5df", "M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"] };
var faCarCrash = { prefix: 'fas', iconName: 'car-crash', icon: [640, 512, [], "f5e1", "M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"] };
var faCarSide = { prefix: 'fas', iconName: 'car-side', icon: [640, 512, [], "f5e4", "M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"] };
var faCaretDown = { prefix: 'fas', iconName: 'caret-down', icon: [320, 512, [], "f0d7", "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"] };
var faCaretLeft = { prefix: 'fas', iconName: 'caret-left', icon: [192, 512, [], "f0d9", "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"] };
var faCaretRight = { prefix: 'fas', iconName: 'caret-right', icon: [192, 512, [], "f0da", "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"] };
var faCaretSquareDown = { prefix: 'fas', iconName: 'caret-square-down', icon: [448, 512, [], "f150", "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"] };
var faCaretSquareLeft = { prefix: 'fas', iconName: 'caret-square-left', icon: [448, 512, [], "f191", "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"] };
var faCaretSquareRight = { prefix: 'fas', iconName: 'caret-square-right', icon: [448, 512, [], "f152", "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"] };
var faCaretSquareUp = { prefix: 'fas', iconName: 'caret-square-up', icon: [448, 512, [], "f151", "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"] };
var faCaretUp = { prefix: 'fas', iconName: 'caret-up', icon: [320, 512, [], "f0d8", "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"] };
var faCartArrowDown = { prefix: 'fas', iconName: 'cart-arrow-down', icon: [576, 512, [], "f218", "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"] };
var faCartPlus = { prefix: 'fas', iconName: 'cart-plus', icon: [576, 512, [], "f217", "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"] };
var faCertificate = { prefix: 'fas', iconName: 'certificate', icon: [512, 512, [], "f0a3", "M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"] };
var faChalkboard = { prefix: 'fas', iconName: 'chalkboard', icon: [640, 512, [], "f51b", "M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"] };
var faChalkboardTeacher = { prefix: 'fas', iconName: 'chalkboard-teacher', icon: [640, 512, [], "f51c", "M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"] };
var faChargingStation = { prefix: 'fas', iconName: 'charging-station', icon: [576, 512, [], "f5e7", "M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"] };
var faChartArea = { prefix: 'fas', iconName: 'chart-area', icon: [512, 512, [], "f1fe", "M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"] };
var faChartBar = { prefix: 'fas', iconName: 'chart-bar', icon: [512, 512, [], "f080", "M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"] };
var faChartLine = { prefix: 'fas', iconName: 'chart-line', icon: [512, 512, [], "f201", "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"] };
var faChartPie = { prefix: 'fas', iconName: 'chart-pie', icon: [544, 512, [], "f200", "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"] };
var faCheck = { prefix: 'fas', iconName: 'check', icon: [512, 512, [], "f00c", "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"] };
var faCheckCircle = { prefix: 'fas', iconName: 'check-circle', icon: [512, 512, [], "f058", "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"] };
var faCheckDouble = { prefix: 'fas', iconName: 'check-double', icon: [512, 512, [], "f560", "M504.5 171.95l-36.2-36.41c-10-10.05-26.21-10.05-36.2 0L192 377.02 79.9 264.28c-10-10.06-26.21-10.06-36.2 0L7.5 300.69c-10 10.05-10 26.36 0 36.41l166.4 167.36c10 10.06 26.21 10.06 36.2 0l294.4-296.09c10-10.06 10-26.36 0-36.42zM166.57 282.71c6.84 7.02 18.18 7.02 25.21.18L403.85 72.62c7.02-6.84 7.02-18.18.18-25.21L362.08 5.29c-6.84-7.02-18.18-7.02-25.21-.18L179.71 161.19l-68.23-68.77c-6.84-7.02-18.18-7.02-25.2-.18l-42.13 41.77c-7.02 6.84-7.02 18.18-.18 25.2l122.6 123.5z"] };
var faCheckSquare = { prefix: 'fas', iconName: 'check-square', icon: [448, 512, [], "f14a", "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"] };
var faChess = { prefix: 'fas', iconName: 'chess', icon: [512, 512, [], "f439", "M199.821 217.633a6 6 0 0 1 6 6l-.001 20.766a6 6 0 0 1-6 6h-25.805c0 31.715-2.153 96.201 17.398 153.229H64.597C84.54 345.452 82.02 279.245 82.02 250.399H56.183a6 6 0 0 1-6-6l.002-20.766a6 6 0 0 1 6-6h143.636zM41.554 115.088l34.58 95.071h103.734l34.572-95.072c2.846-7.826-2.95-16.101-11.278-16.101H152v-30.22h21.57a6 6 0 0 0 6-6V40.383a6 6 0 0 0-6-6h-28.367V6a6 6 0 0 0-6-6H116.82a6 6 0 0 0-6 6v28.383H82.421a6 6 0 0 0-6 6v22.383a6 6 0 0 0 6 6H104v30.219H52.831c-8.328.001-14.124 8.276-11.277 16.103zM222.678 445.17v-28.067a6 6 0 0 0-6-6H39.322a6 6 0 0 0-6 6v28.067l-22.148 14.164a6 6 0 0 0-2.767 5.055V506a6 6 0 0 0 6 6h227.187a6 6 0 0 0 6-6v-41.612a6 6 0 0 0-2.767-5.055l-22.149-14.163zm90.578-144.225l24.88 16.963c.09 18.124-.167 63.904-11.905 114.522h147.526c-11.713-50.475-11.969-96.324-11.882-114.537l24.859-16.949a3.856 3.856 0 0 0 1.684-3.187v-69.901a3.857 3.857 0 0 0-3.857-3.857h-27.655a3.857 3.857 0 0 0-3.857 3.857v31.514h-22.737v-31.514a3.857 3.857 0 0 0-3.858-3.857h-52.918a3.857 3.857 0 0 0-3.857 3.857v31.514h-22.737v-31.514a3.857 3.857 0 0 0-3.857-3.857H315.43a3.857 3.857 0 0 0-3.857 3.857v69.901a3.855 3.855 0 0 0 1.683 3.188zm71.585 51.906c0-8.372 6.787-15.158 15.159-15.158s15.158 6.787 15.158 15.158v30.318h-30.317v-30.318zM504.62 470.059l-13.664-10.639v-15.552a3.857 3.857 0 0 0-3.857-3.857H312.915a3.857 3.857 0 0 0-3.857 3.857v15.552l-13.677 10.639a3.857 3.857 0 0 0-1.488 3.044v35.039a3.857 3.857 0 0 0 3.857 3.857h204.5a3.857 3.857 0 0 0 3.857-3.857v-35.04a3.859 3.859 0 0 0-1.487-3.043z"] };
var faChessBishop = { prefix: 'fas', iconName: 'chess-bishop', icon: [320, 512, [], "f43a", "M123.158 77.881C107.369 72.53 96 57.597 96 40c0-22.091 17.909-40 40-40h47.796c22.091 0 40 17.909 40 40 0 17.541-11.295 32.434-27.005 37.829 23.993 16.657 48.577 46.839 68.703 82.05L144.929 280.443a6 6 0 0 0 0 8.485l14.142 14.142a6 6 0 0 0 8.485 0L280.9 189.726c17.758 38.297 29.371 79.443 29.371 114.273 0 53.786-22.897 75.788-58.446 86.033V448H68.174v-57.97C32.631 379.784 9.739 357.781 9.739 304c0-78.029 58.281-187.766 113.419-226.119zM320 500v-24c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12z"] };
var faChessBoard = { prefix: 'fas', iconName: 'chess-board', icon: [512, 512, [], "f43c", "M256 256v64h-64v-64h64zm0-256h-64v64h64V0zm0 256h64v-64h-64v64zM384 0h-64v64h64V0zm0 512h64v-64h-64v64zm128-64v-64h-64v64h64zm-384 64h64v-64h-64v64zm0-512H64v64h64V0zm384 192v-64h-64v64h64zm0 128v-64h-64v64h64zM0 512h64v-64H0v64zM0 64v64h64V64H0zm0 128v64h64v-64H0zm0 128v64h64v-64H0zm256 192h64v-64h-64v64zm-64-128v64h64v-64h-64zm64-192v-64h-64v64h64zM64 384v64h64v-64H64zm64-128H64v64h64v-64zm256 128h64v-64h-64v64zM512 0h-64v64h64V0zM384 256h64v-64h-64v64zm0-192v64h64V64h-64zm-64 320v64h64v-64h-64zm-192-64v64h64v-64h-64zm128 0v64h64v-64h-64zm-64-128h-64v64h64v-64zm-64-64H64v64h64v-64zm192 192h64v-64h-64v64zM192 128V64h-64v64h64zm128 0V64h-64v64h64zm0 64h64v-64h-64v64z"] };
var faChessKing = { prefix: 'fas', iconName: 'chess-king', icon: [448, 512, [], "f43f", "M416 476v24c0 6.627-5.373 12-12 12H44c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12zm-8.033-324H248v-48h50a6 6 0 0 0 6-6V62a6 6 0 0 0-6-6h-50V6a6 6 0 0 0-6-6h-36a6 6 0 0 0-6 6v50h-50a6 6 0 0 0-6 6v36a6 6 0 0 0 6 6h50v48H40.033c-27.574 0-46.879 27.244-37.738 53.259L87.582 448h272.836l85.287-242.741C454.846 179.244 435.541 152 407.967 152z"] };
var faChessKnight = { prefix: 'fas', iconName: 'chess-knight', icon: [384, 512, [], "f441", "M352 224v224H32v-46.557c0-30.302 17.12-58.003 44.223-71.554l57.243-28.622A48 48 0 0 0 160 258.334V208l-22.127 11.063a23.996 23.996 0 0 0-12.55 15.645l-11.835 47.338a12 12 0 0 1-7.185 8.231l-29.601 11.84a11.998 11.998 0 0 1-9.33-.176L7.126 275.167A12 12 0 0 1 0 264.201v-158.26c0-6.365 2.529-12.47 7.03-16.971L16 80 1.789 51.578A16.937 16.937 0 0 1 0 44c0-6.627 5.373-12 12-12h148c106.039 0 192 85.961 192 192zm20 240H12c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12zM52 128c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"] };
var faChessPawn = { prefix: 'fas', iconName: 'chess-pawn', icon: [320, 512, [], "f443", "M264 448H56s60-42.743 60-176H84c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h40.209C95.721 210.56 76 181.588 76 148c0-46.392 37.608-84 84-84s84 37.608 84 84c0 33.588-19.721 62.56-48.209 76H236c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12h-32c0 133.257 60 176 60 176zm28 16H28c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h264c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12z"] };
var faChessQueen = { prefix: 'fas', iconName: 'chess-queen', icon: [512, 512, [], "f445", "M436 512H76c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12zM255.579 0c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zm204.568 154.634c-5.768-3.045-12.916-.932-16.082 4.77-8.616 15.516-22.747 37.801-44.065 37.801-28.714 0-30.625-19.804-31.686-57.542-.183-6.492-5.501-11.664-11.995-11.664h-41.006c-5.175 0-9.754 3.328-11.388 8.238-8.89 26.709-26.073 40.992-47.925 40.992s-39.034-14.283-47.925-40.992c-1.634-4.91-6.213-8.238-11.388-8.238h-41.005c-6.495 0-11.813 5.174-11.995 11.667-1.052 37.642-2.934 57.539-31.688 57.539-20.691 0-33.817-20.224-44.425-38.025-3.266-5.48-10.258-7.431-15.899-4.453l-39.179 20.679a12 12 0 0 0-5.51 15.145L112 448h288l105.014-257.448a12 12 0 0 0-5.51-15.145l-39.357-20.773z"] };
var faChessRook = { prefix: 'fas', iconName: 'chess-rook', icon: [384, 512, [], "f447", "M81.241 215.027C80.957 258.92 77.411 348.076 48 448h287.982c-29.4-99.604-32.936-188.912-33.221-232.975l45.418-42.312a11.998 11.998 0 0 0 3.82-8.78V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v44h-48V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v44H96V44c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v119.932c0 3.33 1.384 6.51 3.82 8.78l45.421 42.315zM160 256c0-17.673 14.327-32 32-32 17.673 0 32 14.327 32 32v64.004h-64V256zm224 220v24c0 6.627-5.373 12-12 12H12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12z"] };
var faChevronCircleDown = { prefix: 'fas', iconName: 'chevron-circle-down', icon: [512, 512, [], "f13a", "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"] };
var faChevronCircleLeft = { prefix: 'fas', iconName: 'chevron-circle-left', icon: [512, 512, [], "f137", "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"] };
var faChevronCircleRight = { prefix: 'fas', iconName: 'chevron-circle-right', icon: [512, 512, [], "f138", "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"] };
var faChevronCircleUp = { prefix: 'fas', iconName: 'chevron-circle-up', icon: [512, 512, [], "f139", "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"] };
var faChevronDown = { prefix: 'fas', iconName: 'chevron-down', icon: [448, 512, [], "f078", "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"] };
var faChevronLeft = { prefix: 'fas', iconName: 'chevron-left', icon: [320, 512, [], "f053", "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"] };
var faChevronRight = { prefix: 'fas', iconName: 'chevron-right', icon: [320, 512, [], "f054", "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"] };
var faChevronUp = { prefix: 'fas', iconName: 'chevron-up', icon: [448, 512, [], "f077", "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"] };
var faChild = { prefix: 'fas', iconName: 'child', icon: [384, 512, [], "f1ae", "M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"] };
var faChurch = { prefix: 'fas', iconName: 'church', icon: [640, 512, [], "f51d", "M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"] };
var faCircle = { prefix: 'fas', iconName: 'circle', icon: [512, 512, [], "f111", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"] };
var faCircleNotch = { prefix: 'fas', iconName: 'circle-notch', icon: [512, 512, [], "f1ce", "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"] };
var faCity = { prefix: 'fas', iconName: 'city', icon: [640, 512, [], "f64f", "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"] };
var faClipboard = { prefix: 'fas', iconName: 'clipboard', icon: [384, 512, [], "f328", "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"] };
var faClipboardCheck = { prefix: 'fas', iconName: 'clipboard-check', icon: [384, 512, [], "f46c", "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"] };
var faClipboardList = { prefix: 'fas', iconName: 'clipboard-list', icon: [384, 512, [], "f46d", "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"] };
var faClock = { prefix: 'fas', iconName: 'clock', icon: [512, 512, [], "f017", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm57.1 350.1L224.9 294c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v137.7l63.5 46.2c5.4 3.9 6.5 11.4 2.6 16.8l-28.2 38.8c-3.9 5.3-11.4 6.5-16.8 2.6z"] };
var faClone = { prefix: 'fas', iconName: 'clone', icon: [512, 512, [], "f24d", "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"] };
var faClosedCaptioning = { prefix: 'fas', iconName: 'closed-captioning', icon: [512, 512, [], "f20a", "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"] };
var faCloud = { prefix: 'fas', iconName: 'cloud', icon: [640, 512, [], "f0c2", "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"] };
var faCloudDownloadAlt = { prefix: 'fas', iconName: 'cloud-download-alt', icon: [640, 512, [], "f381", "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"] };
var faCloudUploadAlt = { prefix: 'fas', iconName: 'cloud-upload-alt', icon: [640, 512, [], "f382", "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"] };
var faCocktail = { prefix: 'fas', iconName: 'cocktail', icon: [576, 512, [], "f561", "M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"] };
var faCode = { prefix: 'fas', iconName: 'code', icon: [640, 512, [], "f121", "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"] };
var faCodeBranch = { prefix: 'fas', iconName: 'code-branch', icon: [384, 512, [], "f126", "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"] };
var faCoffee = { prefix: 'fas', iconName: 'coffee', icon: [640, 512, [], "f0f4", "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"] };
var faCog = { prefix: 'fas', iconName: 'cog', icon: [512, 512, [], "f013", "M444.788 291.1l42.616 24.599c4.867 2.809 7.126 8.618 5.459 13.985-11.07 35.642-29.97 67.842-54.689 94.586a12.016 12.016 0 0 1-14.832 2.254l-42.584-24.595a191.577 191.577 0 0 1-60.759 35.13v49.182a12.01 12.01 0 0 1-9.377 11.718c-34.956 7.85-72.499 8.256-109.219.007-5.49-1.233-9.403-6.096-9.403-11.723v-49.184a191.555 191.555 0 0 1-60.759-35.13l-42.584 24.595a12.016 12.016 0 0 1-14.832-2.254c-24.718-26.744-43.619-58.944-54.689-94.586-1.667-5.366.592-11.175 5.459-13.985L67.212 291.1a193.48 193.48 0 0 1 0-70.199l-42.616-24.599c-4.867-2.809-7.126-8.618-5.459-13.985 11.07-35.642 29.97-67.842 54.689-94.586a12.016 12.016 0 0 1 14.832-2.254l42.584 24.595a191.577 191.577 0 0 1 60.759-35.13V25.759a12.01 12.01 0 0 1 9.377-11.718c34.956-7.85 72.499-8.256 109.219-.007 5.49 1.233 9.403 6.096 9.403 11.723v49.184a191.555 191.555 0 0 1 60.759 35.13l42.584-24.595a12.016 12.016 0 0 1 14.832 2.254c24.718 26.744 43.619 58.944 54.689 94.586 1.667 5.366-.592 11.175-5.459 13.985L444.788 220.9a193.485 193.485 0 0 1 0 70.2zM336 256c0-44.112-35.888-80-80-80s-80 35.888-80 80 35.888 80 80 80 80-35.888 80-80z"] };
var faCogs = { prefix: 'fas', iconName: 'cogs', icon: [640, 512, [], "f085", "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"] };
var faCoins = { prefix: 'fas', iconName: 'coins', icon: [512, 512, [], "f51e", "M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"] };
var faColumns = { prefix: 'fas', iconName: 'columns', icon: [512, 512, [], "f0db", "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"] };
var faComment = { prefix: 'fas', iconName: 'comment', icon: [512, 512, [], "f075", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"] };
var faCommentAlt = { prefix: 'fas', iconName: 'comment-alt', icon: [512, 512, [], "f27a", "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"] };
var faCommentDollar = { prefix: 'fas', iconName: 'comment-dollar', icon: [512, 512, [], "f651", "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"] };
var faCommentDots = { prefix: 'fas', iconName: 'comment-dots', icon: [512, 512, [], "f4ad", "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"] };
var faCommentSlash = { prefix: 'fas', iconName: 'comment-slash', icon: [640, 512, [], "f4b3", "M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"] };
var faComments = { prefix: 'fas', iconName: 'comments', icon: [576, 512, [], "f086", "M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"] };
var faCommentsDollar = { prefix: 'fas', iconName: 'comments-dollar', icon: [576, 512, [], "f653", "M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"] };
var faCompactDisc = { prefix: 'fas', iconName: 'compact-disc', icon: [496, 512, [], "f51f", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"] };
var faCompass = { prefix: 'fas', iconName: 'compass', icon: [496, 512, [], "f14e", "M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"] };
var faCompress = { prefix: 'fas', iconName: 'compress', icon: [448, 512, [], "f066", "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"] };
var faConciergeBell = { prefix: 'fas', iconName: 'concierge-bell', icon: [512, 512, [], "f562", "M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"] };
var faCookie = { prefix: 'fas', iconName: 'cookie', icon: [512, 512, [], "f563", "M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"] };
var faCookieBite = { prefix: 'fas', iconName: 'cookie-bite', icon: [512, 512, [], "f564", "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"] };
var faCopy = { prefix: 'fas', iconName: 'copy', icon: [448, 512, [], "f0c5", "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"] };
var faCopyright = { prefix: 'fas', iconName: 'copyright', icon: [512, 512, [], "f1f9", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"] };
var faCouch = { prefix: 'fas', iconName: 'couch', icon: [640, 512, [], "f4b8", "M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"] };
var faCreditCard = { prefix: 'fas', iconName: 'credit-card', icon: [576, 512, [], "f09d", "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"] };
var faCrop = { prefix: 'fas', iconName: 'crop', icon: [512, 512, [], "f125", "M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"] };
var faCropAlt = { prefix: 'fas', iconName: 'crop-alt', icon: [512, 512, [], "f565", "M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"] };
var faCross = { prefix: 'fas', iconName: 'cross', icon: [384, 512, [], "f654", "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"] };
var faCrosshairs = { prefix: 'fas', iconName: 'crosshairs', icon: [512, 512, [], "f05b", "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"] };
var faCrow = { prefix: 'fas', iconName: 'crow', icon: [640, 512, [], "f520", "M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"] };
var faCrown = { prefix: 'fas', iconName: 'crown', icon: [640, 512, [], "f521", "M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"] };
var faCube = { prefix: 'fas', iconName: 'cube', icon: [512, 512, [], "f1b2", "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"] };
var faCubes = { prefix: 'fas', iconName: 'cubes', icon: [512, 512, [], "f1b3", "M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"] };
var faCut = { prefix: 'fas', iconName: 'cut', icon: [448, 512, [], "f0c4", "M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"] };
var faDatabase = { prefix: 'fas', iconName: 'database', icon: [448, 512, [], "f1c0", "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"] };
var faDeaf = { prefix: 'fas', iconName: 'deaf', icon: [512, 512, [], "f2a4", "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"] };
var faDesktop = { prefix: 'fas', iconName: 'desktop', icon: [576, 512, [], "f108", "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"] };
var faDharmachakra = { prefix: 'fas', iconName: 'dharmachakra', icon: [512, 512, [], "f655", "M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"] };
var faDiagnoses = { prefix: 'fas', iconName: 'diagnoses', icon: [640, 512, [], "f470", "M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"] };
var faDice = { prefix: 'fas', iconName: 'dice', icon: [640, 512, [], "f522", "M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"] };
var faDiceFive = { prefix: 'fas', iconName: 'dice-five', icon: [448, 512, [], "f523", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"] };
var faDiceFour = { prefix: 'fas', iconName: 'dice-four', icon: [448, 512, [], "f524", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"] };
var faDiceOne = { prefix: 'fas', iconName: 'dice-one', icon: [448, 512, [], "f525", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"] };
var faDiceSix = { prefix: 'fas', iconName: 'dice-six', icon: [448, 512, [], "f526", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"] };
var faDiceThree = { prefix: 'fas', iconName: 'dice-three', icon: [448, 512, [], "f527", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"] };
var faDiceTwo = { prefix: 'fas', iconName: 'dice-two', icon: [448, 512, [], "f528", "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"] };
var faDigitalTachograph = { prefix: 'fas', iconName: 'digital-tachograph', icon: [640, 512, [], "f566", "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"] };
var faDirections = { prefix: 'fas', iconName: 'directions', icon: [512, 512, [], "f5eb", "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"] };
var faDivide = { prefix: 'fas', iconName: 'divide', icon: [448, 512, [], "f529", "M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"] };
var faDizzy = { prefix: 'fas', iconName: 'dizzy', icon: [496, 512, [], "f567", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"] };
var faDna = { prefix: 'fas', iconName: 'dna', icon: [448, 512, [], "f471", "M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"] };
var faDollarSign = { prefix: 'fas', iconName: 'dollar-sign', icon: [288, 512, [], "f155", "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"] };
var faDolly = { prefix: 'fas', iconName: 'dolly', icon: [576, 512, [], "f472", "M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"] };
var faDollyFlatbed = { prefix: 'fas', iconName: 'dolly-flatbed', icon: [640, 512, [], "f474", "M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"] };
var faDonate = { prefix: 'fas', iconName: 'donate', icon: [512, 512, [], "f4b9", "M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"] };
var faDoorClosed = { prefix: 'fas', iconName: 'door-closed', icon: [640, 512, [], "f52a", "M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"] };
var faDoorOpen = { prefix: 'fas', iconName: 'door-open', icon: [640, 512, [], "f52b", "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"] };
var faDotCircle = { prefix: 'fas', iconName: 'dot-circle', icon: [512, 512, [], "f192", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"] };
var faDove = { prefix: 'fas', iconName: 'dove', icon: [512, 512, [], "f4ba", "M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"] };
var faDownload = { prefix: 'fas', iconName: 'download', icon: [512, 512, [], "f019", "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"] };
var faDraftingCompass = { prefix: 'fas', iconName: 'drafting-compass', icon: [512, 512, [], "f568", "M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"] };
var faDrawPolygon = { prefix: 'fas', iconName: 'draw-polygon', icon: [448, 512, [], "f5ee", "M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"] };
var faDrum = { prefix: 'fas', iconName: 'drum', icon: [576, 512, [], "f569", "M458.08 120.88l102.39-61.43c15.16-9.09 20.06-28.75 10.97-43.91C562.34.39 542.7-4.53 527.53 4.57l-160.69 96.41A629.32 629.32 0 0 0 288 96C128.94 96 0 153.31 0 224v160.83c0 30.46 24.03 58.4 64 80.37v-96.37c0-17.6 14.4-32 32-32s32 14.4 32 32v122.41c37.4 11.13 81 18.44 128 20.75V400.84c0-17.6 14.4-32 32-32s32 14.4 32 32V512c47-2.31 90.6-9.62 128-20.75V368.84c0-17.6 14.4-32 32-32s32 14.4 32 32v96.37c39.97-21.97 64-49.91 64-80.37V224.01c-.01-42.38-46.54-79.84-117.92-103.13zM288 304c-132.55 0-240-35.82-240-80s107.45-80 240-80c2.34 0 4.62.1 6.94.12l-87.41 52.44c-15.16 9.09-20.06 28.75-10.97 43.91 9.56 15.93 29.51 19.61 43.91 10.97l162.71-97.62C477.55 167.41 528 193.74 528 224.01 528 268.19 420.54 304 288 304z"] };
var faDrumSteelpan = { prefix: 'fas', iconName: 'drum-steelpan', icon: [576, 512, [], "f56a", "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"] };
var faDumbbell = { prefix: 'fas', iconName: 'dumbbell', icon: [640, 512, [], "f44b", "M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"] };
var faEdit = { prefix: 'fas', iconName: 'edit', icon: [576, 512, [], "f044", "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"] };
var faEject = { prefix: 'fas', iconName: 'eject', icon: [448, 512, [], "f052", "M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"] };
var faEllipsisH = { prefix: 'fas', iconName: 'ellipsis-h', icon: [512, 512, [], "f141", "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"] };
var faEllipsisV = { prefix: 'fas', iconName: 'ellipsis-v', icon: [192, 512, [], "f142", "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"] };
var faEnvelope = { prefix: 'fas', iconName: 'envelope', icon: [512, 512, [], "f0e0", "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"] };
var faEnvelopeOpen = { prefix: 'fas', iconName: 'envelope-open', icon: [512, 512, [], "f2b6", "M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"] };
var faEnvelopeOpenText = { prefix: 'fas', iconName: 'envelope-open-text', icon: [512, 512, [], "f658", "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"] };
var faEnvelopeSquare = { prefix: 'fas', iconName: 'envelope-square', icon: [448, 512, [], "f199", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"] };
var faEquals = { prefix: 'fas', iconName: 'equals', icon: [448, 512, [], "f52c", "M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"] };
var faEraser = { prefix: 'fas', iconName: 'eraser', icon: [512, 512, [], "f12d", "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"] };
var faEuroSign = { prefix: 'fas', iconName: 'euro-sign', icon: [320, 512, [], "f153", "M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"] };
var faExchangeAlt = { prefix: 'fas', iconName: 'exchange-alt', icon: [512, 512, [], "f362", "M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"] };
var faExclamation = { prefix: 'fas', iconName: 'exclamation', icon: [192, 512, [], "f12a", "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"] };
var faExclamationCircle = { prefix: 'fas', iconName: 'exclamation-circle', icon: [512, 512, [], "f06a", "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"] };
var faExclamationTriangle = { prefix: 'fas', iconName: 'exclamation-triangle', icon: [576, 512, [], "f071", "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"] };
var faExpand = { prefix: 'fas', iconName: 'expand', icon: [448, 512, [], "f065", "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"] };
var faExpandArrowsAlt = { prefix: 'fas', iconName: 'expand-arrows-alt', icon: [448, 512, [], "f31e", "M448.1 344v112c0 13.3-10.7 24-24 24h-112c-21.4 0-32.1-25.9-17-41l36.2-36.2L224 295.6 116.8 402.9 153 439c15.1 15.1 4.4 41-17 41H24c-13.3 0-24-10.7-24-24V344c0-21.4 25.9-32.1 41-17l36.2 36.2L184.5 256 77.2 148.7 41 185c-15.1 15.1-41 4.4-41-17V56c0-13.3 10.7-24 24-24h112c21.4 0 32.1 25.9 17 41l-36.2 36.2L224 216.4l107.3-107.3L295.1 73c-15.1-15.1-4.4-41 17-41h112c13.3 0 24 10.7 24 24v112c0 21.4-25.9 32.1-41 17l-36.2-36.2L263.6 256l107.3 107.3 36.2-36.2c15.1-15.2 41-4.5 41 16.9z"] };
var faExternalLinkAlt = { prefix: 'fas', iconName: 'external-link-alt', icon: [576, 512, [], "f35d", "M576 24v127.984c0 21.461-25.96 31.98-40.971 16.971l-35.707-35.709-243.523 243.523c-9.373 9.373-24.568 9.373-33.941 0l-22.627-22.627c-9.373-9.373-9.373-24.569 0-33.941L442.756 76.676l-35.703-35.705C391.982 25.9 402.656 0 424.024 0H552c13.255 0 24 10.745 24 24zM407.029 270.794l-16 16A23.999 23.999 0 0 0 384 303.765V448H64V128h264a24.003 24.003 0 0 0 16.97-7.029l16-16C376.089 89.851 365.381 64 344 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V287.764c0-21.382-25.852-32.09-40.971-16.97z"] };
var faExternalLinkSquareAlt = { prefix: 'fas', iconName: 'external-link-square-alt', icon: [448, 512, [], "f360", "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"] };
var faEye = { prefix: 'fas', iconName: 'eye', icon: [576, 512, [], "f06e", "M569.354 231.631C512.969 135.949 407.81 72 288 72 168.14 72 63.004 135.994 6.646 231.631a47.999 47.999 0 0 0 0 48.739C63.031 376.051 168.19 440 288 440c119.86 0 224.996-63.994 281.354-159.631a47.997 47.997 0 0 0 0-48.738zM288 392c-75.162 0-136-60.827-136-136 0-75.162 60.826-136 136-136 75.162 0 136 60.826 136 136 0 75.162-60.826 136-136 136zm104-136c0 57.438-46.562 104-104 104s-104-46.562-104-104c0-17.708 4.431-34.379 12.236-48.973l-.001.032c0 23.651 19.173 42.823 42.824 42.823s42.824-19.173 42.824-42.823c0-23.651-19.173-42.824-42.824-42.824l-.032.001C253.621 156.431 270.292 152 288 152c57.438 0 104 46.562 104 104z"] };
var faEyeDropper = { prefix: 'fas', iconName: 'eye-dropper', icon: [512, 512, [], "f1fb", "M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"] };
var faEyeSlash = { prefix: 'fas', iconName: 'eye-slash', icon: [576, 512, [], "f070", "M286.693 391.984l32.579 46.542A333.958 333.958 0 0 1 288 440C168.19 440 63.031 376.051 6.646 280.369a47.999 47.999 0 0 1 0-48.739c24.023-40.766 56.913-75.775 96.024-102.537l57.077 81.539C154.736 224.82 152 240.087 152 256c0 74.736 60.135 135.282 134.693 135.984zm282.661-111.615c-31.667 53.737-78.747 97.46-135.175 125.475l.011.015 41.47 59.2c7.6 10.86 4.96 25.82-5.9 33.42l-13.11 9.18c-10.86 7.6-25.82 4.96-33.42-5.9L100.34 46.94c-7.6-10.86-4.96-25.82 5.9-33.42l13.11-9.18c10.86-7.6 25.82-4.96 33.42 5.9l51.038 72.617C230.68 75.776 258.905 72 288 72c119.81 0 224.969 63.949 281.354 159.631a48.002 48.002 0 0 1 0 48.738zM424 256c0-75.174-60.838-136-136-136-17.939 0-35.056 3.473-50.729 9.772l19.299 27.058c25.869-8.171 55.044-6.163 80.4 7.41h-.03c-23.65 0-42.82 19.17-42.82 42.82 0 23.626 19.147 42.82 42.82 42.82 23.65 0 42.82-19.17 42.82-42.82v-.03c18.462 34.49 16.312 77.914-8.25 110.95v.01l19.314 27.061C411.496 321.2 424 290.074 424 256zM262.014 356.727l-77.53-110.757c-5.014 52.387 29.314 98.354 77.53 110.757z"] };
var faFastBackward = { prefix: 'fas', iconName: 'fast-backward', icon: [512, 512, [], "f049", "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"] };
var faFastForward = { prefix: 'fas', iconName: 'fast-forward', icon: [512, 512, [], "f050", "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"] };
var faFax = { prefix: 'fas', iconName: 'fax', icon: [512, 512, [], "f1ac", "M64 128H32c-17.67 0-32 14.33-32 32v320c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zm416 32V77.25c0-8.49-3.37-16.62-9.37-22.63L425.37 9.37c-6-6-14.14-9.37-22.63-9.37H160c-17.67 0-32 14.33-32 32v448c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zM288 432c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v32zm0-128c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v32zm128 128c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v32zm0-128c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v32zm16-112H176V48h208v32c0 8.84 7.16 16 16 16h32v96z"] };
var faFeather = { prefix: 'fas', iconName: 'feather', icon: [512, 512, [], "f52d", "M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"] };
var faFeatherAlt = { prefix: 'fas', iconName: 'feather-alt', icon: [512, 512, [], "f56b", "M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"] };
var faFemale = { prefix: 'fas', iconName: 'female', icon: [256, 512, [], "f182", "M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"] };
var faFighterJet = { prefix: 'fas', iconName: 'fighter-jet', icon: [640, 512, [], "f0fb", "M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"] };
var faFile = { prefix: 'fas', iconName: 'file', icon: [384, 512, [], "f15b", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"] };
var faFileAlt = { prefix: 'fas', iconName: 'file-alt', icon: [384, 512, [], "f15c", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"] };
var faFileArchive = { prefix: 'fas', iconName: 'file-archive', icon: [384, 512, [], "f1c6", "M224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32V32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6zm32.7-53c0 14.9-14.5 27-32.4 27S96 378 96 363c0-14.9 14.5-27 32.4-27s32.5 12.1 32.5 27zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"] };
var faFileAudio = { prefix: 'fas', iconName: 'file-audio', icon: [384, 512, [], "f1c7", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"] };
var faFileCode = { prefix: 'fas', iconName: 'file-code', icon: [384, 512, [], "f1c9", "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"] };
var faFileContract = { prefix: 'fas', iconName: 'file-contract', icon: [384, 512, [], "f56c", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"] };
var faFileDownload = { prefix: 'fas', iconName: 'file-download', icon: [384, 512, [], "f56d", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"] };
var faFileExcel = { prefix: 'fas', iconName: 'file-excel', icon: [384, 512, [], "f1c3", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"] };
var faFileExport = { prefix: 'fas', iconName: 'file-export', icon: [576, 512, [], "f56e", "M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zM192 336v-32c0-8.84 7.16-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.84 0-16-7.16-16-16zm379.05-28.02l-95.7-96.43c-10.06-10.14-27.36-3.01-27.36 11.27V288H384v64h63.99v65.18c0 14.28 17.29 21.41 27.36 11.27l95.7-96.42c6.6-6.66 6.6-17.4 0-24.05z"] };
var faFileImage = { prefix: 'fas', iconName: 'file-image', icon: [384, 512, [], "f1c5", "M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"] };
var faFileImport = { prefix: 'fas', iconName: 'file-import', icon: [512, 512, [], "f56f", "M16 288c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h112v-64H16zm336-152V0H152c-13.3 0-24 10.7-24 24v264h127.99v-65.18c0-14.28 17.29-21.41 27.36-11.27l95.7 96.43c6.6 6.65 6.6 17.39 0 24.04l-95.7 96.42c-10.06 10.14-27.36 3.01-27.36-11.27V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24zm153-31L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"] };
var faFileInvoice = { prefix: 'fas', iconName: 'file-invoice', icon: [384, 512, [], "f570", "M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"] };
var faFileInvoiceDollar = { prefix: 'fas', iconName: 'file-invoice-dollar', icon: [384, 512, [], "f571", "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"] };
var faFileMedical = { prefix: 'fas', iconName: 'file-medical', icon: [384, 512, [], "f477", "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"] };
var faFileMedicalAlt = { prefix: 'fas', iconName: 'file-medical-alt', icon: [448, 512, [], "f478", "M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"] };
var faFilePdf = { prefix: 'fas', iconName: 'file-pdf', icon: [384, 512, [], "f1c1", "M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"] };
var faFilePowerpoint = { prefix: 'fas', iconName: 'file-powerpoint', icon: [384, 512, [], "f1c4", "M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"] };
var faFilePrescription = { prefix: 'fas', iconName: 'file-prescription', icon: [384, 512, [], "f572", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"] };
var faFileSignature = { prefix: 'fas', iconName: 'file-signature', icon: [576, 512, [], "f573", "M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"] };
var faFileUpload = { prefix: 'fas', iconName: 'file-upload', icon: [384, 512, [], "f574", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"] };
var faFileVideo = { prefix: 'fas', iconName: 'file-video', icon: [384, 512, [], "f1c8", "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"] };
var faFileWord = { prefix: 'fas', iconName: 'file-word', icon: [384, 512, [], "f1c2", "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"] };
var faFill = { prefix: 'fas', iconName: 'fill', icon: [512, 512, [], "f575", "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"] };
var faFillDrip = { prefix: 'fas', iconName: 'fill-drip', icon: [576, 512, [], "f576", "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"] };
var faFilm = { prefix: 'fas', iconName: 'film', icon: [512, 512, [], "f008", "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"] };
var faFilter = { prefix: 'fas', iconName: 'filter', icon: [512, 512, [], "f0b0", "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"] };
var faFingerprint = { prefix: 'fas', iconName: 'fingerprint', icon: [512, 512, [], "f577", "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"] };
var faFire = { prefix: 'fas', iconName: 'fire', icon: [384, 512, [], "f06d", "M216 23.858c0-23.802-30.653-32.765-44.149-13.038C48 191.851 224 200 224 288c0 35.629-29.114 64.458-64.85 63.994C123.98 351.538 96 322.22 96 287.046v-85.51c0-21.703-26.471-32.225-41.432-16.504C27.801 213.158 0 261.332 0 320c0 105.869 86.131 192 192 192s192-86.131 192-192c0-170.29-168-193.003-168-296.142z"] };
var faFireExtinguisher = { prefix: 'fas', iconName: 'fire-extinguisher', icon: [448, 512, [], "f134", "M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"] };
var faFirstAid = { prefix: 'fas', iconName: 'first-aid', icon: [576, 512, [], "f479", "M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"] };
var faFish = { prefix: 'fas', iconName: 'fish', icon: [576, 512, [], "f578", "M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"] };
var faFlag = { prefix: 'fas', iconName: 'flag', icon: [512, 512, [], "f024", "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"] };
var faFlagCheckered = { prefix: 'fas', iconName: 'flag-checkered', icon: [512, 512, [], "f11e", "M466.515 66.928C487.731 57.074 512 72.551 512 95.944v243.1c0 10.526-5.161 20.407-13.843 26.358-35.837 24.564-74.335 40.858-122.505 40.858-67.373 0-111.63-34.783-165.217-34.783-50.853 0-86.124 10.058-114.435 22.122V488c0 13.255-10.745 24-24 24H56c-13.255 0-24-10.745-24-24V101.945C17.497 91.825 8 75.026 8 56 8 24.296 34.345-1.254 66.338.048c28.468 1.158 51.779 23.968 53.551 52.404.52 8.342-.81 16.31-3.586 23.562C137.039 68.384 159.393 64 184.348 64c67.373 0 111.63 34.783 165.217 34.783 40.496 0 82.612-15.906 116.95-31.855zM96 134.63v70.49c29-10.67 51.18-17.83 73.6-20.91v-71.57c-23.5 2.17-40.44 9.79-73.6 21.99zm220.8 9.19c-26.417-4.672-49.886-13.979-73.6-21.34v67.42c24.175 6.706 47.566 16.444 73.6 22.31v-68.39zm-147.2 40.39v70.04c32.796-2.978 53.91-.635 73.6 3.8V189.9c-25.247-7.035-46.581-9.423-73.6-5.69zm73.6 142.23c26.338 4.652 49.732 13.927 73.6 21.34v-67.41c-24.277-6.746-47.54-16.45-73.6-22.32v68.39zM96 342.1c23.62-8.39 47.79-13.84 73.6-16.56v-71.29c-26.11 2.35-47.36 8.04-73.6 17.36v70.49zm368-221.6c-21.3 8.85-46.59 17.64-73.6 22.47v71.91c27.31-4.36 50.03-14.1 73.6-23.89V120.5zm0 209.96v-70.49c-22.19 14.2-48.78 22.61-73.6 26.02v71.58c25.07-2.38 48.49-11.04 73.6-27.11zM316.8 212.21v68.16c25.664 7.134 46.616 9.342 73.6 5.62v-71.11c-25.999 4.187-49.943 2.676-73.6-2.67z"] };
var faFlask = { prefix: 'fas', iconName: 'flask', icon: [448, 512, [], "f0c3", "M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"] };
var faFlushed = { prefix: 'fas', iconName: 'flushed', icon: [496, 512, [], "f579", "M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"] };
var faFolder = { prefix: 'fas', iconName: 'folder', icon: [512, 512, [], "f07b", "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"] };
var faFolderMinus = { prefix: 'fas', iconName: 'folder-minus', icon: [512, 512, [], "f65d", "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"] };
var faFolderOpen = { prefix: 'fas', iconName: 'folder-open', icon: [576, 512, [], "f07c", "M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"] };
var faFolderPlus = { prefix: 'fas', iconName: 'folder-plus', icon: [512, 512, [], "f65e", "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16h-72v72c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-72h-72c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h72v-72c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v72h72c8.84 0 16 7.16 16 16v16z"] };
var faFont = { prefix: 'fas', iconName: 'font', icon: [448, 512, [], "f031", "M152 416h-24.013l26.586-80.782H292.8L319.386 416H296c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h136c8.837 0 16-7.163 16-16v-32c0-8.837-7.163-16-16-16h-26.739L275.495 42.746A16 16 0 0 0 260.382 32h-72.766a16 16 0 0 0-15.113 10.746L42.739 416H16c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h136c8.837 0 16-7.163 16-16v-32c0-8.837-7.163-16-16-16zm64.353-271.778c4.348-15.216 6.61-28.156 7.586-34.644.839 6.521 2.939 19.476 7.727 34.706l41.335 124.006h-98.619l41.971-124.068z"] };
var faFontAwesomeLogoFull = { prefix: 'fas', iconName: 'font-awesome-logo-full', icon: [3992, 512, ["Font Awesome"], "f4e6", "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"] };
var faFootballBall = { prefix: 'fas', iconName: 'football-ball', icon: [496, 512, [], "f44e", "M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"] };
var faForward = { prefix: 'fas', iconName: 'forward', icon: [512, 512, [], "f04e", "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"] };
var faFrog = { prefix: 'fas', iconName: 'frog', icon: [576, 512, [], "f52e", "M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"] };
var faFrown = { prefix: 'fas', iconName: 'frown', icon: [496, 512, [], "f119", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"] };
var faFrownOpen = { prefix: 'fas', iconName: 'frown-open', icon: [496, 512, [], "f57a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"] };
var faFunnelDollar = { prefix: 'fas', iconName: 'funnel-dollar', icon: [640, 512, [], "f662", "M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"] };
var faFutbol = { prefix: 'fas', iconName: 'futbol', icon: [512, 512, [], "f1e3", "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"] };
var faGamepad = { prefix: 'fas', iconName: 'gamepad', icon: [640, 512, [], "f11b", "M480 96H160C71.6 96 0 167.6 0 256s71.6 160 160 160c44.8 0 85.2-18.4 114.2-48h91.5c29 29.6 69.5 48 114.2 48 88.4 0 160-71.6 160-160S568.4 96 480 96zM256 276c0 6.6-5.4 12-12 12h-52v52c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-52H76c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h52v-52c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h52c6.6 0 12 5.4 12 12v40zm184 68c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-80c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"] };
var faGasPump = { prefix: 'fas', iconName: 'gas-pump', icon: [512, 512, [], "f52f", "M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"] };
var faGavel = { prefix: 'fas', iconName: 'gavel', icon: [512, 512, [], "f0e3", "M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"] };
var faGem = { prefix: 'fas', iconName: 'gem', icon: [576, 512, [], "f3a5", "M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"] };
var faGenderless = { prefix: 'fas', iconName: 'genderless', icon: [288, 512, [], "f22d", "M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"] };
var faGift = { prefix: 'fas', iconName: 'gift', icon: [512, 512, [], "f06b", "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm448-288h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40zm-72 320h160c17.7 0 32-14.3 32-32V320H288v160z"] };
var faGlassMartini = { prefix: 'fas', iconName: 'glass-martini', icon: [512, 512, [], "f000", "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"] };
var faGlassMartiniAlt = { prefix: 'fas', iconName: 'glass-martini-alt', icon: [512, 512, [], "f57b", "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"] };
var faGlasses = { prefix: 'fas', iconName: 'glasses', icon: [576, 512, [], "f530", "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"] };
var faGlobe = { prefix: 'fas', iconName: 'globe', icon: [496, 512, [], "f0ac", "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"] };
var faGlobeAfrica = { prefix: 'fas', iconName: 'globe-africa', icon: [496, 512, [], "f57c", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"] };
var faGlobeAmericas = { prefix: 'fas', iconName: 'globe-americas', icon: [496, 512, [], "f57d", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"] };
var faGlobeAsia = { prefix: 'fas', iconName: 'globe-asia', icon: [496, 512, [], "f57e", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"] };
var faGolfBall = { prefix: 'fas', iconName: 'golf-ball', icon: [416, 512, [], "f450", "M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"] };
var faGopuram = { prefix: 'fas', iconName: 'gopuram', icon: [512, 512, [], "f664", "M496 352h-16V240c0-8.84-7.16-16-16-16h-16v-80c0-8.84-7.16-16-16-16h-16V16c0-8.84-7.16-16-16-16s-16 7.16-16 16v16h-64V16c0-8.84-7.16-16-16-16s-16 7.16-16 16v16h-64V16c0-8.84-7.16-16-16-16s-16 7.16-16 16v16h-64V16c0-8.84-7.16-16-16-16S96 7.16 96 16v112H80c-8.84 0-16 7.16-16 16v80H48c-8.84 0-16 7.16-16 16v112H16c-8.84 0-16 7.16-16 16v128c0 8.84 7.16 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.84 0 16-7.16 16-16V368c0-8.84-7.16-16-16-16zm-272 0v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64h-64zm8-128v-48c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v48h-48z"] };
var faGraduationCap = { prefix: 'fas', iconName: 'graduation-cap', icon: [640, 512, [], "f19d", "M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"] };
var faGreaterThan = { prefix: 'fas', iconName: 'greater-than', icon: [384, 512, [], "f531", "M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"] };
var faGreaterThanEqual = { prefix: 'fas', iconName: 'greater-than-equal', icon: [448, 512, [], "f532", "M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"] };
var faGrimace = { prefix: 'fas', iconName: 'grimace', icon: [496, 512, [], "f57f", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"] };
var faGrin = { prefix: 'fas', iconName: 'grin', icon: [496, 512, [], "f580", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"] };
var faGrinAlt = { prefix: 'fas', iconName: 'grin-alt', icon: [496, 512, [], "f581", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"] };
var faGrinBeam = { prefix: 'fas', iconName: 'grin-beam', icon: [496, 512, [], "f582", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"] };
var faGrinBeamSweat = { prefix: 'fas', iconName: 'grin-beam-sweat', icon: [504, 512, [], "f583", "M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"] };
var faGrinHearts = { prefix: 'fas', iconName: 'grin-hearts', icon: [496, 512, [], "f584", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"] };
var faGrinSquint = { prefix: 'fas', iconName: 'grin-squint', icon: [496, 512, [], "f585", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"] };
var faGrinSquintTears = { prefix: 'fas', iconName: 'grin-squint-tears', icon: [512, 512, [], "f586", "M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"] };
var faGrinStars = { prefix: 'fas', iconName: 'grin-stars', icon: [496, 512, [], "f587", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"] };
var faGrinTears = { prefix: 'fas', iconName: 'grin-tears', icon: [640, 512, [], "f588", "M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"] };
var faGrinTongue = { prefix: 'fas', iconName: 'grin-tongue', icon: [496, 512, [], "f589", "M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"] };
var faGrinTongueSquint = { prefix: 'fas', iconName: 'grin-tongue-squint', icon: [496, 512, [], "f58a", "M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"] };
var faGrinTongueWink = { prefix: 'fas', iconName: 'grin-tongue-wink', icon: [496, 512, [], "f58b", "M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"] };
var faGrinWink = { prefix: 'fas', iconName: 'grin-wink', icon: [496, 512, [], "f58c", "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"] };
var faGripHorizontal = { prefix: 'fas', iconName: 'grip-horizontal', icon: [448, 512, [], "f58d", "M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"] };
var faGripVertical = { prefix: 'fas', iconName: 'grip-vertical', icon: [320, 512, [], "f58e", "M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"] };
var faHSquare = { prefix: 'fas', iconName: 'h-square', icon: [448, 512, [], "f0fd", "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"] };
var faHamsa = { prefix: 'fas', iconName: 'hamsa', icon: [512, 512, [], "f665", "M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"] };
var faHandHolding = { prefix: 'fas', iconName: 'hand-holding', icon: [576, 512, [], "f4bd", "M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"] };
var faHandHoldingHeart = { prefix: 'fas', iconName: 'hand-holding-heart', icon: [576, 512, [], "f4be", "M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"] };
var faHandHoldingUsd = { prefix: 'fas', iconName: 'hand-holding-usd', icon: [544, 512, [], "f4c0", "M257.6 144.3l50 14.3c3.6 1 6.1 4.4 6.1 8.1 0 4.6-3.8 8.4-8.4 8.4h-32.8c-3.6 0-7.1-.8-10.3-2.2-4.8-2.2-10.4-1.7-14.1 2l-17.5 17.5c-5.3 5.3-4.7 14.3 1.5 18.4 9.5 6.3 20.3 10.1 31.8 11.5V240c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-17.6c30.3-3.6 53.3-31 49.3-63-2.9-23-20.7-41.3-42.9-47.7l-50-14.3c-3.6-1-6.1-4.4-6.1-8.1 0-4.6 3.8-8.4 8.4-8.4h32.8c3.6 0 7.1.8 10.3 2.2 4.8 2.2 10.4 1.7 14.1-2l17.5-17.5c5.3-5.3 4.7-14.3-1.5-18.4-9.5-6.3-20.3-10.1-31.8-11.5V16c0-8.8-7.2-16-16-16h-16c-8.8 0-16 7.2-16 16v17.6c-30.3 3.6-53.3 31-49.3 63 2.9 23 20.7 41.3 42.9 47.7zm276.3 183.8c-11.2-10.7-28.5-10-40.3 0L406.4 402c-10.7 9.1-24 14-37.8 14H256.9c-8.3 0-15.1-7.2-15.1-16s6.8-16 15.1-16h73.9c15.1 0 29-10.9 31.4-26.6 3.1-20-11.5-37.4-29.8-37.4H181.3c-25.5 0-50.2 9.3-69.9 26.3L67.5 384H15.1C6.8 384 0 391.2 0 400v96c0 8.8 6.8 16 15.1 16H352c13.7 0 27-4.9 37.8-14l142.8-121c14.4-12.1 15.5-35.3 1.3-48.9z"] };
var faHandLizard = { prefix: 'fas', iconName: 'hand-lizard', icon: [576, 512, [], "f258", "M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"] };
var faHandPaper = { prefix: 'fas', iconName: 'hand-paper', icon: [448, 512, [], "f256", "M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"] };
var faHandPeace = { prefix: 'fas', iconName: 'hand-peace', icon: [448, 512, [], "f25b", "M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"] };
var faHandPointDown = { prefix: 'fas', iconName: 'hand-point-down', icon: [384, 512, [], "f0a7", "M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"] };
var faHandPointLeft = { prefix: 'fas', iconName: 'hand-point-left', icon: [512, 512, [], "f0a5", "M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"] };
var faHandPointRight = { prefix: 'fas', iconName: 'hand-point-right', icon: [512, 512, [], "f0a4", "M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"] };
var faHandPointUp = { prefix: 'fas', iconName: 'hand-point-up', icon: [384, 512, [], "f0a6", "M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"] };
var faHandPointer = { prefix: 'fas', iconName: 'hand-pointer', icon: [448, 512, [], "f25a", "M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"] };
var faHandRock = { prefix: 'fas', iconName: 'hand-rock', icon: [512, 512, [], "f255", "M512 128.79c0-26.322-20.861-48.344-47.18-48.783C437.935 79.558 416 101.217 416 128h-8V96.79c0-26.322-20.861-48.344-47.18-48.783C333.935 47.558 312 69.217 312 96v32h-8V80.79c0-26.322-20.861-48.344-47.18-48.783C229.935 31.558 208 53.217 208 80v48h-8V96.79c0-26.322-20.861-48.344-47.18-48.783C125.935 47.558 104 69.217 104 96v136l-8-7.111V176.79c0-26.322-20.861-48.344-47.18-48.783C21.935 127.558 0 149.217 0 176v66.445a95.998 95.998 0 0 0 32.221 71.751l111.668 99.261A47.999 47.999 0 0 1 160 449.333V456c0 13.255 10.745 24 24 24h240c13.255 0 24-10.745 24-24v-2.921a96.01 96.01 0 0 1 7.523-37.254l48.954-116.265A96.002 96.002 0 0 0 512 262.306V128.79z"] };
var faHandScissors = { prefix: 'fas', iconName: 'hand-scissors', icon: [512, 512, [], "f257", "M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"] };
var faHandSpock = { prefix: 'fas', iconName: 'hand-spock', icon: [512, 512, [], "f259", "M10.872 316.585c15.139-16.086 40.454-16.854 56.543-1.713L128 371.893v-79.405L88.995 120.865c-4.896-21.542 8.598-42.974 30.14-47.87 21.549-4.894 42.975 8.599 47.87 30.141L201.747 256h9.833L164.016 48.966c-4.946-21.531 8.498-42.994 30.028-47.94 21.532-4.95 42.994 8.498 47.94 30.028L293.664 256h15.105l48.425-193.702c5.357-21.432 27.075-34.462 48.507-29.104 21.432 5.358 34.463 27.075 29.104 48.507L391.231 256h11.08l30.768-129.265c5.117-21.491 26.685-34.768 48.177-29.647 21.491 5.117 34.765 26.686 29.647 48.177l-36.292 152.467A96.024 96.024 0 0 0 472 319.967v42.102a96.002 96.002 0 0 1-3.96 27.287l-26.174 88.287C435.825 498.022 417.101 512 395.846 512H179.172a48.002 48.002 0 0 1-32.898-13.046L12.585 373.128c-16.087-15.141-16.853-40.456-1.713-56.543z"] };
var faHands = { prefix: 'fas', iconName: 'hands', icon: [640, 512, [], "f4c2", "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"] };
var faHandsHelping = { prefix: 'fas', iconName: 'hands-helping', icon: [640, 512, [], "f4c4", "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"] };
var faHandshake = { prefix: 'fas', iconName: 'handshake', icon: [640, 512, [], "f2b5", "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"] };
var faHashtag = { prefix: 'fas', iconName: 'hashtag', icon: [448, 512, [], "f292", "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"] };
var faHaykal = { prefix: 'fas', iconName: 'haykal', icon: [512, 512, [], "f666", "M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"] };
var faHdd = { prefix: 'fas', iconName: 'hdd', icon: [576, 512, [], "f0a0", "M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"] };
var faHeading = { prefix: 'fas', iconName: 'heading', icon: [512, 512, [], "f1dc", "M496 80V48c0-8.837-7.163-16-16-16H320c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h37.621v128H154.379V96H192c8.837 0 16-7.163 16-16V48c0-8.837-7.163-16-16-16H32c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h37.275v320H32c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h160c8.837 0 16-7.163 16-16v-32c0-8.837-7.163-16-16-16h-37.621V288H357.62v128H320c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h160c8.837 0 16-7.163 16-16v-32c0-8.837-7.163-16-16-16h-37.275V96H480c8.837 0 16-7.163 16-16z"] };
var faHeadphones = { prefix: 'fas', iconName: 'headphones', icon: [512, 512, [], "f025", "M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"] };
var faHeadphonesAlt = { prefix: 'fas', iconName: 'headphones-alt', icon: [512, 512, [], "f58f", "M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"] };
var faHeadset = { prefix: 'fas', iconName: 'headset', icon: [512, 512, [], "f590", "M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"] };
var faHeart = { prefix: 'fas', iconName: 'heart', icon: [512, 512, [], "f004", "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"] };
var faHeartbeat = { prefix: 'fas', iconName: 'heartbeat', icon: [512, 512, [], "f21e", "M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"] };
var faHelicopter = { prefix: 'fas', iconName: 'helicopter', icon: [640, 512, [], "f533", "M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"] };
var faHighlighter = { prefix: 'fas', iconName: 'highlighter', icon: [544, 512, [], "f591", "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"] };
var faHistory = { prefix: 'fas', iconName: 'history', icon: [512, 512, [], "f1da", "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"] };
var faHockeyPuck = { prefix: 'fas', iconName: 'hockey-puck', icon: [512, 512, [], "f453", "M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"] };
var faHome = { prefix: 'fas', iconName: 'home', icon: [576, 512, [], "f015", "M488 312.7V456c0 13.3-10.7 24-24 24H348c-6.6 0-12-5.4-12-12V356c0-6.6-5.4-12-12-12h-72c-6.6 0-12 5.4-12 12v112c0 6.6-5.4 12-12 12H112c-13.3 0-24-10.7-24-24V312.7c0-3.6 1.6-7 4.4-9.3l188-154.8c4.4-3.6 10.8-3.6 15.3 0l188 154.8c2.7 2.3 4.3 5.7 4.3 9.3zm83.6-60.9L488 182.9V44.4c0-6.6-5.4-12-12-12h-56c-6.6 0-12 5.4-12 12V117l-89.5-73.7c-17.7-14.6-43.3-14.6-61 0L4.4 251.8c-5.1 4.2-5.8 11.8-1.6 16.9l25.5 31c4.2 5.1 11.8 5.8 16.9 1.6l235.2-193.7c4.4-3.6 10.8-3.6 15.3 0l235.2 193.7c5.1 4.2 12.7 3.5 16.9-1.6l25.5-31c4.2-5.2 3.4-12.7-1.7-16.9z"] };
var faHospital = { prefix: 'fas', iconName: 'hospital', icon: [448, 512, [], "f0f8", "M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"] };
var faHospitalAlt = { prefix: 'fas', iconName: 'hospital-alt', icon: [576, 512, [], "f47d", "M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"] };
var faHospitalSymbol = { prefix: 'fas', iconName: 'hospital-symbol', icon: [512, 512, [], "f47e", "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"] };
var faHotTub = { prefix: 'fas', iconName: 'hot-tub', icon: [512, 512, [], "f593", "M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"] };
var faHotel = { prefix: 'fas', iconName: 'hotel', icon: [576, 512, [], "f594", "M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"] };
var faHourglass = { prefix: 'fas', iconName: 'hourglass', icon: [384, 512, [], "f254", "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"] };
var faHourglassEnd = { prefix: 'fas', iconName: 'hourglass-end', icon: [384, 512, [], "f253", "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"] };
var faHourglassHalf = { prefix: 'fas', iconName: 'hourglass-half', icon: [384, 512, [], "f252", "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"] };
var faHourglassStart = { prefix: 'fas', iconName: 'hourglass-start', icon: [384, 512, [], "f251", "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"] };
var faICursor = { prefix: 'fas', iconName: 'i-cursor', icon: [256, 512, [], "f246", "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"] };
var faIdBadge = { prefix: 'fas', iconName: 'id-badge', icon: [384, 512, [], "f2c1", "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"] };
var faIdCard = { prefix: 'fas', iconName: 'id-card', icon: [576, 512, [], "f2c2", "M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"] };
var faIdCardAlt = { prefix: 'fas', iconName: 'id-card-alt', icon: [576, 512, [], "f47f", "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"] };
var faImage = { prefix: 'fas', iconName: 'image', icon: [512, 512, [], "f03e", "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"] };
var faImages = { prefix: 'fas', iconName: 'images', icon: [576, 512, [], "f302", "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"] };
var faInbox = { prefix: 'fas', iconName: 'inbox', icon: [576, 512, [], "f01c", "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"] };
var faIndent = { prefix: 'fas', iconName: 'indent', icon: [448, 512, [], "f03c", "M0 84V44c0-8.837 7.163-16 16-16h416c8.837 0 16 7.163 16 16v40c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16zm176 144h256c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H176c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zM16 484h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm160-128h256c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H176c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm-52.687-111.313l-96-95.984C17.266 138.652 0 145.776 0 160.016v191.975c0 14.329 17.325 21.304 27.313 11.313l96-95.992c6.249-6.247 6.249-16.377 0-22.625z"] };
var faIndustry = { prefix: 'fas', iconName: 'industry', icon: [512, 512, [], "f275", "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"] };
var faInfinity = { prefix: 'fas', iconName: 'infinity', icon: [640, 512, [], "f534", "M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"] };
var faInfo = { prefix: 'fas', iconName: 'info', icon: [192, 512, [], "f129", "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"] };
var faInfoCircle = { prefix: 'fas', iconName: 'info-circle', icon: [512, 512, [], "f05a", "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"] };
var faItalic = { prefix: 'fas', iconName: 'italic', icon: [320, 512, [], "f033", "M204.758 416h-33.849l62.092-320h40.725a16 16 0 0 0 15.704-12.937l6.242-32C297.599 41.184 290.034 32 279.968 32H120.235a16 16 0 0 0-15.704 12.937l-6.242 32C96.362 86.816 103.927 96 113.993 96h33.846l-62.09 320H46.278a16 16 0 0 0-15.704 12.935l-6.245 32C22.402 470.815 29.967 480 40.034 480h158.479a16 16 0 0 0 15.704-12.935l6.245-32c1.927-9.88-5.638-19.065-15.704-19.065z"] };
var faJedi = { prefix: 'fas', iconName: 'jedi', icon: [544, 512, [], "f669", "M479.99 352l58.88-58.87c3.29-16.8 5.13-34.12 5.13-51.86 0-5.81-.68-11.51-1.05-17.27H496l41.25-41.24c-14.5-64.79-52.43-123.05-107.91-162.27-2.77-1.96-5.97-2.99-9.25-2.99-5.37 0-10.41 2.71-13.49 7.24-3.05 4.49-3.64 9.99-1.61 15.09 6.55 16.46 9.86 33.73 9.86 51.31 0 45.12-21.03 86.57-57.69 113.73-4.02 2.98-6.46 7.5-6.7 12.4-.24 4.92 1.76 9.66 5.49 13.03 32.93 29.75 47.35 73.51 38.57 117.07-9.74 48.35-48.84 87.1-97.31 96.5l-2.5-65.34L321.88 397c2.98 2.06 7.39 1.69 10.02-.8a8.002 8.002 0 0 0 1.34-9.92l-20.11-33.73 42.07-8.72c3.7-.75 6.38-4.05 6.38-7.83 0-3.77-2.69-7.06-6.38-7.83l-42.07-8.73 20.13-33.77c1.92-3.23 1.34-7.31-1.38-9.91-2.7-2.55-6.97-2.89-10-.8l-30.39 20.67L279.96 7.7a7.964 7.964 0 0 0-8-7.7c-4.33 0-7.84 3.38-8 7.67l-11.52 287.97-30.39-20.66c-3.14-2.12-7.27-1.83-10 .78-2.72 2.59-3.3 6.67-1.36 9.94l20.11 33.73-42.07 8.73c-3.7.75-6.38 4.05-6.38 7.83s2.67 7.08 6.38 7.83l42.07 8.72-20.13 33.77c-1.92 3.23-1.34 7.33 1.39 9.94 2.59 2.45 7.03 2.75 10 .75l27.16-18.48-2.5 65.26c-56.94-11.64-99.89-61.89-99.89-121.92 0-35.08 14.62-67.6 41.17-91.58 3.72-3.36 5.72-8.11 5.48-13.01-.24-4.9-2.68-9.41-6.69-12.38-36.67-27.16-57.71-68.62-57.71-113.74 0-17.56 3.31-34.81 9.84-51.26 2.02-5.09 1.43-10.59-1.62-15.09-3.08-4.54-8.13-7.25-13.51-7.25-3.3 0-6.5 1.04-9.27 3-55.87 39.52-93.6 97.37-107.97 162.07L47.93 224H.72c-.63 9.92-.97 19.91-.5 29.99.62 13.43 2.54 26.53 5.11 39.41l58.6 58.6H24.02c41.25 90.23 131.13 154.94 235.1 159.71 4.3.2 8.59.29 12.85.29 110.34 0 205.35-65.83 247.98-160h-39.96z"] };
var faJoint = { prefix: 'fas', iconName: 'joint', icon: [640, 512, [], "f595", "M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"] };
var faJournalWhills = { prefix: 'fas', iconName: 'journal-whills', icon: [448, 512, [], "f66a", "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM133.08 144.39l21.26 21.26c1.56 1.56 3.61 2.34 5.66 2.34s4.09-.78 5.66-2.34c3.12-3.12 3.12-8.19 0-11.31l-26.42-26.42c10-20.9 26.24-37.97 46.37-49.26C179.62 88.4 176 99.74 176 112c0 19.96 9.33 37.57 23.66 49.31C190.01 171.37 184 184.96 184 200c0 26.94 19.04 49.4 44.38 54.76l1.36-32.71-10.37 7.04c-.69.45-1.47.69-2.25.69-1 0-1.98-.38-2.75-1.09a4.006 4.006 0 0 1-.69-4.95l8.54-14.31-17.91-3.72c-1.86-.39-3.19-2.03-3.19-3.92s1.33-3.53 3.19-3.92l17.91-3.72-8.54-14.31c-.95-1.61-.67-3.67.69-4.95 1.36-1.3 3.44-1.44 5-.41l12.01 8.16L236 71.83c.09-2.14 1.86-3.83 4-3.83s3.91 1.69 4 3.83l4.68 112.29 14.2-9.65a4.067 4.067 0 0 1 5 .41 4.006 4.006 0 0 1 .69 4.95l-8.54 14.31 17.91 3.72c1.86.39 3.19 2.03 3.19 3.92s-1.33 3.53-3.19 3.92l-17.91 3.72 8.54 14.31c.95 1.61.67 3.67-.69 4.95-.77.72-1.77 1.09-2.75 1.09-.78 0-1.56-.23-2.25-.69l-12.68-8.62 1.43 34.28C276.96 249.4 296 226.94 296 200c0-15.04-6.01-28.63-15.66-38.69C294.67 149.57 304 131.96 304 112c0-12.26-3.62-23.6-9.6-33.33 20.13 11.28 36.37 28.36 46.37 49.26l-26.42 26.42c-3.12 3.12-3.12 8.19 0 11.31 1.56 1.56 3.61 2.34 5.66 2.34s4.09-.78 5.66-2.34l21.26-21.26c2.97 10.08 5.07 20.55 5.07 31.6 0 .52-.14.99-.15 1.51l-37.11 32.47a7.975 7.975 0 0 0-.75 11.28 7.97 7.97 0 0 0 6.02 2.73c1.88 0 3.75-.66 5.27-1.98l23.59-20.64C337.32 250.96 293.09 288 240 288s-97.32-37.04-108.86-86.62l23.59 20.64A7.957 7.957 0 0 0 160 224c2.22 0 4.44-.92 6.02-2.73 2.92-3.33 2.58-8.38-.75-11.28l-37.11-32.47c-.01-.52-.15-.99-.15-1.51-.01-11.06 2.09-21.53 5.07-31.62zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"] };
var faKaaba = { prefix: 'fas', iconName: 'kaaba', icon: [576, 512, [], "f66b", "M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"] };
var faKey = { prefix: 'fas', iconName: 'key', icon: [512, 512, [], "f084", "M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"] };
var faKeyboard = { prefix: 'fas', iconName: 'keyboard', icon: [576, 512, [], "f11c", "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"] };
var faKhanda = { prefix: 'fas', iconName: 'khanda', icon: [512, 512, [], "f66d", "M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"] };
var faKiss = { prefix: 'fas', iconName: 'kiss', icon: [496, 512, [], "f596", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"] };
var faKissBeam = { prefix: 'fas', iconName: 'kiss-beam', icon: [496, 512, [], "f597", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"] };
var faKissWinkHeart = { prefix: 'fas', iconName: 'kiss-wink-heart', icon: [504, 512, [], "f598", "M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"] };
var faKiwiBird = { prefix: 'fas', iconName: 'kiwi-bird', icon: [576, 512, [], "f535", "M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"] };
var faLandmark = { prefix: 'fas', iconName: 'landmark', icon: [512, 512, [], "f66f", "M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"] };
var faLanguage = { prefix: 'fas', iconName: 'language', icon: [640, 512, [], "f1ab", "M304 416H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h280v320zm-120.676-72.622A12 12 0 0 0 194.839 352h22.863c8.22 0 14.007-8.078 11.362-15.861L171.61 167.085a12 12 0 0 0-11.362-8.139h-32.489a12.001 12.001 0 0 0-11.362 8.139L58.942 336.139C56.297 343.922 62.084 352 70.304 352h22.805a12 12 0 0 0 11.535-8.693l9.118-31.807h60.211l9.351 31.878zm-39.051-140.42s4.32 21.061 7.83 33.21l10.8 37.531h-38.07l11.07-37.531c3.51-12.15 7.83-33.21 7.83-33.21h.54zM616 416H336V96h280c13.255 0 24 10.745 24 24v272c0 13.255-10.745 24-24 24zm-36-228h-64v-16c0-6.627-5.373-12-12-12h-16c-6.627 0-12 5.373-12 12v16h-64c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h114.106c-6.263 14.299-16.518 28.972-30.023 43.206-6.56-6.898-12.397-13.91-17.365-20.933-3.639-5.144-10.585-6.675-15.995-3.446l-7.28 4.346-6.498 3.879c-5.956 3.556-7.693 11.421-3.735 17.117 6.065 8.729 13.098 17.336 20.984 25.726-8.122 6.226-16.841 12.244-26.103 17.964-5.521 3.41-7.381 10.556-4.162 16.19l7.941 13.896c3.362 5.883 10.935 7.826 16.706 4.276 12.732-7.831 24.571-16.175 35.443-24.891 10.917 8.761 22.766 17.102 35.396 24.881 5.774 3.556 13.353 1.618 16.717-4.27l7.944-13.903c3.213-5.623 1.37-12.76-4.135-16.171a312.737 312.737 0 0 1-26.06-18.019c21.024-22.425 35.768-46.289 42.713-69.85H580c6.627 0 12-5.373 12-12v-16c0-6.625-5.373-11.998-12-11.998z"] };
var faLaptop = { prefix: 'fas', iconName: 'laptop', icon: [640, 512, [], "f109", "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"] };
var faLaptopCode = { prefix: 'fas', iconName: 'laptop-code', icon: [640, 512, [], "f5fc", "M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"] };
var faLaugh = { prefix: 'fas', iconName: 'laugh', icon: [496, 512, [], "f599", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"] };
var faLaughBeam = { prefix: 'fas', iconName: 'laugh-beam', icon: [496, 512, [], "f59a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"] };
var faLaughSquint = { prefix: 'fas', iconName: 'laugh-squint', icon: [496, 512, [], "f59b", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"] };
var faLaughWink = { prefix: 'fas', iconName: 'laugh-wink', icon: [496, 512, [], "f59c", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"] };
var faLayerGroup = { prefix: 'fas', iconName: 'layer-group', icon: [512, 512, [], "f5fd", "M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"] };
var faLeaf = { prefix: 'fas', iconName: 'leaf', icon: [576, 512, [], "f06c", "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"] };
var faLemon = { prefix: 'fas', iconName: 'lemon', icon: [512, 512, [], "f094", "M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"] };
var faLessThan = { prefix: 'fas', iconName: 'less-than', icon: [384, 512, [], "f536", "M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"] };
var faLessThanEqual = { prefix: 'fas', iconName: 'less-than-equal', icon: [448, 512, [], "f537", "M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"] };
var faLevelDownAlt = { prefix: 'fas', iconName: 'level-down-alt', icon: [320, 512, [], "f3be", "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"] };
var faLevelUpAlt = { prefix: 'fas', iconName: 'level-up-alt', icon: [320, 512, [], "f3bf", "M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"] };
var faLifeRing = { prefix: 'fas', iconName: 'life-ring', icon: [512, 512, [], "f1cd", "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"] };
var faLightbulb = { prefix: 'fas', iconName: 'lightbulb', icon: [352, 512, [], "f0eb", "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"] };
var faLink = { prefix: 'fas', iconName: 'link', icon: [512, 512, [], "f0c1", "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"] };
var faLiraSign = { prefix: 'fas', iconName: 'lira-sign', icon: [384, 512, [], "f195", "M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"] };
var faList = { prefix: 'fas', iconName: 'list', icon: [512, 512, [], "f03a", "M128 116V76c0-8.837 7.163-16 16-16h352c8.837 0 16 7.163 16 16v40c0 8.837-7.163 16-16 16H144c-8.837 0-16-7.163-16-16zm16 176h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zM16 144h64c8.837 0 16-7.163 16-16V64c0-8.837-7.163-16-16-16H16C7.163 48 0 55.163 0 64v64c0 8.837 7.163 16 16 16zm0 160h64c8.837 0 16-7.163 16-16v-64c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v64c0 8.837 7.163 16 16 16zm0 160h64c8.837 0 16-7.163 16-16v-64c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v64c0 8.837 7.163 16 16 16z"] };
var faListAlt = { prefix: 'fas', iconName: 'list-alt', icon: [512, 512, [], "f022", "M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"] };
var faListOl = { prefix: 'fas', iconName: 'list-ol', icon: [512, 512, [], "f0cb", "M3.263 139.527c0-7.477 3.917-11.572 11.573-11.572h15.131V88.078c0-5.163.534-10.503.534-10.503h-.356s-1.779 2.67-2.848 3.738c-4.451 4.273-10.504 4.451-15.666-1.068l-5.518-6.231c-5.342-5.341-4.984-11.216.534-16.379l21.72-19.938C32.815 33.602 36.732 32 42.785 32H54.89c7.656 0 11.749 3.916 11.749 11.572v84.384h15.488c7.655 0 11.572 4.094 11.572 11.572v8.901c0 7.477-3.917 11.572-11.572 11.572H14.836c-7.656 0-11.573-4.095-11.573-11.572v-8.902zM2.211 304.591c0-47.278 50.955-56.383 50.955-69.165 0-7.18-5.954-8.755-9.28-8.755-3.153 0-6.479 1.051-9.455 3.852-5.079 4.903-10.507 7.004-16.111 2.451l-8.579-6.829c-5.779-4.553-7.18-9.805-2.803-15.409C13.592 201.981 26.025 192 47.387 192c19.437 0 44.476 10.506 44.476 39.573 0 38.347-46.753 46.402-48.679 56.909h39.049c7.529 0 11.557 4.027 11.557 11.382v8.755c0 7.354-4.028 11.382-11.557 11.382h-67.94c-7.005 0-12.083-4.028-12.083-11.382v-4.028zM5.654 454.61l5.603-9.28c3.853-6.654 9.105-7.004 15.584-3.152 4.903 2.101 9.63 3.152 14.359 3.152 10.155 0 14.358-3.502 14.358-8.23 0-6.654-5.604-9.106-15.934-9.106h-4.728c-5.954 0-9.28-2.101-12.258-7.88l-1.05-1.926c-2.451-4.728-1.226-9.806 2.801-14.884l5.604-7.004c6.829-8.405 12.257-13.483 12.257-13.483v-.35s-4.203 1.051-12.608 1.051H16.685c-7.53 0-11.383-4.028-11.383-11.382v-8.755c0-7.53 3.853-11.382 11.383-11.382h58.484c7.529 0 11.382 4.027 11.382 11.382v3.327c0 5.778-1.401 9.806-5.079 14.183l-17.509 20.137c19.611 5.078 28.716 20.487 28.716 34.845 0 21.363-14.358 44.126-48.503 44.126-16.636 0-28.192-4.728-35.896-9.455-5.779-4.202-6.304-9.805-2.626-15.934zM144 132h352c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"] };
var faListUl = { prefix: 'fas', iconName: 'list-ul', icon: [512, 512, [], "f0ca", "M96 96c0 26.51-21.49 48-48 48S0 122.51 0 96s21.49-48 48-48 48 21.49 48 48zM48 208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm0 160c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm96-236h352c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"] };
var faLocationArrow = { prefix: 'fas', iconName: 'location-arrow', icon: [512, 512, [], "f124", "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"] };
var faLock = { prefix: 'fas', iconName: 'lock', icon: [448, 512, [], "f023", "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"] };
var faLockOpen = { prefix: 'fas', iconName: 'lock-open', icon: [576, 512, [], "f3c1", "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"] };
var faLongArrowAltDown = { prefix: 'fas', iconName: 'long-arrow-alt-down', icon: [256, 512, [], "f309", "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"] };
var faLongArrowAltLeft = { prefix: 'fas', iconName: 'long-arrow-alt-left', icon: [448, 512, [], "f30a", "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"] };
var faLongArrowAltRight = { prefix: 'fas', iconName: 'long-arrow-alt-right', icon: [448, 512, [], "f30b", "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"] };
var faLongArrowAltUp = { prefix: 'fas', iconName: 'long-arrow-alt-up', icon: [256, 512, [], "f30c", "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"] };
var faLowVision = { prefix: 'fas', iconName: 'low-vision', icon: [576, 512, [], "f2a8", "M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"] };
var faLuggageCart = { prefix: 'fas', iconName: 'luggage-cart', icon: [640, 512, [], "f59d", "M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"] };
var faMagic = { prefix: 'fas', iconName: 'magic', icon: [512, 512, [], "f0d0", "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"] };
var faMagnet = { prefix: 'fas', iconName: 'magnet', icon: [512, 512, [], "f076", "M164.1 160H12c-6.6 0-12-5.4-12-12V68c0-19.9 16.1-36 36-36h104c19.9 0 36 16.1 36 36v80c.1 6.6-5.3 12-11.9 12zm348-12V67.9c0-19.9-16.1-36-36-36h-104c-19.9 0-36 16.1-36 36v80c0 6.6 5.4 12 12 12h152c6.6.1 12-5.3 12-11.9zm-164 44c-6.6 0-12 5.4-12 12v52c0 128.1-160 127.9-160 0v-52c0-6.6-5.4-12-12-12h-152c-6.7 0-12 5.4-12 12.1.1 21.4.6 40.3 0 53.3C.1 408 136.3 504 256.9 504 377.5 504 512 408 512 257.3c-.6-12.8-.2-33 0-53.2 0-6.7-5.3-12.1-12-12.1H348.1z"] };
var faMailBulk = { prefix: 'fas', iconName: 'mail-bulk', icon: [576, 512, [], "f674", "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"] };
var faMale = { prefix: 'fas', iconName: 'male', icon: [192, 512, [], "f183", "M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"] };
var faMap = { prefix: 'fas', iconName: 'map', icon: [576, 512, [], "f279", "M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"] };
var faMapMarked = { prefix: 'fas', iconName: 'map-marked', icon: [576, 512, [], "f59f", "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"] };
var faMapMarkedAlt = { prefix: 'fas', iconName: 'map-marked-alt', icon: [576, 512, [], "f5a0", "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"] };
var faMapMarker = { prefix: 'fas', iconName: 'map-marker', icon: [384, 512, [], "f041", "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"] };
var faMapMarkerAlt = { prefix: 'fas', iconName: 'map-marker-alt', icon: [384, 512, [], "f3c5", "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"] };
var faMapPin = { prefix: 'fas', iconName: 'map-pin', icon: [288, 512, [], "f276", "M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"] };
var faMapSigns = { prefix: 'fas', iconName: 'map-signs', icon: [512, 512, [], "f277", "M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"] };
var faMarker = { prefix: 'fas', iconName: 'marker', icon: [512, 512, [], "f5a1", "M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"] };
var faMars = { prefix: 'fas', iconName: 'mars', icon: [384, 512, [], "f222", "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"] };
var faMarsDouble = { prefix: 'fas', iconName: 'mars-double', icon: [512, 512, [], "f227", "M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"] };
var faMarsStroke = { prefix: 'fas', iconName: 'mars-stroke', icon: [384, 512, [], "f229", "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"] };
var faMarsStrokeH = { prefix: 'fas', iconName: 'mars-stroke-h', icon: [480, 512, [], "f22b", "M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"] };
var faMarsStrokeV = { prefix: 'fas', iconName: 'mars-stroke-v', icon: [288, 512, [], "f22a", "M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"] };
var faMedal = { prefix: 'fas', iconName: 'medal', icon: [512, 512, [], "f5a2", "M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"] };
var faMedkit = { prefix: 'fas', iconName: 'medkit', icon: [512, 512, [], "f0fa", "M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"] };
var faMeh = { prefix: 'fas', iconName: 'meh', icon: [496, 512, [], "f11a", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"] };
var faMehBlank = { prefix: 'fas', iconName: 'meh-blank', icon: [496, 512, [], "f5a4", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"] };
var faMehRollingEyes = { prefix: 'fas', iconName: 'meh-rolling-eyes', icon: [496, 512, [], "f5a5", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"] };
var faMemory = { prefix: 'fas', iconName: 'memory', icon: [640, 512, [], "f538", "M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"] };
var faMenorah = { prefix: 'fas', iconName: 'menorah', icon: [640, 512, [], "f676", "M144 160h-32c-8.84 0-16 7.16-16 16v112h64V176c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v112h64V176c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v112h64V176c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v112h64V176c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32s-32-64-32-64-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32s-32-64-32-64-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32s-32-64-32-64-32 46.33-32 64 14.33 32 32 32zm-96-32c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 32c17.67 0 32-14.33 32-32s-32-64-32-64-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32s-32-64-32-64-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 32 32 32 0 78.33 0 96s14.33 32 32 32zm544 160c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112z"] };
var faMercury = { prefix: 'fas', iconName: 'mercury', icon: [288, 512, [], "f223", "M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"] };
var faMicrochip = { prefix: 'fas', iconName: 'microchip', icon: [512, 512, [], "f2db", "M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"] };
var faMicrophone = { prefix: 'fas', iconName: 'microphone', icon: [352, 512, [], "f130", "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"] };
var faMicrophoneAlt = { prefix: 'fas', iconName: 'microphone-alt', icon: [352, 512, [], "f3c9", "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"] };
var faMicrophoneAltSlash = { prefix: 'fas', iconName: 'microphone-alt-slash', icon: [640, 512, [], "f539", "M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"] };
var faMicrophoneSlash = { prefix: 'fas', iconName: 'microphone-slash', icon: [640, 512, [], "f131", "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"] };
var faMicroscope = { prefix: 'fas', iconName: 'microscope', icon: [512, 512, [], "f610", "M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"] };
var faMinus = { prefix: 'fas', iconName: 'minus', icon: [448, 512, [], "f068", "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"] };
var faMinusCircle = { prefix: 'fas', iconName: 'minus-circle', icon: [512, 512, [], "f056", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"] };
var faMinusSquare = { prefix: 'fas', iconName: 'minus-square', icon: [448, 512, [], "f146", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"] };
var faMobile = { prefix: 'fas', iconName: 'mobile', icon: [320, 512, [], "f10b", "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"] };
var faMobileAlt = { prefix: 'fas', iconName: 'mobile-alt', icon: [320, 512, [], "f3cd", "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"] };
var faMoneyBill = { prefix: 'fas', iconName: 'money-bill', icon: [640, 512, [], "f0d6", "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"] };
var faMoneyBillAlt = { prefix: 'fas', iconName: 'money-bill-alt', icon: [640, 512, [], "f3d1", "M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"] };
var faMoneyBillWave = { prefix: 'fas', iconName: 'money-bill-wave', icon: [640, 512, [], "f53a", "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"] };
var faMoneyBillWaveAlt = { prefix: 'fas', iconName: 'money-bill-wave-alt', icon: [640, 512, [], "f53b", "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"] };
var faMoneyCheck = { prefix: 'fas', iconName: 'money-check', icon: [640, 512, [], "f53c", "M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"] };
var faMoneyCheckAlt = { prefix: 'fas', iconName: 'money-check-alt', icon: [640, 512, [], "f53d", "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"] };
var faMonument = { prefix: 'fas', iconName: 'monument', icon: [384, 512, [], "f5a6", "M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"] };
var faMoon = { prefix: 'fas', iconName: 'moon', icon: [512, 512, [], "f186", "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"] };
var faMortarPestle = { prefix: 'fas', iconName: 'mortar-pestle', icon: [512, 512, [], "f5a7", "M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"] };
var faMosque = { prefix: 'fas', iconName: 'mosque', icon: [640, 512, [], "f678", "M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"] };
var faMotorcycle = { prefix: 'fas', iconName: 'motorcycle', icon: [640, 512, [], "f21c", "M512.949 192.003c-14.862-.108-29.14 2.322-42.434 6.874L437.589 144H520c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24h-45.311a24 24 0 0 0-17.839 7.945l-37.496 41.663-22.774-37.956A24 24 0 0 0 376 64h-80c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h66.411l19.2 32H227.904c-17.727-23.073-44.924-40-99.904-40H72.54c-13.455 0-24.791 11.011-24.536 24.464C48.252 141.505 58.9 152 72 152h56c24.504 0 38.686 10.919 47.787 24.769l-11.291 20.529c-13.006-3.865-26.871-5.736-41.251-5.21C55.857 194.549 1.565 249.605.034 317.021-1.603 389.076 56.317 448 128 448c59.642 0 109.744-40.794 123.953-96h84.236c13.673 0 24.589-11.421 23.976-25.077-2.118-47.12 17.522-93.665 56.185-125.026l12.485 20.808c-27.646 23.654-45.097 58.88-44.831 98.179.47 69.556 57.203 126.452 126.758 127.11 71.629.678 129.839-57.487 129.234-129.099-.588-69.591-57.455-126.386-127.047-126.892zM128 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c4.242 0 8.405.341 12.469.982L98.97 316.434C90.187 332.407 101.762 352 120 352h81.297c-12.37 28.225-40.56 48-73.297 48zm388.351-.116C470.272 402.337 432 365.554 432 320c0-21.363 8.434-40.781 22.125-55.144l49.412 82.352c4.546 7.577 14.375 10.034 21.952 5.488l13.72-8.232c7.577-4.546 10.034-14.375 5.488-21.952l-48.556-80.927A80.005 80.005 0 0 1 512 240c45.554 0 82.338 38.273 79.884 84.352-2.16 40.558-34.974 73.372-75.533 75.532z"] };
var faMousePointer = { prefix: 'fas', iconName: 'mouse-pointer', icon: [320, 512, [], "f245", "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"] };
var faMusic = { prefix: 'fas', iconName: 'music', icon: [512, 512, [], "f001", "M511.99 32.01c0-21.71-21.1-37.01-41.6-30.51L150.4 96c-13.3 4.2-22.4 16.5-22.4 30.5v261.42c-10.05-2.38-20.72-3.92-32-3.92-53.02 0-96 28.65-96 64s42.98 64 96 64 96-28.65 96-64V214.31l256-75.02v184.63c-10.05-2.38-20.72-3.92-32-3.92-53.02 0-96 28.65-96 64s42.98 64 96 64 96-28.65 96-64l-.01-351.99z"] };
var faNeuter = { prefix: 'fas', iconName: 'neuter', icon: [288, 512, [], "f22c", "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"] };
var faNewspaper = { prefix: 'fas', iconName: 'newspaper', icon: [576, 512, [], "f1ea", "M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"] };
var faNotEqual = { prefix: 'fas', iconName: 'not-equal', icon: [448, 512, [], "f53e", "M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"] };
var faNotesMedical = { prefix: 'fas', iconName: 'notes-medical', icon: [384, 512, [], "f481", "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"] };
var faObjectGroup = { prefix: 'fas', iconName: 'object-group', icon: [512, 512, [], "f247", "M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"] };
var faObjectUngroup = { prefix: 'fas', iconName: 'object-ungroup', icon: [576, 512, [], "f248", "M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"] };
var faOilCan = { prefix: 'fas', iconName: 'oil-can', icon: [640, 512, [], "f613", "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"] };
var faOm = { prefix: 'fas', iconName: 'om', icon: [512, 512, [], "f679", "M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"] };
var faOutdent = { prefix: 'fas', iconName: 'outdent', icon: [448, 512, [], "f03b", "M0 84V44c0-8.837 7.163-16 16-16h416c8.837 0 16 7.163 16 16v40c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16zm208 144h224c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H208c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zM16 484h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm192-128h224c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H208c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zM4.687 267.313l96 95.984C110.734 373.348 128 366.224 128 351.984V160.008c0-14.329-17.325-21.304-27.313-11.313l-96 95.992c-6.249 6.248-6.249 16.378 0 22.626z"] };
var faPaintBrush = { prefix: 'fas', iconName: 'paint-brush', icon: [512, 512, [], "f1fc", "M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"] };
var faPaintRoller = { prefix: 'fas', iconName: 'paint-roller', icon: [512, 512, [], "f5aa", "M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"] };
var faPalette = { prefix: 'fas', iconName: 'palette', icon: [512, 512, [], "f53f", "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"] };
var faPallet = { prefix: 'fas', iconName: 'pallet', icon: [640, 512, [], "f482", "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"] };
var faPaperPlane = { prefix: 'fas', iconName: 'paper-plane', icon: [512, 512, [], "f1d8", "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"] };
var faPaperclip = { prefix: 'fas', iconName: 'paperclip', icon: [448, 512, [], "f0c6", "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"] };
var faParachuteBox = { prefix: 'fas', iconName: 'parachute-box', icon: [512, 512, [], "f4cd", "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"] };
var faParagraph = { prefix: 'fas', iconName: 'paragraph', icon: [448, 512, [], "f1dd", "M408 32H177.531C88.948 32 16.045 103.335 16 191.918 15.956 280.321 87.607 352 176 352v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V112h32v344c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V112h40c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24z"] };
var faParking = { prefix: 'fas', iconName: 'parking', icon: [448, 512, [], "f540", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"] };
var faPassport = { prefix: 'fas', iconName: 'passport', icon: [448, 512, [], "f5ab", "M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"] };
var faPastafarianism = { prefix: 'fas', iconName: 'pastafarianism', icon: [640, 512, [], "f67b", "M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"] };
var faPaste = { prefix: 'fas', iconName: 'paste', icon: [448, 512, [], "f0ea", "M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"] };
var faPause = { prefix: 'fas', iconName: 'pause', icon: [448, 512, [], "f04c", "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"] };
var faPauseCircle = { prefix: 'fas', iconName: 'pause-circle', icon: [512, 512, [], "f28b", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"] };
var faPaw = { prefix: 'fas', iconName: 'paw', icon: [512, 512, [], "f1b0", "M85.231 330.958C36 330.958 0 273.792 0 231.5c0-28.292 16-58.042 49.538-58.042 49.231 0 85.231 57.458 85.231 99.75 0 28.292-15.692 57.75-49.538 57.75zm348 106.167c0 37.042-32 42.875-63.385 42.875-41.231 0-74.462-26.25-113.846-26.25-41.231 0-76.308 25.958-120.923 25.958-29.847 0-56.308-9.625-56.308-42.583C78.769 368 180.616 265.333 256 265.333s177.231 102.959 177.231 171.792zM182.462 203.792c-49.847 0-80-59.5-80-100.333C102.462 70.792 120.308 32 160 32c50.154 0 80 59.5 80 100.333 0 32.667-17.846 71.459-57.538 71.459zM272 132.333C272 91.5 301.846 32 352 32c39.692 0 57.539 38.792 57.539 71.458 0 40.833-30.154 100.333-80.001 100.333C289.846 203.792 272 165 272 132.333zM512 231.5c0 42.292-36 99.458-85.231 99.458-33.847 0-49.538-29.458-49.538-57.75 0-42.291 35.999-99.75 85.231-99.75C496 173.458 512 203.208 512 231.5z"] };
var faPeace = { prefix: 'fas', iconName: 'peace', icon: [496, 512, [], "f67c", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"] };
var faPen = { prefix: 'fas', iconName: 'pen', icon: [512, 512, [], "f304", "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"] };
var faPenAlt = { prefix: 'fas', iconName: 'pen-alt', icon: [512, 512, [], "f305", "M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"] };
var faPenFancy = { prefix: 'fas', iconName: 'pen-fancy', icon: [512, 512, [], "f5ac", "M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"] };
var faPenNib = { prefix: 'fas', iconName: 'pen-nib', icon: [512, 512, [], "f5ad", "M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"] };
var faPenSquare = { prefix: 'fas', iconName: 'pen-square', icon: [448, 512, [], "f14b", "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"] };
var faPencilAlt = { prefix: 'fas', iconName: 'pencil-alt', icon: [512, 512, [], "f303", "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"] };
var faPencilRuler = { prefix: 'fas', iconName: 'pencil-ruler', icon: [512, 512, [], "f5ae", "M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"] };
var faPeopleCarry = { prefix: 'fas', iconName: 'people-carry', icon: [640, 512, [], "f4ce", "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"] };
var faPercent = { prefix: 'fas', iconName: 'percent', icon: [448, 512, [], "f295", "M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"] };
var faPercentage = { prefix: 'fas', iconName: 'percentage', icon: [384, 512, [], "f541", "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"] };
var faPhone = { prefix: 'fas', iconName: 'phone', icon: [512, 512, [], "f095", "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"] };
var faPhoneSlash = { prefix: 'fas', iconName: 'phone-slash', icon: [640, 512, [], "f3dd", "M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"] };
var faPhoneSquare = { prefix: 'fas', iconName: 'phone-square', icon: [448, 512, [], "f098", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"] };
var faPhoneVolume = { prefix: 'fas', iconName: 'phone-volume', icon: [384, 512, [], "f2a0", "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"] };
var faPiggyBank = { prefix: 'fas', iconName: 'piggy-bank', icon: [576, 512, [], "f4d3", "M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"] };
var faPills = { prefix: 'fas', iconName: 'pills', icon: [576, 512, [], "f484", "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"] };
var faPlaceOfWorship = { prefix: 'fas', iconName: 'place-of-worship', icon: [640, 512, [], "f67f", "M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"] };
var faPlane = { prefix: 'fas', iconName: 'plane', icon: [576, 512, [], "f072", "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"] };
var faPlaneArrival = { prefix: 'fas', iconName: 'plane-arrival', icon: [640, 512, [], "f5af", "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"] };
var faPlaneDeparture = { prefix: 'fas', iconName: 'plane-departure', icon: [640, 512, [], "f5b0", "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"] };
var faPlay = { prefix: 'fas', iconName: 'play', icon: [448, 512, [], "f04b", "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"] };
var faPlayCircle = { prefix: 'fas', iconName: 'play-circle', icon: [512, 512, [], "f144", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"] };
var faPlug = { prefix: 'fas', iconName: 'plug', icon: [384, 512, [], "f1e6", "M256 144V32c0-17.673 14.327-32 32-32s32 14.327 32 32v112h-64zm112 16H16c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h16v32c0 77.406 54.969 141.971 128 156.796V512h64v-99.204c73.031-14.825 128-79.39 128-156.796v-32h16c8.837 0 16-7.163 16-16v-32c0-8.837-7.163-16-16-16zm-240-16V32c0-17.673-14.327-32-32-32S64 14.327 64 32v112h64z"] };
var faPlus = { prefix: 'fas', iconName: 'plus', icon: [448, 512, [], "f067", "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"] };
var faPlusCircle = { prefix: 'fas', iconName: 'plus-circle', icon: [512, 512, [], "f055", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"] };
var faPlusSquare = { prefix: 'fas', iconName: 'plus-square', icon: [448, 512, [], "f0fe", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"] };
var faPodcast = { prefix: 'fas', iconName: 'podcast', icon: [448, 512, [], "f2ce", "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"] };
var faPoll = { prefix: 'fas', iconName: 'poll', icon: [448, 512, [], "f681", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"] };
var faPollH = { prefix: 'fas', iconName: 'poll-h', icon: [448, 512, [], "f682", "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"] };
var faPoo = { prefix: 'fas', iconName: 'poo', icon: [512, 512, [], "f2fe", "M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"] };
var faPoop = { prefix: 'fas', iconName: 'poop', icon: [512, 512, [], "f619", "M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"] };
var faPortrait = { prefix: 'fas', iconName: 'portrait', icon: [384, 512, [], "f3e0", "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"] };
var faPoundSign = { prefix: 'fas', iconName: 'pound-sign', icon: [320, 512, [], "f154", "M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"] };
var faPowerOff = { prefix: 'fas', iconName: 'power-off', icon: [512, 512, [], "f011", "M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"] };
var faPray = { prefix: 'fas', iconName: 'pray', icon: [384, 512, [], "f683", "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"] };
var faPrayingHands = { prefix: 'fas', iconName: 'praying-hands', icon: [640, 512, [], "f684", "M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"] };
var faPrescription = { prefix: 'fas', iconName: 'prescription', icon: [384, 512, [], "f5b1", "M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"] };
var faPrescriptionBottle = { prefix: 'fas', iconName: 'prescription-bottle', icon: [384, 512, [], "f485", "M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"] };
var faPrescriptionBottleAlt = { prefix: 'fas', iconName: 'prescription-bottle-alt', icon: [384, 512, [], "f486", "M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"] };
var faPrint = { prefix: 'fas', iconName: 'print', icon: [512, 512, [], "f02f", "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"] };
var faProcedures = { prefix: 'fas', iconName: 'procedures', icon: [640, 512, [], "f487", "M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"] };
var faProjectDiagram = { prefix: 'fas', iconName: 'project-diagram', icon: [640, 512, [], "f542", "M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"] };
var faPuzzlePiece = { prefix: 'fas', iconName: 'puzzle-piece', icon: [576, 512, [], "f12e", "M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"] };
var faQrcode = { prefix: 'fas', iconName: 'qrcode', icon: [448, 512, [], "f029", "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"] };
var faQuestion = { prefix: 'fas', iconName: 'question', icon: [384, 512, [], "f128", "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"] };
var faQuestionCircle = { prefix: 'fas', iconName: 'question-circle', icon: [512, 512, [], "f059", "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"] };
var faQuidditch = { prefix: 'fas', iconName: 'quidditch', icon: [640, 512, [], "f458", "M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"] };
var faQuoteLeft = { prefix: 'fas', iconName: 'quote-left', icon: [512, 512, [], "f10d", "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"] };
var faQuoteRight = { prefix: 'fas', iconName: 'quote-right', icon: [512, 512, [], "f10e", "M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"] };
var faQuran = { prefix: 'fas', iconName: 'quran', icon: [448, 512, [], "f687", "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"] };
var faRandom = { prefix: 'fas', iconName: 'random', icon: [512, 512, [], "f074", "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"] };
var faReceipt = { prefix: 'fas', iconName: 'receipt', icon: [384, 512, [], "f543", "M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"] };
var faRecycle = { prefix: 'fas', iconName: 'recycle', icon: [512, 512, [], "f1b8", "M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"] };
var faRedo = { prefix: 'fas', iconName: 'redo', icon: [512, 512, [], "f01e", "M500.333 0h-47.411c-6.853 0-12.314 5.729-11.986 12.574l3.966 82.759C399.416 41.899 331.672 8 256.001 8 119.34 8 7.899 119.526 8 256.187 8.101 393.068 119.096 504 256 504c63.926 0 122.202-24.187 166.178-63.908 5.113-4.618 5.354-12.561.482-17.433l-33.971-33.971c-4.466-4.466-11.64-4.717-16.38-.543C341.308 415.448 300.606 432 256 432c-97.267 0-176-78.716-176-176 0-97.267 78.716-176 176-176 60.892 0 114.506 30.858 146.099 77.8l-101.525-4.865c-6.845-.328-12.574 5.133-12.574 11.986v47.411c0 6.627 5.373 12 12 12h200.333c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12z"] };
var faRedoAlt = { prefix: 'fas', iconName: 'redo-alt', icon: [512, 512, [], "f2f9", "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"] };
var faRegistered = { prefix: 'fas', iconName: 'registered', icon: [512, 512, [], "f25d", "M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"] };
var faReply = { prefix: 'fas', iconName: 'reply', icon: [512, 512, [], "f3e5", "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"] };
var faReplyAll = { prefix: 'fas', iconName: 'reply-all', icon: [576, 512, [], "f122", "M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"] };
var faRetweet = { prefix: 'fas', iconName: 'retweet', icon: [640, 512, [], "f079", "M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"] };
var faRibbon = { prefix: 'fas', iconName: 'ribbon', icon: [448, 512, [], "f4d6", "M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"] };
var faRoad = { prefix: 'fas', iconName: 'road', icon: [576, 512, [], "f018", "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"] };
var faRobot = { prefix: 'fas', iconName: 'robot', icon: [640, 512, [], "f544", "M0 256v128c0 17.7 14.3 32 32 32h32V224H32c-17.7 0-32 14.3-32 32zM464 96H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v64H176c-44.2 0-80 35.8-80 80v272c0 35.3 28.7 64 64 64h320c35.3 0 64-28.7 64-64V176c0-44.2-35.8-80-80-80zM256 416h-64v-32h64v32zm-32-120c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm128 120h-64v-32h64v32zm96 0h-64v-32h64v32zm-32-120c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm192-72h-32v192h32c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32z"] };
var faRocket = { prefix: 'fas', iconName: 'rocket', icon: [512, 512, [], "f135", "M505.1 19.1C503.8 13 499 8.2 492.9 6.9 460.7 0 435.5 0 410.4 0 307.2 0 245.3 55.2 199.1 128H94.9c-18.2 0-34.8 10.3-42.9 26.5L2.6 253.3c-8 16 3.6 34.7 21.5 34.7h95.1c-5.9 12.8-11.9 25.5-18 37.7-3.1 6.2-1.9 13.6 3 18.5l63.6 63.6c4.9 4.9 12.3 6.1 18.5 3 12.2-6.1 24.9-12 37.7-17.9V488c0 17.8 18.8 29.4 34.7 21.5l98.7-49.4c16.3-8.1 26.5-24.8 26.5-42.9V312.8c72.6-46.3 128-108.4 128-211.1.1-25.2.1-50.4-6.8-82.6zM400 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"] };
var faRoute = { prefix: 'fas', iconName: 'route', icon: [512, 512, [], "f4d7", "M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"] };
var faRss = { prefix: 'fas', iconName: 'rss', icon: [448, 512, [], "f09e", "M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"] };
var faRssSquare = { prefix: 'fas', iconName: 'rss-square', icon: [448, 512, [], "f143", "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"] };
var faRubleSign = { prefix: 'fas', iconName: 'ruble-sign', icon: [384, 512, [], "f158", "M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"] };
var faRuler = { prefix: 'fas', iconName: 'ruler', icon: [640, 512, [], "f545", "M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"] };
var faRulerCombined = { prefix: 'fas', iconName: 'ruler-combined', icon: [512, 512, [], "f546", "M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"] };
var faRulerHorizontal = { prefix: 'fas', iconName: 'ruler-horizontal', icon: [576, 512, [], "f547", "M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"] };
var faRulerVertical = { prefix: 'fas', iconName: 'ruler-vertical', icon: [256, 512, [], "f548", "M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"] };
var faRupeeSign = { prefix: 'fas', iconName: 'rupee-sign', icon: [320, 512, [], "f156", "M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"] };
var faSadCry = { prefix: 'fas', iconName: 'sad-cry', icon: [496, 512, [], "f5b3", "M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"] };
var faSadTear = { prefix: 'fas', iconName: 'sad-tear', icon: [496, 512, [], "f5b4", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"] };
var faSave = { prefix: 'fas', iconName: 'save', icon: [448, 512, [], "f0c7", "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"] };
var faSchool = { prefix: 'fas', iconName: 'school', icon: [640, 512, [], "f549", "M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"] };
var faScrewdriver = { prefix: 'fas', iconName: 'screwdriver', icon: [512, 512, [], "f54a", "M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"] };
var faSearch = { prefix: 'fas', iconName: 'search', icon: [512, 512, [], "f002", "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"] };
var faSearchDollar = { prefix: 'fas', iconName: 'search-dollar', icon: [512, 512, [], "f688", "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"] };
var faSearchLocation = { prefix: 'fas', iconName: 'search-location', icon: [512, 512, [], "f689", "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"] };
var faSearchMinus = { prefix: 'fas', iconName: 'search-minus', icon: [512, 512, [], "f010", "M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"] };
var faSearchPlus = { prefix: 'fas', iconName: 'search-plus', icon: [512, 512, [], "f00e", "M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"] };
var faSeedling = { prefix: 'fas', iconName: 'seedling', icon: [512, 512, [], "f4d8", "M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"] };
var faServer = { prefix: 'fas', iconName: 'server', icon: [512, 512, [], "f233", "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"] };
var faShapes = { prefix: 'fas', iconName: 'shapes', icon: [512, 512, [], "f61f", "M512 320v160c0 17.67-14.33 32-32 32H320c-17.67 0-32-14.33-32-32V320c0-17.67 14.33-32 32-32h160c17.67 0 32 14.33 32 32zm-384-64C57.31 256 0 313.31 0 384s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm351.03-32c25.34 0 41.18-26.67 28.51-48L412.51 16c-12.67-21.33-44.35-21.33-57.02 0l-95.03 160c-12.67 21.33 3.17 48 28.51 48h190.06z"] };
var faShare = { prefix: 'fas', iconName: 'share', icon: [512, 512, [], "f064", "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"] };
var faShareAlt = { prefix: 'fas', iconName: 'share-alt', icon: [448, 512, [], "f1e0", "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"] };
var faShareAltSquare = { prefix: 'fas', iconName: 'share-alt-square', icon: [448, 512, [], "f1e1", "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"] };
var faShareSquare = { prefix: 'fas', iconName: 'share-square', icon: [576, 512, [], "f14d", "M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"] };
var faShekelSign = { prefix: 'fas', iconName: 'shekel-sign', icon: [448, 512, [], "f20b", "M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"] };
var faShieldAlt = { prefix: 'fas', iconName: 'shield-alt', icon: [512, 512, [], "f3ed", "M496 128c0 221.282-135.934 344.645-221.539 380.308a48 48 0 0 1-36.923 0C130.495 463.713 16 326.487 16 128a48 48 0 0 1 29.539-44.308l192-80a48 48 0 0 1 36.923 0l192 80A48 48 0 0 1 496 128zM256 446.313l.066.034c93.735-46.689 172.497-156.308 175.817-307.729L256 65.333v380.98z"] };
var faShip = { prefix: 'fas', iconName: 'ship', icon: [640, 512, [], "f21a", "M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"] };
var faShippingFast = { prefix: 'fas', iconName: 'shipping-fast', icon: [640, 512, [], "f48b", "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"] };
var faShoePrints = { prefix: 'fas', iconName: 'shoe-prints', icon: [640, 512, [], "f54b", "M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"] };
var faShoppingBag = { prefix: 'fas', iconName: 'shopping-bag', icon: [448, 512, [], "f290", "M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"] };
var faShoppingBasket = { prefix: 'fas', iconName: 'shopping-basket', icon: [576, 512, [], "f291", "M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"] };
var faShoppingCart = { prefix: 'fas', iconName: 'shopping-cart', icon: [576, 512, [], "f07a", "M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"] };
var faShower = { prefix: 'fas', iconName: 'shower', icon: [512, 512, [], "f2cc", "M389.66 135.6L231.6 293.66c-9.37 9.37-24.57 9.37-33.94 0l-11.32-11.32c-9.37-9.37-9.37-24.57 0-33.94l.11-.11c-34.03-40.21-35.16-98.94-3.39-140.38-11.97-7.55-26.14-11.91-41.3-11.91C98.88 96 64 130.88 64 173.76V480H0V173.76C0 95.59 63.59 32 141.76 32c36.93 0 70.61 14.2 95.86 37.42 35.9-11.51 76.5-4.5 106.67 21.03l.11-.11c9.37-9.37 24.57-9.37 33.94 0l11.32 11.32c9.37 9.37 9.37 24.57 0 33.94zM384 208c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16zm32 0c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16-16-7.163-16-16zm96 0c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16zm-160 32c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16zm48-16c8.837 0 16 7.163 16 16s-7.163 16-16 16-16-7.163-16-16 7.163-16 16-16zm80 16c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16zm-160 32c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16zm32 0c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16-16-7.163-16-16zm96 0c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16zm-128 32c0-8.837 7.163-16 16-16s16 7.163 16 16-7.163 16-16 16-16-7.163-16-16zm96 0c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16zm-96 32c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16zm64 0c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16zm-32 32c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16zm-32 32c0 8.837-7.163 16-16 16s-16-7.163-16-16 7.163-16 16-16 16 7.163 16 16z"] };
var faShuttleVan = { prefix: 'fas', iconName: 'shuttle-van', icon: [640, 512, [], "f5b6", "M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"] };
var faSign = { prefix: 'fas', iconName: 'sign', icon: [512, 512, [], "f4d9", "M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"] };
var faSignInAlt = { prefix: 'fas', iconName: 'sign-in-alt', icon: [512, 512, [], "f2f6", "M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"] };
var faSignLanguage = { prefix: 'fas', iconName: 'sign-language', icon: [448, 512, [], "f2a7", "M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"] };
var faSignOutAlt = { prefix: 'fas', iconName: 'sign-out-alt', icon: [512, 512, [], "f2f5", "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"] };
var faSignal = { prefix: 'fas', iconName: 'signal', icon: [640, 512, [], "f012", "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"] };
var faSignature = { prefix: 'fas', iconName: 'signature', icon: [512, 512, [], "f5b7", "M496 320h-91.86c-9.27 0-19.72-11.31-25.78-28.52-15.23-43.36-48.11-70.3-85.8-70.3-30.84 0-58.47 18.05-76.11 49.23L194.8 106.5C188.84 81.08 169.34 64 146.28 64c-23.05 0-42.55 17.08-48.5 42.5L56.16 284.2C50.7 307.45 37.75 320 28.33 320H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h12.33c41.97 0 78.19-34.23 90.14-85.2l23.84-101.78 29.25 222.11c1.98 15.05 13.82 27.45 28.94 28.75.99.09 1.96.13 2.93.13 14.08 0 26.64-9.27 30.69-22.95l33.03-112.34c5.88-16.72 15.84-27.52 25.41-27.52 9.58 0 19.55 10.8 25.78 28.52 15.23 43.36 48.11 70.3 85.8 70.3H496c8.84 0 16-7.16 16-16v-32c0-8.86-7.16-16.02-16-16.02z"] };
var faSitemap = { prefix: 'fas', iconName: 'sitemap', icon: [640, 512, [], "f0e8", "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"] };
var faSkull = { prefix: 'fas', iconName: 'skull', icon: [512, 512, [], "f54c", "M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"] };
var faSlidersH = { prefix: 'fas', iconName: 'sliders-h', icon: [512, 512, [], "f1de", "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"] };
var faSmile = { prefix: 'fas', iconName: 'smile', icon: [496, 512, [], "f118", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"] };
var faSmileBeam = { prefix: 'fas', iconName: 'smile-beam', icon: [496, 512, [], "f5b8", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"] };
var faSmileWink = { prefix: 'fas', iconName: 'smile-wink', icon: [496, 512, [], "f4da", "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"] };
var faSmoking = { prefix: 'fas', iconName: 'smoking', icon: [640, 512, [], "f48d", "M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"] };
var faSmokingBan = { prefix: 'fas', iconName: 'smoking-ban', icon: [512, 512, [], "f54d", "M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"] };
var faSnowflake = { prefix: 'fas', iconName: 'snowflake', icon: [448, 512, [], "f2dc", "M444.816 301.639a24.12 24.12 0 0 0 2.661-16.978c-2.725-12.966-15.339-21.245-28.174-18.492l-87.407 25.046L264 256l67.896-35.215 87.407 25.046c12.835 2.753 25.449-5.526 28.174-18.492 2.725-12.966-5.471-25.708-18.305-28.461l-47.477-7.137 53.077-30.956c11.363-6.627 15.257-21.306 8.696-32.785-6.561-11.479-21.091-15.412-32.454-8.785l-53.077 30.956 17.621-45.104c4.057-12.606-2.768-26.146-15.247-30.245-12.478-4.099-25.883 2.797-29.94 15.402l-22.232 88.99-60.38 35.215V144l65.175-63.945c8.778-9.852 7.987-25.027-1.766-33.894-9.753-8.867-24.775-8.068-33.552 1.784l-29.857 37.967V24c0-13.255-10.637-24-23.758-24s-23.758 10.745-23.758 24v61.912l-29.857-37.967c-8.779-9.852-23.799-10.652-33.552-1.784-9.753 8.867-10.543 24.042-1.766 33.894L200.242 144v70.431l-60.38-35.215-22.232-88.99c-4.057-12.605-17.462-19.501-29.94-15.402-12.478 4.099-19.304 17.64-15.247 30.245l17.62 45.104-53.077-30.956c-11.363-6.627-25.893-2.694-32.454 8.785s-2.667 26.157 8.696 32.785l53.077 30.956-47.477 7.137C5.993 201.634-2.203 214.375.523 227.341c2.725 12.965 15.339 21.245 28.174 18.492l87.407-25.046L184 256l-67.896 35.215-87.406-25.045c-12.835-2.753-25.449 5.526-28.174 18.492-2.725 12.967 5.47 25.708 18.305 28.461l47.477 7.137-53.077 30.956C1.866 357.843-2.027 372.521 4.533 384s21.091 15.412 32.454 8.785l53.077-30.956-17.62 45.104a24.157 24.157 0 0 0 2.022 19.428c2.831 4.953 7.416 8.909 13.224 10.816 12.478 4.099 25.883-2.797 29.94-15.402l22.232-88.99 60.38-35.215V368l-65.175 63.945c-8.778 9.852-7.987 25.027 1.766 33.894 9.754 8.868 24.774 8.068 33.552-1.784l29.857-37.967V488c0 13.255 10.637 24 23.758 24s23.758-10.745 23.758-24v-61.912l29.857 37.967A23.59 23.59 0 0 0 295.282 472a23.534 23.534 0 0 0 15.885-6.161c9.753-8.867 10.544-24.042 1.766-33.894L247.758 368v-70.431l60.38 35.215 22.232 88.99c4.057 12.605 17.462 19.501 29.94 15.402 12.479-4.099 19.304-17.64 15.247-30.245l-17.621-45.104 53.077 30.956c11.363 6.627 25.893 2.694 32.454-8.785s2.667-26.157-8.696-32.785l-53.077-30.956 47.477-7.137c6.86-1.469 12.394-5.793 15.645-11.481z"] };
var faSocks = { prefix: 'fas', iconName: 'socks', icon: [512, 512, [], "f696", "M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"] };
var faSolarPanel = { prefix: 'fas', iconName: 'solar-panel', icon: [640, 512, [], "f5ba", "M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"] };
var faSort = { prefix: 'fas', iconName: 'sort', icon: [320, 512, [], "f0dc", "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"] };
var faSortAlphaDown = { prefix: 'fas', iconName: 'sort-alpha-down', icon: [448, 512, [], "f15d", "M187.298 395.314l-79.984 80.002c-6.248 6.247-16.383 6.245-22.627 0L4.705 395.314C-5.365 385.244 1.807 368 16.019 368H64V48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v320h47.984c14.241 0 21.363 17.264 11.314 27.314zm119.075-180.007A12 12 0 0 1 294.838 224h-35.717c-8.22 0-14.007-8.078-11.362-15.861l57.096-168A12 12 0 0 1 316.217 32h39.566c5.139 0 9.708 3.273 11.362 8.139l57.096 168C426.886 215.922 421.1 224 412.879 224h-35.735a12 12 0 0 1-11.515-8.622l-8.301-28.299h-42.863l-8.092 28.228zm22.857-78.697h13.367l-6.6-22.937-6.767 22.937zm12.575 287.323l67.451-95.698a12 12 0 0 0 2.192-6.913V300c0-6.627-5.373-12-12-12H274.522c-6.627 0-12 5.373-12 12v28.93c0 6.627 5.373 12 12 12h56.469c-.739.991-1.497 2.036-2.27 3.133l-67.203 95.205a12.001 12.001 0 0 0-2.196 6.92V468c0 6.627 5.373 12 12 12h129.355c6.627 0 12-5.373 12-12v-28.93c0-6.627-5.373-12-12-12h-61.146c.74-.993 1.5-2.039 2.274-3.137z"] };
var faSortAlphaUp = { prefix: 'fas', iconName: 'sort-alpha-up', icon: [448, 512, [], "f15e", "M4.702 116.686l79.984-80.002c6.248-6.247 16.383-6.245 22.627 0l79.981 80.002c10.07 10.07 2.899 27.314-11.314 27.314H128v320c0 8.837-7.163 16-16 16H80c-8.837 0-16-7.163-16-16V144H16.016c-14.241 0-21.363-17.264-11.314-27.314zm301.671 98.621A12 12 0 0 1 294.838 224h-35.717c-8.22 0-14.007-8.078-11.362-15.861l57.096-168A12 12 0 0 1 316.217 32h39.566c5.139 0 9.708 3.273 11.362 8.139l57.096 168C426.886 215.922 421.1 224 412.879 224h-35.735a12 12 0 0 1-11.515-8.622l-8.301-28.299h-42.863l-8.092 28.228zm22.857-78.697h13.367l-6.6-22.937-6.767 22.937zm12.575 287.323l67.451-95.698a12 12 0 0 0 2.192-6.913V300c0-6.627-5.373-12-12-12H274.522c-6.627 0-12 5.373-12 12v28.93c0 6.627 5.373 12 12 12h56.469c-.739.991-1.497 2.036-2.27 3.133l-67.203 95.205a12.001 12.001 0 0 0-2.196 6.92V468c0 6.627 5.373 12 12 12h129.355c6.627 0 12-5.373 12-12v-28.93c0-6.627-5.373-12-12-12h-61.146c.74-.993 1.5-2.039 2.274-3.137z"] };
var faSortAmountDown = { prefix: 'fas', iconName: 'sort-amount-down', icon: [512, 512, [], "f160", "M187.298 395.314l-79.984 80.002c-6.248 6.247-16.383 6.245-22.627 0L4.705 395.314C-5.365 385.244 1.807 368 16.019 368H64V48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v320h47.984c14.241 0 21.363 17.264 11.314 27.314zM240 96h256c8.837 0 16-7.163 16-16V48c0-8.837-7.163-16-16-16H240c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16zm-16 112v-32c0-8.837 7.163-16 16-16h192c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H240c-8.837 0-16-7.163-16-16zm0 256v-32c0-8.837 7.163-16 16-16h64c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-64c-8.837 0-16-7.163-16-16zm0-128v-32c0-8.837 7.163-16 16-16h128c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H240c-8.837 0-16-7.163-16-16z"] };
var faSortAmountUp = { prefix: 'fas', iconName: 'sort-amount-up', icon: [512, 512, [], "f161", "M4.702 116.686l79.984-80.002c6.248-6.247 16.383-6.245 22.627 0l79.981 80.002c10.07 10.07 2.899 27.314-11.314 27.314H128v320c0 8.837-7.163 16-16 16H80c-8.837 0-16-7.163-16-16V144H16.016c-14.241 0-21.363-17.264-11.314-27.314zM240 96h256c8.837 0 16-7.163 16-16V48c0-8.837-7.163-16-16-16H240c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16zm-16 112v-32c0-8.837 7.163-16 16-16h192c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H240c-8.837 0-16-7.163-16-16zm0 256v-32c0-8.837 7.163-16 16-16h64c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-64c-8.837 0-16-7.163-16-16zm0-128v-32c0-8.837 7.163-16 16-16h128c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H240c-8.837 0-16-7.163-16-16z"] };
var faSortDown = { prefix: 'fas', iconName: 'sort-down', icon: [320, 512, [], "f0dd", "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"] };
var faSortNumericDown = { prefix: 'fas', iconName: 'sort-numeric-down', icon: [448, 512, [], "f162", "M308.811 113.787l-19.448-20.795c-4.522-4.836-4.274-12.421.556-16.95l43.443-40.741a11.999 11.999 0 0 1 8.209-3.247h31.591c6.627 0 12 5.373 12 12v127.07h25.66c6.627 0 12 5.373 12 12v28.93c0 6.627-5.373 12-12 12H301.649c-6.627 0-12-5.373-12-12v-28.93c0-6.627 5.373-12 12-12h25.414v-57.938c-7.254 6.58-14.211 4.921-18.252.601zm-30.57 238.569c0-32.653 23.865-67.356 68.094-67.356 38.253 0 79.424 28.861 79.424 92.228 0 51.276-32.237 105.772-91.983 105.772-17.836 0-30.546-3.557-38.548-6.781-5.79-2.333-8.789-8.746-6.922-14.703l9.237-29.48c2.035-6.496 9.049-9.983 15.467-7.716 13.029 4.602 27.878 5.275 38.103-4.138-38.742 5.072-72.872-25.36-72.872-67.826zm92.273 19.338c0-22.285-15.302-36.505-25.835-36.505-8.642 0-13.164 7.965-13.164 15.832 0 5.669 1.815 24.168 25.168 24.168 9.973 0 13.377-2.154 13.744-2.731.021-.046.087-.291.087-.764zM175.984 368H128V48c0-8.837-7.163-16-16-16H80c-8.837 0-16 7.163-16 16v320H16.019c-14.212 0-21.384 17.244-11.314 27.314l79.981 80.002c6.245 6.245 16.38 6.247 22.627 0l79.984-80.002c10.05-10.05 2.928-27.314-11.313-27.314z"] };
var faSortNumericUp = { prefix: 'fas', iconName: 'sort-numeric-up', icon: [448, 512, [], "f163", "M308.811 113.787l-19.448-20.795c-4.522-4.836-4.274-12.421.556-16.95l43.443-40.741a11.999 11.999 0 0 1 8.209-3.247h31.591c6.627 0 12 5.373 12 12v127.07h25.66c6.627 0 12 5.373 12 12v28.93c0 6.627-5.373 12-12 12H301.649c-6.627 0-12-5.373-12-12v-28.93c0-6.627 5.373-12 12-12h25.414v-57.938c-7.254 6.58-14.211 4.921-18.252.601zm-30.57 238.569c0-32.653 23.865-67.356 68.094-67.356 38.253 0 79.424 28.861 79.424 92.228 0 51.276-32.237 105.772-91.983 105.772-17.836 0-30.546-3.557-38.548-6.781-5.79-2.333-8.789-8.746-6.922-14.703l9.237-29.48c2.035-6.496 9.049-9.983 15.467-7.716 13.029 4.602 27.878 5.275 38.103-4.138-38.742 5.072-72.872-25.36-72.872-67.826zm92.273 19.338c0-22.285-15.302-36.505-25.835-36.505-8.642 0-13.164 7.965-13.164 15.832 0 5.669 1.815 24.168 25.168 24.168 9.973 0 13.377-2.154 13.744-2.731.021-.046.087-.291.087-.764zM16.016 144H64v320c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144h47.981c14.212 0 21.384-17.244 11.314-27.314l-79.981-80.002c-6.245-6.245-16.38-6.247-22.627 0L4.702 116.686C-5.347 126.736 1.775 144 16.016 144z"] };
var faSortUp = { prefix: 'fas', iconName: 'sort-up', icon: [320, 512, [], "f0de", "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"] };
var faSpa = { prefix: 'fas', iconName: 'spa', icon: [576, 512, [], "f5bb", "M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"] };
var faSpaceShuttle = { prefix: 'fas', iconName: 'space-shuttle', icon: [640, 512, [], "f197", "M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"] };
var faSpinner = { prefix: 'fas', iconName: 'spinner', icon: [512, 512, [], "f110", "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"] };
var faSplotch = { prefix: 'fas', iconName: 'splotch', icon: [512, 512, [], "f5bc", "M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"] };
var faSprayCan = { prefix: 'fas', iconName: 'spray-can', icon: [512, 512, [], "f5bd", "M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"] };
var faSquare = { prefix: 'fas', iconName: 'square', icon: [448, 512, [], "f0c8", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"] };
var faSquareFull = { prefix: 'fas', iconName: 'square-full', icon: [512, 512, [], "f45c", "M512 512H0V0h512v512z"] };
var faSquareRootAlt = { prefix: 'fas', iconName: 'square-root-alt', icon: [576, 512, [], "f698", "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"] };
var faStamp = { prefix: 'fas', iconName: 'stamp', icon: [512, 512, [], "f5bf", "M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"] };
var faStar = { prefix: 'fas', iconName: 'star', icon: [576, 512, [], "f005", "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"] };
var faStarAndCrescent = { prefix: 'fas', iconName: 'star-and-crescent', icon: [512, 512, [], "f699", "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"] };
var faStarHalf = { prefix: 'fas', iconName: 'star-half', icon: [576, 512, [], "f089", "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"] };
var faStarHalfAlt = { prefix: 'fas', iconName: 'star-half-alt', icon: [536, 512, [], "f5c0", "M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"] };
var faStarOfDavid = { prefix: 'fas', iconName: 'star-of-david', icon: [464, 512, [], "f69a", "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"] };
var faStarOfLife = { prefix: 'fas', iconName: 'star-of-life', icon: [480, 512, [], "f621", "M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"] };
var faStepBackward = { prefix: 'fas', iconName: 'step-backward', icon: [448, 512, [], "f048", "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"] };
var faStepForward = { prefix: 'fas', iconName: 'step-forward', icon: [448, 512, [], "f051", "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"] };
var faStethoscope = { prefix: 'fas', iconName: 'stethoscope', icon: [512, 512, [], "f0f1", "M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"] };
var faStickyNote = { prefix: 'fas', iconName: 'sticky-note', icon: [448, 512, [], "f249", "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"] };
var faStop = { prefix: 'fas', iconName: 'stop', icon: [448, 512, [], "f04d", "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"] };
var faStopCircle = { prefix: 'fas', iconName: 'stop-circle', icon: [512, 512, [], "f28d", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"] };
var faStopwatch = { prefix: 'fas', iconName: 'stopwatch', icon: [448, 512, [], "f2f2", "M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"] };
var faStore = { prefix: 'fas', iconName: 'store', icon: [616, 512, [], "f54e", "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"] };
var faStoreAlt = { prefix: 'fas', iconName: 'store-alt', icon: [640, 512, [], "f54f", "M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"] };
var faStream = { prefix: 'fas', iconName: 'stream', icon: [512, 512, [], "f550", "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"] };
var faStreetView = { prefix: 'fas', iconName: 'street-view', icon: [512, 512, [], "f21d", "M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"] };
var faStrikethrough = { prefix: 'fas', iconName: 'strikethrough', icon: [512, 512, [], "f0cc", "M496 288H16c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h480c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16zm-214.666 16c27.258 12.937 46.524 28.683 46.524 56.243 0 33.108-28.977 53.676-75.621 53.676-32.325 0-76.874-12.08-76.874-44.271V368c0-8.837-7.164-16-16-16H113.75c-8.836 0-16 7.163-16 16v19.204c0 66.845 77.717 101.82 154.487 101.82 88.578 0 162.013-45.438 162.013-134.424 0-19.815-3.618-36.417-10.143-50.6H281.334zm-30.952-96c-32.422-13.505-56.836-28.946-56.836-59.683 0-33.92 30.901-47.406 64.962-47.406 42.647 0 64.962 16.593 64.962 32.985V136c0 8.837 7.164 16 16 16h45.613c8.836 0 16-7.163 16-16v-30.318c0-52.438-71.725-79.875-142.575-79.875-85.203 0-150.726 40.972-150.726 125.646 0 22.71 4.665 41.176 12.777 56.547h129.823z"] };
var faStroopwafel = { prefix: 'fas', iconName: 'stroopwafel', icon: [512, 512, [], "f551", "M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"] };
var faSubscript = { prefix: 'fas', iconName: 'subscript', icon: [512, 512, [], "f12c", "M395.198 416c3.461-10.526 18.796-21.28 36.265-32.425 16.625-10.605 35.467-22.626 50.341-38.862 17.458-19.054 25.944-40.175 25.944-64.567 0-60.562-50.702-88.146-97.81-88.146-42.491 0-76.378 22.016-94.432 50.447-4.654 7.329-2.592 17.036 4.623 21.865l30.328 20.296c7.032 4.706 16.46 3.084 21.63-3.614 8.022-10.394 18.818-18.225 31.667-18.225 19.387 0 26.266 12.901 26.266 23.948 0 36.159-119.437 57.023-119.437 160.024 0 6.654.561 13.014 1.415 19.331 1.076 7.964 7.834 13.928 15.87 13.928H496c8.837 0 16-7.163 16-16v-32c0-8.837-7.163-16-16-16H395.198zM272 256c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-62.399a16 16 0 0 1-13.541-7.478l-45.701-72.615c-2.297-3.352-4.422-6.969-6.195-10.209-1.65 3.244-3.647 6.937-5.874 10.582l-44.712 72.147a15.999 15.999 0 0 1-13.6 7.572H16c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h26.325l56.552-82.709L46.111 96H16C7.163 96 0 88.837 0 80V48c0-8.837 7.163-16 16-16h68.806a16 16 0 0 1 13.645 7.644l39.882 65.126c2.072 3.523 4.053 7.171 5.727 10.37 1.777-3.244 3.92-6.954 6.237-10.537l40.332-65.035A15.999 15.999 0 0 1 204.226 32H272c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-27.979l-52.69 75.671L249.974 256H272z"] };
var faSubway = { prefix: 'fas', iconName: 'subway', icon: [448, 512, [], "f239", "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"] };
var faSuitcase = { prefix: 'fas', iconName: 'suitcase', icon: [512, 512, [], "f0f2", "M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"] };
var faSuitcaseRolling = { prefix: 'fas', iconName: 'suitcase-rolling', icon: [384, 512, [], "f5c1", "M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"] };
var faSun = { prefix: 'fas', iconName: 'sun', icon: [512, 512, [], "f185", "M274.835 12.646l25.516 62.393c4.213 10.301 16.671 14.349 26.134 8.492l57.316-35.479c15.49-9.588 34.808 4.447 30.475 22.142l-16.03 65.475c-2.647 10.81 5.053 21.408 16.152 22.231l67.224 4.987c18.167 1.348 25.546 24.057 11.641 35.826L441.81 242.26c-8.495 7.19-8.495 20.289 0 27.479l51.454 43.548c13.906 11.769 6.527 34.478-11.641 35.826l-67.224 4.987c-11.099.823-18.799 11.421-16.152 22.231l16.03 65.475c4.332 17.695-14.986 31.73-30.475 22.142l-57.316-35.479c-9.463-5.858-21.922-1.81-26.134 8.492l-25.516 62.393c-6.896 16.862-30.774 16.862-37.67 0l-25.516-62.393c-4.213-10.301-16.671-14.349-26.134-8.492l-57.317 35.479c-15.49 9.588-34.808-4.447-30.475-22.142l16.03-65.475c2.647-10.81-5.053-21.408-16.152-22.231l-67.224-4.987c-18.167-1.348-25.546-24.057-11.641-35.826L70.19 269.74c8.495-7.19 8.495-20.289 0-27.479l-51.454-43.548c-13.906-11.769-6.527-34.478 11.641-35.826l67.224-4.987c11.099-.823 18.799-11.421 16.152-22.231l-16.03-65.475c-4.332-17.695 14.986-31.73 30.475-22.142l57.317 35.479c9.463 5.858 21.921 1.81 26.134-8.492l25.516-62.393c6.896-16.861 30.774-16.861 37.67 0zM392 256c0-74.991-61.01-136-136-136-74.991 0-136 61.009-136 136s61.009 136 136 136c74.99 0 136-61.009 136-136zm-32 0c0 57.346-46.654 104-104 104s-104-46.654-104-104 46.654-104 104-104 104 46.654 104 104z"] };
var faSuperscript = { prefix: 'fas', iconName: 'superscript', icon: [512, 512, [], "f12b", "M395.198 256c3.461-10.526 18.796-21.28 36.265-32.425 16.625-10.605 35.467-22.626 50.341-38.862 17.458-19.054 25.944-40.175 25.944-64.567 0-60.562-50.702-88.146-97.81-88.146-42.491 0-76.378 22.016-94.432 50.447-4.654 7.329-2.592 17.036 4.623 21.865l30.328 20.296c7.032 4.706 16.46 3.084 21.63-3.614 8.022-10.394 18.818-18.225 31.667-18.225 19.387 0 26.266 12.901 26.266 23.948 0 36.159-119.437 57.023-119.437 160.024 0 6.654.561 13.014 1.415 19.331 1.076 7.964 7.834 13.928 15.87 13.928H496c8.837 0 16-7.163 16-16v-32c0-8.837-7.163-16-16-16H395.198zM272 416c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-62.399a16 16 0 0 1-13.541-7.478l-45.701-72.615c-2.297-3.352-4.422-6.969-6.195-10.209-1.65 3.244-3.647 6.937-5.874 10.582l-44.712 72.147a15.999 15.999 0 0 1-13.6 7.572H16c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h26.325l56.552-82.709L46.111 256H16c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h68.806a16 16 0 0 1 13.645 7.644l39.882 65.126c2.072 3.523 4.053 7.171 5.727 10.37 1.777-3.244 3.92-6.954 6.237-10.537l40.332-65.035a16 16 0 0 1 13.598-7.567H272c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-27.979l-52.69 75.671L249.974 416H272z"] };
var faSurprise = { prefix: 'fas', iconName: 'surprise', icon: [496, 512, [], "f5c2", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"] };
var faSwatchbook = { prefix: 'fas', iconName: 'swatchbook', icon: [511, 512, [], "f5c3", "M479.06 320H372.29L186.15 506.51c-2.06 2.07-4.49 3.58-6.67 5.49h299.58c17.64 0 31.94-14.33 31.94-32V352c0-17.67-14.3-32-31.94-32zm-44.5-152.9l-90.33-90.51c-12.47-12.5-32.69-12.5-45.17 0l-75.5 75.65V416c0 2.96-.67 5.73-.87 8.64l211.87-212.28c12.47-12.5 12.47-32.77 0-45.26zM191.62 32c0-17.67-14.3-32-31.94-32H31.94C14.3 0 0 14.33 0 32v384c0 53.02 42.9 96 95.81 96s95.81-42.98 95.81-96V32zM95.81 440c-13.23 0-23.95-10.75-23.95-24 0-13.26 10.73-24 23.95-24s23.95 10.74 23.95 24c.01 13.25-10.72 24-23.95 24zm31.94-184H63.88v-64h63.88v64zm0-128H63.88V64h63.88v64z"] };
var faSwimmer = { prefix: 'fas', iconName: 'swimmer', icon: [640, 512, [], "f5c4", "M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"] };
var faSwimmingPool = { prefix: 'fas', iconName: 'swimming-pool', icon: [640, 512, [], "f5c5", "M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"] };
var faSynagogue = { prefix: 'fas', iconName: 'synagogue', icon: [640, 512, [], "f69b", "M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"] };
var faSync = { prefix: 'fas', iconName: 'sync', icon: [512, 512, [], "f021", "M440.935 12.574l3.966 82.766C399.416 41.904 331.674 8 256 8 134.813 8 33.933 94.924 12.296 209.824 10.908 217.193 16.604 224 24.103 224h49.084c5.57 0 10.377-3.842 11.676-9.259C103.407 137.408 172.931 80 256 80c60.893 0 114.512 30.856 146.104 77.801l-101.53-4.865c-6.845-.328-12.574 5.133-12.574 11.986v47.411c0 6.627 5.373 12 12 12h200.333c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12h-47.411c-6.853 0-12.315 5.729-11.987 12.574zM256 432c-60.895 0-114.517-30.858-146.109-77.805l101.868 4.871c6.845.327 12.573-5.134 12.573-11.986v-47.412c0-6.627-5.373-12-12-12H12c-6.627 0-12 5.373-12 12V500c0 6.627 5.373 12 12 12h47.385c6.863 0 12.328-5.745 11.985-12.599l-4.129-82.575C112.725 470.166 180.405 504 256 504c121.187 0 222.067-86.924 243.704-201.824 1.388-7.369-4.308-14.176-11.807-14.176h-49.084c-5.57 0-10.377 3.842-11.676 9.259C408.593 374.592 339.069 432 256 432z"] };
var faSyncAlt = { prefix: 'fas', iconName: 'sync-alt', icon: [512, 512, [], "f2f1", "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"] };
var faSyringe = { prefix: 'fas', iconName: 'syringe', icon: [512, 512, [], "f48e", "M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"] };
var faTable = { prefix: 'fas', iconName: 'table', icon: [512, 512, [], "f0ce", "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"] };
var faTableTennis = { prefix: 'fas', iconName: 'table-tennis', icon: [512, 512, [], "f45d", "M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"] };
var faTablet = { prefix: 'fas', iconName: 'tablet', icon: [448, 512, [], "f10a", "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"] };
var faTabletAlt = { prefix: 'fas', iconName: 'tablet-alt', icon: [448, 512, [], "f3fa", "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"] };
var faTablets = { prefix: 'fas', iconName: 'tablets', icon: [640, 512, [], "f490", "M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"] };
var faTachometerAlt = { prefix: 'fas', iconName: 'tachometer-alt', icon: [576, 512, [], "f3fd", "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"] };
var faTag = { prefix: 'fas', iconName: 'tag', icon: [512, 512, [], "f02b", "M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"] };
var faTags = { prefix: 'fas', iconName: 'tags', icon: [640, 512, [], "f02c", "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"] };
var faTape = { prefix: 'fas', iconName: 'tape', icon: [640, 512, [], "f4db", "M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"] };
var faTasks = { prefix: 'fas', iconName: 'tasks', icon: [512, 512, [], "f0ae", "M208 132h288c8.8 0 16-7.2 16-16V76c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zm0 160h288c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zm0 160h288c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zM64 368c-26.5 0-48.6 21.5-48.6 48s22.1 48 48.6 48 48-21.5 48-48-21.5-48-48-48zm92.5-299l-72.2 72.2-15.6 15.6c-4.7 4.7-12.9 4.7-17.6 0L3.5 109.4c-4.7-4.7-4.7-12.3 0-17l15.7-15.7c4.7-4.7 12.3-4.7 17 0l22.7 22.1 63.7-63.3c4.7-4.7 12.3-4.7 17 0l17 16.5c4.6 4.7 4.6 12.3-.1 17zm0 159.6l-72.2 72.2-15.7 15.7c-4.7 4.7-12.9 4.7-17.6 0L3.5 269c-4.7-4.7-4.7-12.3 0-17l15.7-15.7c4.7-4.7 12.3-4.7 17 0l22.7 22.1 63.7-63.7c4.7-4.7 12.3-4.7 17 0l17 17c4.6 4.6 4.6 12.2-.1 16.9z"] };
var faTaxi = { prefix: 'fas', iconName: 'taxi', icon: [512, 512, [], "f1ba", "M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"] };
var faTeeth = { prefix: 'fas', iconName: 'teeth', icon: [640, 512, [], "f62e", "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"] };
var faTeethOpen = { prefix: 'fas', iconName: 'teeth-open', icon: [640, 512, [], "f62f", "M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"] };
var faTerminal = { prefix: 'fas', iconName: 'terminal', icon: [640, 512, [], "f120", "M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"] };
var faTextHeight = { prefix: 'fas', iconName: 'text-height', icon: [576, 512, [], "f034", "M16 32h288c8.837 0 16 7.163 16 16v96c0 8.837-7.163 16-16 16h-35.496c-8.837 0-16-7.163-16-16V96h-54.761v320H232c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H88c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h34.257V96H67.496v48c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V48c0-8.837 7.163-16 16-16zm475.308 4.685l79.995 80.001C581.309 126.693 574.297 144 559.99 144H512v224h48c15.639 0 20.635 17.991 11.313 27.314l-79.995 80.001c-6.247 6.247-16.381 6.245-22.626 0l-79.995-80.001C378.691 385.307 385.703 368 400.01 368H448V144h-48c-15.639 0-20.635-17.991-11.313-27.314l79.995-80.001c6.247-6.248 16.381-6.245 22.626 0z"] };
var faTextWidth = { prefix: 'fas', iconName: 'text-width', icon: [448, 512, [], "f035", "M16 32h416c8.837 0 16 7.163 16 16v96c0 8.837-7.163 16-16 16h-35.496c-8.837 0-16-7.163-16-16V96H261.743v128H296c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H152c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h34.257V96H67.496v48c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16V48c0-8.837 7.163-16 16-16zm427.315 340.682l-80.001-79.995C353.991 283.365 336 288.362 336 304v48H112v-47.99c0-14.307-17.307-21.319-27.314-11.313L4.685 372.692c-6.245 6.245-6.247 16.379 0 22.626l80.001 79.995C94.009 484.635 112 479.638 112 464v-48h224v47.99c0 14.307 17.307 21.319 27.314 11.313l80.001-79.995c6.245-6.245 6.248-16.379 0-22.626z"] };
var faTh = { prefix: 'fas', iconName: 'th', icon: [512, 512, [], "f00a", "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"] };
var faThLarge = { prefix: 'fas', iconName: 'th-large', icon: [512, 512, [], "f009", "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"] };
var faThList = { prefix: 'fas', iconName: 'th-list', icon: [512, 512, [], "f00b", "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"] };
var faTheaterMasks = { prefix: 'fas', iconName: 'theater-masks', icon: [640, 512, [], "f630", "M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"] };
var faThermometer = { prefix: 'fas', iconName: 'thermometer', icon: [512, 512, [], "f491", "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"] };
var faThermometerEmpty = { prefix: 'fas', iconName: 'thermometer-empty', icon: [256, 512, [], "f2cb", "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"] };
var faThermometerFull = { prefix: 'fas', iconName: 'thermometer-full', icon: [256, 512, [], "f2c7", "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"] };
var faThermometerHalf = { prefix: 'fas', iconName: 'thermometer-half', icon: [256, 512, [], "f2c9", "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"] };
var faThermometerQuarter = { prefix: 'fas', iconName: 'thermometer-quarter', icon: [256, 512, [], "f2ca", "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"] };
var faThermometerThreeQuarters = { prefix: 'fas', iconName: 'thermometer-three-quarters', icon: [256, 512, [], "f2c8", "M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"] };
var faThumbsDown = { prefix: 'fas', iconName: 'thumbs-down', icon: [512, 512, [], "f165", "M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"] };
var faThumbsUp = { prefix: 'fas', iconName: 'thumbs-up', icon: [512, 512, [], "f164", "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"] };
var faThumbtack = { prefix: 'fas', iconName: 'thumbtack', icon: [384, 512, [], "f08d", "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"] };
var faTicketAlt = { prefix: 'fas', iconName: 'ticket-alt', icon: [576, 512, [], "f3ff", "M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"] };
var faTimes = { prefix: 'fas', iconName: 'times', icon: [352, 512, [], "f00d", "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"] };
var faTimesCircle = { prefix: 'fas', iconName: 'times-circle', icon: [512, 512, [], "f057", "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"] };
var faTint = { prefix: 'fas', iconName: 'tint', icon: [352, 512, [], "f043", "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"] };
var faTintSlash = { prefix: 'fas', iconName: 'tint-slash', icon: [640, 512, [], "f5c7", "M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"] };
var faTired = { prefix: 'fas', iconName: 'tired', icon: [496, 512, [], "f5c8", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"] };
var faToggleOff = { prefix: 'fas', iconName: 'toggle-off', icon: [576, 512, [], "f204", "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"] };
var faToggleOn = { prefix: 'fas', iconName: 'toggle-on', icon: [576, 512, [], "f205", "M576 256c0 106.039-85.961 192-192 192H192C85.961 448 0 362.039 0 256S85.961 64 192 64h192c106.039 0 192 85.961 192 192zM384 128c-70.741 0-128 57.249-128 128 0 70.741 57.249 128 128 128 70.741 0 128-57.249 128-128 0-70.741-57.249-128-128-128"] };
var faToolbox = { prefix: 'fas', iconName: 'toolbox', icon: [512, 512, [], "f552", "M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"] };
var faTooth = { prefix: 'fas', iconName: 'tooth', icon: [448, 512, [], "f5c9", "M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"] };
var faTorah = { prefix: 'fas', iconName: 'torah', icon: [448, 512, [], "f6a0", "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM139.11 141.21c-2.77-4.41.4-10.14 5.6-10.14h53.08c.9 0 1.73-.46 2.21-1.22l34.4-54.76c2.6-4.13 8.61-4.13 11.21 0l34.4 54.76a2.61 2.61 0 0 0 2.21 1.22h53.08c5.2 0 8.37 5.73 5.6 10.14L314.01 184l26.88 42.79c2.77 4.4-.4 10.13-5.6 10.13h-53.08c-.9 0-1.73.46-2.21 1.22l-34.4 54.76c-2.6 4.13-8.61 4.13-11.21 0L200 238.15a2.61 2.61 0 0 0-2.21-1.22h-53.08c-5.2 0-8.37-5.73-5.6-10.13l26.88-42.8-26.88-42.79zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"] };
var faToriiGate = { prefix: 'fas', iconName: 'torii-gate', icon: [512, 512, [], "f6a1", "M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"] };
var faTrademark = { prefix: 'fas', iconName: 'trademark', icon: [640, 512, [], "f25c", "M97.119 163.133H12c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h248.559c6.627 0 12 5.373 12 12v43.133c0 6.627-5.373 12-12 12H175.44V404c0 6.627-5.373 12-12 12h-54.322c-6.627 0-12-5.373-12-12V163.133zM329.825 96h65.425a12 12 0 0 1 11.346 8.093l43.759 127.068c7.161 20.588 16.111 52.812 16.111 52.812h.896s8.95-32.224 16.111-52.812l43.758-127.068A12 12 0 0 1 538.577 96h65.41a12 12 0 0 1 11.961 11.03l24.012 296c.567 6.987-4.951 12.97-11.961 12.97h-54.101a12 12 0 0 1-11.972-11.182l-9.082-132.93c-1.79-24.168 0-53.706 0-53.706h-.896s-10.741 33.566-17.902 53.706l-30.7 84.731a12 12 0 0 1-11.282 7.912h-50.302a12 12 0 0 1-11.282-7.912l-30.7-84.731c-7.161-20.14-17.903-53.706-17.903-53.706h-.895s1.79 29.538 0 53.706l-9.082 132.93c-.428 6.295-5.66 11.182-11.97 11.182H305.4c-7.017 0-12.536-5.994-11.959-12.987l24.425-296A11.999 11.999 0 0 1 329.825 96z"] };
var faTrafficLight = { prefix: 'fas', iconName: 'traffic-light', icon: [384, 512, [], "f637", "M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"] };
var faTrain = { prefix: 'fas', iconName: 'train', icon: [448, 512, [], "f238", "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"] };
var faTransgender = { prefix: 'fas', iconName: 'transgender', icon: [384, 512, [], "f224", "M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"] };
var faTransgenderAlt = { prefix: 'fas', iconName: 'transgender-alt', icon: [480, 512, [], "f225", "M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"] };
var faTrash = { prefix: 'fas', iconName: 'trash', icon: [448, 512, [], "f1f8", "M0 84V56c0-13.3 10.7-24 24-24h112l9.4-18.7c4-8.2 12.3-13.3 21.4-13.3h114.3c9.1 0 17.4 5.1 21.5 13.3L312 32h112c13.3 0 24 10.7 24 24v28c0 6.6-5.4 12-12 12H12C5.4 96 0 90.6 0 84zm415.2 56.7L394.8 467c-1.6 25.3-22.6 45-47.9 45H101.1c-25.3 0-46.3-19.7-47.9-45L32.8 140.7c-.4-6.9 5.1-12.7 12-12.7h358.5c6.8 0 12.3 5.8 11.9 12.7z"] };
var faTrashAlt = { prefix: 'fas', iconName: 'trash-alt', icon: [448, 512, [], "f2ed", "M0 84V56c0-13.3 10.7-24 24-24h112l9.4-18.7c4-8.2 12.3-13.3 21.4-13.3h114.3c9.1 0 17.4 5.1 21.5 13.3L312 32h112c13.3 0 24 10.7 24 24v28c0 6.6-5.4 12-12 12H12C5.4 96 0 90.6 0 84zm416 56v324c0 26.5-21.5 48-48 48H80c-26.5 0-48-21.5-48-48V140c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12zm-272 68c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208zm96 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208z"] };
var faTree = { prefix: 'fas', iconName: 'tree', icon: [384, 512, [], "f1bb", "M377.33 375.429L293.906 288H328c21.017 0 31.872-25.207 17.448-40.479L262.79 160H296c20.878 0 31.851-24.969 17.587-40.331l-104-112.003c-9.485-10.214-25.676-10.229-35.174 0l-104 112.003C56.206 134.969 67.037 160 88 160h33.21l-82.659 87.521C24.121 262.801 34.993 288 56 288h34.094L6.665 375.429C-7.869 390.655 2.925 416 24.025 416H144c0 32.781-11.188 49.26-33.995 67.506C98.225 492.93 104.914 512 120 512h144c15.086 0 21.776-19.069 9.995-28.494-19.768-15.814-33.992-31.665-33.995-67.496V416h119.97c21.05 0 31.929-25.309 17.36-40.571z"] };
var faTrophy = { prefix: 'fas', iconName: 'trophy', icon: [576, 512, [], "f091", "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"] };
var faTruck = { prefix: 'fas', iconName: 'truck', icon: [640, 512, [], "f0d1", "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"] };
var faTruckLoading = { prefix: 'fas', iconName: 'truck-loading', icon: [640, 512, [], "f4de", "M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"] };
var faTruckMonster = { prefix: 'fas', iconName: 'truck-monster', icon: [640, 512, [], "f63b", "M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"] };
var faTruckMoving = { prefix: 'fas', iconName: 'truck-moving', icon: [640, 512, [], "f4df", "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"] };
var faTruckPickup = { prefix: 'fas', iconName: 'truck-pickup', icon: [640, 512, [], "f63c", "M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"] };
var faTshirt = { prefix: 'fas', iconName: 'tshirt', icon: [640, 512, [], "f553", "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"] };
var faTty = { prefix: 'fas', iconName: 'tty', icon: [512, 512, [], "f1e4", "M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"] };
var faTv = { prefix: 'fas', iconName: 'tv', icon: [640, 512, [], "f26c", "M592 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h245.1v32h-160c-17.7 0-32 14.3-32 32s14.3 32 32 32h384c17.7 0 32-14.3 32-32s-14.3-32-32-32h-160v-32H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h512v288z"] };
var faUmbrella = { prefix: 'fas', iconName: 'umbrella', icon: [576, 512, [], "f0e9", "M557.011 267.631c-51.432-45.217-107.572-43.698-158.567 30.731-5.298 7.861-14.906 7.165-19.736 0-2.483-3.624-32.218-60.808-90.708-60.808-45.766 0-70.542 31.378-90.709 60.808-4.829 7.165-14.436 7.861-19.734 0-50.904-74.285-106.613-76.406-158.567-30.731-10.21 8.264-20.912-1.109-18.696-9.481C32.146 134.573 158.516 64.612 288.001 64.612c128.793 0 256.546 69.961 287.706 193.538 2.206 8.322-8.426 17.793-18.696 9.481zM256 261.001V416c0 17.645-14.355 32-32 32s-32-14.355-32-32c0-17.673-14.327-32-32-32s-32 14.327-32 32c0 52.935 43.065 96 96 96s96-43.065 96-96V261.288c-21.836-10.806-45.425-9.737-64-.287zm64-211.007V32c0-17.673-14.327-32-32-32s-32 14.327-32 32v17.987a372.105 372.105 0 0 1 64 .007z"] };
var faUmbrellaBeach = { prefix: 'fas', iconName: 'umbrella-beach', icon: [640, 512, [], "f5ca", "M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"] };
var faUnderline = { prefix: 'fas', iconName: 'underline', icon: [448, 512, [], "f0cd", "M224.264 388.24c-91.669 0-156.603-51.165-156.603-151.392V64H39.37c-8.837 0-16-7.163-16-16V16c0-8.837 7.163-16 16-16h137.39c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-28.813v172.848c0 53.699 28.314 79.444 76.317 79.444 46.966 0 75.796-25.434 75.796-79.965V64h-28.291c-8.837 0-16-7.163-16-16V16c0-8.837 7.163-16 16-16h136.868c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16h-28.291v172.848c0 99.405-64.881 151.392-156.082 151.392zM16 448h416c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H16c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16z"] };
var faUndo = { prefix: 'fas', iconName: 'undo', icon: [512, 512, [], "f0e2", "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"] };
var faUndoAlt = { prefix: 'fas', iconName: 'undo-alt', icon: [512, 512, [], "f2ea", "M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"] };
var faUniversalAccess = { prefix: 'fas', iconName: 'universal-access', icon: [512, 512, [], "f29a", "M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"] };
var faUniversity = { prefix: 'fas', iconName: 'university', icon: [512, 512, [], "f19c", "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"] };
var faUnlink = { prefix: 'fas', iconName: 'unlink', icon: [512, 512, [], "f127", "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"] };
var faUnlock = { prefix: 'fas', iconName: 'unlock', icon: [448, 512, [], "f09c", "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"] };
var faUnlockAlt = { prefix: 'fas', iconName: 'unlock-alt', icon: [448, 512, [], "f13e", "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"] };
var faUpload = { prefix: 'fas', iconName: 'upload', icon: [512, 512, [], "f093", "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"] };
var faUser = { prefix: 'fas', iconName: 'user', icon: [448, 512, [], "f007", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"] };
var faUserAlt = { prefix: 'fas', iconName: 'user-alt', icon: [512, 512, [], "f406", "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"] };
var faUserAltSlash = { prefix: 'fas', iconName: 'user-alt-slash', icon: [640, 512, [], "f4fa", "M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"] };
var faUserAstronaut = { prefix: 'fas', iconName: 'user-astronaut', icon: [448, 512, [], "f4fb", "M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"] };
var faUserCheck = { prefix: 'fas', iconName: 'user-check', icon: [640, 512, [], "f4fc", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"] };
var faUserCircle = { prefix: 'fas', iconName: 'user-circle', icon: [496, 512, [], "f2bd", "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"] };
var faUserClock = { prefix: 'fas', iconName: 'user-clock', icon: [640, 512, [], "f4fd", "M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"] };
var faUserCog = { prefix: 'fas', iconName: 'user-cog', icon: [640, 512, [], "f4fe", "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"] };
var faUserEdit = { prefix: 'fas', iconName: 'user-edit', icon: [640, 512, [], "f4ff", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"] };
var faUserFriends = { prefix: 'fas', iconName: 'user-friends', icon: [640, 512, [], "f500", "M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"] };
var faUserGraduate = { prefix: 'fas', iconName: 'user-graduate', icon: [448, 512, [], "f501", "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"] };
var faUserLock = { prefix: 'fas', iconName: 'user-lock', icon: [640, 512, [], "f502", "M320 320c0-11.1 3.1-21.4 8.1-30.5-4.8-.5-9.5-1.5-14.5-1.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h280.9c-5.5-9.5-8.9-20.3-8.9-32V320zm-96-64c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm384 32h-32v-48c0-44.2-35.8-80-80-80s-80 35.8-80 80v48h-32c-17.7 0-32 14.3-32 32v160c0 17.7 14.3 32 32 32h224c17.7 0 32-14.3 32-32V320c0-17.7-14.3-32-32-32zm-80 0h-64v-48c0-17.6 14.4-32 32-32s32 14.4 32 32v48z"] };
var faUserMd = { prefix: 'fas', iconName: 'user-md', icon: [448, 512, [], "f0f0", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"] };
var faUserMinus = { prefix: 'fas', iconName: 'user-minus', icon: [640, 512, [], "f503", "M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"] };
var faUserNinja = { prefix: 'fas', iconName: 'user-ninja', icon: [448, 512, [], "f504", "M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"] };
var faUserPlus = { prefix: 'fas', iconName: 'user-plus', icon: [640, 512, [], "f234", "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"] };
var faUserSecret = { prefix: 'fas', iconName: 'user-secret', icon: [448, 512, [], "f21b", "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"] };
var faUserShield = { prefix: 'fas', iconName: 'user-shield', icon: [640, 512, [], "f505", "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"] };
var faUserSlash = { prefix: 'fas', iconName: 'user-slash', icon: [640, 512, [], "f506", "M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"] };
var faUserTag = { prefix: 'fas', iconName: 'user-tag', icon: [640, 512, [], "f507", "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"] };
var faUserTie = { prefix: 'fas', iconName: 'user-tie', icon: [448, 512, [], "f508", "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"] };
var faUserTimes = { prefix: 'fas', iconName: 'user-times', icon: [640, 512, [], "f235", "M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"] };
var faUsers = { prefix: 'fas', iconName: 'users', icon: [640, 512, [], "f0c0", "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"] };
var faUsersCog = { prefix: 'fas', iconName: 'users-cog', icon: [640, 512, [], "f509", "M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"] };
var faUtensilSpoon = { prefix: 'fas', iconName: 'utensil-spoon', icon: [512, 512, [], "f2e5", "M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"] };
var faUtensils = { prefix: 'fas', iconName: 'utensils', icon: [416, 512, [], "f2e7", "M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"] };
var faVectorSquare = { prefix: 'fas', iconName: 'vector-square', icon: [512, 512, [], "f5cb", "M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"] };
var faVenus = { prefix: 'fas', iconName: 'venus', icon: [288, 512, [], "f221", "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"] };
var faVenusDouble = { prefix: 'fas', iconName: 'venus-double', icon: [512, 512, [], "f226", "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"] };
var faVenusMars = { prefix: 'fas', iconName: 'venus-mars', icon: [576, 512, [], "f228", "M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"] };
var faVial = { prefix: 'fas', iconName: 'vial', icon: [480, 512, [], "f492", "M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"] };
var faVials = { prefix: 'fas', iconName: 'vials', icon: [640, 512, [], "f493", "M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"] };
var faVideo = { prefix: 'fas', iconName: 'video', icon: [576, 512, [], "f03d", "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"] };
var faVideoSlash = { prefix: 'fas', iconName: 'video-slash', icon: [640, 512, [], "f4e2", "M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"] };
var faVihara = { prefix: 'fas', iconName: 'vihara', icon: [640, 512, [], "f6a7", "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"] };
var faVolleyballBall = { prefix: 'fas', iconName: 'volleyball-ball', icon: [495, 512, [], "f45f", "M223.3 243.4c-.9-37-8.6-72.8-22.7-105.7-90.8 42.4-157.5 122.4-180.3 216.8 13.4 30.8 32.9 58.3 56.9 81.1 22.7-79.2 74.2-147.8 146.1-192.2zM186.4 109c-15-26.4-34.5-50.1-57.4-70.7C38 88.1-15.8 191.2 4 300.5c33.4-83.1 98.4-152 182.4-191.5zM374 274.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5 57.3 59.3 91 138.2 93.5 222.7 32.5 17.7 67.3 29 102.9 33.2zm-124.7 9.5c-31.6 19.3-58.7 43.9-80.2 72.6 82 57.3 184.5 75.1 277.5 47.8 19.7-26.4 34.2-56.8 42.2-89.9-26.6 6.6-53.7 10.4-80.9 10.4-54.6-.1-108.9-14.1-158.6-40.9zM151 383.3c-15.2 26-25.7 54.4-32.1 84.2 37.6 23 81.7 36.5 129.1 36.5 61 0 116.7-22.1 159.9-58.6C295 461.5 204.6 420.6 151 383.3zM331.3 22.7c55.3 70.4 82.5 161.2 74.6 253.6 30.3.2 60.5-4.8 89.7-14.2 0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"] };
var faVolumeDown = { prefix: 'fas', iconName: 'volume-down', icon: [384, 512, [], "f027", "M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"] };
var faVolumeOff = { prefix: 'fas', iconName: 'volume-off', icon: [257, 512, [], "f026", "M216.36 71.04L127.39 160H25.33c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.47-25.96-31.98-40.97-16.98z"] };
var faVolumeUp = { prefix: 'fas', iconName: 'volume-up', icon: [576, 512, [], "f028", "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"] };
var faWalking = { prefix: 'fas', iconName: 'walking', icon: [320, 512, [], "f554", "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"] };
var faWallet = { prefix: 'fas', iconName: 'wallet', icon: [512, 512, [], "f555", "M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"] };
var faWarehouse = { prefix: 'fas', iconName: 'warehouse', icon: [640, 512, [], "f494", "M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"] };
var faWeight = { prefix: 'fas', iconName: 'weight', icon: [512, 512, [], "f496", "M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"] };
var faWeightHanging = { prefix: 'fas', iconName: 'weight-hanging', icon: [512, 512, [], "f5cd", "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"] };
var faWheelchair = { prefix: 'fas', iconName: 'wheelchair', icon: [512, 512, [], "f193", "M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"] };
var faWifi = { prefix: 'fas', iconName: 'wifi', icon: [640, 512, [], "f1eb", "M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"] };
var faWindowClose = { prefix: 'fas', iconName: 'window-close', icon: [512, 512, [], "f410", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"] };
var faWindowMaximize = { prefix: 'fas', iconName: 'window-maximize', icon: [512, 512, [], "f2d0", "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"] };
var faWindowMinimize = { prefix: 'fas', iconName: 'window-minimize', icon: [512, 512, [], "f2d1", "M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"] };
var faWindowRestore = { prefix: 'fas', iconName: 'window-restore', icon: [512, 512, [], "f2d2", "M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"] };
var faWineGlass = { prefix: 'fas', iconName: 'wine-glass', icon: [288, 512, [], "f4e3", "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"] };
var faWineGlassAlt = { prefix: 'fas', iconName: 'wine-glass-alt', icon: [288, 512, [], "f5ce", "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"] };
var faWonSign = { prefix: 'fas', iconName: 'won-sign', icon: [576, 512, [], "f159", "M564 192c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-48.028l18.572-80.61c1.732-7.518-3.978-14.694-11.693-14.694h-46.107a11.998 11.998 0 0 0-11.736 9.5L450.73 128H340.839l-19.725-85.987a12 12 0 0 0-11.696-9.317H265.43a12 12 0 0 0-11.687 9.277L233.696 128H124.975L107.5 42.299a12 12 0 0 0-11.758-9.602H53.628c-7.686 0-13.39 7.124-11.709 14.624L60 128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h62.342l7.171 32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h83.856l40.927 182.624A12 12 0 0 0 148.492 480h56.767c5.583 0 10.428-3.85 11.689-9.288L259.335 288h55.086l42.386 182.712A12 12 0 0 0 368.496 480h56.826a12 12 0 0 0 11.694-9.306L479.108 288H564c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-70.146l7.373-32H564zm-425.976 0h80.757l-7.457 32h-66.776l-6.524-32zm45.796 150.029c-6.194 25.831-6.758 47.25-7.321 47.25h-1.126s-1.689-22.05-6.758-47.25L157.599 288h38.812l-12.591 54.029zM274.182 224l1.996-8.602c1.856-7.962 3.457-15.968 4.803-23.398h11.794c1.347 7.43 2.947 15.436 4.803 23.398l1.996 8.602h-25.392zm130.959 118.029c-5.068 25.2-6.758 47.25-6.758 47.25h-1.126c-.563 0-1.126-21.42-7.321-47.25L377.542 288h39.107l-11.508 54.029zM430.281 224h-67.42l-7.34-32h81.577l-6.817 32z"] };
var faWrench = { prefix: 'fas', iconName: 'wrench', icon: [512, 512, [], "f0ad", "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"] };
var faXRay = { prefix: 'fas', iconName: 'x-ray', icon: [640, 512, [], "f497", "M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"] };
var faYenSign = { prefix: 'fas', iconName: 'yen-sign', icon: [384, 512, [], "f157", "M351.208 32h-65.277a12 12 0 0 0-10.778 6.724l-55.39 113.163c-14.513 34.704-27.133 71.932-27.133 71.932h-1.262s-12.62-37.228-27.133-71.932l-55.39-113.163A11.997 11.997 0 0 0 98.068 32H32.792c-9.057 0-14.85 9.65-10.59 17.643L102.322 200H44c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h88.162L152 293.228V320H44c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h108v92c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-92h108c6.627 0 12-5.373 12-12v-32c0-6.627-5.373-12-12-12H232v-26.772L251.838 256H340c6.627 0 12-5.373 12-12v-32c0-6.627-5.373-12-12-12h-58.322l80.12-150.357C366.058 41.65 360.266 32 351.208 32z"] };
var faYinYang = { prefix: 'fas', iconName: 'yin-yang', icon: [496, 512, [], "f6ad", "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"] };
var _iconsCache = {
  faAd: faAd,
  faAddressBook: faAddressBook,
  faAddressCard: faAddressCard,
  faAdjust: faAdjust,
  faAirFreshener: faAirFreshener,
  faAlignCenter: faAlignCenter,
  faAlignJustify: faAlignJustify,
  faAlignLeft: faAlignLeft,
  faAlignRight: faAlignRight,
  faAllergies: faAllergies,
  faAmbulance: faAmbulance,
  faAmericanSignLanguageInterpreting: faAmericanSignLanguageInterpreting,
  faAnchor: faAnchor,
  faAngleDoubleDown: faAngleDoubleDown,
  faAngleDoubleLeft: faAngleDoubleLeft,
  faAngleDoubleRight: faAngleDoubleRight,
  faAngleDoubleUp: faAngleDoubleUp,
  faAngleDown: faAngleDown,
  faAngleLeft: faAngleLeft,
  faAngleRight: faAngleRight,
  faAngleUp: faAngleUp,
  faAngry: faAngry,
  faAnkh: faAnkh,
  faAppleAlt: faAppleAlt,
  faArchive: faArchive,
  faArchway: faArchway,
  faArrowAltCircleDown: faArrowAltCircleDown,
  faArrowAltCircleLeft: faArrowAltCircleLeft,
  faArrowAltCircleRight: faArrowAltCircleRight,
  faArrowAltCircleUp: faArrowAltCircleUp,
  faArrowCircleDown: faArrowCircleDown,
  faArrowCircleLeft: faArrowCircleLeft,
  faArrowCircleRight: faArrowCircleRight,
  faArrowCircleUp: faArrowCircleUp,
  faArrowDown: faArrowDown,
  faArrowLeft: faArrowLeft,
  faArrowRight: faArrowRight,
  faArrowUp: faArrowUp,
  faArrowsAlt: faArrowsAlt,
  faArrowsAltH: faArrowsAltH,
  faArrowsAltV: faArrowsAltV,
  faAssistiveListeningSystems: faAssistiveListeningSystems,
  faAsterisk: faAsterisk,
  faAt: faAt,
  faAtlas: faAtlas,
  faAtom: faAtom,
  faAudioDescription: faAudioDescription,
  faAward: faAward,
  faBackspace: faBackspace,
  faBackward: faBackward,
  faBalanceScale: faBalanceScale,
  faBan: faBan,
  faBandAid: faBandAid,
  faBarcode: faBarcode,
  faBars: faBars,
  faBaseballBall: faBaseballBall,
  faBasketballBall: faBasketballBall,
  faBath: faBath,
  faBatteryEmpty: faBatteryEmpty,
  faBatteryFull: faBatteryFull,
  faBatteryHalf: faBatteryHalf,
  faBatteryQuarter: faBatteryQuarter,
  faBatteryThreeQuarters: faBatteryThreeQuarters,
  faBed: faBed,
  faBeer: faBeer,
  faBell: faBell,
  faBellSlash: faBellSlash,
  faBezierCurve: faBezierCurve,
  faBible: faBible,
  faBicycle: faBicycle,
  faBinoculars: faBinoculars,
  faBirthdayCake: faBirthdayCake,
  faBlender: faBlender,
  faBlind: faBlind,
  faBold: faBold,
  faBolt: faBolt,
  faBomb: faBomb,
  faBone: faBone,
  faBong: faBong,
  faBook: faBook,
  faBookOpen: faBookOpen,
  faBookReader: faBookReader,
  faBookmark: faBookmark,
  faBowlingBall: faBowlingBall,
  faBox: faBox,
  faBoxOpen: faBoxOpen,
  faBoxes: faBoxes,
  faBraille: faBraille,
  faBrain: faBrain,
  faBriefcase: faBriefcase,
  faBriefcaseMedical: faBriefcaseMedical,
  faBroadcastTower: faBroadcastTower,
  faBroom: faBroom,
  faBrush: faBrush,
  faBug: faBug,
  faBuilding: faBuilding,
  faBullhorn: faBullhorn,
  faBullseye: faBullseye,
  faBurn: faBurn,
  faBus: faBus,
  faBusAlt: faBusAlt,
  faBusinessTime: faBusinessTime,
  faCalculator: faCalculator,
  faCalendar: faCalendar,
  faCalendarAlt: faCalendarAlt,
  faCalendarCheck: faCalendarCheck,
  faCalendarMinus: faCalendarMinus,
  faCalendarPlus: faCalendarPlus,
  faCalendarTimes: faCalendarTimes,
  faCamera: faCamera,
  faCameraRetro: faCameraRetro,
  faCannabis: faCannabis,
  faCapsules: faCapsules,
  faCar: faCar,
  faCarAlt: faCarAlt,
  faCarBattery: faCarBattery,
  faCarCrash: faCarCrash,
  faCarSide: faCarSide,
  faCaretDown: faCaretDown,
  faCaretLeft: faCaretLeft,
  faCaretRight: faCaretRight,
  faCaretSquareDown: faCaretSquareDown,
  faCaretSquareLeft: faCaretSquareLeft,
  faCaretSquareRight: faCaretSquareRight,
  faCaretSquareUp: faCaretSquareUp,
  faCaretUp: faCaretUp,
  faCartArrowDown: faCartArrowDown,
  faCartPlus: faCartPlus,
  faCertificate: faCertificate,
  faChalkboard: faChalkboard,
  faChalkboardTeacher: faChalkboardTeacher,
  faChargingStation: faChargingStation,
  faChartArea: faChartArea,
  faChartBar: faChartBar,
  faChartLine: faChartLine,
  faChartPie: faChartPie,
  faCheck: faCheck,
  faCheckCircle: faCheckCircle,
  faCheckDouble: faCheckDouble,
  faCheckSquare: faCheckSquare,
  faChess: faChess,
  faChessBishop: faChessBishop,
  faChessBoard: faChessBoard,
  faChessKing: faChessKing,
  faChessKnight: faChessKnight,
  faChessPawn: faChessPawn,
  faChessQueen: faChessQueen,
  faChessRook: faChessRook,
  faChevronCircleDown: faChevronCircleDown,
  faChevronCircleLeft: faChevronCircleLeft,
  faChevronCircleRight: faChevronCircleRight,
  faChevronCircleUp: faChevronCircleUp,
  faChevronDown: faChevronDown,
  faChevronLeft: faChevronLeft,
  faChevronRight: faChevronRight,
  faChevronUp: faChevronUp,
  faChild: faChild,
  faChurch: faChurch,
  faCircle: faCircle,
  faCircleNotch: faCircleNotch,
  faCity: faCity,
  faClipboard: faClipboard,
  faClipboardCheck: faClipboardCheck,
  faClipboardList: faClipboardList,
  faClock: faClock,
  faClone: faClone,
  faClosedCaptioning: faClosedCaptioning,
  faCloud: faCloud,
  faCloudDownloadAlt: faCloudDownloadAlt,
  faCloudUploadAlt: faCloudUploadAlt,
  faCocktail: faCocktail,
  faCode: faCode,
  faCodeBranch: faCodeBranch,
  faCoffee: faCoffee,
  faCog: faCog,
  faCogs: faCogs,
  faCoins: faCoins,
  faColumns: faColumns,
  faComment: faComment,
  faCommentAlt: faCommentAlt,
  faCommentDollar: faCommentDollar,
  faCommentDots: faCommentDots,
  faCommentSlash: faCommentSlash,
  faComments: faComments,
  faCommentsDollar: faCommentsDollar,
  faCompactDisc: faCompactDisc,
  faCompass: faCompass,
  faCompress: faCompress,
  faConciergeBell: faConciergeBell,
  faCookie: faCookie,
  faCookieBite: faCookieBite,
  faCopy: faCopy,
  faCopyright: faCopyright,
  faCouch: faCouch,
  faCreditCard: faCreditCard,
  faCrop: faCrop,
  faCropAlt: faCropAlt,
  faCross: faCross,
  faCrosshairs: faCrosshairs,
  faCrow: faCrow,
  faCrown: faCrown,
  faCube: faCube,
  faCubes: faCubes,
  faCut: faCut,
  faDatabase: faDatabase,
  faDeaf: faDeaf,
  faDesktop: faDesktop,
  faDharmachakra: faDharmachakra,
  faDiagnoses: faDiagnoses,
  faDice: faDice,
  faDiceFive: faDiceFive,
  faDiceFour: faDiceFour,
  faDiceOne: faDiceOne,
  faDiceSix: faDiceSix,
  faDiceThree: faDiceThree,
  faDiceTwo: faDiceTwo,
  faDigitalTachograph: faDigitalTachograph,
  faDirections: faDirections,
  faDivide: faDivide,
  faDizzy: faDizzy,
  faDna: faDna,
  faDollarSign: faDollarSign,
  faDolly: faDolly,
  faDollyFlatbed: faDollyFlatbed,
  faDonate: faDonate,
  faDoorClosed: faDoorClosed,
  faDoorOpen: faDoorOpen,
  faDotCircle: faDotCircle,
  faDove: faDove,
  faDownload: faDownload,
  faDraftingCompass: faDraftingCompass,
  faDrawPolygon: faDrawPolygon,
  faDrum: faDrum,
  faDrumSteelpan: faDrumSteelpan,
  faDumbbell: faDumbbell,
  faEdit: faEdit,
  faEject: faEject,
  faEllipsisH: faEllipsisH,
  faEllipsisV: faEllipsisV,
  faEnvelope: faEnvelope,
  faEnvelopeOpen: faEnvelopeOpen,
  faEnvelopeOpenText: faEnvelopeOpenText,
  faEnvelopeSquare: faEnvelopeSquare,
  faEquals: faEquals,
  faEraser: faEraser,
  faEuroSign: faEuroSign,
  faExchangeAlt: faExchangeAlt,
  faExclamation: faExclamation,
  faExclamationCircle: faExclamationCircle,
  faExclamationTriangle: faExclamationTriangle,
  faExpand: faExpand,
  faExpandArrowsAlt: faExpandArrowsAlt,
  faExternalLinkAlt: faExternalLinkAlt,
  faExternalLinkSquareAlt: faExternalLinkSquareAlt,
  faEye: faEye,
  faEyeDropper: faEyeDropper,
  faEyeSlash: faEyeSlash,
  faFastBackward: faFastBackward,
  faFastForward: faFastForward,
  faFax: faFax,
  faFeather: faFeather,
  faFeatherAlt: faFeatherAlt,
  faFemale: faFemale,
  faFighterJet: faFighterJet,
  faFile: faFile,
  faFileAlt: faFileAlt,
  faFileArchive: faFileArchive,
  faFileAudio: faFileAudio,
  faFileCode: faFileCode,
  faFileContract: faFileContract,
  faFileDownload: faFileDownload,
  faFileExcel: faFileExcel,
  faFileExport: faFileExport,
  faFileImage: faFileImage,
  faFileImport: faFileImport,
  faFileInvoice: faFileInvoice,
  faFileInvoiceDollar: faFileInvoiceDollar,
  faFileMedical: faFileMedical,
  faFileMedicalAlt: faFileMedicalAlt,
  faFilePdf: faFilePdf,
  faFilePowerpoint: faFilePowerpoint,
  faFilePrescription: faFilePrescription,
  faFileSignature: faFileSignature,
  faFileUpload: faFileUpload,
  faFileVideo: faFileVideo,
  faFileWord: faFileWord,
  faFill: faFill,
  faFillDrip: faFillDrip,
  faFilm: faFilm,
  faFilter: faFilter,
  faFingerprint: faFingerprint,
  faFire: faFire,
  faFireExtinguisher: faFireExtinguisher,
  faFirstAid: faFirstAid,
  faFish: faFish,
  faFlag: faFlag,
  faFlagCheckered: faFlagCheckered,
  faFlask: faFlask,
  faFlushed: faFlushed,
  faFolder: faFolder,
  faFolderMinus: faFolderMinus,
  faFolderOpen: faFolderOpen,
  faFolderPlus: faFolderPlus,
  faFont: faFont,
  faFontAwesomeLogoFull: faFontAwesomeLogoFull,
  faFootballBall: faFootballBall,
  faForward: faForward,
  faFrog: faFrog,
  faFrown: faFrown,
  faFrownOpen: faFrownOpen,
  faFunnelDollar: faFunnelDollar,
  faFutbol: faFutbol,
  faGamepad: faGamepad,
  faGasPump: faGasPump,
  faGavel: faGavel,
  faGem: faGem,
  faGenderless: faGenderless,
  faGift: faGift,
  faGlassMartini: faGlassMartini,
  faGlassMartiniAlt: faGlassMartiniAlt,
  faGlasses: faGlasses,
  faGlobe: faGlobe,
  faGlobeAfrica: faGlobeAfrica,
  faGlobeAmericas: faGlobeAmericas,
  faGlobeAsia: faGlobeAsia,
  faGolfBall: faGolfBall,
  faGopuram: faGopuram,
  faGraduationCap: faGraduationCap,
  faGreaterThan: faGreaterThan,
  faGreaterThanEqual: faGreaterThanEqual,
  faGrimace: faGrimace,
  faGrin: faGrin,
  faGrinAlt: faGrinAlt,
  faGrinBeam: faGrinBeam,
  faGrinBeamSweat: faGrinBeamSweat,
  faGrinHearts: faGrinHearts,
  faGrinSquint: faGrinSquint,
  faGrinSquintTears: faGrinSquintTears,
  faGrinStars: faGrinStars,
  faGrinTears: faGrinTears,
  faGrinTongue: faGrinTongue,
  faGrinTongueSquint: faGrinTongueSquint,
  faGrinTongueWink: faGrinTongueWink,
  faGrinWink: faGrinWink,
  faGripHorizontal: faGripHorizontal,
  faGripVertical: faGripVertical,
  faHSquare: faHSquare,
  faHamsa: faHamsa,
  faHandHolding: faHandHolding,
  faHandHoldingHeart: faHandHoldingHeart,
  faHandHoldingUsd: faHandHoldingUsd,
  faHandLizard: faHandLizard,
  faHandPaper: faHandPaper,
  faHandPeace: faHandPeace,
  faHandPointDown: faHandPointDown,
  faHandPointLeft: faHandPointLeft,
  faHandPointRight: faHandPointRight,
  faHandPointUp: faHandPointUp,
  faHandPointer: faHandPointer,
  faHandRock: faHandRock,
  faHandScissors: faHandScissors,
  faHandSpock: faHandSpock,
  faHands: faHands,
  faHandsHelping: faHandsHelping,
  faHandshake: faHandshake,
  faHashtag: faHashtag,
  faHaykal: faHaykal,
  faHdd: faHdd,
  faHeading: faHeading,
  faHeadphones: faHeadphones,
  faHeadphonesAlt: faHeadphonesAlt,
  faHeadset: faHeadset,
  faHeart: faHeart,
  faHeartbeat: faHeartbeat,
  faHelicopter: faHelicopter,
  faHighlighter: faHighlighter,
  faHistory: faHistory,
  faHockeyPuck: faHockeyPuck,
  faHome: faHome,
  faHospital: faHospital,
  faHospitalAlt: faHospitalAlt,
  faHospitalSymbol: faHospitalSymbol,
  faHotTub: faHotTub,
  faHotel: faHotel,
  faHourglass: faHourglass,
  faHourglassEnd: faHourglassEnd,
  faHourglassHalf: faHourglassHalf,
  faHourglassStart: faHourglassStart,
  faICursor: faICursor,
  faIdBadge: faIdBadge,
  faIdCard: faIdCard,
  faIdCardAlt: faIdCardAlt,
  faImage: faImage,
  faImages: faImages,
  faInbox: faInbox,
  faIndent: faIndent,
  faIndustry: faIndustry,
  faInfinity: faInfinity,
  faInfo: faInfo,
  faInfoCircle: faInfoCircle,
  faItalic: faItalic,
  faJedi: faJedi,
  faJoint: faJoint,
  faJournalWhills: faJournalWhills,
  faKaaba: faKaaba,
  faKey: faKey,
  faKeyboard: faKeyboard,
  faKhanda: faKhanda,
  faKiss: faKiss,
  faKissBeam: faKissBeam,
  faKissWinkHeart: faKissWinkHeart,
  faKiwiBird: faKiwiBird,
  faLandmark: faLandmark,
  faLanguage: faLanguage,
  faLaptop: faLaptop,
  faLaptopCode: faLaptopCode,
  faLaugh: faLaugh,
  faLaughBeam: faLaughBeam,
  faLaughSquint: faLaughSquint,
  faLaughWink: faLaughWink,
  faLayerGroup: faLayerGroup,
  faLeaf: faLeaf,
  faLemon: faLemon,
  faLessThan: faLessThan,
  faLessThanEqual: faLessThanEqual,
  faLevelDownAlt: faLevelDownAlt,
  faLevelUpAlt: faLevelUpAlt,
  faLifeRing: faLifeRing,
  faLightbulb: faLightbulb,
  faLink: faLink,
  faLiraSign: faLiraSign,
  faList: faList,
  faListAlt: faListAlt,
  faListOl: faListOl,
  faListUl: faListUl,
  faLocationArrow: faLocationArrow,
  faLock: faLock,
  faLockOpen: faLockOpen,
  faLongArrowAltDown: faLongArrowAltDown,
  faLongArrowAltLeft: faLongArrowAltLeft,
  faLongArrowAltRight: faLongArrowAltRight,
  faLongArrowAltUp: faLongArrowAltUp,
  faLowVision: faLowVision,
  faLuggageCart: faLuggageCart,
  faMagic: faMagic,
  faMagnet: faMagnet,
  faMailBulk: faMailBulk,
  faMale: faMale,
  faMap: faMap,
  faMapMarked: faMapMarked,
  faMapMarkedAlt: faMapMarkedAlt,
  faMapMarker: faMapMarker,
  faMapMarkerAlt: faMapMarkerAlt,
  faMapPin: faMapPin,
  faMapSigns: faMapSigns,
  faMarker: faMarker,
  faMars: faMars,
  faMarsDouble: faMarsDouble,
  faMarsStroke: faMarsStroke,
  faMarsStrokeH: faMarsStrokeH,
  faMarsStrokeV: faMarsStrokeV,
  faMedal: faMedal,
  faMedkit: faMedkit,
  faMeh: faMeh,
  faMehBlank: faMehBlank,
  faMehRollingEyes: faMehRollingEyes,
  faMemory: faMemory,
  faMenorah: faMenorah,
  faMercury: faMercury,
  faMicrochip: faMicrochip,
  faMicrophone: faMicrophone,
  faMicrophoneAlt: faMicrophoneAlt,
  faMicrophoneAltSlash: faMicrophoneAltSlash,
  faMicrophoneSlash: faMicrophoneSlash,
  faMicroscope: faMicroscope,
  faMinus: faMinus,
  faMinusCircle: faMinusCircle,
  faMinusSquare: faMinusSquare,
  faMobile: faMobile,
  faMobileAlt: faMobileAlt,
  faMoneyBill: faMoneyBill,
  faMoneyBillAlt: faMoneyBillAlt,
  faMoneyBillWave: faMoneyBillWave,
  faMoneyBillWaveAlt: faMoneyBillWaveAlt,
  faMoneyCheck: faMoneyCheck,
  faMoneyCheckAlt: faMoneyCheckAlt,
  faMonument: faMonument,
  faMoon: faMoon,
  faMortarPestle: faMortarPestle,
  faMosque: faMosque,
  faMotorcycle: faMotorcycle,
  faMousePointer: faMousePointer,
  faMusic: faMusic,
  faNeuter: faNeuter,
  faNewspaper: faNewspaper,
  faNotEqual: faNotEqual,
  faNotesMedical: faNotesMedical,
  faObjectGroup: faObjectGroup,
  faObjectUngroup: faObjectUngroup,
  faOilCan: faOilCan,
  faOm: faOm,
  faOutdent: faOutdent,
  faPaintBrush: faPaintBrush,
  faPaintRoller: faPaintRoller,
  faPalette: faPalette,
  faPallet: faPallet,
  faPaperPlane: faPaperPlane,
  faPaperclip: faPaperclip,
  faParachuteBox: faParachuteBox,
  faParagraph: faParagraph,
  faParking: faParking,
  faPassport: faPassport,
  faPastafarianism: faPastafarianism,
  faPaste: faPaste,
  faPause: faPause,
  faPauseCircle: faPauseCircle,
  faPaw: faPaw,
  faPeace: faPeace,
  faPen: faPen,
  faPenAlt: faPenAlt,
  faPenFancy: faPenFancy,
  faPenNib: faPenNib,
  faPenSquare: faPenSquare,
  faPencilAlt: faPencilAlt,
  faPencilRuler: faPencilRuler,
  faPeopleCarry: faPeopleCarry,
  faPercent: faPercent,
  faPercentage: faPercentage,
  faPhone: faPhone,
  faPhoneSlash: faPhoneSlash,
  faPhoneSquare: faPhoneSquare,
  faPhoneVolume: faPhoneVolume,
  faPiggyBank: faPiggyBank,
  faPills: faPills,
  faPlaceOfWorship: faPlaceOfWorship,
  faPlane: faPlane,
  faPlaneArrival: faPlaneArrival,
  faPlaneDeparture: faPlaneDeparture,
  faPlay: faPlay,
  faPlayCircle: faPlayCircle,
  faPlug: faPlug,
  faPlus: faPlus,
  faPlusCircle: faPlusCircle,
  faPlusSquare: faPlusSquare,
  faPodcast: faPodcast,
  faPoll: faPoll,
  faPollH: faPollH,
  faPoo: faPoo,
  faPoop: faPoop,
  faPortrait: faPortrait,
  faPoundSign: faPoundSign,
  faPowerOff: faPowerOff,
  faPray: faPray,
  faPrayingHands: faPrayingHands,
  faPrescription: faPrescription,
  faPrescriptionBottle: faPrescriptionBottle,
  faPrescriptionBottleAlt: faPrescriptionBottleAlt,
  faPrint: faPrint,
  faProcedures: faProcedures,
  faProjectDiagram: faProjectDiagram,
  faPuzzlePiece: faPuzzlePiece,
  faQrcode: faQrcode,
  faQuestion: faQuestion,
  faQuestionCircle: faQuestionCircle,
  faQuidditch: faQuidditch,
  faQuoteLeft: faQuoteLeft,
  faQuoteRight: faQuoteRight,
  faQuran: faQuran,
  faRandom: faRandom,
  faReceipt: faReceipt,
  faRecycle: faRecycle,
  faRedo: faRedo,
  faRedoAlt: faRedoAlt,
  faRegistered: faRegistered,
  faReply: faReply,
  faReplyAll: faReplyAll,
  faRetweet: faRetweet,
  faRibbon: faRibbon,
  faRoad: faRoad,
  faRobot: faRobot,
  faRocket: faRocket,
  faRoute: faRoute,
  faRss: faRss,
  faRssSquare: faRssSquare,
  faRubleSign: faRubleSign,
  faRuler: faRuler,
  faRulerCombined: faRulerCombined,
  faRulerHorizontal: faRulerHorizontal,
  faRulerVertical: faRulerVertical,
  faRupeeSign: faRupeeSign,
  faSadCry: faSadCry,
  faSadTear: faSadTear,
  faSave: faSave,
  faSchool: faSchool,
  faScrewdriver: faScrewdriver,
  faSearch: faSearch,
  faSearchDollar: faSearchDollar,
  faSearchLocation: faSearchLocation,
  faSearchMinus: faSearchMinus,
  faSearchPlus: faSearchPlus,
  faSeedling: faSeedling,
  faServer: faServer,
  faShapes: faShapes,
  faShare: faShare,
  faShareAlt: faShareAlt,
  faShareAltSquare: faShareAltSquare,
  faShareSquare: faShareSquare,
  faShekelSign: faShekelSign,
  faShieldAlt: faShieldAlt,
  faShip: faShip,
  faShippingFast: faShippingFast,
  faShoePrints: faShoePrints,
  faShoppingBag: faShoppingBag,
  faShoppingBasket: faShoppingBasket,
  faShoppingCart: faShoppingCart,
  faShower: faShower,
  faShuttleVan: faShuttleVan,
  faSign: faSign,
  faSignInAlt: faSignInAlt,
  faSignLanguage: faSignLanguage,
  faSignOutAlt: faSignOutAlt,
  faSignal: faSignal,
  faSignature: faSignature,
  faSitemap: faSitemap,
  faSkull: faSkull,
  faSlidersH: faSlidersH,
  faSmile: faSmile,
  faSmileBeam: faSmileBeam,
  faSmileWink: faSmileWink,
  faSmoking: faSmoking,
  faSmokingBan: faSmokingBan,
  faSnowflake: faSnowflake,
  faSocks: faSocks,
  faSolarPanel: faSolarPanel,
  faSort: faSort,
  faSortAlphaDown: faSortAlphaDown,
  faSortAlphaUp: faSortAlphaUp,
  faSortAmountDown: faSortAmountDown,
  faSortAmountUp: faSortAmountUp,
  faSortDown: faSortDown,
  faSortNumericDown: faSortNumericDown,
  faSortNumericUp: faSortNumericUp,
  faSortUp: faSortUp,
  faSpa: faSpa,
  faSpaceShuttle: faSpaceShuttle,
  faSpinner: faSpinner,
  faSplotch: faSplotch,
  faSprayCan: faSprayCan,
  faSquare: faSquare,
  faSquareFull: faSquareFull,
  faSquareRootAlt: faSquareRootAlt,
  faStamp: faStamp,
  faStar: faStar,
  faStarAndCrescent: faStarAndCrescent,
  faStarHalf: faStarHalf,
  faStarHalfAlt: faStarHalfAlt,
  faStarOfDavid: faStarOfDavid,
  faStarOfLife: faStarOfLife,
  faStepBackward: faStepBackward,
  faStepForward: faStepForward,
  faStethoscope: faStethoscope,
  faStickyNote: faStickyNote,
  faStop: faStop,
  faStopCircle: faStopCircle,
  faStopwatch: faStopwatch,
  faStore: faStore,
  faStoreAlt: faStoreAlt,
  faStream: faStream,
  faStreetView: faStreetView,
  faStrikethrough: faStrikethrough,
  faStroopwafel: faStroopwafel,
  faSubscript: faSubscript,
  faSubway: faSubway,
  faSuitcase: faSuitcase,
  faSuitcaseRolling: faSuitcaseRolling,
  faSun: faSun,
  faSuperscript: faSuperscript,
  faSurprise: faSurprise,
  faSwatchbook: faSwatchbook,
  faSwimmer: faSwimmer,
  faSwimmingPool: faSwimmingPool,
  faSynagogue: faSynagogue,
  faSync: faSync,
  faSyncAlt: faSyncAlt,
  faSyringe: faSyringe,
  faTable: faTable,
  faTableTennis: faTableTennis,
  faTablet: faTablet,
  faTabletAlt: faTabletAlt,
  faTablets: faTablets,
  faTachometerAlt: faTachometerAlt,
  faTag: faTag,
  faTags: faTags,
  faTape: faTape,
  faTasks: faTasks,
  faTaxi: faTaxi,
  faTeeth: faTeeth,
  faTeethOpen: faTeethOpen,
  faTerminal: faTerminal,
  faTextHeight: faTextHeight,
  faTextWidth: faTextWidth,
  faTh: faTh,
  faThLarge: faThLarge,
  faThList: faThList,
  faTheaterMasks: faTheaterMasks,
  faThermometer: faThermometer,
  faThermometerEmpty: faThermometerEmpty,
  faThermometerFull: faThermometerFull,
  faThermometerHalf: faThermometerHalf,
  faThermometerQuarter: faThermometerQuarter,
  faThermometerThreeQuarters: faThermometerThreeQuarters,
  faThumbsDown: faThumbsDown,
  faThumbsUp: faThumbsUp,
  faThumbtack: faThumbtack,
  faTicketAlt: faTicketAlt,
  faTimes: faTimes,
  faTimesCircle: faTimesCircle,
  faTint: faTint,
  faTintSlash: faTintSlash,
  faTired: faTired,
  faToggleOff: faToggleOff,
  faToggleOn: faToggleOn,
  faToolbox: faToolbox,
  faTooth: faTooth,
  faTorah: faTorah,
  faToriiGate: faToriiGate,
  faTrademark: faTrademark,
  faTrafficLight: faTrafficLight,
  faTrain: faTrain,
  faTransgender: faTransgender,
  faTransgenderAlt: faTransgenderAlt,
  faTrash: faTrash,
  faTrashAlt: faTrashAlt,
  faTree: faTree,
  faTrophy: faTrophy,
  faTruck: faTruck,
  faTruckLoading: faTruckLoading,
  faTruckMonster: faTruckMonster,
  faTruckMoving: faTruckMoving,
  faTruckPickup: faTruckPickup,
  faTshirt: faTshirt,
  faTty: faTty,
  faTv: faTv,
  faUmbrella: faUmbrella,
  faUmbrellaBeach: faUmbrellaBeach,
  faUnderline: faUnderline,
  faUndo: faUndo,
  faUndoAlt: faUndoAlt,
  faUniversalAccess: faUniversalAccess,
  faUniversity: faUniversity,
  faUnlink: faUnlink,
  faUnlock: faUnlock,
  faUnlockAlt: faUnlockAlt,
  faUpload: faUpload,
  faUser: faUser,
  faUserAlt: faUserAlt,
  faUserAltSlash: faUserAltSlash,
  faUserAstronaut: faUserAstronaut,
  faUserCheck: faUserCheck,
  faUserCircle: faUserCircle,
  faUserClock: faUserClock,
  faUserCog: faUserCog,
  faUserEdit: faUserEdit,
  faUserFriends: faUserFriends,
  faUserGraduate: faUserGraduate,
  faUserLock: faUserLock,
  faUserMd: faUserMd,
  faUserMinus: faUserMinus,
  faUserNinja: faUserNinja,
  faUserPlus: faUserPlus,
  faUserSecret: faUserSecret,
  faUserShield: faUserShield,
  faUserSlash: faUserSlash,
  faUserTag: faUserTag,
  faUserTie: faUserTie,
  faUserTimes: faUserTimes,
  faUsers: faUsers,
  faUsersCog: faUsersCog,
  faUtensilSpoon: faUtensilSpoon,
  faUtensils: faUtensils,
  faVectorSquare: faVectorSquare,
  faVenus: faVenus,
  faVenusDouble: faVenusDouble,
  faVenusMars: faVenusMars,
  faVial: faVial,
  faVials: faVials,
  faVideo: faVideo,
  faVideoSlash: faVideoSlash,
  faVihara: faVihara,
  faVolleyballBall: faVolleyballBall,
  faVolumeDown: faVolumeDown,
  faVolumeOff: faVolumeOff,
  faVolumeUp: faVolumeUp,
  faWalking: faWalking,
  faWallet: faWallet,
  faWarehouse: faWarehouse,
  faWeight: faWeight,
  faWeightHanging: faWeightHanging,
  faWheelchair: faWheelchair,
  faWifi: faWifi,
  faWindowClose: faWindowClose,
  faWindowMaximize: faWindowMaximize,
  faWindowMinimize: faWindowMinimize,
  faWindowRestore: faWindowRestore,
  faWineGlass: faWineGlass,
  faWineGlassAlt: faWineGlassAlt,
  faWonSign: faWonSign,
  faWrench: faWrench,
  faXRay: faXRay,
  faYenSign: faYenSign,
  faYinYang: faYinYang
};




/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FontAwesomeIcon", function() { return FontAwesomeIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);




var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var humps = createCommonjsModule(function (module) {
(function(global) {

  var _processKeys = function(convert, obj, options) {
    if(!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
      return obj;
    }

    var output,
        i = 0,
        l = 0;

    if(_isArray(obj)) {
      output = [];
      for(l=obj.length; i<l; i++) {
        output.push(_processKeys(convert, obj[i], options));
      }
    }
    else {
      output = {};
      for(var key in obj) {
        if(Object.prototype.hasOwnProperty.call(obj, key)) {
          output[convert(key, options)] = _processKeys(convert, obj[key], options);
        }
      }
    }
    return output;
  };

  // String conversion methods

  var separateWords = function(string, options) {
    options = options || {};
    var separator = options.separator || '_';
    var split = options.split || /(?=[A-Z])/;

    return string.split(split).join(separator);
  };

  var camelize = function(string) {
    if (_isNumerical(string)) {
      return string;
    }
    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
      return chr ? chr.toUpperCase() : '';
    });
    // Ensure 1st char is always lowercase
    return string.substr(0, 1).toLowerCase() + string.substr(1);
  };

  var pascalize = function(string) {
    var camelized = camelize(string);
    // Ensure 1st char is always uppercase
    return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
  };

  var decamelize = function(string, options) {
    return separateWords(string, options).toLowerCase();
  };

  // Utilities
  // Taken from Underscore.js

  var toString = Object.prototype.toString;

  var _isFunction = function(obj) {
    return typeof(obj) === 'function';
  };
  var _isObject = function(obj) {
    return obj === Object(obj);
  };
  var _isArray = function(obj) {
    return toString.call(obj) == '[object Array]';
  };
  var _isDate = function(obj) {
    return toString.call(obj) == '[object Date]';
  };
  var _isRegExp = function(obj) {
    return toString.call(obj) == '[object RegExp]';
  };
  var _isBoolean = function(obj) {
    return toString.call(obj) == '[object Boolean]';
  };

  // Performant way to determine if obj coerces to a number
  var _isNumerical = function(obj) {
    obj = obj - 0;
    return obj === obj;
  };

  // Sets up function which handles processing keys
  // allowing the convert function to be modified by a callback
  var _processor = function(convert, options) {
    var callback = options && 'process' in options ? options.process : options;

    if(typeof(callback) !== 'function') {
      return convert;
    }

    return function(string, options) {
      return callback(string, convert, options);
    }
  };

  var humps = {
    camelize: camelize,
    decamelize: decamelize,
    pascalize: pascalize,
    depascalize: decamelize,
    camelizeKeys: function(object, options) {
      return _processKeys(_processor(camelize, options), object);
    },
    decamelizeKeys: function(object, options) {
      return _processKeys(_processor(decamelize, options), object, options);
    },
    pascalizeKeys: function(object, options) {
      return _processKeys(_processor(pascalize, options), object);
    },
    depascalizeKeys: function () {
      return this.decamelizeKeys.apply(this, arguments);
    }
  };

  if (false) {
    undefined(humps);
  } else if ('object' !== 'undefined' && module.exports) {
    module.exports = humps;
  } else {
    global.humps = humps;
  }

})(commonjsGlobal);
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

function capitalize(val) {
  return val.charAt(0).toUpperCase() + val.slice(1);
}

function styleToObject(style) {
  return style.split(';').map(function (s) {
    return s.trim();
  }).filter(function (s) {
    return s;
  }).reduce(function (acc, pair) {
    var i = pair.indexOf(':');
    var prop = humps.camelize(pair.slice(0, i));
    var value = pair.slice(i + 1).trim();

    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;

    return acc;
  }, {});
}

function convert(createElement, element) {
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var children = (element.children || []).map(convert.bind(null, createElement));

  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
    var val = element.attributes[key];

    switch (key) {
      case 'class':
        acc.attrs['className'] = val;
        delete element.attributes['class'];
        break;
      case 'style':
        acc.attrs['style'] = styleToObject(val);
        break;
      default:
        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
          acc.attrs[key.toLowerCase()] = val;
        } else {
          acc.attrs[humps.camelize(key)] = val;
        }
    }

    return acc;
  }, { attrs: {} });

  var _extraProps$style = extraProps.style,
      existingStyle = _extraProps$style === undefined ? {} : _extraProps$style,
      remaining = objectWithoutProperties(extraProps, ['style']);


  mixins.attrs['style'] = _extends({}, mixins.attrs['style'], existingStyle);

  return createElement.apply(undefined, [element.tag, _extends({}, mixins.attrs, remaining)].concat(toConsumableArray(children)));
}

var PRODUCTION = false;

try {
  PRODUCTION = process.env.NODE_ENV === 'production';
} catch (e) {}

function log () {
  if (!PRODUCTION && console && typeof console.error === 'function') {
    var _console;

    (_console = console).error.apply(_console, arguments);
  }
}

function objectWithKey(key, value) {
  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? defineProperty({}, key, value) : {};
}

function classList(props) {
  var _classes;

  var classes = (_classes = {
    'fa-spin': props.spin,
    'fa-pulse': props.pulse,
    'fa-fw': props.fixedWidth,
    'fa-inverse': props.inverse,
    'fa-border': props.border,
    'fa-li': props.listItem,
    'fa-flip-horizontal': props.flip === 'horizontal' || props.flip === 'both',
    'fa-flip-vertical': props.flip === 'vertical' || props.flip === 'both'
  }, defineProperty(_classes, 'fa-' + props.size, props.size !== null), defineProperty(_classes, 'fa-rotate-' + props.rotation, props.rotation !== null), defineProperty(_classes, 'fa-pull-' + props.pull, props.pull !== null), _classes);

  return Object.keys(classes).map(function (key) {
    return classes[key] ? key : null;
  }).filter(function (key) {
    return key;
  });
}

function normalizeIconArgs(icon$$1) {
  if (icon$$1 === null) {
    return null;
  }

  if ((typeof icon$$1 === 'undefined' ? 'undefined' : _typeof(icon$$1)) === 'object' && icon$$1.prefix && icon$$1.iconName) {
    return icon$$1;
  }

  if (Array.isArray(icon$$1) && icon$$1.length === 2) {
    return { prefix: icon$$1[0], iconName: icon$$1[1] };
  }

  if (typeof icon$$1 === 'string') {
    return { prefix: 'fas', iconName: icon$$1 };
  }
}

function FontAwesomeIcon(props) {
  var iconArgs = props.icon,
      maskArgs = props.mask,
      symbol = props.symbol,
      className = props.className;


  var iconLookup = normalizeIconArgs(iconArgs);
  var classes = objectWithKey('classes', [].concat(toConsumableArray(classList(props)), toConsumableArray(className.split(' '))));
  var transform = objectWithKey('transform', typeof props.transform === 'string' ? __WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["a" /* parse */].transform(props.transform) : props.transform);
  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));

  var renderedIcon = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fortawesome_fontawesome_svg_core__["b" /* icon */])(iconLookup, _extends({}, classes, transform, mask, {
    symbol: symbol
  }));

  if (!renderedIcon) {
    log('Could not find icon', iconLookup);
    return null;
  }

  var abstract = renderedIcon.abstract;

  var extraProps = {};

  Object.keys(props).forEach(function (key) {
    if (!FontAwesomeIcon.defaultProps.hasOwnProperty(key)) {
      extraProps[key] = props[key];
    }
  });

  return convertCurry(abstract[0], extraProps);
}

FontAwesomeIcon.displayName = 'FontAwesomeIcon';

FontAwesomeIcon.propTypes = {
  border: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,

  mask: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  fixedWidth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  inverse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  flip: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['horizontal', 'vertical', 'both']),

  icon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  listItem: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  pull: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['right', 'left']),

  pulse: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  rotation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf([90, 180, 270]),

  size: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),

  spin: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,

  symbol: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]),

  transform: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])
};

FontAwesomeIcon.defaultProps = {
  border: false,
  className: '',
  mask: null,
  fixedWidth: false,
  inverse: false,
  flip: null,
  icon: null,
  listItem: false,
  pull: null,
  pulse: false,
  rotation: null,
  size: null,
  spin: false,
  symbol: false,
  transform: null
};

var convertCurry = convert.bind(null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement);



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(482), __webpack_require__(50)))

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** logical operations that can be applied to a list of conditions */
var operationTypes;
(function (operationTypes) {
    operationTypes["And"] = "AND";
    operationTypes["Or"] = "OR";
})(operationTypes = exports.operationTypes || (exports.operationTypes = {}));
/** the full list of condition types */
var conditionTypes;
(function (conditionTypes) {
    /** applies an [[operationTypes]] to a list of conditions */
    conditionTypes["operator"] = "condition.operation";
    /** checks if an element's value is equal to a given value */
    conditionTypes["equal"] = "condition.equal";
    /** checks if an element's value is not equal to a given value */
    conditionTypes["notEqual"] = "condition.not-equal";
    /** checks if an element's value is equal to a given value */
    conditionTypes["equalMaskedMulti"] = "condition.equal-masked-multi";
    /** checks if an element's value is not equal to a given value */
    conditionTypes["notEqualMaskedMulti"] = "condition.not-equal-masked-multi";
    /** checks if an element's value is equal to a given value */
    conditionTypes["equalLabel"] = "condition.equal-label";
    /** checks if an element's value is not equal to a given value */
    conditionTypes["notEqualLabel"] = "condition.not-equal-label";
    /** checks if an element's value is considered empty */
    conditionTypes["empty"] = "condition.empty";
    /** checks if an element's value is not considered empty */
    conditionTypes["notEmpty"] = "condition.not-empty";
    /** checks if an element contains a given value */
    conditionTypes["contains"] = "condition.contains";
    /** checks if an element contains a given string value */
    conditionTypes["containsString"] = "condition.contains-string";
    /** checks if an element does not contain a given string value */
    conditionTypes["notContainString"] = "condition.not-contain-string";
    /** checks if an element's value is equal to the value of another element */
    conditionTypes["equalElement"] = "condition.element.equal";
    /** checks if an element's value is not equal to the value of another element */
    conditionTypes["notEqualElement"] = "condition.element.not-equal";
    /** checks if an element's value is less than a given value */
    conditionTypes["lessThan"] = "condition.less";
    /** checks if an element's value is less than or equal to a given value */
    conditionTypes["lessThanOrEqual"] = "condition.less-or-equal";
    /** checks if an element's value is greater than a given value */
    conditionTypes["greaterThan"] = "condition.greater";
    /** checks if an element's value is greater than or equal to a given value */
    conditionTypes["greaterThanOrEqual"] = "condition.greater-or-equal";
    /** checks if an element's value is less than the value of another element */
    conditionTypes["lessThanElement"] = "condition.element.numeric.less";
    /** checks if an element's value is less than or equal to the value of another element */
    conditionTypes["lessThanOrEqualElement"] = "condition.element.numeric.less-or-equal";
    /** checks if an element's value is greater than the value of another element */
    conditionTypes["greaterThanElement"] = "condition.element.numeric.greater";
    /** checks if an element's value is greater than or equal to the value of another element */
    conditionTypes["greaterThanOrEqualElement"] = "condition.element.numeric.greater-or-equal";
    /** checks if an elements' value begins with a given substring */
    conditionTypes["beginsWith"] = "condition.begins-with";
    /** checks if an elements' value does not begin with a given substring */
    conditionTypes["notBeginWith"] = "condition.not-begin-with";
    /** checks if an elements' value ends with a given substring */
    conditionTypes["endsWith"] = "condition.ends-with";
    /** checks if an elements' value does not end with a given substring */
    conditionTypes["notEndWith"] = "condition.not-end-with";
    /** checks if an element's value contains any of a given number of values */
    conditionTypes["matchesAny"] = "condition.apricot-matches-any";
    /** checks if an element's value does NOT contain any of a given number of values */
    conditionTypes["notMatchAny"] = "condition.apricot-not-match-any";
    /** checks if an element's value contains any of a given number of values */
    conditionTypes["matchesAnyMaskedMulti"] = "condition.apricot-matches-any-masked-multi";
    /** checks if an element's value does NOT contain any of a given number of values */
    conditionTypes["notMatchAnyMaskedMulti"] = "condition.apricot-not-matches-any-masked-multi";
    /** checks if an element's value contains all of a given number of values */
    conditionTypes["matchesEvery"] = "condition.apricot-matches-every";
    /** checks that an element's value does NOT contain every one of a given number of values */
    conditionTypes["notMatchEvery"] = "condition.apricot-not-match-every";
    /** checks if an element's value is earlier than now */
    conditionTypes["earlierThanNow"] = "condition.time.earlier";
    /** checks if an element's value is earlier than or equal to now */
    conditionTypes["earlierThanNowOrEqual"] = "condition.time.earlier-or-equal";
    /** checks if an element's value is later than now */
    conditionTypes["laterThanNow"] = "condition.time.later";
    /** checks if an element's value is later than or equal to now */
    conditionTypes["laterThanNowOrEqual"] = "condition.time.later-or-equal";
    /** checks if an element's value is between two constant values */
    conditionTypes["between"] = "condition.between";
    /** checks if an element's value is not between two constant values */
    conditionTypes["notBetween"] = "condition.not-between";
    /** checks that a date element's value is today */
    conditionTypes["today"] = "condition.today";
    /** checks that a date element's value is NOT today */
    conditionTypes["notToday"] = "condition.not-today";
    /** checks that a date element's value is in the current week */
    conditionTypes["thisWeek"] = "condition.this-week";
    /** checks that a date element's value is NOT in the current week */
    conditionTypes["notThisWeek"] = "condition.not-this-week";
    /** checks that a date element's value is in the current month */
    conditionTypes["thisMonth"] = "condition.this-month";
    /** checks that a date element's value is NOT in the current month */
    conditionTypes["notThisMonth"] = "condition.not-this-month";
    /** checks that a date element's value is in the current year */
    conditionTypes["thisYear"] = "condition.this-year";
    /** checks that a date element's value is NOT in the current year */
    conditionTypes["notThisYear"] = "condition.not-this-year";
    /** checks that a date element's value is within given number of days */
    conditionTypes["last"] = "condition.last";
    /** checks that a date element's value is NOT within given number of days */
    conditionTypes["notLast"] = "condition.not-last";
    /** checks that a date element's value is within given number of days */
    conditionTypes["next"] = "condition.next";
    /** checks that a date element's value is NOT within given number of days */
    conditionTypes["notNext"] = "condition.not-next";
    /** check for static condition being true or false */
    conditionTypes["static"] = "condition.static";
    /** determines if there are no selected programs */
    conditionTypes["programEmpty"] = "condition.program.empty";
    /** determines if there are any selected programs */
    conditionTypes["programNotEmpty"] = "condition.program.not-empty";
    /** determines if there are programs selected that have a name containing some text */
    conditionTypes["programContains"] = "condition.program.contains";
    /** determines if there are no programs selected that have a name containing some text */
    conditionTypes["programNotContains"] = "condition.program.not-contains";
    /** determines if there are programs selected that match a list of program ids */
    conditionTypes["programMatchesAny"] = "condition.program.matches-any";
    /** determines if there are no programs selected that match a list of program ids */
    conditionTypes["programNotMatchesAny"] = "condition.program.not-matches-any";
    /** determines if the programs selected match all program ids in a list */
    conditionTypes["programMatchesAll"] = "condition.program.matches-all";
    /** determines if the programs selected don't match all program ids in a list */
    conditionTypes["programNotMatchesAll"] = "condition.program.not-matches-all";
})(conditionTypes = exports.conditionTypes || (exports.conditionTypes = {}));
/** the full list of action types */
var actionTypes;
(function (actionTypes) {
    /** this action will be ignored, the action reducer will skip this action */
    actionTypes["ignore"] = "action.ignore";
    /** shows a hidden element, changes hidden property to false */
    actionTypes["show"] = "action.show";
    /** hides an element, changes hidden property to true */
    actionTypes["hide"] = "action.hide";
    /** requires a response to an element, changes isRequired to true */
    actionTypes["makeRequired"] = "action.required";
    /** unrequires a response to an element, changes isRequired to false */
    actionTypes["makeNotRequired"] = "action.not-required";
    /** sets an element to a specific value and makes it readOnly so it cannot be edited */
    actionTypes["setValue"] = "action.set-value-readonly";
    /** provides a default value for an element, allows it to be edited*/
    actionTypes["setDefault"] = "action.set-default";
    /** for elements that have validation related to a specific country, this will change which country is being used */
    actionTypes["changeCountry"] = "action.change-country";
    /** makes the given element disabled */
    actionTypes["disable"] = "action.disable";
    /** sets disabled flag to false if it was true */
    actionTypes["enable"] = "action.enable";
    /** locks element, changes readonly property to true */
    actionTypes["lock"] = "action.lock";
    /** unlocks element, changes readonly property to false */
    actionTypes["unlock"] = "action.unlock";
})(actionTypes = exports.actionTypes || (exports.actionTypes = {}));
//# sourceMappingURL=rule-constants.js.map

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getCurrentValue(value, defaultValue) {
    return value !== undefined && value !== null ? value : defaultValue ? defaultValue : "";
}
exports.getCurrentValue = getCurrentValue;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var form_definition_1 = __webpack_require__(38);
exports.elementStoresData = form_definition_1.elementStoresData;
exports.getValue = form_definition_1.getValue;
exports.getSelectedPrograms = form_definition_1.getSelectedPrograms;
exports.getModifiedSubElement = form_definition_1.getModifiedSubElement;
exports.isSubElementRequiredByGroup = form_definition_1.isSubElementRequiredByGroup;
exports.getAllElementInfo = form_definition_1.getAllElementInfo;
exports.getElementInfo = form_definition_1.getElementInfo;
exports.getElementById = form_definition_1.getElementById;
exports.hasEmptyValue = form_definition_1.hasEmptyValue;
exports.Form = form_definition_1.Form;
exports.FormState = form_definition_1.FormState;
exports.getAssessedElementsForTarget = form_definition_1.getAssessedElementsForTarget;
exports.getAllPreviewElementInfo = form_definition_1.getAllPreviewElementInfo;
var form_validation_definition_1 = __webpack_require__(44);
exports.ValidationResult = form_validation_definition_1.ValidationResult;
exports.Error = form_validation_definition_1.Error;
var formRuleTypes = __webpack_require__(21);
exports.formRuleTypes = formRuleTypes;
var formElementTypes = __webpack_require__(26);
exports.formElementTypes = formElementTypes;
var element_response_definition_1 = __webpack_require__(121);
exports.AttachmentResponseState = element_response_definition_1.AttachmentResponseState;
exports.TimeResponseState = element_response_definition_1.TimeResponseState;
exports.ElectronicSignatureResponseState = element_response_definition_1.ElectronicSignatureResponseState;
exports.EmailNotificationState = element_response_definition_1.EmailNotificationState;
exports.emailNotificationStatus = element_response_definition_1.emailNotificationStatus;
var form_constants_1 = __webpack_require__(5);
exports.countryCodes = form_constants_1.countryCodes;
exports.numericElementTypes = form_constants_1.numericElementTypes;
exports.elementTypes = form_constants_1.elementTypes;
exports.nationalIdTypes = form_constants_1.nationalIdTypes;
exports.timePeriod = form_constants_1.timePeriod;
exports.groupTypes = form_constants_1.groupTypes;
exports.electronicSignatureModes = form_constants_1.electronicSignatureModes;
exports.specialTextTypes = form_constants_1.specialTextTypes;
exports.requireType = form_constants_1.requireType;
var form_element_utilities_1 = __webpack_require__(122);
exports.getPlainTextValue = form_element_utilities_1.getPlainTextValue;
var groupDataFormatHelpers = __webpack_require__(154);
exports.groupDataFormatHelpers = groupDataFormatHelpers;
var program_1 = __webpack_require__(155);
exports.Program = program_1.Program;
//# sourceMappingURL=index.js.map

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var custom_icon_component_1 = __webpack_require__(372);
exports.CustomIcon = custom_icon_component_1.default;
var custom_icon_set_1 = __webpack_require__(104);
exports.CustomIconSet = custom_icon_set_1.default;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var required_indicator_1 = __webpack_require__(34);
exports.RequiredIndicator = required_indicator_1.default;
var required_label_1 = __webpack_require__(375);
exports.RequiredLabel = required_label_1.default;
var required_legend_1 = __webpack_require__(376);
exports.RequiredLegend = required_legend_1.default;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var text_element_1 = __webpack_require__(94);
exports.TextElement = text_element_1.TextElement;
var text_area_element_1 = __webpack_require__(92);
exports.TextAreaElement = text_area_element_1.TextAreaElement;
var numeric_element_1 = __webpack_require__(78);
exports.NumericElement = numeric_element_1.NumericElement;
var heading_element_1 = __webpack_require__(69);
exports.HeadingElement = heading_element_1.HeadingElement;
var html_label_element_1 = __webpack_require__(73);
exports.HtmlLabelElement = html_label_element_1.HtmlLabelElement;
var select_element_1 = __webpack_require__(86);
exports.SelectElement = select_element_1.SelectElement;
var date_element_1 = __webpack_require__(59);
exports.DateElement = date_element_1.DateElement;
var radio_element_1 = __webpack_require__(84);
exports.RadioElement = radio_element_1.RadioElement;
var likert_scale_element_1 = __webpack_require__(335);
exports.LikertScaleElement = likert_scale_element_1.LikertScaleElement;
var checkbox_element_1 = __webpack_require__(57);
exports.CheckboxElement = checkbox_element_1.CheckboxElement;
var email_element_1 = __webpack_require__(63);
exports.EmailElement = email_element_1.EmailElement;
var email_notification_element_1 = __webpack_require__(65);
exports.EmailNotificationElement = email_notification_element_1.EmailNotificationElement;
var national_id_element_1 = __webpack_require__(76);
exports.NationalIdElement = national_id_element_1.NationalIdElement;
var time_element_1 = __webpack_require__(96);
exports.TimeElement = time_element_1.TimeElement;
var phone_element_1 = __webpack_require__(80);
exports.PhoneElement = phone_element_1.PhoneElement;
var help_element_1 = __webpack_require__(71);
exports.HelpElement = help_element_1.HelpElement;
var group_element_1 = __webpack_require__(331);
exports.GroupElement = group_element_1.GroupElement;
var electronic_signature_element_1 = __webpack_require__(61);
exports.ElectronicSignatureElement = electronic_signature_element_1.ElectronicSignatureElement;
var form_element_1 = __webpack_require__(66);
exports.FormElement = form_element_1.default;
var attachment_element_1 = __webpack_require__(55);
exports.AttachmentElement = attachment_element_1.AttachmentElement;
var postal_code_element_1 = __webpack_require__(82);
exports.PostalCodeElement = postal_code_element_1.PostalCodeElement;
var single_checkbox_input_1 = __webpack_require__(343);
exports.SingleCheckboxInput = single_checkbox_input_1.SingleCheckboxInput;
var single_radio_input_1 = __webpack_require__(345);
exports.SingleRadioInput = single_radio_input_1.SingleRadioInput;
var specialized_text_element_1 = __webpack_require__(90);
exports.SpecializedTextElement = specialized_text_element_1.SpecializedTextElement;
var giscoordinates_element_1 = __webpack_require__(324);
exports.GISCoordinatesElement = giscoordinates_element_1.GISCoordinatesElement;
var form_element_style_1 = __webpack_require__(29);
exports.defaultElementStyles = form_element_style_1.default;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var operation_condition_1 = __webpack_require__(148);
exports.ImmutableOperationCondition = operation_condition_1.ImmutableOperationCondition;
var element_state_condition_1 = __webpack_require__(145);
exports.ImmutableElementStateCondition = element_state_condition_1.ImmutableElementStateCondition;
var element_value_condition_1 = __webpack_require__(146);
exports.ImmutableElementValueCondition = element_value_condition_1.ImmutableElementValueCondition;
var unsupported_conditions_1 = __webpack_require__(153);
exports.ImmutableUnsupportedCondition = unsupported_conditions_1.ImmutableUnsupportedCondition;
var element_comparison_condition_1 = __webpack_require__(144);
exports.ImmutableElementComparisonCondition = element_comparison_condition_1.ImmutableElementComparisonCondition;
var form_action_1 = __webpack_require__(43);
exports.ImmutableFormAction = form_action_1.ImmutableFormAction;
var form_rule_1 = __webpack_require__(147);
exports.ImmutableFormRule = form_rule_1.ImmutableFormRule;
var rule_constants_1 = __webpack_require__(15);
exports.conditionTypes = rule_constants_1.conditionTypes;
exports.actionTypes = rule_constants_1.actionTypes;
exports.operationTypes = rule_constants_1.operationTypes;
var rule_helpers_1 = __webpack_require__(151);
exports.isConditionElementComparisonType = rule_helpers_1.isConditionElementComparisonType;
exports.isConditionElementValueType = rule_helpers_1.isConditionElementValueType;
exports.isConditionElementStateType = rule_helpers_1.isConditionElementStateType;
exports.isConditionOperatorType = rule_helpers_1.isConditionOperatorType;
exports.isStaticConditionType = rule_helpers_1.isStaticConditionType;
var static_condition_1 = __webpack_require__(152);
exports.ImmutableStaticCondition = static_condition_1.ImmutableStaticCondition;
var program_state_condition_1 = __webpack_require__(149);
exports.ImmutableProgramStateCondition = program_state_condition_1.ImmutableProgramStateCondition;
var program_value_condition_1 = __webpack_require__(150);
exports.ImmutableProgramValueCondition = program_value_condition_1.ImmutableProgramValueCondition;
/**
 * Converts a JS object definition of a form condition into an immutable definition of a form condition.
 * @param condition normal js object definition of a form condition
 */
function convertConditionToImmutable(condition) {
    switch (condition.type) {
        case rule_constants_1.conditionTypes.operator:
            return new operation_condition_1.ImmutableOperationCondition(condition);
        case rule_constants_1.conditionTypes.empty:
        case rule_constants_1.conditionTypes.notEmpty:
        case rule_constants_1.conditionTypes.earlierThanNow:
        case rule_constants_1.conditionTypes.earlierThanNowOrEqual:
        case rule_constants_1.conditionTypes.laterThanNow:
        case rule_constants_1.conditionTypes.laterThanNowOrEqual:
        case rule_constants_1.conditionTypes.today:
        case rule_constants_1.conditionTypes.notToday:
        case rule_constants_1.conditionTypes.thisWeek:
        case rule_constants_1.conditionTypes.notThisWeek:
        case rule_constants_1.conditionTypes.thisMonth:
        case rule_constants_1.conditionTypes.notThisMonth:
        case rule_constants_1.conditionTypes.thisYear:
        case rule_constants_1.conditionTypes.notThisYear:
            return new element_state_condition_1.ImmutableElementStateCondition(condition);
        case rule_constants_1.conditionTypes.equal:
        case rule_constants_1.conditionTypes.notEqual:
        case rule_constants_1.conditionTypes.equalLabel:
        case rule_constants_1.conditionTypes.notEqualLabel:
        case rule_constants_1.conditionTypes.equalMaskedMulti:
        case rule_constants_1.conditionTypes.notEqualMaskedMulti:
        case rule_constants_1.conditionTypes.contains:
        case rule_constants_1.conditionTypes.containsString:
        case rule_constants_1.conditionTypes.notContainString:
        case rule_constants_1.conditionTypes.lessThan:
        case rule_constants_1.conditionTypes.lessThanOrEqual:
        case rule_constants_1.conditionTypes.greaterThan:
        case rule_constants_1.conditionTypes.greaterThanOrEqual:
        case rule_constants_1.conditionTypes.beginsWith:
        case rule_constants_1.conditionTypes.notBeginWith:
        case rule_constants_1.conditionTypes.endsWith:
        case rule_constants_1.conditionTypes.notEndWith:
        case rule_constants_1.conditionTypes.matchesAny:
        case rule_constants_1.conditionTypes.notMatchAny:
        case rule_constants_1.conditionTypes.matchesAnyMaskedMulti:
        case rule_constants_1.conditionTypes.notMatchAnyMaskedMulti:
        case rule_constants_1.conditionTypes.matchesEvery:
        case rule_constants_1.conditionTypes.notMatchEvery:
        case rule_constants_1.conditionTypes.between:
        case rule_constants_1.conditionTypes.notBetween:
        case rule_constants_1.conditionTypes.last:
        case rule_constants_1.conditionTypes.notLast:
        case rule_constants_1.conditionTypes.next:
        case rule_constants_1.conditionTypes.notNext:
            return new element_value_condition_1.ImmutableElementValueCondition(condition);
        case rule_constants_1.conditionTypes.equalElement:
        case rule_constants_1.conditionTypes.notEqualElement:
        case rule_constants_1.conditionTypes.lessThanElement:
        case rule_constants_1.conditionTypes.lessThanOrEqualElement:
        case rule_constants_1.conditionTypes.greaterThanElement:
        case rule_constants_1.conditionTypes.greaterThanOrEqualElement:
            return new element_comparison_condition_1.ImmutableElementComparisonCondition(condition);
        case rule_constants_1.conditionTypes.static:
            return new static_condition_1.ImmutableStaticCondition(condition);
        case rule_constants_1.conditionTypes.programEmpty:
        case rule_constants_1.conditionTypes.programNotEmpty:
            return new program_state_condition_1.ImmutableProgramStateCondition(condition);
        case rule_constants_1.conditionTypes.programContains:
        case rule_constants_1.conditionTypes.programNotContains:
        case rule_constants_1.conditionTypes.programMatchesAny:
        case rule_constants_1.conditionTypes.programNotMatchesAny:
        case rule_constants_1.conditionTypes.programMatchesAll:
        case rule_constants_1.conditionTypes.programNotMatchesAll:
            return new program_value_condition_1.ImmutableProgramValueCondition(condition);
        default: return new unsupported_conditions_1.ImmutableUnsupportedCondition();
    }
}
exports.convertConditionToImmutable = convertConditionToImmutable;
/**
 * checks to see if a rule is comprised of supported conditions and actions
 * @param rule the rule we are evaluating
 */
function isRuleSupported(rule) {
    var conditionSupported = isConditionSupported(rule.condition);
    var actionsSupported = !!rule.conditionActions ? rule.conditionActions.every(function (action) { return isActionSupported(action); }) : true;
    var preConditionactionsSupported = !!rule.preConditionActions ? rule.preConditionActions.every(function (action) { return isActionSupported(action); }) : true;
    return conditionSupported && actionsSupported && preConditionactionsSupported;
}
exports.isRuleSupported = isRuleSupported;
/**
 * checks to see if the condition has supported type values
 * @param condition condition being evaluated
 */
function isConditionSupported(condition) {
    if (!condition)
        return false;
    var supported = enumContainsValue(rule_constants_1.conditionTypes, condition.type);
    if (!supported)
        return false;
    switch (condition.type) {
        case rule_constants_1.conditionTypes.operator:
            return condition.conditions.every(function (subCondition) { return isConditionSupported(subCondition); });
        default: return supported;
    }
}
exports.isConditionSupported = isConditionSupported;
/**
 * checks to see if the action has supported type values
 * @param action action being evaluated
 */
function isActionSupported(action) {
    if (!action)
        return false;
    var supported = enumContainsValue(rule_constants_1.actionTypes, action.type);
    return supported;
}
exports.isActionSupported = isActionSupported;
/**
 * checks to see if a certain string is a valid value in a string enum
 * @param enumObject a string enum
 * @param value the value we are searching for in the enum
 */
function enumContainsValue(enumObject, value) {
    var keys = Object.keys(enumObject);
    return keys.some(function (key) { return enumObject[key] === value; });
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var numberUtilities = __webpack_require__(48);
exports.numberUtilities = numberUtilities;
var dateUtilities = __webpack_require__(47);
exports.dateUtilities = dateUtilities;
var emailUtilities = __webpack_require__(160);
exports.emailUtilities = emailUtilities;
var arrayExtensions = __webpack_require__(159);
exports.arrayExtensions = arrayExtensions;
var textUtilities = __webpack_require__(161);
exports.textUtilities = textUtilities;
var timeUtilities = __webpack_require__(162);
exports.timeUtilities = timeUtilities;
//# sourceMappingURL=index.js.map

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function handleSelection(maskCharacters, selection, oldValue, newValue) {
    var start = selection.start, end = selection.end, changeValue = selection.changeValue;
    if (oldValue !== newValue || changeValue !== newValue) {
        if (start - end === 0) {
            var subset = changeValue.substr(0, start);
            var unmasked = subset.replace(new RegExp(maskCharacters, 'g'), '');
            var nonMaskChars = 0;
            var index = 0;
            for (var i = 0; i < newValue.length; i++) {
                var char = newValue.charAt(i);
                if (!maskCharacters.test(char)) {
                    nonMaskChars++;
                }
                if (nonMaskChars === unmasked.length) {
                    index = i + 1;
                    break;
                }
            }
            return {
                start: index,
                end: index,
            };
        }
    }
    return null;
}
exports.handleSelection = handleSelection;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
function handleMultipleChoiceInput(value, defaultValue, selectedValue, checked, exclusiveChoice) {
    var currentValue = getCurrentValue(value, defaultValue);
    var modifiedValue = currentValue;
    if (exclusiveChoice) {
        modifiedValue = modifiedValue.clear();
        if (!selectedValue) {
            return modifiedValue;
        }
    }
    if (checked && !modifiedValue.contains(selectedValue)) {
        return modifiedValue.push(selectedValue);
    }
    if (!checked && modifiedValue.contains(selectedValue)) {
        return modifiedValue.remove(modifiedValue.indexOf(selectedValue));
    }
    return modifiedValue;
}
exports.handleMultipleChoiceInput = handleMultipleChoiceInput;
function getCurrentValue(value, defaultValue) {
    return value ? value : defaultValue ? defaultValue : immutable_1.List();
}
exports.getCurrentValue = getCurrentValue;
/**
 * Returns a list of the selections, as defined by the multiple-choice options, for a given element,
 *  provided the values and/or default values. If no selections had been made, returns an empty list.
 * @param value list of the selected values, if any, from the multiple choice options
 * @param defaultValue list of the default values, if any
 * @param options list of all the options that might be selected for the element
 */
function getCurrentSelection(value, defaultValue, options) {
    var selectionsList = immutable_1.List();
    if (!!value) {
        if (value.size > 0) {
            value.forEach(function (val) {
                var selection = options.find(function (option) { return option.value === val; });
                if (!!selection) {
                    selectionsList = selectionsList.push(selection);
                }
            });
        }
        else {
            return selectionsList;
        }
    }
    else if (!!defaultValue && defaultValue.size > 0) {
        defaultValue.forEach(function (defaultVal) {
            var selection = options.find(function (option) { return option.value === defaultVal; });
            if (!!selection) {
                selectionsList = selectionsList.push(selection);
            }
        });
    }
    return selectionsList;
}
exports.getCurrentSelection = getCurrentSelection;
/**
 * Determine if the chosen value is currently checked/selected within the element.
 * @param value The existing value of the control.
 * @param defaultValue If the control has a default value, this is used instead of value.
 * @param selectedValue The newly selected value
 * @returns True if the selected value is equal to the existing value, false otherwise.
 */
function isChecked(value, defaultValue, selectedValue) {
    var currentValue = getCurrentValue(value, defaultValue);
    return !!currentValue && !!currentValue.find(function (i) { return i == selectedValue; });
}
exports.isChecked = isChecked;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var form_constants_1 = __webpack_require__(5);
exports.defaultValues = {
    type: form_constants_1.dataFormatType.NONE,
};
//# sourceMappingURL=data-format.js.map

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var form_constants_1 = __webpack_require__(5);
var attachment_element_1 = __webpack_require__(123);
exports.ImmutableAttachmentElement = attachment_element_1.ImmutableAttachmentElement;
var basic_form_element_1 = __webpack_require__(124);
exports.ImmutableBasicFormElement = basic_form_element_1.ImmutableBasicFormElement;
var basic_input_element_1 = __webpack_require__(125);
exports.ImmutableBasicInputElement = basic_input_element_1.ImmutableBasicInputElement;
var date_element_1 = __webpack_require__(129);
exports.ImmutableDateElement = date_element_1.ImmutableDateElement;
var duration_element_1 = __webpack_require__(130);
exports.ImmutableDurationElement = duration_element_1.ImmutableDurationElement;
var electronic_signature_element_1 = __webpack_require__(131);
exports.ImmutableElectronicSignatureElement = electronic_signature_element_1.ImmutableElectronicSignatureElement;
var group_element_1 = __webpack_require__(133);
exports.ImmutableGroupElement = group_element_1.ImmutableGroupElement;
var multiple_choice_element_1 = __webpack_require__(134);
exports.ImmutableMultipleChoiceElement = multiple_choice_element_1.ImmutableMultipleChoiceElement;
exports.MultipleChoiceOption = multiple_choice_element_1.MultipleChoiceOption;
exports.ImmutableMultipleChoiceOption = multiple_choice_element_1.ImmutableMultipleChoiceOption;
var national_id_element_1 = __webpack_require__(135);
exports.ImmutableNationalIdElement = national_id_element_1.ImmutableNationalIdElement;
var numeric_element_1 = __webpack_require__(136);
exports.ImmutableNumericElement = numeric_element_1.ImmutableNumericElement;
var postal_code_element_1 = __webpack_require__(137);
exports.ImmutablePostalCodeElement = postal_code_element_1.ImmutablePostalCodeElement;
var text_area_element_1 = __webpack_require__(141);
exports.ImmutableTextAreaElement = text_area_element_1.ImmutableTextAreaElement;
var text_element_1 = __webpack_require__(142);
exports.ImmutableTextElement = text_element_1.ImmutableTextElement;
var time_element_1 = __webpack_require__(143);
exports.ImmutableTimeElement = time_element_1.ImmutableTimeElement;
var specialized_text_element_1 = __webpack_require__(140);
exports.ImmutableSpecializedTextElement = specialized_text_element_1.ImmutableSpecializedTextElement;
var giscoordinates_element_1 = __webpack_require__(132);
exports.ImmutableGISCoordinatesElement = giscoordinates_element_1.ImmutableGISCoordinatesElement;
var required_definition_1 = __webpack_require__(41);
exports.convertRequiredDefinitionToImmutable = required_definition_1.convertToImmutable;
exports.ImmutableBasicRequiredDefinition = required_definition_1.ImmutableBasicRequiredDefinition;
exports.ImmutableSomeRequiredDefinition = required_definition_1.ImmutableSomeRequiredDefinition;
var data_format_1 = __webpack_require__(39);
exports.convertDataFormatToImmutable = data_format_1.convertToImmutable;
exports.ImmutableBasicDataFormat = data_format_1.ImmutableBasicDataFormat;
exports.ImmutableMCOtherFormat = data_format_1.ImmutableMCOtherFormat;
exports.ImmutableZipExtensionFormat = data_format_1.ImmutableZipExtensionFormat;
/**
 * Converts a non-immutable element definition to an immutable element definition that can be used by the form state
 * @param element non-immutable element to be converted
 */
function convertToImmutable(element) {
    switch (element.type) {
        case form_constants_1.elementTypes.attachment: return new attachment_element_1.ImmutableAttachmentElement(element);
        case form_constants_1.elementTypes.heading:
        case form_constants_1.elementTypes.help:
        case form_constants_1.elementTypes.html:
        case form_constants_1.elementTypes.ignore:
        case form_constants_1.elementTypes.page:
        case form_constants_1.elementTypes.undefined:
        case form_constants_1.elementTypes.unsupported:
            return new basic_form_element_1.ImmutableBasicFormElement(element);
        case form_constants_1.elementTypes.email:
        case form_constants_1.elementTypes.phone:
        case form_constants_1.elementTypes.emailNotification:
            return new basic_input_element_1.ImmutableBasicInputElement(element);
        case form_constants_1.elementTypes.date: return new date_element_1.ImmutableDateElement(element);
        case form_constants_1.elementTypes.duration: return new duration_element_1.ImmutableDurationElement(element);
        case form_constants_1.elementTypes.electronicSignature: return new electronic_signature_element_1.ImmutableElectronicSignatureElement(element);
        case form_constants_1.elementTypes.group: return new group_element_1.ImmutableGroupElement(element);
        case form_constants_1.elementTypes.radio:
        case form_constants_1.elementTypes.checkbox:
        case form_constants_1.elementTypes.select:
        case form_constants_1.elementTypes.likert:
            return new multiple_choice_element_1.ImmutableMultipleChoiceElement(element);
        case form_constants_1.elementTypes.nationalId: return new national_id_element_1.ImmutableNationalIdElement(element);
        case form_constants_1.elementTypes.number: return new numeric_element_1.ImmutableNumericElement(element);
        case form_constants_1.elementTypes.postalCode: return new postal_code_element_1.ImmutablePostalCodeElement(element);
        case form_constants_1.elementTypes.specialText: return new specialized_text_element_1.ImmutableSpecializedTextElement(element);
        case form_constants_1.elementTypes.textArea: return new text_area_element_1.ImmutableTextAreaElement(element);
        case form_constants_1.elementTypes.text: return new text_element_1.ImmutableTextElement(element);
        case form_constants_1.elementTypes.time: return new time_element_1.ImmutableTimeElement(element);
        case form_constants_1.elementTypes.gisCoordinates: return new giscoordinates_element_1.ImmutableGISCoordinatesElement(element);
        default: return null;
    }
}
exports.convertToImmutable = convertToImmutable;
//# sourceMappingURL=index.js.map

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var rule_constants_1 = __webpack_require__(15);
exports.defaultValues = {
    type: rule_constants_1.conditionTypes.empty,
    elementId: ''
};
//# sourceMappingURL=element-condition.js.map

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(204);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./nav.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./nav.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var text_element_1 = __webpack_require__(94);
var text_area_element_1 = __webpack_require__(92);
var numeric_element_1 = __webpack_require__(78);
var heading_element_1 = __webpack_require__(69);
var help_element_1 = __webpack_require__(71);
var html_label_element_1 = __webpack_require__(73);
var select_element_1 = __webpack_require__(86);
var date_element_1 = __webpack_require__(59);
var radio_element_1 = __webpack_require__(84);
var checkbox_element_1 = __webpack_require__(57);
var electronic_signature_element_1 = __webpack_require__(61);
var email_element_1 = __webpack_require__(63);
var email_notification_element_1 = __webpack_require__(65);
var national_id_element_1 = __webpack_require__(76);
var time_element_1 = __webpack_require__(96);
var phone_element_1 = __webpack_require__(80);
var attachment_element_1 = __webpack_require__(55);
var postal_code_element_1 = __webpack_require__(82);
var specialized_text_element_1 = __webpack_require__(90);
exports.unsupportedDefault = {
    unsupportedText: 'ssg-forms-unsupported-warning ssg-forms-no-focus ssg-forms-text normal',
    unsupportedIcon: 'ssg-forms-unsupported-icon',
};
/**
 * Merges all the styles in the style sheet for the different element types
 * @param style1 the default styles
 * @param style2 the styles that should override the default styles in [[style1]]
 */
function mergeStyles(style1, style2) {
    if (!style2) {
        return style1;
    }
    else if (!style1) {
        return style2;
    }
    var returnValue = Object.assign({}, style1);
    var keys = Object.getOwnPropertyNames(style1);
    keys.forEach(function (key) {
        var val1 = returnValue[key];
        var val2 = style2[key];
        if (val1 === undefined || val1 === null) {
            returnValue[key] = val2;
        }
        else if (val2 !== undefined && val2 !== null) {
            returnValue[key] = Object.assign({}, returnValue[key], style2[key]);
        }
    });
    return returnValue;
}
exports.mergeStyles = mergeStyles;
var defaultStyle = {
    group: undefined,
    heading: heading_element_1.defaultStyle,
    help: help_element_1.defaultStyle,
    html: html_label_element_1.defaultStyle,
    text: text_element_1.defaultStyle,
    textArea: text_area_element_1.defaultStyle,
    email: email_element_1.defaultStyle,
    emailNotification: email_notification_element_1.defaultStyle,
    number: numeric_element_1.defaultStyle,
    date: date_element_1.defaultStyle,
    tel: phone_element_1.defaultStyle,
    checkbox: checkbox_element_1.defaultStyle,
    select: select_element_1.defaultStyle,
    radio: radio_element_1.defaultStyle,
    nationalId: national_id_element_1.defaultStyle,
    time: time_element_1.defaultStyle,
    attachment: attachment_element_1.defaultStyle,
    electronicSignature: electronic_signature_element_1.defaultStyle,
    postalCode: postal_code_element_1.defaultStyle,
    specialText: specialized_text_element_1.defaultStyle,
    unsupported: exports.unsupportedDefault,
};
exports.default = defaultStyle;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
__webpack_require__(271);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { inputWrapper: 'group-element-sub-elements' });
exports.default = defaultStyle;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var ssg_forms_processing_1 = __webpack_require__(7);
var date_enum_1 = __webpack_require__(105);
var ssgFormActionTypes;
(function (ssgFormActionTypes) {
    ssgFormActionTypes["INIT_FORM"] = "ssg-forms.init-form";
    ssgFormActionTypes["UPDATE_SCALAR_ANSWER"] = "ssg-forms.update-scalar-answer";
    ssgFormActionTypes["UPDATE_SELECTED_PROGRAMS"] = "ssg-forms.update-selected-programs";
    ssgFormActionTypes["PROCESS_FORM"] = "ssg-forms.process-form";
    ssgFormActionTypes["UPDATE_ATTACHMENT_ELEMENT_BEGIN"] = "ssg-forms.update-attachment-element-begin";
    ssgFormActionTypes["ADD_ATTACHMENT_INFO"] = "ssg-forms.add-attachment-info";
    ssgFormActionTypes["ADD_ATTACHMENT_CONTENT"] = "ssg-forms.add-attachment-content";
    ssgFormActionTypes["UPDATE_ATTACHMENT_ELEMENT_FAILURE"] = "ssg-forms.update-attachment-element-failure";
    ssgFormActionTypes["REMOVE_ATTACHMENT"] = "ssg-forms.remove-attachment";
    ssgFormActionTypes["REMOVE_ATTACHMENT_ELEMENT_FAILURE"] = "ssg-forms.remove-attachment-element-failure";
    ssgFormActionTypes["UPDATE_RECAPTCHA"] = "ssg-forms.update-recaptcha";
    ssgFormActionTypes["UPDATE_SHOW_VALIDATION"] = "ssg-forms.update-show-validation";
    ssgFormActionTypes["RESET"] = "ssg-forms.reset";
    ssgFormActionTypes["HARD_RESET"] = "ssg-forms.hard-reset";
})(ssgFormActionTypes = exports.ssgFormActionTypes || (exports.ssgFormActionTypes = {}));
;
;
;
function initializeFormState(id, form, defaultValues, allPrograms, defaultSelectedPrograms) {
    if (allPrograms === void 0) { allPrograms = []; }
    if (defaultSelectedPrograms === void 0) { defaultSelectedPrograms = []; }
    return function (dispatch, getState) {
        var ssgForms = getState().ssgForms;
        var forms = ssgForms.forms;
        var currentFormState = forms.get(id);
        var convertedForm = ssg_forms_processing_1.adapters.convertJsonForm(form);
        var formState = new ssg_forms_processing_1.formDefinition.FormState({
            form: convertedForm,
            allPrograms: allPrograms ? immutable_1.List(allPrograms.map(function (program) { return new ssg_forms_processing_1.formDefinition.Program(program); })) : immutable_1.List([]),
            defaultSelectedPrograms: defaultSelectedPrograms ? immutable_1.List(defaultSelectedPrograms) : immutable_1.List([]),
            value: !!currentFormState ? currentFormState.value : immutable_1.Map({}),
            defaultValue: defaultValues || immutable_1.Map({}),
        });
        dispatch(initFormState(id, formState));
    };
}
function initFormState(id, state) {
    return {
        type: ssgFormActionTypes.INIT_FORM,
        id: id,
        state: state,
    };
}
function updateScalarAnswer(id, elementId, value) {
    return {
        type: ssgFormActionTypes.UPDATE_SCALAR_ANSWER,
        id: id,
        elementId: elementId,
        value: value
    };
}
/**
 * function used to update the selected programs in the form state
 * @param id id of the form component
 * @param value array of program ids, that represent which programs will be selected upon saving
 */
function updateSelectedPrograms(id, value) {
    return {
        type: ssgFormActionTypes.UPDATE_SELECTED_PROGRAMS,
        id: id,
        value: value
    };
}
function processForm(id, country) {
    if (country === void 0) { country = date_enum_1.default.UnitedStates; }
    return function (dispatch, getState) {
        var ssgForms = getState().ssgForms;
        var forms = ssgForms.forms;
        var formState = forms.get(id);
        var modifiedState = ssg_forms_processing_1.rulesEngine.runRulesEngine(formState);
        var validatedState = ssg_forms_processing_1.validation.runValidation(modifiedState, country);
        dispatch(setProcessedFormState(id, validatedState));
    };
}
function setProcessedFormState(id, state) {
    return {
        type: ssgFormActionTypes.PROCESS_FORM,
        id: id,
        state: state,
    };
}
function updateAttachmentElementBegin(id, elementId, fileCount) {
    return {
        type: ssgFormActionTypes.UPDATE_ATTACHMENT_ELEMENT_BEGIN,
        id: id,
        elementId: elementId,
        fileCount: fileCount
    };
}
function addAttachmentInfo(id, elementId, fileId, name, contentType, size) {
    return {
        type: ssgFormActionTypes.ADD_ATTACHMENT_INFO,
        id: id,
        elementId: elementId,
        fileId: fileId,
        name: name,
        contentType: contentType,
        size: size
    };
}
function addAttachmentContent(id, elementId, fileId, content) {
    return {
        type: ssgFormActionTypes.ADD_ATTACHMENT_CONTENT,
        id: id,
        elementId: elementId,
        fileId: fileId,
        content: content
    };
}
function updateShowValidation(id, showFormValidation) {
    return {
        type: ssgFormActionTypes.UPDATE_SHOW_VALIDATION,
        id: id,
        showFormValidation: showFormValidation,
    };
}
function updateAttachmentElementFailure(id, elementId, fileId, err) {
    return {
        type: ssgFormActionTypes.UPDATE_ATTACHMENT_ELEMENT_FAILURE,
        id: id,
        elementId: elementId,
        fileId: fileId,
        err: err
    };
}
function removeAttachment(id, elementId, fileId) {
    return {
        type: ssgFormActionTypes.REMOVE_ATTACHMENT,
        id: id,
        elementId: elementId,
        fileId: fileId
    };
}
function updateAttachmentRemoveFailure(id, elementId, fileId, err) {
    return {
        type: ssgFormActionTypes.REMOVE_ATTACHMENT_ELEMENT_FAILURE,
        id: id,
        elementId: elementId,
        fileId: fileId,
        err: err
    };
}
function updateRecaptcha(id, value) {
    return {
        type: ssgFormActionTypes.UPDATE_RECAPTCHA,
        id: id,
        value: value
    };
}
function resetForm(id) {
    return {
        type: ssgFormActionTypes.RESET,
        id: id
    };
}
/**
 * Clear out the data in ssgForms.forms.(section) and ssgForms.processedForms.(section)
 * Replace the existing data, if any, with a new form state.
 * @param id The section to clear out.
 */
function hardReset(id) {
    return {
        type: ssgFormActionTypes.HARD_RESET,
        id: id
    };
}
exports.default = {
    initializeFormState: initializeFormState,
    updateScalarAnswer: updateScalarAnswer,
    updateSelectedPrograms: updateSelectedPrograms,
    processForm: processForm,
    updateAttachmentElementBegin: updateAttachmentElementBegin,
    addAttachmentInfo: addAttachmentInfo,
    addAttachmentContent: addAttachmentContent,
    updateAttachmentElementFailure: updateAttachmentElementFailure,
    removeAttachment: removeAttachment,
    updateAttachmentRemoveFailure: updateAttachmentRemoveFailure,
    updateRecaptcha: updateRecaptcha,
    updateShowValidation: updateShowValidation,
    resetForm: resetForm,
    hardReset: hardReset
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var TAB_KEY = 9;
var LEFT_ARROW = 37;
var RIGHT_ARROW = 39;
var isLeftArrow = function (event) { return event.key == 'LeftArrow' || event.keyCode === LEFT_ARROW; };
var isRightArrow = function (event) { return event.key == 'RightArrow' || event.keyCode === RIGHT_ARROW; };
/**
 * Returns if a particular HTML element can recieve focus via keyboard input
 * @param element html element to be evaluated
 */
function isFocusable(element) {
    var tabIndexAttr = element.getAttribute('tabindex');
    var tabIndex = tabIndexAttr && parseInt(tabIndexAttr, 10);
    return (element.tagName === 'A' ||
        element.tagName === 'OBJECT' ||
        element.tagName === 'INPUT' ||
        element.tagName === 'TEXTAREA' ||
        element.tagName === 'SELECT' ||
        element.tagName === 'BUTTON' ||
        element.tagName === 'IFRAME' ||
        (!!tabIndex && tabIndex >= 0));
}
exports.isFocusable = isFocusable;
/**
 * Returns all HTML elements that can be focused via keyboard input
 * @param element parent HTML element
 */
function getFocusableChildren(element) {
    if (!element)
        return [];
    var focusableElements = [];
    var children = element.getElementsByTagName("*");
    for (var i = 0; i < children.length; i++) {
        var child = children.item(i);
        if (isFocusable(child)) {
            focusableElements.push(child);
        }
    }
    return focusableElements;
}
exports.getFocusableChildren = getFocusableChildren;
/**
 * This funciton is meant to be used
 * @param element This is the HTMLElement that you are trying to limit focus to.
 * @param event This is the keybord event that has occurred
 */
function trapFocus(element, event) {
    if (event.key !== 'Tab' && event.keyCode !== TAB_KEY)
        return;
    var focusableElements = getFocusableChildren(element);
    var firstFocusableElement = focusableElements && focusableElements[0];
    var lastFocusableElement = focusableElements && focusableElements[focusableElements.length - 1];
    if (event.shiftKey) {
        if (document.activeElement === firstFocusableElement) {
            lastFocusableElement.focus();
            event.preventDefault();
        }
    }
    else {
        if (document.activeElement === lastFocusableElement) {
            firstFocusableElement.focus();
            event.preventDefault();
        }
    }
}
exports.trapFocus = trapFocus;
/**
 * This function is used to allow the left and right arrow keys to change focus to focusable elements within the parent element
 * @param element This is the parent HTMLElement shifting focus inside of.
 * @param event This is the keybord event that has occurred
 * @param wrap determines how to handle trying to navigate past the start or end of the parent's range.
 * If true it will wrap back around to the end or start of the range, if false nothing will happen
 */
function subElementNavigation(element, event, wrap) {
    if (wrap === void 0) { wrap = false; }
    if (!isLeftArrow(event) && !isRightArrow(event))
        return;
    event.preventDefault();
    var focusableElements = getFocusableChildren(element);
    if (!focusableElements || focusableElements.length < 2) {
        return;
    }
    var activeElementLocation = focusableElements && focusableElements.findIndex(function (val) { return val === document.activeElement; });
    if (isLeftArrow(event)) {
        if (activeElementLocation > 0 && activeElementLocation < focusableElements.length) {
            focusableElements[activeElementLocation - 1].focus();
        }
        else if (activeElementLocation === 0 && wrap) {
            focusableElements[focusableElements.length - 1].focus();
        }
    }
    else if (isRightArrow(event)) {
        if (activeElementLocation >= 0 && activeElementLocation < focusableElements.length - 1) {
            focusableElements[activeElementLocation + 1].focus();
        }
        else if (activeElementLocation === focusableElements.length - 1 && wrap) {
            focusableElements[0].focus();
        }
    }
}
exports.subElementNavigation = subElementNavigation;
/**
 * Determines if the target is within the element with id = elementId
 * @param target
 * @param elementId
 */
function isInsideElement(target, elementId) {
    if (target.id === elementId)
        return true;
    var parent = target.parentElement;
    while (!!parent) {
        if (parent.id === elementId)
            return true;
        parent = parent.parentElement;
    }
    return false;
}
exports.isInsideElement = isInsideElement;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(290);
exports.default = {
    requiredLabel: 'ssg-forms-label',
    requiredLegend: 'ssg-forms-label',
    legendWrapper: 'ssg-legend-wrapper',
    requiredIndicator: "ssg-forms-required-indicator",
    errorIndicator: 'ssg-forms-error-icon',
    tooltipGroup: "tooltip-group",
    noContent: 'ssg-forms-no-content',
    centeredTextWrapper: 'ssg-legend-centered-text-wraper'
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var descriptors_style_1 = __webpack_require__(33);
var RequiredIndicator = /** @class */ (function (_super) {
    __extends(RequiredIndicator, _super);
    function RequiredIndicator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RequiredIndicator.prototype.render = function () {
        var _a = this.props, isRequired = _a.isRequired, css = _a.css;
        if (isRequired)
            return React.createElement("span", { className: css.requiredIndicator });
        else
            return null;
    };
    return RequiredIndicator;
}(React.Component));
exports.default = react_styleable_1.default(descriptors_style_1.default)(RequiredIndicator);


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var save_button_1 = __webpack_require__(402);
exports.SaveButton = save_button_1.default;
var save_button_style_1 = __webpack_require__(113);
exports.defaultSaveButtonStyle = save_button_style_1.default;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(303);
var defaultStyle = {
    tabsDisplay: '',
    activeTab: "ssg-forms-tab active",
    inactiveTab: "ssg-forms-tab",
    header: "ssg-forms-tab-header",
    tabList: "ssg-forms-tab-list",
    tabListItem: "ssg-forms-tab-list-item",
    tabPanel: ""
};
exports.default = defaultStyle;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = require("moment");

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_validation_definition_1 = __webpack_require__(44);
var form_constants_1 = __webpack_require__(5);
var form_rules_1 = __webpack_require__(21);
var moment = __webpack_require__(37);
exports.FormRecord = immutable_1.Record({
    id: '',
    name: '',
    heading: '',
    elements: immutable_1.List([]),
    rules: immutable_1.List([]),
    maxTotalAttachmentSize: null,
    includeRecaptcha: false,
});
/** Immutable SSG Form */
var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form(props) {
        return _super.call(this, props) || this;
    }
    return Form;
}(exports.FormRecord));
exports.Form = Form;
;
exports.FormStateRecord = immutable_1.Record({
    form: new Form({}),
    allPrograms: immutable_1.List([]),
    selectedPrograms: undefined,
    defaultSelectedPrograms: immutable_1.List([]),
    value: immutable_1.Map({}),
    defaultValue: immutable_1.Map({}),
    validationResult: new form_validation_definition_1.ValidationResult({}),
    recaptchaValue: '',
});
/** The Immutable SSG Form State */
var FormState = /** @class */ (function (_super) {
    __extends(FormState, _super);
    function FormState(props) {
        return _super.call(this, props) || this;
    }
    return FormState;
}(exports.FormStateRecord));
exports.FormState = FormState;
/**
 * Searches through all the elements in the form state to find one with a matching id.
 * This will short circuit as soon as the element is found.
 * @param state the form state
 * @param elementId the identifier of the element
 * @returns the immutable form element with an id that equals elementId
 */
function getElementById(state, elementId) {
    if (!elementId) {
        return undefined;
    }
    var element = getElementByIdRecursive(state.form.elements.toArray(), elementId);
    return element;
}
exports.getElementById = getElementById;
/**
 * Recursively searches through a list of elements for an element with a particular id. This is a breadth first search,
 * so it starts with the top level elements first and then, if the element has not been found, it will search the first level of subElements.
 * @param elements the list of elements to search through
 * @param elementId the id of the element we are searching for
 */
function getElementByIdRecursive(elements, elementId) {
    var subElements = [];
    var foundElement = undefined;
    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        if (!element) {
            break;
        }
        else if (element.id === elementId) {
            foundElement = element;
            break;
        }
        else if (element.type === form_constants_1.elementTypes.group) {
            subElements.push.apply(subElements, element.subElements);
        }
    }
    if (!foundElement && subElements.length > 0) {
        foundElement = getElementByIdRecursive(subElements, elementId);
    }
    return foundElement;
}
/**
 * returns the current value of a specific form element in the FormState, merging the value and defaultValues in the state
 * @param {object} state the current FormState
 * @param {string} elementId id of the form element
 */
function getValue(state, elementId, country) {
    var element = getElementById(state, elementId);
    if (!element)
        return undefined;
    var value = state.value, defaultValue = state.defaultValue;
    var elementValue = value && value.get(elementId);
    var elementDefaultValue = defaultValue && defaultValue.get(elementId);
    if (element.type === form_constants_1.elementTypes.group) {
        if (!element.dataFormat)
            return undefined;
        switch (element.dataFormat.type) {
            case form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER:
                var mcValue = getValue(state, element.dataFormat.mcElementId);
                var otherValue = getValue(state, element.dataFormat.otherTextElementId);
                return { mcValue: mcValue, otherValue: otherValue };
            case form_constants_1.dataFormatType.ZIP_EXTENSION: {
                var zipValue = getValue(state, element.dataFormat.zipElementId);
                var extensionValue = getValue(state, element.dataFormat.extensionElementId);
                var groupValue = zipValue ? zipValue : '';
                if (zipValue && extensionValue)
                    groupValue += "-" + extensionValue;
                return groupValue;
            }
            case form_constants_1.dataFormatType.NONE:
            default:
                return undefined;
        }
    }
    else if (element.type === form_constants_1.elementTypes.date) {
        // allows for correct date formatting when viewing or editing existing records
        var dateFormattedValue = void 0;
        switch (country) {
            case form_constants_1.CountryEnum.UnitedKingdom:
                dateFormattedValue = moment(elementDefaultValue).format('DD/MM/YYYY');
                break;
            case form_constants_1.CountryEnum.Canada:
                dateFormattedValue = moment(elementDefaultValue).format('YYYY-MM-DD');
                break;
            case form_constants_1.CountryEnum.UnitedStates:
            default:
                dateFormattedValue = elementDefaultValue;
                break;
        }
        return elementValue || dateFormattedValue || undefined;
    }
    else {
        return elementValue || elementDefaultValue || undefined;
    }
}
exports.getValue = getValue;
/** gets the currently selected programs, merges list of defaultSelectedPrograms with selectedPrograms */
function getSelectedPrograms(_a) {
    var selectedPrograms = _a.selectedPrograms, defaultSelectedPrograms = _a.defaultSelectedPrograms;
    return selectedPrograms !== undefined ? selectedPrograms : defaultSelectedPrograms ? defaultSelectedPrograms : immutable_1.List([]);
}
exports.getSelectedPrograms = getSelectedPrograms;
/**
 * Returns whether the specified element is capable of storing user input
 * @param type the type of element in question
 */
function elementStoresData(type) {
    switch (type) {
        case form_constants_1.elementTypes.emailNotification:
        case form_constants_1.elementTypes.heading:
        case form_constants_1.elementTypes.help:
        case form_constants_1.elementTypes.html:
        case form_constants_1.elementTypes.ignore:
        case form_constants_1.elementTypes.page:
        case form_constants_1.elementTypes.undefined:
        case form_constants_1.elementTypes.unsupported:
            return false;
        default:
            return true;
    }
}
exports.elementStoresData = elementStoresData;
/**
 * Determines if a given value should be considered empty based on the form element definition
 * @param element the definition of the element we are evaluating
 * @param value the current value of the element
 * @param state the form state, to get values for subElements of a group
 * @returns true if the given value should be considered empty
 */
function hasEmptyValue(element, value, state) {
    if (state === void 0) { state = new FormState({}); }
    switch (element.type) {
        case form_constants_1.elementTypes.radio:
        case form_constants_1.elementTypes.select:
        case form_constants_1.elementTypes.checkbox:
        case form_constants_1.elementTypes.likert:
            return !value || (immutable_1.List.isList(value) && value.size === 0);
        case form_constants_1.elementTypes.number:
            return value === undefined || value === null || value === "";
        case form_constants_1.elementTypes.group:
            var emptyGroup = true;
            element.subElements.forEach(function (subElement) {
                var subElementValue = getValue(state, subElement.id);
                if (!subElement.hidden && !subElement.disabled)
                    emptyGroup = emptyGroup && hasEmptyValue(subElement, subElementValue, state);
            });
            return emptyGroup;
        case form_constants_1.elementTypes.electronicSignature:
            if (value === undefined)
                return true;
            if (typeof (value) !== 'object')
                return false;
            if (element.mode === form_constants_1.electronicSignatureModes.ETO) {
                var coord = value.get('etoCoords');
                return (!coord || coord.size === 0);
            }
            else if (element.mode === form_constants_1.electronicSignatureModes.APRICOT) {
                var coord = value.get('imageUrl');
                return (!coord || coord.length === 0);
            }
            else {
                return true;
            }
        case form_constants_1.elementTypes.time:
            if (!!value && typeof (value) !== 'object') {
                return false;
            }
            return !value || (!value.hour && !value.minute);
        default: return !elementStoresData(element.type) || !value;
    }
}
exports.hasEmptyValue = hasEmptyValue;
/**
 * This function returns an altered version of the subElement, based on its parent groupElement.
 * If the groupElement is hidden, disabled, isRequired, or readOnly then the modified subElement will also have those properties.
 * @param groupElement the group element definition
 * @param subElement the sub element within the group
 * @returns a modified version of the subElement
 */
function getModifiedSubElement(groupElement, subElement) {
    var modifiedElement = subElement;
    modifiedElement = modifiedElement.set('hidden', groupElement.hidden || subElement.hidden)
        .set('disabled', groupElement.disabled || subElement.disabled);
    if (elementStoresData(subElement.type)) {
        var inputElement = subElement;
        var requiredByGroup = groupElement.isRequired && isSubElementRequiredByGroup(groupElement, subElement);
        modifiedElement = modifiedElement.set('isRequired', requiredByGroup || inputElement.isRequired)
            .set('readOnly', groupElement.readOnly || inputElement.readOnly);
    }
    return modifiedElement;
}
exports.getModifiedSubElement = getModifiedSubElement;
/**
 * Determines if a particular subElement should required when the group is required
 * @param groupElement the group element, containing all subElements
 * @param subElement the particular subElement being evaluated
 */
function isSubElementRequiredByGroup(groupElement, subElement) {
    var requiredDefinition = groupElement.requiredDefinition;
    // defaults to ALL option
    if (!requiredDefinition) {
        return true;
    }
    switch (requiredDefinition.type) {
        case form_constants_1.requireType.SOME:
            var subElementId_1 = subElement.id;
            return requiredDefinition.requiredSubElements &&
                requiredDefinition.requiredSubElements.some(function (val) { return val === subElementId_1; });
        case form_constants_1.requireType.ANY:
            return false;
        case form_constants_1.requireType.ALL:
        default:
            return true;
    }
}
exports.isSubElementRequiredByGroup = isSubElementRequiredByGroup;
/**
 * Gets information about a particular element including the path needed to update it in the form state.
 * This unlike getAllElementInfo will short circuit when it finds the given element.
 * @param state the form state that contains the elements
 * @param elementId the id of the element that we want to find
 */
function getElementInfo(state, elementId) {
    var form = state.form;
    var elements = form.elements;
    var basePath = ['form', 'elements'];
    return recursiveGetElementInfo(elements.toArray(), basePath, elementId);
}
exports.getElementInfo = getElementInfo;
/**
 * Recursive search function that returns an element and the path to get to it.
 * @param elements the list of elements to search through
 * @param path the path to get to this list of elements
 * @param elementId the id of the element we are searching for
 */
function recursiveGetElementInfo(elements, path, elementId) {
    var groupElements = [];
    var foundElement = undefined;
    for (var i = 0; i < elements.length; i++) {
        var element = elements[i];
        if (element.id === elementId) {
            var defaultPath = path.concat([i]);
            foundElement = {
                element: element,
                path: defaultPath
            };
            break;
        }
        else if (element.type === form_constants_1.elementTypes.group) {
            var groupPath = path.concat([i, 'subElementsList']);
            groupElements.push({
                element: element,
                path: groupPath
            });
        }
    }
    if (!foundElement && groupElements.length > 0) {
        for (var i = 0; i < groupElements.length; i++) {
            var groupInfo = groupElements[i];
            foundElement = recursiveGetElementInfo(groupInfo.element.subElements, groupInfo.path, elementId);
            if (foundElement) {
                break;
            }
        }
    }
    return foundElement;
}
/**
 * This will get all the elements in the formstate that have isPreviewElement set to true
 * @param state the form state that contains the elements
 */
function getAllPreviewElementInfo(state) {
    var allElements = getAllElementInfo(state);
    return allElements.filter(function (val) { return val.element.isPreviewElement; });
}
exports.getAllPreviewElementInfo = getAllPreviewElementInfo;
/**
 * This will search through all the elements in the formstate and return [[ElementInformation]] for all of them
 * @param state the form state that contains the elements
 */
function getAllElementInfo(state) {
    var form = state.form;
    var elements = form.elements;
    var basePath = ['form', 'elements'];
    return recursiveGetAllElements(elements, basePath);
}
exports.getAllElementInfo = getAllElementInfo;
/**
 * A recursive function that will go through the list of elements and return information about them.
 * If the list contains any group elements it will also process the subElements of that group.
 * @param elements list of elements to get information about
 * @param path the current path in the form state to this list of elements
 */
function recursiveGetAllElements(elements, path) {
    var allElements = [];
    elements && elements.forEach(function (element, index) {
        switch (element.type) {
            case form_constants_1.elementTypes.group: {
                var groupPath = path.concat([index, 'subElementsList']);
                allElements.push.apply(allElements, recursiveGetAllElements(element.subElementsList, groupPath));
            }
            default:
                var defaultPath = path.concat([index]);
                allElements.push({
                    element: element,
                    path: defaultPath
                });
                break;
        }
    });
    return allElements;
}
/**
 * Given an IOperationCondition, traverse the subconditions
 * to build a list of all element ids that are referenced within.
 * This will recurse as necessary.
 * @param opCond The operation condition to flatten.
 * @returns Array<string> of all the element ids utilized in the given opCond.
 */
function flattenOpConditionIds(opCond) {
    var idList = [];
    opCond.conditions.forEach(function (oneCon) {
        if (form_rules_1.isConditionOperatorType(oneCon.type)) {
            // recurse
            var opCond_1 = oneCon;
            idList = idList.concat(flattenOpConditionIds(opCond_1));
        }
        else if (form_rules_1.isConditionElementComparisonType(oneCon.type)) {
            // add the element id and the value
            var compCond_1 = oneCon;
            if (idList.findIndex(function (id) { return id === compCond_1.elementId; }) === -1) {
                idList.push(compCond_1.elementId);
            }
            if (idList.findIndex(function (id) { return id === compCond_1.value; }) === -1) {
                idList.push(compCond_1.value);
            }
        }
        else if (form_rules_1.isConditionElementStateType(oneCon.type)) {
            // just add the element id
            var stateCond_1 = oneCon;
            if (idList.findIndex(function (id) { return id === stateCond_1.elementId; }) === -1) {
                idList.push(stateCond_1.elementId);
            }
        }
        else if (form_rules_1.isConditionElementValueType(oneCon.type)) {
            // just add the element id
            var valCond_1 = oneCon;
            if (idList.findIndex(function (id) { return id === valCond_1.elementId; }) === -1) {
                idList.push(valCond_1.elementId);
            }
        }
    });
    return idList;
}
exports.flattenOpConditionIds = flattenOpConditionIds;
/**
 * Checks form rules for the associated element. If that element is affected by any rules on the form,
 * return a list of the element ids that are assessed by those rules (if the rules are supported)
 * @param baseForm The original form that contains the rules and set of elements we need to process.
 * @param elementId id of the form element to check which rules affect it
 * @returns {Array} list of element ids as strings. these are elements which are
 *  assessed in a form rule whose conditions may result in an action being taken on the target element
 */
function getAssessedElementsForTarget(baseForm, elementId) {
    var assessedElements = [];
    if (!baseForm || !elementId) {
        // no valid form or element id to check; return empty array.
        return assessedElements;
    }
    if (!baseForm.rules || baseForm.rules.size === 0) {
        // form and id are valid, but the rules do not exist, or the rule
        // list is empty. Return empty array in this case too.
        return assessedElements;
    }
    var rules = baseForm.rules;
    var addAssessedForRule;
    rules.forEach(function (rule) {
        var condition = rule.condition, conditionActions = rule.conditionActions, disabled = rule.disabled;
        if (disabled || !form_rules_1.isRuleSupported(rule)) {
            // do not stealth add in this case
            return;
        }
        addAssessedForRule = false;
        // if the passed in elementId appears anywhere in our condition actions,
        // we have work to do
        conditionActions && conditionActions.forEach(function (ca) {
            var targetElement = ca.elementId;
            if (targetElement === elementId) {
                addAssessedForRule = true;
            }
        });
        // if the conditional rule affects the element in question, add the assessed elements to the list
        if (addAssessedForRule) {
            if (form_rules_1.isConditionOperatorType(condition.type)) {
                var opCond = condition;
                assessedElements = assessedElements.concat(flattenOpConditionIds(opCond));
            }
            else {
                if (form_rules_1.isConditionElementComparisonType(condition.type)) {
                    var compCond_2 = condition;
                    if (compCond_2.elementId !== elementId && !assessedElements.find(function (ae) { return ae === compCond_2.elementId; })) {
                        assessedElements.push(compCond_2.elementId);
                    }
                    if (compCond_2.value !== elementId && !assessedElements.find(function (ae) { return ae === compCond_2.value; })) {
                        assessedElements.push(compCond_2.value);
                    }
                }
                else if (form_rules_1.isConditionElementStateType(condition.type)) {
                    var stateCond_2 = condition;
                    if (!assessedElements.find(function (ae) { return ae === stateCond_2.elementId; })) {
                        assessedElements.push(stateCond_2.elementId);
                    }
                }
                else if (form_rules_1.isConditionElementValueType(condition.type)) {
                    var valCond_2 = condition;
                    if (!assessedElements.find(function (ae) { return ae === valCond_2.elementId; })) {
                        assessedElements.push(valCond_2.elementId);
                    }
                }
            }
        }
    }); // end rules iteration
    return assessedElements;
}
exports.getAssessedElementsForTarget = getAssessedElementsForTarget;
//# sourceMappingURL=form-definition.js.map

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var basic_data_format_1 = __webpack_require__(126);
exports.ImmutableBasicDataFormat = basic_data_format_1.ImmutableBasicDataFormat;
var mc_other_format_1 = __webpack_require__(127);
exports.ImmutableMCOtherFormat = mc_other_format_1.ImmutableMCOtherFormat;
var zip_format_1 = __webpack_require__(128);
exports.ImmutableZipExtensionFormat = zip_format_1.ImmutableZipExtensionFormat;
var form_constants_1 = __webpack_require__(5);
/**
 * converts a non-immutable definition of a required definition, and converts it into an immutable definition
 * @param definition the non-immutable definition
 */
function convertToImmutable(definition) {
    if (!definition)
        return null;
    switch (definition.type) {
        case form_constants_1.dataFormatType.NONE: return new basic_data_format_1.ImmutableBasicDataFormat(definition);
        case form_constants_1.dataFormatType.ZIP_EXTENSION: return new zip_format_1.ImmutableZipExtensionFormat(definition);
        case form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER: return new mc_other_format_1.ImmutableMCOtherFormat(definition);
        default: return null;
    }
}
exports.convertToImmutable = convertToImmutable;
//# sourceMappingURL=index.js.map

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var form_constants_1 = __webpack_require__(5);
exports.defaultValues = {
    id: '',
    label: '',
    typeLabel: '',
    ariaLabel: '',
    type: form_constants_1.elementTypes.undefined,
    disabled: false,
    hidden: false,
    isPreviewElement: false,
};
//# sourceMappingURL=form-element-base.js.map

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var basic_required_1 = __webpack_require__(138);
exports.ImmutableBasicRequiredDefinition = basic_required_1.ImmutableBasicRequiredDefinition;
var some_required_1 = __webpack_require__(139);
exports.ImmutableSomeRequiredDefinition = some_required_1.ImmutableSomeRequiredDefinition;
var form_constants_1 = __webpack_require__(5);
/**
 * converts a non-immutable definition of a required definition, and converts it into an immutable definition
 * @param definition the non-immutable definition
 */
function convertToImmutable(definition) {
    if (!definition)
        return null;
    switch (definition.type) {
        case form_constants_1.requireType.ALL:
        case form_constants_1.requireType.ANY: return new basic_required_1.ImmutableBasicRequiredDefinition(definition);
        case form_constants_1.requireType.SOME: return new some_required_1.ImmutableSomeRequiredDefinition(definition);
        default: return null;
    }
}
exports.convertToImmutable = convertToImmutable;
//# sourceMappingURL=index.js.map

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var form_constants_1 = __webpack_require__(5);
exports.defaultValues = {
    type: form_constants_1.requireType.ALL,
    requireCompleteResponse: false,
};
//# sourceMappingURL=required-definition.js.map

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var rule_constants_1 = __webpack_require__(15);
/** An action that changes a Form in some way */
var IFormAction = /** @class */ (function () {
    function IFormAction() {
    }
    return IFormAction;
}());
exports.IFormAction = IFormAction;
exports.defaultValues = {
    type: rule_constants_1.actionTypes.hide,
    elementId: '',
    value: undefined,
};
/** factory that generates immutable form actions */
exports.FormActionRecord = immutable_1.Record(exports.defaultValues);
/** immutable class that represents an [[IFormAction]] */
var ImmutableFormAction = /** @class */ (function (_super) {
    __extends(ImmutableFormAction, _super);
    function ImmutableFormAction(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableFormAction;
}(exports.FormActionRecord));
exports.ImmutableFormAction = ImmutableFormAction;
//# sourceMappingURL=form-action.js.map

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
exports.ErrorRecord = immutable_1.Record({
    id: '',
    sourceId: '',
    subSection: '',
    type: '',
    context: '',
    errorMessage: '',
});
var Error = /** @class */ (function (_super) {
    __extends(Error, _super);
    function Error(props) {
        return _super.call(this, props) || this;
    }
    return Error;
}(exports.ErrorRecord));
exports.Error = Error;
;
exports.ValidationResultRecord = immutable_1.Record({
    passedValidation: true,
    errors: immutable_1.List([])
});
var ValidationResult = /** @class */ (function (_super) {
    __extends(ValidationResult, _super);
    function ValidationResult(props) {
        return _super.call(this, props) || this;
    }
    return ValidationResult;
}(exports.ValidationResultRecord));
exports.ValidationResult = ValidationResult;
;
//# sourceMappingURL=form-validation-definition.js.map

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var form_definition_1 = __webpack_require__(17);
var immutable_1 = __webpack_require__(2);
var actionTypes = form_definition_1.formRuleTypes.actionTypes;
/**
 * this function applies a form action to the state, modifying the state based on the action's
 * type, value and the elementId of the associated element
 * @param {FormState} state initial FormState before the ation is applied
 * @param {FormAction} action the action to be applied ot the FormState
 */
function actionReducer(state, action) {
    var elementId = action.elementId, actionType = action.type, actionValue = action.value;
    if (actionType === actionTypes.ignore)
        return state;
    var info = form_definition_1.getElementInfo(state, elementId);
    var element = info && info.element;
    if (!element) {
        return state;
    }
    // modify the state based on the actionType and element information
    switch (actionType) {
        case actionTypes.makeRequired: {
            if (!form_definition_1.elementStoresData(element.type)) {
                // cannot make elements required that do not store user input
                return state;
            }
            if (element.hidden) {
                return state.setIn(info.path.concat(['hidden']), false).setIn(info.path.concat(['isRequired']), true);
            }
            return state.setIn(info.path.concat(['isRequired']), true);
        }
        case actionTypes.makeNotRequired: {
            if (!form_definition_1.elementStoresData(element.type)) {
                // cannot make elements required that do not store user input
                return state;
            }
            return state.setIn(info.path.concat(['isRequired']), false);
        }
        case actionTypes.hide: {
            return state.setIn(info.path.concat(['hidden']), true);
        }
        case actionTypes.show: {
            return state.setIn(info.path.concat(['hidden']), false);
        }
        case actionTypes.setDefault: {
            var modifiedValue = getActionValue(element, actionValue);
            return state.setIn(['defaultValue', element.id], modifiedValue);
        }
        case actionTypes.setValue: {
            var modifiedValue = getActionValue(element, actionValue);
            return state.setIn(info.path.concat(['readOnly']), true)
                .setIn(['value', element.id], modifiedValue);
        }
        case actionTypes.changeCountry: {
            switch (element.type) {
                case form_definition_1.elementTypes.postalCode:
                    return state.setIn(info.path.concat(['country']), action.value);
                default:
                    return state;
            }
        }
        case actionTypes.disable: {
            return state.setIn(info.path.concat(['disabled']), true);
        }
        case actionTypes.enable: {
            return state.setIn(info.path.concat(['disabled']), false);
        }
        case actionTypes.lock: {
            return state.setIn(info.path.concat(['readOnly']), true);
        }
        case actionTypes.unlock: {
            return state.setIn(info.path.concat(['readOnly']), false);
        }
        default: return state;
    }
}
exports.actionReducer = actionReducer;
function getActionValue(element, value) {
    if (!element)
        return value;
    switch (element.type) {
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
            return immutable_1.List(value);
        default:
            return value;
    }
}
//# sourceMappingURL=action.reducer.js.map

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var form_definition_1 = __webpack_require__(17);
var utilities_1 = __webpack_require__(22);
var moment = __webpack_require__(37);
var form_constants_1 = __webpack_require__(5);
var programOperators = __webpack_require__(157);
var conditionTypes = form_definition_1.formRuleTypes.conditionTypes, operationTypes = form_definition_1.formRuleTypes.operationTypes;
/**
 * this function will check if a condition is met based on a given state.
 * Conditions cannot be evaluated for 'group' elements
 * @param {FormState} state the FormState
 * @param {FormCondition} condition the condition to be checked against the state
 * @returns true if the condition is met, and false if it is not.
 */
function conditionReducer(state, condition) {
    // determine if the condition is met based on conditionType and element information
    switch (condition.type) {
        case conditionTypes.operator: {
            var conditionResults = [];
            condition.conditions.forEach(function (subCondition) {
                conditionResults.push(conditionReducer(state, subCondition));
            });
            if (conditionResults.length === 0) {
                return true;
            }
            switch (condition.operator) {
                case operationTypes.And:
                    return conditionResults.every(function (result) { return result; });
                case operationTypes.Or:
                    return conditionResults.some(function (result) { return result; });
                default:
                    return false;
            }
        }
        case conditionTypes.static: {
            return condition.value;
        }
        case conditionTypes.programEmpty:
        case conditionTypes.programNotEmpty:
        case conditionTypes.programContains:
        case conditionTypes.programNotContains:
        case conditionTypes.programMatchesAny:
        case conditionTypes.programNotMatchesAny:
        case conditionTypes.programMatchesAll:
        case conditionTypes.programNotMatchesAll: {
            return programConditionReducer(state, condition);
        }
        case conditionTypes.empty:
        case conditionTypes.notEmpty:
        case conditionTypes.equal:
        case conditionTypes.notEqual:
        case conditionTypes.equalLabel:
        case conditionTypes.notEqualLabel:
        case conditionTypes.equalMaskedMulti:
        case conditionTypes.notEqualMaskedMulti:
        case conditionTypes.contains:
        case conditionTypes.containsString:
        case conditionTypes.notContainString:
        case conditionTypes.lessThan:
        case conditionTypes.lessThanOrEqual:
        case conditionTypes.greaterThan:
        case conditionTypes.greaterThanOrEqual:
        case conditionTypes.equalElement:
        case conditionTypes.notEqualElement:
        case conditionTypes.lessThanElement:
        case conditionTypes.lessThanOrEqualElement:
        case conditionTypes.greaterThanElement:
        case conditionTypes.greaterThanOrEqualElement:
        case conditionTypes.beginsWith:
        case conditionTypes.notBeginWith:
        case conditionTypes.endsWith:
        case conditionTypes.notEndWith:
        case conditionTypes.matchesAny:
        case conditionTypes.notMatchAny:
        case conditionTypes.matchesAnyMaskedMulti:
        case conditionTypes.notMatchAnyMaskedMulti:
        case conditionTypes.matchesEvery:
        case conditionTypes.notMatchEvery:
        case conditionTypes.earlierThanNow:
        case conditionTypes.earlierThanNowOrEqual:
        case conditionTypes.laterThanNow:
        case conditionTypes.laterThanNowOrEqual:
        case conditionTypes.between:
        case conditionTypes.notBetween:
        case conditionTypes.today:
        case conditionTypes.notToday:
        case conditionTypes.thisWeek:
        case conditionTypes.notThisWeek:
        case conditionTypes.thisMonth:
        case conditionTypes.notThisMonth:
        case conditionTypes.thisYear:
        case conditionTypes.notThisYear:
        case conditionTypes.last:
        case conditionTypes.notLast:
        case conditionTypes.next:
        case conditionTypes.notNext:
            return elementConditionReducer(state, condition);
        default: return false;
    }
}
exports.conditionReducer = conditionReducer;
/**
 * Function that will evaluate conditions that deal with elements
 * @param state form state
 * @param condition form element condition
 */
function elementConditionReducer(state, condition) {
    var elementId = condition.elementId, conditionType = condition.type;
    var element = form_definition_1.getElementById(state, elementId);
    // can evaluate if groups are empty/notEmpty
    if (!element || (element.type === form_definition_1.elementTypes.group && !isValidGroup(element, condition)))
        return false;
    var elementValue = form_definition_1.getValue(state, elementId);
    switch (condition.type) {
        case conditionTypes.equal:
            return checkEquality(element, elementValue, condition.value, state);
        case conditionTypes.notEqual:
            return !checkEquality(element, elementValue, condition.value, state);
        case conditionTypes.equalLabel:
            return checkEqualityLabel(element, elementValue, condition.value, state);
        case conditionTypes.notEqualLabel:
            return !checkEqualityLabel(element, elementValue, condition.value, state);
        case conditionTypes.equalMaskedMulti:
            return checkEqualityMaskedMulti(element, elementValue, condition.value, state);
        case conditionTypes.notEqualMaskedMulti:
            return !checkEqualityMaskedMulti(element, elementValue, condition.value, state);
        case conditionTypes.empty:
            return checkEmpty(element, elementValue, state);
        case conditionTypes.notEmpty:
            return !checkEmpty(element, elementValue, state);
        case conditionTypes.contains:
            return checkContains(element, elementValue, condition.value);
        case conditionTypes.containsString:
            return checkContainsString(element, elementValue, condition.value, state);
        case conditionTypes.notContainString:
            return checkNotContainString(element, elementValue, condition.value, state);
        case conditionTypes.equalElement:
            return checkEqualElement(state, element, elementValue, condition.value);
        case conditionTypes.notEqualElement:
            return !checkEqualElement(state, element, elementValue, condition.value);
        case conditionTypes.lessThan:
            return checkLessThan(element, elementValue, condition.value, state);
        case conditionTypes.lessThanOrEqual:
            return checkLessThanOrEqual(element, elementValue, condition.value, state);
        case conditionTypes.greaterThan:
            return checkGreaterThan(element, elementValue, condition.value, state);
        case conditionTypes.greaterThanOrEqual:
            return checkGreaterThanOrEqual(element, elementValue, condition.value, state);
        case conditionTypes.equalElement:
            return checkEqualElement(state, element, elementValue, condition.value);
        case conditionTypes.notEqualElement:
            return !checkEqualElement(state, element, elementValue, condition.value);
        case conditionTypes.lessThanElement:
            return checkLessThanElement(state, element, elementValue, condition.value);
        case conditionTypes.lessThanOrEqualElement:
            return checkLessThanOrEqualElement(state, element, elementValue, condition.value);
        case conditionTypes.greaterThanElement:
            return checkGreaterThanElement(state, element, elementValue, condition.value);
        case conditionTypes.greaterThanOrEqualElement:
            return checkGreaterThanOrEqualElement(state, element, elementValue, condition.value);
        case conditionTypes.beginsWith:
            return checkBeginsWith(element, elementValue, condition.value, state);
        case conditionTypes.notBeginWith:
            return checkNotBeginWith(element, elementValue, condition.value, state);
        case conditionTypes.endsWith:
            return checkEndsWith(element, elementValue, condition.value, state);
        case conditionTypes.notEndWith:
            return checkNotEndWith(element, elementValue, condition.value, state);
        case conditionTypes.matchesAny:
            return checkMatchesAny(element, elementValue, condition.value, state);
        case conditionTypes.notMatchAny:
            return checkNotMatchAny(element, elementValue, condition.value, state);
        case conditionTypes.matchesAnyMaskedMulti:
            return checkMatchesAnyMaskedMulti(element, elementValue, condition.value, state);
        case conditionTypes.notMatchAnyMaskedMulti:
            return !checkMatchesAnyMaskedMulti(element, elementValue, condition.value, state);
        case conditionTypes.matchesEvery:
            return checkMatchesEvery(element, elementValue, condition.value, state);
        case conditionTypes.notMatchEvery:
            return checkNotMatchEvery(element, elementValue, condition.value, state);
        case conditionTypes.earlierThanNow:
            return checkEarlierThanNow(element, elementValue, state);
        case conditionTypes.earlierThanNowOrEqual:
            return checkEarlierThanNowOrEqual(element, elementValue, state);
        case conditionTypes.laterThanNow:
            return checkLaterThanNow(element, elementValue, state);
        case conditionTypes.laterThanNowOrEqual:
            return checkLaterThanNowOrEqual(element, elementValue, state);
        case conditionTypes.today:
            return checkToday(element, elementValue);
        case conditionTypes.notToday:
            return checkNotToday(element, elementValue);
        case conditionTypes.thisWeek:
            return checkThisWeek(element, elementValue);
        case conditionTypes.notThisWeek:
            return checkNotThisWeek(element, elementValue);
        case conditionTypes.thisMonth:
            return checkThisMonth(element, elementValue);
        case conditionTypes.notThisMonth:
            return checkNotThisMonth(element, elementValue);
        case conditionTypes.thisYear:
            return checkThisYear(element, elementValue);
        case conditionTypes.notThisYear:
            return checkNotThisYear(element, elementValue);
        case conditionTypes.between:
            return checkBetween(element, elementValue, condition.value, state);
        case conditionTypes.notBetween:
            return checkNotBetween(element, elementValue, condition.value, state);
        case conditionTypes.last:
            return checkLast(element, elementValue, condition.value, state);
        case conditionTypes.notLast:
            return checkNotLast(element, elementValue, condition.value, state);
        case conditionTypes.next:
            return checkNext(element, elementValue, condition.value, state);
        case conditionTypes.notNext:
            return checkNotNext(element, elementValue, condition.value, state);
    }
}
exports.elementConditionReducer = elementConditionReducer;
/**
 * Function that will evaluate conditions that deal with programs
 * @param state form state
 * @param condition program condition
 */
function programConditionReducer(state, condition) {
    var allPrograms = state.allPrograms;
    var selectedPrograms = form_definition_1.getSelectedPrograms(state);
    switch (condition.type) {
        case conditionTypes.programEmpty:
            return programOperators.hasEmptyProgramValue(selectedPrograms);
        case conditionTypes.programNotEmpty:
            return !programOperators.hasEmptyProgramValue(selectedPrograms);
        case conditionTypes.programContains:
            return programOperators.programNameContains(selectedPrograms, allPrograms, condition.value);
        case conditionTypes.programNotContains:
            return !programOperators.programNameContains(selectedPrograms, allPrograms, condition.value);
        case conditionTypes.programMatchesAny:
            return programOperators.programAnySelected(selectedPrograms, condition.value);
        case conditionTypes.programNotMatchesAny:
            return !programOperators.programAnySelected(selectedPrograms, condition.value);
        case conditionTypes.programMatchesAll:
            return programOperators.programAllSelected(selectedPrograms, condition.value);
        case conditionTypes.programNotMatchesAll:
            return !programOperators.programAllSelected(selectedPrograms, condition.value);
        default:
            return false;
    }
}
exports.programConditionReducer = programConditionReducer;
/**
 * Determines if a group element has sufficient information to be evaluated by conditional rules
 * @param groupElement the group element to evaluate
 * @param condition the condition evaluating it
 */
function isValidGroup(groupElement, condition) {
    if (groupElement.dataFormat && groupElement.dataFormat.type !== form_constants_1.dataFormatType.NONE)
        return true;
    if (condition.type === conditionTypes.empty || condition.type === conditionTypes.notEmpty)
        return true;
    return false;
}
/**
 * Determines if element value and condition value are equal for text, email, date, and zip
 * @param element
 * @param elementValue
 * @param conditionValue
 * @param formState
 */
function textEqualityCheck(elementValue, conditionValue) {
    // need to do a case-insensitive compare
    var stringValue = elementValue;
    var conditionString = conditionValue;
    if (stringValue == null && conditionString == null) {
        // both null
        return true;
    }
    if (stringValue == null || conditionString == null) {
        // only one null
        return false;
    }
    // neither one is null; do a case insensitive comparison.
    // MUST trim spaces first.
    return stringValue.trim().toLowerCase() === conditionString.trim().toLowerCase();
}
/**
* This function handles comparing equalilty for a given element and a provided value for various element types
* @param {FormElement} element the form element that is being evaluated by the condition
* @param {any} elementValue  the value of the element being evaluated
* @param {any} conditionValue the value on the condition
*/
function checkEquality(element, elementValue, conditionValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio: {
            var mcValue = elementValue && elementValue.toJS();
            return utilities_1.arrayExtensions.compareArrays(mcValue, conditionValue);
        }
        case form_definition_1.elementTypes.number: {
            var numberValue = utilities_1.numberUtilities.stringToNumber(elementValue);
            var conditionNumber = utilities_1.numberUtilities.stringToNumber(conditionValue);
            return numberValue === conditionNumber;
        }
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.email:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.date: {
            return textEqualityCheck(elementValue, conditionValue);
        }
        case form_definition_1.elementTypes.time: {
            if (form_definition_1.hasEmptyValue(element, elementValue, formState))
                return false;
            var timeString = utilities_1.timeUtilities.getTimeString(elementValue, element.isMilitaryTime);
            var timeValue = moment.utc(timeString, 'HH:mm:ss');
            var conditionTime = moment.utc(conditionValue, 'HH:mm:ss');
            return timeValue.isSame(conditionTime, 'minute');
        }
        case form_definition_1.elementTypes.group: {
            switch (element.dataFormat.type) {
                case form_constants_1.dataFormatType.ZIP_EXTENSION: {
                    return textEqualityCheck(elementValue, conditionValue);
                }
                default: return false;
            }
        }
        default:
            return elementValue === conditionValue;
    }
}
/**
 * This function handles comparing equalilty for a given element and a provided value for various element types
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {any} conditionValue the value on the condition
 */
function checkEqualityLabel(element, elementValue, conditionValue, formState) {
    if (!elementValue || elementValue === undefined || elementValue === null) {
        return false;
    }
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.radio: {
            var condition = conditionValue.split("|").map(function (val) { return val.toLowerCase(); });
            var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.label.toLowerCase(); });
            return utilities_1.arrayExtensions.compareArrays(mcValue, condition);
        }
        case form_definition_1.elementTypes.group: {
            switch (element.dataFormat.type) {
                case form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER: {
                    if (!elementValue)
                        return false;
                    var condition_1 = conditionValue.split("|").map(function (val) { return val.toLowerCase(); });
                    var mcValue_1 = form_definition_1.groupDataFormatHelpers.getMCOtherLabels(element, elementValue, formState).map(function (result) { return result.toLowerCase(); });
                    return utilities_1.arrayExtensions.compareArrays(mcValue_1, condition_1);
                }
                default: return false;
            }
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * This function handles comparing equalilty for a given element and a provided value for various element types
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {any} conditionValue the value on the condition
 */
function checkEqualityMaskedMulti(element, elementValue, conditionValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert: {
            var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.numValue; });
            var mcNumValue = utilities_1.numberUtilities.stringToNumber(mcValue[0]);
            var conditionNumber = utilities_1.numberUtilities.stringToNumber(conditionValue);
            return mcNumValue === conditionNumber;
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element has an empty value for various element types
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkEmpty(element, elementValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert: {
            var mcValue = elementValue && elementValue.toJS();
            return !mcValue || mcValue.length <= 0;
        }
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.date: {
            // Null, empty string, and whitespace all count as empty.
            return !elementValue || elementValue === '' || elementValue.trim() === '';
        }
        default:
            return form_definition_1.hasEmptyValue(element, elementValue, state);
    }
}
/**
 * checks to see if an element value contains a given value for various element types
 * **NOTE**: for multiple choice, an array of values shoudl be provided for the conditionValue,
 * and **all** of those values in the array must be selected for the function to return true
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value on the condition
 */
function checkContains(element, elementValue, conditionValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert: {
            var mcValue = elementValue && elementValue.toJS();
            return !!mcValue && !!conditionValue && conditionValue.every(function (choiceValue) { return mcValue.includes(choiceValue); });
        }
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.email: {
            return !!elementValue && !!conditionValue && elementValue.trim().toLocaleUpperCase().includes(conditionValue.trim().toLocaleUpperCase());
        }
        default:
            return elementValue === conditionValue;
    }
}
/**
 * checks to see if an element value contains a given string (case-insensitive) for various element types.
 * The percent symbol (%) is used as a wildcard, meaning it will match any character in its position in the string.
 * **NOTE**: for multiple choice, this means that if **any** value
 * in the set of elementValues contains the conditionValue, the function returns true
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {string} conditionValue the value to check if the element's value contains
 */
function checkContainsString(element, elementValue, conditionValue, state) {
    // make case-insensitive
    var conditionStr = conditionValue.trim().toLocaleUpperCase();
    // regex format
    conditionStr = utilities_1.textUtilities.convertStrToRegExStr(conditionStr);
    // account for wildcard with regex symbol for wildcard
    conditionStr = conditionStr.replace(RegExp("%", "g"), ".");
    var conditionRegex = RegExp(conditionStr);
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert: {
            var mcElement = element;
            var options_1 = mcElement.options;
            var mcValue = elementValue && elementValue.toJS();
            return !!mcValue && !!conditionRegex && mcValue.some(function (choiceValue) {
                return options_1.find(function (opt) { return opt.value === choiceValue && conditionRegex.test(opt.label.trim().toLocaleUpperCase()); });
            });
        }
        case form_definition_1.elementTypes.group: {
            switch (element.dataFormat.type) {
                case form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER: {
                    if (!elementValue)
                        return false;
                    var mcValue = form_definition_1.groupDataFormatHelpers.getMCOtherLabels(element, elementValue, state);
                    return !!mcValue && !!conditionRegex && mcValue.some(function (choiceValue) { return conditionRegex.test(choiceValue.trim().toLocaleUpperCase()); });
                }
                case form_constants_1.dataFormatType.ZIP_EXTENSION: {
                    return !!elementValue && !!conditionRegex && conditionRegex.test(elementValue.trim().toLocaleUpperCase());
                }
                default: return false;
            }
        }
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.email: {
            return !!elementValue && !!conditionRegex && conditionRegex.test(elementValue.trim().toLocaleUpperCase());
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value does not contain a given string (case-insensitive) for various element types.
 * The percent symbol (%) is used as a wildcard, meaning it will match any character in its position in the string.
 * **NOTE**: for multiple choice, this means that if **any** value
 * in the set of elementValues contains the conditionValue, the function returns false
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {string} conditionValue the value to check if the element's value does not contain
 */
function checkNotContainString(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.email:
        case form_definition_1.elementTypes.group: {
            return !checkContainsString(element, elementValue, conditionValue, state);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if the value of an element is equal to the value of another element.
 * the condition value is equal to the elementId of the element to be compared.
 * the function handles the comparison for various element types of both the given element,
 * and the comparison element. when two elements cannot be compared the function returns false.
 * @param {FormState} state
 * @param {FormElement} element
 * @param {any} elementValue
 * @param {any} comparisonElementId
 */
function checkEqualElement(state, element, elementValue, comparisonElementId) {
    var comparisonElement = form_definition_1.getElementById(state, comparisonElementId);
    var comparisonValue = form_definition_1.getValue(state, comparisonElementId);
    if (!comparisonElement)
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert: {
            var mcValue = elementValue && elementValue.toJS();
            var choice = (mcValue && mcValue.length > 0) ? element.options.find(function (val) { return val.value === mcValue[0]; }) : undefined;
            var label = choice && choice.label;
            switch (comparisonElement.type) {
                case form_definition_1.elementTypes.select:
                case form_definition_1.elementTypes.radio:
                case form_definition_1.elementTypes.likert: {
                    var mcCompareValue = comparisonValue && comparisonValue.toJS();
                    if (!comparisonElement)
                        return false;
                    var comparisonChoice = (mcCompareValue && mcCompareValue.length > 0) ?
                        comparisonElement.options.find(function (val) { return val.value === mcCompareValue[0]; }) : undefined;
                    var comparisonLabel = comparisonChoice && comparisonChoice.label;
                    return label === comparisonLabel;
                }
                case form_definition_1.elementTypes.text:
                case form_definition_1.elementTypes.gisCoordinates:
                case form_definition_1.elementTypes.textArea: {
                    if (!label) {
                        if (!comparisonValue) {
                            return true;
                        }
                        else if (comparisonValue.trim() === '') {
                            return true;
                        }
                    }
                    return label != null && comparisonValue != null && label.trim().toLocaleUpperCase() === comparisonValue.trim().toLocaleUpperCase();
                }
                default:
                    return false;
            }
        }
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.textArea: {
            switch (comparisonElement.type) {
                case form_definition_1.elementTypes.select:
                case form_definition_1.elementTypes.radio:
                case form_definition_1.elementTypes.likert: {
                    var mcCompareValue = comparisonValue && comparisonValue.toJS();
                    if (!comparisonElement)
                        return false;
                    var comparisonChoice = (mcCompareValue && mcCompareValue.length > 0) ?
                        comparisonElement.options.find(function (val) { return val.value === mcCompareValue[0]; }) : undefined;
                    var comparisonLabel = comparisonChoice && comparisonChoice.label;
                    if (!comparisonLabel) {
                        if (!elementValue) {
                            return true;
                        }
                        else if (elementValue.trim() === '') {
                            return true;
                        }
                    }
                    return elementValue != null && comparisonLabel != null && elementValue.trim().toLocaleUpperCase() === comparisonLabel.trim().toLocaleUpperCase();
                }
                case form_definition_1.elementTypes.text:
                case form_definition_1.elementTypes.gisCoordinates:
                case form_definition_1.elementTypes.textArea: {
                    if (!elementValue) {
                        if (!comparisonValue) {
                            return true;
                        }
                        else if (comparisonValue.trim() === '') {
                            return true;
                        }
                    }
                    return elementValue != null && comparisonValue != null && elementValue.trim().toLocaleUpperCase() === comparisonValue.trim().toLocaleUpperCase();
                }
                default:
                    return false;
            }
        }
        case form_definition_1.elementTypes.number:
            switch (comparisonElement.type) {
                case form_definition_1.elementTypes.number:
                    var numberValue = utilities_1.numberUtilities.stringToNumber(elementValue);
                    var conditionNumber = utilities_1.numberUtilities.stringToNumber(comparisonValue);
                    return numberValue === conditionNumber;
                default: return false;
            }
        default:
            return elementValue === comparisonValue;
    }
}
/**
 * This function checks if the elementvalue is less than a constant value for numeric element types
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {string | number} conditionValue the value on the condition
 */
function checkLessThan(element, elementValue, conditionValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.number: {
            var numberValue = utilities_1.numberUtilities.stringToNumber(elementValue);
            var conditionNumber = utilities_1.numberUtilities.stringToNumber(conditionValue);
            return numberValue < conditionNumber;
        }
        case form_definition_1.elementTypes.time: {
            var timeString = utilities_1.timeUtilities.getTimeString(elementValue, element.isMilitaryTime);
            var timeValue = moment.utc(timeString, 'HH:mm:ss');
            var conditionTime = moment.utc(conditionValue, 'HH:mm:ss');
            return timeValue.isBefore(conditionTime, 'minute');
        }
        case form_definition_1.elementTypes.date: {
            var comparisonValue = moment(conditionValue, 'MM/DD/YYYY');
            var recordValue = moment(elementValue, 'MM/DD/YYYY');
            return recordValue.isBefore(comparisonValue, 'day');
        }
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.select:
            {
                var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.numValue; });
                var mcNumValue = utilities_1.numberUtilities.stringToNumber(mcValue[0]);
                var conditionNumber = utilities_1.numberUtilities.stringToNumber(conditionValue);
                return mcNumValue < conditionNumber;
            }
        default: return false;
    }
}
/**
* This function checks if the elementvalue is less than or equal than a constant for numeric element types
* @param {FormElement} element the form element that is being evaluated by the condition
* @param {any} elementValue  the value of the element being evaluated
* @param {string | number} conditionValue the value on the condition
*/
function checkLessThanOrEqual(element, elementValue, conditionValue, formState) {
    switch (element.type) {
        case form_definition_1.elementTypes.number: {
            return !checkGreaterThan(element, elementValue, conditionValue, formState);
        }
        case form_definition_1.elementTypes.time: {
            if (form_definition_1.hasEmptyValue(element, elementValue, formState))
                return false;
            return !checkGreaterThan(element, elementValue, conditionValue, formState);
        }
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue, formState))
                return false;
            var comparisonValue = moment(conditionValue, 'MM/DD/YYYY');
            var recordValue = moment(elementValue, 'MM/DD/YYYY');
            return recordValue.isSameOrBefore(comparisonValue, 'day');
        }
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.select:
            {
                var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.numValue; });
                var mcNumValue = utilities_1.numberUtilities.stringToNumber(mcValue[0]);
                var conditionNumber = utilities_1.numberUtilities.stringToNumber(conditionValue);
                return mcNumValue <= conditionNumber;
            }
        default: return false;
    }
}
/**
 * This function checks if the elementvalue is greater than a constant for numeric element types
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {string | number} conditionValue the value on the condition
 */
function checkGreaterThan(element, elementValue, conditionValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.number: {
            var numberValue = utilities_1.numberUtilities.stringToNumber(elementValue);
            var conditionNumber = utilities_1.numberUtilities.stringToNumber(conditionValue);
            return numberValue > conditionNumber;
        }
        case form_definition_1.elementTypes.time: {
            var timeString = utilities_1.timeUtilities.getTimeString(elementValue, element.isMilitaryTime);
            var timeValue = moment.utc(timeString, 'HH:mm:ss');
            var conditionTime = moment.utc(conditionValue, 'HH:mm:ss');
            return timeValue.isAfter(conditionTime, 'minute');
        }
        case form_definition_1.elementTypes.date: {
            var comparisonValue = moment(conditionValue, 'MM/DD/YYYY');
            var recordValue = moment(elementValue, 'MM/DD/YYYY');
            return recordValue.isAfter(comparisonValue, 'day');
        }
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.select:
            {
                var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.numValue; });
                var mcNumValue = utilities_1.numberUtilities.stringToNumber(mcValue[0]);
                var conditionNumber = utilities_1.numberUtilities.stringToNumber(conditionValue);
                return mcNumValue > conditionNumber;
            }
        default: return false;
    }
}
/**
 * This function checks if the elementvalue is greater than or equal than a constant for numeric element types
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {string | number} conditionValue the value on the condition
 */
function checkGreaterThanOrEqual(element, elementValue, conditionValue, formState) {
    switch (element.type) {
        case form_definition_1.elementTypes.number: {
            return !checkLessThan(element, elementValue, conditionValue, formState);
        }
        case form_definition_1.elementTypes.time: {
            if (form_definition_1.hasEmptyValue(element, elementValue, formState))
                return false;
            return !checkLessThan(element, elementValue, conditionValue, formState);
        }
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue, formState))
                return false;
            var comparisonValue = moment(conditionValue, 'MM/DD/YYYY');
            var recordValue = moment(elementValue, 'MM/DD/YYYY');
            return recordValue.isSameOrAfter(comparisonValue, 'day');
        }
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.select:
            {
                var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.numValue; });
                var mcNumValue = utilities_1.numberUtilities.stringToNumber(mcValue[0]);
                var conditionNumber = utilities_1.numberUtilities.stringToNumber(conditionValue);
                return mcNumValue >= conditionNumber;
            }
        default: return false;
    }
}
/**
 * This function checks if the elementvalue is less than for a given element for numeric element types
 * @param {FormState} state the form state containing all elements
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {string} comparisonElementId the id of the comparison element
 */
function checkLessThanElement(state, element, elementValue, comparisonElementId) {
    var form = state.form;
    var elements = (form || new form_definition_1.Form({})).elements;
    var comparisonElement = form_definition_1.getElementById(state, comparisonElementId);
    var comparisonValue = form_definition_1.getValue(state, comparisonElementId);
    if (!comparisonElement)
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.number:
            switch (comparisonElement.type) {
                case form_definition_1.elementTypes.number:
                    var numberValue = utilities_1.numberUtilities.stringToNumber(elementValue);
                    var comparisonNumber = utilities_1.numberUtilities.stringToNumber(comparisonValue);
                    return numberValue < comparisonNumber;
                default: return false;
            }
        default: return false;
    }
}
/**
 * This function checks if the elementvalue is less than for a given element for numeric element types
 * @param {FormState} state the form state containing all elements
 * @param {object} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {string} comparisonElementId the id of the comparison element
 */
function checkLessThanOrEqualElement(state, element, elementValue, comparisonElementId) {
    var form = state.form;
    var elements = (form || new form_definition_1.Form({})).elements;
    var comparisonElement = form_definition_1.getElementById(state, comparisonElementId);
    var comparisonValue = form_definition_1.getValue(state, comparisonElementId);
    if (!comparisonElement)
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.number:
            switch (comparisonElement.type) {
                case form_definition_1.elementTypes.number:
                    var numberValue = utilities_1.numberUtilities.stringToNumber(elementValue);
                    var comparisonNumber = utilities_1.numberUtilities.stringToNumber(comparisonValue);
                    return numberValue <= comparisonNumber;
                default: return false;
            }
        default: return false;
    }
}
/**
 * This function checks if the elementvalue is greater than for a given element for numeric element types
 * @param {FormState} state the form state containing all elements
 * @param {object} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {string} conditionValue the id of the comparison element
 */
function checkGreaterThanElement(state, element, elementValue, comparisonElementId) {
    var form = state.form;
    var elements = (form || new form_definition_1.Form({})).elements;
    var comparisonElement = form_definition_1.getElementById(state, comparisonElementId);
    var comparisonValue = form_definition_1.getValue(state, comparisonElementId);
    if (!comparisonElement)
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.number:
            switch (comparisonElement.type) {
                case form_definition_1.elementTypes.number:
                    var numberValue = utilities_1.numberUtilities.stringToNumber(elementValue);
                    var comparisonNumber = utilities_1.numberUtilities.stringToNumber(comparisonValue);
                    return numberValue > comparisonNumber;
                default: return false;
            }
        default: return false;
    }
}
/**
 * This function checks if the elementvalue is greater than for a given element for numeric element types
 * @param {FormState} state the form state containing all elements
 * @param {object} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {string} conditionValue the id of the comparison element
 */
function checkGreaterThanOrEqualElement(state, element, elementValue, comparisonElementId) {
    var form = state.form;
    var elements = (form || new form_definition_1.Form({})).elements;
    var comparisonElement = form_definition_1.getElementById(state, comparisonElementId);
    var comparisonValue = form_definition_1.getValue(state, comparisonElementId);
    if (!comparisonElement)
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.number:
            switch (comparisonElement.type) {
                case form_definition_1.elementTypes.number:
                    var numberValue = utilities_1.numberUtilities.stringToNumber(elementValue);
                    var comparisonNumber = utilities_1.numberUtilities.stringToNumber(comparisonValue);
                    return numberValue >= comparisonNumber;
                default: return false;
            }
        default: return false;
    }
}
/**
 * checks to see if an element value begins with a given string (case-insensitive) for various element types
 * **NOTE**: for multiple choice means that all of the given values are selected, and if **any** value
 * in the set begins with the conditionValue, the function returns true
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {string} conditionValue string to check the elementValue begins with
 */
function checkBeginsWith(element, elementValue, conditionValue, state) {
    // make case-insensitive
    var conditionStr = conditionValue.trim().toLocaleUpperCase();
    // regex format
    conditionStr = utilities_1.textUtilities.convertStrToRegExStr(conditionStr);
    // account for wildcard with regex symbol for wildcard
    conditionStr = conditionStr.replace(RegExp("%", "g"), ".");
    var conditionRegex = RegExp("^" + conditionStr);
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert: {
            var mcElement = element;
            var options_2 = mcElement.options;
            var mcValue = elementValue && elementValue.toJS();
            return !!mcValue && !!conditionRegex && mcValue.some(function (choiceValue) {
                return options_2.find(function (opt) { return opt.value === choiceValue && conditionRegex.test(opt.label.trim().toLocaleUpperCase()); });
            });
        }
        case form_definition_1.elementTypes.group: {
            switch (element.dataFormat.type) {
                case form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER: {
                    if (!elementValue)
                        return false;
                    var mcValue = form_definition_1.groupDataFormatHelpers.getMCOtherLabels(element, elementValue, state);
                    return !!mcValue && !!conditionRegex && mcValue.some(function (choiceValue) { return conditionRegex.test(choiceValue.trim().toLocaleUpperCase()); });
                }
                case form_constants_1.dataFormatType.ZIP_EXTENSION: {
                    return !!elementValue && !!conditionRegex && conditionRegex.test(elementValue.trim().toLocaleUpperCase());
                }
                default: return false;
            }
        }
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.email: {
            return !!elementValue && !!conditionRegex && conditionRegex.test(elementValue.trim().toLocaleUpperCase());
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value does not begin with a given string (case-insensitive) for various element types
 * **NOTE**: for multiple choice means that all of the given values are selected, and if **any** value
 * in the set begins with the conditionValue, the function returns false
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {string} conditionValue string to check the elementValue does not begin with
 */
function checkNotBeginWith(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.email:
        case form_definition_1.elementTypes.group: {
            return !checkBeginsWith(element, elementValue, conditionValue, state);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value ends with a given string (case-insensitive) for various element types
 * **NOTE**: for multiple choice means that all of the given values are selected, and if **any** value
 * in the set ends with the conditionValue, the function returns true
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {string} conditionValue string to check the elementValue ends with
 */
function checkEndsWith(element, elementValue, conditionValue, state) {
    // make case-insensitive
    var conditionStr = conditionValue.trim().toLocaleUpperCase();
    // regex format
    conditionStr = utilities_1.textUtilities.convertStrToRegExStr(conditionStr);
    // account for wildcard with regex symbol for wildcard
    conditionStr = conditionStr.replace(RegExp("%", "g"), ".");
    var conditionRegex = RegExp(conditionStr + "$");
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert: {
            var mcElement = element;
            var options_3 = mcElement.options;
            var mcValue = elementValue && elementValue.toJS();
            return !!mcValue && !!conditionRegex && mcValue.some(function (choiceValue) {
                return options_3.find(function (opt) { return opt.value === choiceValue && conditionRegex.test(opt.label.trim().toLocaleUpperCase()); });
            });
        }
        case form_definition_1.elementTypes.group: {
            switch (element.dataFormat.type) {
                case form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER: {
                    if (!elementValue)
                        return false;
                    var mcValue = form_definition_1.groupDataFormatHelpers.getMCOtherLabels(element, elementValue, state);
                    return !!mcValue && !!conditionRegex && mcValue.some(function (choiceValue) { return conditionRegex.test(choiceValue.trim().toLocaleUpperCase()); });
                }
                case form_constants_1.dataFormatType.ZIP_EXTENSION: {
                    return !!elementValue && !!conditionRegex && conditionRegex.test(elementValue.trim().toLocaleUpperCase());
                }
                default: return false;
            }
        }
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.email: {
            return !!elementValue && !!conditionRegex && conditionRegex.test(elementValue.trim().toLocaleUpperCase());
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value does not end with a given string (case-insensitive) for various element types
 * **NOTE**: for multiple choice means that all of the given values are selected, and if **any** value
 * in the set ends with the conditionValue, the function returns false
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {string} conditionValue string to check the elementValue does not end with
 */
function checkNotEndWith(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.email:
        case form_definition_1.elementTypes.group: {
            return !checkEndsWith(element, elementValue, conditionValue, state);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value matches any one of a set of values
 * **NOTE**: for multiple choice means that all of the given values are selected, and if **any** value
 * in the set matches any of the conditionValue, the function returns true
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkMatchesAny(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.checkbox: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            var choiceValueArray = !conditionValue ? [] : conditionValue.split("|");
            var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.label; });
            return !!mcValue && !!conditionValue && mcValue.some(function (choiceValue) { return choiceValueArray.includes(choiceValue); });
        }
        case form_definition_1.elementTypes.group: {
            switch (element.dataFormat.type) {
                case form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER: {
                    if (!elementValue)
                        return false;
                    var choiceValueArray_1 = conditionValue ? conditionValue.split("|") : [];
                    var mcValue_2 = form_definition_1.groupDataFormatHelpers.getMCOtherLabels(element, elementValue, state);
                    return !!mcValue_2 && mcValue_2.some(function (choiceValue) { return choiceValueArray_1.includes(choiceValue); });
                }
                default: return false;
            }
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value does not match any one of a set of values
 * **NOTE**: for multiple choice means that all of the given values are selected, and if **any** value
 * in the set matches any of the conditionValue, the function returns false
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkNotMatchAny(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.group: {
            return !checkMatchesAny(element, elementValue, conditionValue, state);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value matches any one of a set of values
 * **NOTE**: for multiple choice means that all of the given values are selected, and if **any** value
 * in the set matches any of the conditionValue, the function returns true
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkMatchesAnyMaskedMulti(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.likert: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            var choiceValueArray = !conditionValue ? [] : conditionValue.split("|");
            var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.numValue; });
            var mcNumValueArray = mcValue.map(Number);
            var choiceNumValueArray = choiceValueArray.map(Number);
            return !!mcNumValueArray && !!choiceNumValueArray && mcNumValueArray.some(function (choiceValue) { return choiceNumValueArray.includes(choiceValue); });
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value matches all of a set of values
 * This means that all values in the conditionValue set must be satisfied by a subset of the elementValue
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against, of which, all items must be matched
 */
function checkMatchesEvery(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            var choiceValueArray = !conditionValue ? [] : conditionValue.split("|");
            var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.label; });
            return !!mcValue && !!conditionValue && choiceValueArray.every(function (choiceValue) { return mcValue.includes(choiceValue); });
        }
        case form_definition_1.elementTypes.group: {
            switch (element.dataFormat.type) {
                case form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER: {
                    if (!elementValue)
                        return false;
                    var choiceValueArray_2 = conditionValue ? conditionValue.split("|") : [];
                    var mcValue_3 = form_definition_1.groupDataFormatHelpers.getMCOtherLabels(element, elementValue, state);
                    return !!mcValue_3 && choiceValueArray_2.every(function (choiceValue) { return mcValue_3.includes(choiceValue); });
                }
                default: return false;
            }
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value does not match all of a set of values
 * This means that all values in the conditionValue set must be satisfied by a subset of
 *  the elementValue for this check to fail
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkNotMatchEvery(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.group: {
            return !checkMatchesEvery(element, elementValue, conditionValue, state);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value is earlier than now
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkEarlierThanNow(element, elementValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.time: {
            var timeString = utilities_1.timeUtilities.getTimeString(elementValue, element.isMilitaryTime);
            var time = moment.utc(timeString, 'HH:mm:ss');
            return time.isBefore(moment.utc());
        }
    }
}
/**
 * checks to see if an element value is earlier than now or equal
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkEarlierThanNowOrEqual(element, elementValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.time: {
            return !checkLaterThanNow(element, elementValue, formState);
        }
    }
}
/**
 * checks to see if an element value is later than now
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkLaterThanNow(element, elementValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.time: {
            var timeString = utilities_1.timeUtilities.getTimeString(elementValue, element.isMilitaryTime);
            var time = moment.utc(timeString, 'HH:mm:ss');
            return time.isAfter(moment.utc());
        }
    }
}
/**
 * checks to see if an element value is later than or equal to now
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param formState
 */
function checkLaterThanNowOrEqual(element, elementValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.time: {
            return !checkEarlierThanNow(element, elementValue, formState);
        }
    }
}
/**
 * checks to see if an element value is between two constant values
 * This means that all values in the conditionValue set must be satisfied by a subset of
 *  the elementValue for this check to fail
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkBetween(element, elementValue, conditionValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.number: {
            var numVal = Number(elementValue);
            if (!isNaN(numVal) && !!conditionValue && conditionValue.trim() !== "") {
                var conditionValues = conditionValue.split('|');
                // It is possible to get any of the following for condition values:
                // "22|44" (value is between 22 and 44)
                // "22" (value is greater than or equal to 22)
                // "|44" (value is less than or equal to 44)
                var condLoBound = Number(conditionValues[0]);
                if (conditionValues.length === 2) {
                    var condHiBound = Number(conditionValues[1]);
                    if (!isNaN(condLoBound) && !isNaN(condHiBound)) {
                        // valid numbers for both lobound and hibound
                        return numVal >= condLoBound && numVal <= condHiBound;
                    }
                    else if (!isNaN(condHiBound)) {
                        // only the hibound is valid
                        return numVal <= condHiBound;
                    }
                }
                else if (conditionValues.length === 1) {
                    var condLoBound = Number(conditionValues[0]);
                    if (!isNaN(condLoBound)) {
                        // only the lobound is valid
                        return numVal >= condLoBound;
                    }
                }
            }
            return false;
        }
        case form_definition_1.elementTypes.date: {
            var bounds = conditionValue.split('|').map(function (date) { return moment(date, 'MM/DD/YYYY'); });
            var lowerBound = moment.min(bounds);
            var upperBound = moment.max(bounds);
            return utilities_1.dateUtilities.isDateInRange(elementValue, lowerBound, upperBound);
        }
        case form_definition_1.elementTypes.time: {
            var bounds = conditionValue.split('|').map(function (time) { return moment.utc(time, 'hh:mm:ss'); });
            if (bounds.length !== 2)
                throw new Error("Invalid condition value for between operator: " + conditionValue);
            var lowerBound_1 = moment.min(bounds);
            var upperBound_1 = moment.max(bounds);
            var timeString = utilities_1.timeUtilities.getTimeString(elementValue, element.isMilitaryTime);
            var timeValue = moment.utc(timeString, 'HH:mm:ss');
            return timeValue.isBetween(lowerBound_1, upperBound_1, 'minute', '()');
        }
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.select: {
            var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.numValue; });
            if (!!mcValue && !!conditionValue && conditionValue.trim() !== "") {
                var mcNumValue = Number(mcValue[0]);
                var conditionValues = conditionValue.split('|');
                // It is possible to get any of the following for condition values:
                // "22|44" (value is between 22 and 44)
                // "22" (value is greater than or equal to 22)
                // "|44" (value is less than or equal to 44)
                var condLoBound = Number(conditionValues[0]);
                if (conditionValues.length === 2) {
                    var condHiBound = Number(conditionValues[1]);
                    if (!isNaN(condLoBound) && !isNaN(condHiBound)) {
                        // valid numbers for both lobound and hibound
                        return mcNumValue >= condLoBound && mcNumValue <= condHiBound;
                    }
                    else if (!isNaN(condHiBound)) {
                        // only the hibound is valid
                        return mcNumValue <= condHiBound;
                    }
                }
                else if (conditionValues.length === 1) {
                    var condLoBound = Number(conditionValues[0]);
                    if (!isNaN(condLoBound)) {
                        // only the lobound is valid
                        return mcNumValue >= condLoBound;
                    }
                }
            }
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value is not between two constant values
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkNotBetween(element, elementValue, conditionValue, formState) {
    switch (element.type) {
        case form_definition_1.elementTypes.number:
        case form_definition_1.elementTypes.date:
        case form_definition_1.elementTypes.time:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.select: {
            return !checkBetween(element, elementValue, conditionValue, formState);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an date element value matches today
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkToday(element, elementValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            var today = moment().format('MM/DD/YYYY');
            return today === elementValue;
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an date element value does not match today
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkNotToday(element, elementValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            return !checkToday(element, elementValue);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an date element value matches a value in the current week
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkThisWeek(element, elementValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            var recordValue = moment(elementValue, 'MM/DD/YYYY');
            return moment().isSame(recordValue, 'isoWeek');
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an date element value does not match a value in the current week
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkNotThisWeek(element, elementValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            return !checkThisWeek(element, elementValue);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an date element value matches a value in the current month
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkThisMonth(element, elementValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            var recordValue = moment(elementValue, 'MM/DD/YYYY');
            return moment().isSame(recordValue, 'month');
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an date element value does not match a value in the current month
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkNotThisMonth(element, elementValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            return !checkThisMonth(element, elementValue);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an date element value matches a value in the current year
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkThisYear(element, elementValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            var recordValue = moment(elementValue, 'MM/DD/YYYY');
            return moment().isSame(recordValue, 'year');
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an date element value does not match a value in the current year
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkNotThisYear(element, elementValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            return !checkThisYear(element, elementValue);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value is within certain number of days
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkLast(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue, state)) {
                return false;
            }
            var diff = moment().diff(elementValue, 'days');
            if (Math.sign(diff) >= 0) {
                return +conditionValue >= diff;
            }
            return false;
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value is not within certain number of days
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkNotLast(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue, state)) {
                return false;
            }
            return !checkLast(element, elementValue, conditionValue, state);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value is within certain number of days
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkNext(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue, state)) {
                return false;
            }
            var start = moment().add(1, 'd');
            var diff = moment(elementValue).diff(start, 'days');
            if (Math.sign(diff) >= 0) {
                return +conditionValue >= diff;
            }
            return false;
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value is not within certain number of days
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkNotNext(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue, state)) {
                return false;
            }
            return !checkNext(element, elementValue, conditionValue, state);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
//# sourceMappingURL=condition.reducer.js.map

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var moment = __webpack_require__(37);
var form_constants_1 = __webpack_require__(5);
/**
 * All dates in the store are in yyyy-MM-dd.
 * However, some browsers (all of them except chrome and edge)
 * want to show dates in the format MM/dd/yyyy.
 * So, based on the browser we have detected,
 * we will return the properly formatted date.
 * @param {string} browserName The name of the browser.  The choices for what we support are 'chrome', 'firefox', 'ie', and 'edge'.
 * (This comes from detect-browser).
 * @param {string} dateString A date from the store, in string format, which will be yyyy-MM-dd.
 * @returns {string} A date string of the appropriate format yyyy-MM-dd or MM/dd/yyyy
 */
function getDateForBrowser(browserName, dateString) {
    var retval = dateString; // if we do nothing else, just return what we were passed in
    if (browserName !== 'chrome' && browserName !== 'edge') {
        retval = getUserFriendlyFormat(dateString);
    }
    return retval;
}
exports.getDateForBrowser = getDateForBrowser;
function getUserFriendlyFormat(dateString) {
    var retval = dateString;
    if (dateString) {
        var yyyyMMddFormatted = false;
        var yyyyMMddPattern = new RegExp("^\\d{4}[/-]\\d{2}[/-]\\d{2}");
        yyyyMMddFormatted = yyyyMMddPattern.test(dateString);
        if (yyyyMMddFormatted) {
            retval = dateString.substring(5, 7) + "/" + dateString.substring(8) + "/" + dateString.substring(0, 4);
        }
    }
    return retval;
}
exports.getUserFriendlyFormat = getUserFriendlyFormat;
/**
 * Convert a JSON date string (can be either '2016-11-02T00:00:00-05:00' or '2017-09-28T10:09:20.9546978-05:00' or '2017-09-21T00:00:00') to a user friendly date (example: '11/02/2016')
 * If the incoming date string does not contain a timezone offset, we simply extract the date part and return.
 * If the incoming date string contains a timezone offset, moment.js is used to perform a local conversion.
 * @param {*} dateString A JSON date string (can be either '2016-11-02T00:00:00-05:00' or '2017-09-28T10:09:20.9546978-05:00' or '2017-09-21T00:00:00')
 * @returns A user friendly MM/dd/yyyy date (example: '11/02/2016') if the conversion was successful.
 * If the supplied dateString does not match any of the supported date formats, the originally supplied dateString is returned.
 */
function getUserFriendlyFormatFromJson(dateString) {
    var retval = dateString;
    if (dateString != null) {
        var timeZoneOffsetPresent = false; // set this to true if we found a non zero timezone offset.  The offset can be positive or negative.
        // Each pattern has to be tested separately because the timezone information may appear in different places.
        var jsonDatePattern1Matched = false; // Did we match pattern 1:  '2016-11-02T00:00:00-05:00'
        var jsonDatePattern2Matched = false; // Did we match pattern 2:  '2017-09-28T10:09:20.9546978-05:00'
        var jsonDatePattern3Matched = false; // Did we match pattern 3:  '2017-09-21T00:00:00'
        // pattern 1:  '2016-11-02T00:00:00-05:00'
        var jsonDatePattern1 = new RegExp("^\\d{4}[/-]\\d{2}[/-]\\d{2}[T]\\d{2}[:]\\d{2}[:]\\d{2}[+-]\\d{2}[:]\\d{2}");
        jsonDatePattern1Matched = jsonDatePattern1.test(dateString);
        if (jsonDatePattern1Matched) {
            // get out the timezone offset, convert to numbers, and act accordingly
            var tzHrString = dateString.substring(20, 22);
            var tzMinString = dateString.substring(23, 25);
            var tzHrNum = parseInt(tzHrString, 10);
            var tzMinNum = parseInt(tzMinString, 10);
            if (tzHrNum > 0 || tzMinNum > 0) {
                timeZoneOffsetPresent = true;
            }
        }
        else {
            // pattern 2:  '2017-09-28T10:09:20.9546978-05:00'
            var jsonDatePattern2 = new RegExp("^\\d{4}[/-]\\d{2}[/-]\\d{2}[T]\\d{2}[:]\\d{2}[:]\\d{2}[\\.]\\d{7}[+-]\\d{2}[:]\\d{2}");
            jsonDatePattern2Matched = jsonDatePattern2.test(dateString);
            if (jsonDatePattern2Matched) {
                // get out the timezone offset, convert to numbers, and act accordingly
                var tzHrString2 = dateString.substring(28, 30);
                var tzMinString2 = dateString.substring(31, 33);
                var tzHrNum2 = parseInt(tzHrString2, 10);
                var tzMinNum2 = parseInt(tzMinString2, 10);
                if (tzHrNum2 > 0 || tzMinNum2 > 0) {
                    timeZoneOffsetPresent = true;
                }
            }
            else {
                // pattern 3:  '2017-09-21T00:00:00'
                var jsonDatePattern3 = new RegExp("^\\d{4}[/-]\\d{2}[/-]\\d{2}[T]\\d{2}[:]\\d{2}[:]\\d{2}");
                jsonDatePattern3Matched = jsonDatePattern3.test(dateString);
                if (jsonDatePattern3Matched) {
                    timeZoneOffsetPresent = false;
                }
            }
        }
        // We can test for a match in the same statement since the date parts we care about are in the same place in any case.
        // If the place where the actual date parts are ever changes, just test for each pattern matched variable independently.
        if (jsonDatePattern1Matched || jsonDatePattern2Matched || jsonDatePattern3Matched) {
            if (timeZoneOffsetPresent) {
                // with a nonzero utc offset, we perform a local date conversion using moment.js.
                var dateMoment = moment(dateString);
                if (dateMoment != null) {
                    retval = dateMoment.format('MM/DD/YYYY');
                    if (retval != null) {
                        return retval;
                    }
                }
            }
            else {
                // with no UTC offset, we strip out just the date part and return it.
                retval = dateString.substring(5, 7) + "/" + dateString.substring(8, 10) + "/" + dateString.substring(0, 4);
                return retval;
            }
        }
    }
    return dateString;
}
exports.getUserFriendlyFormatFromJson = getUserFriendlyFormatFromJson;
// verifies that a date string of format yyyy-mm-dd or mm/dd/yyyy is valid
function isValidDate(dateString, country) {
    var yyyyMMddFormat = new RegExp("^\\d{4}[-](0?[1-9]|1[012])[-](0?[1-9]|[12][0-9]|3[01])");
    var ddMMyyyyFormat = new RegExp("^(0?[1-9]|[12][0-9]|3[01])[/](0?[1-9]|1[012])[/]\\d{4}");
    var mmDDyyyyFormat = new RegExp("^(0?[1-9]|1[012])[/](0?[1-9]|[12][0-9]|3[01])[/]\\d{4}");
    var day, month, year;
    if (mmDDyyyyFormat.test(dateString) && country === form_constants_1.CountryEnum.UnitedStates) {
        var date = dateString.split('/');
        month = parseInt(date[0], 10);
        day = parseInt(date[1], 10);
        year = parseInt(date[2], 10);
    }
    else if (yyyyMMddFormat.test(dateString) && country === form_constants_1.CountryEnum.Canada) {
        var date = dateString.split('-');
        month = parseInt(date[1], 10);
        day = parseInt(date[2], 10);
        year = parseInt(date[0], 10);
    }
    else if (ddMMyyyyFormat.test(dateString) && country === form_constants_1.CountryEnum.UnitedKingdom) {
        var date = dateString.split('/');
        month = parseInt(date[1], 10);
        day = parseInt(date[0], 10);
        year = parseInt(date[2], 10);
    }
    else {
        return false;
    }
    // Create list of days of a month [assume there is no leap year by default]
    var ListofDays = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (month === 2) {
        var leapYear = false;
        if ((!(year % 4) && year % 100) || !(year % 400)) {
            leapYear = true;
        }
        if ((leapYear === false) && (day >= 29)) {
            return false;
        }
        else if ((leapYear === true) && (day > 29)) {
            return false;
        }
    }
    else if (month >= 1 && month <= 12) {
        if (day > ListofDays[month - 1]) {
            return false;
        }
    }
    else {
        return false;
    }
    return true;
}
exports.isValidDate = isValidDate;
function isDateInRange(selectedDate, minDate, maxDate, earliestAllowed, latestAllowed) {
    if (!selectedDate)
        return false;
    var minDateValue = minDate && Date.parse(minDate);
    var maxDateValue = maxDate && Date.parse(maxDate);
    if (!!earliestAllowed && earliestAllowed.trim() !== '') {
        var earliestAllowedValue = (earliestAllowed && earliestAllowed.toLowerCase() == "today") ? moment().format("MM/DD/YYYY") : earliestAllowed;
        var earliestAllowedValueDate = Date.parse(earliestAllowedValue);
        minDateValue = (minDateValue && earliestAllowedValueDate < minDateValue) ? earliestAllowedValueDate : minDateValue;
    }
    if (!!latestAllowed && latestAllowed.trim() !== '') {
        var latestAllowedValue = (latestAllowed && latestAllowed.toLowerCase() == "today") ? moment().format("MM/DD/YYYY") : latestAllowed;
        var latestAllowedValueDate = Date.parse(latestAllowedValue);
        maxDateValue = (maxDateValue && latestAllowedValueDate > maxDateValue) ? latestAllowedValueDate : maxDateValue;
    }
    var selectedDateValue = Date.parse(selectedDate);
    if (isNaN(selectedDateValue)) {
        var dateArray = selectedDate.split('/');
        var usDateFormat = dateArray[1] + "/" + dateArray[0] + "/" + dateArray[2];
        selectedDateValue = Date.parse(usDateFormat);
    }
    if (isNaN(selectedDateValue) || (maxDateValue && selectedDateValue > maxDateValue) || (minDateValue && selectedDateValue < minDateValue))
        return false;
    return true;
}
exports.isDateInRange = isDateInRange;
/**
 * Given a UTC date string, apply the the current time zone, and format the result as a string.
 * @param {string} originalUtcDateTime A UTC datetime string, typically from an API or database.
 * This is an example: '2019-09-12T18:23:31'
 * @param {string} desiredDateFormat The format for the returned value. If this is blank/null/undefined,
 * the default is 'MM/DD/YYYY'
 * @returns {string} A localized version of the original utc date, formatted as a string.
 * If the original utc date is blank/null/undefined, an empty string is returned.
 */
function getLocalDateString(originalUtcDate, desiredDateFormat) {
    if (desiredDateFormat === void 0) { desiredDateFormat = null; }
    if (!originalUtcDate || originalUtcDate.trim() === "") {
        return "";
    }
    if (!desiredDateFormat || desiredDateFormat.trim() === "") {
        desiredDateFormat = "MM/DD/YYYY";
    }
    return moment.utc(originalUtcDate).local().format(desiredDateFormat);
}
exports.getLocalDateString = getLocalDateString;
//# sourceMappingURL=date-utilities.js.map

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * returns a number type representation of the input string or null if it is not a number
 * @param n
 */
function stringToNumber(n) {
    if (n === null || n === undefined)
        return null;
    if (n === '0' || n === 0)
        return 0;
    if (n.toString().substr(-1) !== '0')
        return + +n || null;
    if (n.toString().indexOf('.') === -1) {
        var val = parseInt(n.toString(), 10);
        if (isNaN(val))
            return null;
        else
            return val;
    }
    else {
        var fp = parseFloat(n.toString());
        if (isNaN(fp))
            return null;
        else
            return fp;
    }
}
exports.stringToNumber = stringToNumber;
/**
 * returns number of places to the right of decimal (if any) in the string input of a number
 * @param num
 */
function decPlaces(num) {
    if (Math.floor(num) === num || !num)
        return 0;
    else
        return (num.toString().split('.')[1] || []).length;
}
exports.decPlaces = decPlaces;
function formatBytesForString(bytes) {
    if (bytes < 1024) {
        return bytes + ' bytes';
    }
    else if (bytes >= 1024 && bytes < 1048576) {
        return (bytes / 1024).toFixed(1) + ' KB';
    }
    else if (bytes >= 1048576) {
        return (bytes / 1048576).toFixed(1) + ' MB';
    }
}
exports.formatBytesForString = formatBytesForString;
/**
 * returns number with commas removed from string, maintaining decimal precision
 * @param {string} numberStr
 * @param {number} decimalPlaces
 */
function removeCommas(numberStr, decimalPlaces) {
    if (decimalPlaces === void 0) { decimalPlaces = null; }
    if (!numberStr)
        return null;
    if (decimalPlaces === null || decimalPlaces === undefined) {
        return parseFloat(numberStr.replace(/,/g, ''));
    }
    else {
        return parseFloat(numberStr.replace(/,/g, '')).toFixed(decimalPlaces);
    }
}
exports.removeCommas = removeCommas;
/**
 * Convert the given int to a guid.
 * @param {number} int The number to convert to a guid.
 * @returns {string} A guid representation of the provided integer.  For example, the number 2 becomes '00000002-0000-0000-0000-000000000000'
 */
function convertIntToGuid(int) {
    if (int < 0) {
        int = 0xFFFFFFFF + int + 1;
    }
    var converted = int.toString(16).toUpperCase();
    var padded = pad(converted, 8, '0');
    return padded + '-0000-0000-0000-000000000000';
}
exports.convertIntToGuid = convertIntToGuid;
/**
 * Convert given guid to an int.
 * @param {string} guid The guid to convert to an integer.
 * @returns {number} An integer.
 */
function convertGuidToInt(guid) {
    var hex = '0x' + guid.substring(0, 8);
    var result = parseInt(hex, 16);
    return result;
}
exports.convertGuidToInt = convertGuidToInt;
/**
 * Pad out the given converted number with zeros.  For example, if the converted number is 10, and width is 4, the result will be '0010'
 * @param {number} convertedNumber The number to pad.
 * @param {*} width Total number of characters to return.
 * @param {*} padChar The character to pad with.  By default, this is '0'.
 */
function pad(convertedNumber, width, padChar) {
    padChar = padChar || '0';
    convertedNumber += '';
    return convertedNumber.length >= width ? convertedNumber : new Array(width - convertedNumber.length + 1).join(padChar) + convertedNumber;
}
exports.pad = pad;
//# sourceMappingURL=number-utilities.js.map

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var form_definition_1 = __webpack_require__(17);
exports.errorTypes = {
    inline: 'inline-error',
    global: 'global-error'
};
function validationError(sourceId, label, section, errorNum, message, errorType) {
    if (errorType === void 0) { errorType = exports.errorTypes.global; }
    var errorId = section + '-' + errorNum;
    return new form_definition_1.Error({
        id: "error-" + sourceId + "-" + errorId,
        sourceId: sourceId,
        type: errorType,
        context: label,
        errorMessage: message
    });
}
exports.validationError = validationError;
;
function sectionedValidationError(sourceId, label, subSection, section, errorNum, message, errorType) {
    if (errorType === void 0) { errorType = exports.errorTypes.global; }
    var baseError = validationError(sourceId, label, section, errorNum, message, errorType);
    return baseError.set('subSection', subSection);
}
exports.sectionedValidationError = sectionedValidationError;
//# sourceMappingURL=validation-error.js.map

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(183);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./radio-element.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./radio-element.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(262);
exports.defaultStyle = {
    errorWrapper: 'form-validation-error-wrapper',
    errorSection: 'form-validation-error-section',
    errorList: 'form-validation-error-list',
};
exports.default = exports.defaultStyle;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(263);
exports.default = {
    warningMessage: "ssg-inline-error",
    warningText: "ssg-inline-error-text",
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
__webpack_require__(264);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { fileDisplay: 'ssg-attached-file', uploadedIcon: '', uploadingIcon: 'ssg-forms-spin', fileName: 'ssg-fileName ssg-forms-text normal', emptyText: 'ssg-forms-text normal', deleteButton: 'ssg-forms-icon-btn ssg-attachment-delete-button', deleteIcon: 'ssg-forms-btn-icon', attachButton: 'ssg-forms-btn ssg-forms-btn-secondary ssg-attach-button', link: 'ssg-attachment-link-text' });
exports.default = defaultStyle;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var attachment_element_1 = __webpack_require__(317);
exports.AttachmentElement = attachment_element_1.default;
var attachment_element_style_1 = __webpack_require__(54);
exports.defaultStyle = attachment_element_style_1.default;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
__webpack_require__(265);
exports.defaultOptionStyle = {
    checkOptionWrapper: 'ssg-checkbox-choice-wrapper',
    checkboxChoice: 'ssg-checkbox-choice-label ssg-forms-text normal',
    checkbox: 'ssg-checkbox-input',
};
var defaultStyle = __assign({}, common_1.defaultElementStyles, { group: 'ssg-checkbox-fieldset', label: 'ssg-forms-label ssg-checkbox-label-legend', checkOptionWrapperContent: 'ssg-checkbox-choice-wrapper-content', readOnly: 'just-read', emptyValue: '' }, exports.defaultOptionStyle);
exports.default = defaultStyle;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var checkbox_element_1 = __webpack_require__(318);
exports.CheckboxElement = checkbox_element_1.default;
var checkbox_element_style_1 = __webpack_require__(56);
exports.defaultStyle = checkbox_element_style_1.default;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
__webpack_require__(260);
__webpack_require__(266);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { date: 'ssg-forms-input date-element', dateWrapper: 'ssg-forms-input-group', dateWrapperError: 'ssg-forms-input-group input-error', calendarButton: 'ssg-forms-addon ssg-forms-icon-btn', calendarIcon: 'ssg-forms-btn-icon', calendarAnchor: 'anchor', calendarWrapper: 'calendar', disabled: 'disabled' });
exports.default = defaultStyle;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var date_element_1 = __webpack_require__(319);
exports.DateElement = date_element_1.default;
var date_element_style_1 = __webpack_require__(58);
exports.defaultStyle = date_element_style_1.default;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
__webpack_require__(267);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { canvasPad: 'ssg-forms-input-group canvasPad', signPad: 'ssg-forms-input-group signPad', canvasPosition: 'ssg-signature-position', buttonArea: 'ssg-esig-button-area', signButton: 'ssg-forms-btn ssg-forms-btn-secondary', clearButton: 'ssg-forms-btn', saveButton: 'ssg-forms-btn ssg-forms-btn-primary', startOverButton: 'ssg-forms-btn ssg-forms-btn-secondary ssg-signature-button', readOnly: 'readonly', hidden: 'hidden', complete: 'drawing-completed', focus: 'focus' });
exports.default = defaultStyle;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var electronic_signature_element_1 = __webpack_require__(320);
exports.ElectronicSignatureElement = electronic_signature_element_1.default;
var electronic_signature_element_style_1 = __webpack_require__(60);
exports.defaultStyle = electronic_signature_element_style_1.default;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
var defaultValue = __assign({}, common_1.defaultElementStyles, { input: "ssg-forms-input", inputError: "ssg-forms-input input-error" });
exports.default = defaultValue;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var email_element_1 = __webpack_require__(321);
exports.EmailElement = email_element_1.default;
var email_element_style_1 = __webpack_require__(62);
exports.defaultStyle = email_element_style_1.default;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
__webpack_require__(268);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { collapsibleSection: 'email-notification-element-collapsible-section', collapsibleSectionBody: 'email-notification-element-body ssg-forms-text normal', emailComponent: 'email-notification-element-email-parts', notificationText: 'ssg-forms-text normal', errorText: 'email-notification-element-error-text ssg-forms-text normal' });
exports.default = defaultStyle;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var email_notification_element_1 = __webpack_require__(322);
exports.EmailNotificationElement = email_notification_element_1.default;
var email_notification_element_style_1 = __webpack_require__(64);
exports.defaultStyle = email_notification_element_style_1.default;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var immutable_1 = __webpack_require__(2);
var react_styleable_1 = __webpack_require__(1);
var form_element_style_1 = __webpack_require__(29);
var ssg_forms_processing_1 = __webpack_require__(7);
var formElements = __webpack_require__(20);
var react_fontawesome_1 = __webpack_require__(14);
var free_solid_svg_icons_1 = __webpack_require__(13);
__webpack_require__(269);
/** Generic Form Element, renders the element display for any given type */
var FormElement = /** @class */ (function (_super) {
    __extends(FormElement, _super);
    function FormElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * determines if any changes have been made for this element
     * @param nextProps
     */
    FormElement.prototype.shouldComponentUpdate = function (nextProps) {
        var shouldUpdate = true;
        var _a = this.props, oldElement = _a.element, oldFormState = _a.state, oldErrorSetting = _a.showInlineErrors, oldCustomErrors = _a.customValidationErrors;
        var oldValidation = oldFormState && oldFormState.validationResult;
        var oldElementId = oldElement.id;
        var oldErrors = oldValidation && oldValidation.errors.filter(function (val) { return val.sourceId === oldElementId; });
        var oldValue = oldFormState && ssg_forms_processing_1.formDefinition.getValue(oldFormState, oldElementId);
        var element = nextProps.element, formState = nextProps.state, showInlineErrors = nextProps.showInlineErrors, customValidationErrors = nextProps.customValidationErrors;
        var validation = formState && formState.validationResult;
        var elementId = element.id;
        var errors = validation && validation.errors.filter(function (val) { return val.sourceId === elementId; });
        var value = formState && ssg_forms_processing_1.formDefinition.getValue(formState, elementId);
        var elementsEqual = (!oldElement && !element) || (oldElement && oldElement.equals(element));
        var customErrorsEqual = (!oldCustomErrors && !customValidationErrors) || (oldCustomErrors && oldCustomErrors.equals(customValidationErrors));
        var errorsEqual = (!oldErrors && !errors) || (oldErrors && oldErrors.equals(errors));
        if (oldValue === value &&
            element.type !== ssg_forms_processing_1.formDefinition.elementTypes.group &&
            element.type !== ssg_forms_processing_1.formDefinition.elementTypes.time &&
            oldErrorSetting === showInlineErrors &&
            elementsEqual &&
            customErrorsEqual &&
            errorsEqual) {
            shouldUpdate = false;
        }
        return shouldUpdate;
    };
    /** renders the correct type of element display given the type */
    FormElement.prototype.render = function () {
        var _a = this.props, country = _a.country, css = _a.css, customDisplays = _a.customDisplays, customValidationErrors = _a.customValidationErrors, element = _a.element, getOnChange = _a.getOnChange, getOnDownload = _a.getOnDownload, getOnRemove = _a.getOnRemove, getStyleOverride = _a.getStyleOverride, _b = _a.idAddOn, idAddOn = _b === void 0 ? "" : _b, showInlineErrors = _a.showInlineErrors, showUnsupported = _a.showUnsupported, state = _a.state;
        var id = element.id, type = element.type;
        var value = state.value, defaultValue = state.defaultValue, validationResult = state.validationResult;
        var elementValue = value && value.get(id);
        var elementDefault = defaultValue && defaultValue.get(id);
        var errors = !!validationResult ? validationResult.errors.filter(function (error) { return error.sourceId === id; }).toList() : immutable_1.List([]);
        var customElementErrors = !!customValidationErrors ? customValidationErrors.filter(function (error) { return error.sourceId === id; }).toList() : immutable_1.List([]);
        errors = errors.concat(customElementErrors).toList();
        var onChange = getOnChange && getOnChange(element);
        var onDownload = getOnDownload && getOnDownload(id);
        var onRemove = function (eid, fileId) { return getOnRemove && getOnRemove(eid, fileId); };
        var customCss = getStyleOverride && getStyleOverride(id);
        var commonElementProps = {
            key: id,
            errors: errors,
            value: elementValue,
            defaultValue: elementDefault,
            onChange: onChange,
            css: Object.assign({}, css[element.type], customCss),
            showErrors: showInlineErrors,
        };
        if (element.hidden) {
            return null;
        }
        switch (element.type) {
            case 'group':
                var groupProps = {
                    css: commonElementProps.css,
                    customDisplays: customDisplays,
                    customValidationErrors: customValidationErrors,
                    element: element,
                    getOnChange: getOnChange,
                    getOnDownload: getOnDownload,
                    getOnRemove: getOnRemove,
                    getStyleOverride: getStyleOverride,
                    showInlineErrors: showInlineErrors,
                    state: state,
                    styleSheet: css,
                };
                return (React.createElement(formElements.GroupElement, __assign({}, groupProps)));
            case 'heading':
                return (React.createElement(formElements.HeadingElement, __assign({}, commonElementProps, { element: element })));
            case 'help':
                return (React.createElement(formElements.HelpElement, __assign({}, commonElementProps, { element: element })));
            case ssg_forms_processing_1.formDefinition.elementTypes.html:
                return (React.createElement(formElements.HtmlLabelElement, __assign({}, commonElementProps, { element: element })));
            case 'select':
                return (React.createElement(formElements.SelectElement, __assign({}, commonElementProps, { element: element, idAddOn: idAddOn })));
            case 'textArea':
                return (React.createElement(formElements.TextAreaElement, __assign({}, commonElementProps, { element: element })));
            case 'number':
                return (React.createElement(formElements.NumericElement, __assign({}, commonElementProps, { element: element })));
            case 'text':
                return (React.createElement(formElements.TextElement, __assign({}, commonElementProps, { element: element, idAddOn: idAddOn })));
            case 'date':
                return (React.createElement(formElements.DateElement, __assign({}, commonElementProps, { element: element, country: country })));
            case 'radio':
                return (React.createElement(formElements.RadioElement, __assign({}, commonElementProps, { element: element })));
            case ssg_forms_processing_1.formDefinition.elementTypes.likert:
                return (React.createElement(formElements.LikertScaleElement, __assign({}, commonElementProps, { element: element })));
            case 'checkbox':
                return (React.createElement(formElements.CheckboxElement, __assign({}, commonElementProps, { element: element })));
            case 'nationalId':
                return (React.createElement(formElements.NationalIdElement, __assign({}, commonElementProps, { element: element })));
            case 'time':
                return (React.createElement(formElements.TimeElement, __assign({}, commonElementProps, { element: element })));
            case 'tel': {
                return (React.createElement(formElements.PhoneElement, __assign({}, commonElementProps, { element: element })));
            }
            case 'electronicSignature': {
                return (React.createElement(formElements.ElectronicSignatureElement, __assign({}, commonElementProps, { element: element })));
            }
            case 'ignore':
                return null;
            case 'email':
                return (React.createElement(formElements.EmailElement, __assign({}, commonElementProps, { element: element })));
            case 'attachment': {
                return (React.createElement(formElements.AttachmentElement, __assign({}, commonElementProps, { element: element, onDownload: onDownload, onRemove: onRemove })));
            }
            case 'postalCode':
                return (React.createElement(formElements.PostalCodeElement, __assign({}, commonElementProps, { element: element })));
            case ssg_forms_processing_1.formDefinition.elementTypes.specialText:
                return (React.createElement(formElements.SpecializedTextElement, __assign({}, commonElementProps, { element: element })));
            case ssg_forms_processing_1.formDefinition.elementTypes.emailNotification:
                return (React.createElement(formElements.EmailNotificationElement, __assign({}, commonElementProps, { element: element })));
            case ssg_forms_processing_1.formDefinition.elementTypes.gisCoordinates:
                return (React.createElement(formElements.GISCoordinatesElement, __assign({}, commonElementProps, { element: element })));
            case ssg_forms_processing_1.formDefinition.elementTypes.unsupported:
                var descriptor = element.typeLabel || element.label;
                return showUnsupported ? (React.createElement("div", { "aria-label": descriptor + " is not supported.", tabIndex: -1, className: css.unsupported.unsupportedText },
                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: css.unsupported.unsupportedIcon, icon: free_solid_svg_icons_1.faExclamationTriangle }),
                    descriptor,
                    " is not supported.")) : null;
            default:
                console.log(type + ' Not Implemented');
                return null;
        }
    };
    return FormElement;
}(React.Component));
exports.FormElement = FormElement;
exports.default = react_styleable_1.default(form_element_style_1.default)(FormElement);


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
__webpack_require__(270);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { text: 'ssg-forms-input input-gis', textError: 'ssg-forms-input input-gis input-error', disabled: 'disabled', button: 'ssg-forms-btn button-gis' });
exports.default = defaultStyle;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(274);
var defaultStyle = {
    heading: 'ssg-forms-header ssg-forms-text large',
    group: ''
};
exports.default = defaultStyle;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var heading_element_1 = __webpack_require__(332);
exports.HeadingElement = heading_element_1.default;
var heading_element_style_1 = __webpack_require__(68);
exports.defaultStyle = heading_element_style_1.default;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(275);
var defaultStyle = {
    helpText: 'ssg-help-text ssg-forms-text normal'
};
exports.default = defaultStyle;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var help_element_1 = __webpack_require__(333);
exports.HelpElement = help_element_1.default;
var help_element_style_1 = __webpack_require__(70);
exports.defaultStyle = help_element_style_1.default;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var defaultStyle = {
    label: 'ssg-forms-text',
};
exports.default = defaultStyle;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var html_label_element_1 = __webpack_require__(334);
exports.HtmlLabelElement = html_label_element_1.default;
var html_label_element_style_1 = __webpack_require__(72);
exports.defaultStyle = html_label_element_style_1.default;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
__webpack_require__(276);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { radioGroup: 'ssg-likert-group', radio: 'ssg-likert-input', readOnly: 'readonly', radioChoice: 'ssg-likert-choice-label ssg-forms-text normal', optionWrapper: 'ssg-likert-choice-wrapper' });
exports.default = defaultStyle;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
/**
 * This will return the value that should be used for the multi-section answers
 * @param value the value entered that would override the default value
 * @param defaultValue the initial value
 */
function getBaseValue(value, defaultValue) {
    if (value !== undefined && defaultValue !== undefined) {
        var TIME_KEYS = ['hour', 'minute', 'period'];
        var isTimeValue = TIME_KEYS.every(function (key) { return value.has(key); });
        if (isTimeValue) {
            var shouldUseValue = value.every(function (val, key) {
                if (typeof val === 'string') {
                    return val != undefined && val != '' && val != null;
                }
            });
            var shouldUseDefaultValue = defaultValue.every(function (val) {
                if (typeof val === 'string') {
                    return val != undefined && val != '' && val != null;
                }
            });
            if (shouldUseValue) {
                return value;
            }
            else if (shouldUseDefaultValue) {
                return defaultValue;
            }
            else {
                return immutable_1.Map({});
            }
        }
    }
    var currentValue = value !== undefined ? value : defaultValue !== undefined ? defaultValue : immutable_1.Map({});
    return currentValue;
}
exports.getBaseValue = getBaseValue;
/**
 * Returns a particular section of a multi-section answer
 * @param value the value entered that would override the default value
 * @param defaultValue the initial value
 * @param sections the section or sections of this value that are to be returned.
 */
function getSectionValue(value, defaultValue) {
    var sections = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        sections[_i - 2] = arguments[_i];
    }
    var currentValue = getBaseValue(value, defaultValue);
    var sectionValue = currentValue && currentValue.getIn(sections);
    return sectionValue ? sectionValue : "";
}
exports.getSectionValue = getSectionValue;
/**
 * This handles the possibility that a particular section of a multi-sectioned value needs to be updated
 * @param value the value entered that would override the default value
 * @param defaultValue the initial value
 * @param sectionValue the value that will be set for the particular section
 * @param sections the section of this value to be updated
 */
function handleInput(value, defaultValue, sectionValue) {
    var sections = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        sections[_i - 3] = arguments[_i];
    }
    var currentValue = getBaseValue(value, defaultValue);
    var modifiedValue = currentValue.setIn(sections, sectionValue);
    return modifiedValue;
}
exports.handleInput = handleInput;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var national_id_element_1 = __webpack_require__(337);
exports.NationalIdElement = national_id_element_1.default;
var national_id_element_style_1 = __webpack_require__(77);
exports.defaultStyle = national_id_element_style_1.default;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { input: 'ssg-forms-input', inputError: 'ssg-forms-input input-error', inputGroup: 'ssg-forms-input-group', disabled: "disabled" });
exports.default = defaultStyle;


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var numeric_element_1 = __webpack_require__(338);
exports.NumericElement = numeric_element_1.default;
var numeric_element_style_1 = __webpack_require__(79);
exports.defaultStyle = numeric_element_style_1.default;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
__webpack_require__(277);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { input: 'ssg-forms-input', inputGroup: 'ssg-forms-input-group', noInputGroup: 'ssg-forms-no-input-group', inputGroupAddon: 'ssg-forms-addon' });
exports.default = defaultStyle;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var phone_element_1 = __webpack_require__(339);
exports.PhoneElement = phone_element_1.default;
var phone_element_style_1 = __webpack_require__(81);
exports.defaultStyle = phone_element_style_1.default;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { phone: 'ssg-forms-input', phoneError: 'ssg-forms-input input-error' });
exports.default = defaultStyle;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var postal_code_element_1 = __webpack_require__(340);
exports.PostalCodeElement = postal_code_element_1.default;
var postal_code_element_style_1 = __webpack_require__(83);
exports.defaultStyle = postal_code_element_style_1.default;


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { input: 'ssg-forms-input' });
exports.default = defaultStyle;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var radio_element_1 = __webpack_require__(341);
exports.RadioElement = radio_element_1.default;
var radio_element_style_1 = __webpack_require__(85);
exports.defaultStyle = radio_element_style_1.default;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
__webpack_require__(51);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { group: 'ssg-radio-fieldset', label: 'ssg-forms-label ssg-radio-group-label-legend', radio: 'ssg-radio-input', radioGroup: 'ssg-radio-group', subText: 'text-sub-text', radioChoice: 'ssg-radio-choice-label ssg-forms-text normal', optionWrapper: 'ssg-radio-choice-wrapper', disabled: 'disabled', readOnly: 'just-read', emptyValue: '' });
exports.default = defaultStyle;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var select_element_1 = __webpack_require__(342);
exports.SelectElement = select_element_1.default;
var select_element_style_1 = __webpack_require__(87);
exports.defaultStyle = select_element_style_1.default;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
__webpack_require__(278);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { dropdownControl: "ssg-dropdown-control", dropdownControlError: "ssg-dropdown-control input-error", dropdownIndicator: "ssg-dropdown-indicator", dropdownLoadingContainer: "ssg-dropdown-loading-container", dropdownLoading: "ssg-dropdown-loading", dropdownMenu: "ssg-dropdown-menu", dropdownMenuList: "ssg-dropdown-menu-list", dropdownOption: "ssg-forms-option", matchingText: "ssg-matching-text", dropdownPlaceholder: "ssg-dropdown-placeholder", dropdownSeparator: "ssg-dropdown-indicator-separator", dropdownSelectedText: "ssg-dropdown-selected-text", readOnlySelect: "ssg-forms-input readonly", select: "ssg-forms-select " });
exports.default = defaultStyle;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
__webpack_require__(279);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { inputWrapper: 'ssg-single-checkbox-input-wrapper', label: 'ssg-forms-text normal ssg-single-checkbox-label', input: 'ssg-single-checkbox-input', readOnly: 'just-read' });
exports.default = defaultStyle;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
__webpack_require__(51);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { inputWrapper: 'ssg-radio-choice-wrapper', label: 'ssg-forms-text normal ssg-radio-choice-label', input: 'ssg-radio-input', readOnly: 'just-read' });
exports.default = defaultStyle;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var specialized_text_element_1 = __webpack_require__(347);
exports.SpecializedTextElement = specialized_text_element_1.default;
var specialized_text_element_style_1 = __webpack_require__(91);
exports.defaultStyle = specialized_text_element_style_1.default;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { text: 'ssg-forms-input' });
exports.default = defaultStyle;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var text_area_element_1 = __webpack_require__(352);
exports.TextAreaElement = text_area_element_1.default;
var text_area_element_style_1 = __webpack_require__(93);
exports.defaultStyle = text_area_element_style_1.default;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
__webpack_require__(280);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { countdownValid: 'ssg-forms-countdown', countdownInvalid: 'ssg-forms-countdown invalid', textarea: 'ssg-forms-input ssg-forms-text-input', textareaError: 'ssg-forms-input input-error ssg-forms-text-input', disabled: 'disabled' });
exports.default = defaultStyle;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var text_element_1 = __webpack_require__(353);
exports.TextElement = text_element_1.default;
var text_element_style_1 = __webpack_require__(95);
exports.defaultStyle = text_element_style_1.default;


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
__webpack_require__(281);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { text: 'ssg-forms-input', textError: 'ssg-forms-input input-error', subText: 'text-sub-text', disabled: 'disabled' });
exports.default = defaultStyle;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var time_element_1 = __webpack_require__(355);
exports.TimeElement = time_element_1.default;
var time_element_style_1 = __webpack_require__(97);
exports.defaultStyle = time_element_style_1.default;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(8);
__webpack_require__(282);
var defaultStyle = __assign({}, common_1.defaultElementStyles, { inputWrapper: 'timegroup-sub-section', inputGroup: 'ssg-forms-input-group ssg-time-element', inputGroupError: 'ssg-forms-input-group input-error ssg-time-element', input: 'ssg-forms-input ssg-time-element', section: 'ssg-forms-input-section ssg-time-input-section', sectionError: 'ssg-forms-input-section-error ssg-time-input-section', periodSection: 'ssg-forms-input-section ssg-time-input-section period-section', displayText: 'ssg-time-text' });
exports.default = defaultStyle;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ssg_form_component_1 = __webpack_require__(356);
exports.SsgFormComponent = ssg_form_component_1.default;
var ssg_form_reducer_1 = __webpack_require__(358);
exports.ssgFormsReducer = ssg_form_reducer_1.ssgFormsReducer;
exports.SsgFormsState = ssg_form_reducer_1.SsgFormsState;
var ssg_form_actions_1 = __webpack_require__(31);
exports.ssgFormActions = ssg_form_actions_1.default;
var ssgFormComponentHelpers = __webpack_require__(357);
exports.ssgFormComponentHelpers = ssgFormComponentHelpers;
var ssg_form_component_style_1 = __webpack_require__(99);
exports.defaultSsgFormStyle = ssg_form_component_style_1.default;
var ssg_form_position_1 = __webpack_require__(100);
exports.SsgFormAnchor = ssg_form_position_1.SsgFormAnchor;
exports.SsgFormRelation = ssg_form_position_1.SsgFormRelation;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(286);
var defaultStyle = {
    form: 'ssg-form',
    formBody: '',
    title: '',
    reCaptcha: 'ssg-forms-recaptcha',
    actions: 'ssg-forms-actions',
    defaultButton: 'ssg-forms-btn',
    secondaryButton: 'ssg-forms-btn ssg-forms-btn-secondary',
    primaryButton: 'ssg-forms-btn ssg-forms-btn-primary',
    requiredKey: 'ssg-forms-text normal ssg-forms-required-key',
    requiredIndicator: 'ssg-forms-required-indicator',
    errorStyle: {
        errorWrapper: 'form-validation-error-wrapper',
        errorSection: 'form-validation-error-section',
        errorList: 'form-validation-error-list',
    }
};
exports.default = defaultStyle;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SsgFormAnchor;
(function (SsgFormAnchor) {
    SsgFormAnchor["BODY"] = "ssg-forms-body";
    SsgFormAnchor["INNER_BODY"] = "ssg-forms-body-inner";
    SsgFormAnchor["ACTIONS"] = "ssg-forms-actions";
    SsgFormAnchor["ELEMENT"] = "ssg-forms-element";
})(SsgFormAnchor = exports.SsgFormAnchor || (exports.SsgFormAnchor = {}));
var SsgFormRelation;
(function (SsgFormRelation) {
    SsgFormRelation["BEFORE"] = "before";
    SsgFormRelation["AFTER"] = "after";
})(SsgFormRelation = exports.SsgFormRelation || (exports.SsgFormRelation = {}));


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/** This is the accessibilityNotificationsEmitter object, call its functions to have messages read by the screen reader */
exports.accessibilityNotificationsEmitter = {
    componentRef: null,
    polite: function (message) { return addNotification(exports.accessibilityNotificationsEmitter.componentRef, message, 'polite'); },
    assertive: function (message) { return addNotification(exports.accessibilityNotificationsEmitter.componentRef, message, 'assertive'); },
};
/**
 * This function will add a new message to the notifications of the [[AccessibilityNotifications]] component
 * @param component [[AccessibilityNotifications]] component reference
 * @param message the message text to be read
 * @param alertLevel the priority level of the message
 */
function addNotification(component, message, alertLevel) {
    if (!component)
        return;
    return component.addNotification(message, alertLevel);
}
exports.default = exports.accessibilityNotificationsEmitter;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var accessibility_notifications_1 = __webpack_require__(359);
exports.AccessibilityNotifications = accessibility_notifications_1.default;
var accessibility_notifications_emitter_1 = __webpack_require__(101);
exports.accessibilityNotificationsEmitter = accessibility_notifications_emitter_1.default;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(288);
var defaultStyle = {
    display: 'ssg-forms-collapsible-section-display',
    collapseToggle: 'ssg-forms-collapsible-section-toggle',
    icon: 'ssg-forms-collapsible-section-icon',
    label: 'ssg-forms-collapsible-section-label ssg-forms-text large',
    content: 'ssg-forms-collapsible-section-content',
};
exports.default = defaultStyle;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * All available custom icons are identified here.
 * The value is the underlying filename, which is used
 * to determine how to load the file; svgs are loaded differently
 * than other image file types.
 */
var CustomIconSet;
(function (CustomIconSet) {
    CustomIconSet["ic_bonterra_logo_purple"] = "ic_bonterra_logo_purple.svg";
    CustomIconSet["ic_bonterra_logo_white"] = "ic_bonterra_logo_white.svg";
    CustomIconSet["ic_calendar_14x14"] = "ic_calendar_14x14.svg";
    CustomIconSet["ic_calendar_14x14_1x"] = "ic_calendar_14x14@1x.png";
    CustomIconSet["ic_calendar_14x14_2x"] = "ic_calendar_14x14@2x.png";
    CustomIconSet["ic_calendar_18x18"] = "ic_calendar_18x18.svg";
    CustomIconSet["ic_calendar_18x18_1x"] = "ic_calendar_18x18@1x.png";
    CustomIconSet["ic_calendar_18x18_2x"] = "ic_calendar_18x18@2x.png";
    CustomIconSet["ic_check_14x14"] = "ic_check_14x14.svg";
    CustomIconSet["ic_collapse_18x18"] = "ic_collapse_18x18.svg";
    CustomIconSet["ic_dashboard_16x12"] = "ic_dashboard_16x12_white.svg";
    CustomIconSet["ic_dashboard_16x12_1x"] = "ic_dashboard_16x12_white@1x.png";
    CustomIconSet["ic_dashboard_16x12_2x"] = "ic_dashboard_16x12_white@2x.png";
    CustomIconSet["ic_desktop_switch_16x14"] = "ic_desktop_switch_16x14.svg";
    CustomIconSet["ic_disclaim_msg_14x14"] = "ic_disclaim_msg_14x14.svg";
    CustomIconSet["ic_disclaim_msg_14x14_1x"] = "ic_disclaim_msg_14x14@1x.png";
    CustomIconSet["ic_disclaim_msg_14x14_2x"] = "ic_disclaim_msg_14x14@2x.png";
    CustomIconSet["ic_down_arrow_14x14"] = "ic_down_arrow_14x14.svg";
    CustomIconSet["ic_down_arrow_14x14_1x"] = "ic_down_arrow_14x14@1x.png";
    CustomIconSet["ic_down_arrow_14x14_2x"] = "ic_down_arrow_14x14@2x.png";
    CustomIconSet["ic_down_arrow_18x18"] = "ic_down_arrow_18x18.svg";
    CustomIconSet["ic_down_arrow_18x18_1x"] = "ic_down_arrow_18x18@1x.png";
    CustomIconSet["ic_down_arrow_18x18_2x"] = "ic_down_arrow_18x18@2x.png";
    CustomIconSet["ic_edit_14x14"] = "ic_edit_14x14.svg";
    CustomIconSet["ic_edit_14x14_1x"] = "ic_edit_14x14@1x.png";
    CustomIconSet["ic_edit_14x14_2x"] = "ic_edit_14x14@2x.png";
    CustomIconSet["ic_edit_18x18"] = "ic_edit_18x18.svg";
    CustomIconSet["ic_edit_18x18_1x"] = "ic_edit_18x18@1x.png";
    CustomIconSet["ic_edit_18x18_2x"] = "ic_edit_18x18@2x.png";
    CustomIconSet["ic_expand_18x18"] = "ic_expand_18x18.svg";
    CustomIconSet["ic_form_submit_16x16"] = "ic_form_submit_16x16.svg";
    CustomIconSet["ic_home_16x16"] = "ic_home_16x16.svg";
    CustomIconSet["ic_info_18x18"] = "ic_info_18x18.svg";
    CustomIconSet["ic_info_18x18_1x"] = "ic_info_18x18@1x.png";
    CustomIconSet["ic_info_18x18_2x"] = "ic_info_18x18@2x.png";
    CustomIconSet["ic_left_arrow_14x14"] = "ic_left_arrow_14x14.svg";
    CustomIconSet["ic_left_arrow_14x14_1x"] = "ic_left_arrow_14x14@1x.png";
    CustomIconSet["ic_left_arrow_14x14_2x"] = "ic_left_arrow_14x14@2x.png";
    CustomIconSet["ic_left_arrow_18x18"] = "ic_left_arrow_18x18.svg";
    CustomIconSet["ic_left_arrow_18x18_1x"] = "ic_left_arrow_18x18@1x.png";
    CustomIconSet["ic_left_arrow_18x18_2x"] = "ic_left_arrow_18x18@2x.png";
    CustomIconSet["ic_link_14x14"] = "ic_link_14x14.svg";
    CustomIconSet["ic_link_14x14_1x"] = "ic_link_14x14@1x.png";
    CustomIconSet["ic_link_14x14_2x"] = "ic_link_14x14@2x.png";
    CustomIconSet["ic_link_18x18"] = "ic_link_18x18.svg";
    CustomIconSet["ic_link_18x18_1x"] = "ic_link_18x18@1x.png";
    CustomIconSet["ic_link_18x18_2x"] = "ic_link_18x18@2x.png";
    CustomIconSet["ic_lock_14x16"] = "ic_lock_14x16.svg";
    CustomIconSet["ic_logout_14x16"] = "ic_logout_14x16.svg";
    CustomIconSet["ic_magnifying_glass_14x14"] = "ic_magnifying_glass_14x14.svg";
    CustomIconSet["ic_magnifying_glass_14x14_1x"] = "ic_magnifying_glass_14x14@1x.png";
    CustomIconSet["ic_magnifying_glass_14x14_2x"] = "ic_magnifying_glass_14x14@2x.png";
    CustomIconSet["ic_magnifying_glass_18x18"] = "ic_magnifying_glass_18x18.svg";
    CustomIconSet["ic_magnifying_glass_18x18_1x"] = "ic_magnifying_glass_18x18@1x.png";
    CustomIconSet["ic_magnifying_glass_18x18_2x"] = "ic_magnifying_glass_18x18@2x.png";
    CustomIconSet["ic_menu_18x12"] = "ic_menu_18x12.svg";
    CustomIconSet["ic_menu_18x12_1x"] = "ic_menu_18x12@1x.png";
    CustomIconSet["ic_menu_18x12_2x"] = "ic_menu_18x12@2x.png";
    CustomIconSet["ic_message_18x13"] = "ic_message_18x13.svg";
    CustomIconSet["ic_message_18x13_1x"] = "ic_message_18x13@1x.png";
    CustomIconSet["ic_message_18x13_2x"] = "ic_message_18x13@2x.png";
    CustomIconSet["ic_paper_clip_14x14"] = "ic_paper_clip_14x14.svg";
    CustomIconSet["ic_paper_clip_14x14_1x"] = "ic_paper_clip_14x14@1x.png";
    CustomIconSet["ic_paper_clip_14x14_2x"] = "ic_paper_clip_14x14@2x.png";
    CustomIconSet["ic_paper_clip_18x18"] = "ic_paper_clip_18x18.svg";
    CustomIconSet["ic_paper_clip_18x18_1x"] = "ic_paper_clip_18x18@1x.png";
    CustomIconSet["ic_paper_clip_18x18_2x"] = "ic_paper_clip_18x18@2x.png";
    CustomIconSet["ic_portal_participants_36x36_1x"] = "ic_portal_participants_36x36@1x.png";
    CustomIconSet["ic_portal_participants_36x36_2x"] = "ic_portal_participants_36x36@2x.png";
    CustomIconSet["ic_portal_participants_36x36_3x"] = "ic_portal_participants_36x36@3x.svg";
    CustomIconSet["ic_publish_14x14"] = "ic_publish_14x14.svg";
    CustomIconSet["ic_publish_14x14_1x"] = "ic_publish_14x14@1x.png";
    CustomIconSet["ic_publish_14x14_2x"] = "ic_publish_14x14@2x.png";
    CustomIconSet["ic_publish_18x18"] = "ic_publish_18x18.svg";
    CustomIconSet["ic_publish_18x18_1x"] = "ic_publish_18x18@1x.png";
    CustomIconSet["ic_publish_18x18_2x"] = "ic_publish_18x18@2x.png";
    CustomIconSet["ic_remove_14x14"] = "ic_remove_14x14.svg";
    CustomIconSet["ic_remove_14x14_1x"] = "ic_remove_14x14@1x.png";
    CustomIconSet["ic_remove_14x14_2x"] = "ic_remove_14x14@2x.png";
    CustomIconSet["ic_remove_18x18"] = "ic_remove_18x18.svg";
    CustomIconSet["ic_remove_18x18_1x"] = "ic_remove_18x18@1x.png";
    CustomIconSet["ic_remove_18x18_2x"] = "ic_remove_18x18@2x.png";
    CustomIconSet["ic_retract_14x14"] = "ic_retract_14x14.svg";
    CustomIconSet["ic_retract_14x14_1x"] = "ic_retract_14x14@1x.png";
    CustomIconSet["ic_retract_14x14_2x"] = "ic_retract_14x14@2x.png";
    CustomIconSet["ic_retract_18x18"] = "ic_retract_18x18.svg";
    CustomIconSet["ic_retract_18x18_1x"] = "ic_retract_18x18@1x.png";
    CustomIconSet["ic_retract_18x18_2x"] = "ic_retract_18x18@2x.png";
    CustomIconSet["ic_right_arrow_14x14"] = "ic_right_arrow_14x14.svg";
    CustomIconSet["ic_right_arrow_14x14_1x"] = "ic_right_arrow_14x14@1x.png";
    CustomIconSet["ic_right_arrow_14x14_2x"] = "ic_right_arrow_14x14@2x.png";
    CustomIconSet["ic_right_arrow_18x18"] = "ic_right_arrow_18x18.svg";
    CustomIconSet["ic_right_arrow_18x18_1x"] = "ic_right_arrow_18x18@1x.png";
    CustomIconSet["ic_right_arrow_18x18_2x"] = "ic_right_arrow_18x18@2x.png";
    CustomIconSet["ic_site_16x16"] = "ic_site_16x16.svg";
    CustomIconSet["ic_spinner_18x18_1x"] = "ic_spinner_18x18@1x.svg";
    CustomIconSet["ic_spinner_36x36_2x"] = "ic_spinner_36x36@2x.svg";
    CustomIconSet["ic_sprocket_14x14"] = "ic_sprocket_14x14.svg";
    CustomIconSet["ic_ssg_logo_grey_green_leaf"] = "ic_ssg_logo_grey_green_leaf.svg";
    CustomIconSet["ic_user_pref_16x16"] = "ic_user_pref_16x16.svg";
    CustomIconSet["ic_x_14x14"] = "ic_x_14x14.svg";
    CustomIconSet["ic_x_14x14_1x"] = "ic_x_14x14@1x.png";
    CustomIconSet["ic_x_14x14_2x"] = "ic_x_14x14@2x.png";
    CustomIconSet["ic_x_18x18"] = "ic_x_18x18.svg";
    CustomIconSet["ic_x_18x18_1x"] = "ic_x_18x18@1x.png";
    CustomIconSet["ic_x_18x18_2x"] = "ic_x_18x18@2x.png";
})(CustomIconSet = exports.CustomIconSet || (exports.CustomIconSet = {}));
exports.default = CustomIconSet;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * enum corresponding to countries used for date formatting
 */
var CountryEnum;
(function (CountryEnum) {
    CountryEnum["Canada"] = "CA";
    CountryEnum["UnitedKingdom"] = "UK";
    CountryEnum["UnitedStates"] = "US";
})(CountryEnum || (CountryEnum = {}));
exports.default = CountryEnum;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var modal_style_1 = __webpack_require__(107);
var accessibility_helper_functions_1 = __webpack_require__(32);
var custom_icon_1 = __webpack_require__(18);
/**
 * @hidden this function allows us to have a type safe way of accessing the ids of the various parts of the modal display
 * @param id id of the modal
 */
var modalElementsIds = function (id) {
    return {
        modal: id + "-modal",
        dialog: id + "-dialog",
        header: id + "-header",
        title: id + "-title",
        closeButton: id + "-close",
        body: id + "-body",
        footer: id + "-footer",
        background: id + "-background"
    };
};
var ModalWindow = /** @class */ (function (_super) {
    __extends(ModalWindow, _super);
    function ModalWindow(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            show: false
        };
        return _this;
    }
    /**
     * @hidden when initially mounting the component we set a reference to this component, if that option is used
     */
    ModalWindow.prototype.componentWillMount = function () {
        var modalRef = this.props.modalRef;
        modalRef && modalRef(this);
    };
    /**
     * @hidden add the event listener to trap focus inside of the modal while it is open.
     */
    ModalWindow.prototype.componentDidMount = function () {
        var _this = this;
        var id = this.props.id;
        var modal = document.getElementById(id);
        modal && modal.addEventListener('keydown', function (event) { return _this.handleKeyboardInput(modal, event); });
    };
    /**
     * @hidden remove the event listener when the component is unmounted
     */
    ModalWindow.prototype.componentDidUnMount = function () {
        var _this = this;
        var id = this.props.id;
        var modal = document.getElementById(id);
        modal && modal.removeEventListener('keydown', function (event) { return _this.handleKeyboardInput(modal, event); });
    };
    /**
     * @hidden
     * handles closing the modal upon pressing the Escape key, and trapping focus inside the modal when tabbing
     * @param element This is the HTMLElement that you are trying to limit focus to.
     * @param event This is the keybord event that has occurred
     */
    ModalWindow.prototype.handleKeyboardInput = function (element, event) {
        if (event.key === "Escape" || event.keyCode === 111) {
            this.handleCloseButtonInput(event);
        }
        accessibility_helper_functions_1.trapFocus(element, event);
    };
    /**
     * This function causes the modal to be shown (unless the internal state is overriden by the [[overrideShow]] prop).
     */
    ModalWindow.prototype.show = function () {
        var _this = this;
        var onShow = this.props.onShow;
        this.setState({
            show: true
        }, function () {
            _this.focusOnModal();
            onShow && onShow();
        });
    };
    /**
     * This function causes the modal to be closed (unless the internal state is overriden by the [[overrideShow]] prop).
     */
    ModalWindow.prototype.hide = function () {
        var _this = this;
        var onHide = this.props.onHide;
        this.setState({
            show: false
        }, function () {
            _this.focusOnPage();
            onHide && onHide();
        });
    };
    /**
     * @hidden focuses page on the body of the modal
     */
    ModalWindow.prototype.focusOnModal = function () {
        var focusTarget = document.getElementById(modalElementsIds(this.props.id).dialog);
        focusTarget && focusTarget.focus();
    };
    /**
     * @hidden focuses page on an external element, if one is provided as a prop
     */
    ModalWindow.prototype.focusOnPage = function () {
        var pageElementId = this.props.pageElementId;
        if (!!pageElementId) {
            var pageElement = document.getElementById(pageElementId);
            pageElement && pageElement.focus();
        }
    };
    /**
     * @hidden Handles the close button being pressed by hiding the modal and calling the onClose callback.
     * @param e the mouse event associated with clicking the close button
     */
    ModalWindow.prototype.handleCloseButtonInput = function (e) {
        var onClose = this.props.onClose;
        this.hide();
        onClose && onClose(e);
    };
    ModalWindow.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, overrideShow = _a.overrideShow, footer = _a.footer, children = _a.children, css = _a.css, id = _a.id, hideCloseButton = _a.hideCloseButton;
        var showState = this.state.show;
        var show = overrideShow === undefined || overrideShow === null ? showState : overrideShow;
        var ids = modalElementsIds(id);
        return (React.createElement("div", { id: id },
            React.createElement("div", { id: ids.modal, role: "application", className: show ? css.show : css.hide },
                React.createElement("div", { id: ids.dialog, tabIndex: -1, role: "dialog", "aria-labelledby": ids.title, "aria-describedby": ids.body, className: css.dialog },
                    React.createElement("div", { className: css.content },
                        React.createElement("div", { id: ids.header, className: css.header },
                            hideCloseButton ? null : (React.createElement("button", { id: ids.closeButton, type: "button", "aria-label": "close", className: css.closeButton, onClick: function (e) { return _this.handleCloseButtonInput(e); } },
                                React.createElement(custom_icon_1.CustomIcon, { iconChoice: custom_icon_1.CustomIconSet.ic_x_18x18, css: { ssgCustomIconContainer: css.closeIcon } }))),
                            React.createElement("h4", { id: ids.title, className: css.title }, title)),
                        React.createElement("div", { tabIndex: -1, id: ids.body, className: css.body + " ssg-forms-no-focus" }, children),
                        React.createElement("div", { id: ids.footer, className: css.footer }, footer)))),
            React.createElement("div", { id: ids.background, className: show ? css.backgroundShow : css.backgroundHide })));
    };
    return ModalWindow;
}(React.Component));
exports.ModalWindow = ModalWindow;
exports.default = react_styleable_1.default(modal_style_1.default)(ModalWindow);


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(295);
var modalDefaultStyle = {
    show: "ssg-forms-modal",
    hide: "ssg-forms-modal hidden",
    backgroundShow: "ssg-forms-modal-backdrop",
    backgroundHide: "ssg-forms-modal-backdrop hidden",
    closeButton: "ssg-forms-icon-btn ssg-forms-close",
    closeIcon: 'ssg-custom-icon-container-inline',
    dialog: "ssg-forms-modal-dialog",
    content: "ssg-forms-modal-content",
    header: "ssg-forms-modal-header",
    title: "ssg-forms-modal-title",
    body: "ssg-forms-modal-body ssg-forms-scrollable",
    footer: "ssg-forms-modal-footer",
};
exports.default = modalDefaultStyle;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var classnames_1 = __webpack_require__(6);
var header_style_1 = __webpack_require__(391);
var custom_icon_1 = __webpack_require__(18);
/** Displays a Header fixed at the top of the application, has a hamburger menu button by default. */
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** handles the hamburger menu being clicked */
    Header.prototype.onHamburgerClicked = function () {
        var onMenuClicked = this.props.onMenuClicked;
        onMenuClicked && onMenuClicked();
    };
    Header.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, hideHamburgerMenu = _b.hideHamburgerMenu, navigationOpen = _b.navigationOpen, headerItems = _b.headerItems, contentElementId = _b.contentElementId, onContentLink = _b.onContentLink, navigationElementId = _b.navigationElementId, onNavLink = _b.onNavLink, css = _b.css;
        var hamburgerMenu = !hideHamburgerMenu ? (React.createElement("button", { id: 'toggle-menu', "aria-label": 'toggle menu', type: 'button', className: classnames_1.default(css.headerItem, css.headerButton, (_a = {}, _a[css.alternateHeaderMenuBtn] = navigationOpen, _a)), onClick: function (e) { return _this.onHamburgerClicked(); } }, navigationOpen ? (React.createElement(custom_icon_1.CustomIcon, { id: 'close-menu-icon', iconChoice: custom_icon_1.CustomIconSet.ic_x_18x18 })) : (React.createElement("div", null,
            React.createElement(custom_icon_1.CustomIcon, { id: 'menu-icon', iconChoice: custom_icon_1.CustomIconSet.ic_menu_18x12 }),
            React.createElement("span", { className: css.headerButtonText }, "Menu"))))) : null;
        return (React.createElement("nav", { className: css.header },
            React.createElement("ul", { className: css.screenReaderOnly },
                React.createElement("li", { className: css.screenReaderOnly },
                    React.createElement("a", { id: 'menu', className: css.screenReaderOnly, href: '#header-menu-items' }, "Skip To Menu")),
                navigationElementId ? (React.createElement("li", { className: css.screenReaderOnly },
                    React.createElement("a", { id: 'nav', className: css.screenReaderOnly, href: "#" + navigationElementId, onClick: function () { return onNavLink(); } }, "Skip To Navigation"))) : null,
                contentElementId ? (React.createElement("li", { className: css.screenReaderOnly },
                    React.createElement("a", { id: 'content', className: css.screenReaderOnly, href: "#" + contentElementId, onClick: function () { return onContentLink(); } }, "Skip To Content"))) : null),
            hamburgerMenu,
            React.createElement("div", { id: 'header-menu-items', className: css.headerMenuItems }, headerItems)));
    };
    return Header;
}(React.Component));
exports.Header = Header;
exports.default = react_styleable_1.default(header_style_1.default)(Header);


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var nav_style_1 = __webpack_require__(110);
/**
 * Primary page navigation, expands out from the left side of the screen and can be collapsed.
 * Contains a set of navLinks that are displayed when expanded.
 **/
var Nav = /** @class */ (function (_super) {
    __extends(Nav, _super);
    function Nav() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Nav.prototype.render = function () {
        var _a = this.props, id = _a.id, ariaLabel = _a.ariaLabel, expanded = _a.expanded, navLinks = _a.navLinks, css = _a.css;
        if (!expanded) {
            return null;
        }
        return (React.createElement("nav", { id: id || 'side-nav', "aria-label": ariaLabel || "Navigation", className: css.navBar },
            React.createElement("div", { role: "navigation", className: css.links }, navLinks)));
    };
    return Nav;
}(React.Component));
exports.Nav = Nav;
exports.default = react_styleable_1.default(nav_style_1.default)(Nav);


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(28);
var defaultStyle = {
    navBar: 'ssg-forms-nav-bar ssg-forms-scrollable',
    links: '',
};
/** styles used for custom icons used within the nav */
exports.navIconStyle = {
    ssgCustomIconContainer: 'ssg-forms-nav-icon-container',
    ssgCustomIcon: 'ssg-forms-nav-icon',
};
exports.default = defaultStyle;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var paging_control_1 = __webpack_require__(401);
exports.PagingControl = paging_control_1.default;
var paging_control_style_1 = __webpack_require__(112);
exports.defaultPagingControlStyle = paging_control_style_1.default;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(298);
var defaultStyle = {
    paginationButton: 'ssg-forms-btn ssg-forms-btn-primary',
    paginationInput: 'ssg-forms-input ssg-forms-page-input',
    paginationText: 'ssg-forms-pagination-text',
    paginationDisplay: 'ssg-forms-pagination',
    header: 'ssg-forms-page-header',
    additionalHeaderContent: 'ssg-forms-page-header-addl-content',
    title: 'ssg-forms-page-title-bar',
    titleText: 'ssg-forms-page-title-bar-text',
    footer: 'ssg-forms-page-footer',
    body: 'ssg-forms-page-body',
    display: 'ssg-forms-page',
    perPage: 'ssg-forms-per-page',
    perPageLabel: 'ssg-forms-per-page-label ssg-forms-text normal',
    perPageTooltipGroup: 'tooltip-group ssg-tooltip-inline',
    perPageDropdown: 'ssg-forms-select ssg-forms-dropdown ssg-forms-text normal',
    paginationGroup: 'ssg-forms-pagination-group',
};
exports.default = defaultStyle;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(299);
var defaultStyle = {
    button: "ssg-forms-btn ssg-forms-btn-primary",
    buttonSaving: "ssg-forms-btn ssg-forms-btn-primary disabled",
    spin: "ssg-forms-saving-icon ssg-forms-spin",
};
exports.default = defaultStyle;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var table_1 = __webpack_require__(409);
exports.Table = table_1.default;
var table_style_1 = __webpack_require__(115);
exports.defaultTableStyle = table_style_1.default;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(302);
var defaultStyle = {
    table: 'ssg-forms-table',
    heading: 'ssg-forms-table-heading',
    header: 'ssg-forms-table-header',
    headerLabel: 'ssg-forms-table-header-label',
    body: 'ssg-forms-table-body',
    row: 'ssg-forms-table-row',
    dataCell: 'ssg-forms-table-data ssg-forms-text normal',
    sortDropdown: 'ssg-forms-dropdown ssg-forms-text normal',
    sortDisplay: 'ssg-forms-sort-display',
    empty: 'ssg-forms-empty-text ssg-forms-text normal',
};
exports.default = defaultStyle;


/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports = require("react-router-dom");

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(284);
var error_reporting_1 = __webpack_require__(10);
exports.FormError = error_reporting_1.FormError;
exports.CollapsibleErrorDisplay = error_reporting_1.CollapsibleErrorDisplay;
exports.InlineWarning = error_reporting_1.InlineWarning;
var ssg_form_component_1 = __webpack_require__(98);
exports.SsgFormComponent = ssg_form_component_1.SsgFormComponent;
exports.ssgFormsReducer = ssg_form_component_1.ssgFormsReducer;
exports.ssgFormActions = ssg_form_component_1.ssgFormActions;
exports.SsgFormsState = ssg_form_component_1.SsgFormsState;
exports.defaultSsgFormStyle = ssg_form_component_1.defaultSsgFormStyle;
exports.ssgFormComponentHelpers = ssg_form_component_1.ssgFormComponentHelpers;
exports.SsgFormAnchor = ssg_form_component_1.SsgFormAnchor;
exports.SsgFormRelation = ssg_form_component_1.SsgFormRelation;
var formElements = __webpack_require__(20);
exports.formElements = formElements;
var utilities_1 = __webpack_require__(9);
exports.InPlaceTabsComponent = utilities_1.InPlaceTabsComponent;
exports.TabsComponent = utilities_1.TabsComponent;
exports.defaultTabsStyle = utilities_1.defaultTabsStyle;
exports.CopyButton = utilities_1.CopyButton;
exports.ModalWindow = utilities_1.ModalWindow;
exports.SaveButton = utilities_1.SaveButton;
exports.CancelButton = utilities_1.CancelButton;
exports.PagingControl = utilities_1.PagingControl;
exports.Table = utilities_1.Table;
exports.defaultTableStyle = utilities_1.defaultTableStyle;
exports.PagedList = utilities_1.PagedList;
exports.pagingActions = utilities_1.pagingActions;
exports.pagingReducer = utilities_1.pagingReducer;
exports.CustomIcon = utilities_1.CustomIcon;
exports.CustomIconSet = utilities_1.CustomIconSet;
exports.accessibilityNotificationsEmitter = utilities_1.accessibilityNotificationsEmitter;
exports.AccessibilityNotifications = utilities_1.AccessibilityNotifications;
exports.TooltipDisplay = utilities_1.TooltipDisplay;
exports.ConfirmModalWindow = utilities_1.ConfirmModalWindow;
exports.LoadingPane = utilities_1.LoadingPane;
exports.defaultPagingControlStyle = utilities_1.defaultPagingControlStyle;
exports.Widget = utilities_1.Widget;
exports.HighlightText = utilities_1.HighlightText;
exports.SearchBar = utilities_1.SearchBar;
exports.searchUtilities = utilities_1.searchUtilities;
exports.ImageDisplay = utilities_1.ImageDisplay;
exports.Wizard = utilities_1.Wizard;
exports.processDownloadedAttachment = utilities_1.processDownloadedAttachment;
exports.getAttachmentData = utilities_1.getAttachmentData;
exports.Menu = utilities_1.Menu;
exports.MenuButton = utilities_1.MenuButton;
exports.Header = utilities_1.Header;
exports.Nav = utilities_1.Nav;
exports.NavSection = utilities_1.NavSection;
exports.SsgNavLink = utilities_1.SsgNavLink;
exports.navIconStyle = utilities_1.navIconStyle;
exports.Application = utilities_1.Application;
exports.CollapsibleSection = utilities_1.CollapsibleSection;
exports.trapFocus = utilities_1.trapFocus;
exports.subElementNavigation = utilities_1.subElementNavigation;
exports.isInsideElement = utilities_1.isInsideElement;
exports.isFocusable = utilities_1.isFocusable;


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return icon; });
/* unused harmony export noAuto */
/* unused harmony export config */
/* unused harmony export toHtml */
/* unused harmony export layer */
/* unused harmony export text */
/* unused harmony export counter */
/* unused harmony export library */
/* unused harmony export dom */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parse; });
/* unused harmony export findIconDefinition */
/*!
 * Font Awesome Free 5.3.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */
var noop = function noop() {};

var _WINDOW = {};
var _DOCUMENT = {};
var _MUTATION_OBSERVER$1 = null;
var _PERFORMANCE = { mark: noop, measure: noop };

try {
  if (typeof window !== 'undefined') _WINDOW = window;
  if (typeof document !== 'undefined') _DOCUMENT = document;
  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER$1 = MutationObserver;
  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
} catch (e) {}

var _ref = _WINDOW.navigator || {};
var _ref$userAgent = _ref.userAgent;
var userAgent = _ref$userAgent === undefined ? '' : _ref$userAgent;

var WINDOW = _WINDOW;
var DOCUMENT = _DOCUMENT;
var MUTATION_OBSERVER = _MUTATION_OBSERVER$1;
var PERFORMANCE = _PERFORMANCE;

var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var UNITS_IN_GRID = 16;
var DEFAULT_FAMILY_PREFIX = 'fa';
var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var DATA_FA_I2SVG = 'data-fa-i2svg';
var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var DATA_PREFIX = 'data-prefix';
var DATA_ICON = 'data-icon';
var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = ['HTML', 'HEAD', 'STYLE', 'SCRIPT'];
var PRODUCTION = function () {
  try {
    return process.env.NODE_ENV === 'production';
  } catch (e) {
    return false;
  }
}();

var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);

var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];

var RESERVED_CLASSES = ['xs', 'sm', 'lg', 'fw', 'ul', 'li', 'border', 'pull-left', 'pull-right', 'spin', 'pulse', 'rotate-90', 'rotate-180', 'rotate-270', 'flip-horizontal', 'flip-vertical', 'stack', 'stack-1x', 'stack-2x', 'inverse', 'layers', 'layers-text', 'layers-counter'].concat(oneToTen.map(function (n) {
  return n + 'x';
})).concat(oneToTwenty.map(function (n) {
  return 'w-' + n;
}));

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();



var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var initial = WINDOW.FontAwesomeConfig || {};

function getAttrConfig(attr) {
  var element = DOCUMENT.querySelector('script[' + attr + ']');

  if (element) {
    return element.getAttribute(attr);
  }
}

function coerce(val) {
  // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
  // We'll assume that this is an indication that it should be toggled to true
  // For example <script data-search-pseudo-elements src="..."></script>
  if (val === '') return true;
  if (val === 'false') return false;
  if (val === 'true') return true;
  return val;
}

if (DOCUMENT && typeof DOCUMENT.querySelector === 'function') {
  var attrs = [['data-family-prefix', 'familyPrefix'], ['data-replacement-class', 'replacementClass'], ['data-auto-replace-svg', 'autoReplaceSvg'], ['data-auto-add-css', 'autoAddCss'], ['data-auto-a11y', 'autoA11y'], ['data-search-pseudo-elements', 'searchPseudoElements'], ['data-observe-mutations', 'observeMutations'], ['data-keep-original-source', 'keepOriginalSource'], ['data-measure-performance', 'measurePerformance'], ['data-show-missing-icons', 'showMissingIcons']];

  attrs.forEach(function (_ref) {
    var _ref2 = slicedToArray(_ref, 2),
        attr = _ref2[0],
        key = _ref2[1];

    var val = coerce(getAttrConfig(attr));

    if (val !== undefined && val !== null) {
      initial[key] = val;
    }
  });
}

var _default = _extends({
  familyPrefix: DEFAULT_FAMILY_PREFIX,
  replacementClass: DEFAULT_REPLACEMENT_CLASS,
  autoReplaceSvg: true,
  autoAddCss: true,
  autoA11y: true,
  searchPseudoElements: false,
  observeMutations: true,
  keepOriginalSource: true,
  measurePerformance: false,
  showMissingIcons: true
}, initial);

if (!_default.autoReplaceSvg) _default.observeMutations = false;

var config = _extends({}, _default);

WINDOW.FontAwesomeConfig = config;

var w = WINDOW || {};

if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];

var namespace = w[NAMESPACE_IDENTIFIER];

var functions = [];
var listener = function listener() {
  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
  loaded = 1;
  functions.map(function (fn) {
    return fn();
  });
};

var loaded = false;

if (IS_DOM) {
  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);

  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
}

var domready = function (fn) {
  if (!IS_DOM) return;
  loaded ? setTimeout(fn, 0) : functions.push(fn);
};

var d = UNITS_IN_GRID;

var meaninglessTransform = {
  size: 16,
  x: 0,
  y: 0,
  rotate: 0,
  flipX: false,
  flipY: false
};

function isReserved(name) {
  return ~RESERVED_CLASSES.indexOf(name);
}



function insertCss(css) {
  if (!css || !IS_DOM) {
    return;
  }

  var style = DOCUMENT.createElement('style');
  style.setAttribute('type', 'text/css');
  style.innerHTML = css;

  var headChildren = DOCUMENT.head.childNodes;
  var beforeChild = null;

  for (var i = headChildren.length - 1; i > -1; i--) {
    var child = headChildren[i];
    var tagName = (child.tagName || '').toUpperCase();
    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
      beforeChild = child;
    }
  }

  DOCUMENT.head.insertBefore(style, beforeChild);

  return css;
}

var _uniqueId = 0;

function nextUniqueId() {
  _uniqueId++;

  return _uniqueId;
}

function toArray(obj) {
  var array = [];

  for (var i = (obj || []).length >>> 0; i--;) {
    array[i] = obj[i];
  }

  return array;
}

function classArray(node) {
  if (node.classList) {
    return toArray(node.classList);
  } else {
    return (node.getAttribute('class') || '').split(' ').filter(function (i) {
      return i;
    });
  }
}

function getIconName(familyPrefix, cls) {
  var parts = cls.split('-');
  var prefix = parts[0];
  var iconName = parts.slice(1).join('-');

  if (prefix === familyPrefix && iconName !== '' && !isReserved(iconName)) {
    return iconName;
  } else {
    return null;
  }
}

function htmlEscape(str) {
  return ('' + str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function joinAttributes(attributes) {
  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
    return acc + (attributeName + '="' + htmlEscape(attributes[attributeName]) + '" ');
  }, '').trim();
}

function joinStyles(styles) {
  return Object.keys(styles || {}).reduce(function (acc, styleName) {
    return acc + (styleName + ': ' + styles[styleName] + ';');
  }, '');
}

function transformIsMeaningful(transform) {
  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
}

function transformForSvg(_ref) {
  var transform = _ref.transform,
      containerWidth = _ref.containerWidth,
      iconWidth = _ref.iconWidth;

  var outer = {
    transform: 'translate(' + containerWidth / 2 + ' 256)'
  };
  var innerTranslate = 'translate(' + transform.x * 32 + ', ' + transform.y * 32 + ') ';
  var innerScale = 'scale(' + transform.size / 16 * (transform.flipX ? -1 : 1) + ', ' + transform.size / 16 * (transform.flipY ? -1 : 1) + ') ';
  var innerRotate = 'rotate(' + transform.rotate + ' 0 0)';
  var inner = {
    transform: innerTranslate + ' ' + innerScale + ' ' + innerRotate
  };
  var path = {
    transform: 'translate(' + iconWidth / 2 * -1 + ' -256)'
  };
  return {
    outer: outer,
    inner: inner,
    path: path
  };
}

function transformForCss(_ref2) {
  var transform = _ref2.transform,
      _ref2$width = _ref2.width,
      width = _ref2$width === undefined ? UNITS_IN_GRID : _ref2$width,
      _ref2$height = _ref2.height,
      height = _ref2$height === undefined ? UNITS_IN_GRID : _ref2$height,
      _ref2$startCentered = _ref2.startCentered,
      startCentered = _ref2$startCentered === undefined ? false : _ref2$startCentered;

  var val = '';

  if (startCentered && IS_IE) {
    val += 'translate(' + (transform.x / d - width / 2) + 'em, ' + (transform.y / d - height / 2) + 'em) ';
  } else if (startCentered) {
    val += 'translate(calc(-50% + ' + transform.x / d + 'em), calc(-50% + ' + transform.y / d + 'em)) ';
  } else {
    val += 'translate(' + transform.x / d + 'em, ' + transform.y / d + 'em) ';
  }

  val += 'scale(' + transform.size / d * (transform.flipX ? -1 : 1) + ', ' + transform.size / d * (transform.flipY ? -1 : 1) + ') ';
  val += 'rotate(' + transform.rotate + 'deg) ';

  return val;
}

var ALL_SPACE = {
  x: 0,
  y: 0,
  width: '100%',
  height: '100%'
};

var makeIconMasking = function (_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      mask = _ref.mask,
      transform = _ref.transform;
  var mainWidth = main.width,
      mainPath = main.icon;
  var maskWidth = mask.width,
      maskPath = mask.icon;


  var trans = transformForSvg({ transform: transform, containerWidth: maskWidth, iconWidth: mainWidth });

  var maskRect = {
    tag: 'rect',
    attributes: _extends({}, ALL_SPACE, {
      fill: 'white'
    })
  };
  var maskInnerGroup = {
    tag: 'g',
    attributes: _extends({}, trans.inner),
    children: [{ tag: 'path', attributes: _extends({}, mainPath.attributes, trans.path, { fill: 'black' }) }]
  };
  var maskOuterGroup = {
    tag: 'g',
    attributes: _extends({}, trans.outer),
    children: [maskInnerGroup]
  };
  var maskId = 'mask-' + nextUniqueId();
  var clipId = 'clip-' + nextUniqueId();
  var maskTag = {
    tag: 'mask',
    attributes: _extends({}, ALL_SPACE, {
      id: maskId,
      maskUnits: 'userSpaceOnUse',
      maskContentUnits: 'userSpaceOnUse'
    }),
    children: [maskRect, maskOuterGroup]
  };
  var defs = {
    tag: 'defs',
    children: [{ tag: 'clipPath', attributes: { id: clipId }, children: [maskPath] }, maskTag]
  };

  children.push(defs, { tag: 'rect', attributes: _extends({ fill: 'currentColor', 'clip-path': 'url(#' + clipId + ')', mask: 'url(#' + maskId + ')' }, ALL_SPACE) });

  return {
    children: children,
    attributes: attributes
  };
};

var makeIconStandard = function (_ref) {
  var children = _ref.children,
      attributes = _ref.attributes,
      main = _ref.main,
      transform = _ref.transform,
      styles = _ref.styles;

  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  if (transformIsMeaningful(transform)) {
    var trans = transformForSvg({ transform: transform, containerWidth: main.width, iconWidth: main.width });
    children.push({
      tag: 'g',
      attributes: _extends({}, trans.outer),
      children: [{
        tag: 'g',
        attributes: _extends({}, trans.inner),
        children: [{
          tag: main.icon.tag,
          children: main.icon.children,
          attributes: _extends({}, main.icon.attributes, trans.path)
        }]
      }]
    });
  } else {
    children.push(main.icon);
  }

  return {
    children: children,
    attributes: attributes
  };
};

var asIcon = function (_ref) {
  var children = _ref.children,
      main = _ref.main,
      mask = _ref.mask,
      attributes = _ref.attributes,
      styles = _ref.styles,
      transform = _ref.transform;

  if (transformIsMeaningful(transform) && main.found && !mask.found) {
    var width = main.width,
        height = main.height;

    var offset = {
      x: width / height / 2,
      y: 0.5
    };
    attributes['style'] = joinStyles(_extends({}, styles, {
      'transform-origin': offset.x + transform.x / 16 + 'em ' + (offset.y + transform.y / 16) + 'em'
    }));
  }

  return [{
    tag: 'svg',
    attributes: attributes,
    children: children
  }];
};

var asSymbol = function (_ref) {
  var prefix = _ref.prefix,
      iconName = _ref.iconName,
      children = _ref.children,
      attributes = _ref.attributes,
      symbol = _ref.symbol;

  var id = symbol === true ? prefix + '-' + config.familyPrefix + '-' + iconName : symbol;

  return [{
    tag: 'svg',
    attributes: {
      style: 'display: none;'
    },
    children: [{
      tag: 'symbol',
      attributes: _extends({}, attributes, { id: id }),
      children: children
    }]
  }];
};

function makeInlineSvgAbstract(params) {
  var _params$icons = params.icons,
      main = _params$icons.main,
      mask = _params$icons.mask,
      prefix = params.prefix,
      iconName = params.iconName,
      transform = params.transform,
      symbol = params.symbol,
      title = params.title,
      extra = params.extra,
      _params$watchable = params.watchable,
      watchable = _params$watchable === undefined ? false : _params$watchable;

  var _ref = mask.found ? mask : main,
      width = _ref.width,
      height = _ref.height;

  var widthClass = 'fa-w-' + Math.ceil(width / height * 16);
  var attrClass = [config.replacementClass, iconName ? config.familyPrefix + '-' + iconName : '', widthClass].filter(function (c) {
    return extra.classes.indexOf(c) === -1;
  }).concat(extra.classes).join(' ');

  var content = {
    children: [],
    attributes: _extends({}, extra.attributes, {
      'data-prefix': prefix,
      'data-icon': iconName,
      'class': attrClass,
      'role': 'img',
      'xmlns': 'http://www.w3.org/2000/svg',
      'viewBox': '0 0 ' + width + ' ' + height
    })
  };

  if (watchable) {
    content.attributes[DATA_FA_I2SVG] = '';
  }

  if (title) content.children.push({ tag: 'title', attributes: { id: content.attributes['aria-labelledby'] || 'title-' + nextUniqueId() }, children: [title] });

  var args = _extends({}, content, {
    prefix: prefix,
    iconName: iconName,
    main: main,
    mask: mask,
    transform: transform,
    symbol: symbol,
    styles: extra.styles
  });

  var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args),
      children = _ref2.children,
      attributes = _ref2.attributes;

  args.children = children;
  args.attributes = attributes;

  if (symbol) {
    return asSymbol(args);
  } else {
    return asIcon(args);
  }
}

function makeLayersTextAbstract(params) {
  var content = params.content,
      width = params.width,
      height = params.height,
      transform = params.transform,
      title = params.title,
      extra = params.extra,
      _params$watchable2 = params.watchable,
      watchable = _params$watchable2 === undefined ? false : _params$watchable2;


  var attributes = _extends({}, extra.attributes, title ? { 'title': title } : {}, {
    'class': extra.classes.join(' ')
  });

  if (watchable) {
    attributes[DATA_FA_I2SVG] = '';
  }

  var styles = _extends({}, extra.styles);

  if (transformIsMeaningful(transform)) {
    styles['transform'] = transformForCss({ transform: transform, startCentered: true, width: width, height: height });
    styles['-webkit-transform'] = styles['transform'];
  }

  var styleString = joinStyles(styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];

  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({ tag: 'span', attributes: { class: 'sr-only' }, children: [title] });
  }

  return val;
}

function makeLayersCounterAbstract(params) {
  var content = params.content,
      title = params.title,
      extra = params.extra;


  var attributes = _extends({}, extra.attributes, title ? { 'title': title } : {}, {
    'class': extra.classes.join(' ')
  });

  var styleString = joinStyles(extra.styles);

  if (styleString.length > 0) {
    attributes['style'] = styleString;
  }

  var val = [];

  val.push({
    tag: 'span',
    attributes: attributes,
    children: [content]
  });

  if (title) {
    val.push({ tag: 'span', attributes: { class: 'sr-only' }, children: [title] });
  }

  return val;
}

var noop$2 = function noop() {};
var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : { mark: noop$2, measure: noop$2 };
var preamble = 'FA "5.3.1"';

var begin = function begin(name) {
  p.mark(preamble + ' ' + name + ' begins');
  return function () {
    return end(name);
  };
};

var end = function end(name) {
  p.mark(preamble + ' ' + name + ' ends');
  p.measure(preamble + ' ' + name, preamble + ' ' + name + ' begins', preamble + ' ' + name + ' ends');
};

var perf = { begin: begin, end: end };

'use strict';

/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */
var bindInternal4 = function bindInternal4 (func, thisContext) {
  return function (a, b, c, d) {
    return func.call(thisContext, a, b, c, d);
  };
};

'use strict';



/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */
var reduce = function fastReduceObject (subject, fn, initialValue, thisContext) {
  var keys = Object.keys(subject),
      length = keys.length,
      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
      i, key, result;

  if (initialValue === undefined) {
    i = 1;
    result = subject[keys[0]];
  }
  else {
    i = 0;
    result = initialValue;
  }

  for (; i < length; i++) {
    key = keys[i];
    result = iterator(result, subject[key], key, subject);
  }

  return result;
};

var styles$2 = namespace.styles;
var shims = namespace.shims;


var _byUnicode = {};
var _byLigature = {};
var _byOldName = {};

var build = function build() {
  var lookup = function lookup(reducer) {
    return reduce(styles$2, function (o, style, prefix) {
      o[prefix] = reduce(style, reducer, {});
      return o;
    }, {});
  };

  _byUnicode = lookup(function (acc, icon, iconName) {
    acc[icon[3]] = iconName;

    return acc;
  });

  _byLigature = lookup(function (acc, icon, iconName) {
    var ligatures = icon[2];

    acc[iconName] = iconName;

    ligatures.forEach(function (ligature) {
      acc[ligature] = iconName;
    });

    return acc;
  });

  var hasRegular = 'far' in styles$2;

  _byOldName = reduce(shims, function (acc, shim) {
    var oldName = shim[0];
    var prefix = shim[1];
    var iconName = shim[2];

    if (prefix === 'far' && !hasRegular) {
      prefix = 'fas';
    }

    acc[oldName] = { prefix: prefix, iconName: iconName };

    return acc;
  }, {});
};

build();

function byUnicode(prefix, unicode) {
  return _byUnicode[prefix][unicode];
}

function byLigature(prefix, ligature) {
  return _byLigature[prefix][ligature];
}

function byOldName(name) {
  return _byOldName[name] || { prefix: null, iconName: null };
}

var styles$1 = namespace.styles;


var emptyCanonicalIcon = function emptyCanonicalIcon() {
  return { prefix: null, iconName: null, rest: [] };
};

function getCanonicalIcon(values) {
  return values.reduce(function (acc, cls) {
    var iconName = getIconName(config.familyPrefix, cls);

    if (styles$1[cls]) {
      acc.prefix = cls;
    } else if (iconName) {
      var shim = acc.prefix === 'fa' ? byOldName(iconName) : {};

      acc.iconName = shim.iconName || iconName;
      acc.prefix = shim.prefix || acc.prefix;
    } else if (cls !== config.replacementClass && cls.indexOf('fa-w-') !== 0) {
      acc.rest.push(cls);
    }

    return acc;
  }, emptyCanonicalIcon());
}

function iconFromMapping(mapping, prefix, iconName) {
  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
    return {
      prefix: prefix,
      iconName: iconName,
      icon: mapping[prefix][iconName]
    };
  }
}

function toHtml(abstractNodes) {
  var tag = abstractNodes.tag,
      _abstractNodes$attrib = abstractNodes.attributes,
      attributes = _abstractNodes$attrib === undefined ? {} : _abstractNodes$attrib,
      _abstractNodes$childr = abstractNodes.children,
      children = _abstractNodes$childr === undefined ? [] : _abstractNodes$childr;


  if (typeof abstractNodes === 'string') {
    return htmlEscape(abstractNodes);
  } else {
    return '<' + tag + ' ' + joinAttributes(attributes) + '>' + children.map(toHtml).join('') + '</' + tag + '>';
  }
}

var noop$1 = function noop() {};

function isWatched(node) {
  var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;

  return typeof i2svg === 'string';
}

function getMutator() {
  if (config.autoReplaceSvg === true) {
    return mutators.replace;
  }

  var mutator = mutators[config.autoReplaceSvg];

  return mutator || mutators.replace;
}

var mutators = {
  replace: function replace(mutation) {
    var node = mutation[0];
    var abstract = mutation[1];
    var newOuterHTML = abstract.map(function (a) {
      return toHtml(a);
    }).join('\n');

    if (node.parentNode && node.outerHTML) {
      node.outerHTML = newOuterHTML + (config.keepOriginalSource && node.tagName.toLowerCase() !== 'svg' ? '<!-- ' + node.outerHTML + ' -->' : '');
    } else if (node.parentNode) {
      var newNode = document.createElement('span');
      node.parentNode.replaceChild(newNode, node);
      newNode.outerHTML = newOuterHTML;
    }
  },
  nest: function nest(mutation) {
    var node = mutation[0];
    var abstract = mutation[1];

    // If we already have a replaced node we do not want to continue nesting within it.
    // Short-circuit to the standard replacement
    if (~classArray(node).indexOf(config.replacementClass)) {
      return mutators.replace(mutation);
    }

    var forSvg = new RegExp(config.familyPrefix + '-.*');

    delete abstract[0].attributes.style;

    var splitClasses = abstract[0].attributes.class.split(' ').reduce(function (acc, cls) {
      if (cls === config.replacementClass || cls.match(forSvg)) {
        acc.toSvg.push(cls);
      } else {
        acc.toNode.push(cls);
      }

      return acc;
    }, { toNode: [], toSvg: [] });

    abstract[0].attributes.class = splitClasses.toSvg.join(' ');

    var newInnerHTML = abstract.map(function (a) {
      return toHtml(a);
    }).join('\n');
    node.setAttribute('class', splitClasses.toNode.join(' '));
    node.setAttribute(DATA_FA_I2SVG, '');
    node.innerHTML = newInnerHTML;
  }
};

function perform(mutations, callback) {
  var callbackFunction = typeof callback === 'function' ? callback : noop$1;

  if (mutations.length === 0) {
    callbackFunction();
  } else {
    var frame = WINDOW.requestAnimationFrame || function (op) {
      return op();
    };

    frame(function () {
      var mutator = getMutator();
      var mark = perf.begin('mutate');

      mutations.map(mutator);

      mark();

      callbackFunction();
    });
  }
}

var disabled = false;

function disableObservation(operation) {
  disabled = true;
  operation();
  disabled = false;
}

var mo = null;

function observe(options) {
  if (!MUTATION_OBSERVER) {
    return;
  }

  if (!config.observeMutations) {
    return;
  }

  var treeCallback = options.treeCallback,
      nodeCallback = options.nodeCallback,
      pseudoElementsCallback = options.pseudoElementsCallback,
      _options$observeMutat = options.observeMutationsRoot,
      observeMutationsRoot = _options$observeMutat === undefined ? DOCUMENT.body : _options$observeMutat;


  mo = new MUTATION_OBSERVER(function (objects) {
    if (disabled) return;

    toArray(objects).forEach(function (mutationRecord) {
      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
        if (config.searchPseudoElements) {
          pseudoElementsCallback(mutationRecord.target);
        }

        treeCallback(mutationRecord.target);
      }

      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config.searchPseudoElements) {
        pseudoElementsCallback(mutationRecord.target.parentNode);
      }

      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
        if (mutationRecord.attributeName === 'class') {
          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
              prefix = _getCanonicalIcon.prefix,
              iconName = _getCanonicalIcon.iconName;

          if (prefix) mutationRecord.target.setAttribute('data-prefix', prefix);
          if (iconName) mutationRecord.target.setAttribute('data-icon', iconName);
        } else {
          nodeCallback(mutationRecord.target);
        }
      }
    });
  });

  if (!IS_DOM) return;

  mo.observe(observeMutationsRoot, {
    childList: true, attributes: true, characterData: true, subtree: true
  });
}

function disconnect() {
  if (!mo) return;

  mo.disconnect();
}

var styleParser = function (node) {
  var style = node.getAttribute('style');

  var val = [];

  if (style) {
    val = style.split(';').reduce(function (acc, style) {
      var styles = style.split(':');
      var prop = styles[0];
      var value = styles.slice(1);

      if (prop && value.length > 0) {
        acc[prop] = value.join(':').trim();
      }

      return acc;
    }, {});
  }

  return val;
};

function toHex(unicode) {
  var result = '';

  for (var i = 0; i < unicode.length; i++) {
    var hex = unicode.charCodeAt(i).toString(16);
    result += ('000' + hex).slice(-4);
  }

  return result;
}

var classParser = function (node) {
  var existingPrefix = node.getAttribute('data-prefix');
  var existingIconName = node.getAttribute('data-icon');
  var innerText = node.innerText !== undefined ? node.innerText.trim() : '';

  var val = getCanonicalIcon(classArray(node));

  if (existingPrefix && existingIconName) {
    val.prefix = existingPrefix;
    val.iconName = existingIconName;
  }

  if (val.prefix && innerText.length > 1) {
    val.iconName = byLigature(val.prefix, node.innerText);
  } else if (val.prefix && innerText.length === 1) {
    val.iconName = byUnicode(val.prefix, toHex(node.innerText));
  }

  return val;
};

var parseTransformString = function parseTransformString(transformString) {
  var transform = {
    size: 16,
    x: 0,
    y: 0,
    flipX: false,
    flipY: false,
    rotate: 0
  };

  if (!transformString) {
    return transform;
  } else {
    return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
      var parts = n.toLowerCase().split('-');
      var first = parts[0];
      var rest = parts.slice(1).join('-');

      if (first && rest === 'h') {
        acc.flipX = true;
        return acc;
      }

      if (first && rest === 'v') {
        acc.flipY = true;
        return acc;
      }

      rest = parseFloat(rest);

      if (isNaN(rest)) {
        return acc;
      }

      switch (first) {
        case 'grow':
          acc.size = acc.size + rest;
          break;
        case 'shrink':
          acc.size = acc.size - rest;
          break;
        case 'left':
          acc.x = acc.x - rest;
          break;
        case 'right':
          acc.x = acc.x + rest;
          break;
        case 'up':
          acc.y = acc.y - rest;
          break;
        case 'down':
          acc.y = acc.y + rest;
          break;
        case 'rotate':
          acc.rotate = acc.rotate + rest;
          break;
      }

      return acc;
    }, transform);
  }
};

var transformParser = function (node) {
  return parseTransformString(node.getAttribute('data-fa-transform'));
};

var symbolParser = function (node) {
  var symbol = node.getAttribute('data-fa-symbol');

  return symbol === null ? false : symbol === '' ? true : symbol;
};

var attributesParser = function (node) {
  var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
    if (acc.name !== 'class' && acc.name !== 'style') {
      acc[attr.name] = attr.value;
    }
    return acc;
  }, {});

  var title = node.getAttribute('title');

  if (config.autoA11y) {
    if (title) {
      extraAttributes['aria-labelledby'] = config.replacementClass + '-title-' + nextUniqueId();
    } else {
      extraAttributes['aria-hidden'] = 'true';
    }
  }

  return extraAttributes;
};

var maskParser = function (node) {
  var mask = node.getAttribute('data-fa-mask');

  if (!mask) {
    return emptyCanonicalIcon();
  } else {
    return getCanonicalIcon(mask.split(' ').map(function (i) {
      return i.trim();
    }));
  }
};

var blankMeta = {
  iconName: null,
  title: null,
  prefix: null,
  transform: meaninglessTransform,
  symbol: false,
  mask: null,
  extra: { classes: [], styles: {}, attributes: {} }
};

function parseMeta(node) {
  var _classParser = classParser(node),
      iconName = _classParser.iconName,
      prefix = _classParser.prefix,
      extraClasses = _classParser.rest;

  var extraStyles = styleParser(node);
  var transform = transformParser(node);
  var symbol = symbolParser(node);
  var extraAttributes = attributesParser(node);
  var mask = maskParser(node);

  return {
    iconName: iconName,
    title: node.getAttribute('title'),
    prefix: prefix,
    transform: transform,
    symbol: symbol,
    mask: mask,
    extra: {
      classes: extraClasses,
      styles: extraStyles,
      attributes: extraAttributes
    }
  };
}

function MissingIcon(error) {
  this.name = 'MissingIcon';
  this.message = error || 'Icon unavailable';
  this.stack = new Error().stack;
}

MissingIcon.prototype = Object.create(Error.prototype);
MissingIcon.prototype.constructor = MissingIcon;

var FILL = { fill: 'currentColor' };
var ANIMATION_BASE = {
  attributeType: 'XML',
  repeatCount: 'indefinite',
  dur: '2s'
};
var RING = {
  tag: 'path',
  attributes: _extends({}, FILL, {
    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
  })
};
var OPACITY_ANIMATE = _extends({}, ANIMATION_BASE, {
  attributeName: 'opacity'
});
var DOT = {
  tag: 'circle',
  attributes: _extends({}, FILL, {
    cx: '256',
    cy: '364',
    r: '28'
  }),
  children: [{ tag: 'animate', attributes: _extends({}, ANIMATION_BASE, { attributeName: 'r', values: '28;14;28;28;14;28;' }) }, { tag: 'animate', attributes: _extends({}, OPACITY_ANIMATE, { values: '1;0;1;1;0;1;' }) }]
};
var QUESTION = {
  tag: 'path',
  attributes: _extends({}, FILL, {
    opacity: '1',
    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
  }),
  children: [{ tag: 'animate', attributes: _extends({}, OPACITY_ANIMATE, { values: '1;0;0;0;0;1;' }) }]
};
var EXCLAMATION = {
  tag: 'path',
  attributes: _extends({}, FILL, {
    opacity: '0',
    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
  }),
  children: [{ tag: 'animate', attributes: _extends({}, OPACITY_ANIMATE, { values: '0;0;1;1;0;0;' }) }]
};

var missing = { tag: 'g', children: [RING, DOT, QUESTION, EXCLAMATION] };

var styles = namespace.styles;

var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var FONT_FAMILY_PATTERN = /Font Awesome 5 (Solid|Regular|Light|Brands|Free|Pro)/;
var STYLE_TO_PREFIX = {
  'Solid': 'fas',
  'Regular': 'far',
  'Light': 'fal',
  'Brands': 'fab'
};
var FONT_WEIGHT_TO_PREFIX = {
  '900': 'fas',
  '400': 'far',
  '300': 'fal'
};

function findIcon(iconName, prefix) {
  var val = {
    found: false,
    width: 512,
    height: 512,
    icon: missing
  };

  if (iconName && prefix && styles[prefix] && styles[prefix][iconName]) {
    var icon = styles[prefix][iconName];
    var width = icon[0];
    var height = icon[1];
    var vectorData = icon.slice(4);

    val = {
      found: true,
      width: width,
      height: height,
      icon: { tag: 'path', attributes: { fill: 'currentColor', d: vectorData[0] } }
    };
  } else if (iconName && prefix && !config.showMissingIcons) {
    throw new MissingIcon('Icon is missing for prefix ' + prefix + ' with icon name ' + iconName);
  }

  return val;
}

function generateSvgReplacementMutation(node, nodeMeta) {
  var iconName = nodeMeta.iconName,
      title = nodeMeta.title,
      prefix = nodeMeta.prefix,
      transform = nodeMeta.transform,
      symbol = nodeMeta.symbol,
      mask = nodeMeta.mask,
      extra = nodeMeta.extra;


  return [node, makeInlineSvgAbstract({
    icons: {
      main: findIcon(iconName, prefix),
      mask: findIcon(mask.iconName, mask.prefix)
    },
    prefix: prefix,
    iconName: iconName,
    transform: transform,
    symbol: symbol,
    mask: mask,
    title: title,
    extra: extra,
    watchable: true
  })];
}

function generateLayersText(node, nodeMeta) {
  var title = nodeMeta.title,
      transform = nodeMeta.transform,
      extra = nodeMeta.extra;


  var width = null;
  var height = null;

  if (IS_IE) {
    var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
    var boundingClientRect = node.getBoundingClientRect();
    width = boundingClientRect.width / computedFontSize;
    height = boundingClientRect.height / computedFontSize;
  }

  if (config.autoA11y && !title) {
    extra.attributes['aria-hidden'] = 'true';
  }

  return [node, makeLayersTextAbstract({
    content: node.innerHTML,
    width: width,
    height: height,
    transform: transform,
    title: title,
    extra: extra,
    watchable: true
  })];
}

function generateMutation(node) {
  var nodeMeta = parseMeta(node);

  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
    return generateLayersText(node, nodeMeta);
  } else {
    return generateSvgReplacementMutation(node, nodeMeta);
  }
}

function searchPseudoElements(root) {
  if (!IS_DOM) return;

  var end = perf.begin('searchPseudoElements');

  disableObservation(function () {
    toArray(root.querySelectorAll('*')).filter(function (n) {
      return n.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(n.tagName.toUpperCase()) && !n.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!n.parentNode || n.parentNode.tagName !== 'svg');
    }).forEach(function (node) {
      [':before', ':after'].forEach(function (pos) {
        var children = toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function (c) {
          return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === pos;
        })[0];

        var styles = WINDOW.getComputedStyle(node, pos);
        var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue('font-weight');

        if (alreadyProcessedPseudoElement && !fontFamily) {
          // If we've already processed it but the current computed style does not result in a font-family,
          // that probably means that a class name that was previously present to make the icon has been
          // removed. So we now should delete the icon.
          node.removeChild(alreadyProcessedPseudoElement);
        } else if (fontFamily) {
          var content = styles.getPropertyValue('content');
          var prefix = ~['Light', 'Regular', 'Solid', 'Brands'].indexOf(fontFamily[1]) ? STYLE_TO_PREFIX[fontFamily[1]] : FONT_WEIGHT_TO_PREFIX[fontWeight];
          var iconName = byUnicode(prefix, toHex(content.length === 3 ? content.substr(1, 1) : content));
          // Only convert the pseudo element in this :before/:after position into an icon if we haven't
          // already done so with the same prefix and iconName
          if (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconName) {
            if (alreadyProcessedPseudoElement) {
              // Delete the old one, since we're replacing it with a new one
              node.removeChild(alreadyProcessedPseudoElement);
            }

            var extra = blankMeta.extra;

            extra.attributes[DATA_FA_PSEUDO_ELEMENT] = pos;
            var abstract = makeInlineSvgAbstract(_extends({}, blankMeta, {
              icons: {
                main: findIcon(iconName, prefix),
                mask: emptyCanonicalIcon()
              },
              prefix: prefix,
              iconName: iconName,
              extra: extra,
              watchable: true
            }));

            var element = DOCUMENT.createElement('svg');

            if (pos === ':before') {
              node.insertBefore(element, node.firstChild);
            } else {
              node.appendChild(element);
            }

            element.outerHTML = abstract.map(function (a) {
              return toHtml(a);
            }).join('\n');
          }
        }
      });
    });
  });

  end();
}

function onTree(root) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!IS_DOM) return;

  var htmlClassList = DOCUMENT.documentElement.classList;
  var hclAdd = function hclAdd(suffix) {
    return htmlClassList.add(HTML_CLASS_I2SVG_BASE_CLASS + '-' + suffix);
  };
  var hclRemove = function hclRemove(suffix) {
    return htmlClassList.remove(HTML_CLASS_I2SVG_BASE_CLASS + '-' + suffix);
  };
  var prefixes = Object.keys(styles);
  var prefixesDomQuery = ['.' + LAYERS_TEXT_CLASSNAME + ':not([' + DATA_FA_I2SVG + '])'].concat(prefixes.map(function (p) {
    return '.' + p + ':not([' + DATA_FA_I2SVG + '])';
  })).join(', ');

  if (prefixesDomQuery.length === 0) {
    return;
  }

  var candidates = toArray(root.querySelectorAll(prefixesDomQuery));

  if (candidates.length > 0) {
    hclAdd('pending');
    hclRemove('complete');
  } else {
    return;
  }

  var mark = perf.begin('onTree');

  var mutations = candidates.reduce(function (acc, node) {
    try {
      var mutation = generateMutation(node);

      if (mutation) {
        acc.push(mutation);
      }
    } catch (e) {
      if (!PRODUCTION) {
        if (e instanceof MissingIcon) {
          console.error(e);
        }
      }
    }

    return acc;
  }, []);

  mark();

  perform(mutations, function () {
    hclAdd('active');
    hclAdd('complete');
    hclRemove('pending');

    if (typeof callback === 'function') callback();
  });
}

function onNode(node) {
  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var mutation = generateMutation(node);

  if (mutation) {
    perform([mutation], callback);
  }
}

var baseStyles = "svg:not(:root).svg-inline--fa {\n  overflow: visible; }\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -.125em; }\n  .svg-inline--fa.fa-lg {\n    vertical-align: -.225em; }\n  .svg-inline--fa.fa-w-1 {\n    width: 0.0625em; }\n  .svg-inline--fa.fa-w-2 {\n    width: 0.125em; }\n  .svg-inline--fa.fa-w-3 {\n    width: 0.1875em; }\n  .svg-inline--fa.fa-w-4 {\n    width: 0.25em; }\n  .svg-inline--fa.fa-w-5 {\n    width: 0.3125em; }\n  .svg-inline--fa.fa-w-6 {\n    width: 0.375em; }\n  .svg-inline--fa.fa-w-7 {\n    width: 0.4375em; }\n  .svg-inline--fa.fa-w-8 {\n    width: 0.5em; }\n  .svg-inline--fa.fa-w-9 {\n    width: 0.5625em; }\n  .svg-inline--fa.fa-w-10 {\n    width: 0.625em; }\n  .svg-inline--fa.fa-w-11 {\n    width: 0.6875em; }\n  .svg-inline--fa.fa-w-12 {\n    width: 0.75em; }\n  .svg-inline--fa.fa-w-13 {\n    width: 0.8125em; }\n  .svg-inline--fa.fa-w-14 {\n    width: 0.875em; }\n  .svg-inline--fa.fa-w-15 {\n    width: 0.9375em; }\n  .svg-inline--fa.fa-w-16 {\n    width: 1em; }\n  .svg-inline--fa.fa-w-17 {\n    width: 1.0625em; }\n  .svg-inline--fa.fa-w-18 {\n    width: 1.125em; }\n  .svg-inline--fa.fa-w-19 {\n    width: 1.1875em; }\n  .svg-inline--fa.fa-w-20 {\n    width: 1.25em; }\n  .svg-inline--fa.fa-pull-left {\n    margin-right: .3em;\n    width: auto; }\n  .svg-inline--fa.fa-pull-right {\n    margin-left: .3em;\n    width: auto; }\n  .svg-inline--fa.fa-border {\n    height: 1.5em; }\n  .svg-inline--fa.fa-li {\n    width: 2em; }\n  .svg-inline--fa.fa-fw {\n    width: 1.25em; }\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -.125em;\n  width: 1em; }\n  .fa-layers svg.svg-inline--fa {\n    -webkit-transform-origin: center center;\n            transform-origin: center center; }\n\n.fa-layers-text, .fa-layers-counter {\n  display: inline-block;\n  position: absolute;\n  text-align: center; }\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center; }\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: .25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right; }\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right; }\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left; }\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right; }\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left; }\n\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -.0667em; }\n\n.fa-xs {\n  font-size: .75em; }\n\n.fa-sm {\n  font-size: .875em; }\n\n.fa-1x {\n  font-size: 1em; }\n\n.fa-2x {\n  font-size: 2em; }\n\n.fa-3x {\n  font-size: 3em; }\n\n.fa-4x {\n  font-size: 4em; }\n\n.fa-5x {\n  font-size: 5em; }\n\n.fa-6x {\n  font-size: 6em; }\n\n.fa-7x {\n  font-size: 7em; }\n\n.fa-8x {\n  font-size: 8em; }\n\n.fa-9x {\n  font-size: 9em; }\n\n.fa-10x {\n  font-size: 10em; }\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em; }\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0; }\n  .fa-ul > li {\n    position: relative; }\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit; }\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: .1em;\n  padding: .2em .25em .15em; }\n\n.fa-pull-left {\n  float: left; }\n\n.fa-pull-right {\n  float: right; }\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: .3em; }\n\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: .3em; }\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear; }\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8); }\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg); }\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg); }\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg); }\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1); }\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1); }\n\n.fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1); }\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical {\n  -webkit-filter: none;\n          filter: none; }\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2em; }\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1em; }\n\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2em; }\n\n.fa-inverse {\n  color: #fff; }\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto; }\n";

var css = function () {
  var dfp = DEFAULT_FAMILY_PREFIX;
  var drc = DEFAULT_REPLACEMENT_CLASS;
  var fp = config.familyPrefix;
  var rc = config.replacementClass;
  var s = baseStyles;

  if (fp !== dfp || rc !== drc) {
    var dPatt = new RegExp('\\.' + dfp + '\\-', 'g');
    var rPatt = new RegExp('\\.' + drc, 'g');

    s = s.replace(dPatt, '.' + fp + '-').replace(rPatt, '.' + rc);
  }

  return s;
};

function define(prefix, icons) {
  var normalized = Object.keys(icons).reduce(function (acc, iconName) {
    var icon = icons[iconName];
    var expanded = !!icon.icon;

    if (expanded) {
      acc[icon.iconName] = icon.icon;
    } else {
      acc[iconName] = icon;
    }
    return acc;
  }, {});

  if (typeof namespace.hooks.addPack === 'function') {
    namespace.hooks.addPack(prefix, normalized);
  } else {
    namespace.styles[prefix] = _extends({}, namespace.styles[prefix] || {}, normalized);
  }

  /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll easy the upgrade process for our users by automatically defining
   * this as well.
   */
  if (prefix === 'fas') {
    define('fa', icons);
  }
}

var Library = function () {
  function Library() {
    classCallCheck(this, Library);

    this.definitions = {};
  }

  createClass(Library, [{
    key: 'add',
    value: function add() {
      var _this = this;

      for (var _len = arguments.length, definitions = Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      var additions = definitions.reduce(this._pullDefinitions, {});

      Object.keys(additions).forEach(function (key) {
        _this.definitions[key] = _extends({}, _this.definitions[key] || {}, additions[key]);
        define(key, additions[key]);
        build();
      });
    }
  }, {
    key: 'reset',
    value: function reset() {
      this.definitions = {};
    }
  }, {
    key: '_pullDefinitions',
    value: function _pullDefinitions(additions, definition) {
      var normalized = definition.prefix && definition.iconName && definition.icon ? { 0: definition } : definition;

      Object.keys(normalized).map(function (key) {
        var _normalized$key = normalized[key],
            prefix = _normalized$key.prefix,
            iconName = _normalized$key.iconName,
            icon = _normalized$key.icon;


        if (!additions[prefix]) additions[prefix] = {};

        additions[prefix][iconName] = icon;
      });

      return additions;
    }
  }]);
  return Library;
}();

function prepIcon(icon) {
  var width = icon[0];
  var height = icon[1];
  var vectorData = icon.slice(4);

  return {
    found: true,
    width: width,
    height: height,
    icon: { tag: 'path', attributes: { fill: 'currentColor', d: vectorData[0] } }
  };
}

function ensureCss() {
  if (config.autoAddCss && !_cssInserted) {
    insertCss(css());
    _cssInserted = true;
  }
}

function apiObject(val, abstractCreator) {
  Object.defineProperty(val, 'abstract', {
    get: abstractCreator
  });

  Object.defineProperty(val, 'html', {
    get: function get() {
      return val.abstract.map(function (a) {
        return toHtml(a);
      });
    }
  });

  Object.defineProperty(val, 'node', {
    get: function get() {
      if (!IS_DOM) return;

      var container = DOCUMENT.createElement('div');
      container.innerHTML = val.html;
      return container.children;
    }
  });

  return val;
}

function findIconDefinition(params) {
  var _params$prefix = params.prefix,
      prefix = _params$prefix === undefined ? 'fa' : _params$prefix,
      iconName = params.iconName;


  if (!iconName) return;

  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
}

function resolveIcons(next) {
  return function (maybeIconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});

    var mask = params.mask;


    if (mask) {
      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
    }

    return next(iconDefinition, _extends({}, params, { mask: mask }));
  };
}

var library = new Library();

var noAuto = function noAuto() {
  config.autoReplaceSvg = false;
  config.observeMutations = false;

  disconnect();
};

var _cssInserted = false;

var dom = {
  i2svg: function i2svg() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (IS_DOM) {
      ensureCss();

      var _params$node = params.node,
          node = _params$node === undefined ? DOCUMENT : _params$node,
          _params$callback = params.callback,
          callback = _params$callback === undefined ? function () {} : _params$callback;


      if (config.searchPseudoElements) {
        searchPseudoElements(node);
      }

      onTree(node, callback);
    }
  },

  css: css,

  insertCss: function insertCss$$1() {
    if (!_cssInserted) {
      insertCss(css());
      _cssInserted = true;
    }
  },

  watch: function watch() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var autoReplaceSvgRoot = params.autoReplaceSvgRoot,
        observeMutationsRoot = params.observeMutationsRoot;


    if (config.autoReplaceSvg === false) {
      config.autoReplaceSvg = true;
    }

    config.observeMutations = true;

    domready(function () {
      autoReplace({
        autoReplaceSvgRoot: autoReplaceSvgRoot
      });

      observe({
        treeCallback: onTree,
        nodeCallback: onNode,
        pseudoElementsCallback: searchPseudoElements,
        observeMutationsRoot: observeMutationsRoot
      });
    });
  }
};

var parse = {
  transform: function transform(transformString) {
    return parseTransformString(transformString);
  }
};

var icon = resolveIcons(function (iconDefinition) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform = params.transform,
      transform = _params$transform === undefined ? meaninglessTransform : _params$transform,
      _params$symbol = params.symbol,
      symbol = _params$symbol === undefined ? false : _params$symbol,
      _params$mask = params.mask,
      mask = _params$mask === undefined ? null : _params$mask,
      _params$title = params.title,
      title = _params$title === undefined ? null : _params$title,
      _params$classes = params.classes,
      classes = _params$classes === undefined ? [] : _params$classes,
      _params$attributes = params.attributes,
      attributes = _params$attributes === undefined ? {} : _params$attributes,
      _params$styles = params.styles,
      styles = _params$styles === undefined ? {} : _params$styles;


  if (!iconDefinition) return;

  var prefix = iconDefinition.prefix,
      iconName = iconDefinition.iconName,
      icon = iconDefinition.icon;


  return apiObject(_extends({ type: 'icon' }, iconDefinition), function () {
    ensureCss();

    if (config.autoA11y) {
      if (title) {
        attributes['aria-labelledby'] = config.replacementClass + '-title-' + nextUniqueId();
      } else {
        attributes['aria-hidden'] = 'true';
      }
    }

    return makeInlineSvgAbstract({
      icons: {
        main: prepIcon(icon),
        mask: mask ? prepIcon(mask.icon) : { found: false, width: null, height: null, icon: {} }
      },
      prefix: prefix,
      iconName: iconName,
      transform: _extends({}, meaninglessTransform, transform),
      symbol: symbol,
      title: title,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: classes
      }
    });
  });
});

var text = function text(content) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$transform2 = params.transform,
      transform = _params$transform2 === undefined ? meaninglessTransform : _params$transform2,
      _params$title2 = params.title,
      title = _params$title2 === undefined ? null : _params$title2,
      _params$classes2 = params.classes,
      classes = _params$classes2 === undefined ? [] : _params$classes2,
      _params$attributes2 = params.attributes,
      attributes = _params$attributes2 === undefined ? {} : _params$attributes2,
      _params$styles2 = params.styles,
      styles = _params$styles2 === undefined ? {} : _params$styles2;


  return apiObject({ type: 'text', content: content }, function () {
    ensureCss();

    return makeLayersTextAbstract({
      content: content,
      transform: _extends({}, meaninglessTransform, transform),
      title: title,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: [config.familyPrefix + '-layers-text'].concat(toConsumableArray(classes))
      }
    });
  });
};

var counter = function counter(content) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _params$title3 = params.title,
      title = _params$title3 === undefined ? null : _params$title3,
      _params$classes3 = params.classes,
      classes = _params$classes3 === undefined ? [] : _params$classes3,
      _params$attributes3 = params.attributes,
      attributes = _params$attributes3 === undefined ? {} : _params$attributes3,
      _params$styles3 = params.styles,
      styles = _params$styles3 === undefined ? {} : _params$styles3;


  return apiObject({ type: 'counter', content: content }, function () {
    ensureCss();

    return makeLayersCounterAbstract({
      content: content.toString(),
      title: title,
      extra: {
        attributes: attributes,
        styles: styles,
        classes: [config.familyPrefix + '-layers-counter'].concat(toConsumableArray(classes))
      }
    });
  });
};

var layer = function layer(assembler) {
  return apiObject({ type: 'layer' }, function () {
    ensureCss();

    var children = [];

    assembler(function (args) {
      Array.isArray(args) ? args.map(function (a) {
        children = children.concat(a.abstract);
      }) : children = children.concat(args.abstract);
    });

    return [{
      tag: 'span',
      attributes: { class: config.familyPrefix + '-layers' },
      children: children
    }];
  });
};

var api = {
  noAuto: noAuto,
  config: config,
  dom: dom,
  library: library,
  parse: parse,
  findIconDefinition: findIconDefinition,
  icon: icon,
  text: text,
  counter: counter,
  layer: layer,
  toHtml: toHtml
};

var autoReplace = function autoReplace() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _params$autoReplaceSv = params.autoReplaceSvgRoot,
      autoReplaceSvgRoot = _params$autoReplaceSv === undefined ? DOCUMENT : _params$autoReplaceSv;


  if (Object.keys(namespace.styles).length > 0 && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({ node: autoReplaceSvgRoot });
};



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(50)))

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var json_adapters_1 = __webpack_require__(120);
exports.convertJsonForm = json_adapters_1.convertJsonForm;
exports.convertJsonResponse = json_adapters_1.convertJsonResponse;
exports.processResponseState = json_adapters_1.processResponseState;
exports.getAllElements = json_adapters_1.getAllElements;
exports.getAllPreviewElements = json_adapters_1.getAllPreviewElements;
//# sourceMappingURL=index.js.map

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_definition_1 = __webpack_require__(17);
/**
 * this function takes a json form object and converts it into a Form object as defined above
 * @param {JsonForm} rawForm a json represenation of a TouchpointForm as defined in the participant portal
 */
function convertJsonForm(rawForm) {
    if (!rawForm) {
        return new form_definition_1.Form({});
    }
    var immutableElements;
    immutableElements = !!rawForm.elements ? rawForm.elements.map(function (element) { return form_definition_1.formElementTypes.convertToImmutable(element); }) : [];
    var immutableRules = !!rawForm.rules ?
        rawForm.rules.map(function (rule) { return new form_definition_1.formRuleTypes.ImmutableFormRule(rule); }) : [];
    return new form_definition_1.Form({
        id: rawForm.id,
        name: rawForm.name,
        heading: rawForm.heading,
        elements: immutable_1.List(immutableElements),
        rules: immutable_1.List(immutableRules),
        maxTotalAttachmentSize: rawForm.maxTotalAttachmentSize,
        includeRecaptcha: rawForm.includeRecaptcha,
    });
}
exports.convertJsonForm = convertJsonForm;
/**
 * Returns all elements that have isPreviewElement set to true
 * @param rawForm ssg form definition
 */
function getAllPreviewElements(rawForm) {
    if (!rawForm || !rawForm.elements)
        return [];
    var allElements = getAllElementsRecursive(rawForm.elements);
    return allElements.filter(function (element) { return element.isPreviewElement; });
}
exports.getAllPreviewElements = getAllPreviewElements;
/**
 * Returns all elements in the given form definition
 * @param rawForm ssg form definition
 */
function getAllElements(rawForm) {
    if (!rawForm || !rawForm.elements)
        return [];
    return getAllElementsRecursive(rawForm.elements);
}
exports.getAllElements = getAllElements;
function getAllElementsRecursive(elements) {
    var allElements = [];
    elements && elements.forEach(function (element, index) {
        switch (element.type) {
            case form_definition_1.elementTypes.group: {
                allElements.push.apply(allElements, getAllElementsRecursive(element.subElements));
            }
            default:
                allElements.push(element);
                break;
        }
    });
    return allElements;
}
/**
 * this function takes a Form and a json response object and converts it into the format that is expected to be in the
 * default values section of the FormsState
 * @param {JsonForm} form a json representation of an SSG Form
 * @param {JsonResponse} rawResponse a json representation of a TouchpointResponse as defined in the participant portal
 */
function convertJsonResponse(form, rawResponse) {
    var value = immutable_1.Map({});
    var ssgForm = convertJsonForm(form);
    var state = new form_definition_1.FormState({
        form: ssgForm
    });
    var elements = form_definition_1.getAllElementInfo(state);
    var elementResponses = rawResponse && rawResponse.elements;
    elementResponses && elementResponses.forEach(function (element) {
        var info = elements.find(function (info) { return info.element.id === element.id; });
        var formElement = info && info.element;
        if (!!formElement) {
            var elementValue = null;
            switch (formElement.type) {
                case form_definition_1.elementTypes.radio:
                case form_definition_1.elementTypes.checkbox:
                case form_definition_1.elementTypes.select:
                case form_definition_1.elementTypes.likert:
                    elementValue = !!element.value && immutable_1.List(element.value);
                    break;
                case form_definition_1.elementTypes.attachment: {
                    var files = element && element.value && element.value.files;
                    var convertedFiles = immutable_1.List(files || []).map(function (file) { return immutable_1.Map(file); });
                    elementValue = element && element.value && new form_definition_1.AttachmentResponseState(element.value);
                    elementValue = elementValue && elementValue.set('files', convertedFiles);
                    break;
                }
                case form_definition_1.elementTypes.time:
                    elementValue = new form_definition_1.TimeResponseState(element.value);
                    break;
                case form_definition_1.elementTypes.electronicSignature:
                    elementValue = new form_definition_1.ElectronicSignatureResponseState();
                    elementValue = elementValue.set('signInProgress', element.value.signInProgress);
                    if (element.value.etoCoords != null && element.value.etoCoords.length > 0) {
                        elementValue = elementValue.set('etoCoords', immutable_1.List(element.value.etoCoords));
                    }
                    else if (element.value.imageUrl != null) {
                        elementValue = elementValue.set('imageUrl', element.value.imageUrl);
                    }
                    elementValue = elementValue.set('signPadWidth', element.value.signPadWidth);
                    elementValue = elementValue.set('signPadHeight', element.value.signPadHeight);
                    break;
                case form_definition_1.elementTypes.emailNotification:
                    elementValue = new form_definition_1.EmailNotificationState(element.value);
                    break;
                default:
                    elementValue = element.value;
                    break;
            }
            value = value.set(element.id, elementValue);
        }
    });
    return value;
}
exports.convertJsonResponse = convertJsonResponse;
/**
 * Converts the answers in the form state into a simple js object that can be used for a PUT or POST request
 * @param format POST or PUT format
 *  the POST format will include all answers, including default values not set by the user
 *  the PUT format will only include values that the user changed directly
 * @param state the state of the form, including answers to the questions
 */
function processResponseState(format, state) {
    var form = state.form;
    var elements = form.elements;
    var response = {
        formId: form.id,
        elements: []
    };
    elements && elements.forEach(function (element) {
        var _a;
        var responses = processElementResponse(format, element, state);
        if (!!responses) {
            (_a = response.elements).push.apply(_a, responses);
        }
    });
    return response;
}
exports.processResponseState = processResponseState;
/**
 * recursive function that gets reponse values for an element
 * if it is a group element it will return all response values for all the sub elements as well
 * @param format POST or PUT format
 * @param element the element we are getting answers for
 * @param state the state of the form, including answers to the questions
 */
function processElementResponse(format, element, state) {
    var value = state.value, defaultValue = state.defaultValue;
    var responses = [];
    var elementValue = value && value.get(element.id);
    switch (element.type) {
        case form_definition_1.elementTypes.group:
            element.subElementsList && element.subElementsList.forEach(function (subElement) {
                var modifiedElement = form_definition_1.getModifiedSubElement(element, subElement);
                var subElementResponses = processElementResponse(format, modifiedElement, state);
                responses.push.apply(responses, subElementResponses);
            });
            break;
        default:
            if (!element.hidden && !element.disabled) {
                var responseValue = format === 'PUT' ?
                    value && value.get(element.id) :
                    form_definition_1.getValue(state, element.id);
                var response = {
                    id: element.id,
                    value: responseValue,
                };
                responses.push(response);
            }
            break;
    }
    return responses;
}
//# sourceMappingURL=json-adapters.js.map

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
exports.AttachmentResponseStateRecord = immutable_1.Record({
    err: null,
    fileCount: 0,
    completedUploads: 0,
    files: null
});
/** This is a class that defines the structure of an attachment's state once a file has been uploaded  */
var AttachmentResponseState = /** @class */ (function (_super) {
    __extends(AttachmentResponseState, _super);
    function AttachmentResponseState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AttachmentResponseState;
}(exports.AttachmentResponseStateRecord));
exports.AttachmentResponseState = AttachmentResponseState;
/** Immutable Record structured in the format expected for a TimeElement response */
exports.TimeResponseStateRecord = immutable_1.Record({
    hour: "",
    minute: "",
    period: ""
});
/** Immutable time of day value */
var TimeResponseState = /** @class */ (function (_super) {
    __extends(TimeResponseState, _super);
    function TimeResponseState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TimeResponseState;
}(exports.TimeResponseStateRecord));
exports.TimeResponseState = TimeResponseState;
/** Immutable record for electronic signature store data. Contains default values. */
exports.ElectronicSignatureResponseStateRecord = immutable_1.Record({
    /* True if signing is in progress, false otherwise */
    signInProgress: false,
    /* ETO formatted coordinates (destination: ETO database) */
    etoCoords: immutable_1.List(),
    /* Image URL, obtained from html canvas. Use this for Apricot compatibility. */
    imageUrl: null,
    /* Default sign pad width. Used for scaling and element sizing. */
    signPadWidth: 100,
    /* Default sign pad height. Used for scaling and element sizing. */
    signPadHeight: 100
});
/** Immutable record for electronic signature store data. Contains type information. */
var ElectronicSignatureResponseState = /** @class */ (function (_super) {
    __extends(ElectronicSignatureResponseState, _super);
    function ElectronicSignatureResponseState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ElectronicSignatureResponseState;
}(exports.ElectronicSignatureResponseStateRecord));
exports.ElectronicSignatureResponseState = ElectronicSignatureResponseState;
var emailNotificationStatus;
(function (emailNotificationStatus) {
    /** this is the default if the notification has not been evaluated */
    emailNotificationStatus["notChecked"] = "email.not-checked";
    /** this is the status if an email notification has been sent successfully */
    emailNotificationStatus["sent"] = "email.sent";
    /** this is the status if the notification has been evaluated, but not was not sent */
    emailNotificationStatus["notSent"] = "email.not-sent";
    /** this is the status if an attempt was made to send the notification, but it failed for some reason */
    emailNotificationStatus["failure"] = "email.failed";
})(emailNotificationStatus = exports.emailNotificationStatus || (exports.emailNotificationStatus = {}));
/** Immutable record for electronic signature store data. Contains default values. */
exports.EmailNotificationRecord = immutable_1.Record({
    from: '',
    recipients: '',
    subject: '',
    body: '',
    status: emailNotificationStatus.notChecked,
    errorMessage: ''
});
/** Immutable record for electronic signature store data. Contains type information. */
var EmailNotificationState = /** @class */ (function (_super) {
    __extends(EmailNotificationState, _super);
    function EmailNotificationState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EmailNotificationState;
}(exports.EmailNotificationRecord));
exports.EmailNotificationState = EmailNotificationState;
//# sourceMappingURL=element-response-definition.js.map

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var form_constants_1 = __webpack_require__(5);
/**
 * For an applicable element, return a plain text version of the response. Group elements are supported as well
 * @param element the element in the form
 * @param allElementResponses all element responses for the form
 * @returns the plain text string, or null if none can be determined
 */
function getPlainTextValue(element, allElementResponses) {
    var response;
    switch (element.type) {
        case form_constants_1.elementTypes.email:
        case form_constants_1.elementTypes.nationalId:
        case form_constants_1.elementTypes.number:
        case form_constants_1.elementTypes.phone:
        case form_constants_1.elementTypes.postalCode:
        case form_constants_1.elementTypes.text:
        case form_constants_1.elementTypes.textArea:
        case form_constants_1.elementTypes.specialText:
        case form_constants_1.elementTypes.gisCoordinates:
            response = allElementResponses.find(function (e) { return e.id === element.id; });
            if (response && (typeof response.value === "string" || typeof response.value === "number")) {
                return response.value + "";
            }
            break;
        case form_constants_1.elementTypes.group:
            // get subelement values
            var groupElement = element;
            var groupElementValue = "";
            var subEl;
            var subElValue;
            for (var i = 0; i < groupElement.subElements.length; i++) {
                subEl = groupElement.subElements[i];
                subElValue = this.getPlainTextValue(subEl, allElementResponses);
                if (subElValue) {
                    groupElementValue = groupElementValue ? groupElementValue + " " + subElValue : subElValue;
                }
            }
            return groupElementValue ? groupElementValue : null;
        case form_constants_1.elementTypes.checkbox:
        case form_constants_1.elementTypes.select:
        case form_constants_1.elementTypes.likert:
        case form_constants_1.elementTypes.radio:
            response = allElementResponses.find(function (e) { return e.id === element.id; });
            if (response && Array.isArray(response.value) && response.value.length > 0) {
                var responseArr = response.value;
                var responses = responseArr.map(function (id) {
                    var option = element.options.find(function (option) { return option.value === id; });
                    return option && option.label;
                });
                return responses.join(", ");
            }
            break;
        case form_constants_1.elementTypes.date:
            response = allElementResponses.find(function (e) { return e.id === element.id; });
            if (response && typeof response.value === "string") {
                var date = new Date(response.value);
                return date.toLocaleDateString();
            }
            break;
        case form_constants_1.elementTypes.duration:
            response = allElementResponses.find(function (e) { return e.id === element.id; });
            if (response && typeof response.value === "object") {
                var hours = response.value.hours;
                var mins = response.value.minutes;
                if (hours !== undefined || mins !== undefined) {
                    if (typeof hours === "number") {
                        var strValue = hours !== 0 ? hours + (hours === 1 ? " hour" : " hours") : "";
                        if (typeof mins === "number" && mins !== 0) {
                            var minuteText = mins + (mins === 1 ? " minute" : " minutes");
                            strValue = strValue ? strValue + ", " + minuteText : minuteText;
                        }
                        return strValue;
                    }
                    else if (typeof mins === "number") {
                        return mins + " minutes";
                    }
                }
            }
            break;
        case form_constants_1.elementTypes.time:
            response = allElementResponses.find(function (e) { return e.id === element.id; });
            if (response && typeof response.value === "object") {
                var hour = response.value.hour;
                var min = response.value.minute;
                var period = response.value.period;
                if (hour !== undefined && min !== undefined) {
                    var strValue = hour + ":" + min;
                    if (period) {
                        strValue = strValue + " " + period;
                    }
                    return strValue;
                }
            }
            break;
        case form_constants_1.elementTypes.electronicSignature:
        case form_constants_1.elementTypes.attachment:
        default:
            response = allElementResponses.find(function (e) { return e.id === element.id; });
            break;
    }
    if (response && typeof response.value === "string") {
        return response.value;
    }
    return null;
}
exports.getPlainTextValue = getPlainTextValue;
//# sourceMappingURL=form-element-utilities.js.map

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var form_input_element_base_1 = __webpack_require__(12);
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.attachment, uploadSize: 0, imageAttachment: false, height: 0, width: 0, maxTotalUploadSize: 0, allowMultipleFiles: false, allowRemoveExisting: false, fileUploadValue: '' });
exports.AttachmentElementRecord = immutable_1.Record(exports.defaultValues);
var ImmutableAttachmentElement = /** @class */ (function (_super) {
    __extends(ImmutableAttachmentElement, _super);
    function ImmutableAttachmentElement(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableAttachmentElement;
}(exports.AttachmentElementRecord));
exports.ImmutableAttachmentElement = ImmutableAttachmentElement;
//# sourceMappingURL=attachment-element.js.map

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var form_element_base_1 = __webpack_require__(40);
exports.defaultValues = __assign({}, form_element_base_1.defaultValues, { type: form_constants_1.elementTypes.undefined });
exports.BasicFormElementRecord = immutable_1.Record(exports.defaultValues);
var ImmutableBasicFormElement = /** @class */ (function (_super) {
    __extends(ImmutableBasicFormElement, _super);
    function ImmutableBasicFormElement(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableBasicFormElement;
}(exports.BasicFormElementRecord));
exports.ImmutableBasicFormElement = ImmutableBasicFormElement;
//# sourceMappingURL=basic-form-element.js.map

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var form_input_element_base_1 = __webpack_require__(12);
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.email });
exports.BasicInputElementRecord = immutable_1.Record(exports.defaultValues);
var ImmutableBasicInputElement = /** @class */ (function (_super) {
    __extends(ImmutableBasicInputElement, _super);
    function ImmutableBasicInputElement(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableBasicInputElement;
}(exports.BasicInputElementRecord));
exports.ImmutableBasicInputElement = ImmutableBasicInputElement;
//# sourceMappingURL=basic-input-element.js.map

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var data_format_1 = __webpack_require__(25);
exports.defaultValues = __assign({}, data_format_1.defaultValues, { type: form_constants_1.dataFormatType.NONE });
exports.BasicDataFormatRecord = immutable_1.Record(exports.defaultValues);
/** the immutable implementation of IBasicDataFormat */
var ImmutableBasicDataFormat = /** @class */ (function (_super) {
    __extends(ImmutableBasicDataFormat, _super);
    function ImmutableBasicDataFormat(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableBasicDataFormat;
}(exports.BasicDataFormatRecord));
exports.ImmutableBasicDataFormat = ImmutableBasicDataFormat;
//# sourceMappingURL=basic-data-format.js.map

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var data_format_1 = __webpack_require__(25);
exports.defaultValues = __assign({}, data_format_1.defaultValues, { type: form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER, mcElementId: '', otherOptionValue: '', otherTextElementId: '' });
exports.MCOtherFormatRecord = immutable_1.Record(exports.defaultValues);
/** the immutable implementation of IMCOtherFormat */
var ImmutableMCOtherFormat = /** @class */ (function (_super) {
    __extends(ImmutableMCOtherFormat, _super);
    function ImmutableMCOtherFormat(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableMCOtherFormat;
}(exports.MCOtherFormatRecord));
exports.ImmutableMCOtherFormat = ImmutableMCOtherFormat;
//# sourceMappingURL=mc-other-format.js.map

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var data_format_1 = __webpack_require__(25);
exports.defaultValues = __assign({}, data_format_1.defaultValues, { type: form_constants_1.dataFormatType.ZIP_EXTENSION, zipElementId: '', extensionElementId: '' });
exports.ZipExtensionFormatRecord = immutable_1.Record(exports.defaultValues);
/** the immutable implementation of IZipExtensionFormat */
var ImmutableZipExtensionFormat = /** @class */ (function (_super) {
    __extends(ImmutableZipExtensionFormat, _super);
    function ImmutableZipExtensionFormat(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableZipExtensionFormat;
}(exports.ZipExtensionFormatRecord));
exports.ImmutableZipExtensionFormat = ImmutableZipExtensionFormat;
//# sourceMappingURL=zip-format.js.map

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var form_input_element_base_1 = __webpack_require__(12);
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.date, maxDate: '', minDate: '', earliestAllowed: '', latestAllowed: '' });
exports.DateElementRecord = immutable_1.Record(exports.defaultValues);
var ImmutableDateElement = /** @class */ (function (_super) {
    __extends(ImmutableDateElement, _super);
    function ImmutableDateElement(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableDateElement;
}(exports.DateElementRecord));
exports.ImmutableDateElement = ImmutableDateElement;
//# sourceMappingURL=date-element.js.map

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var form_input_element_base_1 = __webpack_require__(12);
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.duration, useHours: false, useMinutes: false });
exports.DurationElementRecord = immutable_1.Record(exports.defaultValues);
var ImmutableDurationElement = /** @class */ (function (_super) {
    __extends(ImmutableDurationElement, _super);
    function ImmutableDurationElement(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableDurationElement;
}(exports.DurationElementRecord));
exports.ImmutableDurationElement = ImmutableDurationElement;
//# sourceMappingURL=duration-element.js.map

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var form_input_element_base_1 = __webpack_require__(12);
/**
 * Default values for IElectronicSignatureElement.
 */
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.electronicSignature, mode: form_constants_1.electronicSignatureModes.ETO, targetWidth: 100, targetHeight: 100 });
/**
 * ElectronicSignatureElementRecord with defaults set
 */
exports.ElectronicSignatureElementRecord = immutable_1.Record(exports.defaultValues);
/**
 * Immutable version of everything needed to work with Electronic Signature.
 */
var ImmutableElectronicSignatureElement = /** @class */ (function (_super) {
    __extends(ImmutableElectronicSignatureElement, _super);
    function ImmutableElectronicSignatureElement(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableElectronicSignatureElement;
}(exports.ElectronicSignatureElementRecord));
exports.ImmutableElectronicSignatureElement = ImmutableElectronicSignatureElement;
//# sourceMappingURL=electronic-signature-element.js.map

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var form_input_element_base_1 = __webpack_require__(12);
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.gisCoordinates });
exports.GISCoordinatesElementRecord = immutable_1.Record(exports.defaultValues);
var ImmutableGISCoordinatesElement = /** @class */ (function (_super) {
    __extends(ImmutableGISCoordinatesElement, _super);
    function ImmutableGISCoordinatesElement(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableGISCoordinatesElement;
}(exports.GISCoordinatesElementRecord));
exports.ImmutableGISCoordinatesElement = ImmutableGISCoordinatesElement;
//# sourceMappingURL=giscoordinates-element.js.map

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var form_input_element_base_1 = __webpack_require__(12);
var _1 = __webpack_require__(26);
var requiredDefinitions = __webpack_require__(41);
var dataFormats = __webpack_require__(39);
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.group, subElementsList: immutable_1.List([]), groupType: form_constants_1.groupTypes.INDENTED, immutableRequiredDefinition: null, immutableDataFormat: null });
/** Factory that generates Immutable [[IGroupElementRecord]] */
exports.GroupElementRecord = immutable_1.Record(exports.defaultValues);
/** class used to represent an immutable version of the [[GroupElement]] */
var ImmutableGroupElement = /** @class */ (function (_super) {
    __extends(ImmutableGroupElement, _super);
    /** constructs an immutable group element from the standard JS Object [[GroupElement]] */
    function ImmutableGroupElement(props) {
        var _this = _super.call(this, __assign({}, props, { subElementsList: immutable_1.List(props.subElements.map(function (element) { return _1.convertToImmutable(element); })), immutableRequiredDefinition: requiredDefinitions.convertToImmutable(props.requiredDefinition), immutableDataFormat: dataFormats.convertToImmutable(props.dataFormat) })) || this;
        _this.subElements = _this.subElementsList.toArray();
        _this.requiredDefinition = props.requiredDefinition;
        _this.dataFormat = props.dataFormat;
        return _this;
    }
    /**
     * creates a clone of the current ImmutableGroupElement
     * @param key property to change
     * @param value value that the property will be set to
     */
    ImmutableGroupElement.prototype.set = function (key, value) {
        var result = _super.prototype.set.call(this, key, value);
        var object = result.toObject();
        return new ImmutableGroupElement(object);
    };
    /** makes sure that converting this to an object includes the subElements array */
    ImmutableGroupElement.prototype.toObject = function () {
        var object = _super.prototype.toObject.call(this);
        var immutableSubElements = object.subElementsList.toArray();
        object.subElements = immutableSubElements.map(function (element) { return element.toObject(); });
        object.requiredDefinition = object.immutableRequiredDefinition && object.immutableRequiredDefinition.toObject();
        object.dataFormat = object.immutableDataFormat && object.immutableDataFormat.toObject();
        return object;
    };
    return ImmutableGroupElement;
}(exports.GroupElementRecord));
exports.ImmutableGroupElement = ImmutableGroupElement;
//# sourceMappingURL=group-element.js.map

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var form_input_element_base_1 = __webpack_require__(12);
var MultipleChoiceOption = /** @class */ (function () {
    function MultipleChoiceOption() {
    }
    return MultipleChoiceOption;
}());
exports.MultipleChoiceOption = MultipleChoiceOption;
exports.MultipleChoiceOptionRecord = immutable_1.Record({
    value: '',
    label: '',
    numValue: ''
});
var ImmutableMultipleChoiceOption = /** @class */ (function (_super) {
    __extends(ImmutableMultipleChoiceOption, _super);
    function ImmutableMultipleChoiceOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ImmutableMultipleChoiceOption;
}(exports.MultipleChoiceOptionRecord));
exports.ImmutableMultipleChoiceOption = ImmutableMultipleChoiceOption;
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.radio, optionsList: immutable_1.List([]) });
exports.MultipleChoiceElementRecord = immutable_1.Record(exports.defaultValues);
var ImmutableMultipleChoiceElement = /** @class */ (function (_super) {
    __extends(ImmutableMultipleChoiceElement, _super);
    function ImmutableMultipleChoiceElement(props) {
        var _this = _super.call(this, __assign({}, props, { optionsList: immutable_1.List(props.options.map(function (option) { return new ImmutableMultipleChoiceOption(option); })) })) || this;
        _this.options = _this.optionsList.toArray();
        return _this;
    }
    /**
     * creates a clone of the current ImmutableMultipleChoiceElement
     * @param key property to change
     * @param value value that the property will be set to
     */
    ImmutableMultipleChoiceElement.prototype.set = function (key, value) {
        var result = _super.prototype.set.call(this, key, value);
        var object = result.toObject();
        return new ImmutableMultipleChoiceElement(object);
    };
    /** makes sure that converting this to an object includes the options array */
    ImmutableMultipleChoiceElement.prototype.toObject = function () {
        var object = _super.prototype.toObject.call(this);
        object.options = object.optionsList.toArray();
        return object;
    };
    return ImmutableMultipleChoiceElement;
}(exports.MultipleChoiceElementRecord));
exports.ImmutableMultipleChoiceElement = ImmutableMultipleChoiceElement;
//# sourceMappingURL=multiple-choice-element.js.map

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var form_input_element_base_1 = __webpack_require__(12);
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.nationalId, nationalIdType: form_constants_1.nationalIdTypes.SSN });
exports.NationalIdElementRecord = immutable_1.Record(exports.defaultValues);
var ImmutableNationalIdElement = /** @class */ (function (_super) {
    __extends(ImmutableNationalIdElement, _super);
    function ImmutableNationalIdElement(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableNationalIdElement;
}(exports.NationalIdElementRecord));
exports.ImmutableNationalIdElement = ImmutableNationalIdElement;
//# sourceMappingURL=national-id-element.js.map

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var form_input_element_base_1 = __webpack_require__(12);
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.number, decLimit: undefined, minVal: undefined, maxVal: undefined, numericNumberType: form_constants_1.numericElementTypes.RAW_NUMBER });
exports.NumericElementRecord = immutable_1.Record(exports.defaultValues);
var ImmutableNumericElement = /** @class */ (function (_super) {
    __extends(ImmutableNumericElement, _super);
    function ImmutableNumericElement(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableNumericElement;
}(exports.NumericElementRecord));
exports.ImmutableNumericElement = ImmutableNumericElement;
//# sourceMappingURL=numeric-element.js.map

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var form_input_element_base_1 = __webpack_require__(12);
/** [[PostalCodeElement]] with the default values set for the props */
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.postalCode, country: form_constants_1.countryCodes.UnitedStates });
/** Create immutable record for the postal code element, setting default values at start */
exports.PostalCodeElementRecord = immutable_1.Record(exports.defaultValues);
/** Used to handle country-specific postal codes. Immutable Record of [[PostalCodeElement]] with default props */
var ImmutablePostalCodeElement = /** @class */ (function (_super) {
    __extends(ImmutablePostalCodeElement, _super);
    function ImmutablePostalCodeElement(props) {
        return _super.call(this, props) || this;
    }
    return ImmutablePostalCodeElement;
}(exports.PostalCodeElementRecord));
exports.ImmutablePostalCodeElement = ImmutablePostalCodeElement;
//# sourceMappingURL=postal-code-element.js.map

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var required_definition_1 = __webpack_require__(42);
exports.defaultValues = __assign({}, required_definition_1.defaultValues, { type: form_constants_1.requireType.ALL });
exports.BasicRequiredDefinitionRecord = immutable_1.Record(exports.defaultValues);
/** the immutable implementation of IBasicRequiredDefinition */
var ImmutableBasicRequiredDefinition = /** @class */ (function (_super) {
    __extends(ImmutableBasicRequiredDefinition, _super);
    function ImmutableBasicRequiredDefinition(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableBasicRequiredDefinition;
}(exports.BasicRequiredDefinitionRecord));
exports.ImmutableBasicRequiredDefinition = ImmutableBasicRequiredDefinition;
//# sourceMappingURL=basic-required.js.map

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var required_definition_1 = __webpack_require__(42);
exports.defaultValues = __assign({}, required_definition_1.defaultValues, { type: form_constants_1.requireType.SOME, requiredSubElementsList: immutable_1.List([]) });
exports.SomeRequiredDefinitionRecord = immutable_1.Record(exports.defaultValues);
/** immutable object used to represent the SOME required definition for group elements in the redux store */
var ImmutableSomeRequiredDefinition = /** @class */ (function (_super) {
    __extends(ImmutableSomeRequiredDefinition, _super);
    function ImmutableSomeRequiredDefinition(props) {
        var _this = _super.call(this, __assign({}, props, { requiredSubElementsList: immutable_1.List(props.requiredSubElements) })) || this;
        _this.requiredSubElements = props.requiredSubElements;
        return _this;
    }
    /**
     * creates a clone of the current ImmutableSomeRequiredDefinition
     * @param key property to change
     * @param value value that the property will be set to
     */
    ImmutableSomeRequiredDefinition.prototype.set = function (key, value) {
        var result = _super.prototype.set.call(this, key, value);
        var object = result.toObject();
        return new ImmutableSomeRequiredDefinition(object);
    };
    /** makes sure that converting this to an object includes the requiredSubElements array */
    ImmutableSomeRequiredDefinition.prototype.toObject = function () {
        var object = _super.prototype.toObject.call(this);
        object.requiredSubElements = object.requiredSubElementsList.toArray();
        return object;
    };
    return ImmutableSomeRequiredDefinition;
}(exports.SomeRequiredDefinitionRecord));
exports.ImmutableSomeRequiredDefinition = ImmutableSomeRequiredDefinition;
//# sourceMappingURL=some-required.js.map

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var form_input_element_base_1 = __webpack_require__(12);
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.specialText, minCharLength: undefined, maxCharLength: undefined, textType: form_constants_1.specialTextTypes.ANY, isPassword: false });
exports.SpecializedTextElementRecord = immutable_1.Record(exports.defaultValues);
/** Immutable definition of a SpecializedTextElement */
var ImmutableSpecializedTextElement = /** @class */ (function (_super) {
    __extends(ImmutableSpecializedTextElement, _super);
    function ImmutableSpecializedTextElement(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableSpecializedTextElement;
}(exports.SpecializedTextElementRecord));
exports.ImmutableSpecializedTextElement = ImmutableSpecializedTextElement;
//# sourceMappingURL=specialized-text-element.js.map

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var form_input_element_base_1 = __webpack_require__(12);
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.textArea, maxCharLength: undefined, wordLimit: undefined, placeholder: '' });
exports.TextAreaElementRecord = immutable_1.Record(exports.defaultValues);
var ImmutableTextAreaElement = /** @class */ (function (_super) {
    __extends(ImmutableTextAreaElement, _super);
    function ImmutableTextAreaElement(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableTextAreaElement;
}(exports.TextAreaElementRecord));
exports.ImmutableTextAreaElement = ImmutableTextAreaElement;
//# sourceMappingURL=text-area-element.js.map

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var form_input_element_base_1 = __webpack_require__(12);
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.text, maxCharLength: undefined, subText: '', placeholder: '' });
exports.TextElementRecord = immutable_1.Record(exports.defaultValues);
var ImmutableTextElement = /** @class */ (function (_super) {
    __extends(ImmutableTextElement, _super);
    function ImmutableTextElement(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableTextElement;
}(exports.TextElementRecord));
exports.ImmutableTextElement = ImmutableTextElement;
//# sourceMappingURL=text-element.js.map

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var form_constants_1 = __webpack_require__(5);
var form_input_element_base_1 = __webpack_require__(12);
exports.defaultValues = __assign({}, form_input_element_base_1.defaultValues, { type: form_constants_1.elementTypes.time, isMilitaryTime: false });
exports.TimeElementRecord = immutable_1.Record(exports.defaultValues);
var ImmutableTimeElement = /** @class */ (function (_super) {
    __extends(ImmutableTimeElement, _super);
    function ImmutableTimeElement(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableTimeElement;
}(exports.TimeElementRecord));
exports.ImmutableTimeElement = ImmutableTimeElement;
//# sourceMappingURL=time-element.js.map

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var rule_constants_1 = __webpack_require__(15);
var element_condition_1 = __webpack_require__(27);
exports.defaultValues = __assign({}, element_condition_1.defaultValues, { type: rule_constants_1.conditionTypes.equalElement, value: '' });
/** Factory that generates Immutable [[IElementComparisonCondition]] */
exports.ElementComparisonConditionRecord = immutable_1.Record(exports.defaultValues);
/** class that represents an immutable version of the [[IElementComparisonCondition]] */
var ImmutableElementComparisonCondition = /** @class */ (function (_super) {
    __extends(ImmutableElementComparisonCondition, _super);
    function ImmutableElementComparisonCondition(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableElementComparisonCondition;
}(exports.ElementComparisonConditionRecord));
exports.ImmutableElementComparisonCondition = ImmutableElementComparisonCondition;
//# sourceMappingURL=element-comparison-condition.js.map

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var rule_constants_1 = __webpack_require__(15);
var element_condition_1 = __webpack_require__(27);
exports.defaultValues = __assign({}, element_condition_1.defaultValues, { type: rule_constants_1.conditionTypes.empty });
/** Factory that generates Immutable [[IElementStateCondition]] */
exports.ElementStateConditionRecord = immutable_1.Record(exports.defaultValues);
/** an immutable version of the [[IElementStateCondition]] */
var ImmutableElementStateCondition = /** @class */ (function (_super) {
    __extends(ImmutableElementStateCondition, _super);
    function ImmutableElementStateCondition(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableElementStateCondition;
}(exports.ElementStateConditionRecord));
exports.ImmutableElementStateCondition = ImmutableElementStateCondition;
//# sourceMappingURL=element-state-condition.js.map

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var rule_constants_1 = __webpack_require__(15);
var element_condition_1 = __webpack_require__(27);
exports.defaultValues = __assign({}, element_condition_1.defaultValues, { type: rule_constants_1.conditionTypes.equal, value: undefined });
/** Factory that generates Immutable [[IElementValueCondition]] */
exports.ElementValueConditionRecord = immutable_1.Record(exports.defaultValues);
/** class that represents an immutable version of the [[IElementValueCondition]] */
var ImmutableElementValueCondition = /** @class */ (function (_super) {
    __extends(ImmutableElementValueCondition, _super);
    function ImmutableElementValueCondition(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableElementValueCondition;
}(exports.ElementValueConditionRecord));
exports.ImmutableElementValueCondition = ImmutableElementValueCondition;
//# sourceMappingURL=element-value-condition.js.map

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var _1 = __webpack_require__(21);
var form_action_1 = __webpack_require__(43);
exports.defaultValues = {
    name: '',
    disabled: false,
    immutableCondition: null,
    conditionActionsList: immutable_1.List([]),
    preConditionActionsList: immutable_1.List([]),
};
/** factory that generates an immutable [[IFormRuleRecord]] */
exports.FormRuleRecord = immutable_1.Record(exports.defaultValues);
/** class that represents an immutable Form Rule */
var ImmutableFormRule = /** @class */ (function (_super) {
    __extends(ImmutableFormRule, _super);
    function ImmutableFormRule(props) {
        var _this = _super.call(this, __assign({}, props, { immutableCondition: _1.convertConditionToImmutable(props.condition), conditionActionsList: immutable_1.List(props.conditionActions ? props.conditionActions.map(function (action) { return new form_action_1.ImmutableFormAction(action); }) : []), preConditionActionsList: immutable_1.List(!!props.preConditionActions ? props.preConditionActions.map(function (action) { return new form_action_1.ImmutableFormAction(action); }) : []) })) || this;
        _this.condition = _this.immutableCondition && _this.immutableCondition.toObject();
        _this.conditionActions = _this.conditionActionsList && _this.conditionActionsList.toArray();
        _this.preConditionActions = _this.preConditionActionsList && _this.preConditionActionsList.toArray();
        return _this;
    }
    /**
     * creates a clone of the current [[ImmutableFormRule]]
     * @param key property to change
     * @param value value that the property will be set to
     */
    ImmutableFormRule.prototype.set = function (key, value) {
        var result = _super.prototype.set.call(this, key, value);
        var object = result.toObject();
        return new ImmutableFormRule(object);
    };
    /** makes sure that converting this to an object includes properties exclusive to [[IFormRule]] */
    ImmutableFormRule.prototype.toObject = function () {
        var object = _super.prototype.toObject.call(this);
        var immutableActions = object.conditionActionsList.toArray();
        var immutablePreConditionActions = object.preConditionActionsList.toArray();
        return __assign({}, object, { condition: object.immutableCondition && object.immutableCondition.toObject(), conditionActions: immutableActions && immutableActions.map(function (val) { return val.toObject(); }), preConditionActions: immutablePreConditionActions && immutablePreConditionActions.map(function (val) { return val.toObject(); }) });
    };
    return ImmutableFormRule;
}(exports.FormRuleRecord));
exports.ImmutableFormRule = ImmutableFormRule;
//# sourceMappingURL=form-rule.js.map

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var rule_constants_1 = __webpack_require__(15);
var _1 = __webpack_require__(21);
exports.defaultValues = {
    type: rule_constants_1.conditionTypes.operator,
    operator: rule_constants_1.operationTypes.And,
    conditionList: immutable_1.List([]),
};
/** Factory that generates a [[IOperationConditionRecord]] */
exports.OperationConditionRecord = immutable_1.Record(exports.defaultValues);
/** immutable representation of an [[IOperationCondition]] */
var ImmutableOperationCondition = /** @class */ (function (_super) {
    __extends(ImmutableOperationCondition, _super);
    function ImmutableOperationCondition(props) {
        var _this = _super.call(this, __assign({}, props, { conditionList: immutable_1.List(!!props.conditions ? props.conditions.map(function (condition) { return _1.convertConditionToImmutable(condition); }) : []) })) || this;
        _this.conditions = _this.conditionList.toArray();
        return _this;
    }
    /**
     * creates a clone of the current [[ImmutableOperationCondition]]
     * @param key property to change
     * @param value value that the property will be set to
     */
    ImmutableOperationCondition.prototype.set = function (key, value) {
        var result = _super.prototype.set.call(this, key, value);
        var object = result.toObject();
        return new ImmutableOperationCondition(object);
    };
    /** makes sure that converting this to an object includes the conditions array */
    ImmutableOperationCondition.prototype.toObject = function () {
        var object = _super.prototype.toObject.call(this);
        var immutableConditions = object.conditionList.toArray();
        return __assign({}, object, { conditions: immutableConditions.map(function (condition) { return condition.toObject(); }) });
    };
    return ImmutableOperationCondition;
}(exports.OperationConditionRecord));
exports.ImmutableOperationCondition = ImmutableOperationCondition;
//# sourceMappingURL=operation-condition.js.map

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var rule_constants_1 = __webpack_require__(15);
exports.defaultValues = {
    type: rule_constants_1.conditionTypes.programEmpty,
};
/** Factory that generates Immutable [[IProgramStateCondition]] */
exports.ProgramStateConditionRecord = immutable_1.Record(exports.defaultValues);
/** class that represents an immutable version of the [[IProgramStateCondition]] */
var ImmutableProgramStateCondition = /** @class */ (function (_super) {
    __extends(ImmutableProgramStateCondition, _super);
    function ImmutableProgramStateCondition(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableProgramStateCondition;
}(exports.ProgramStateConditionRecord));
exports.ImmutableProgramStateCondition = ImmutableProgramStateCondition;
//# sourceMappingURL=program-state-condition.js.map

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var rule_constants_1 = __webpack_require__(15);
exports.defaultValues = {
    type: rule_constants_1.conditionTypes.programContains,
    value: undefined,
};
/** Factory that generates Immutable [[IProgramValueCondition]] */
exports.ProgramValueConditionRecord = immutable_1.Record(exports.defaultValues);
/** class that represents an immutable version of the [[IProgramValueCondition]] */
var ImmutableProgramValueCondition = /** @class */ (function (_super) {
    __extends(ImmutableProgramValueCondition, _super);
    function ImmutableProgramValueCondition(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableProgramValueCondition;
}(exports.ProgramValueConditionRecord));
exports.ImmutableProgramValueCondition = ImmutableProgramValueCondition;
//# sourceMappingURL=program-value-condition.js.map

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var rule_constants_1 = __webpack_require__(15);
/**
 * Check if the given condition matches a value in elementComparisonTypes.
 * @param condType The condition type to test.
 * @returns True if this condition is of the element comparison type; false otherwise
 */
function isConditionElementComparisonType(condType) {
    switch (condType) {
        case rule_constants_1.conditionTypes.equalElement:
        case rule_constants_1.conditionTypes.notEqualElement:
        case rule_constants_1.conditionTypes.lessThanElement:
        case rule_constants_1.conditionTypes.lessThanOrEqualElement:
        case rule_constants_1.conditionTypes.greaterThanElement:
        case rule_constants_1.conditionTypes.greaterThanOrEqualElement:
            return true;
    }
    return false;
}
exports.isConditionElementComparisonType = isConditionElementComparisonType;
/**
 * Check if the given condition matches a value in elementValueTypes.
 * @param condType The condition type to test.
 * @returns True if this condition is of the element value type; false otherwise
 */
function isConditionElementValueType(condType) {
    switch (condType) {
        case rule_constants_1.conditionTypes.equal:
        case rule_constants_1.conditionTypes.notEqual:
        case rule_constants_1.conditionTypes.equalLabel:
        case rule_constants_1.conditionTypes.notEqualLabel:
        case rule_constants_1.conditionTypes.equalMaskedMulti:
        case rule_constants_1.conditionTypes.notEqualMaskedMulti:
        case rule_constants_1.conditionTypes.contains:
        case rule_constants_1.conditionTypes.containsString:
        case rule_constants_1.conditionTypes.notContainString:
        case rule_constants_1.conditionTypes.lessThan:
        case rule_constants_1.conditionTypes.lessThanOrEqual:
        case rule_constants_1.conditionTypes.greaterThan:
        case rule_constants_1.conditionTypes.greaterThanOrEqual:
        case rule_constants_1.conditionTypes.beginsWith:
        case rule_constants_1.conditionTypes.notBeginWith:
        case rule_constants_1.conditionTypes.endsWith:
        case rule_constants_1.conditionTypes.notEndWith:
        case rule_constants_1.conditionTypes.matchesAny:
        case rule_constants_1.conditionTypes.notMatchAny:
        case rule_constants_1.conditionTypes.matchesAnyMaskedMulti:
        case rule_constants_1.conditionTypes.notMatchAnyMaskedMulti:
        case rule_constants_1.conditionTypes.matchesEvery:
        case rule_constants_1.conditionTypes.notMatchEvery:
        case rule_constants_1.conditionTypes.between:
        case rule_constants_1.conditionTypes.notBetween:
        case rule_constants_1.conditionTypes.last:
        case rule_constants_1.conditionTypes.notLast:
        case rule_constants_1.conditionTypes.next:
        case rule_constants_1.conditionTypes.notNext:
            return true;
    }
    return false;
}
exports.isConditionElementValueType = isConditionElementValueType;
/**
 * Check if the given condition matches a value in elementStateTypes.
 * @param condType The condition type to test.
 * @returns True if this condition is of the element state type; false otherwise
 */
function isConditionElementStateType(condType) {
    switch (condType) {
        case rule_constants_1.conditionTypes.empty:
        case rule_constants_1.conditionTypes.notEmpty:
        case rule_constants_1.conditionTypes.earlierThanNow:
        case rule_constants_1.conditionTypes.earlierThanNowOrEqual:
        case rule_constants_1.conditionTypes.laterThanNow:
        case rule_constants_1.conditionTypes.laterThanNowOrEqual:
        case rule_constants_1.conditionTypes.today:
        case rule_constants_1.conditionTypes.notToday:
        case rule_constants_1.conditionTypes.thisWeek:
        case rule_constants_1.conditionTypes.notThisWeek:
        case rule_constants_1.conditionTypes.thisMonth:
        case rule_constants_1.conditionTypes.notThisMonth:
        case rule_constants_1.conditionTypes.thisYear:
        case rule_constants_1.conditionTypes.notThisYear:
            return true;
    }
    return false;
}
exports.isConditionElementStateType = isConditionElementStateType;
/**
 * Check if the given condition uses operators.
 * @param condType The condition type to test.
 * @returns True if this condition is of the operator type; false otherwise
 */
function isConditionOperatorType(condType) {
    switch (condType) {
        case rule_constants_1.conditionTypes.operator:
            return true;
    }
    return false;
}
exports.isConditionOperatorType = isConditionOperatorType;
function isStaticConditionType(condType) {
    return condType === rule_constants_1.conditionTypes.static;
}
exports.isStaticConditionType = isStaticConditionType;
//# sourceMappingURL=rule-helpers.js.map

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var rule_constants_1 = __webpack_require__(15);
exports.defaultValues = {
    type: rule_constants_1.conditionTypes.static,
    value: false
};
/** Factory that generates Immutable [[IStaticCondition]] */
exports.StaticConditionRecord = immutable_1.Record(exports.defaultValues);
/** an immutable version of the [[IStaticCondition]] */
var ImmutableStaticCondition = /** @class */ (function (_super) {
    __extends(ImmutableStaticCondition, _super);
    function ImmutableStaticCondition(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableStaticCondition;
}(exports.StaticConditionRecord));
exports.ImmutableStaticCondition = ImmutableStaticCondition;
//# sourceMappingURL=static-condition.js.map

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
exports.defaultValues = {
    type: 'invalid'
};
/** Factory that generates Immutable [[IUnsupportedCondition]] */
exports.UnsupportedConditionRecord = immutable_1.Record(exports.defaultValues);
/** class that represents an immutable version of the [[IUnsupportedCondition]] */
var ImmutableUnsupportedCondition = /** @class */ (function (_super) {
    __extends(ImmutableUnsupportedCondition, _super);
    function ImmutableUnsupportedCondition() {
        return _super.call(this) || this;
    }
    return ImmutableUnsupportedCondition;
}(exports.UnsupportedConditionRecord));
exports.ImmutableUnsupportedCondition = ImmutableUnsupportedCondition;
//# sourceMappingURL=unsupported-conditions.js.map

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var form_definition_1 = __webpack_require__(38);
var form_constants_1 = __webpack_require__(5);
/**
 * Returns an array with the labels of selected multiple choice values,
 * if one of the options selected is the other option the value of the other text element is returned instead of the label.
 * @param groupElement a group element with data format of MULTIPLE_CHOICE_OTHER
 * @param groupValue the value of the group
 * @param state
 */
function getMCOtherLabels(groupElement, groupValue, state) {
    if (!groupElement || !groupValue)
        return [];
    if (groupElement.dataFormat && groupElement.dataFormat.type === form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER) {
        var dataFormat_1 = groupElement.dataFormat;
        var mcElement = form_definition_1.getElementById(state, dataFormat_1.mcElementId);
        var mcValue_1 = groupValue.mcValue ? groupValue.mcValue.toArray() : [];
        var selectedOptions = mcElement ? mcElement.options.filter(function (opt) { return mcValue_1.includes(opt.value); }) : [];
        var otherValue_1 = groupValue.otherValue ? groupValue.otherValue : '';
        return selectedOptions.map(function (option) { return option.value === dataFormat_1.otherOptionValue ? otherValue_1 : option.label; });
    }
    else {
        return [];
    }
}
exports.getMCOtherLabels = getMCOtherLabels;
//# sourceMappingURL=group-data-format-helpers.js.map

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
exports.ProgramRecord = immutable_1.Record({
    id: '',
    name: '',
    siteId: '',
    disabled: false,
});
/** Immutable SSG Program */
var Program = /** @class */ (function (_super) {
    __extends(Program, _super);
    function Program(props) {
        return _super.call(this, props) || this;
    }
    return Program;
}(exports.ProgramRecord));
exports.Program = Program;
;
//# sourceMappingURL=program.js.map

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var rules_engine_1 = __webpack_require__(158);
exports.runRulesEngine = rules_engine_1.runRulesEngine;
var action_reducer_1 = __webpack_require__(45);
exports.actionReducer = action_reducer_1.actionReducer;
var condition_reducer_1 = __webpack_require__(46);
exports.conditionReducer = condition_reducer_1.conditionReducer;
//# sourceMappingURL=index.js.map

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var utilities_1 = __webpack_require__(22);
/**
 * Determines if the selected programs in the form state are empty
 * @param selectedPrograms the current value of the selected programs in the form state
 * @returns true if the given value should be considered empty
 */
function hasEmptyProgramValue(selectedPrograms) {
    return !selectedPrograms || (immutable_1.List.isList(selectedPrograms) && selectedPrograms.size === 0);
}
exports.hasEmptyProgramValue = hasEmptyProgramValue;
/**
 * determines if a program name contains some text
 * @param selectedPrograms the current value of the selected programs in the form state
 * @param allPrograms information on all programs, used to determine the names of the selected programs
 * @param conditionValue text string to match
 */
function programNameContains(selectedPrograms, allPrograms, conditionValue) {
    var conditionStr = conditionValue.trim().toLocaleUpperCase();
    // regex format
    conditionStr = utilities_1.textUtilities.convertStrToRegExStr(conditionStr);
    // account for wildcard with regex symbol for wildcard
    conditionStr = conditionStr.replace(RegExp("%", "g"), ".*");
    var conditionRegex = RegExp(conditionStr);
    var programs = allPrograms ? allPrograms.toArray() : [];
    var selectedProgramNames = selectedPrograms ? programs.filter(function (program) { return selectedPrograms.includes(program.id); }).map(function (program) { return program.name; }) : [];
    return !!selectedProgramNames && !!conditionRegex && selectedProgramNames.some(function (name) { return conditionRegex.test(name.trim().toLocaleUpperCase()); });
}
exports.programNameContains = programNameContains;
/**
 * Determines if any of the programs in the condition value have been selected
 * @param selectedPrograms the current value of the selected programs in the form state
 * @param conditionValue array of program ids to match
 */
function programAnySelected(selectedPrograms, conditionValue) {
    return !!selectedPrograms && !!conditionValue && conditionValue.some(function (programId) { return selectedPrograms.includes(programId); });
}
exports.programAnySelected = programAnySelected;
/**
 * Determines if all of the programs in the condition value have been selected
 * @param selectedPrograms the current value of the selected programs in the form state
 * @param conditionValue array of program ids to match
 */
function programAllSelected(selectedPrograms, conditionValue) {
    return !!selectedPrograms && (!conditionValue || conditionValue.every(function (programId) { return selectedPrograms.includes(programId); }));
}
exports.programAllSelected = programAllSelected;
//# sourceMappingURL=program-operators.js.map

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var form_definition_1 = __webpack_require__(17);
var condition_reducer_1 = __webpack_require__(46);
var action_reducer_1 = __webpack_require__(45);
/**
 * This function takes an initial form state, including: the starting form, the current responses, and any previously existing response information,
 * and processes it based on the set of rules on the form.
 * - First, it checks to see if any preconditions exist on the form and runs those through the actionReducer if any are present.
 * - Second, the rules are run through the rulesReducer to produce the final state
 * - Finally, the modified FormState is returned to the user
 * @param {FormState} formState the initial FormState before the rules are applied (see ../common/form-definition for information on the FormState structure)
 */
function runRulesEngine(formState) {
    var rules = formState.getIn(['form', 'rules']);
    if (!rules) {
        return formState;
    }
    var state = new form_definition_1.FormState(formState);
    // run preconditions
    rules.forEach(function (rule) {
        var preConditionActions = rule.preConditionActions;
        preConditionActions && preConditionActions.forEach(function (action) {
            state = action_reducer_1.actionReducer(state, action);
        });
    });
    rules.forEach(function (rule) {
        state = ruleReducer(state, rule);
    });
    state = filterHiddenValues(state);
    return state;
}
exports.runRulesEngine = runRulesEngine;
/**
 * This function applies a given rule to the state.
 * It first checks to see what operation needs to be applied when there are multiple conditions to check(And/Or)
 * Then it processes the conditions using the conditionReducer, which returns whether or not the conditions for a rule have been met based on the state
 * If the required number of conditions are not met based on the operation type the initial state is returned
 * If the required number of conditions are met then the actionReducer is applied for each conditionAction in the rule
 * @param {FormState} state the initial FormState before this rule is applied
 * @param {FormRule} rule the rule that is to be applied to the state
 */
function ruleReducer(state, rule) {
    var disabled = rule.disabled, condition = rule.condition, conditionActions = rule.conditionActions, preConditionActions = rule.preConditionActions;
    if (disabled || !form_definition_1.formRuleTypes.isRuleSupported(rule)) {
        return state;
    }
    var conditionsMet = condition_reducer_1.conditionReducer(state, condition);
    if (conditionsMet) {
        var modifiedState = new form_definition_1.FormState(state);
        conditionActions && conditionActions.forEach(function (action) {
            modifiedState = action_reducer_1.actionReducer(modifiedState, action);
        });
        return modifiedState;
    }
    return state;
}
exports.ruleReducer = ruleReducer;
/**
 * This function will remove any values for elements that are marked as hidden, because any responses to these questions should not be included when saving
 * @param {FormState} initialState
 */
function filterHiddenValues(initialState) {
    var form = initialState.form;
    var elements = form.elements;
    var state = initialState;
    elements && elements.forEach(function (element) {
        state = removeHiddenValueRecursive(element, state);
    });
    return state;
}
exports.filterHiddenValues = filterHiddenValues;
/**
 * Handles recursively removing values for hidden fields, including groups
 * @param element the element we are removing a value for
 * @param initialState the form state
 * @param parentHidden true if a parent group element was hidden, causing this element to be hidden
 */
function removeHiddenValueRecursive(element, initialState, parentHidden) {
    if (parentHidden === void 0) { parentHidden = false; }
    var state = initialState;
    if (!element)
        return state;
    var hiddenValue = element.hidden || parentHidden;
    if (element.type === form_definition_1.elementTypes.group) {
        element.subElements && element.subElements.forEach(function (subElement) {
            state = removeHiddenValueRecursive(subElement, state, hiddenValue);
        });
    }
    else {
        var elementValue = state.getIn(['value', element.id]);
        if (!!elementValue && hiddenValue) {
            state = state.setIn(['value', element.id], undefined);
        }
    }
    return state;
}
//# sourceMappingURL=rules-engine.js.map

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function compareArrays(array1, array2) {
    return !!array1 && !!array2 &&
        Array.isArray(array1) && Array.isArray(array2) &&
        (array1.length === array2.length) &&
        array1.every(function (elem, index) {
            return elem === array2[index];
        });
}
exports.compareArrays = compareArrays;
;
//# sourceMappingURL=array-extensions.js.map

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var validateEmailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
/**
 * Tests the email for valid format according to the RFC 5322 standard
 * @param email
 */
function isValidEmail(email) {
    return validateEmailRegex.test(email);
}
exports.isValidEmail = isValidEmail;
;
//# sourceMappingURL=email-utilities.js.map

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var wordCountRegex = /\S+/g;
function getWordCount(value) {
    var match = value && value.match(wordCountRegex);
    return match ? match.length : 0;
}
exports.getWordCount = getWordCount;
;
/**
 * this function can be used when doing string comparisons and it is desired
 * to use regular expressions. this will take the input text and escape special
 * regex characters so that the original string integrity is preserved
 * @param text text string to convert
 */
function convertStrToRegExStr(text) {
    var regExStr = text.replace("\\", "\\\\")
        .replace(".", "\\.")
        .replace("?", "\\?")
        .replace("+", "\\+")
        .replace("*", "\\*")
        .replace("^", "\\^")
        .replace("$", "\\$")
        .replace("|", "\\|")
        .replace("(", "\\(")
        .replace(")", "\\)")
        .replace("[", "\\[");
    return regExStr;
}
exports.convertStrToRegExStr = convertStrToRegExStr;
//# sourceMappingURL=text-utilities.js.map

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Takes time value as it is stored the ssg forms state and
 * converts it to a time string in the format HH:mm:ss
 * @param timeValue
 * @param isMilitaryTime
 */
exports.getTimeString = function (timeValue, isMilitaryTime) {
    var modifiedHours = timeValue.hour;
    if (!isMilitaryTime) {
        var hoursNum = parseInt(timeValue.hour, 10);
        if (timeValue.period === 'AM' && hoursNum === 12) {
            modifiedHours = '00';
        }
        else if (timeValue.period === 'PM' && hoursNum !== 12) {
            modifiedHours = (hoursNum + 12).toString();
        }
    }
    return modifiedHours + ":" + timeValue.minute + ":00";
};
//# sourceMappingURL=time-utilities.js.map

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var run_validation_1 = __webpack_require__(164);
exports.runValidation = run_validation_1.runValidation;
exports.validateFormElement = run_validation_1.validateFormElement;
var validation_error_1 = __webpack_require__(49);
exports.errorTypes = validation_error_1.errorTypes;
exports.validationError = validation_error_1.validationError;
exports.sectionedValidationError = validation_error_1.sectionedValidationError;
//# sourceMappingURL=index.js.map

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var iconv = __webpack_require__(484);
var validation_error_1 = __webpack_require__(49);
var form_definition_1 = __webpack_require__(17);
var utilities_1 = __webpack_require__(22);
var form_constants_1 = __webpack_require__(5);
var form_elements_1 = __webpack_require__(26);
var isValidEmail = utilities_1.emailUtilities.isValidEmail;
var getWordCount = utilities_1.textUtilities.getWordCount;
function invalidEmailError(id, element, section, errorNum, parentElement) {
    var displayLabel = element.label || (parentElement && parentElement.label);
    return validation_error_1.validationError(id, displayLabel, section, errorNum, "Please enter a valid email address.", validation_error_1.errorTypes.inline);
}
function elementError(element, message, section, errorNum, parentElement) {
    var displayLabel = element.label || (parentElement && parentElement.label);
    return validation_error_1.validationError(element.id, displayLabel, section, errorNum, message);
}
function requiredResponseError(element, section, errorNum, parentElement) {
    var displayLabel = element.label || (parentElement && parentElement.label);
    return validation_error_1.validationError(element.id, displayLabel, section, errorNum, "Element requires a response");
}
;
/**
 * returns a generic incomplete error
 * @param element the element that the error pertains to
 * @param section the level of the error (form-element)
 * @param errorNum the error number, used to distinguish this form other errors
 * @param parentElement the group element that contains the element, if one exists
 */
function incompleteResponseError(element, section, errorNum, parentElement) {
    var displayLabel = element.label || (parentElement && parentElement.label);
    return validation_error_1.validationError(element.id, displayLabel, section, errorNum, "This is incomplete, please provide a value.");
}
;
function unexpectedTypeError(element, section, errorNum, actualType, expectedType, parentElement) {
    var displayLabel = element.label || (parentElement && parentElement.label);
    return validation_error_1.validationError(element.id, displayLabel, section, errorNum, "invalid response type [" + actualType + "], it should be an " + expectedType);
}
;
function decimalLimitExceededError(element, section, errorNum, decimalLimit, parentElement) {
    var displayLabel = element.label || (parentElement && parentElement.label);
    return validation_error_1.validationError(element.id, displayLabel, section, errorNum, "invalid response. Number of decimal places cannot exceed " + decimalLimit.toString(), validation_error_1.errorTypes.inline);
}
;
function numberOutOfBoundsError(element, section, errorNum, minVal, maxVal, currentVal, numberType, parentElement) {
    var displayLabel = element.label || (parentElement && parentElement.label);
    var numberWording = numberType === form_definition_1.numericElementTypes.MONEY ? 'an amount' : numberType === form_definition_1.numericElementTypes.PERCENTAGE ? 'a percentage' : 'a number';
    var dollars = numberType === form_definition_1.numericElementTypes.MONEY ? '$' : '';
    var percent = numberType === form_definition_1.numericElementTypes.PERCENTAGE ? '%' : '';
    var warn;
    if (minVal !== null && minVal !== undefined && typeof currentVal === 'number' && currentVal < minVal) {
        if (maxVal !== null && maxVal !== undefined)
            warn = 'You can enter ' + numberWording + ' between ' + dollars + minVal.toString() + percent + ' and ' + dollars + maxVal.toString() + percent + ".";
        else
            warn = 'You can enter ' + numberWording + ' greater than or equal to ' + dollars + minVal.toString() + percent + ".";
    }
    else if (maxVal !== null && maxVal !== undefined && typeof currentVal === 'number' && currentVal > maxVal) {
        if (minVal !== null && minVal !== undefined)
            warn = 'You can enter ' + numberWording + ' between ' + dollars + minVal.toString() + percent + ' and ' + dollars + maxVal.toString() + percent + ".";
        else
            warn = 'You can enter ' + numberWording + ' less than or equal to ' + dollars + maxVal.toString() + percent + ".";
    }
    return validation_error_1.validationError(element.id, displayLabel, section, errorNum, warn, validation_error_1.errorTypes.inline);
}
;
function dateOutOfBoundsError(element, section, errorNum, minVal, maxVal, parentElement) {
    var displayLabel = element.label || (parentElement && parentElement.label);
    var minDisplay = utilities_1.dateUtilities.getUserFriendlyFormat(minVal);
    var maxDisplay = utilities_1.dateUtilities.getUserFriendlyFormat(maxVal);
    var warn;
    if (maxVal && minVal) {
        warn = 'Please enter a date between ' + minDisplay + ' and ' + maxDisplay + '.';
    }
    else if (minVal) {
        warn = 'Please enter a date on or after ' + minDisplay + '.';
    }
    else if (maxVal) {
        warn = 'Please enter a date on or before ' + maxDisplay + '.';
    }
    return validation_error_1.validationError(element.id, displayLabel, section, errorNum, warn, validation_error_1.errorTypes.inline);
}
function incompleteSelectionError(element, subSection, section, errorNum) {
    return validation_error_1.sectionedValidationError(element.id, element.label, subSection, section, errorNum, "incomplete value", validation_error_1.errorTypes.inline);
}
;
function invalidSelectionError(element, subSection, section, errorNum, expectedSelection) {
    return validation_error_1.sectionedValidationError(element.id, element.label, subSection, section, errorNum, "unexpected value, expecting value in range " + expectedSelection, validation_error_1.errorTypes.inline);
}
;
/**
 * Runs validation on the entire form state
 * @param state the form state to validate
 * @returns returns a modified form state with an updated validation result
 */
function runValidation(state, country) {
    var passedValidation = true;
    var errors = [];
    var modifiedState = state.set('validationResult', new form_definition_1.ValidationResult({}));
    modifiedState = validateFormElements(modifiedState, country);
    modifiedState = validateForm(modifiedState);
    return modifiedState;
}
exports.runValidation = runValidation;
;
/**
 * Perform validation on all the form elements
 * @param {FormState} state the FormState containing the form and value information
 * @returns modified form state
 */
function validateFormElements(state, country) {
    var _a = state || new form_definition_1.FormState({}), form = _a.form, value = _a.value, defaultValue = _a.defaultValue, validationResult = _a.validationResult;
    var passedValidation = true;
    var errors = [];
    if (!!form) {
        var elements = form.elements;
        if (elements) {
            elements.forEach(function (element) {
                var elementValidation = validateFormElement(country, state, element);
                passedValidation = elementValidation.passedValidation && passedValidation;
                errors.push.apply(errors, elementValidation.errors.toArray());
            }, this);
        }
    }
    return state.set('validationResult', new form_definition_1.ValidationResult({
        passedValidation: validationResult.passedValidation && passedValidation,
        errors: validationResult.errors.concat(errors).toList()
    }));
}
exports.validateFormElements = validateFormElements;
/**
 * Validate an individual form element
 * @param formState the form state
 * @param element the element being evaluated
 * @param parentElement the group element that contains the element being evaluated
 * @param requireCompletion if true, it will override whether or not completion is required for a group element
 * @returns validation errors
 */
function validateFormElement(country, formState, element, parentElement, requireCompletion) {
    var value = formState.value, defaultValue = formState.defaultValue;
    var passedValidation = true;
    var errors = [];
    var elementValue = value && value.get(element.id);
    var elementDefaultValue = defaultValue.get(element.id);
    var response = form_definition_1.getValue(formState, element.id, country);
    if (element.disabled || element.hidden || !form_definition_1.elementStoresData(element.type) || element.readOnly) {
        return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
    }
    var elementEmptyValue = form_definition_1.hasEmptyValue(element, response, formState);
    if (elementEmptyValue && element.type !== form_definition_1.elementTypes.group && element.isRequired) {
        passedValidation = false;
        errors.push(requiredResponseError(element, 'form-element', errors.length, parentElement));
    }
    if (!elementEmptyValue || element.type === form_definition_1.elementTypes.group) {
        var type = typeof (response);
        switch (element.type) {
            case form_definition_1.elementTypes.group: {
                var groupValidation = validateGroupValue(element, formState, requireCompletion, country, parentElement);
                passedValidation = groupValidation.passedValidation && passedValidation;
                errors.push.apply(errors, groupValidation.errors.toArray());
                break;
            }
            case form_definition_1.elementTypes.radio:
            case form_definition_1.elementTypes.select:
            case form_definition_1.elementTypes.checkbox:
            case form_definition_1.elementTypes.likert:
                if (!immutable_1.List.isList(response)) {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "List"));
                }
                break;
            case form_definition_1.elementTypes.text:
                if (type !== 'string') {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
                    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                }
                if (element.maxCharLength && element.maxCharLength > 0 && iconv.encode(response, 'utf8').length > element.maxCharLength) {
                    passedValidation = false;
                    var charLengthErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "Exceeded character limit", validation_error_1.errorTypes.inline);
                    errors.push(charLengthErr);
                }
                break;
            case form_definition_1.elementTypes.textArea:
                if (type !== 'string') {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
                    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                }
                var wordCount = getWordCount(response);
                if (element.wordLimit && element.wordLimit > 0 && wordCount > element.wordLimit) {
                    passedValidation = false;
                    var wordLimitErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "Exceeded word limit", validation_error_1.errorTypes.inline);
                    errors.push(wordLimitErr);
                }
                if (element.maxCharLength && element.maxCharLength > 0 && response.length > element.maxCharLength) {
                    passedValidation = false;
                    var charLengthErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "Exceeded character limit", validation_error_1.errorTypes.inline);
                    errors.push(charLengthErr);
                }
                break;
            case form_definition_1.elementTypes.gisCoordinates:
                if (type !== 'string') {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
                    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                }
                break;
            case form_definition_1.elementTypes.date:
                if (type !== 'string') {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
                }
                // check if valid date string
                if (!utilities_1.dateUtilities.isValidDate(response, country)) {
                    passedValidation = false;
                    errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, 'Enter a valid date', validation_error_1.errorTypes.inline));
                }
                else {
                    // check date limits
                    if (!utilities_1.dateUtilities.isDateInRange(response, element.minDate, element.maxDate, element.earliestAllowed, element.latestAllowed)) {
                        passedValidation = false;
                        errors.push(dateOutOfBoundsError(element, 'form-element', errors.length, element.minDate, element.maxDate));
                    }
                }
                break;
            case form_definition_1.elementTypes.number:
                var responseAsNumber = utilities_1.numberUtilities.stringToNumber(response);
                if (response === null || response === undefined || response === "")
                    break;
                if (responseAsNumber === null) {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "number"));
                }
                else {
                    if (element.decLimit !== null && utilities_1.numberUtilities.decPlaces(responseAsNumber) > element.decLimit) {
                        passedValidation = false;
                        errors.push(decimalLimitExceededError(element, 'form-element', errors.length, element.decLimit));
                    }
                    if (element.minVal !== null && responseAsNumber < element.minVal) {
                        passedValidation = false;
                        errors.push(numberOutOfBoundsError(element, 'form-element', errors.length, element.minVal, element.maxVal, responseAsNumber, element.numericNumberType));
                    }
                    if (element.maxVal !== null && responseAsNumber > element.maxVal) {
                        passedValidation = false;
                        errors.push(numberOutOfBoundsError(element, 'form-element', errors.length, element.minVal, element.maxVal, responseAsNumber, element.numericNumberType));
                    }
                }
                break;
            case form_definition_1.elementTypes.phone:
                if (type !== 'string') {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
                }
                // check if valid phone number string
                var phoneRegEx = /^\d{10}$/;
                if (!phoneRegEx.test(response)) {
                    passedValidation = false;
                    errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, 'Please enter a 10 digit number.', validation_error_1.errorTypes.inline));
                }
                break;
            case form_definition_1.elementTypes.email:
                if (type !== 'string') {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
                }
                // check if valid email string
                if (!isValidEmail(response)) {
                    passedValidation = false;
                    errors.push(invalidEmailError(element.id, element, 'form-element', errors.length));
                }
                break;
            case form_definition_1.elementTypes.duration:
                if (type !== 'object') {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "object"));
                    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                }
                var hours = response.get('hours');
                var mins = response.get('minutes');
                if (element.isRequired && !hours && !mins) {
                    passedValidation = false;
                    errors.push(requiredResponseError(element, 'form-element', errors.length));
                    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                }
                if ((hours && typeof (hours) !== 'number') || (mins && typeof (mins) !== 'number')) {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "number"));
                }
                if (hours > 999 || hours < 0) {
                    passedValidation = false;
                    errors.push(validation_error_1.sectionedValidationError(element.id, element.label, 'hours', 'form-element', errors.length, 'Enter a value between 0 and 999', validation_error_1.errorTypes.inline));
                }
                if (element.useHours && (mins > 59 || mins < 0)) {
                    passedValidation = false;
                    errors.push(validation_error_1.sectionedValidationError(element.id, element.label, 'minutes', 'form-element', errors.length, 'Enter a value between 0 and 59', validation_error_1.errorTypes.inline));
                }
                else if (!element.useHours && (mins > 99999 || mins < 0)) {
                    passedValidation = false;
                    errors.push(validation_error_1.sectionedValidationError(element.id, element.label, 'minutes', 'form-element', errors.length, 'Enter a value between 0 and 99999', validation_error_1.errorTypes.inline));
                }
                break;
            case form_definition_1.elementTypes.nationalId:
                if (!elementEmptyValue) {
                    if (type !== 'string') {
                        passedValidation = false;
                        errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
                    }
                    // check if valid id string (Canadian SIN or American SSN)
                    var nationalIdRegEx = /^\d{9}$/;
                    if (!nationalIdRegEx.test(response)) {
                        passedValidation = false;
                        errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, 'Please enter a 9 digit number.', validation_error_1.errorTypes.inline));
                    }
                }
                break;
            case form_definition_1.elementTypes.postalCode:
                if (!elementEmptyValue) {
                    if (type !== 'string') {
                        passedValidation = false;
                        errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
                    }
                    // check if valid, based on country's specific rule set
                    var postalCodeRegex = void 0;
                    switch (element.country) {
                        case form_definition_1.countryCodes.UnitedKingdom:
                            postalCodeRegex = /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/;
                            if (!postalCodeRegex.test(response)) {
                                passedValidation = false;
                                errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, 'Please enter a valid UK Postal Code.', validation_error_1.errorTypes.inline));
                            }
                            break;
                        case form_definition_1.countryCodes.Canada:
                            // in the format A1A 1A1, where A is a letter and 1 is a digit. allowing the space to be present or absent
                            postalCodeRegex = /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/;
                            if (!postalCodeRegex.test(response)) {
                                passedValidation = false;
                                errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, 'Please enter a valid six-character Postal Code.', validation_error_1.errorTypes.inline));
                            }
                            break;
                        case form_definition_1.countryCodes.UnitedStates:
                        default:
                            // default to U.S. style of 5 digits
                            postalCodeRegex = /^\d{5}$/;
                            if (!postalCodeRegex.test(response)) {
                                passedValidation = false;
                                errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, 'Zip Code must be five digits long.', validation_error_1.errorTypes.inline));
                            }
                            break;
                    }
                }
                break;
            case form_definition_1.elementTypes.specialText: {
                var specialTextValidation = validateSpecializedTextValue(element, response);
                passedValidation = specialTextValidation.passedValidation && passedValidation;
                errors.push.apply(errors, specialTextValidation.errors.toArray());
                break;
            }
            case form_definition_1.elementTypes.time: {
                if (!elementEmptyValue) {
                    var timeValidation = validateTimeValue(element, response);
                    passedValidation = timeValidation.passedValidation && passedValidation;
                    errors.push.apply(errors, timeValidation.errors.toArray());
                }
                break;
            }
            case form_definition_1.elementTypes.attachment:
                if (!elementValue) {
                    break;
                }
                var files = response.get('files');
                var numFiles = response.get('fileCount');
                if (element.isRequired && (!files || !numFiles || !files.size || files.size === 0)) {
                    passedValidation = false;
                    errors.push(requiredResponseError(element, 'form-element', errors.length));
                    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                }
                if (files !== null && files !== undefined && !!files.size && files.size > 0) {
                    var filesUploaded = response.get('completedUploads');
                    var isUploading = files.some(function (file) { return file.get('isUploading'); });
                    if (isUploading) {
                        passedValidation = false;
                        errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, 'The file has not finished uploading'));
                        return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                    }
                    else if (numFiles - filesUploaded !== 0 || numFiles !== files.size) {
                        passedValidation = false;
                        errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, 'There was an error uploading the selected files. Please try again.', validation_error_1.errorTypes.inline));
                        return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                    }
                    var imagesOnly = element.imageAttachment;
                    var maxUploadSize = element.uploadSize;
                    var maxTotalUploadSize = element.maxTotalUploadSize;
                    var totalUploadSize = 0;
                    var imgFilter = /^image\//;
                    var file, i;
                    for (i = 0; i < numFiles; i++) {
                        file = files.get(i);
                        if (maxUploadSize !== 0 && file.get('size') > maxUploadSize) {
                            passedValidation = false;
                            errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "A file exceeded the maximum upload size of " + utilities_1.numberUtilities.formatBytesForString(maxUploadSize) + ".", validation_error_1.errorTypes.inline));
                            return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                        }
                        if (imagesOnly === true && !imgFilter.test(file.get('contentType'))) {
                            passedValidation = false;
                            errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "You may only upload images.", validation_error_1.errorTypes.inline));
                            return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                        }
                        totalUploadSize += file.get('size');
                        if (totalUploadSize > maxTotalUploadSize) {
                            passedValidation = false;
                            errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, (numFiles === 1 ? 'The file exceeds' : 'Combined, the files exceed') + " the maximum total upload size of " + utilities_1.numberUtilities.formatBytesForString(maxTotalUploadSize) + ".", validation_error_1.errorTypes.inline));
                            return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                        }
                    }
                }
                break;
            case form_definition_1.elementTypes.electronicSignature:
                if (type !== 'object') {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "object"));
                    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                }
                //apricot stores sig data as a string in 'imageUrl' field
                if (element.mode === form_constants_1.electronicSignatureModes.APRICOT) {
                    var coord = response.get('imageUrl');
                    if (!!coord && typeof (coord) !== 'string') {
                        passedValidation = false;
                        errors.push(unexpectedTypeError(element, 'form-element', errors.length, typeof (coord), "string"));
                        return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                    }
                }
                //eto stores sig data as an array in 'etoCoords' field
                else if (element.mode === form_constants_1.electronicSignatureModes.ETO) {
                    var coord = response.get('etoCoords');
                    if (coord && !immutable_1.List.isList(coord)) {
                        passedValidation = false;
                        errors.push(unexpectedTypeError(element, 'form-element', errors.length, typeof (coord), "list"));
                        return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                    }
                }
                else {
                    passedValidation = false;
                    errors.push(validation_error_1.validationError(element.id, element.label, null, errors.length, 'Invalid mode', validation_error_1.errorTypes.global));
                    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                }
                break;
            default: break;
        }
    }
    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
}
exports.validateFormElement = validateFormElement;
/**
 * Perform validation for form-wide requirements
 * @param {object} state the FormState containing the form and value information
 */
function validateForm(state) {
    var _a = state || new form_definition_1.FormState({}), form = _a.form, value = _a.value, validationResult = _a.validationResult, recaptchaValue = _a.recaptchaValue;
    var elements = form.elements;
    var passedValidation = true;
    var errors = [];
    if (!!form && form.includeRecaptcha && !recaptchaValue) {
        passedValidation = false;
        errors.push(validation_error_1.validationError('0', '', 'form-element', errors.length, 'The google reCAPTCHA at the bottom of the form must be completed to submit the form.', validation_error_1.errorTypes.global));
    }
    // Currently, only requirement across the form is maximum total attachment size limit
    if (elements && !!form.maxTotalAttachmentSize) {
        var formAttachmentsSize = 0;
        elements.forEach(function (element) {
            if (!!value) { // do not perform validation against a value if there is no value present
                var response = value.get(element.id);
                if (!element.disabled && !element.hidden && response !== undefined && response !== null && response !== "" &&
                    (!immutable_1.List.isList(response) || response.size > 0) && formAttachmentsSize <= form.maxTotalAttachmentSize) {
                    switch (element.type) {
                        case form_definition_1.elementTypes.attachment:
                            var files = response.get('files');
                            var numFiles = response.get('fileCount');
                            if (files !== null && files !== undefined && !!files.size && files.size > 0) {
                                var filesUploaded = response.get('completedUploads');
                                var isUploading = files.some(function (file) { return file.get('isUploading'); });
                                if (isUploading || (numFiles - filesUploaded !== 0 || numFiles !== files.size)) {
                                    return;
                                }
                                var file, i;
                                for (i = 0; i < numFiles; i++) {
                                    file = files.get(i);
                                    formAttachmentsSize += file.get('size');
                                    if (formAttachmentsSize > form.maxTotalAttachmentSize) {
                                        passedValidation = false;
                                        errors.push(validation_error_1.validationError('0', '', 'form-element', errors.length, "The combined files exceeded the maximum form upload size of " + utilities_1.numberUtilities.formatBytesForString(form.maxTotalAttachmentSize) + ".", validation_error_1.errorTypes.global));
                                        return;
                                    }
                                }
                            }
                            break;
                        default: break;
                    }
                }
            }
        }, this);
    }
    return state.set('validationResult', new form_definition_1.ValidationResult({
        passedValidation: validationResult.passedValidation && passedValidation,
        errors: validationResult.errors.concat(errors).toList()
    }));
}
exports.validateForm = validateForm;
/**
 * This function runs validation on a particular group element
 * This will evaluate all the subElements of the group, taking into account any modifications made by the group's properties
 * @param element group element definition
 * @param state the forms state
 * @param requireCompletion if true, this group will evaluate to not empty regardless of the value returned by hasEmptyValue
 * @returns a validation result, representing the validation of this group element
 */
function validateGroupValue(element, state, requireCompletion, country, parentElement) {
    if (requireCompletion === void 0) { requireCompletion = false; }
    var passedValidation = true;
    var errors = [];
    if (!element.hidden && !element.disabled && element.subElementsList) {
        var emptyGroup = form_definition_1.hasEmptyValue(element, null, state);
        var requiredDefinition = element.immutableRequiredDefinition || new form_elements_1.ImmutableBasicRequiredDefinition({});
        var completionRequired_1 = requireCompletion ? true : !emptyGroup && requiredDefinition.requireCompleteResponse;
        if (requiredDefinition.type === form_constants_1.requireType.ANY && emptyGroup && element.isRequired && element.subElementsList.size > 0) {
            passedValidation = false;
            errors.push(elementError(element, "A response is required for at least one of these elements.", 'form-element', errors.length, parentElement));
        }
        element.subElementsList.forEach(function (subElement) {
            var isSubElementRequired = form_definition_1.isSubElementRequiredByGroup(element, subElement);
            if (completionRequired_1 && !element.isRequired && subElement.type !== form_definition_1.elementTypes.group &&
                isSubElementRequired && form_definition_1.hasEmptyValue(subElement, form_definition_1.getValue(state, subElement.id), state) &&
                !subElement.hidden && !subElement.disabled) {
                passedValidation = false;
                errors.push(incompleteResponseError(subElement, 'form-element', errors.length, element));
            }
            var modifiedSubElement = form_definition_1.getModifiedSubElement(element, subElement);
            var elementValidation = validateFormElement(country, state, modifiedSubElement, element, completionRequired_1 && isSubElementRequired);
            passedValidation = elementValidation.passedValidation && passedValidation;
            errors.push.apply(errors, elementValidation.errors.toArray());
        }, this);
    }
    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
}
exports.validateGroupValue = validateGroupValue;
/**
 * This function runs validation on a particular time element, given the value
 * @param element time element definition
 * @param value value of the time element
 * @returns a validation result, representing the validation of this individual time element
 */
function validateTimeValue(element, value) {
    var passedValidation = true;
    var errors = [];
    var required = element.isRequired && !element.disabled && !element.hidden;
    var type = typeof (value);
    var expectedType = "object";
    if (type !== expectedType) {
        passedValidation = false;
        errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, expectedType));
        return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
    }
    var timeValue = value;
    var numHours = parseInt(timeValue.hour, 10);
    var numMins = parseInt(timeValue.minute, 10);
    if ((timeValue.hour && !timeValue.minute) || (!timeValue.hour && timeValue.minute)) {
        passedValidation = false;
        var subSection = timeValue.hour ? 'minute' : 'hour';
        errors.push(incompleteSelectionError(element, subSection, 'form-element', errors.length));
    }
    if (timeValue.minute && (isNaN(numMins) || numMins < 0 || numMins > 59)) {
        passedValidation = false;
        errors.push(invalidSelectionError(element, 'minute', 'form-element', errors.length, "[0-59]"));
    }
    if (element.isMilitaryTime) {
        if (timeValue.hour && (isNaN(numHours) || numHours < 0 || numHours > 23)) {
            passedValidation = false;
            errors.push(invalidSelectionError(element, 'hour', 'form-element', errors.length, "[0-23]"));
        }
        if (timeValue.period) {
            passedValidation = false;
            errors.push(invalidSelectionError(element, 'period', 'form-element', errors.length, "[\"\"]"));
        }
    }
    else {
        if (timeValue.hour && (isNaN(numHours) || numHours < 1 || numHours > 12)) {
            passedValidation = false;
            errors.push(invalidSelectionError(element, 'hour', 'form-element', errors.length, "[1-12]"));
        }
        if (!timeValue.period || (timeValue.period && timeValue.period !== 'AM' && timeValue.period !== 'PM')) {
            passedValidation = false;
            errors.push(invalidSelectionError(element, 'period', 'form-element', errors.length, "[AM, PM]"));
        }
    }
    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
}
exports.validateTimeValue = validateTimeValue;
/**
 * This function runs validation on a particular specialized text element, given the value.
 * It checks to see if the length requirements of the text are met, and that only valid characters are used.
 * @param element specialized text element definition
 * @param value value of the specialized text element
 * @returns a validation result, representing the validation of this individual specialized text element
 */
function validateSpecializedTextValue(element, value) {
    var passedValidation = true;
    var errors = [];
    var type = typeof (value);
    if (type !== 'string') {
        passedValidation = false;
        errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
        return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
    }
    var textResponse = value;
    // text length validation
    var isMinLimit = element.minCharLength !== undefined && element.minCharLength !== null;
    var isMaxLimit = element.maxCharLength !== undefined && element.maxCharLength !== null;
    if (isMinLimit && isMaxLimit && element.minCharLength === element.maxCharLength && textResponse.length !== element.minCharLength) {
        passedValidation = false;
        var charLengthErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "The response must have exactly " + element.minCharLength + " characters.", validation_error_1.errorTypes.inline);
        errors.push(charLengthErr);
    }
    else if (isMinLimit && textResponse.length < element.minCharLength) {
        passedValidation = false;
        var charLengthErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "The response must have at least " + element.minCharLength + " characters.", validation_error_1.errorTypes.inline);
        errors.push(charLengthErr);
    }
    else if (isMaxLimit && textResponse.length > element.maxCharLength) {
        passedValidation = false;
        var charLengthErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "The response cannot have more than " + element.maxCharLength + " characters.", validation_error_1.errorTypes.inline);
        errors.push(charLengthErr);
    }
    // text content validation
    switch (element.textType) {
        case form_definition_1.specialTextTypes.NUMERIC:
            {
                var regex = RegExp('[^0-9]', 'g');
                if (regex.test(textResponse)) {
                    passedValidation = false;
                    var charLengthErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "The response should only contain numbers.", validation_error_1.errorTypes.inline);
                    errors.push(charLengthErr);
                }
            }
            break;
        case form_definition_1.specialTextTypes.ALPHA:
            {
                var regex = RegExp('[^A-Za-z]', 'g');
                if (regex.test(textResponse)) {
                    passedValidation = false;
                    var charLengthErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "The response should only contain letters.", validation_error_1.errorTypes.inline);
                    errors.push(charLengthErr);
                }
            }
            break;
        case form_definition_1.specialTextTypes.ALPHA_NUMERIC:
            {
                var regex = RegExp('[^A-Za-z0-9_]', 'g');
                if (regex.test(textResponse)) {
                    passedValidation = false;
                    var charLengthErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "The response should only contain alpha numeric characters.", validation_error_1.errorTypes.inline);
                    errors.push(charLengthErr);
                }
            }
            break;
        case form_definition_1.specialTextTypes.ANY:
        default: break;
    }
    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
}
exports.validateSpecializedTextValue = validateSpecializedTextValue;
//# sourceMappingURL=run-validation.js.map

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".CalendarDay {\n  border: 1px solid #e4e7e7;\n  padding: 0;\n  box-sizing: border-box;\n  color: #565a5c;\n  cursor: pointer; }\n\n.CalendarDay__button {\n  position: relative;\n  height: 100%;\n  width: 100%;\n  text-align: center;\n  background: none;\n  border: 0;\n  margin: 0;\n  padding: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  box-sizing: border-box; }\n  .CalendarDay__button:active {\n    outline: 0; }\n\n.CalendarDay--highlighted-calendar {\n  background: #ffe8bc;\n  color: #565a5c;\n  cursor: default; }\n  .CalendarDay--highlighted-calendar:active {\n    background: #007a87; }\n\n.CalendarDay--outside {\n  border: 0;\n  cursor: default; }\n  .CalendarDay--outside:active {\n    background: #fff; }\n\n.CalendarDay--hovered {\n  background: #e4e7e7;\n  border: 1px double #d4d9d9;\n  color: inherit; }\n\n.CalendarDay--blocked-minimum-nights {\n  color: #cacccd;\n  background: #fff;\n  border: 1px solid #e4e7e7;\n  cursor: default; }\n  .CalendarDay--blocked-minimum-nights:active {\n    background: #fff; }\n\n.CalendarDay--selected-span {\n  background: #66e2da;\n  border: 1px double #33dacd;\n  color: #fff; }\n  .CalendarDay--selected-span.CalendarDay--hovered, .CalendarDay--selected-span:active {\n    background: #33dacd;\n    border: 1px double #00a699; }\n  .CalendarDay--selected-span.CalendarDay--last-in-range {\n    border-right: #00a699; }\n\n.CalendarDay--hovered-span,\n.CalendarDay--after-hovered-start {\n  background: #b2f1ec;\n  border: 1px double #80e8e0;\n  color: #007a87; }\n  .CalendarDay--hovered-span:active,\n  .CalendarDay--after-hovered-start:active {\n    background: #80e8e0; }\n\n.CalendarDay--selected-start,\n.CalendarDay--selected-end,\n.CalendarDay--selected {\n  background: #00a699;\n  border: 1px double #00a699;\n  color: #fff; }\n  .CalendarDay--selected-start:active,\n  .CalendarDay--selected-end:active,\n  .CalendarDay--selected:active {\n    background: #00a699; }\n\n.CalendarDay--blocked-calendar {\n  background: #cacccd;\n  color: #82888a;\n  cursor: default; }\n  .CalendarDay--blocked-calendar:active {\n    background: #cacccd; }\n\n.CalendarDay--blocked-out-of-range {\n  color: #cacccd;\n  background: #fff;\n  border: 1px solid #e4e7e7;\n  cursor: default; }\n  .CalendarDay--blocked-out-of-range:active {\n    background: #fff; }\n\n.CalendarMonth {\n  text-align: center;\n  padding: 0 13px;\n  vertical-align: top;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n  .CalendarMonth table {\n    border-collapse: collapse;\n    border-spacing: 0;\n    caption-caption-side: initial; }\n\n.CalendarMonth--horizontal:first-of-type,\n.CalendarMonth--vertical:first-of-type {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n  pointer-events: none; }\n\n.CalendarMonth--horizontal {\n  display: inline-block;\n  min-height: 100%; }\n\n.CalendarMonth--vertical {\n  display: block; }\n\n.CalendarMonth__caption {\n  color: #3c3f40;\n  margin-top: 7px;\n  font-size: 18px;\n  text-align: center;\n  margin-bottom: 2px;\n  caption-side: initial; }\n\n.CalendarMonth--horizontal .CalendarMonth__caption,\n.CalendarMonth--vertical .CalendarMonth__caption {\n  padding: 15px 0 35px; }\n\n.CalendarMonth--vertical-scrollable .CalendarMonth__caption {\n  padding: 5px 0; }\n\n.CalendarMonthGrid {\n  background: #fff;\n  z-index: 0;\n  text-align: left; }\n\n.CalendarMonthGrid--animating {\n  -webkit-transition: -webkit-transform 0.2s ease-in-out;\n  -moz-transition: -moz-transform 0.2s ease-in-out;\n  transition: transform 0.2s ease-in-out;\n  z-index: 1; }\n\n.CalendarMonthGrid--horizontal {\n  position: absolute;\n  left: 9px; }\n\n.CalendarMonthGrid--vertical {\n  margin: 0 auto; }\n\n.CalendarMonthGrid--vertical-scrollable {\n  margin: 0 auto;\n  overflow-y: scroll; }\n\n.DayPicker {\n  background: #fff;\n  position: relative;\n  text-align: left; }\n\n.DayPicker--horizontal {\n  background: #fff;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05), 0 0 0 1px rgba(0, 0, 0, 0.07);\n  border-radius: 3px; }\n  .DayPicker--horizontal.DayPicker--portal {\n    box-shadow: none;\n    position: absolute;\n    left: 50%;\n    top: 50%; }\n\n.DayPicker--vertical.DayPicker--portal {\n  position: initial; }\n\n.DayPicker__focus-region {\n  outline: none; }\n\n.DayPicker__week-headers {\n  position: relative; }\n\n.DayPicker--horizontal .DayPicker__week-headers {\n  margin-left: 9px; }\n\n.DayPicker__week-header {\n  color: #757575;\n  position: absolute;\n  top: 62px;\n  z-index: 2;\n  padding: 0 13px;\n  text-align: left; }\n  .DayPicker__week-header ul {\n    list-style: none;\n    margin: 1px 0;\n    padding-left: 0;\n    padding-right: 0; }\n  .DayPicker__week-header li {\n    display: inline-block;\n    text-align: center; }\n\n.DayPicker--vertical .DayPicker__week-header {\n  left: 50%; }\n\n.DayPicker--vertical-scrollable {\n  height: 100%; }\n  .DayPicker--vertical-scrollable .DayPicker__week-header {\n    top: 0;\n    display: table-row;\n    border-bottom: 1px solid #dbdbdb;\n    background: white; }\n  .DayPicker--vertical-scrollable .transition-container--vertical {\n    padding-top: 20px;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    overflow-y: scroll; }\n  .DayPicker--vertical-scrollable .DayPicker__week-header {\n    margin-left: 0;\n    left: 0;\n    width: 100%;\n    text-align: center; }\n\n.transition-container {\n  position: relative;\n  overflow: hidden;\n  border-radius: 3px; }\n\n.transition-container--horizontal {\n  transition: height 0.2s ease-in-out; }\n\n.transition-container--vertical {\n  width: 100%; }\n\n.DayPickerNavigation__prev,\n.DayPickerNavigation__next {\n  cursor: pointer;\n  line-height: 0.78;\n  -webkit-user-select: none;\n  /* Chrome/Safari */\n  -moz-user-select: none;\n  /* Firefox */\n  -ms-user-select: none;\n  /* IE10+ */\n  user-select: none; }\n\n.DayPickerNavigation__prev--default,\n.DayPickerNavigation__next--default {\n  border: 1px solid #dce0e0;\n  background-color: #fff;\n  color: #757575; }\n  .DayPickerNavigation__prev--default:focus, .DayPickerNavigation__prev--default:hover,\n  .DayPickerNavigation__next--default:focus,\n  .DayPickerNavigation__next--default:hover {\n    border: 1px solid #c4c4c4; }\n  .DayPickerNavigation__prev--default:active,\n  .DayPickerNavigation__next--default:active {\n    background: #f2f2f2; }\n\n.DayPickerNavigation--horizontal {\n  position: relative; }\n  .DayPickerNavigation--horizontal .DayPickerNavigation__prev,\n  .DayPickerNavigation--horizontal .DayPickerNavigation__next {\n    border-radius: 3px;\n    padding: 6px 9px;\n    top: 18px;\n    z-index: 2;\n    position: absolute; }\n  .DayPickerNavigation--horizontal .DayPickerNavigation__prev {\n    left: 22px; }\n  .DayPickerNavigation--horizontal .DayPickerNavigation__prev--rtl {\n    left: auto;\n    right: 22px; }\n  .DayPickerNavigation--horizontal .DayPickerNavigation__next {\n    right: 22px; }\n  .DayPickerNavigation--horizontal .DayPickerNavigation__next--rtl {\n    right: auto;\n    left: 22px; }\n  .DayPickerNavigation--horizontal .DayPickerNavigation__prev--default svg,\n  .DayPickerNavigation--horizontal .DayPickerNavigation__next--default svg {\n    height: 19px;\n    width: 19px;\n    fill: #82888a; }\n\n.DayPickerNavigation--vertical {\n  background: #fff;\n  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 52px;\n  width: 100%;\n  z-index: 2; }\n  .DayPickerNavigation--vertical .DayPickerNavigation__prev,\n  .DayPickerNavigation--vertical .DayPickerNavigation__next {\n    display: inline-block;\n    position: relative;\n    height: 100%;\n    width: 50%; }\n  .DayPickerNavigation--vertical .DayPickerNavigation__next--default {\n    border-left: 0; }\n  .DayPickerNavigation--vertical .DayPickerNavigation__prev--default,\n  .DayPickerNavigation--vertical .DayPickerNavigation__next--default {\n    text-align: center;\n    font-size: 2.5em;\n    padding: 5px; }\n    .DayPickerNavigation--vertical .DayPickerNavigation__prev--default svg,\n    .DayPickerNavigation--vertical .DayPickerNavigation__next--default svg {\n      height: 42px;\n      width: 42px;\n      fill: #484848; }\n\n.DayPickerNavigation--vertical-scrollable {\n  position: relative; }\n  .DayPickerNavigation--vertical-scrollable .DayPickerNavigation__next {\n    width: 100%; }\n\n.DayPickerKeyboardShortcuts__show,\n.DayPickerKeyboardShortcuts__close {\n  background: none;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  padding: 0;\n  cursor: pointer; }\n  .DayPickerKeyboardShortcuts__show:active,\n  .DayPickerKeyboardShortcuts__close:active {\n    outline: none; }\n\n.DayPickerKeyboardShortcuts__show {\n  width: 22px;\n  position: absolute;\n  z-index: 2; }\n\n.DayPickerKeyboardShortcuts__show--bottom-right {\n  border-top: 26px solid transparent;\n  border-right: 33px solid #00a699;\n  bottom: 0;\n  right: 0; }\n  .DayPickerKeyboardShortcuts__show--bottom-right:hover {\n    border-right: 33px solid #008489; }\n  .DayPickerKeyboardShortcuts__show--bottom-right .DayPickerKeyboardShortcuts__show_span {\n    bottom: 0;\n    right: -28px; }\n\n.DayPickerKeyboardShortcuts__show--top-right {\n  border-bottom: 26px solid transparent;\n  border-right: 33px solid #00a699;\n  top: 0;\n  right: 0; }\n  .DayPickerKeyboardShortcuts__show--top-right:hover {\n    border-right: 33px solid #008489; }\n  .DayPickerKeyboardShortcuts__show--top-right .DayPickerKeyboardShortcuts__show_span {\n    top: 1px;\n    right: -28px; }\n\n.DayPickerKeyboardShortcuts__show--top-left {\n  border-bottom: 26px solid transparent;\n  border-left: 33px solid #00a699;\n  top: 0;\n  left: 0; }\n  .DayPickerKeyboardShortcuts__show--top-left:hover {\n    border-left: 33px solid #008489; }\n  .DayPickerKeyboardShortcuts__show--top-left .DayPickerKeyboardShortcuts__show_span {\n    top: 1px;\n    left: -28px; }\n\n.DayPickerKeyboardShortcuts__show_span {\n  color: #fff;\n  position: absolute; }\n\n.DayPickerKeyboardShortcuts__panel {\n  overflow: auto;\n  background: #fff;\n  border: 1px solid #dbdbdb;\n  border-radius: 2px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 2;\n  padding: 22px;\n  margin: 33px; }\n\n.DayPickerKeyboardShortcuts__title {\n  font-size: 16px;\n  font-weight: bold;\n  margin: 0; }\n\n.DayPickerKeyboardShortcuts__list {\n  list-style: none;\n  padding: 0; }\n\n.DayPickerKeyboardShortcuts__close {\n  position: absolute;\n  right: 22px;\n  top: 22px;\n  z-index: 2; }\n  .DayPickerKeyboardShortcuts__close svg {\n    height: 15px;\n    width: 15px;\n    fill: #cacccd; }\n    .DayPickerKeyboardShortcuts__close svg:hover, .DayPickerKeyboardShortcuts__close svg:focus {\n      fill: #82888a; }\n  .DayPickerKeyboardShortcuts__close:active {\n    outline: none; }\n\n.KeyboardShortcutRow {\n  margin: 6px 0; }\n\n.KeyboardShortcutRow__key-container {\n  display: inline-block;\n  white-space: nowrap;\n  text-align: right;\n  margin-right: 6px; }\n\n.KeyboardShortcutRow__key {\n  font-family: monospace;\n  font-size: 12px;\n  text-transform: uppercase;\n  background: #f2f2f2;\n  padding: 2px 6px; }\n\n.KeyboardShortcutRow__action {\n  display: inline;\n  word-break: break-word;\n  margin-left: 8px; }\n\n.DayPickerKeyboardShortcuts__panel--block .KeyboardShortcutRow {\n  margin-bottom: 16px; }\n\n.DayPickerKeyboardShortcuts__panel--block .KeyboardShortcutRow__key-container {\n  width: auto;\n  text-align: left;\n  display: inline; }\n\n.DayPickerKeyboardShortcuts__panel--block .KeyboardShortcutRow__action {\n  display: inline; }\n\n.DateInput {\n  font-weight: 200;\n  font-size: 18px;\n  line-height: 24px;\n  color: #757575;\n  margin: 0;\n  padding: 8px;\n  background: #fff;\n  position: relative;\n  display: inline-block;\n  width: 130px;\n  vertical-align: middle; }\n\n.DateInput--with-caret::before,\n.DateInput--with-caret::after {\n  content: \"\";\n  display: inline-block;\n  position: absolute;\n  bottom: auto;\n  border: 10px solid transparent;\n  border-top: 0;\n  left: 22px;\n  z-index: 2; }\n\n.DateInput--with-caret::before {\n  top: 62px;\n  border-bottom-color: rgba(0, 0, 0, 0.1); }\n\n.DateInput--with-caret::after {\n  top: 63px;\n  border-bottom-color: #fff; }\n\n.DateInput--disabled {\n  background: #cacccd; }\n\n.DateInput__input {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border: 0;\n  height: 100%;\n  width: 100%; }\n  .DateInput__input[readonly] {\n    -moz-user-select: none;\n    -webkit-user-select: none;\n    -ms-user-select: none;\n    user-select: none; }\n\n.DateInput__display-text {\n  padding: 4px 8px;\n  white-space: nowrap;\n  overflow: hidden; }\n\n.DateInput__display-text--has-input {\n  color: #484848; }\n\n.DateInput__display-text--focused {\n  background: #99ede6;\n  border-color: #99ede6;\n  border-radius: 3px;\n  color: #007a87; }\n\n.DateInput__display-text--disabled {\n  font-style: italic; }\n\n.screen-reader-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.DateRangePicker {\n  position: relative;\n  display: inline-block; }\n\n.DateRangePicker__picker {\n  z-index: 1;\n  background-color: #fff;\n  position: absolute;\n  top: 72px; }\n\n.DateRangePicker__picker--rtl {\n  direction: rtl; }\n\n.DateRangePicker__picker--direction-left {\n  left: 0; }\n\n.DateRangePicker__picker--direction-right {\n  right: 0; }\n\n.DateRangePicker__picker--portal {\n  background-color: rgba(0, 0, 0, 0.3);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%; }\n\n.DateRangePicker__picker--full-screen-portal {\n  background-color: #fff; }\n\n.DateRangePicker__close {\n  background: none;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  padding: 0;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 15px;\n  z-index: 2; }\n  .DateRangePicker__close svg {\n    height: 15px;\n    width: 15px;\n    fill: #cacccd; }\n  .DateRangePicker__close:hover, .DateRangePicker__close:focus {\n    color: #b0b3b4;\n    text-decoration: none; }\n\n.DateRangePickerInput {\n  background-color: #fff;\n  border: 1px solid #cacccd;\n  display: inline-block; }\n\n.DateRangePickerInput--disabled {\n  background: #cacccd; }\n\n.DateRangePickerInput--rtl {\n  direction: rtl; }\n\n.DateRangePickerInput__arrow {\n  display: inline-block;\n  vertical-align: middle; }\n\n.DateRangePickerInput__arrow svg {\n  vertical-align: middle;\n  fill: #484848;\n  height: 24px;\n  width: 24px; }\n\n.DateRangePickerInput__clear-dates {\n  background: none;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 10px;\n  margin: 0 10px 0 5px; }\n\n.DateRangePickerInput__clear-dates svg {\n  fill: #82888a;\n  height: 12px;\n  width: 15px;\n  vertical-align: middle; }\n\n.DateRangePickerInput__clear-dates--hide {\n  visibility: hidden; }\n\n.DateRangePickerInput__clear-dates:focus,\n.DateRangePickerInput__clear-dates--hover {\n  background: #dbdbdb;\n  border-radius: 50%; }\n\n.DateRangePickerInput__calendar-icon {\n  background: none;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 10px;\n  margin: 0 5px 0 10px; }\n  .DateRangePickerInput__calendar-icon svg {\n    fill: #82888a;\n    height: 15px;\n    width: 14px;\n    vertical-align: middle; }\n\n.SingleDatePicker {\n  position: relative;\n  display: inline-block; }\n\n.SingleDatePicker__picker {\n  z-index: 1;\n  background-color: #fff;\n  position: absolute;\n  top: 72px; }\n\n.SingleDatePicker__picker--rtl {\n  direction: rtl; }\n\n.SingleDatePicker__picker--direction-left {\n  left: 0; }\n\n.SingleDatePicker__picker--direction-right {\n  right: 0; }\n\n.SingleDatePicker__picker--portal {\n  background-color: rgba(0, 0, 0, 0.3);\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%; }\n\n.SingleDatePicker__picker--full-screen-portal {\n  background-color: #fff; }\n\n.SingleDatePicker__close {\n  background: none;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  padding: 0;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 15px;\n  z-index: 2; }\n  .SingleDatePicker__close svg {\n    height: 15px;\n    width: 15px;\n    fill: #cacccd; }\n  .SingleDatePicker__close:hover, .SingleDatePicker__close:focus {\n    color: #b0b3b4;\n    text-decoration: none; }\n\n.SingleDatePickerInput {\n  background-color: #fff;\n  border: 1px solid #dbdbdb; }\n\n.SingleDatePickerInput--rtl {\n  direction: rtl; }\n\n.SingleDatePickerInput__clear-date {\n  background: none;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 10px;\n  margin: 0 10px 0 5px; }\n\n.SingleDatePickerInput__clear-date svg {\n  fill: #82888a;\n  height: 12px;\n  width: 15px;\n  vertical-align: middle; }\n\n.SingleDatePickerInput__clear-date--hide {\n  visibility: hidden; }\n\n.SingleDatePickerInput__clear-date:focus,\n.SingleDatePickerInput__clear-date--hover {\n  background: #dbdbdb;\n  border-radius: 50%; }\n\n.SingleDatePickerInput__calendar-icon {\n  background: none;\n  border: 0;\n  color: inherit;\n  font: inherit;\n  line-height: normal;\n  overflow: visible;\n  cursor: pointer;\n  display: inline-block;\n  vertical-align: middle;\n  padding: 10px;\n  margin: 0 5px 0 10px; }\n  .SingleDatePickerInput__calendar-icon svg {\n    fill: #82888a;\n    height: 15px;\n    width: 14px;\n    vertical-align: middle; }\n", ""]);

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-collapsible-error-display {\n  width: 100%;\n  text-align: left;\n  color: #C70000;\n  background-color: #F8D9D9;\n  border-bottom: 1px solid #C70000;\n  padding: 10px 10px 10px 20px;\n  margin-bottom: 20px; }\n  .ssg-forms-collapsible-error-display.ssg-forms-text {\n    color: #C70000; }\n  .ssg-forms-collapsible-error-display ul ul {\n    list-style-type: disc; }\n  .ssg-forms-collapsible-error-display a {\n    color: #C70000;\n    text-decoration: underline; }\n    .ssg-forms-collapsible-error-display a:hover, .ssg-forms-collapsible-error-display a:focus {\n      color: #8a0000; }\n\n.ssg-forms-collapsible-error-collapsed-display {\n  display: flex; }\n\n.ssg-forms-collapsible-error-collapsed-error-text {\n  flex-grow: 1;\n  display: flex; }\n\n.ssg-forms-collapsible-error-collapse-button {\n  float: right;\n  border: none;\n  background: transparent;\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  color: #5a5b5e;\n  cursor: pointer; }\n\n.ssg-forms-collapsible-error-error-summary-text {\n  margin-left: 5px;\n  font-weight: normal;\n  flex-grow: 1; }\n  .ssg-forms-collapsible-error-error-summary-text .ssg-forms-collapsible-error-count {\n    font-weight: bold; }\n\n.ssg-forms-collapsible-error-error-section {\n  font-weight: bold; }\n\n.ssg-forms-collapsible-error-error {\n  margin: 2px; }\n\n.ssg-forms-collapsible-error-error-text {\n  margin-left: 5px;\n  font-size: 16px;\n  line-height: 22px; }\n\n.ssg-forms-collapsible-error-error-button {\n  width: 32px;\n  height: 32px; }\n\n.ssg-forms-collapsible-error-error-icon {\n  color: #C70000;\n  width: 16px;\n  height: 16px; }\n\n.ssg-forms-collapsible-error-collapse-button-text {\n  display: inline;\n  margin-right: 10px; }\n\n@media (max-width: 768px) {\n  .ssg-forms-collapsible-error-collapse-button-text {\n    display: none; } }\n", ""]);

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".form-validation-error-wrapper {\n  background-color: #F8D9D9;\n  border-bottom: 1px solid #C70000;\n  font-size: 16px;\n  text-align: center; }\n\n.form-validation-error-section {\n  display: inline-block;\n  text-align: left;\n  max-width: 80%;\n  font-family: \"graphik\", sans-serif;\n  color: #C70000;\n  line-height: 22px; }\n", ""]);

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-inline-error {\n  color: #C70000;\n  font-family: \"graphik\", sans-serif;\n  font-size: 12px;\n  line-height: 17px;\n  padding-top: 5px; }\n\n.ssg-inline-error-text {\n  padding-left: 5px; }\n\n.validated-section input.validated-input:focus ~ .ssg-inline-error {\n  display: none; }\n\n.validated-section select.validated-select:focus ~ .ssg-inline-error {\n  display: none; }\n\n.warning-list ul {\n  list-style-position: inside; }\n\n.warning-list li {\n  margin-left: 30px; }\n", ""]);

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-attached-file {\n  position: relative;\n  padding: 5px 10px;\n  margin-bottom: 2px;\n  background-color: #f2f2f2;\n  color: #1F8475; }\n  .ssg-attached-file .ssg-fileName {\n    display: inline-block;\n    vertical-align: middle;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    padding-left: 10px;\n    padding-right: 5px;\n    color: #1F8475; }\n\n.ssg-attachment-delete-button {\n  height: 28px;\n  width: 28px;\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translate(0%, -50%); }\n\n.ssg-attach-button {\n  margin-top: 8px; }\n\n.ssg-attachment-link-text {\n  text-overflow: ellipsis;\n  overflow-x: hidden; }\n", ""]);

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-checkbox-label-legend {\n  margin-bottom: 0px; }\n\n.ssg-checkbox-choice-wrapper-content {\n  padding-top: 10px; }\n\n.ssg-checkbox-fieldset {\n  position: relative;\n  margin-top: 5px; }\n\n.ssg-checkbox-choice-wrapper {\n  clear: both;\n  vertical-align: middle; }\n\n.ssg-checkbox-choice-label {\n  cursor: pointer;\n  font-weight: normal;\n  letter-spacing: 0.5px;\n  margin-bottom: 8px; }\n  .ssg-checkbox-choice-label.disabled, .ssg-checkbox-choice-label:disabled {\n    color: #CCCCCC;\n    cursor: not-allowed; }\n  .ssg-checkbox-choice-label.just-read {\n    cursor: not-allowed; }\n\ninput[type=checkbox].ssg-checkbox-input {\n  border: 2px solid #003D50;\n  width: 18px;\n  height: 18px;\n  vertical-align: middle;\n  margin: 0px 20px 0px 10px; }\n  input[type=checkbox].ssg-checkbox-input.disabled, input[type=checkbox].ssg-checkbox-input:disabled {\n    color: #CCCCCC; }\n  input[type=checkbox].ssg-checkbox-input.readonly, input[type=checkbox].ssg-checkbox-input.just-read {\n    color: #CCCCCC;\n    opacity: 0.5; }\n  input[type=checkbox].ssg-checkbox-input:read-only {\n    color: #CCCCCC;\n    opacity: 0.5; }\n  input[type=checkbox].ssg-checkbox-input:hover {\n    cursor: pointer; }\n    input[type=checkbox].ssg-checkbox-input:hover.disabled, input[type=checkbox].ssg-checkbox-input:hover:disabled {\n      cursor: not-allowed; }\n    input[type=checkbox].ssg-checkbox-input:hover.just-read {\n      cursor: not-allowed; }\n", ""]);

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".CalendarDay {\n  border: 1px solid #CCCCCC;\n  color: #003D50; }\n  .CalendarDay.CalendarDay--today {\n    border: 1px solid #1F8475;\n    background-color: #FFFFFF;\n    color: #003D50; }\n  .CalendarDay.CalendarDay--blocked-calendar {\n    background-color: white;\n    color: #CCCCCC;\n    cursor: not-allowed; }\n    .CalendarDay.CalendarDay--blocked-calendar:hover {\n      border: 1px solid #CCCCCC;\n      background-color: white;\n      color: #CCCCCC; }\n  .CalendarDay.CalendarDay--selected {\n    background-color: #1F8475;\n    border: 1px solid #1F8475;\n    color: white; }\n  .CalendarDay:hover {\n    border: 1px solid #CCCCCC;\n    background-color: #F9ECC8;\n    color: #003D50; }\n\n.CalendarMonth__caption {\n  caption-side: top; }\n\n.DayPickerKeyboardShortcuts__panel {\n  overflow: visible;\n  min-height: 110%; }\n\n.anchor {\n  position: relative; }\n  .anchor .calendar {\n    position: absolute;\n    z-index: 10; }\n\n@media (min-width: 769px) {\n  .input-group .date-element {\n    width: 125px; } }\n", ""]);

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".signPad {\n  float: top;\n  cursor: crosshair;\n  touch-action: manipulation;\n  margin-bottom: 10px; }\n  .signPad.hidden {\n    display: none; }\n  .signPad.drawing-completed {\n    cursor: default; }\n  .signPad.readonly {\n    cursor: wait; }\n  .signPad .path {\n    fill: none;\n    stroke-width: 1px;\n    stroke: #000000;\n    stroke-linejoin: round;\n    stroke-linecap: round; }\n    .signPad .path.drawing-completed {\n      stroke: #000000; }\n\n.canvasPad {\n  width: 100%;\n  margin-bottom: 10px; }\n  .canvasPad.hidden {\n    display: none; }\n\n.ssg-esig-button-area {\n  clear: both; }\n  .ssg-esig-button-area.hidden {\n    display: none; }\n  .ssg-esig-button-area.readonly {\n    opacity: 75%; }\n  .ssg-esig-button-area .ssg-forms-btn {\n    margin-right: 10px; }\n\n.drawing {\n  width: 100%;\n  height: 100%; }\n\n.ssg-signature-position {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0; }\n\n.ssg-signature-button {\n  margin-top: 10px; }\n", ""]);

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".email-notification-element-collapsible-section {\n  width: 100%; }\n\n.ssg-forms-input-group .email-notification-element-collapsible-section {\n  position: relative;\n  flex: 1 1 auto;\n  width: 1%; }\n\n.email-notification-element-body {\n  white-space: pre-wrap;\n  overflow: hidden; }\n\n.email-notification-element-email-parts {\n  margin-bottom: 10px; }\n\n.email-notification-element-error-text.ssg-forms-text {\n  color: #C70000;\n  margin-bottom: 20px; }\n\n.email-notification-element-error-text span {\n  margin-left: 10px; }\n", ""]);

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-unsupported-warning {\n  padding: 10px;\n  background-color: #FFEBBD;\n  color: #9F7417;\n  border-radius: 3px;\n  margin-bottom: 10px; }\n\n.ssg-forms-unsupported-icon {\n  margin-right: 10px; }\n", ""]);

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".input-gis:disabled {\n  flex: 1 1 0;\n  color: #003D50;\n  background-color: #CCCCCC; }\n\n.input-gis:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-right: 0; }\n\n.button-gis {\n  flex: 0 0 auto;\n  border-color: #1F8475;\n  color: #1F8475;\n  letter-spacing: 0.5px; }\n\n.input-gis + .button-gis {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0; }\n", ""]);

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, "@import url(https://use.typekit.net/jxi2cmo.css);", ""]);
exports.push([module.i, "\n.ssg-forms-no-focus:focus {\n  outline: 0px solid transparent; }\n\n.ssg-forms-skip {\n  position: absolute;\n  left: -200%;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden; }\n  .ssg-forms-skip:focus {\n    position: static;\n    width: auto;\n    height: auto; }\n\n.ssg-forms-hidden {\n  display: none; }\n\n.ssg-forms-spin {\n  animation: spin 2s linear infinite;\n  z-index: 2;\n  width: 18px;\n  height: 18px; }\n  .ssg-forms-spin .path {\n    stroke: #20907f;\n    stroke-linecap: round;\n    animation: dash 1.5s ease-in-out infinite; }\n\n@keyframes spin {\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes dash {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0; }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35; }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124; } }\n\n.ssg-forms-fade-out {\n  opacity: 0;\n  animation-name: fade-out;\n  animation-duration: 2000ms;\n  animation-iteration-count: 1;\n  animation-timing-function: linear; }\n\n@keyframes fade-out {\n  from {\n    opacity: 1; }\n  to {\n    opacity: 0; } }\n\n.ssg-forms-fade-in {\n  animation-name: fade-in;\n  animation-duration: 2000ms;\n  animation-iteration-count: 1;\n  animation-timing-function: linear; }\n\n@keyframes fade-in {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.ssg-forms-dark-actions {\n  text-align: right;\n  background-color: #003D50;\n  padding: 10px; }\n  .ssg-forms-dark-actions .ssg-forms-btn {\n    margin: 0px 0px 0px 10px;\n    color: white;\n    background-color: #003D50; }\n    .ssg-forms-dark-actions .ssg-forms-btn:first-child {\n      margin-left: 0px; }\n    .ssg-forms-dark-actions .ssg-forms-btn:active, .ssg-forms-dark-actions .ssg-forms-btn:hover {\n      background-color: rgba(255, 255, 255, 0.15); }\n    .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary {\n      border: 1px solid white;\n      color: white; }\n      .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:active, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:hover {\n        background-color: rgba(255, 255, 255, 0.15); }\n      .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled {\n        opacity: 0.5; }\n        .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled:active, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled:hover, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled:focus, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled:active, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled:hover, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled:focus {\n          background-color: #003D50; }\n    .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-primary:hover {\n      background-color: #10463e;\n      border: #10463e; }\n    .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-primary.disabled, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-primary:disabled {\n      opacity: .5;\n      background-color: rgba(31, 132, 117, 0.3);\n      border: rgba(31, 132, 117, 0.3); }\n\n.ssg-forms-btn {\n  border-radius: 18px;\n  border: 1px solid #1F8475;\n  background-color: #FFFFFF;\n  color: #1F8475;\n  font-family: \"graphik\", sans-serif;\n  font-size: 13px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  line-height: 18px;\n  text-align: center;\n  padding: 9px 20px; }\n  .ssg-forms-btn:active, .ssg-forms-btn:hover {\n    background-color: #DEEFEC;\n    cursor: pointer; }\n  .ssg-forms-btn.disabled, .ssg-forms-btn:disabled {\n    opacity: 0.5; }\n    .ssg-forms-btn.disabled:active, .ssg-forms-btn.disabled:hover, .ssg-forms-btn.disabled:focus, .ssg-forms-btn:disabled:active, .ssg-forms-btn:disabled:hover, .ssg-forms-btn:disabled:focus {\n      background-color: #FFFFFF;\n      cursor: not-allowed; }\n  .ssg-forms-btn.ssg-forms-btn-secondary {\n    border: 1px solid #1F8475;\n    color: #1F8475; }\n    .ssg-forms-btn.ssg-forms-btn-secondary:active, .ssg-forms-btn.ssg-forms-btn-secondary:hover {\n      background-color: rgba(31, 132, 117, 0.15); }\n    .ssg-forms-btn.ssg-forms-btn-secondary.disabled, .ssg-forms-btn.ssg-forms-btn-secondary:disabled {\n      opacity: 0.5; }\n      .ssg-forms-btn.ssg-forms-btn-secondary.disabled:active, .ssg-forms-btn.ssg-forms-btn-secondary.disabled:hover, .ssg-forms-btn.ssg-forms-btn-secondary.disabled:focus, .ssg-forms-btn.ssg-forms-btn-secondary:disabled:active, .ssg-forms-btn.ssg-forms-btn-secondary:disabled:hover, .ssg-forms-btn.ssg-forms-btn-secondary:disabled:focus {\n        background-color: white; }\n  .ssg-forms-btn.ssg-forms-btn-primary {\n    border: 1px solid #1F8475;\n    background-color: #1F8475;\n    color: #FFFFFF; }\n    .ssg-forms-btn.ssg-forms-btn-primary:active, .ssg-forms-btn.ssg-forms-btn-primary:hover {\n      background-color: #10463e; }\n    .ssg-forms-btn.ssg-forms-btn-primary.disabled, .ssg-forms-btn.ssg-forms-btn-primary:disabled {\n      opacity: 1;\n      background-color: rgba(31, 132, 117, 0.3);\n      border: rgba(31, 132, 117, 0.3); }\n  .ssg-forms-btn .glyphicon-text {\n    margin-right: 10px; }\n\n.ssg-forms-icon-btn {\n  background-color: transparent;\n  border: none;\n  color: #003D50;\n  cursor: pointer;\n  height: 36px;\n  position: relative;\n  padding: 6px;\n  text-align: center;\n  width: 36px; }\n  .ssg-forms-icon-btn:hover {\n    border-radius: 50%;\n    background-color: #F9ECC8; }\n  .ssg-forms-icon-btn:focus {\n    border: 1px solid #DC8A5E;\n    border-radius: 50%;\n    background-color: #F9ECC8;\n    outline: none; }\n  .ssg-forms-icon-btn.disabled, .ssg-forms-icon-btn:disabled {\n    color: #CCCCCC;\n    cursor: not-allowed; }\n  .ssg-forms-icon-btn .ssg-forms-btn-icon {\n    height: 50%;\n    width: 50%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); }\n\n.ssg-forms-element {\n  margin-bottom: 10px;\n  width: 100%; }\n  .ssg-forms-element .tooltip-group {\n    display: flex; }\n  .ssg-forms-element ::-webkit-input-placeholder {\n    color: #767676; }\n  .ssg-forms-element :-moz-placeholder {\n    /* Firefox 18- */\n    color: #767676; }\n  .ssg-forms-element ::-moz-placeholder {\n    /* Firefox 19+ */\n    color: #767676; }\n  .ssg-forms-element :-ms-input-placeholder {\n    color: #767676; }\n\n.ssg-forms-input {\n  width: 100%;\n  border: 1px solid #CCCCCC;\n  border-radius: 3px;\n  background-color: white;\n  padding: 9px;\n  color: #003D50;\n  font-family: \"graphik\", sans-serif;\n  font-size: 16px;\n  line-height: 22px; }\n  .ssg-forms-input:focus {\n    outline: 0px solid transparent;\n    border: 1px solid #003D50; }\n  .ssg-forms-input.disabled, .ssg-forms-input:disabled {\n    cursor: not-allowed;\n    color: #CCCCCC; }\n  .ssg-forms-input.readonly, .ssg-forms-input:read-only {\n    cursor: not-allowed;\n    border: none;\n    border-bottom: 1px solid #CCCCCC;\n    border-radius: 3px;\n    padding: 0px; }\n    .ssg-forms-input.readonly:focus, .ssg-forms-input:read-only:focus {\n      border-bottom: 1px solid #CCCCCC; }\n\n.ssg-forms-input-group {\n  width: 100%;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  align-items: stretch;\n  border: 1px solid #CCCCCC;\n  border-radius: 3px;\n  background-color: white; }\n  .ssg-forms-input-group:focus-within, .ssg-forms-input-group.focus, .ssg-forms-input-group:focus {\n    outline: 0px solid transparent;\n    border: 1px solid #003D50; }\n  .ssg-forms-input-group.disabled {\n    cursor: not-allowed; }\n  .ssg-forms-input-group.readonly {\n    cursor: not-allowed;\n    border: none;\n    border-bottom: 1px solid #CCCCCC;\n    border-radius: 3px;\n    padding: 0px; }\n    .ssg-forms-input-group.readonly:focus-within, .ssg-forms-input-group.readonly:focus {\n      border: none;\n      border-bottom: 1px solid #CCCCCC; }\n  .ssg-forms-input-group .ssg-forms-input {\n    position: relative;\n    flex: 1 1 auto;\n    width: 1%;\n    border: none; }\n    .ssg-forms-input-group .ssg-forms-input:not(:first-child) {\n      padding-left: 0px; }\n    .ssg-forms-input-group .ssg-forms-input:not(:last-child) {\n      padding-right: 0px; }\n    .ssg-forms-input-group .ssg-forms-input:focus {\n      border: none; }\n    .ssg-forms-input-group .ssg-forms-input.readonly {\n      border: none; }\n    .ssg-forms-input-group .ssg-forms-input:read-only {\n      border: none; }\n  .ssg-forms-input-group .ssg-forms-input-section {\n    position: relative;\n    flex: 1 1 auto;\n    -ms-flex: 1;\n    color: #003D50;\n    font-family: \"graphik\", sans-serif;\n    font-size: 16px;\n    line-height: 22px;\n    border: none;\n    padding: 4px;\n    margin: 5px;\n    text-align: center;\n    background-color: white; }\n    .ssg-forms-input-group .ssg-forms-input-section::selection {\n      background: transparent; }\n    .ssg-forms-input-group .ssg-forms-input-section:focus {\n      outline: 0px solid transparent;\n      background-color: #F9ECC8; }\n    .ssg-forms-input-group .ssg-forms-input-section.disabled, .ssg-forms-input-group .ssg-forms-input-section:disabled {\n      cursor: not-allowed; }\n    .ssg-forms-input-group .ssg-forms-input-section.readonly, .ssg-forms-input-group .ssg-forms-input-section:read-only {\n      cursor: not-allowed; }\n  .ssg-forms-input-group .btn {\n    padding-top: 10px; }\n\n.input-error {\n  border: 1px solid #C70000; }\n\n.ssg-forms-addon {\n  border: black;\n  display: flex;\n  color: #767676;\n  font-family: \"graphik\", sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 9px; }\n  .ssg-forms-addon.disabled {\n    cursor: not-allowed;\n    pointer-events: none;\n    color: #CCCCCC; }\n  .ssg-forms-addon.readonly {\n    cursor: not-allowed;\n    display: inline;\n    color: #003D50;\n    padding: 0px; }\n\n.end-line {\n  clear: left; }\n\n@media (min-width: 769px) {\n  .ssg-forms-element {\n    margin-bottom: 10px;\n    max-width: 416px; } }\n\n.ssg-form h1 {\n  color: #003D50;\n  font-family: \"graphik\", sans-serif;\n  font-size: 30px; }\n\n.tooltip-group {\n  display: flex; }\n\n.ssg-forms-plain-actions {\n  text-align: right; }\n  .ssg-forms-plain-actions .ssg-forms-btn {\n    margin: 10px 0px 10px 10px; }\n\n.ssg-forms-scrollable::-webkit-scrollbar {\n  width: 15px; }\n\n.ssg-forms-scrollable::-webkit-scrollbar-thumb {\n  background-color: #BCBEC0;\n  border-radius: 10px;\n  border: 3px solid transparent;\n  background-clip: content-box; }\n  .ssg-forms-scrollable::-webkit-scrollbar-thumb:hover {\n    background-color: #95989b; }\n\n.ssg-forms-scrollable::-webkit-scrollbar-track {\n  background-color: #F2F2F2; }\n\n/**\n * This style should be used by individual field labels.\n * It is smaller text than the question label, and all caps.\n * For example, if the question prompt is \"What is your address?\",\n * this style could be applied to the related fields \"Line 1\",\n * \"Line 2\", \"City\", \"State\", \"Zip\".\n */\n.ssg-field-label {\n  color: #003D50;\n  font-family: \"graphik\", sans-serif;\n  font-size: 11px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  line-height: 13px;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n  border: none; }\n  .ssg-field-label.readonly {\n    color: #767676; }\n  .ssg-field-label.disabled, .ssg-field-label:disabled {\n    color: #CCCCCC; }\n\n/**\n * This style should be used by the element question text.\n * It is larger text than the field label, and all mixed case.\n * For example this style might be applied to the prompt: \"What is your address?\"\n */\n.ssg-forms-label {\n  color: #003D50;\n  font-family: \"graphik\", sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: normal;\n  margin-bottom: 10px;\n  border: none; }\n  .ssg-forms-label.readonly {\n    color: #767676; }\n  .ssg-forms-label.disabled, .ssg-forms-label:disabled {\n    color: #CCCCCC; }\n\n.ssg-forms-error-icon {\n  color: #C70000;\n  width: 18px;\n  height: 18px;\n  vertical-align: middle; }\n\n.ssg-forms-warning-icon {\n  color: #9F7417;\n  width: 18px;\n  height: 18px;\n  vertical-align: middle; }\n\n.ssg-forms-text {\n  color: #003D50;\n  font-family: \"graphik\", sans-serif; }\n  .ssg-forms-text.small {\n    font-size: 11px;\n    line-height: 14px;\n    letter-spacing: 0.5px; }\n  .ssg-forms-text.normal {\n    font-size: 16px;\n    line-height: 22px; }\n  .ssg-forms-text.large {\n    font-size: 18px;\n    line-height: 25px; }\n  .ssg-forms-text.xl {\n    font-size: 28px;\n    line-height: 38px; }\n\n.group-element-sub-elements {\n  margin-bottom: 10px; }\n  .group-element-sub-elements.input-error {\n    border: 1px solid #C70000;\n    border-radius: 3px;\n    padding: 10px; }\n", ""]);

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-indented-group {\n  margin-left: 15px; }\n", ""]);

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-inline-group {\n  display: flex;\n  align-items: baseline; }\n\n.ssg-forms-inline-element {\n  width: max-content;\n  margin-right: 10px;\n  margin-left: 10px; }\n  .ssg-forms-inline-element:first-child {\n    margin-left: 0px; }\n  .ssg-forms-inline-element:last-child {\n    margin-right: 0px; }\n", ""]);

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-header {\n  white-space: pre-wrap;\n  overflow: hidden; }\n", ""]);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-help-text {\n  white-space: pre-line;\n  overflow-wrap: break-word; }\n  .ssg-help-text.disabled {\n    color: #CCCCCC; }\n", ""]);

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-likert-choice-wrapper {\n  clear: both;\n  text-align: center;\n  position: relative;\n  flex: 1;\n  z-index: 1; }\n  .ssg-likert-choice-wrapper::before {\n    content: '';\n    position: absolute;\n    z-index: -1;\n    background-color: #003D50;\n    height: 2px;\n    top: calc((18px / 2) - (2px - 1px));\n    width: calc(50% - (18px / 2) + 2px);\n    right: calc(50% + (18px / 2) - 1px); }\n  .ssg-likert-choice-wrapper::after {\n    content: '';\n    position: absolute;\n    z-index: -1;\n    background-color: #003D50;\n    height: 2px;\n    top: calc((18px / 2) - (2px - 1px));\n    width: calc(50% - (18px / 2) + 2px);\n    left: calc(50% + (18px / 2) - 1px); }\n  .ssg-likert-choice-wrapper.readonly::before {\n    background-color: #767676; }\n  .ssg-likert-choice-wrapper.readonly::after {\n    background-color: #767676; }\n  .ssg-likert-choice-wrapper.disabled::before {\n    background-color: #CCCCCC; }\n  .ssg-likert-choice-wrapper.disabled::after {\n    background-color: #CCCCCC; }\n  .ssg-likert-choice-wrapper:first-child::before {\n    content: none; }\n  .ssg-likert-choice-wrapper:last-child::after {\n    content: none; }\n\n.ssg-likert-group {\n  padding-top: 10px;\n  position: relative;\n  display: flex; }\n\n.ssg-likert-choice-label {\n  cursor: pointer;\n  margin-bottom: 8px; }\n  .ssg-likert-choice-label.disabled, .ssg-likert-choice-label:disabled {\n    color: #CCCCCC;\n    cursor: not-allowed; }\n  .ssg-likert-choice-label.read-only {\n    cursor: not-allowed; }\n\ninput[type=radio].ssg-likert-input {\n  display: block;\n  border: 0px;\n  width: 18px;\n  height: 18px;\n  margin: 0px auto 14px; }\n  input[type=radio].ssg-likert-input.disabled, input[type=radio].ssg-likert-input:disabled {\n    color: #CCCCCC; }\n  input[type=radio].ssg-likert-input.readonly {\n    color: #CCCCCC;\n    opacity: 0.5; }\n  input[type=radio].ssg-likert-input:read-only {\n    color: #CCCCCC;\n    opacity: 0.5; }\n  input[type=radio].ssg-likert-input:hover {\n    cursor: pointer; }\n    input[type=radio].ssg-likert-input:hover.disabled, input[type=radio].ssg-likert-input:hover:disabled {\n      cursor: not-allowed; }\n    input[type=radio].ssg-likert-input:hover.readonly {\n      cursor: not-allowed; }\n", ""]);

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-no-input-group {\n  width: 100%; }\n", ""]);

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-radio-fieldset {\n  position: relative;\n  margin-top: 5px; }\n\n.ssg-radio-choice-wrapper {\n  clear: both;\n  vertical-align: middle; }\n\n.ssg-radio-group {\n  padding-top: 10px; }\n\n.ssg-radio-group-label-legend {\n  margin-bottom: 0px; }\n\n.ssg-radio-choice-label {\n  cursor: pointer;\n  font-weight: normal;\n  letter-spacing: 0.5px;\n  margin-bottom: 8px; }\n  .ssg-radio-choice-label.disabled, .ssg-radio-choice-label:disabled {\n    color: #CCCCCC;\n    cursor: not-allowed; }\n  .ssg-radio-choice-label.just-read {\n    cursor: not-allowed; }\n\ninput[type=radio].ssg-radio-input {\n  border: 0px;\n  width: 18px;\n  height: 18px;\n  vertical-align: middle;\n  margin: 0px 20px 0px 10px; }\n  input[type=radio].ssg-radio-input.disabled, input[type=radio].ssg-radio-input:disabled {\n    color: #CCCCCC; }\n  input[type=radio].ssg-radio-input.readonly, input[type=radio].ssg-radio-input.just-read {\n    color: #CCCCCC;\n    opacity: 0.5; }\n  input[type=radio].ssg-radio-input:read-only {\n    color: #CCCCCC;\n    opacity: 0.5; }\n  input[type=radio].ssg-radio-input:hover {\n    cursor: pointer; }\n    input[type=radio].ssg-radio-input:hover.disabled, input[type=radio].ssg-radio-input:hover:disabled {\n      cursor: not-allowed; }\n    input[type=radio].ssg-radio-input:hover.just-read {\n      cursor: not-allowed; }\n", ""]);

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, "@import url(https://use.typekit.net/jxi2cmo.css);", ""]);
exports.push([module.i, "\n.ssg-forms-no-focus:focus {\n  outline: 0px solid transparent; }\n\n.ssg-forms-skip {\n  position: absolute;\n  left: -200%;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden; }\n  .ssg-forms-skip:focus {\n    position: static;\n    width: auto;\n    height: auto; }\n\n.ssg-forms-hidden {\n  display: none; }\n\n.ssg-forms-spin {\n  animation: spin 2s linear infinite;\n  z-index: 2;\n  width: 18px;\n  height: 18px; }\n  .ssg-forms-spin .path {\n    stroke: #20907f;\n    stroke-linecap: round;\n    animation: dash 1.5s ease-in-out infinite; }\n\n@keyframes spin {\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes dash {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0; }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35; }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124; } }\n\n.ssg-forms-fade-out {\n  opacity: 0;\n  animation-name: fade-out;\n  animation-duration: 2000ms;\n  animation-iteration-count: 1;\n  animation-timing-function: linear; }\n\n@keyframes fade-out {\n  from {\n    opacity: 1; }\n  to {\n    opacity: 0; } }\n\n.ssg-forms-fade-in {\n  animation-name: fade-in;\n  animation-duration: 2000ms;\n  animation-iteration-count: 1;\n  animation-timing-function: linear; }\n\n@keyframes fade-in {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.ssg-forms-dark-actions {\n  text-align: right;\n  background-color: #003D50;\n  padding: 10px; }\n  .ssg-forms-dark-actions .ssg-forms-btn {\n    margin: 0px 0px 0px 10px;\n    color: white;\n    background-color: #003D50; }\n    .ssg-forms-dark-actions .ssg-forms-btn:first-child {\n      margin-left: 0px; }\n    .ssg-forms-dark-actions .ssg-forms-btn:active, .ssg-forms-dark-actions .ssg-forms-btn:hover {\n      background-color: rgba(255, 255, 255, 0.15); }\n    .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary {\n      border: 1px solid white;\n      color: white; }\n      .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:active, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:hover {\n        background-color: rgba(255, 255, 255, 0.15); }\n      .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled {\n        opacity: 0.5; }\n        .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled:active, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled:hover, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled:focus, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled:active, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled:hover, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled:focus {\n          background-color: #003D50; }\n    .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-primary:hover {\n      background-color: #10463e;\n      border: #10463e; }\n    .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-primary.disabled, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-primary:disabled {\n      opacity: .5;\n      background-color: rgba(31, 132, 117, 0.3);\n      border: rgba(31, 132, 117, 0.3); }\n\n.ssg-forms-btn {\n  border-radius: 18px;\n  border: 1px solid #1F8475;\n  background-color: #FFFFFF;\n  color: #1F8475;\n  font-family: \"graphik\", sans-serif;\n  font-size: 13px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  line-height: 18px;\n  text-align: center;\n  padding: 9px 20px; }\n  .ssg-forms-btn:active, .ssg-forms-btn:hover {\n    background-color: #DEEFEC;\n    cursor: pointer; }\n  .ssg-forms-btn.disabled, .ssg-forms-btn:disabled {\n    opacity: 0.5; }\n    .ssg-forms-btn.disabled:active, .ssg-forms-btn.disabled:hover, .ssg-forms-btn.disabled:focus, .ssg-forms-btn:disabled:active, .ssg-forms-btn:disabled:hover, .ssg-forms-btn:disabled:focus {\n      background-color: #FFFFFF;\n      cursor: not-allowed; }\n  .ssg-forms-btn.ssg-forms-btn-secondary {\n    border: 1px solid #1F8475;\n    color: #1F8475; }\n    .ssg-forms-btn.ssg-forms-btn-secondary:active, .ssg-forms-btn.ssg-forms-btn-secondary:hover {\n      background-color: rgba(31, 132, 117, 0.15); }\n    .ssg-forms-btn.ssg-forms-btn-secondary.disabled, .ssg-forms-btn.ssg-forms-btn-secondary:disabled {\n      opacity: 0.5; }\n      .ssg-forms-btn.ssg-forms-btn-secondary.disabled:active, .ssg-forms-btn.ssg-forms-btn-secondary.disabled:hover, .ssg-forms-btn.ssg-forms-btn-secondary.disabled:focus, .ssg-forms-btn.ssg-forms-btn-secondary:disabled:active, .ssg-forms-btn.ssg-forms-btn-secondary:disabled:hover, .ssg-forms-btn.ssg-forms-btn-secondary:disabled:focus {\n        background-color: white; }\n  .ssg-forms-btn.ssg-forms-btn-primary {\n    border: 1px solid #1F8475;\n    background-color: #1F8475;\n    color: #FFFFFF; }\n    .ssg-forms-btn.ssg-forms-btn-primary:active, .ssg-forms-btn.ssg-forms-btn-primary:hover {\n      background-color: #10463e; }\n    .ssg-forms-btn.ssg-forms-btn-primary.disabled, .ssg-forms-btn.ssg-forms-btn-primary:disabled {\n      opacity: 1;\n      background-color: rgba(31, 132, 117, 0.3);\n      border: rgba(31, 132, 117, 0.3); }\n  .ssg-forms-btn .glyphicon-text {\n    margin-right: 10px; }\n\n.ssg-forms-icon-btn {\n  background-color: transparent;\n  border: none;\n  color: #003D50;\n  cursor: pointer;\n  height: 36px;\n  position: relative;\n  padding: 6px;\n  text-align: center;\n  width: 36px; }\n  .ssg-forms-icon-btn:hover {\n    border-radius: 50%;\n    background-color: #F9ECC8; }\n  .ssg-forms-icon-btn:focus {\n    border: 1px solid #DC8A5E;\n    border-radius: 50%;\n    background-color: #F9ECC8;\n    outline: none; }\n  .ssg-forms-icon-btn.disabled, .ssg-forms-icon-btn:disabled {\n    color: #CCCCCC;\n    cursor: not-allowed; }\n  .ssg-forms-icon-btn .ssg-forms-btn-icon {\n    height: 50%;\n    width: 50%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); }\n\n.ssg-forms-element {\n  margin-bottom: 10px;\n  width: 100%; }\n  .ssg-forms-element .tooltip-group {\n    display: flex; }\n  .ssg-forms-element ::-webkit-input-placeholder {\n    color: #767676; }\n  .ssg-forms-element :-moz-placeholder {\n    /* Firefox 18- */\n    color: #767676; }\n  .ssg-forms-element ::-moz-placeholder {\n    /* Firefox 19+ */\n    color: #767676; }\n  .ssg-forms-element :-ms-input-placeholder {\n    color: #767676; }\n\n.ssg-forms-input {\n  width: 100%;\n  border: 1px solid #CCCCCC;\n  border-radius: 3px;\n  background-color: white;\n  padding: 9px;\n  color: #003D50;\n  font-family: \"graphik\", sans-serif;\n  font-size: 16px;\n  line-height: 22px; }\n  .ssg-forms-input:focus {\n    outline: 0px solid transparent;\n    border: 1px solid #003D50; }\n  .ssg-forms-input.disabled, .ssg-forms-input:disabled {\n    cursor: not-allowed;\n    color: #CCCCCC; }\n  .ssg-forms-input.readonly, .ssg-forms-input:read-only {\n    cursor: not-allowed;\n    border: none;\n    border-bottom: 1px solid #CCCCCC;\n    border-radius: 3px;\n    padding: 0px; }\n    .ssg-forms-input.readonly:focus, .ssg-forms-input:read-only:focus {\n      border-bottom: 1px solid #CCCCCC; }\n\n.ssg-forms-input-group {\n  width: 100%;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  align-items: stretch;\n  border: 1px solid #CCCCCC;\n  border-radius: 3px;\n  background-color: white; }\n  .ssg-forms-input-group:focus-within, .ssg-forms-input-group.focus, .ssg-forms-input-group:focus {\n    outline: 0px solid transparent;\n    border: 1px solid #003D50; }\n  .ssg-forms-input-group.disabled {\n    cursor: not-allowed; }\n  .ssg-forms-input-group.readonly {\n    cursor: not-allowed;\n    border: none;\n    border-bottom: 1px solid #CCCCCC;\n    border-radius: 3px;\n    padding: 0px; }\n    .ssg-forms-input-group.readonly:focus-within, .ssg-forms-input-group.readonly:focus {\n      border: none;\n      border-bottom: 1px solid #CCCCCC; }\n  .ssg-forms-input-group .ssg-forms-input {\n    position: relative;\n    flex: 1 1 auto;\n    width: 1%;\n    border: none; }\n    .ssg-forms-input-group .ssg-forms-input:not(:first-child) {\n      padding-left: 0px; }\n    .ssg-forms-input-group .ssg-forms-input:not(:last-child) {\n      padding-right: 0px; }\n    .ssg-forms-input-group .ssg-forms-input:focus {\n      border: none; }\n    .ssg-forms-input-group .ssg-forms-input.readonly {\n      border: none; }\n    .ssg-forms-input-group .ssg-forms-input:read-only {\n      border: none; }\n  .ssg-forms-input-group .ssg-forms-input-section {\n    position: relative;\n    flex: 1 1 auto;\n    -ms-flex: 1;\n    color: #003D50;\n    font-family: \"graphik\", sans-serif;\n    font-size: 16px;\n    line-height: 22px;\n    border: none;\n    padding: 4px;\n    margin: 5px;\n    text-align: center;\n    background-color: white; }\n    .ssg-forms-input-group .ssg-forms-input-section::selection {\n      background: transparent; }\n    .ssg-forms-input-group .ssg-forms-input-section:focus {\n      outline: 0px solid transparent;\n      background-color: #F9ECC8; }\n    .ssg-forms-input-group .ssg-forms-input-section.disabled, .ssg-forms-input-group .ssg-forms-input-section:disabled {\n      cursor: not-allowed; }\n    .ssg-forms-input-group .ssg-forms-input-section.readonly, .ssg-forms-input-group .ssg-forms-input-section:read-only {\n      cursor: not-allowed; }\n  .ssg-forms-input-group .btn {\n    padding-top: 10px; }\n\n.input-error {\n  border: 1px solid #C70000; }\n\n.ssg-forms-addon {\n  border: black;\n  display: flex;\n  color: #767676;\n  font-family: \"graphik\", sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 9px; }\n  .ssg-forms-addon.disabled {\n    cursor: not-allowed;\n    pointer-events: none;\n    color: #CCCCCC; }\n  .ssg-forms-addon.readonly {\n    cursor: not-allowed;\n    display: inline;\n    color: #003D50;\n    padding: 0px; }\n\n.end-line {\n  clear: left; }\n\n@media (min-width: 769px) {\n  .ssg-forms-element {\n    margin-bottom: 10px;\n    max-width: 416px; } }\n\n.ssg-form h1 {\n  color: #003D50;\n  font-family: \"graphik\", sans-serif;\n  font-size: 30px; }\n\n.tooltip-group {\n  display: flex; }\n\n.ssg-forms-plain-actions {\n  text-align: right; }\n  .ssg-forms-plain-actions .ssg-forms-btn {\n    margin: 10px 0px 10px 10px; }\n\n.ssg-forms-scrollable::-webkit-scrollbar {\n  width: 15px; }\n\n.ssg-forms-scrollable::-webkit-scrollbar-thumb {\n  background-color: #BCBEC0;\n  border-radius: 10px;\n  border: 3px solid transparent;\n  background-clip: content-box; }\n  .ssg-forms-scrollable::-webkit-scrollbar-thumb:hover {\n    background-color: #95989b; }\n\n.ssg-forms-scrollable::-webkit-scrollbar-track {\n  background-color: #F2F2F2; }\n\n/**\n * This style should be used by individual field labels.\n * It is smaller text than the question label, and all caps.\n * For example, if the question prompt is \"What is your address?\",\n * this style could be applied to the related fields \"Line 1\",\n * \"Line 2\", \"City\", \"State\", \"Zip\".\n */\n.ssg-field-label {\n  color: #003D50;\n  font-family: \"graphik\", sans-serif;\n  font-size: 11px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  line-height: 13px;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n  border: none; }\n  .ssg-field-label.readonly {\n    color: #767676; }\n  .ssg-field-label.disabled, .ssg-field-label:disabled {\n    color: #CCCCCC; }\n\n/**\n * This style should be used by the element question text.\n * It is larger text than the field label, and all mixed case.\n * For example this style might be applied to the prompt: \"What is your address?\"\n */\n.ssg-forms-label {\n  color: #003D50;\n  font-family: \"graphik\", sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: normal;\n  margin-bottom: 10px;\n  border: none; }\n  .ssg-forms-label.readonly {\n    color: #767676; }\n  .ssg-forms-label.disabled, .ssg-forms-label:disabled {\n    color: #CCCCCC; }\n\n.ssg-forms-error-icon {\n  color: #C70000;\n  width: 18px;\n  height: 18px;\n  vertical-align: middle; }\n\n.ssg-forms-warning-icon {\n  color: #9F7417;\n  width: 18px;\n  height: 18px;\n  vertical-align: middle; }\n\n.ssg-forms-text {\n  color: #003D50;\n  font-family: \"graphik\", sans-serif; }\n  .ssg-forms-text.small {\n    font-size: 11px;\n    line-height: 14px;\n    letter-spacing: 0.5px; }\n  .ssg-forms-text.normal {\n    font-size: 16px;\n    line-height: 22px; }\n  .ssg-forms-text.large {\n    font-size: 18px;\n    line-height: 25px; }\n  .ssg-forms-text.xl {\n    font-size: 28px;\n    line-height: 38px; }\n\n.ssg-forms-select {\n  width: 100%;\n  border: 1px solid #CCCCCC;\n  border-radius: 3px;\n  background-color: white;\n  padding: 9px;\n  color: #003D50;\n  font-family: \"graphik\", sans-serif;\n  font-size: 16px;\n  line-height: 22px; }\n  .ssg-forms-select:focus {\n    outline: 0px solid transparent;\n    border: 1px solid #003D50; }\n  .ssg-forms-select.disabled, .ssg-forms-select:disabled {\n    cursor: not-allowed;\n    color: #CCCCCC; }\n  .ssg-forms-select .ssg-forms-option {\n    background-color: white;\n    color: #003D50; }\n", ""]);

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-single-checkbox-input-wrapper {\n  clear: both;\n  vertical-align: middle; }\n\n.ssg-single-checkbox-label {\n  cursor: pointer;\n  margin-bottom: 8px; }\n  .ssg-single-checkbox-label.disabled, .ssg-single-checkbox-label:disabled {\n    color: #CCCCCC;\n    cursor: not-allowed; }\n  .ssg-single-checkbox-label.just-read {\n    cursor: not-allowed; }\n\ninput[type=checkbox].ssg-single-checkbox-input {\n  border: 2px solid #003D50;\n  width: 18px;\n  height: 18px;\n  vertical-align: middle;\n  margin: 0px 20px 0px 10px; }\n  input[type=checkbox].ssg-single-checkbox-input.disabled, input[type=checkbox].ssg-single-checkbox-input:disabled {\n    color: #CCCCCC; }\n  input[type=checkbox].ssg-single-checkbox-input.readonly, input[type=checkbox].ssg-single-checkbox-input.just-read {\n    color: #CCCCCC;\n    opacity: 0.9; }\n  input[type=checkbox].ssg-single-checkbox-input:read-only {\n    color: #CCCCCC;\n    opacity: 0.9; }\n  input[type=checkbox].ssg-single-checkbox-input:hover {\n    cursor: pointer; }\n    input[type=checkbox].ssg-single-checkbox-input:hover.disabled, input[type=checkbox].ssg-single-checkbox-input:hover:disabled {\n      cursor: not-allowed; }\n    input[type=checkbox].ssg-single-checkbox-input:hover.just-read {\n      cursor: not-allowed; }\n", ""]);

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-text-input {\n  overflow: auto;\n  resize: both; }\n  .ssg-forms-text-input.readonly {\n    resize: none;\n    overflow: hidden; }\n  .ssg-forms-text-input:read-only {\n    resize: none;\n    overflow: hidden; }\n\n.ssg-forms-countdown {\n  display: block;\n  font-weight: normal;\n  color: #003D50;\n  font-family: \"graphik\", sans-serif;\n  font-size: 12px;\n  line-height: 17px;\n  margin-bottom: 1px; }\n  .ssg-forms-countdown.invalid {\n    color: #C70000; }\n  .ssg-forms-countdown.disabled {\n    color: #CCCCCC; }\n\n.hidden-accessibility {\n  position: absolute;\n  left: -200%;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden; }\n", ""]);

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".text-sub-text {\n  font-weight: normal;\n  color: #003D50;\n  font-family: \"graphik\", sans-serif;\n  font-size: 12px;\n  line-height: 17px; }\n  .text-sub-text.disabled, .text-sub-text:disabled {\n    color: #CCCCCC; }\n", ""]);

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-input-group.ssg-time-element {\n  width: 140px;\n  justify-content: center; }\n\n.ssg-forms-input-group .ssg-time-input-section {\n  height: 26px;\n  flex-basis: 26px;\n  max-width: 26px;\n  flex-grow: 0;\n  -webkit-user-select: all;\n  -moz-user-select: all;\n  -ms-user-select: all;\n  user-select: all; }\n  .ssg-forms-input-group .ssg-time-input-section.period-section {\n    flex-basis: 32px;\n    max-width: 32px;\n    text-transform: lowercase; }\n\n.ssg-time-text {\n  padding: 4px 0px; }\n", ""]);

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-dark-actions {\n  text-align: right;\n  background-color: #003D50;\n  padding: 10px; }\n  .ssg-forms-dark-actions .ssg-forms-btn {\n    margin: 0px 0px 0px 10px;\n    color: white;\n    background-color: #003D50; }\n    .ssg-forms-dark-actions .ssg-forms-btn:first-child {\n      margin-left: 0px; }\n    .ssg-forms-dark-actions .ssg-forms-btn:active, .ssg-forms-dark-actions .ssg-forms-btn:hover {\n      background-color: rgba(255, 255, 255, 0.15); }\n    .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary {\n      border: 1px solid white;\n      color: white; }\n      .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:active, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:hover {\n        background-color: rgba(255, 255, 255, 0.15); }\n      .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled {\n        opacity: 0.5; }\n        .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled:active, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled:hover, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled:focus, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled:active, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled:hover, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled:focus {\n          background-color: #003D50; }\n    .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-primary:hover {\n      background-color: #10463e;\n      border: #10463e; }\n    .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-primary.disabled, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-primary:disabled {\n      opacity: .5;\n      background-color: rgba(31, 132, 117, 0.3);\n      border: rgba(31, 132, 117, 0.3); }\n\n.ssg-forms-btn {\n  border-radius: 18px;\n  border: 1px solid #1F8475;\n  background-color: #FFFFFF;\n  color: #1F8475;\n  font-family: \"graphik\", sans-serif;\n  font-size: 13px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  line-height: 18px;\n  text-align: center;\n  padding: 9px 20px; }\n  .ssg-forms-btn:active, .ssg-forms-btn:hover {\n    background-color: #DEEFEC;\n    cursor: pointer; }\n  .ssg-forms-btn.disabled, .ssg-forms-btn:disabled {\n    opacity: 0.5; }\n    .ssg-forms-btn.disabled:active, .ssg-forms-btn.disabled:hover, .ssg-forms-btn.disabled:focus, .ssg-forms-btn:disabled:active, .ssg-forms-btn:disabled:hover, .ssg-forms-btn:disabled:focus {\n      background-color: #FFFFFF;\n      cursor: not-allowed; }\n  .ssg-forms-btn.ssg-forms-btn-secondary {\n    border: 1px solid #1F8475;\n    color: #1F8475; }\n    .ssg-forms-btn.ssg-forms-btn-secondary:active, .ssg-forms-btn.ssg-forms-btn-secondary:hover {\n      background-color: rgba(31, 132, 117, 0.15); }\n    .ssg-forms-btn.ssg-forms-btn-secondary.disabled, .ssg-forms-btn.ssg-forms-btn-secondary:disabled {\n      opacity: 0.5; }\n      .ssg-forms-btn.ssg-forms-btn-secondary.disabled:active, .ssg-forms-btn.ssg-forms-btn-secondary.disabled:hover, .ssg-forms-btn.ssg-forms-btn-secondary.disabled:focus, .ssg-forms-btn.ssg-forms-btn-secondary:disabled:active, .ssg-forms-btn.ssg-forms-btn-secondary:disabled:hover, .ssg-forms-btn.ssg-forms-btn-secondary:disabled:focus {\n        background-color: white; }\n  .ssg-forms-btn.ssg-forms-btn-primary {\n    border: 1px solid #1F8475;\n    background-color: #1F8475;\n    color: #FFFFFF; }\n    .ssg-forms-btn.ssg-forms-btn-primary:active, .ssg-forms-btn.ssg-forms-btn-primary:hover {\n      background-color: #10463e; }\n    .ssg-forms-btn.ssg-forms-btn-primary.disabled, .ssg-forms-btn.ssg-forms-btn-primary:disabled {\n      opacity: 1;\n      background-color: rgba(31, 132, 117, 0.3);\n      border: rgba(31, 132, 117, 0.3); }\n  .ssg-forms-btn .glyphicon-text {\n    margin-right: 10px; }\n\n.ssg-forms-icon-btn {\n  background-color: transparent;\n  border: none;\n  color: #003D50;\n  cursor: pointer;\n  height: 36px;\n  position: relative;\n  padding: 6px;\n  text-align: center;\n  width: 36px; }\n  .ssg-forms-icon-btn:hover {\n    border-radius: 50%;\n    background-color: #F9ECC8; }\n  .ssg-forms-icon-btn:focus {\n    border: 1px solid #DC8A5E;\n    border-radius: 50%;\n    background-color: #F9ECC8;\n    outline: none; }\n  .ssg-forms-icon-btn.disabled, .ssg-forms-icon-btn:disabled {\n    color: #CCCCCC;\n    cursor: not-allowed; }\n  .ssg-forms-icon-btn .ssg-forms-btn-icon {\n    height: 50%;\n    width: 50%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); }\n", ""]);

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, "@import url(https://use.typekit.net/jxi2cmo.css);", ""]);
exports.push([module.i, "\n.ssg-forms-no-focus:focus {\n  outline: 0px solid transparent; }\n\n.ssg-forms-skip {\n  position: absolute;\n  left: -200%;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden; }\n  .ssg-forms-skip:focus {\n    position: static;\n    width: auto;\n    height: auto; }\n\n.ssg-forms-hidden {\n  display: none; }\n\n.ssg-forms-spin {\n  animation: spin 2s linear infinite;\n  z-index: 2;\n  width: 18px;\n  height: 18px; }\n  .ssg-forms-spin .path {\n    stroke: #20907f;\n    stroke-linecap: round;\n    animation: dash 1.5s ease-in-out infinite; }\n\n@keyframes spin {\n  100% {\n    transform: rotate(360deg); } }\n\n@keyframes dash {\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0; }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -35; }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -124; } }\n\n.ssg-forms-fade-out {\n  opacity: 0;\n  animation-name: fade-out;\n  animation-duration: 2000ms;\n  animation-iteration-count: 1;\n  animation-timing-function: linear; }\n\n@keyframes fade-out {\n  from {\n    opacity: 1; }\n  to {\n    opacity: 0; } }\n\n.ssg-forms-fade-in {\n  animation-name: fade-in;\n  animation-duration: 2000ms;\n  animation-iteration-count: 1;\n  animation-timing-function: linear; }\n\n@keyframes fade-in {\n  from {\n    opacity: 0; }\n  to {\n    opacity: 1; } }\n\n.ssg-forms-dark-actions {\n  text-align: right;\n  background-color: #003D50;\n  padding: 10px; }\n  .ssg-forms-dark-actions .ssg-forms-btn {\n    margin: 0px 0px 0px 10px;\n    color: white;\n    background-color: #003D50; }\n    .ssg-forms-dark-actions .ssg-forms-btn:first-child {\n      margin-left: 0px; }\n    .ssg-forms-dark-actions .ssg-forms-btn:active, .ssg-forms-dark-actions .ssg-forms-btn:hover {\n      background-color: rgba(255, 255, 255, 0.15); }\n    .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary {\n      border: 1px solid white;\n      color: white; }\n      .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:active, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:hover {\n        background-color: rgba(255, 255, 255, 0.15); }\n      .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled {\n        opacity: 0.5; }\n        .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled:active, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled:hover, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled:focus, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled:active, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled:hover, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled:focus {\n          background-color: #003D50; }\n    .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-primary:hover {\n      background-color: #10463e;\n      border: #10463e; }\n    .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-primary.disabled, .ssg-forms-dark-actions .ssg-forms-btn.ssg-forms-btn-primary:disabled {\n      opacity: .5;\n      background-color: rgba(31, 132, 117, 0.3);\n      border: rgba(31, 132, 117, 0.3); }\n\n.ssg-forms-btn {\n  border-radius: 18px;\n  border: 1px solid #1F8475;\n  background-color: #FFFFFF;\n  color: #1F8475;\n  font-family: \"graphik\", sans-serif;\n  font-size: 13px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  line-height: 18px;\n  text-align: center;\n  padding: 9px 20px; }\n  .ssg-forms-btn:active, .ssg-forms-btn:hover {\n    background-color: #DEEFEC;\n    cursor: pointer; }\n  .ssg-forms-btn.disabled, .ssg-forms-btn:disabled {\n    opacity: 0.5; }\n    .ssg-forms-btn.disabled:active, .ssg-forms-btn.disabled:hover, .ssg-forms-btn.disabled:focus, .ssg-forms-btn:disabled:active, .ssg-forms-btn:disabled:hover, .ssg-forms-btn:disabled:focus {\n      background-color: #FFFFFF;\n      cursor: not-allowed; }\n  .ssg-forms-btn.ssg-forms-btn-secondary {\n    border: 1px solid #1F8475;\n    color: #1F8475; }\n    .ssg-forms-btn.ssg-forms-btn-secondary:active, .ssg-forms-btn.ssg-forms-btn-secondary:hover {\n      background-color: rgba(31, 132, 117, 0.15); }\n    .ssg-forms-btn.ssg-forms-btn-secondary.disabled, .ssg-forms-btn.ssg-forms-btn-secondary:disabled {\n      opacity: 0.5; }\n      .ssg-forms-btn.ssg-forms-btn-secondary.disabled:active, .ssg-forms-btn.ssg-forms-btn-secondary.disabled:hover, .ssg-forms-btn.ssg-forms-btn-secondary.disabled:focus, .ssg-forms-btn.ssg-forms-btn-secondary:disabled:active, .ssg-forms-btn.ssg-forms-btn-secondary:disabled:hover, .ssg-forms-btn.ssg-forms-btn-secondary:disabled:focus {\n        background-color: white; }\n  .ssg-forms-btn.ssg-forms-btn-primary {\n    border: 1px solid #1F8475;\n    background-color: #1F8475;\n    color: #FFFFFF; }\n    .ssg-forms-btn.ssg-forms-btn-primary:active, .ssg-forms-btn.ssg-forms-btn-primary:hover {\n      background-color: #10463e; }\n    .ssg-forms-btn.ssg-forms-btn-primary.disabled, .ssg-forms-btn.ssg-forms-btn-primary:disabled {\n      opacity: 1;\n      background-color: rgba(31, 132, 117, 0.3);\n      border: rgba(31, 132, 117, 0.3); }\n  .ssg-forms-btn .glyphicon-text {\n    margin-right: 10px; }\n\n.ssg-forms-icon-btn {\n  background-color: transparent;\n  border: none;\n  color: #003D50;\n  cursor: pointer;\n  height: 36px;\n  position: relative;\n  padding: 6px;\n  text-align: center;\n  width: 36px; }\n  .ssg-forms-icon-btn:hover {\n    border-radius: 50%;\n    background-color: #F9ECC8; }\n  .ssg-forms-icon-btn:focus {\n    border: 1px solid #DC8A5E;\n    border-radius: 50%;\n    background-color: #F9ECC8;\n    outline: none; }\n  .ssg-forms-icon-btn.disabled, .ssg-forms-icon-btn:disabled {\n    color: #CCCCCC;\n    cursor: not-allowed; }\n  .ssg-forms-icon-btn .ssg-forms-btn-icon {\n    height: 50%;\n    width: 50%;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%); }\n\n.ssg-forms-element {\n  margin-bottom: 10px;\n  width: 100%; }\n  .ssg-forms-element .tooltip-group {\n    display: flex; }\n  .ssg-forms-element ::-webkit-input-placeholder {\n    color: #767676; }\n  .ssg-forms-element :-moz-placeholder {\n    /* Firefox 18- */\n    color: #767676; }\n  .ssg-forms-element ::-moz-placeholder {\n    /* Firefox 19+ */\n    color: #767676; }\n  .ssg-forms-element :-ms-input-placeholder {\n    color: #767676; }\n\n.ssg-forms-input {\n  width: 100%;\n  border: 1px solid #CCCCCC;\n  border-radius: 3px;\n  background-color: white;\n  padding: 9px;\n  color: #003D50;\n  font-family: \"graphik\", sans-serif;\n  font-size: 16px;\n  line-height: 22px; }\n  .ssg-forms-input:focus {\n    outline: 0px solid transparent;\n    border: 1px solid #003D50; }\n  .ssg-forms-input.disabled, .ssg-forms-input:disabled {\n    cursor: not-allowed;\n    color: #CCCCCC; }\n  .ssg-forms-input.readonly, .ssg-forms-input:read-only {\n    cursor: not-allowed;\n    border: none;\n    border-bottom: 1px solid #CCCCCC;\n    border-radius: 3px;\n    padding: 0px; }\n    .ssg-forms-input.readonly:focus, .ssg-forms-input:read-only:focus {\n      border-bottom: 1px solid #CCCCCC; }\n\n.ssg-forms-input-group {\n  width: 100%;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  align-items: stretch;\n  border: 1px solid #CCCCCC;\n  border-radius: 3px;\n  background-color: white; }\n  .ssg-forms-input-group:focus-within, .ssg-forms-input-group.focus, .ssg-forms-input-group:focus {\n    outline: 0px solid transparent;\n    border: 1px solid #003D50; }\n  .ssg-forms-input-group.disabled {\n    cursor: not-allowed; }\n  .ssg-forms-input-group.readonly {\n    cursor: not-allowed;\n    border: none;\n    border-bottom: 1px solid #CCCCCC;\n    border-radius: 3px;\n    padding: 0px; }\n    .ssg-forms-input-group.readonly:focus-within, .ssg-forms-input-group.readonly:focus {\n      border: none;\n      border-bottom: 1px solid #CCCCCC; }\n  .ssg-forms-input-group .ssg-forms-input {\n    position: relative;\n    flex: 1 1 auto;\n    width: 1%;\n    border: none; }\n    .ssg-forms-input-group .ssg-forms-input:not(:first-child) {\n      padding-left: 0px; }\n    .ssg-forms-input-group .ssg-forms-input:not(:last-child) {\n      padding-right: 0px; }\n    .ssg-forms-input-group .ssg-forms-input:focus {\n      border: none; }\n    .ssg-forms-input-group .ssg-forms-input.readonly {\n      border: none; }\n    .ssg-forms-input-group .ssg-forms-input:read-only {\n      border: none; }\n  .ssg-forms-input-group .ssg-forms-input-section {\n    position: relative;\n    flex: 1 1 auto;\n    -ms-flex: 1;\n    color: #003D50;\n    font-family: \"graphik\", sans-serif;\n    font-size: 16px;\n    line-height: 22px;\n    border: none;\n    padding: 4px;\n    margin: 5px;\n    text-align: center;\n    background-color: white; }\n    .ssg-forms-input-group .ssg-forms-input-section::selection {\n      background: transparent; }\n    .ssg-forms-input-group .ssg-forms-input-section:focus {\n      outline: 0px solid transparent;\n      background-color: #F9ECC8; }\n    .ssg-forms-input-group .ssg-forms-input-section.disabled, .ssg-forms-input-group .ssg-forms-input-section:disabled {\n      cursor: not-allowed; }\n    .ssg-forms-input-group .ssg-forms-input-section.readonly, .ssg-forms-input-group .ssg-forms-input-section:read-only {\n      cursor: not-allowed; }\n  .ssg-forms-input-group .btn {\n    padding-top: 10px; }\n\n.input-error {\n  border: 1px solid #C70000; }\n\n.ssg-forms-addon {\n  border: black;\n  display: flex;\n  color: #767676;\n  font-family: \"graphik\", sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  padding: 10px 9px; }\n  .ssg-forms-addon.disabled {\n    cursor: not-allowed;\n    pointer-events: none;\n    color: #CCCCCC; }\n  .ssg-forms-addon.readonly {\n    cursor: not-allowed;\n    display: inline;\n    color: #003D50;\n    padding: 0px; }\n\n.end-line {\n  clear: left; }\n\n@media (min-width: 769px) {\n  .ssg-forms-element {\n    margin-bottom: 10px;\n    max-width: 416px; } }\n\n.ssg-form h1 {\n  color: #003D50;\n  font-family: \"graphik\", sans-serif;\n  font-size: 30px; }\n\n.tooltip-group {\n  display: flex; }\n\n.ssg-forms-plain-actions {\n  text-align: right; }\n  .ssg-forms-plain-actions .ssg-forms-btn {\n    margin: 10px 0px 10px 10px; }\n\n.ssg-forms-scrollable::-webkit-scrollbar {\n  width: 15px; }\n\n.ssg-forms-scrollable::-webkit-scrollbar-thumb {\n  background-color: #BCBEC0;\n  border-radius: 10px;\n  border: 3px solid transparent;\n  background-clip: content-box; }\n  .ssg-forms-scrollable::-webkit-scrollbar-thumb:hover {\n    background-color: #95989b; }\n\n.ssg-forms-scrollable::-webkit-scrollbar-track {\n  background-color: #F2F2F2; }\n\n/**\n * This style should be used by individual field labels.\n * It is smaller text than the question label, and all caps.\n * For example, if the question prompt is \"What is your address?\",\n * this style could be applied to the related fields \"Line 1\",\n * \"Line 2\", \"City\", \"State\", \"Zip\".\n */\n.ssg-field-label {\n  color: #003D50;\n  font-family: \"graphik\", sans-serif;\n  font-size: 11px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n  line-height: 13px;\n  text-transform: uppercase;\n  margin-bottom: 10px;\n  border: none; }\n  .ssg-field-label.readonly {\n    color: #767676; }\n  .ssg-field-label.disabled, .ssg-field-label:disabled {\n    color: #CCCCCC; }\n\n/**\n * This style should be used by the element question text.\n * It is larger text than the field label, and all mixed case.\n * For example this style might be applied to the prompt: \"What is your address?\"\n */\n.ssg-forms-label {\n  color: #003D50;\n  font-family: \"graphik\", sans-serif;\n  font-size: 16px;\n  line-height: 22px;\n  font-weight: normal;\n  margin-bottom: 10px;\n  border: none; }\n  .ssg-forms-label.readonly {\n    color: #767676; }\n  .ssg-forms-label.disabled, .ssg-forms-label:disabled {\n    color: #CCCCCC; }\n\n.ssg-forms-error-icon {\n  color: #C70000;\n  width: 18px;\n  height: 18px;\n  vertical-align: middle; }\n\n.ssg-forms-warning-icon {\n  color: #9F7417;\n  width: 18px;\n  height: 18px;\n  vertical-align: middle; }\n\n.ssg-forms-text {\n  color: #003D50;\n  font-family: \"graphik\", sans-serif; }\n  .ssg-forms-text.small {\n    font-size: 11px;\n    line-height: 14px;\n    letter-spacing: 0.5px; }\n  .ssg-forms-text.normal {\n    font-size: 16px;\n    line-height: 22px; }\n  .ssg-forms-text.large {\n    font-size: 18px;\n    line-height: 25px; }\n  .ssg-forms-text.xl {\n    font-size: 28px;\n    line-height: 38px; }\n", ""]);

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, "", ""]);

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-actions {\n  text-align: right;\n  background-color: #003D50; }\n  .ssg-forms-actions .ssg-forms-btn {\n    margin: 10px 10px 10px 0px;\n    color: white;\n    background-color: #003D50;\n    border: #FFFFFF;\n    height: 36px; }\n    .ssg-forms-actions .ssg-forms-btn:active, .ssg-forms-actions .ssg-forms-btn:hover {\n      background-color: rgba(255, 255, 255, 0.15); }\n    .ssg-forms-actions .ssg-forms-btn.ssg-forms-btn-secondary {\n      border: 1px solid white;\n      color: white; }\n      .ssg-forms-actions .ssg-forms-btn.ssg-forms-btn-secondary:active, .ssg-forms-actions .ssg-forms-btn.ssg-forms-btn-secondary:hover {\n        background-color: rgba(255, 255, 255, 0.15); }\n      .ssg-forms-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled, .ssg-forms-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled {\n        opacity: 0.5; }\n        .ssg-forms-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled:active, .ssg-forms-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled:hover, .ssg-forms-actions .ssg-forms-btn.ssg-forms-btn-secondary.disabled:focus, .ssg-forms-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled:active, .ssg-forms-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled:hover, .ssg-forms-actions .ssg-forms-btn.ssg-forms-btn-secondary:disabled:focus {\n          background-color: #003D50; }\n    .ssg-forms-actions .ssg-forms-btn.ssg-forms-btn-primary:hover {\n      background-color: #10463e;\n      border: #1f8374; }\n    .ssg-forms-actions .ssg-forms-btn.ssg-forms-btn-primary.disabled, .ssg-forms-actions .ssg-forms-btn.ssg-forms-btn-primary:disabled {\n      opacity: .5;\n      background-color: rgba(31, 132, 117, 0.3);\n      border: rgba(31, 132, 117, 0.3); }\n\n.ssg-forms-recaptcha {\n  margin-bottom: 10px; }\n\n.ssg-forms-body {\n  width: 55%;\n  border: 1px solid #CCCCCC;\n  border-radius: 3px;\n  background-color: white;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15);\n  padding: 20px;\n  margin: 30px auto 50px; }\n\n@media (max-width: 768px) {\n  .ssg-forms-body {\n    width: 100%;\n    margin: 30px 0px 50px; } }\n\n.ssg-forms-required-key {\n  float: right; }\n\n@media (min-width: 769px) {\n  .ssg-forms-body .ssg-forms-element {\n    max-width: 100%; } }\n", ""]);

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-cancel-icon {\n  margin-left: 5px; }\n", ""]);

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-collapsible-section-display {\n  border: 1px solid #CCCCCC; }\n\n.ssg-forms-collapsible-section-toggle {\n  background-color: #FFFFFF;\n  padding: 15px 10px;\n  width: 100%;\n  border: none;\n  text-align: left; }\n\n.ssg-forms-collapsible-section-icon {\n  color: #1F8475;\n  margin-right: 10px; }\n  .ssg-forms-collapsible-section-icon .ssg-custom-icon {\n    color: #1F8475; }\n\n.ssg-forms-collapsible-section-label {\n  font-weight: bold; }\n\n.ssg-forms-collapsible-section-content {\n  background-color: #FFFFFF;\n  padding: 20px 10px; }\n", ""]);

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-custom-icon {\n  width: 100%;\n  color: #003D50; }\n\n.ssg-custom-icon-container-inline {\n  display: inline-block; }\n", ""]);

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-required-indicator {\n  color: red;\n  white-space: pre; }\n  .ssg-forms-required-indicator::before {\n    margin-left: 1px;\n    content: \"*\"; }\n\n.ssg-forms-legend.tooltip,\n.ssg-forms-label.tooltip {\n  max-width: max-content;\n  max-width: intrinsic;\n  max-width: -moz-max-content; }\n\n.ssg-forms-no-content {\n  margin: 0px;\n  padding: 0px; }\n\n.ssg-legend-wrapper {\n  margin: auto 0px;\n  display: inline-block; }\n\n.ssg-legend-centered-text-wraper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center; }\n", ""]);

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-image-display {\n  display: inline-block;\n  text-align: center;\n  max-width: 500px; }\n  .ssg-forms-image-display .ssg-forms-image-display-container {\n    display: inline-block;\n    padding: 40px 89px 0px;\n    background-image: radial-gradient(circle farthest-corner at 50% 100%, #BBBBBB 0%, rgba(187, 187, 187, 0) 70%); }\n  .ssg-forms-image-display .ssg-forms-image-display-primary-text {\n    font-size: 24px;\n    font-weight: bold;\n    line-height: 31px;\n    margin-top: 30px; }\n  .ssg-forms-image-display .ssg-forms-image-display-secondary-text {\n    margin-top: 5px;\n    font-size: 16px;\n    line-height: 22px; }\n", ""]);

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-loading-spinner {\n  display: inline-block; }\n\n.ssg-loading-pane {\n  position: relative; }\n\n.ssg-display-over-content {\n  position: absolute;\n  display: block;\n  z-index: 1050;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%); }\n\n.ssg-loading-display {\n  max-width: 100%;\n  overflow-wrap: break-word;\n  display: inline-block;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.25);\n  background-color: #FFFFFF; }\n  .ssg-loading-display.spinner {\n    padding: 9px;\n    border-radius: 18px; }\n  .ssg-loading-display.loading-bar {\n    padding: 20px;\n    border-radius: 5px; }\n\n.ssg-loading-text {\n  padding-left: 9px; }\n\n.ssg-loading-bar-background {\n  margin-top: 8px;\n  display: block;\n  height: 5px;\n  background-color: #a0e9de; }\n  .ssg-loading-bar-background.error {\n    background-color: #ffaeae; }\n  .ssg-loading-bar-background.warning {\n    background-color: #f3dba9; }\n\n.ssg-loading-bar {\n  height: inherit;\n  background-color: #1F8475; }\n  .ssg-loading-bar.error {\n    background-color: #C70000; }\n  .ssg-loading-bar.warning {\n    background-color: #9F7417; }\n", ""]);

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-menu-btn {\n  width: 100%;\n  border: none;\n  padding: 15px 20px;\n  background-color: transparent;\n  text-align: left; }\n  .ssg-forms-menu-btn:hover {\n    cursor: pointer;\n    background-color: #FFFFFF; }\n", ""]);

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-menu {\n  position: relative;\n  width: min-content; }\n\n.ssg-forms-menu-list {\n  position: absolute;\n  z-index: 1;\n  list-style-type: none;\n  top: calc(100% + 5px);\n  right: 0;\n  width: 200px;\n  margin: 0px; }\n\n.ssg-forms-menu-item {\n  display: block;\n  width: 100%;\n  color: #003D50;\n  border: 1px solid #CCCCCC;\n  background-color: white;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15); }\n", ""]);

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-modal {\n  height: auto;\n  display: block;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1050;\n  overflow: hidden;\n  -webkit-overflow-scrolling: touch;\n  outline: 0; }\n  .ssg-forms-modal.hidden {\n    display: none; }\n\n.ssg-forms-modal-backdrop {\n  display: block;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1040;\n  background-color: #000;\n  opacity: 0.5; }\n  .ssg-forms-modal-backdrop.hidden {\n    display: none; }\n\n.ssg-forms-modal-dialog {\n  overflow-y: initial !important;\n  position: relative;\n  margin: 30px auto;\n  outline: none;\n  width: 85%;\n  max-width: 611px;\n  height: 100%;\n  max-height: 85%;\n  -webkit-transform: translate(0, 0);\n  -ms-transform: translate(0, 0);\n  -o-transform: translate(0, 0);\n  transform: translate(0, 0); }\n\n.ssg-forms-modal-content {\n  position: relative;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n  -ms-flex-direction: column;\n  -webkit-flex-direction: column;\n  flex-direction: column;\n  max-height: 100%;\n  background-color: white;\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n  border: 1px solid #CCCCCC;\n  border-radius: 5px;\n  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25);\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.25);\n  font-family: \"graphik\", sans-serif;\n  color: #003D50; }\n\n.ssg-forms-modal-header {\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 25px;\n  padding: 20px;\n  border-bottom: 1px solid #dfdfdf; }\n\n.ssg-forms-modal-title {\n  margin: 0; }\n\n.ssg-forms-close {\n  float: right; }\n\n.ssg-forms-modal-body {\n  overflow-y: auto;\n  padding: 20px;\n  max-height: 70vh; }\n\n.ssg-forms-modal-footer {\n  padding: 10px 21px;\n  text-align: right;\n  border-top: 1px solid #dfdfdf; }\n\n@media (max-width: 768px) {\n  .ssg-forms-modal-dialog {\n    margin: 7vh 7vw; }\n    .ssg-forms-modal-dialog.ssg-forms-mobile-modal-dialog {\n      margin: 0px;\n      width: 100%;\n      height: 100%;\n      max-height: unset;\n      max-width: unset; }\n      .ssg-forms-modal-dialog.ssg-forms-mobile-modal-dialog .ssg-forms-modal-content {\n        height: 100%;\n        width: 100%;\n        border-radius: 0px; }\n      .ssg-forms-modal-dialog.ssg-forms-mobile-modal-dialog .ssg-forms-modal-body {\n        max-height: unset;\n        height: 100%;\n        padding: 0px; } }\n\n.modal-actions {\n  text-align: right; }\n  .modal-actions .ssg-forms-btn {\n    margin-right: 10px; }\n", ""]);

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-app-page {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #FFFFFF;\n  overflow: auto; }\n\n.ssg-forms-app-content {\n  margin-top: 62px;\n  margin-left: 230px;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-height: calc(100% - 62px); }\n  .ssg-forms-app-content.ssg-forms-app-hide-nav {\n    margin-left: 0px; }\n\n@media (max-width: 768px) {\n  .ssg-forms-app-content {\n    margin-top: 46px;\n    margin-left: 0px;\n    min-height: calc(100% - 46px); } }\n", ""]);

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-nav-header {\n  z-index: 1000;\n  position: fixed;\n  display: flex;\n  top: 0px;\n  left: 0px;\n  width: 100vw;\n  height: 62px;\n  background-color: #FFFFFF;\n  padding: 0px; }\n  .ssg-forms-nav-header .ssg-forms-nav-header-menu-items {\n    display: flex;\n    flex-grow: 1;\n    width: 100%;\n    height: 100%; }\n  .ssg-forms-nav-header .ssg-forms-nav-header-button {\n    height: 100%;\n    position: relative;\n    text-align: center;\n    padding: 10px 20px 5px;\n    border: none;\n    background-color: #FFFFFF;\n    margin: 0px; }\n    .ssg-forms-nav-header .ssg-forms-nav-header-button.ssg-forms-alt-header-button {\n      background-color: #003D50;\n      color: white; }\n      .ssg-forms-nav-header .ssg-forms-nav-header-button.ssg-forms-alt-header-button:hover {\n        background-color: #002a37; }\n      .ssg-forms-nav-header .ssg-forms-nav-header-button.ssg-forms-alt-header-button .ssg-custom-icon {\n        color: unset; }\n    .ssg-forms-nav-header .ssg-forms-nav-header-button .ssg-forms-text.ssg-forms-nav-header-button-text {\n      font-size: 10px;\n      font-weight: bold;\n      letter-spacing: 0.5px;\n      line-height: 13px;\n      text-transform: uppercase;\n      margin: 1px; }\n    .ssg-forms-nav-header .ssg-forms-nav-header-button:hover {\n      background-color: #DDDDDD; }\n    .ssg-forms-nav-header .ssg-forms-nav-header-button:disabled {\n      color: #CCCCCC;\n      cursor: not-allowed; }\n      .ssg-forms-nav-header .ssg-forms-nav-header-button:disabled .ssg-custom-icon {\n        color: #CCCCCC; }\n      .ssg-forms-nav-header .ssg-forms-nav-header-button:disabled .ssg-forms-nav-header-button-text {\n        color: #CCCCCC; }\n      .ssg-forms-nav-header .ssg-forms-nav-header-button:disabled:hover {\n        background-color: unset; }\n  .ssg-forms-nav-header .ssg-forms-nav-header-item {\n    height: 100%;\n    position: relative;\n    background-color: #FFFFFF;\n    border: none;\n    margin: 0px; }\n\n@media (max-width: 768px) {\n  .ssg-forms-nav-header {\n    height: 46px; }\n    .ssg-forms-nav-header .ssg-forms-nav-header-button {\n      padding: 10px 10px 5px; }\n      .ssg-forms-nav-header .ssg-forms-nav-header-button .ssg-forms-text.ssg-forms-nav-header-button-text {\n        display: none; } }\n", ""]);

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-nav-bar {\n  top: 62px;\n  bottom: 0;\n  left: 0;\n  display: block;\n  position: fixed;\n  z-index: 1000;\n  overflow-x: hidden;\n  overflow-y: auto;\n  background-color: #003D50;\n  width: 230px;\n  color: #ffffff; }\n  .ssg-forms-nav-bar a {\n    color: #ffffff;\n    display: block;\n    text-decoration: none; }\n    .ssg-forms-nav-bar a div {\n      line-height: 25px;\n      font-size: 16px;\n      padding-right: 8px; }\n    .ssg-forms-nav-bar a .ssg-forms-nav-logo-wrapper {\n      float: left;\n      height: 25px;\n      width: 20px;\n      padding: 0px;\n      background-position: center;\n      background-repeat: no-repeat; }\n  .ssg-forms-nav-bar a:hover {\n    background-color: #002a37;\n    color: #FFFFFF; }\n  .ssg-forms-nav-bar a.router-link-active,\n  .ssg-forms-nav-bar a.router-link-active:hover {\n    color: #DC8A5E;\n    background-color: #002a37; }\n  .ssg-forms-nav-bar .ssg-forms-nav-item {\n    cursor: pointer;\n    padding: 10px 3px 10px 20px;\n    word-break: normal; }\n  .ssg-forms-nav-bar .ssg-forms-nav-icon {\n    color: inherit; }\n    .ssg-forms-nav-bar .ssg-forms-nav-icon .ssg-forms-nav-icon-account-svg {\n      max-width: 20px;\n      max-height: 20px; }\n  .ssg-forms-nav-bar .ssg-forms-nav-icon-container {\n    padding-inline-start: 0px; }\n  .ssg-forms-nav-bar .ssg-forms-nav-label {\n    padding-right: 10px;\n    word-break: normal; }\n  .ssg-forms-nav-bar .ssg-forms-nav-section {\n    line-height: 25px;\n    font-size: 16px; }\n    .ssg-forms-nav-bar .ssg-forms-nav-section .ssg-forms-nav-logo-wrapper {\n      float: left;\n      height: 25px;\n      width: 20px;\n      padding: 0px;\n      background-position: center;\n      background-repeat: no-repeat; }\n    .ssg-forms-nav-bar .ssg-forms-nav-section .ssg-forms-section-title {\n      display: inline-block;\n      margin-left: 10px;\n      max-width: 145px; }\n    .ssg-forms-nav-bar .ssg-forms-nav-section:hover {\n      background-color: #003D50; }\n    .ssg-forms-nav-bar .ssg-forms-nav-section.zone-expanded {\n      background-color: #002a37; }\n  .ssg-forms-nav-bar .ssg-forms-nav-section-links {\n    margin-left: 30px; }\n    .ssg-forms-nav-bar .ssg-forms-nav-section-links a:hover {\n      background-color: inherit;\n      color: #DC8A5E; }\n    .ssg-forms-nav-bar .ssg-forms-nav-section-links a.router-link-active {\n      background-color: inherit;\n      color: #DC8A5E; }\n  .ssg-forms-nav-bar ul {\n    list-style: none;\n    padding: 0px;\n    margin: 0px;\n    margin-top: 0px; }\n    .ssg-forms-nav-bar ul li {\n      list-style: none;\n      padding: 0px;\n      margin: 0px;\n      color: #FFFFFF; }\n\n.ssg-forms-nav-bar.active {\n  display: block;\n  background-color: rgba(0, 0, 0, 0.25); }\n\n@media (max-width: 768px) {\n  .ssg-forms-nav-bar {\n    top: 46px;\n    width: 100vw;\n    display: block; } }\n", ""]);

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-pagination {\n  display: inline-block;\n  margin-left: 30px;\n  vertical-align: top; }\n  .ssg-forms-pagination .ssg-forms-page-input {\n    width: 50px;\n    height: 36px;\n    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.12);\n    margin-left: 10px;\n    margin-right: 10px; }\n  .ssg-forms-pagination .ssg-forms-pagination-text {\n    margin-right: 10px;\n    font-family: \"graphik\", sans-serif;\n    color: #003D50;\n    line-height: 17px;\n    letter-spacing: 1.09px;\n    font-size: 12px; }\n  .ssg-forms-pagination .ssg-forms-btn {\n    padding: 8px 14px;\n    border: none;\n    border-radius: 3px;\n    width: 36px;\n    height: 36px; }\n\n.ssg-forms-per-page {\n  display: inline-block; }\n  .ssg-forms-per-page .ssg-forms-per-page-label {\n    padding: 9px 11px 9px 0px;\n    margin-bottom: 0px; }\n  .ssg-forms-per-page .ssg-forms-dropdown {\n    width: 78px;\n    min-width: unset; }\n  .ssg-forms-per-page .ssg-tooltip-inline {\n    display: inline-flex;\n    height: 36px; }\n\n.ssg-forms-page {\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n  -ms-flex-direction: column;\n  -webkit-flex-direction: column;\n  flex-direction: column;\n  border: 1px solid #CCCCCC;\n  border-radius: 5px;\n  background-color: #FFFFFF;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15); }\n  .ssg-forms-page .ssg-forms-page-footer,\n  .ssg-forms-page .ssg-forms-page-header {\n    padding: 15px 20px; }\n    .ssg-forms-page .ssg-forms-page-footer .ssg-forms-pagination-group,\n    .ssg-forms-page .ssg-forms-page-header .ssg-forms-pagination-group {\n      float: right; }\n  .ssg-forms-page .ssg-forms-page-header-addl-content {\n    display: inline-block;\n    width: 100%; }\n  .ssg-forms-page .ssg-forms-page-body {\n    border-bottom: 1px solid #cccccc; }\n  .ssg-forms-page .ssg-forms-page-title-bar {\n    color: #003D50;\n    font-family: \"graphik\", sans-serif;\n    font-size: 18px;\n    line-height: 25px;\n    display: inline-block;\n    width: 100%; }\n    .ssg-forms-page .ssg-forms-page-title-bar .ssg-forms-page-title-bar-text {\n      float: left;\n      line-height: 39px; }\n\n@media (max-width: 768px) {\n  .ssg-forms-page .ssg-forms-page-header {\n    padding: 0px; }\n    .ssg-forms-page .ssg-forms-page-header .ssg-forms-page-title-bar {\n      width: 100%;\n      padding: 15px 20px;\n      border-bottom: 1px solid #CCCCCC; }\n      .ssg-forms-page .ssg-forms-page-header .ssg-forms-page-title-bar .ssg-forms-page-title-bar-text {\n        float: left;\n        width: 100%; }\n    .ssg-forms-page .ssg-forms-page-header .ssg-forms-pagination-group {\n      padding: 10px;\n      float: none;\n      display: block;\n      padding-top: 10px;\n      border-bottom: 1px solid #CCCCCC;\n      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15); }\n    .ssg-forms-page .ssg-forms-page-header .ssg-forms-per-page {\n      margin: 0 auto; }\n    .ssg-forms-page .ssg-forms-page-header .ssg-forms-pagination {\n      display: none; }\n  .ssg-forms-page .ssg-forms-page-footer .ssg-forms-pagination-group {\n    margin: 0 auto;\n    float: none; }\n  .ssg-forms-page .ssg-forms-page-footer .ssg-forms-per-page {\n    display: none; }\n  .ssg-forms-page .ssg-forms-page-header-addl-content {\n    display: inline-block;\n    padding-left: 20px;\n    padding-right: 20px;\n    width: 100%; } }\n", ""]);

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-saving-icon {\n  margin-left: 5px; }\n", ""]);

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-highlighted-text {\n  color: #DC8A5E; }\n", ""]);

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-search-bar-dim .ssg-forms-input-group {\n  border: none;\n  background-color: #FFFFFF; }\n  .ssg-forms-search-bar-dim .ssg-forms-input-group .ssg-custom-icon {\n    color: unset; }\n  .ssg-forms-search-bar-dim .ssg-forms-input-group .ssg-forms-input {\n    background-color: unset; }\n  .ssg-forms-search-bar-dim .ssg-forms-input-group:focus-within, .ssg-forms-search-bar-dim .ssg-forms-input-group.focus, .ssg-forms-search-bar-dim .ssg-forms-input-group:focus {\n    outline: 0px solid transparent;\n    border: none; }\n\n.ssg-forms-search-bar-clear-icon {\n  color: #003D50; }\n", ""]);

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-table {\n  width: 100%;\n  max-width: 100%; }\n  .ssg-forms-table .ssg-forms-empty-text {\n    padding: 15px 20px; }\n  .ssg-forms-table .ssg-forms-sort-display {\n    display: none; }\n  .ssg-forms-table .ssg-forms-table-heading {\n    background-color: #CCCCCC;\n    border: 1px solid #CCCCCC; }\n    .ssg-forms-table .ssg-forms-table-heading .ssg-forms-table-header-label {\n      padding: 5px; }\n    .ssg-forms-table .ssg-forms-table-heading .ssg-forms-table-header {\n      color: #767676;\n      font-family: \"graphik\", sans-serif;\n      font-size: 11px;\n      font-weight: bold;\n      letter-spacing: 0.5px;\n      line-height: 14px;\n      text-transform: uppercase;\n      padding: 15px 20px;\n      text-align: left; }\n      .ssg-forms-table .ssg-forms-table-heading .ssg-forms-table-header.selected {\n        color: #003D50; }\n  .ssg-forms-table .ssg-forms-table-row {\n    border-bottom: 1px solid #CCCCCC; }\n    .ssg-forms-table .ssg-forms-table-row:last-child {\n      border-bottom: none; }\n    .ssg-forms-table .ssg-forms-table-row .ssg-forms-table-data {\n      padding: 15px 20px; }\n\n.ssg-forms-standalone-table {\n  background-color: white;\n  border: 1px solid #CCCCCC;\n  border-radius: 5px;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15); }\n  .ssg-forms-standalone-table .ssg-forms-table-heading {\n    background-color: white;\n    border-top: none;\n    border-right: none;\n    border-left: none; }\n    .ssg-forms-standalone-table .ssg-forms-table-heading .ssg-forms-table-header {\n      color: #003D50; }\n\n@media (max-width: 768px) {\n  .ssg-forms-table {\n    width: 100%; }\n    .ssg-forms-table .ssg-forms-sort-display {\n      display: block;\n      padding: 15px 20px; }\n      .ssg-forms-table .ssg-forms-sort-display .ssg-forms-dropdown {\n        display: block;\n        margin: 0px auto;\n        padding: 9px 10px;\n        border: 1px solid #CCCCCC;\n        border-radius: 3px;\n        background-color: #FFFFFF; }\n    .ssg-forms-table .ssg-forms-table-heading {\n      display: none; }\n    .ssg-forms-table .ssg-forms-table-row:nth-of-type(2n) {\n      background-color: #CCCCCC; }\n    .ssg-forms-table .ssg-forms-table-row .ssg-forms-table-data {\n      display: block;\n      text-align: left;\n      padding: 5px 10px; }\n      .ssg-forms-table .ssg-forms-table-row .ssg-forms-table-data:first-child {\n        padding-top: 10px; }\n      .ssg-forms-table .ssg-forms-table-row .ssg-forms-table-data:last-child {\n        padding-bottom: 10px; }\n      .ssg-forms-table .ssg-forms-table-row .ssg-forms-table-data:before {\n        content: attr(data-th);\n        display: inline-block;\n        text-align: left;\n        width: 60%;\n        color: #767676;\n        font-family: \"graphik\", sans-serif;\n        font-size: 11px;\n        font-weight: bold;\n        letter-spacing: 0.5px;\n        line-height: 14px;\n        text-transform: uppercase; }\n      .ssg-forms-table .ssg-forms-table-row .ssg-forms-table-data[data-selected=\"true\"]:before {\n        color: #003D50; } }\n", ""]);

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-tab-header {\n  color: #003D50;\n  font-family: \"graphik\", sans-serif;\n  font-size: 30px; }\n\n.ssg-forms-tab {\n  display: flex;\n  padding: 15px 20px 12px;\n  color: #003D50;\n  font-family: \"graphik\", sans-serif;\n  font-weight: 300;\n  letter-spacing: 0.5px;\n  line-height: 18px;\n  font-size: 13px;\n  text-transform: uppercase;\n  text-decoration: none;\n  border-bottom: 3px solid transparent; }\n  .ssg-forms-tab:hover {\n    color: #1F8475;\n    background-color: rgba(31, 132, 117, 0.15);\n    cursor: pointer;\n    text-decoration: none; }\n  .ssg-forms-tab.active {\n    color: #1F8475;\n    border-bottom: 3px solid #1F8475;\n    font-weight: bold; }\n  .ssg-forms-tab.disabled, .ssg-forms-tab:disabled {\n    color: #CCCCCC;\n    cursor: not-allowed;\n    background-color: unset;\n    border: none; }\n\n.ssg-forms-tab-list {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n  border-bottom: 1px solid #CCCCCC;\n  margin-bottom: 10px; }\n\n.ssg-forms-tab-list-item {\n  display: list-item; }\n", ""]);

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-tooltip {\n  margin-left: 5px;\n  margin-right: 5px;\n  display: inline-block;\n  position: relative;\n  width: 16px; }\n  .ssg-tooltip .ssg-tooltip-text {\n    display: none;\n    text-align: left;\n    text-transform: none;\n    background-color: #5A5B5E;\n    color: #FFFFFF;\n    padding: 15px;\n    border: 1px solid #5A5B5E;\n    border-radius: 5px;\n    font-weight: 300;\n    word-wrap: break-word;\n    height: -moz-min-content;\n    height: min-content;\n    width: intrinsic;\n    width: -moz-max-content;\n    width: max-content;\n    min-width: 50px;\n    max-width: 320px;\n    position: absolute;\n    z-index: 10000; }\n  .ssg-tooltip .shown {\n    display: block; }\n  .ssg-tooltip .ssg-tooltip-text:after {\n    width: 0;\n    height: 0;\n    border-color: #5A5B5E;\n    color: #5A5B5E;\n    border-left: 14px solid transparent;\n    border-top: 14px solid #5A5B5E;\n    content: '';\n    position: absolute;\n    bottom: -14px;\n    margin-left: -10px; }\n  .ssg-tooltip .ssg-tooltip-text.top:after {\n    border-top-color: transparent;\n    border-bottom: 14px solid #5A5B5E;\n    top: -28px;\n    bottom: auto; }\n  .ssg-tooltip .ssg-tooltip-text.left:after {\n    right: 10px;\n    margin: 0; }\n  .ssg-tooltip .ssg-tooltip-text.right:after {\n    left: 10px;\n    margin: 0; }\n  .ssg-tooltip .ssg-tooltip-icon-wrapper {\n    height: 36px;\n    width: 36px;\n    background-color: transparent;\n    display: inline-block;\n    padding: 9px; }\n    .ssg-tooltip .ssg-tooltip-icon-wrapper:focus {\n      outline: none; }\n  .ssg-tooltip .ssg-tooltip-icon {\n    height: 18px;\n    width: 18px;\n    color: #1F8475;\n    cursor: pointer; }\n  .ssg-tooltip .ssg-tooltip-icon-wrapper:focus > .ssg-tooltip-icon-highlight {\n    color: #FFEBBD; }\n  .ssg-tooltip .ssg-tooltip-icon-wrapper:hover > .ssg-tooltip-icon-highlight {\n    color: #FFEBBD; }\n  .ssg-tooltip .ssg-tooltip-icon-highlight {\n    color: transparent; }\n    .ssg-tooltip .ssg-tooltip-icon-highlight:focus, .ssg-tooltip .ssg-tooltip-icon-highlight:hover {\n      color: #FFEBBD; }\n", ""]);

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-widget {\n  position: relative;\n  display: inline-block;\n  min-height: 200px;\n  min-width: 200px;\n  width: fit-content;\n  padding: 20px;\n  border-radius: 5px;\n  background-color: #FFFFFF;\n  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.15); }\n\n.ssg-forms-widget-anchor {\n  position: absolute;\n  top: 0px;\n  left: 50%;\n  transform: translate(-50%, -50%); }\n", ""]);

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(3)();
exports.push([module.i, ".ssg-forms-wizard-title {\n  text-align: center; }\n\n.ssg-forms-wizard-page-markers {\n  margin: 30px 0px;\n  padding: 15px;\n  display: flex;\n  justify-content: space-evenly; }\n  .ssg-forms-wizard-page-markers .ssg-forms-wizard-page-title {\n    color: #767676; }\n    .ssg-forms-wizard-page-markers .ssg-forms-wizard-page-title .ssg-forms-wizard-page-number {\n      display: inline-block;\n      text-align: center;\n      height: 24px;\n      width: 24px;\n      margin-right: 5px;\n      border-radius: 50%;\n      background-color: #ECE8E6;\n      color: white; }\n    .ssg-forms-wizard-page-markers .ssg-forms-wizard-page-title.ssg-forms-wizard-completed-page {\n      color: #003D50; }\n      .ssg-forms-wizard-page-markers .ssg-forms-wizard-page-title.ssg-forms-wizard-completed-page .ssg-forms-wizard-page-number {\n        background-color: #003D50; }\n    .ssg-forms-wizard-page-markers .ssg-forms-wizard-page-title.ssg-forms-wizard-active-page {\n      color: #1F8475;\n      font-weight: bold; }\n      .ssg-forms-wizard-page-markers .ssg-forms-wizard-page-title.ssg-forms-wizard-active-page .ssg-forms-wizard-page-number {\n        background-color: #1F8475; }\n  .ssg-forms-wizard-page-markers .ssg-forms-wizard-nav-icon {\n    color: #CCCCCC; }\n", ""]);

/***/ }),
/* 214 */
/***/ (function(module, exports) {

module.exports = "<svg width=\"193\" height=\"36\" viewBox=\"0 0 193 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n        d=\"M188.406 27.6275H187.608V27.2459H189.603V27.6275H188.805V29.6742H188.406V27.6275ZM189.925 27.2459H190.584L191.243 28.7549H191.33L191.989 27.2459H192.631V29.6742H192.232V27.9744L192.267 27.6449H192.232L191.59 29.1192H190.966L190.324 27.6449H190.289L190.324 27.9744V29.6742H189.925V27.2459Z\"\n        fill=\"#420C7D\" />\n    <path\n        d=\"M103.609 19.4986V29.6741H100.106V19.8323C100.106 16.8295 98.7716 15.4949 96.1028 15.4949C93.4336 15.4949 91.4318 17.4967 91.4318 20.4995V29.6741H87.9288V12.6592H91.4318V14.9945H91.5985C91.5985 14.9945 93.1001 12.3257 96.9365 12.3257C101.107 12.3257 103.609 14.8277 103.609 19.4986ZM85.0617 21.1667C85.0617 26.171 81.2248 30.0079 76.2203 30.0079C71.2162 30.0079 67.3793 26.171 67.3793 21.1667C67.3793 16.1623 71.2162 12.3257 76.2203 12.3257C81.2248 12.3257 85.0617 16.1623 85.0617 21.1667ZM81.3916 21.1667C81.3916 17.6637 79.223 15.4949 76.2203 15.4949C73.2175 15.4949 71.049 17.6637 71.049 21.1667C71.049 24.6698 73.2175 26.8384 76.2203 26.8384C79.223 26.8384 81.3916 24.6698 81.3916 21.1667ZM65.1176 23.0017C65.1176 26.8384 62.4073 29.6741 57.0693 29.6741L44.9985 29.6742V26.4356H47.2675V9.55878H44.9985V6.32025H57.236C61.7398 6.32025 64.2839 8.98925 64.2839 12.3257C64.2839 16.3291 60.9057 17.1633 60.9057 17.1633V17.33C60.9057 17.33 65.1176 17.8305 65.1176 23.0017ZM50.9096 16.0511H57.0384C59.4495 16.0511 60.7477 14.7528 60.7477 12.6757C60.7477 10.8582 59.4495 9.5599 57.0384 9.5599H50.9096V16.0511ZM61.5734 22.7615C61.5734 20.5596 60.1054 19.0915 56.8024 19.0915H50.9096V26.4316H56.8024C60.1054 26.4316 61.5734 24.9636 61.5734 22.7615ZM157.478 15.1614H157.311V12.6592H153.808V29.6741H157.311V20.4995C157.311 17.6637 159.313 15.8286 161.982 15.8286H164.15V12.4924H162.149C158.812 12.4924 157.478 15.1614 157.478 15.1614ZM143.913 15.1614H143.746V12.6592H140.243V29.6741H143.746V20.4995C143.746 17.6637 145.748 15.8286 148.417 15.8286H150.586V12.4924H148.584C145.248 12.4924 143.913 15.1614 143.913 15.1614ZM112.134 25.1079V15.8286H116.752V12.6592H112.134V8.98925H108.631V12.6592H106.63V15.8286H108.631V26.0269C108.631 28.0412 110.264 29.6741 112.278 29.6741H116.919V26.4333H113.46C112.728 26.4333 112.134 25.8399 112.134 25.1079ZM136.688 21.1667V22.3343H122.843C123.343 25.1703 125.512 26.7974 128.014 26.8384C130.567 26.8802 132.42 25.7134 133.188 24.8767L135.547 27.0311C134.522 28.2213 132.021 30.0079 128.139 30.0079C123.01 30.0079 119.34 26.171 119.34 21.1667C119.34 16.1623 123.177 12.3257 128.014 12.3257C132.852 12.3257 136.688 16.1623 136.688 21.1667ZM133.019 19.4986C132.685 17.4967 131.017 15.4949 128.014 15.4949C125.679 15.4949 123.51 16.9963 123.01 19.4986H133.019ZM184.902 26.4366V29.6742H182.183C180.715 29.6742 179.342 28.7648 178.77 27.3407V27.3407H178.603C178.603 27.3407 176.768 30.0097 173.265 30.0097C168.761 30.0097 165.258 26.5066 165.258 21.1686C165.258 15.8305 168.761 12.3276 173.265 12.3276C176.768 12.3276 178.603 14.8297 178.603 14.8297H178.77V12.661H182.273V25.9054C182.273 26.1988 182.511 26.4366 182.804 26.4366H184.902ZM178.77 21.1686C178.77 17.4986 176.768 15.4969 173.932 15.4969C170.93 15.4969 168.928 17.4986 168.928 21.1686C168.928 24.8385 170.93 26.8404 173.932 26.8404C176.768 26.8404 178.77 24.8385 178.77 21.1686Z\"\n        fill=\"#420C7D\" />\n    <path\n        d=\"M5.37571 27.8662V30.8307C5.37478 30.8297 5.37381 30.8289 5.37287 30.8279C4.4632 29.9324 3.64831 28.9409 2.94469 27.8697C2.94393 27.8685 2.94322 27.8674 2.94246 27.8662H5.37571ZM7.74563 3.20455C7.74557 3.20455 7.74554 3.20461 7.74548 3.20461C6.89801 3.79313 6.10354 4.45254 5.37059 5.1743H7.74563V3.20455ZM16.5074 8.1358V0.0610547C13.5704 0.302109 10.8331 1.24828 8.46521 2.73V8.1358H16.5074ZM17.2376 26.4346H29.9694V20.1998H29.0708H17.2376V26.4346ZM28.3181 15.8019H35.8671C35.867 15.8012 35.867 15.8004 35.8669 15.7998C35.5954 13.5721 34.9169 11.47 33.9081 9.57012C33.9075 9.56912 33.907 9.56812 33.9064 9.56713H28.3181V15.8019ZM28.3182 32.7509C29.14 32.175 29.9114 31.5322 30.6246 30.8305C30.6248 30.8302 30.6251 30.8299 30.6253 30.8297H28.3182V32.7509ZM5.37466 6.60902H4.06213C1.52323 9.71186 0 13.678 0 18C0 18.2562 0.00536133 18.5112 0.0159668 18.7648C0.0159668 18.7652 0.0159961 18.7655 0.0159961 18.7658H5.37466V6.60902ZM30.6257 29.3954H31.9343C31.9348 29.3948 31.9353 29.3942 31.9358 29.3936C34.4759 26.2904 36 22.3232 36 18C36 17.7441 35.9947 17.4894 35.9841 17.2361H30.6257V29.3954ZM19.5563 27.8689V35.9337C19.5564 35.9337 19.5564 35.9337 19.5565 35.9337C22.4946 35.682 25.2311 34.7246 27.5958 33.2317C27.5967 33.2312 27.5976 33.2305 27.5985 33.2299L27.5958 27.8689H19.5563ZM8.46521 29.3954H16.5074V29.0168V17.2362H8.46521V29.3954ZM27.5958 6.60773H19.5563V18.7671H27.5958V18.0423V6.60773ZM33.057 8.13287C33.0568 8.13264 33.0567 8.13246 33.0566 8.13223C32.3523 7.05984 31.5365 6.06732 30.6257 5.1709L30.6258 8.13287H33.057ZM6.09533 30.8297V31.5013C6.09551 31.5015 6.09565 31.5016 6.09583 31.5018C9.26868 34.3014 13.436 36 18 36H18C18.2804 36 18.5593 35.9936 18.8365 35.9809C18.8367 35.9809 18.8368 35.9809 18.837 35.9809L18.8365 30.8305L6.09533 30.8297ZM7.7456 20.1998H0.133096C0.133184 20.2005 0.133242 20.2012 0.13333 20.2018C0.405176 22.4308 1.08448 24.534 2.09446 26.4346H7.7456V20.1998H7.7456ZM29.9058 5.17207V4.49971C26.7328 1.69928 22.5649 0 18 0H18C17.7446 0 17.4904 0.00533204 17.2376 0.0158789C17.2341 0.0159961 17.2307 0.0162305 17.2273 0.0164063L17.2376 5.17207H29.9058ZM18.8368 9.57006H18.0962H6.09434V15.8048H18.8368V9.57006Z\"\n        fill=\"#420C7D\" />\n</svg>"

/***/ }),
/* 215 */
/***/ (function(module, exports) {

module.exports = "<svg width=\"193\" height=\"36\" viewBox=\"0 0 193 36\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n    <path\n        d=\"M188.406 27.6275H187.608V27.2459H189.603V27.6275H188.805V29.6742H188.406V27.6275ZM189.925 27.2459H190.584L191.243 28.7549H191.33L191.989 27.2459H192.631V29.6742H192.232V27.9744L192.267 27.6449H192.232L191.59 29.1192H190.966L190.324 27.6449H190.289L190.324 27.9744V29.6742H189.925V27.2459Z\"\n        fill=\"white\" />\n    <path\n        d=\"M103.609 19.4986V29.6741H100.106V19.8323C100.106 16.8295 98.7716 15.4949 96.1028 15.4949C93.4336 15.4949 91.4318 17.4967 91.4318 20.4995V29.6741H87.9288V12.6592H91.4318V14.9945H91.5985C91.5985 14.9945 93.1001 12.3257 96.9365 12.3257C101.107 12.3257 103.609 14.8277 103.609 19.4986ZM85.0617 21.1667C85.0617 26.171 81.2248 30.0079 76.2203 30.0079C71.2162 30.0079 67.3793 26.171 67.3793 21.1667C67.3793 16.1623 71.2162 12.3257 76.2203 12.3257C81.2248 12.3257 85.0617 16.1623 85.0617 21.1667ZM81.3916 21.1667C81.3916 17.6637 79.223 15.4949 76.2203 15.4949C73.2175 15.4949 71.049 17.6637 71.049 21.1667C71.049 24.6698 73.2175 26.8384 76.2203 26.8384C79.223 26.8384 81.3916 24.6698 81.3916 21.1667ZM65.1176 23.0017C65.1176 26.8384 62.4073 29.6741 57.0693 29.6741L44.9985 29.6742V26.4356H47.2675V9.55878H44.9985V6.32025H57.236C61.7398 6.32025 64.2839 8.98925 64.2839 12.3257C64.2839 16.3291 60.9057 17.1633 60.9057 17.1633V17.33C60.9057 17.33 65.1176 17.8305 65.1176 23.0017ZM50.9096 16.0511H57.0384C59.4495 16.0511 60.7477 14.7528 60.7477 12.6757C60.7477 10.8582 59.4495 9.5599 57.0384 9.5599H50.9096V16.0511ZM61.5734 22.7615C61.5734 20.5596 60.1054 19.0915 56.8024 19.0915H50.9096V26.4316H56.8024C60.1054 26.4316 61.5734 24.9636 61.5734 22.7615ZM157.478 15.1614H157.311V12.6592H153.808V29.6741H157.311V20.4995C157.311 17.6637 159.313 15.8286 161.982 15.8286H164.15V12.4924H162.149C158.812 12.4924 157.478 15.1614 157.478 15.1614ZM143.913 15.1614H143.746V12.6592H140.243V29.6741H143.746V20.4995C143.746 17.6637 145.748 15.8286 148.417 15.8286H150.586V12.4924H148.584C145.248 12.4924 143.913 15.1614 143.913 15.1614ZM112.134 25.1079V15.8286H116.752V12.6592H112.134V8.98925H108.631V12.6592H106.63V15.8286H108.631V26.0269C108.631 28.0412 110.264 29.6741 112.278 29.6741H116.919V26.4333H113.46C112.728 26.4333 112.134 25.8399 112.134 25.1079ZM136.688 21.1667V22.3343H122.843C123.343 25.1703 125.512 26.7974 128.014 26.8384C130.567 26.8802 132.42 25.7134 133.188 24.8767L135.547 27.0311C134.522 28.2213 132.021 30.0079 128.139 30.0079C123.01 30.0079 119.34 26.171 119.34 21.1667C119.34 16.1623 123.177 12.3257 128.014 12.3257C132.852 12.3257 136.688 16.1623 136.688 21.1667ZM133.019 19.4986C132.685 17.4967 131.017 15.4949 128.014 15.4949C125.679 15.4949 123.51 16.9963 123.01 19.4986H133.019ZM184.902 26.4366V29.6742H182.183C180.715 29.6742 179.342 28.7648 178.77 27.3407V27.3407H178.603C178.603 27.3407 176.768 30.0097 173.265 30.0097C168.761 30.0097 165.258 26.5066 165.258 21.1686C165.258 15.8305 168.761 12.3276 173.265 12.3276C176.768 12.3276 178.603 14.8297 178.603 14.8297H178.77V12.661H182.273V25.9054C182.273 26.1988 182.511 26.4366 182.804 26.4366H184.902ZM178.77 21.1686C178.77 17.4986 176.768 15.4969 173.932 15.4969C170.93 15.4969 168.928 17.4986 168.928 21.1686C168.928 24.8385 170.93 26.8404 173.932 26.8404C176.768 26.8404 178.77 24.8385 178.77 21.1686Z\"\n        fill=\"white\" />\n    <path\n        d=\"M5.37571 27.8662V30.8307C5.37478 30.8297 5.37381 30.8289 5.37287 30.8279C4.4632 29.9324 3.64831 28.9409 2.94469 27.8697C2.94393 27.8685 2.94322 27.8674 2.94246 27.8662H5.37571ZM7.74563 3.20455C7.74557 3.20455 7.74554 3.20461 7.74548 3.20461C6.89801 3.79313 6.10354 4.45254 5.37059 5.1743H7.74563V3.20455ZM16.5074 8.1358V0.0610547C13.5704 0.302109 10.8331 1.24828 8.46521 2.73V8.1358H16.5074ZM17.2376 26.4346H29.9694V20.1998H29.0708H17.2376V26.4346ZM28.3181 15.8019H35.8671C35.867 15.8012 35.867 15.8004 35.8669 15.7998C35.5954 13.5721 34.9169 11.47 33.9081 9.57012C33.9075 9.56912 33.907 9.56812 33.9064 9.56713H28.3181V15.8019ZM28.3182 32.7509C29.14 32.175 29.9114 31.5322 30.6246 30.8305C30.6248 30.8302 30.6251 30.8299 30.6253 30.8297H28.3182V32.7509ZM5.37466 6.60902H4.06213C1.52323 9.71186 0 13.678 0 18C0 18.2562 0.00536133 18.5112 0.0159668 18.7648C0.0159668 18.7652 0.0159961 18.7655 0.0159961 18.7658H5.37466V6.60902ZM30.6257 29.3954H31.9343C31.9348 29.3948 31.9353 29.3942 31.9358 29.3936C34.4759 26.2904 36 22.3232 36 18C36 17.7441 35.9947 17.4894 35.9841 17.2361H30.6257V29.3954ZM19.5563 27.8689V35.9337C19.5564 35.9337 19.5564 35.9337 19.5565 35.9337C22.4946 35.682 25.2311 34.7246 27.5958 33.2317C27.5967 33.2312 27.5976 33.2305 27.5985 33.2299L27.5958 27.8689H19.5563ZM8.46521 29.3954H16.5074V29.0168V17.2362H8.46521V29.3954ZM27.5958 6.60773H19.5563V18.7671H27.5958V18.0423V6.60773ZM33.057 8.13287C33.0568 8.13264 33.0567 8.13246 33.0566 8.13223C32.3523 7.05984 31.5365 6.06732 30.6257 5.1709L30.6258 8.13287H33.057ZM6.09533 30.8297V31.5013C6.09551 31.5015 6.09565 31.5016 6.09583 31.5018C9.26868 34.3014 13.436 36 18 36H18C18.2804 36 18.5593 35.9936 18.8365 35.9809C18.8367 35.9809 18.8368 35.9809 18.837 35.9809L18.8365 30.8305L6.09533 30.8297ZM7.7456 20.1998H0.133096C0.133184 20.2005 0.133242 20.2012 0.13333 20.2018C0.405176 22.4308 1.08448 24.534 2.09446 26.4346H7.7456V20.1998H7.7456ZM29.9058 5.17207V4.49971C26.7328 1.69928 22.5649 0 18 0H18C17.7446 0 17.4904 0.00533204 17.2376 0.0158789C17.2341 0.0159961 17.2307 0.0162305 17.2273 0.0164063L17.2376 5.17207H29.9058ZM18.8368 9.57006H18.0962H6.09434V15.8048H18.8368V9.57006Z\"\n        fill=\"white\" />\n</svg>"

/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"14x14\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M13.6804131,2.29692652 C13.4675025,2.09900808 13.2148976,2.00003518 12.9232469,2.00003518 L11.8464349,2.00003518 L11.8464349,1.25000831 C11.8464349,0.906325799 11.714504,0.61203397 11.4509074,0.367242272 C11.1871635,0.122450575 10.8704055,0 10.5001031,0 L9.96177081,0 C9.59149789,0 9.27462207,0.122450575 9.010996,0.367269636 C8.74728152,0.61203397 8.61546849,0.906353162 8.61546849,1.25003567 L8.61546849,2.00006254 L5.3848262,2.00006254 L5.3848262,1.25003567 C5.3848262,0.906353162 5.25295423,0.612061333 4.98929869,0.367269636 C4.72570209,0.122450575 4.4087968,0 4.03852388,0 L3.50010314,0 C3.12991862,0 2.81298386,0.122450575 2.54932833,0.367269636 C2.28573173,0.61203397 2.15383029,0.906353162 2.15383029,1.25003567 L2.15383029,2.00006254 L1.07698881,2.00006254 C0.785249704,2.00006254 0.53288064,2.09903545 0.319734277,2.29695388 C0.106587915,2.49484496 0,2.72929334 0,3.0001075 L0,13.0000919 C0,13.2707145 0.106587915,13.5051081 0.319734277,13.703136 C0.532851171,13.9009997 0.785220236,14 1.07698881,14 L12.9230407,14 C13.2146914,14 13.4673256,13.9010271 13.6802068,13.703136 C13.8933826,13.5051902 14,13.2706871 14,13.0000919 L14,3.00008014 C13.9999705,2.72918389 13.893471,2.49484496 13.6804131,2.29692652 Z M9.69254571,1.25011776 C9.69254571,1.17713995 9.71756455,1.11718706 9.76798532,1.07042325 C9.81840609,1.02360472 9.88294231,1.00015441 9.961594,1.00015441 L10.4999263,1.00015441 C10.5786075,1.00015441 10.6429374,1.02352263 10.693535,1.07042325 C10.7439852,1.11726915 10.7691809,1.17722204 10.7691809,1.25011776 L10.7691809,3.5000342 C10.7691809,3.57298465 10.7439852,3.63282809 10.693535,3.67972871 C10.642908,3.72649252 10.5786075,3.74999756 10.4999263,3.74999756 L9.961594,3.74999756 C9.88294231,3.74999756 9.81840609,3.72660197 9.76798532,3.67972871 C9.71756455,3.63280073 9.69254571,3.57298465 9.69254571,3.5000342 L9.69254571,1.25011776 Z M3.23090751,1.25011776 C3.23090751,1.17713995 3.25610316,1.11718706 3.30658286,1.07042325 C3.35709204,1.02360472 3.42153986,1.00015441 3.50010314,1.00015441 L4.03852388,1.00015441 C4.11711662,1.00015441 4.18168232,1.02352263 4.23204415,1.07042325 C4.28246492,1.11726915 4.30777845,1.17722204 4.30777845,1.25011776 L4.30777845,3.5000342 C4.30777845,3.57298465 4.2825828,3.63291018 4.23204415,3.67972871 C4.18156445,3.72649252 4.11711662,3.74999756 4.03852388,3.74999756 L3.50010314,3.74999756 C3.42153986,3.74999756 3.35700363,3.72660197 3.30658286,3.67972871 C3.25622103,3.63280073 3.23090751,3.57298465 3.23090751,3.5000342 L3.23090751,1.25011776 Z M12.9230407,12.999955 L1.07698881,12.999955 L1.07698881,5.00003323 L12.9230407,5.00003323 L12.9230407,12.999955 Z\" id=\"calendar\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n    </g>\n</svg>\n"

/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"18x18\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M17.5891025,2.95319124 C17.3153603,2.69872468 16.9905827,2.5714738 16.6156032,2.5714738 L15.2311306,2.5714738 L15.2311306,1.60715354 C15.2311306,1.16527603 15.0615052,0.786900818 14.7225953,0.472168636 C14.3834959,0.157436454 13.9762357,0 13.5001326,0 L12.807991,0 C12.3319259,0 11.9245141,0.157436454 11.5855663,0.472203817 C11.2465048,0.786900818 11.0770309,1.16531121 11.0770309,1.60718872 L11.0770309,2.57150899 L6.92334797,2.57150899 L6.92334797,1.60718872 C6.92334797,1.16531121 6.75379829,0.786935999 6.4148126,0.472203817 C6.07590269,0.157436454 5.66845302,0 5.19238784,0 L4.50013261,0 C4.02418109,0 3.61669354,0.157436454 3.27770785,0.472203817 C2.93879793,0.786900818 2.76921037,1.16531121 2.76921037,1.60718872 L2.76921037,2.57150899 L1.3846999,2.57150899 C1.00960676,2.57150899 0.685132251,2.69875986 0.411086928,2.95322642 C0.137041605,3.2076578 0,3.50909144 0,3.85728107 L0,16.7144038 C0,17.0623472 0.137041605,17.3637105 0.411086928,17.6183177 C0.685094363,17.8727139 1.00956887,18 1.3846999,18 L16.615338,18 C16.9903175,18 17.315133,17.8727491 17.5888373,17.6183177 C17.8629205,17.363816 18,17.062312 18,16.7144038 L18,3.85724589 C17.9999621,3.50895072 17.8630342,3.2076578 17.5891025,2.95319124 Z M12.4618445,1.60729426 C12.4618445,1.51346565 12.4940116,1.43638336 12.5588383,1.37625847 C12.623665,1.31606321 12.7066401,1.28591281 12.8077637,1.28591281 L13.4999053,1.28591281 C13.6010668,1.28591281 13.6837767,1.31595767 13.7488307,1.37625847 C13.8136953,1.4364889 13.8460897,1.5135712 13.8460897,1.60729426 L13.8460897,4.50004398 C13.8460897,4.5938374 13.8136953,4.67077897 13.7488307,4.73107977 C13.6837388,4.79120467 13.6010668,4.82142543 13.4999053,4.82142543 L12.8077637,4.82142543 C12.7066401,4.82142543 12.623665,4.79134539 12.5588383,4.73107977 C12.4940116,4.67074379 12.4618445,4.5938374 12.4618445,4.50004398 L12.4618445,1.60729426 Z M4.15402394,1.60729426 C4.15402394,1.51346565 4.18641834,1.43638336 4.25132082,1.37625847 C4.31626119,1.31606321 4.39912268,1.28591281 4.50013261,1.28591281 L5.19238784,1.28591281 C5.29343566,1.28591281 5.3764487,1.31595767 5.44119962,1.37625847 C5.50602633,1.4364889 5.53857229,1.5135712 5.53857229,1.60729426 L5.53857229,4.50004398 C5.53857229,4.5938374 5.50617788,4.67088452 5.44119962,4.73107977 C5.37629714,4.79120467 5.29343566,4.82142543 5.19238784,4.82142543 L4.50013261,4.82142543 C4.39912268,4.82142543 4.31614753,4.79134539 4.25132082,4.73107977 C4.1865699,4.67074379 4.15402394,4.5938374 4.15402394,4.50004398 L4.15402394,1.60729426 Z M16.615338,16.7142279 L1.3846999,16.7142279 L1.3846999,6.42861415 L16.615338,6.42861415 L16.615338,16.7142279 Z\" id=\"calendar\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n    </g>\n</svg>\n"

/***/ }),
/* 218 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"14px\" height=\"11px\" viewBox=\"0 0 14 11\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->\n    <desc>Created with Sketch.</desc>\n    <g id=\"Covid-Updates\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Intake-Form-Designer-Update-V2-1\" transform=\"translate(-752.000000, -24.000000)\" fill=\"currentColor\">\n            <g id=\"Top-Nav\">\n                <g id=\"Attach-CTA\" transform=\"translate(368.000000, 0.000000)\">\n                    <g id=\"Outline-Icon-BTN\" transform=\"translate(228.000000, 12.000000)\">\n                        <g id=\"Icon\" transform=\"translate(156.000000, 11.000000)\">\n                            <path d=\"M13.8615094,2.71433141 L12.3011234,1.13976331 C12.1164467,0.953412229 11.8169957,0.953412229 11.6323191,1.13976331 L5.13225476,7.69883202 L2.36763034,4.90920862 C2.1830211,4.72285754 1.8835364,4.72285754 1.69889347,4.90920862 L0.138507461,6.48377671 C-0.0461691537,6.67009381 -0.0461691537,6.97225995 0.138507461,7.15861104 L4.79790317,11.8602197 C4.89024148,11.9534292 5.0112818,12 5.13228844,12 C5.25332877,12 5.3743691,11.9534292 5.46667372,11.8602197 L13.8615094,3.38913173 C13.9502094,3.29966146 14,3.1782715 14,3.05174857 C14.0000337,2.92515764 13.9502094,2.80383568 13.8615094,2.71433141 L13.8615094,2.71433141 Z\" id=\"Check\"></path>\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 219 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: sketchtool 55.2 (78181) - https://sketchapp.com -->\n    <desc>Created with sketchtool.</desc>\n    <g id=\"Apricot-Mobile\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Participant-(Quick-Info-Expand---Links-Modal)\" transform=\"translate(-20.000000, -459.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <g id=\"Quick-Info-(Expanded)\" transform=\"translate(10.000000, 136.000000)\">\n                <g id=\"Expander\" transform=\"translate(0.000000, 307.000000)\">\n                    <path d=\"M18.1,24.1 L14.5,24.1 L14.5,25.9 L18.1,25.9 L19.9,25.9 L23.5,25.9 L23.5,24.1 L19.9,24.1 L18.1,24.1 Z M19,16 C14.05,16 10,20.05 10,25 C10,29.95 14.05,34 19,34 C23.95,34 28,29.95 28,25 C28,20.05 23.95,16 19,16 Z M19,32.2 C15.04,32.2 11.8,28.96 11.8,25 C11.8,21.04 15.04,17.8 19,17.8 C22.96,17.8 26.2,21.04 26.2,25 C26.2,28.96 22.96,32.2 19,32.2 Z\" id=\"ic_collapse_18x18\"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n"

/***/ }),
/* 220 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"16px\" height=\"12px\" viewBox=\"0 0 16 12\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com -->\n    <desc>Created with Sketch.</desc>\n    <g id=\"Connect-V2\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Form\" transform=\"translate(-20.000000, -85.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <g id=\"Side-Nav-wDashboard\" transform=\"translate(0.000000, 60.000000)\">\n                <g id=\"Dashboard\" transform=\"translate(0.000000, 10.000000)\">\n                    <path d=\"M35.3662558,19.6704528 C34.9437284,18.727192 34.3752507,17.9148277 33.6609789,17.2328823 C32.9467384,16.5510564 32.0954916,16.0084851 31.1072698,15.605109 C30.1190166,15.2017328 29.0835102,15 28.0000313,15 C26.9166149,15 25.8809208,15.2017627 24.8928553,15.605109 C23.9047898,16.0086344 23.0536056,16.5510564 22.3393338,17.2328823 C21.6249057,17.9148277 21.0565843,18.727192 20.6339005,19.6704528 C20.2113106,20.6137135 20,21.6022284 20,22.6363555 C20,24.1248741 20.419619,25.4972127 21.2589196,26.7528937 C21.3719397,26.917671 21.5326821,27 21.741053,27 L34.2589782,27 C34.4672554,27 34.6279978,26.9176412 34.7410179,26.7528937 C35.580381,25.4915708 36,24.1193218 36,22.6363555 C36,21.6022284 35.7887832,20.6137135 35.3662558,19.6704528 Z M27.1919097,16.4105777 C27.4152604,16.1974716 27.6845196,16.0909037 28,16.0909037 C28.3155117,16.0909037 28.5847709,16.1975015 28.8080277,16.4105777 C29.0312846,16.6235644 29.1429912,16.8807006 29.1429912,17.1818372 C29.1429912,17.4829738 29.0312846,17.7400204 28.8080277,17.9530967 C28.5847709,18.1661729 28.3155117,18.2727707 28,18.2727707 C27.6845196,18.2727707 27.4151353,18.1661729 27.1919097,17.9530967 C26.968778,17.7399906 26.8570714,17.4829738 26.8570714,17.1818372 C26.8570714,16.8807006 26.9686529,16.6235942 27.1919097,16.4105777 Z M23.0937912,23.4076448 C22.8705656,23.6206315 22.6011813,23.727498 22.2857009,23.727498 C21.9703143,23.727498 21.70093,23.6206315 21.4777044,23.4076448 C21.2544476,23.1947477 21.1429286,22.9375219 21.1429286,22.6363555 C21.1429286,22.3352189 21.2544476,22.0782021 21.4777044,21.865096 C21.7009612,21.6519899 21.9703143,21.5454518 22.2857009,21.5454518 C22.6011813,21.5454518 22.8706907,21.6519899 23.0937912,21.865096 C23.3169229,22.0782021 23.4286295,22.3352189 23.4286295,22.6363555 C23.4286295,22.9375219 23.3169229,23.1945388 23.0937912,23.4076448 Z M24.8081372,19.5894969 C24.5847865,19.8025433 24.3155274,19.909171 24.0000156,19.909171 C23.6845039,19.909171 23.4151509,19.8024239 23.1918941,19.5894969 C22.9687623,19.3765103 22.857087,19.119374 22.857087,18.8182374 C22.857087,18.5171009 22.9686372,18.2600542 23.1918941,18.046978 C23.4152447,17.8338719 23.6845039,17.7273039 24.0000156,17.7273039 C24.3154961,17.7273039 24.5848804,17.8339017 24.8081372,18.046978 C25.0312689,18.260084 25.1429443,18.5171009 25.1429443,18.8182374 C25.1429443,19.1192845 25.0312377,19.3763909 24.8081372,19.5894969 Z M29.8660193,19.6619751 L28.9641418,22.9175815 C29.2619843,23.1106575 29.4762659,23.3691072 29.6072365,23.6931097 C29.7380196,24.0169628 29.7560015,24.3493534 29.6607444,24.6902514 C29.5417199,25.1277771 29.2767764,25.4601975 28.8660076,25.6873633 C28.4552388,25.9146486 28.0208277,25.9715744 27.5623678,25.8578721 C27.1041268,25.7442593 26.7558099,25.4914514 26.5177923,25.099359 C26.2797747,24.7071769 26.2202625,24.2925768 26.3392869,23.8549318 C26.4344814,23.5141531 26.6219934,23.2343301 26.9017915,23.0157315 C27.1814959,22.7968343 27.499916,22.6734005 27.8570518,22.6449227 L28.7588668,19.3892566 C28.800491,19.241554 28.889775,19.1292248 29.0266249,19.0525079 C29.1636312,18.9759401 29.3063605,18.9574624 29.4552505,18.997194 C29.6042343,19.0370152 29.7187242,19.1207472 29.7989703,19.2485392 C29.8795292,19.3765103 29.9017642,19.5142725 29.8660193,19.6619751 Z M31.1919879,19.5894969 C30.9687311,19.3765103 30.8570245,19.119374 30.8570245,18.8182374 C30.8570245,18.5171009 30.9687311,18.2600542 31.1919879,18.046978 C31.4152447,17.8339017 31.6845039,17.7273039 32.0000156,17.7273039 C32.3154961,17.7273039 32.5847553,17.8339017 32.8080121,18.046978 C33.0312689,18.2600542 33.1430068,18.5171009 33.1430068,18.8182374 C33.1430068,19.1192845 33.0312689,19.3764207 32.8080121,19.5894969 C32.5847553,19.8025433 32.3154961,19.909171 32.0000156,19.909171 C31.6845039,19.909171 31.4152447,19.8025433 31.1919879,19.5894969 Z M34.5222956,23.4076448 C34.2990388,23.6206315 34.0297796,23.727498 33.7142991,23.727498 C33.3987874,23.727498 33.1295282,23.6206315 32.9062714,23.4076448 C32.6830145,23.1947477 32.5714018,22.9375219 32.5714018,22.6363555 C32.5714018,22.3352189 32.6830145,22.0782021 32.9062714,21.865096 C33.1295282,21.6519899 33.3987874,21.5454518 33.7142991,21.5454518 C34.0297796,21.5454518 34.2990388,21.6519899 34.5222956,21.865096 C34.7455524,22.0782021 34.8570401,22.3352189 34.8570401,22.6363555 C34.8570401,22.9375219 34.7455211,23.1945388 34.5222956,23.4076448 Z\" id=\"ic_dashboard_16x12_white\"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n"

/***/ }),
/* 221 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"16px\" height=\"14px\" viewBox=\"0 0 16 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->\n    <desc>Created with Sketch.</desc>\n    <g id=\"Apricot-Mobile\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Home-(Main-Menu)\" transform=\"translate(-20.000000, -136.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <g id=\"Menu\" transform=\"translate(0.000000, 24.000000)\">\n                <g id=\"TP\" transform=\"translate(0.000000, 98.000000)\">\n                    <path d=\"M35.6082112,14.3955233 C35.3471258,14.1319295 35.0333854,14 34.6665815,14 L21.3333309,14 C20.9666729,14 20.6528742,14.1319295 20.3916136,14.3955233 C20.1304989,14.6592056 20,14.9759897 20,15.3461997 L20,24.5000221 C20,24.8703206 20.1304989,25.1870752 20.3916136,25.4508164 C20.6528742,25.7144102 20.9666729,25.846104 21.3333309,25.846104 L25.8667318,25.846104 C25.8667318,26.0591892 25.8222495,26.2781385 25.7333433,26.5023333 C25.6444954,26.7267048 25.5555892,26.9229341 25.4666829,27.0911391 C25.3778935,27.2595504 25.3334403,27.3827867 25.3334403,27.4612608 C25.3334403,27.6070699 25.3861828,27.7335478 25.4917553,27.8398399 C25.5972695,27.9465445 25.7222811,28 25.8667318,28 L30.1333849,28 C30.2778356,28 30.4028764,27.946574 30.5083906,27.8398399 C30.6140506,27.7335772 30.6667931,27.6070993 30.6667931,27.4612608 C30.6667931,27.388533 30.6222524,27.2664459 30.5333754,27.095412 C30.4444691,26.9244665 30.3555629,26.7251135 30.2667734,26.4981782 C30.1778672,26.2709777 30.1334141,26.0536491 30.1334141,25.846104 L34.666815,25.846104 C35.0334146,25.846104 35.347155,25.7144102 35.6082404,25.4508164 C35.8694426,25.1871047 36,24.8703501 36,24.5000221 L36,15.3461997 C36,14.9759897 35.8694134,14.6592056 35.6082112,14.3955233 Z M34.9333002,22.3461555 C34.9333002,22.4190896 34.9069436,22.4820928 34.8541719,22.5354598 C34.8013419,22.5886206 34.7388215,22.6152305 34.6665815,22.6152305 L21.3333309,22.6152305 C21.2611493,22.6152305 21.1986289,22.5886206 21.1458572,22.5354598 C21.0931148,22.4819159 21.0666997,22.4190896 21.0666997,22.3461555 L21.0666997,15.3461997 C21.0666997,15.2732657 21.0930272,15.2102036 21.1458572,15.1569249 C21.1986581,15.1037347 21.2611785,15.0770069 21.3333309,15.0770069 L34.6667858,15.0770069 C34.738909,15.0770069 34.8015462,15.1036463 34.8541719,15.1569249 C34.9069436,15.2102331 34.9333002,15.2732952 34.9333002,15.3461997 L34.9333002,22.3461555 L34.9333002,22.3461555 Z\" id=\"ic_desktop_switch_16x14\"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n"

/***/ }),
/* 222 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"16px\" height=\"14px\" viewBox=\"0 0 16 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->\n    <desc>Created with Sketch.</desc>\n    <g id=\"V3\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Participants-View---Registered\" transform=\"translate(-216.000000, -919.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <g id=\"Message\" transform=\"translate(216.000000, 919.000000)\">\n                <path d=\"M8.5673331,0 C4.46240185,0 1.13473847,3.13399802 1.13473847,7 C1.13473847,8.05030986 1.3807944,9.04628381 1.82083302,9.94037331 L0.0627021799,13.1854778 C-0.0350119079,13.365749 -0.0173409801,13.5881463 0.107475758,13.7501212 C0.204033466,13.8753926 0.350387777,13.9455903 0.501765112,13.9455903 C0.5459605,13.9455903 0.590553393,13.9396145 0.63453196,13.9272201 L4.48328896,12.8489123 C5.6553521,13.5763053 7.05872732,14 8.5673331,14 C12.6723005,14 16,10.8660389 16,7 C15.9999639,3.13399802 12.6722643,0 8.5673331,0 Z M7.87354139,4.19282899 C7.87354139,3.81653528 8.17340511,3.51040239 8.54207343,3.51040239 C8.91074174,3.51040239 9.21060546,3.81653528 9.21060546,4.19282899 L9.21060546,7.91850931 C9.21060546,8.29480302 8.91070561,8.6009359 8.54207343,8.6009359 C8.17344125,8.6009359 7.87354139,8.29480302 7.87354139,7.91850931 L7.87354139,4.19282899 Z M8.54203729,10.4895976 C8.13640096,10.4895976 7.80643523,10.1527371 7.80643523,9.73870703 C7.80643523,9.3245663 8.13647324,8.98770578 8.54203729,8.98770578 C8.9477459,8.98770578 9.27767549,9.32460319 9.27767549,9.73870703 C9.27771163,10.152774 8.9477459,10.4895976 8.54203729,10.4895976 Z\" id=\"ic_disclaim_msg_14x14\"></path>\n            </g>\n        </g>\n    </g>\n</svg>\n"

/***/ }),
/* 223 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"14x14\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M5.52433103,7.50295935 L11.2553834,2.26536585 C11.4131885,2.12149593 11.5,1.92913821 11.5,1.72403252 C11.5,1.51881301 11.4131885,1.32656911 11.2553834,1.18247154 L10.7531971,0.723772358 C10.5956411,0.579447154 10.3850267,0.5 10.1605873,0.5 C9.93614783,0.5 9.72578256,0.579447154 9.56810202,0.723772358 L2.74437081,6.95957724 C2.58606752,7.10413008 2.49938059,7.29728455 2.50000334,7.50261789 C2.49938059,7.70886179 2.58594297,7.90178862 2.74437081,8.04645528 L9.56174996,14.2762276 C9.7194305,14.4205528 9.92979577,14.5 10.1543598,14.5 C10.3787992,14.5 10.5891645,14.4205528 10.7469696,14.2762276 L11.2490314,13.8175285 C11.5757265,13.5189756 11.5757265,13.0329593 11.2490314,12.7345203 L5.52433103,7.50295935 Z\" id=\"down_arrow\" fill=\"currentColor\" fill-rule=\"nonzero\" transform=\"translate(7.000000, 7.500000) rotate(-90.000000) translate(-7.000000, -7.500000) \"></path>\n    </g>\n</svg>\n"

/***/ }),
/* 224 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"18x18\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M7.03244137,9.00380488 L14.6738446,2.2697561 C14.8842514,2.08478049 15,1.83746341 15,1.5737561 C15,1.30990244 14.8842514,1.06273171 14.6738446,0.877463415 L14.0042628,0.287707317 C13.7941881,0.102146341 13.5133689,0 13.2141164,0 C12.9148638,0 12.6343767,0.102146341 12.424136,0.287707317 L3.32582774,8.30517073 C3.11475669,8.49102439 2.99917411,8.73936585 3.00000445,9.00336585 C2.99917411,9.26853659 3.11459062,9.51658537 3.32582774,9.70258537 L12.4156666,17.7122927 C12.6259073,17.8978537 12.9063944,18 13.205813,18 C13.5050656,18 13.7855526,17.8978537 13.9959594,17.7122927 L14.6653752,17.1225366 C15.1009687,16.7386829 15.1009687,16.1138049 14.6653752,15.7300976 L7.03244137,9.00380488 Z\" id=\"down_arrow\" fill=\"currentColor\" fill-rule=\"nonzero\" transform=\"translate(9.000000, 9.000000) rotate(-90.000000) translate(-9.000000, -9.000000) \"></path>\n    </g>\n</svg>\n"

/***/ }),
/* 225 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->\n\n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"14x14\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M8.70554578,2.33641964 L11.5534625,5.19825689 L4.3445989,12.4424246 L1.49829688,9.58058733 L8.70554578,2.33641964 Z M13.7144804,1.64621011 L12.4444191,0.369928953 C11.9535843,-0.123309651 11.15657,-0.123309651 10.6640675,0.369928953 L9.44747586,1.59247867 L12.2953926,4.45434253 L13.7144804,3.02830495 C14.0951732,2.64572118 14.0951732,2.02876728 13.7144804,1.64621011 Z M0.00792508019,13.60313 C-0.0439033508,13.8375267 0.166692664,14.0475581 0.399973543,13.9905549 L3.57349878,13.2173276 L0.727196763,10.3554904 L0.00792508019,13.60313 Z\" id=\"edit\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n    </g>\n</svg>\n"

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->\n    \n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"18x18\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M11.1928446,3.00396811 L14.8544518,6.68347314 L5.58591287,15.997403 L1.9263817,12.317898 L11.1928446,3.00396811 Z M17.6329034,2.11655585 L15.9999675,0.47562294 C15.3688941,-0.15854098 14.3441614,-0.15854098 13.710944,0.47562294 L12.1467547,2.04747258 L15.8083619,5.72701182 L17.6329034,3.89353493 C18.1223655,3.40164152 18.1223655,2.60841507 17.6329034,2.11655585 Z M0.0101893888,17.4897385 C-0.0564471653,17.7911057 0.214319139,18.0611461 0.514251699,17.9878563 L4.59449843,16.9937069 L0.934967266,13.3142019 L0.0101893888,17.4897385 Z\" id=\"edit\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n    </g>\n</svg>"

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: sketchtool 55.2 (78181) - https://sketchapp.com -->\n    <desc>Created with sketchtool.</desc>\n    <g id=\"Apricot-Mobile\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Participant-(Quick-Info-Expand---Links-Modal)\" transform=\"translate(-20.000000, -1465.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <g id=\"Docs\" transform=\"translate(10.000000, 1348.000000)\">\n                <g id=\"Table\">\n                    <g>\n                        <g id=\"Row\" transform=\"translate(1.000000, 108.000000)\">\n                            <path d=\"M18.9,13.5 L17.1,13.5 L17.1,17.1 L13.5,17.1 L13.5,18.9 L17.1,18.9 L17.1,22.5 L18.9,22.5 L18.9,18.9 L22.5,18.9 L22.5,17.1 L18.9,17.1 L18.9,13.5 Z M18,9 C13.05,9 9,13.05 9,18 C9,22.95 13.05,27 18,27 C22.95,27 27,22.95 27,18 C27,13.05 22.95,9 18,9 Z M18,25.2 C14.04,25.2 10.8,21.96 10.8,18 C10.8,14.04 14.04,10.8 18,10.8 C21.96,10.8 25.2,14.04 25.2,18 C25.2,21.96 21.96,25.2 18,25.2 Z\" id=\"ic_expand_18x18\"></path>\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n"

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 55 (78076) - https://sketchapp.com -->\n    <desc>Created with Sketch.</desc>\n    <g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Side-Nav-UPDATE\" transform=\"translate(-20.000000, -65.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <g id=\"TP\">\n                <g transform=\"translate(0.000000, 52.000000)\">\n                    <path d=\"M32.315283,21.4669793 L32.315283,14.2861425 L21.3195094,14.2861425 L21.3195094,27.683292 L26.3775472,27.683292 C26.7404151,27.683292 27.037283,27.9726529 27.037283,28.3263448 C27.037283,28.6800368 26.7404151,28.9693977 26.3775472,28.9693977 L20.6597358,28.9693977 C20.2968679,28.9693977 20,28.6800368 20,28.3263448 L20,13.6430529 C20,13.2893609 20.2969057,13 20.6597358,13 L32.9749811,13 C33.3378491,13 33.634717,13.2893609 33.634717,13.6430529 L33.634717,21.4669793 C33.634717,21.8206713 33.3378491,22.1100322 32.9749811,22.1100322 C32.6121132,22.1100322 32.315283,21.8206713 32.315283,21.4669793 Z M35.7129811,23.0317793 C35.4380755,22.7959724 35.0202642,22.8174161 34.7783396,23.0853701 L31.160717,27.0080552 L29.3464151,25.3039264 C29.0825283,25.0574161 28.6646792,25.0681195 28.4117736,25.3253701 C28.1588679,25.5826207 28.1698491,25.9898667 28.4337736,26.236377 L30.7428679,28.4013425 C30.8638113,28.5192276 31.0287547,28.5835586 31.2046792,28.5835586 C31.2156604,28.5835586 31.2156604,28.5835586 31.2266792,28.5835586 C31.4026038,28.5728552 31.5785283,28.4978207 31.6884906,28.3691954 L35.7569434,23.9534897 C36.0098491,23.6748322 35.9878491,23.2675862 35.7129811,23.0317793 Z M29.8961887,16.7512092 L23.9584906,16.7512092 C23.5956226,16.7512092 23.2987547,17.0405701 23.2987547,17.3942621 C23.2987547,17.747954 23.5956226,18.0373149 23.9584906,18.0373149 L29.8961887,18.0373149 C30.2590566,18.0373149 30.5559245,17.747954 30.5559245,17.3942621 C30.5559245,17.0405701 30.2590566,16.7512092 29.8961887,16.7512092 Z M30.5559623,20.931108 C30.5559623,20.5774161 30.2590943,20.2880552 29.8962264,20.2880552 L23.9584906,20.2880552 C23.5956226,20.2880552 23.2987547,20.5774161 23.2987547,20.931108 C23.2987547,21.2848 23.5956226,21.5741609 23.9584906,21.5741609 L29.8961887,21.5741609 C30.2590566,21.5741609 30.5559623,21.2848 30.5559623,20.931108 Z M23.9584906,23.7177195 C23.5956226,23.7177195 23.2987547,24.0070805 23.2987547,24.3607724 C23.2987547,24.7144644 23.5956226,25.0038253 23.9584906,25.0038253 L25.7178113,25.0038253 C26.0806792,25.0038253 26.3775472,24.7144644 26.3775472,24.3607724 C26.3775472,24.0070805 26.0806792,23.7177195 25.7178113,23.7177195 L23.9584906,23.7177195 Z\" id=\"ic_form_submit_16x16\"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n"

/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->\n    <desc>Created with Sketch.</desc>\n    <g id=\"Apricot-Mobile\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Home-(Main-Menu)\" transform=\"translate(-20.000000, -93.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <g id=\"Menu\" transform=\"translate(0.000000, 24.000000)\">\n                <g id=\"Home\" transform=\"translate(0.000000, 56.000000)\">\n                    <polygon id=\"ic_home_16x16\" points=\"20 20.9310345 22.4761905 20.9310345 22.4761905 29 26.4761905 29 26.4761905 23.6896552 29.5238095 23.6896552 29.5238095 29 33.5238095 29 33.5238095 20.9310345 36 20.9310345 28 13\"></polygon>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n"

/***/ }),
/* 230 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: sketchtool 55.2 (78181) - https://sketchapp.com -->\n    <desc>Created with sketchtool.</desc>\n    <g id=\"MVP-V1-UPDATED\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Create-New-Message---Review-&amp;-Send\" transform=\"translate(-341.000000, -288.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <g id=\"Allowance\" transform=\"translate(118.000000, 275.000000)\">\n                <g id=\"ic_info_18x18\" transform=\"translate(223.000000, 13.000000)\">\n                    <path d=\"M9,0 C4.0374,0 0,4.03745455 0,9.00005455 C0,13.9626545 4.0374,18 9,18 C13.9626,18 18,13.9626545 18,9.00005455 C18,4.03745455 13.9626,0 9,0 Z M9,16.3636364 C4.93963636,16.3636364 1.63636364,13.0603636 1.63636364,9.00005455 C1.63636364,4.93974545 4.93963636,1.63636364 9,1.63636364 C13.0603636,1.63636364 16.3636364,4.93974545 16.3636364,9.00005455 C16.3636364,13.0603636 13.0603091,16.3636364 9,16.3636364 Z\" id=\"Shape\"></path>\n                    <path d=\"M8.99989091,3.81818182 C8.39847273,3.81818182 7.9092,4.30778182 7.9092,4.90958182 C7.9092,5.51083636 8.39847273,6 8.99989091,6 C9.60130909,6 10.0905818,5.51083636 10.0905818,4.90958182 C10.0905818,4.30778182 9.60130909,3.81818182 8.99989091,3.81818182 Z\" id=\"Path\"></path>\n                    <path d=\"M9,7.63636364 C8.54814545,7.63636364 8.18181818,8.00269091 8.18181818,8.45454545 L8.18181818,13.3636364 C8.18181818,13.8154909 8.54814545,14.1818182 9,14.1818182 C9.45185455,14.1818182 9.81818182,13.8154909 9.81818182,13.3636364 L9.81818182,8.45454545 C9.81818182,8.00269091 9.45185455,7.63636364 9,7.63636364 Z\" id=\"Path\"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n"

/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->\n    \n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"14x14\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M6.02433103,7.00295935 L11.7553834,1.76536585 C11.9131885,1.62149593 12,1.42913821 12,1.22403252 C12,1.01881301 11.9131885,0.826569106 11.7553834,0.682471545 L11.2531971,0.223772358 C11.0956411,0.0794471545 10.8850267,0 10.6605873,0 C10.4361478,0 10.2257826,0.0794471545 10.068102,0.223772358 L3.24437081,6.45957724 C3.08606752,6.60413008 2.99938059,6.79728455 3.00000334,7.00261789 C2.99938059,7.20886179 3.08594297,7.40178862 3.24437081,7.54645528 L10.06175,13.7762276 C10.2194305,13.9205528 10.4297958,14 10.6543598,14 C10.8787992,14 11.0891645,13.9205528 11.2469696,13.7762276 L11.7490314,13.3175285 C12.0757265,13.0189756 12.0757265,12.5329593 11.7490314,12.2345203 L6.02433103,7.00295935 Z\" id=\"left_arrow\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n    </g>\n</svg>"

/***/ }),
/* 232 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->\n    \n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"18x18\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M7.03244137,9.00380488 L14.6738446,2.2697561 C14.8842514,2.08478049 15,1.83746341 15,1.5737561 C15,1.30990244 14.8842514,1.06273171 14.6738446,0.877463415 L14.0042628,0.287707317 C13.7941881,0.102146341 13.5133689,0 13.2141164,0 C12.9148638,0 12.6343767,0.102146341 12.424136,0.287707317 L3.32582774,8.30517073 C3.11475669,8.49102439 2.99917411,8.73936585 3.00000445,9.00336585 C2.99917411,9.26853659 3.11459062,9.51658537 3.32582774,9.70258537 L12.4156666,17.7122927 C12.6259073,17.8978537 12.9063944,18 13.205813,18 C13.5050656,18 13.7855526,17.8978537 13.9959594,17.7122927 L14.6653752,17.1225366 C15.1009687,16.7386829 15.1009687,16.1138049 14.6653752,15.7300976 L7.03244137,9.00380488 Z\" id=\"left_arrow\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n    </g>\n</svg>"

/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->\n    \n    <desc>Created with Sketch.</desc>\n    <g id=\"14x14\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M13.038961,0.96108342 C14.3203463,2.24252342 14.3203463,4.32005092 13.038961,5.60149092 L10.2965416,8.34391034 C10.2886666,8.35175801 10.2792056,8.35676193 10.2713033,8.36452757 C10.4331239,7.2311816 10.1185334,6.5441412 10.0661154,6.25410548 L11.8788181,4.44140272 C12.5186358,3.80158506 12.5186358,2.76101662 11.8788181,2.12119897 C11.2390005,1.48138131 10.198432,1.48138131 9.55861437,2.12119897 C9.50048145,2.17933189 6.91203498,4.76777836 6.81624964,4.8635637 C6.17126401,5.50854933 6.19901797,6.56659046 6.81624964,7.18376745 C6.88094508,7.24846289 6.95102725,7.30367003 7.02307817,7.35474825 C7.02898443,7.63171364 7.14453934,8.0155386 6.81624964,8.343883 L6.31572132,8.84441132 C6.08040055,8.70952434 5.85754855,8.54529745 5.65613409,8.343883 C4.45336221,7.14105643 4.33064322,5.02902105 5.65613409,3.7034755 L8.39855351,0.961056076 C9.67999352,-0.320356583 11.757521,-0.320356583 13.038961,0.96108342 Z M8.5563546,5.44363514 C9.7861695,6.6734227 9.85726339,8.78313385 8.5563546,10.0840426 L5.60141914,13.0389781 C4.31997914,14.3203634 2.24247899,14.3203634 0.961038986,13.0389781 C-0.320346329,11.7575381 -0.320346329,9.68001061 0.961038986,8.3985706 L3.9159471,5.4436078 C3.92382212,5.43576013 3.93333776,5.43070152 3.94124012,5.42293588 C3.77939215,6.55628185 4.09400995,7.24332225 4.14642802,7.53335798 L2.12115453,9.55863146 C1.48133688,10.1984491 1.48133688,11.2390176 2.12115453,11.8788352 C2.76097219,12.5186529 3.80154063,12.5186529 4.44135828,11.8788352 C4.49744042,11.8227531 7.30028965,9.01990385 7.39629374,8.92389975 C8.04127938,8.27891412 8.01352542,7.22092768 7.39629374,6.603696 C7.3315983,6.53900056 7.26151614,6.48379343 7.18941053,6.4327152 C7.18350426,6.15574982 7.06794935,5.77192485 7.39629374,5.44363514 L7.89682206,4.94310682 C8.13208815,5.0779938 8.35496749,5.24222069 8.5563546,5.44363514 Z\" id=\"ic_link\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n    </g>\n</svg>"

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->\n    \n    <desc>Created with Sketch.</desc>\n    <g id=\"18x18\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M16.7643457,1.23567627 C18.4118379,2.88323877 18.4118379,5.55434033 16.7643457,7.20190283 L13.2383848,10.7278638 C13.2282598,10.7379536 13.2160957,10.7443872 13.2059355,10.7543716 C13.4139902,9.29721533 13.0095176,8.41387939 12.942123,8.04097705 L15.2727363,5.71036377 C16.0953574,4.88774268 16.0953574,3.54987158 15.2727363,2.72725049 C14.4501152,1.90462939 13.1122441,1.90462939 12.289623,2.72725049 C12.2148809,2.80199268 8.88688477,6.12998877 8.76373242,6.25314111 C7.9344668,7.08240674 7.97015039,8.44274268 8.76373242,9.23625439 C8.84691211,9.31943408 8.93701758,9.39041455 9.0296543,9.45608643 C9.03724805,9.81218408 9.18581836,10.3056724 8.76373242,10.7278286 L8.12019727,11.3713638 C7.81764258,11.197938 7.53111914,10.9867896 7.2721582,10.7278286 C5.72574023,9.18134033 5.56795898,6.46587158 7.2721582,4.76160205 L10.7981191,1.23564111 C12.4456816,-0.41188623 15.1167832,-0.41188623 16.7643457,1.23567627 Z M11.0010059,6.9989458 C12.5821934,8.58009814 12.6735996,11.2925786 11.0010059,12.9651724 L7.20181055,16.7643677 C5.55424805,18.4118599 2.88318164,18.4118599 1.23561914,16.7643677 C-0.411873047,15.1168052 -0.411873047,12.4457036 1.23561914,10.7981411 L5.0347793,6.99891064 C5.0449043,6.9888208 5.05713867,6.98231689 5.06729883,6.97233252 C4.85920898,8.42948877 5.2637168,9.31282471 5.33111133,9.68572705 L2.72719336,12.289645 C1.90457227,13.1122661 1.90457227,14.4501372 2.72719336,15.2727583 C3.54981445,16.0953794 4.88768555,16.0953794 5.71030664,15.2727583 C5.78241211,15.2006528 9.38606836,11.5969966 9.50950195,11.473563 C10.3387676,10.6442974 10.303084,9.28403174 9.50950195,8.49044971 C9.42632227,8.40727002 9.3362168,8.33628955 9.24350977,8.27061768 C9.23591602,7.91452002 9.0873457,7.42103174 9.50950195,6.9989458 L10.1530371,6.35541064 C10.4555215,6.52883643 10.7420801,6.73998486 11.0010059,6.9989458 Z\" id=\"ic_link\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n    </g>\n</svg>"

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"14px\" height=\"16px\" viewBox=\"0 0 14 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->\n    <desc>Created with Sketch.</desc>\n    <g id=\"Apricot-Mobile\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Home-(Main-Menu)\" transform=\"translate(-20.000000, -569.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <g id=\"Menu\" transform=\"translate(0.000000, 24.000000)\">\n                <g id=\"TP\" transform=\"translate(0.000000, 532.000000)\">\n                    <path d=\"M33.6594313,20.5909233 C33.4325134,20.378783 33.1571556,20.2727924 32.8329323,20.2727924 L32.4442646,20.2727924 L32.4442646,18.0908512 C32.4442646,16.6969338 31.9096814,15.5000721 30.8401746,14.5000672 C29.7707529,13.5000224 28.4908863,13 26.9999361,13 C25.5090284,13 24.2289063,13.5000224 23.1595698,14.5000274 C22.090063,15.5000721 21.5554799,16.696894 21.5554799,18.0908512 L21.5554799,20.2727924 L21.1666418,20.2727924 C20.842674,20.2727924 20.5671459,20.378783 20.3402705,20.5909233 C20.1133951,20.8029045 20,21.0605376 20,21.3637431 L20,27.9091289 C20,28.2120558 20.1134377,28.4697685 20.3402705,28.6819487 C20.5671459,28.89389 20.842674,29 21.1666418,29 L32.8332303,29 C33.1574535,29 33.4327687,28.8940094 33.6597293,28.6819487 C33.8863918,28.4697685 34,28.2120558 34,27.9091289 L34,21.3636237 C34.0001701,21.060657 33.8863918,20.8030637 33.6594313,20.5909233 Z M30.1110235,20.2727924 L23.8888486,20.2727924 L23.8888486,18.0908512 C23.8888486,17.2878621 24.1927255,16.602207 24.8003514,16.0341245 C25.4080625,15.4659625 26.1412148,15.1819412 27.0000638,15.1819412 C27.8589978,15.1819412 28.5919799,15.4659227 29.1997335,16.0341245 C29.8071892,16.6021672 30.1110235,17.2878621 30.1110235,18.0908512 L30.1110235,20.2727924 Z\" id=\"ic_lock_14x16\"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n"

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"13px\" height=\"16px\" viewBox=\"0 0 13 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->\n    <desc>Created with Sketch.</desc>\n    <g id=\"Apricot-Mobile\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Home-(Main-Menu)\" transform=\"translate(-22.000000, -611.000000)\" fill=\"currentColor\">\n            <g id=\"Menu\" transform=\"translate(0.000000, 24.000000)\">\n                <g id=\"TP\" transform=\"translate(0.000000, 574.000000)\">\n                    <g id=\"ic_logout_14x16\" transform=\"translate(22.000000, 13.000000)\">\n                        <rect id=\"Rectangle-path\" x=\"5.973448\" y=\"0\" width=\"1\" height=\"7\"></rect>\n                        <path d=\"M9.1543778,3.50996078 L8.72970701,4.4285091 C10.6961552,5.2746075 11.9667966,7.16293204 11.9667966,9.23923746 C11.9667966,12.1422967 9.51861467,14.504144 6.50935991,14.504144 C3.50010516,14.504144 1.05199273,12.1423302 1.05199273,9.23927098 C1.05199273,7.16296556 2.32263415,5.27464103 4.28908233,4.42854263 L3.86441153,3.50999431 C1.52257106,4.51758797 0.00939466667,6.76645228 0.00939466667,9.23927098 C0.00939466667,12.6969191 2.9252705,15.5099608 6.50939467,15.5099608 C10.0935188,15.5099608 13.0093947,12.6969527 13.0093947,9.23927098 C13.0093947,6.76645228 11.4962183,4.51758797 9.1543778,3.50996078 L9.1543778,3.50996078 Z\" id=\"Shape\"></path>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n"

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->\n    \n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"14x14\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M13.7871392,12.7517818 L10.3358997,9.28631113 C11.223274,8.26787909 11.7094716,6.98648317 11.7094716,5.65249447 C11.7094716,2.53575817 9.08298623,0 5.85473581,0 C2.6264854,0 0,2.53575817 0,5.65249447 C0,8.76923077 2.6264854,11.3049889 5.85473581,11.3049889 C7.06666613,11.3049889 8.2215764,10.9520767 9.20899032,10.2821332 L12.6864488,13.7739002 C12.831799,13.9196363 13.0272963,14 13.236794,14 C13.4350914,14 13.6232066,13.9270091 13.7660112,13.7942984 C14.0694393,13.5124109 14.0791123,13.0449742 13.7871392,12.7517818 Z M5.85473581,1.47456377 C8.24092249,1.47456377 10.1821492,3.34873433 10.1821492,5.65249447 C10.1821492,7.95625461 8.24092249,9.83042517 5.85473581,9.83042517 C3.46854914,9.83042517 1.52732239,7.95625461 1.52732239,5.65249447 C1.52732239,3.34873433 3.46854914,1.47456377 5.85473581,1.47456377 Z\" id=\"magnifying_glass\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n    </g>\n</svg>"

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->\n    \n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"18x18\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M17.7263218,16.395148 L13.2890139,11.9395429 C14.4299237,10.6301303 15.0550349,8.98262121 15.0550349,7.26749289 C15.0550349,3.26026051 11.6781252,0 7.52751747,0 C3.37690979,0 0,3.26026051 0,7.26749289 C0,11.2747253 3.37690979,14.5349858 7.52751747,14.5349858 C9.08571359,14.5349858 10.5705982,14.0812414 11.8401304,13.2198855 L16.3111485,17.7093003 C16.4980273,17.8966752 16.7493809,18 17.0187352,18 C17.2736889,18 17.5155513,17.9061545 17.6991573,17.7355265 C18.0892791,17.3730997 18.1017158,16.7721097 17.7263218,16.395148 Z M7.52751747,1.89586771 C10.5954718,1.89586771 13.0913347,4.30551557 13.0913347,7.26749289 C13.0913347,10.2294702 10.5954718,12.6391181 7.52751747,12.6391181 C4.45956318,12.6391181 1.96370021,10.2294702 1.96370021,7.26749289 C1.96370021,4.30551557 4.45956318,1.89586771 7.52751747,1.89586771 Z\" id=\"magnifying_glass\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n    </g>\n</svg>"

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"18px\" height=\"12px\" viewBox=\"0 0 18 12\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 54.1 (76490) - https://sketchapp.com -->\n    <desc>Created with Sketch.</desc>\n    <g id=\"Connect-V2\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Dashboard\" transform=\"translate(-29.000000, -16.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <g id=\"Top-Navigation\" transform=\"translate(0.000000, -1.000000)\">\n                <g id=\"Menu\" transform=\"translate(20.000000, 5.000000)\">\n                    <g id=\"ic_menu_18x12\" transform=\"translate(9.000000, 12.000000)\">\n                        <path d=\"M17.2728984,5 L0.727101562,5 C0.325546875,5 0,5.44768398 0,6 C0,6.55231602 0.325546875,7 0.727101562,7 L17.2728984,7 C17.6744883,7 18,6.55231602 18,6 C18,5.44773233 17.6744883,5 17.2728984,5 Z\" id=\"Shape\"></path>\n                        <path d=\"M17.2728984,0 L0.727101562,0 C0.325546875,0 0,0.447732328 0,1 C0,1.55226767 0.325546875,2 0.727101562,2 L17.2728984,2 C17.6744883,2 18,1.55226767 18,1 C18,0.447732328 17.6744883,0 17.2728984,0 Z\" id=\"Shape\"></path>\n                        <path d=\"M17.2728984,10 L0.727101562,10 C0.325546875,10 0,10.447684 0,11 C0,11.552316 0.325546875,12 0.727101562,12 L17.2728984,12 C17.6744883,12 18,11.552316 18,11 C18,10.447684 17.6744883,10 17.2728984,10 Z\" id=\"Shape\"></path>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n"

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"18px\" height=\"13px\" viewBox=\"0 0 18 13\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: sketchtool 54.1 (76490) - https://sketchapp.com -->\n    <desc>Created with sketchtool.</desc>\n    <g id=\"Connect-V2\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Dashboard-(Menu)\" transform=\"translate(-839.000000, -18.000000)\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <g id=\"Top-Navigation\" transform=\"translate(0.000000, -1.000000)\">\n                <g id=\"Messages\" transform=\"translate(809.000000, 1.000000)\">\n                    <g transform=\"translate(21.000000, 5.000000)\" id=\"ic_message_18x13\">\n                        <path d=\"M24.863602,13 L11.1364451,13 C9.95841849,13 9,13.8752011 9,14.9509384 L9,24.0490616 C9,25.1247989 9.95841849,26 11.1364451,26 L24.863602,26 C26.0416286,26 27,25.1247989 27,24.0490616 L27,14.9509384 C27,13.8752011 26.0416286,13 24.863602,13 Z M24.863602,24.2776378 L11.1364451,24.2776378 C10.9632835,24.2776378 10.8114138,24.1708525 10.8114138,24.0490616 L10.8114138,16.1540208 L17.0198421,21.138085 C17.1471225,21.2403016 17.3089787,21.296561 17.4756397,21.296561 L18.5241719,21.2966058 C18.6907387,21.2966058 18.8526891,21.2403016 18.9800166,21.138085 L25.1887275,16.1538416 L25.1887275,24.0491512 C25.1886333,24.1708525 25.0367165,24.2776378 24.863602,24.2776378 Z M18.0000236,19.5863824 L11.9615537,14.7223622 L24.0384934,14.7223622 L18.0000236,19.5863824 Z\"></path>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n"

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->\n\n    <desc>Created with Sketch.</desc>\n    <g id=\"14x14\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"ic_paper_clip_\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <path d=\"M3.85,11 C1.75,11 0,9.18181818 0,7 C0,4.81818182 1.75,3 3.85,3 L11.2,3 C12.74,3 14,4.30909091 14,5.90909091 C14,7.50909091 12.74,8.81818182 11.2,8.81818182 L5.25,8.81818182 C4.27,8.81818182 3.5,8.01818182 3.5,7 C3.5,5.98181818 4.27,5.18181818 5.25,5.18181818 L10.5,5.18181818 L10.5,6.27272727 L5.25,6.27272727 C4.83,6.27272727 4.55,6.56363636 4.55,7 C4.55,7.43636364 4.83,7.72727273 5.25,7.72727273 L11.2,7.72727273 C12.18,7.72727273 12.95,6.92727273 12.95,5.90909091 C12.95,4.89090909 12.18,4.09090909 11.2,4.09090909 L3.85,4.09090909 C2.31,4.09090909 1.05,5.4 1.05,7 C1.05,8.6 2.31,9.90909091 3.85,9.90909091 L10.5,9.90909091 L10.5,11 L3.85,11 Z\" id=\"Shape\"></path>\n        </g>\n    </g>\n</svg>\n"

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->\n\n    <desc>Created with Sketch.</desc>\n    <g id=\"18x18\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"ic_paper_clip_\" fill=\"currentColor\" fill-rule=\"nonzero\">\n            <path d=\"M4.95,14.1428571 C2.25,14.1428571 0,11.8051948 0,9 C0,6.19480519 2.25,3.85714286 4.95,3.85714286 L14.4,3.85714286 C16.38,3.85714286 18,5.54025974 18,7.5974026 C18,9.65454545 16.38,11.3376623 14.4,11.3376623 L6.75,11.3376623 C5.49,11.3376623 4.5,10.3090909 4.5,9 C4.5,7.69090909 5.49,6.66233766 6.75,6.66233766 L13.5,6.66233766 L13.5,8.06493506 L6.75,8.06493506 C6.21,8.06493506 5.85,8.43896104 5.85,9 C5.85,9.56103896 6.21,9.93506494 6.75,9.93506494 L14.4,9.93506494 C15.66,9.93506494 16.65,8.90649351 16.65,7.5974026 C16.65,6.28831169 15.66,5.25974026 14.4,5.25974026 L4.95,5.25974026 C2.97,5.25974026 1.35,6.94285714 1.35,9 C1.35,11.0571429 2.97,12.7402597 4.95,12.7402597 L13.5,12.7402597 L13.5,14.1428571 L4.95,14.1428571 Z\" id=\"Shape\"></path>\n        </g>\n    </g>\n</svg>\n"

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"40px\" height=\"40px\" viewBox=\"0 0 40 40\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 53 (72520) - https://sketchapp.com -->\n    <desc>Created with Sketch.</desc>\n    <defs>\n        <circle id=\"path-1\" cx=\"18\" cy=\"18\" r=\"18\"></circle>\n    </defs>\n    <g id=\"V3\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"All-Portal-Participants\" transform=\"translate(-350.000000, -162.000000)\">\n            <g id=\"Card\" transform=\"translate(216.000000, 164.000000)\">\n                <g id=\"ic_portal_participants_36x36\" transform=\"translate(136.000000, 0.000000)\">\n                    <mask id=\"mask-2\" fill=\"white\">\n                        <use xlink:href=\"#path-1\"></use>\n                    </mask>\n                    <circle stroke=\"currentColor\" stroke-width=\"2\" cx=\"18\" cy=\"18\" r=\"19\"></circle>\n                    <path d=\"M21.1037065,17.2909258 C22.4908274,18.152151 23.4634968,19.6095235 23.6405841,21.3012027 C24.2062898,21.562944 24.8341445,21.7134637 25.4998128,21.7134637 C27.9299888,21.7134637 29.899663,19.7630092 29.899663,17.3569172 C29.899663,14.9504545 27.9299888,13 25.4998128,13 C23.0928491,13.0007415 21.1403969,14.9163466 21.1037065,17.2909258 Z M18.2212654,26.2116323 C20.6514414,26.2116323 22.6211157,24.260807 22.6211157,21.8547151 C22.6211157,19.4486231 20.651067,17.4981686 18.2212654,17.4981686 C15.7914639,17.4981686 13.8206664,19.4489938 13.8206664,21.8550858 C13.8206664,24.2611778 15.7914639,26.2116323 18.2212654,26.2116323 Z M20.0876076,26.5085937 L16.3541745,26.5085937 C13.2478472,26.5085937 10.7207039,29.0114484 10.7207039,32.0874646 L10.7207039,36.6086189 L10.73231,36.67943 L11.046799,36.7769341 C14.0112317,37.6941409 16.5866717,38 18.706477,38 C22.8468738,38 25.2467241,36.8310619 25.3946088,36.7565435 L25.6885062,36.6093604 L25.7199551,36.6093604 L25.7199551,32.0874646 C25.7210782,29.0114484 23.1939349,26.5085937 20.0876076,26.5085937 Z M27.3669038,22.0107959 L23.6622988,22.0107959 C23.6222389,23.4785491 22.989517,24.8002313 21.9887683,25.7508045 C24.7499064,26.5638337 26.7701235,29.0993134 26.7701235,32.0941379 L26.7701235,33.4873727 C30.4279296,33.3546483 32.5357544,32.3280738 32.6746537,32.2591165 L32.9685511,32.1115626 L33,32.1115626 L33,27.5889253 C33,24.5132798 30.4728566,22.0107959 27.3669038,22.0107959 Z M10.500936,21.7142052 C11.3616623,21.7142052 12.162486,21.4654398 12.8408836,21.0416858 C13.0565331,19.6488218 13.8105578,18.4316877 14.8876825,17.6027168 C14.8921752,17.5211543 14.9000374,17.4403334 14.9000374,17.3580295 C14.9000374,14.9515667 12.9299888,13.0011122 10.500936,13.0011122 C8.07038562,13.0011122 6.10108574,14.9515667 6.10108574,17.3580295 C6.10108574,19.7633799 8.07038562,21.7142052 10.500936,21.7142052 Z M14.4522651,25.7508045 C13.4563834,24.8050509 12.8259079,23.4904127 12.7798577,22.0315572 C12.642456,22.0215473 12.5065519,22.0107959 12.3665294,22.0107959 L8.63347061,22.0107959 C5.52714339,22.0107959 3,24.5132798 3,27.5889253 L3,32.1108211 L3.01160614,32.1805199 L3.3260951,32.2787656 C5.70423063,33.0139398 7.82665668,33.3527946 9.67016099,33.4595673 L9.67016099,32.0941379 C9.67090977,29.0993134 11.6903781,26.5645752 14.4522651,25.7508045 Z\" id=\"Shape\" fill=\"currentColor\" fill-rule=\"nonzero\" mask=\"url(#mask-2)\"></path>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n"

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->\n    \n    <desc>Created with Sketch.</desc>\n    <g id=\"14x14\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"ic_publish\" fill-rule=\"nonzero\">\n            <path d=\"M7.00026693,0 L4.06897781,3.09858444 C3.7770467,3.40008106 3.84195123,3.61265974 4.24976338,3.61265974 L5.88574751,3.61265974 L5.88546895,7.37783437 C5.88546895,8.02793646 6.38409174,8.55555556 6.99970981,8.55555556 C7.61504932,8.55555556 8.11395066,8.02823089 8.11395066,7.37783437 L8.11422922,3.61236531 L9.75104903,3.61236531 C10.1583041,3.61265974 10.2226515,3.3994922 9.93099893,3.09799558 L7.00026693,0 Z\" id=\"Shape\" fill=\"#93AD3C\"></path>\n            <path d=\"M13.7042812,6.22222222 L11.9136902,6.22222222 C11.7496983,6.22222222 11.6176759,6.35105446 11.6176759,6.51043751 L11.6176759,11.6807316 L2.38261964,11.6807316 L2.38261964,6.51043751 C2.38261964,6.35105446 2.25030122,6.22222222 2.08660528,6.22222222 L0.296014367,6.22222222 C0.132318422,6.22222222 -4.74065232e-14,6.35105446 -4.74065232e-14,6.51043751 L-4.74065232e-14,12.4084752 C-4.74065232e-14,13.2860907 0.733819617,14 1.63518337,14 L12.3651122,14 C13.2667719,14 13.9999995,13.2855143 13.9999995,12.4084752 L13.9999995,6.51043751 C14.0002955,6.35105446 13.8682731,6.22222222 13.7042812,6.22222222 Z\" id=\"Shape\" fill=\"currentColor\"></path>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->\n    \n    <desc>Created with Sketch.</desc>\n    <g id=\"18x18\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"ic_publish\" fill-rule=\"nonzero\">\n            <path d=\"M9.00034319,0 L5.23154289,3.98389428 C4.8562029,4.3715328 4.93965158,4.64484823 5.46398149,4.64484823 L7.56738966,4.64484823 L7.56703151,9.48578705 C7.56703151,10.3216326 8.20811795,11 8.99962689,11 C9.79077769,11 10.4322223,10.3220112 10.4322223,9.48578705 L10.4325804,4.64446968 L12.537063,4.64446968 C13.0606766,4.64484823 13.143409,4.37077569 12.7684272,3.98313717 L9.00034319,0 Z\" id=\"Shape\" fill=\"#93AD3C\"></path>\n            <path d=\"M17.6197901,8 L15.3176017,8 C15.1067549,8 14.9370118,8.16564144 14.9370118,8.37056251 L14.9370118,15.0180835 L3.06336811,15.0180835 L3.06336811,8.37056251 C3.06336811,8.16564144 2.89324443,8 2.68277821,8 L0.380589901,8 C0.170123686,8 -4.74065232e-14,8.16564144 -4.74065232e-14,8.37056251 L-4.74065232e-14,15.9537538 C-4.74065232e-14,17.0821167 0.943482364,18 2.10237861,18 L15.8980013,18 C17.0572782,18 17.9999994,17.0813755 17.9999994,15.9537538 L17.9999994,8.37056251 C18.00038,8.16564144 17.8306369,8 17.6197901,8 Z\" id=\"Shape\" fill=\"currentColor\"></path>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->\n    \n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"14x14\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M3.1654066,13.3554398 L2.71428571,3.88888889 L11.2857143,3.88888889 L10.8345934,13.3554398 C10.8194189,13.715692 10.5211952,14 10.158521,14 L3.84147898,14 C3.47880478,14 3.18058112,13.715692 3.1654066,13.3554398 Z M11.5762865,0.659330379 C11.8103143,0.659330379 12,0.840307059 12,1.06355132 L12,2.33333333 L2,2.33333333 L2,1.06351999 C2,0.840275726 2.1896857,0.659299047 2.4237135,0.659299047 L5.33176767,0.659299047 L5.33176767,0.134886531 C5.33176767,0.0604091133 5.39506193,0 5.47313689,0 L8.52686311,0 C8.60497091,0 8.66826517,0.0604091133 8.66826517,0.134886531 L8.66826517,0.659330379 L11.5762865,0.659330379 Z\" id=\"remove\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n    </g>\n</svg>"

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->\n    \n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"18x18\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M3.63156925,17.1712797 L3,5 L15,5 L14.3684308,17.1712797 C14.3471864,17.6344611 13.9296733,18 13.4219294,18 L4.57807058,18 C4.07032669,18 3.65281357,17.6344611 3.63156925,17.1712797 Z M15.4068011,0.847710487 C15.73444,0.847710487 16,1.08039479 16,1.36742312 L16,3 L2,3 L2,1.36738284 C2,1.08035451 2.26555998,0.847670203 2.59319891,0.847670203 L6.66447474,0.847670203 L6.66447474,0.17342554 C6.66447474,0.0776688599 6.7530867,0 6.86239165,0 L11.1376084,0 C11.2469593,0 11.3355712,0.0776688599 11.3355712,0.17342554 L11.3355712,0.847710487 L15.4068011,0.847710487 Z\" id=\"remove\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n    </g>\n</svg>"

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->\n    \n    <desc>Created with Sketch.</desc>\n    <g id=\"14x14\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"ic_retract\" fill-rule=\"nonzero\">\n            <path d=\"M7.00026693,0 L4.06897781,3.09858444 C3.7770467,3.40008106 3.84195123,3.61265974 4.24976338,3.61265974 L5.88574751,3.61265974 L5.88546895,7.37783437 C5.88546895,8.02793646 6.38409174,8.55555556 6.99970981,8.55555556 C7.61504932,8.55555556 8.11395066,8.02823089 8.11395066,7.37783437 L8.11422922,3.61236531 L9.75104903,3.61236531 C10.1583041,3.61265974 10.2226515,3.3994922 9.93099893,3.09799558 L7.00026693,0 Z\" id=\"Shape\" fill=\"#EC5B49\" transform=\"translate(7.000000, 4.277778) scale(1, -1) translate(-7.000000, -4.277778) \"></path>\n            <path d=\"M13.7042812,6.22222222 L11.9136902,6.22222222 C11.7496983,6.22222222 11.6176759,6.35105446 11.6176759,6.51043751 L11.6176759,11.6807316 L2.38261964,11.6807316 L2.38261964,6.51043751 C2.38261964,6.35105446 2.25030122,6.22222222 2.08660528,6.22222222 L0.296014367,6.22222222 C0.132318422,6.22222222 -4.74065232e-14,6.35105446 -4.74065232e-14,6.51043751 L-4.74065232e-14,12.4084752 C-4.74065232e-14,13.2860907 0.733819617,14 1.63518337,14 L12.3651122,14 C13.2667719,14 13.9999995,13.2855143 13.9999995,12.4084752 L13.9999995,6.51043751 C14.0002955,6.35105446 13.8682731,6.22222222 13.7042812,6.22222222 Z\" id=\"Shape\" fill=\"currentColor\"></path>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 52.2 (67145) - http://www.bohemiancoding.com/sketch -->\n    \n    <desc>Created with Sketch.</desc>\n    <g id=\"18x18\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"ic_retract\" fill-rule=\"nonzero\">\n            <path d=\"M9.00034319,0 L5.23154289,3.98389428 C4.8562029,4.3715328 4.93965158,4.64484823 5.46398149,4.64484823 L7.56738966,4.64484823 L7.56703151,9.48578705 C7.56703151,10.3216326 8.20811795,11 8.99962689,11 C9.79077769,11 10.4322223,10.3220112 10.4322223,9.48578705 L10.4325804,4.64446968 L12.537063,4.64446968 C13.0606766,4.64484823 13.143409,4.37077569 12.7684272,3.98313717 L9.00034319,0 Z\" id=\"Shape\" fill=\"#EC5B49\" transform=\"translate(9.000000, 5.500000) scale(1, -1) translate(-9.000000, -5.500000) \"></path>\n            <path d=\"M17.6197901,8 L15.3176017,8 C15.1067549,8 14.9370118,8.16564144 14.9370118,8.37056251 L14.9370118,15.0180835 L3.06336811,15.0180835 L3.06336811,8.37056251 C3.06336811,8.16564144 2.89324443,8 2.68277821,8 L0.380589901,8 C0.170123686,8 -4.74065232e-14,8.16564144 -4.74065232e-14,8.37056251 L-4.74065232e-14,15.9537538 C-4.74065232e-14,17.0821167 0.943482364,18 2.10237861,18 L15.8980013,18 C17.0572782,18 17.9999994,17.0813755 17.9999994,15.9537538 L17.9999994,8.37056251 C18.00038,8.16564144 17.8306369,8 17.6197901,8 Z\" id=\"Shape\" fill=\"currentColor\"></path>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->\n    \n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"14x14\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M6.02433103,7.00295935 L11.7553834,1.76536585 C11.9131885,1.62149593 12,1.42913821 12,1.22403252 C12,1.01881301 11.9131885,0.826569106 11.7553834,0.682471545 L11.2531971,0.223772358 C11.0956411,0.0794471545 10.8850267,0 10.6605873,0 C10.4361478,0 10.2257826,0.0794471545 10.068102,0.223772358 L3.24437081,6.45957724 C3.08606752,6.60413008 2.99938059,6.79728455 3.00000334,7.00261789 C2.99938059,7.20886179 3.08594297,7.40178862 3.24437081,7.54645528 L10.06175,13.7762276 C10.2194305,13.9205528 10.4297958,14 10.6543598,14 C10.8787992,14 11.0891645,13.9205528 11.2469696,13.7762276 L11.7490314,13.3175285 C12.0757265,13.0189756 12.0757265,12.5329593 11.7490314,12.2345203 L6.02433103,7.00295935 Z\" id=\"right_arrow\" fill=\"currentColor\" fill-rule=\"nonzero\" transform=\"translate(7.500000, 7.000000) scale(-1, 1) translate(-7.500000, -7.000000) \"></path>\n    </g>\n</svg>"

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->\n    \n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"18x18\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M7.03244137,9.00380488 L14.6738446,2.2697561 C14.8842514,2.08478049 15,1.83746341 15,1.5737561 C15,1.30990244 14.8842514,1.06273171 14.6738446,0.877463415 L14.0042628,0.287707317 C13.7941881,0.102146341 13.5133689,0 13.2141164,0 C12.9148638,0 12.6343767,0.102146341 12.424136,0.287707317 L3.32582774,8.30517073 C3.11475669,8.49102439 2.99917411,8.73936585 3.00000445,9.00336585 C2.99917411,9.26853659 3.11459062,9.51658537 3.32582774,9.70258537 L12.4156666,17.7122927 C12.6259073,17.8978537 12.9063944,18 13.205813,18 C13.5050656,18 13.7855526,17.8978537 13.9959594,17.7122927 L14.6653752,17.1225366 C15.1009687,16.7386829 15.1009687,16.1138049 14.6653752,15.7300976 L7.03244137,9.00380488 Z\" id=\"right_arrow\" fill=\"currentColor\" fill-rule=\"nonzero\" transform=\"translate(9.000000, 9.000000) scale(-1, 1) translate(-9.000000, -9.000000) \"></path>\n    </g>\n</svg>"

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(-20.000000, -181.000000)\" fill=\"#5A5B5E\">\n            <g transform=\"translate(0.000000, 24.000000)\">\n                <g transform=\"translate(20.000000, 157.000000)\">\n                    <path d=\"M0,0 L16,0 L16,16 L0,16 L0,0 Z M14,14 L14,2 L2,2 L2,14 L14,14 Z\"></path>\n                    <polygon points=\"6 4 13 4 13 6 6 6\"></polygon>\n                    <polygon points=\"6 7 13 7 13 9 6 9\"></polygon>\n                    <polygon points=\"6 10 13 10 13 12 6 12\"></polygon>\n                    <polygon points=\"3 4 5 4 5 6 3 6\"></polygon>\n                    <polygon points=\"3 7 5 7 5 9 3 9\"></polygon>\n                    <polygon points=\"3 10 5 10 5 12 3 12\"></polygon>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n"

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg class=\"ssg-forms-spin\" width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <circle id=\"Spinner\" class=\"path\" cx=\"7\" cy=\"7\" r=\"5.5\" fill=\"none\" stroke-width=\"3\"></circle>\n</svg>"

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg class=\"ssg-forms-spin\" width=\"36px\" height=\"36px\" viewBox=\"0 0 36 36\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <circle id=\"Spinner\" class=\"path\" cx=\"18\" cy=\"18\" r=\"15.5\" fill=\"none\" stroke-width=\"5\"></circle>\n</svg>"

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: sketchtool 55.2 (78181) - https://sketchapp.com -->\n    <desc>Created with sketchtool.</desc>\n    <g id=\"Covid-Updates\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Intake-Form-Designer-Update-V3-1\" transform=\"translate(-752.000000, -23.000000)\" fill=\"currentColor\">\n            <g id=\"Top-Nav\">\n                <g id=\"Attach-CTA\" transform=\"translate(322.000000, 0.000000)\">\n                    <g id=\"Outline-Icon-BTN\" transform=\"translate(228.000000, 12.000000)\">\n                        <g id=\"Icon\" transform=\"translate(202.000000, 11.000000)\">\n                            <path d=\"M12.0759643,5.39480532 L11.7225436,4.5370677 C11.7225436,4.5370677 12.5448142,2.6420968 12.4721846,2.56923878 L11.3833894,1.48365426 C11.3081659,1.4088092 9.45222082,2.27383262 9.45222082,2.27383262 L8.59622936,1.92080238 C8.59622936,1.92080238 7.84010357,0 7.73634703,0 L6.20010176,0 C6.09310283,0 5.39339466,1.92477646 5.39339466,1.92477646 L4.53870016,2.27913138 C4.53870016,2.27913138 2.64384634,1.45649808 2.57121676,1.53001845 L1.484367,2.61692766 C1.40914351,2.69177272 2.27421367,4.54832758 2.27421367,4.54832758 L1.92079295,5.4047405 C1.92079295,5.4047405 0,6.16047689 0,6.26247812 L0,7.80044472 C0,7.90774471 1.9253323,8.60784406 1.9253323,8.60784406 L2.27875302,9.4629323 C2.27875302,9.4629323 1.45648243,11.3565785 1.52846353,11.4294365 L2.61661025,12.5176704 C2.69053678,12.5911908 4.54713038,11.7261674 4.54713038,11.7261674 L5.40377031,12.0805223 C5.40377031,12.0805223 6.1598961,14 6.26430112,14 L7.80054639,14 C7.90689685,14 8.60725349,12.0752235 8.60725349,12.0752235 L9.46454191,11.7208686 C9.46454191,11.7208686 11.3555049,12.5435019 11.4287829,12.4713062 L12.5169296,11.384397 C12.5928016,11.3082273 11.725786,9.45299711 11.725786,9.45299711 L12.0785582,8.59658419 C12.0785582,8.59658419 14,7.83952311 14,7.73619719 L14,6.19955528 C14.0006482,6.09291763 12.0759643,5.39480532 12.0759643,5.39480532 Z M9.24470774,6.99966883 C9.24470774,8.23626816 8.23762082,9.24303354 7.00032408,9.24303354 C5.76432429,9.24303354 4.75594041,8.23626816 4.75594041,6.99966883 C4.75594041,5.7630695 5.76432429,4.7576288 7.00032408,4.7576288 C8.2382693,4.75829115 9.24470774,5.7630695 9.24470774,6.99966883 Z\" id=\"Shape\"></path>\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>"

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 520.61 53.75\"><defs><style>.cls-1{fill:#92ac3c;}.cls-2{fill:#615d54;}</style></defs><title>SS-Logo-Grey-Green-Leaf</title><path class=\"cls-1\" d=\"M559.53,35.65H545a16.67,16.67,0,0,0-16.4,16.92v15a1.92,1.92,0,0,0,1.88,1.94H545a16.67,16.67,0,0,0,16.39-16.93v-15a1.92,1.92,0,0,0-1.88-1.94M531.63,66.14V60.22c4.62-5.72,12.15-13.29,21-15.58a44.24,44.24,0,0,0-21,21.5\" transform=\"translate(-40.8 -35.46)\"/><path class=\"cls-2\" d=\"M59.05,59.28c-7-2.71-9.23-4.82-9.23-8.72,0-3.27,2.61-6.57,8.45-6.57a18.62,18.62,0,0,1,8.92,2.23l.78.43,2.22-6.58-.54-.31c-1.64-.93-5.27-2.49-11.17-2.49-9.74,0-16.55,5.76-16.55,14,0,6.69,4.26,11.31,13.38,14.54,6.44,2.48,8.72,4.83,8.72,9,0,4.68-3.63,7.58-9.47,7.58a21.7,21.7,0,0,1-10.91-3.08l-.83-.51-2,6.76.46.31c2.86,1.91,8.16,3.24,12.88,3.24,13.18,0,17.85-8,17.85-14.81C72,67.29,68.12,62.79,59.05,59.28Z\" transform=\"translate(-40.8 -35.46)\"/><path class=\"cls-2\" d=\"M94.8,51c-10.68,0-18.14,8-18.14,19.37,0,11.07,7.22,18.8,17.56,18.8,9.07,0,18.22-6,18.22-19.37C112.43,58.6,105.34,51,94.8,51Zm-.15,6.28c7.72,0,9.76,8.33,9.76,12.73,0,7.46-4.17,12.88-9.9,12.88s-9.9-5.35-9.9-12.73C84.6,63.79,87.71,57.33,94.65,57.33Z\" transform=\"translate(-40.8 -35.46)\"/><path class=\"cls-2\" d=\"M135.88,57.69a14,14,0,0,1,7,1.57l.82.47,1.9-6.44-.56-.28a22.1,22.1,0,0,0-9.18-1.89c-11.54,0-19.59,8-19.59,19.38,0,11.16,7.32,18.65,18.22,18.65A24.3,24.3,0,0,0,144.93,87l.51-.27L144,80.53l-.83.37a17.37,17.37,0,0,1-7.52,1.68c-6.83,0-11.42-5-11.42-12.37C124.24,62.6,128.81,57.69,135.88,57.69Z\" transform=\"translate(-40.8 -35.46)\"/><path class=\"cls-2\" d=\"M155.09,38a4.63,4.63,0,0,0-4.74,4.74,4.53,4.53,0,0,0,4.59,4.66A4.91,4.91,0,0,0,158.53,46a4.44,4.44,0,0,0,1.22-3.26A4.54,4.54,0,0,0,155.09,38Z\" transform=\"translate(-40.8 -35.46)\"/><rect class=\"cls-2\" x=\"110.35\" y=\"16.38\" width=\"7.88\" height=\"36.58\"/><path class=\"cls-2\" d=\"M194.1,79.26V66.14c0-6.89-2.44-15.1-14.08-15.1a22.43,22.43,0,0,0-11.93,3.24l-.49.32,2,5.66.8-.52a16.67,16.67,0,0,1,8.72-2.49c4.78,0,7.21,2.47,7.22,7.34-8.26.06-14.21,1.86-17.72,5.34a11.48,11.48,0,0,0-3.37,8.45c0,5.38,3.94,10.82,11.48,10.82a14,14,0,0,0,10.37-4.35l.41,3.55h7.36l-.16-.88A47.72,47.72,0,0,1,194.1,79.26Zm-7.66-8.75v5.35a5.91,5.91,0,0,1-.32,1.79A8,8,0,0,1,178.35,83a4.93,4.93,0,0,1-5.27-5.34,5.56,5.56,0,0,1,1.66-4.19c2-2,5.85-3,11.41-3Z\" transform=\"translate(-40.8 -35.46)\"/><rect class=\"cls-2\" x=\"161.94\" width=\"7.88\" height=\"52.95\"/><path class=\"cls-2\" d=\"M250.79,59.28c-7-2.71-9.23-4.82-9.23-8.72,0-3.27,2.61-6.57,8.45-6.57a18.62,18.62,0,0,1,8.92,2.23l.78.43,2.22-6.58-.54-.31c-1.64-.93-5.27-2.49-11.17-2.49-9.74,0-16.55,5.76-16.55,14,0,6.69,4.26,11.31,13.38,14.54,6.44,2.48,8.72,4.83,8.72,9,0,4.68-3.63,7.58-9.47,7.58a21.7,21.7,0,0,1-10.91-3.08l-.83-.51-2,6.76.46.31c2.86,1.91,8.16,3.24,12.88,3.24,13.18,0,17.85-8,17.85-14.81C263.74,67.29,259.87,62.79,250.79,59.28Z\" transform=\"translate(-40.8 -35.46)\"/><path class=\"cls-2\" d=\"M286.54,51c-10.68,0-18.14,8-18.14,19.37,0,11.07,7.22,18.8,17.56,18.8,9.07,0,18.22-6,18.22-19.37C304.17,58.6,297.09,51,286.54,51Zm9.61,19c0,7.46-4.17,12.88-9.9,12.88s-9.9-5.35-9.9-12.73c0-6.41,3.11-12.87,10-12.87C294.11,57.33,296.15,65.65,296.15,70.06Z\" transform=\"translate(-40.8 -35.46)\"/><rect class=\"cls-2\" x=\"269.77\" width=\"7.88\" height=\"52.95\"/><path class=\"cls-2\" d=\"M358.38,78.1V51.84H350.5V74.11a8.53,8.53,0,0,1-.52,3,8.43,8.43,0,0,1-7.71,5.33c-4.83,0-7.08-3.31-7.08-10.41V51.84h-7.88V73.1c0,14.54,9,16.11,12.85,16.11A13.78,13.78,0,0,0,351.28,84l.28,4.47h7.17l-.06-.81C358.47,85.12,358.38,82.1,358.38,78.1Z\" transform=\"translate(-40.8 -35.46)\"/><path class=\"cls-2\" d=\"M376.49,41.54l-7.73,2.07v8.23h-5.44V58.2h5.44V76.58c0,4.69.85,7.75,2.65,9.62a9.53,9.53,0,0,0,7.45,2.94,16.39,16.39,0,0,0,5.94-.93l.5-.2-.38-6.24L384,82a13.36,13.36,0,0,1-3.5.41c-2.09,0-4-.73-4-6.06V58.2h9.13V51.84h-9.13Z\" transform=\"translate(-40.8 -35.46)\"/><path class=\"cls-2\" d=\"M395.09,38a4.63,4.63,0,0,0-4.74,4.74,4.53,4.53,0,0,0,4.59,4.66A4.91,4.91,0,0,0,398.53,46a4.44,4.44,0,0,0,1.22-3.26A4.54,4.54,0,0,0,395.09,38Z\" transform=\"translate(-40.8 -35.46)\"/><rect class=\"cls-2\" x=\"350.35\" y=\"16.38\" width=\"7.88\" height=\"36.58\"/><path class=\"cls-2\" d=\"M423.57,51c-10.68,0-18.14,8-18.14,19.37,0,11.07,7.22,18.8,17.56,18.8,9.07,0,18.22-6,18.22-19.37C441.21,58.6,434.12,51,423.57,51Zm9.61,19c0,7.46-4.17,12.88-9.9,12.88s-9.9-5.35-9.9-12.73c0-6.41,3.11-12.87,10-12.87C431.14,57.33,433.18,65.65,433.18,70.06Z\" transform=\"translate(-40.8 -35.46)\"/><path class=\"cls-2\" d=\"M465.82,51a13.77,13.77,0,0,0-11.12,5.23l-.28-4.43h-7.17l.06.81c.2,2.69.29,5.52.29,9.44V88.42h7.88V66.58a8.47,8.47,0,0,1,.4-2.75,8.28,8.28,0,0,1,7.83-6c6.09,0,7.37,5.23,7.37,9.61v21H479V66.72C479,51.8,468,51,465.82,51Z\" transform=\"translate(-40.8 -35.46)\"/><path class=\"cls-2\" d=\"M500,66.6c-4.8-1.83-6.18-3-6.18-5.24,0-2.41,2.06-4,5.12-4a13,13,0,0,1,6.77,1.91l.8.51,2.1-6.11-.53-.31a18.42,18.42,0,0,0-9-2.28c-7.57,0-12.85,4.54-12.85,11,0,3.26,1.7,7.76,9.77,10.63,4.51,1.67,6,3.12,6,5.75,0,2.8-2.27,4.47-6.06,4.47a15.94,15.94,0,0,1-8-2.42l-.82-.53-2.09,6.36.52.31a20.8,20.8,0,0,0,10.24,2.5c8.42,0,13.87-4.42,13.87-11.26C509.69,72.63,506.7,69.15,500,66.6Z\" transform=\"translate(-40.8 -35.46)\"/></svg>"

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"16px\" height=\"16px\" viewBox=\"0 0 16 16\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 55.2 (78181) - https://sketchapp.com -->\n    <desc>Created with Sketch.</desc>\n    <defs>\n        <circle id=\"path-1\" cx=\"8\" cy=\"8\" r=\"8\"></circle>\n        <circle id=\"path-3\" cx=\"8\" cy=\"8\" r=\"8\"></circle>\n    </defs>\n    <g id=\"Apricot-Mobile\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"Home-(Main-Menu)\" transform=\"translate(-20.000000, -526.000000)\">\n            <g id=\"Menu\" transform=\"translate(0.000000, 24.000000)\">\n                <g id=\"TP\" transform=\"translate(0.000000, 490.000000)\">\n                    <g id=\"ic_user_pref_16x16\" transform=\"translate(20.000000, 12.000000)\">\n                        <mask id=\"mask-2\" fill=\"currentColor\">\n                            <use xlink:href=\"#path-1\"></use>\n                        </mask>\n                        <circle stroke=\"#FFFFFF\" cx=\"8\" cy=\"8\" r=\"7.5\"></circle>\n                        <path d=\"M6.07948701,12.3500117 L4.16622399,13.456355 C4.05394954,13.5212529 3.95304772,13.6010287 3.85916306,13.6879868 C4.97464839,14.6850553 6.41461655,15.2865797 7.98791061,15.2865797 C9.54959008,15.2865797 10.9803633,14.6940333 12.0927031,13.71056 C11.9901074,13.6187281 11.8788009,13.5361307 11.7553958,13.4709763 L9.70662912,12.3851541 C9.44191308,12.2448411 9.27471126,11.9580589 9.27471126,11.6443427 L9.27471126,10.7922044 C9.33230031,10.7226893 9.39811637,10.6334225 9.46852986,10.5279954 C9.74776415,10.1098782 9.95900465,9.64994926 10.105397,9.16744712 C10.3681773,9.08151505 10.5617539,8.82423188 10.5617539,8.51846764 L10.5617539,7.60887031 C10.5617539,7.40878968 10.47779,7.22999968 10.3473678,7.10482103 L10.3473678,5.78993216 C10.3473678,5.78993216 10.602163,3.74372294 7.98815258,3.74372294 C5.37414216,3.74372294 5.6289374,5.78993216 5.6289374,5.78993216 L5.6289374,7.10482103 C5.49827318,7.22999968 5.41455128,7.40878968 5.41455128,7.60887031 L5.41455128,8.51846764 C5.41455128,8.75805137 5.53335894,8.96890557 5.71120747,9.09074954 C5.92559359,10.0801226 6.48696582,10.7922044 6.48696582,10.7922044 L6.48696582,11.6233086 C6.48672385,11.9259947 6.33041072,12.204825 6.07948701,12.3500117 Z\" id=\"Shape\" fill=\"#FFFFFF\" fill-rule=\"nonzero\" mask=\"url(#mask-2)\"></path>\n                        <mask id=\"mask-4\" fill=\"currentColor\">\n                            <use xlink:href=\"#path-3\"></use>\n                        </mask>\n                        <circle stroke=\"#FFFFFF\" cx=\"8\" cy=\"8\" r=\"7.5\"></circle>\n                    </g>\n                </g>\n            </g>\n        </g>\n    </g>\n</svg>\n"

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"14px\" height=\"14px\" viewBox=\"0 0 14 14\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->\n    \n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"14x14\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M8.36639821,6.99975361 L13.7187769,1.64928245 C14.093741,1.2723472 14.093741,0.659573091 13.7187769,0.282701433 C13.3418417,-0.0942338109 12.72716,-0.0942338109 12.3521959,0.282701433 L6.99981719,5.63317259 L1.64928245,0.282701433 C1.2723472,-0.0942338109 0.659573091,-0.0942338109 0.282701433,0.282701433 C-0.0941702254,0.659636677 -0.0942338109,1.27241079 0.282701433,1.64928245 L5.63317259,6.99975361 L0.282701433,12.3521323 C-0.0942338109,12.7270964 -0.0942338109,13.3418417 0.282701433,13.7187133 C0.659636677,14.0936774 1.27241079,14.0936774 1.64928245,13.7187133 L6.99975361,8.36633462 L12.3521323,13.7187133 C12.7270964,14.0936774 13.3418417,14.0936774 13.7187133,13.7187133 C14.0936774,13.3417781 14.0936774,12.7270964 13.7187133,12.3521323 L8.36639821,6.99975361 Z\" id=\"x\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n    </g>\n</svg>"

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<svg width=\"18px\" height=\"18px\" viewBox=\"0 0 18 18\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">\n    <!-- Generator: Sketch 51.2 (57519) - http://www.bohemiancoding.com/sketch -->\n    \n    <desc>Created with Sketch.</desc>\n    <defs></defs>\n    <g id=\"18x18\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M10.7568466,8.99972408 L17.6385076,2.12051564 C18.1206065,1.63588241 18.1206065,0.848026397 17.6385076,0.363474922 C17.1538744,-0.121158307 16.3635658,-0.121158307 15.8814669,0.363474922 L8.99980584,7.24268337 L2.12051564,0.363474922 C1.63588241,-0.121158307 0.848026397,-0.121158307 0.363474922,0.363474922 C-0.121076554,0.84810815 -0.121158307,1.63596416 0.363474922,2.12051564 L7.24268337,8.99972408 L0.363474922,15.8813851 C-0.121158307,16.363484 -0.121158307,17.1538744 0.363474922,17.6384258 C0.84810815,18.1205247 1.63596416,18.1205247 2.12051564,17.6384258 L8.99972408,10.7567648 L15.8813851,17.6384258 C16.363484,18.1205247 17.1538744,18.1205247 17.6384258,17.6384258 C18.1205247,17.1537926 18.1205247,16.363484 17.6384258,15.8813851 L10.7568466,8.99972408 Z\" id=\"x\" fill=\"currentColor\" fill-rule=\"nonzero\"></path>\n    </g>\n</svg>"

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(165);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../css-loader/index.js!./_datepicker.css", function() {
		var newContent = require("!!../../../css-loader/index.js!./_datepicker.css");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(166);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./collapsible-error-display.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./collapsible-error-display.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(167);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./form-validation-control.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./form-validation-control.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(168);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./inline-warning.scss", function() {
		var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./inline-warning.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(169);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./attachment-element.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./attachment-element.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(170);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./checkbox-element.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./checkbox-element.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(171);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./date-element.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./date-element.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(172);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./electronic-signature-element.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./electronic-signature-element.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(173);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./email-notification-element.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./email-notification-element.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(174);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./form-element.scss", function() {
		var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./form-element.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(175);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./giscoordinates-element.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./giscoordinates-element.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(176);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./group-element.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./group-element.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(177);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js!./indented.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js!./indented.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(178);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js!./inline.scss", function() {
		var newContent = require("!!../../../../../node_modules/css-loader/index.js!../../../../../node_modules/sass-loader/lib/loader.js!./inline.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(179);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./heading-element.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./heading-element.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(180);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./help-element.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./help-element.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(181);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./likert-scale-element.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./likert-scale-element.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(182);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./numeric.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./numeric.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(184);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./select-element.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./select-element.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(185);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./single-checkbox-input.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./single-checkbox-input.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(186);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./text-area-element.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./text-area-element.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(187);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./text-element.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./text-element.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(188);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./time-element.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./time-element.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(189);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./buttons.scss", function() {
		var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./buttons.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(190);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./index.scss", function() {
		var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./index.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(191);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./variables.scss", function() {
		var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./variables.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(192);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./ssg-form.scss", function() {
		var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/lib/loader.js!./ssg-form.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(193);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./cancel-button.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./cancel-button.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(194);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./collapsible-section.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./collapsible-section.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(195);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./custom-icon.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./custom-icon.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(196);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./descriptors.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./descriptors.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(197);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./image-display.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./image-display.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(198);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./loading-pane.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./loading-pane.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(199);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./menu-button.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./menu-button.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(200);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./menu.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./menu.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(201);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./modal.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./modal.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(202);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./application.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./application.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(203);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./header.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./header.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(205);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./paging-control.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./paging-control.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(206);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./save-button.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./save-button.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(207);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./highlight-text.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./highlight-text.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(208);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./search-bar.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./search-bar.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(209);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./table.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./table.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(210);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./tabs.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./tabs.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(211);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./tooltip.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./tooltip.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(212);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./widget.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./widget.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(213);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(4)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./wizard.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./wizard.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 307 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(261);
var defaultStyle = {
    display: 'ssg-forms-collapsible-error-display ssg-forms-text',
    collapsedDisplay: 'ssg-forms-collapsible-error-collapsed-display',
    collapsedErrorText: 'ssg-forms-collapsible-error-collapsed-error-text',
    errorSummaryText: 'ssg-forms-collapsible-error-error-summary-text ssg-forms-text normal',
    errorSummaryCount: 'ssg-forms-collapsible-error-count',
    collapseButton: 'ssg-forms-collapsible-error-collapse-button',
    collapseButtonText: 'ssg-forms-collapsible-error-collapse-button-text',
};
exports.default = defaultStyle;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var free_solid_svg_icons_1 = __webpack_require__(13);
var react_fontawesome_1 = __webpack_require__(14);
var collapsible_error_display_style_1 = __webpack_require__(308);
var CollapsibleErrorDisplay = /** @class */ (function (_super) {
    __extends(CollapsibleErrorDisplay, _super);
    function CollapsibleErrorDisplay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            expanded: false,
        };
        return _this;
    }
    /** determines if the display should be expanded based on the expanded prop and the expanded state */
    CollapsibleErrorDisplay.prototype.isExpanded = function () {
        var expandedProp = this.props.expanded;
        var expanded = this.state.expanded;
        return (expandedProp !== undefined && expandedProp !== null) ? expandedProp : expanded;
    };
    /** handles setting the state and calling onCollapse/onExpand as appropriate */
    CollapsibleErrorDisplay.prototype.handleCollapseButton = function (event) {
        event.preventDefault();
        var _a = this.props, onExpand = _a.onExpand, onCollapse = _a.onCollapse;
        var currentlyExpanded = this.isExpanded();
        this.setState({ expanded: !currentlyExpanded });
        if (currentlyExpanded) {
            onCollapse && onCollapse();
        }
        else {
            onExpand && onExpand();
        }
    };
    CollapsibleErrorDisplay.prototype.render = function () {
        var _this = this;
        var _a = this.props, errorCount = _a.errorCount, mainErrorText = _a.mainErrorText, expandedDisplay = _a.expandedDisplay, expandButtonDisplay = _a.expandButtonDisplay, collapseButtonDisplay = _a.collapseButtonDisplay, css = _a.css;
        var expanded = this.isExpanded();
        var display = errorCount > 0 ? (React.createElement("div", { className: css.display },
            React.createElement("div", { id: "main-error-display", className: css.collapsedDisplay },
                React.createElement("div", { className: css.collapsedErrorText },
                    React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faExclamationCircle }),
                    React.createElement("span", { className: css.errorSummaryText },
                        React.createElement("span", { className: css.errorSummaryCount },
                            errorCount,
                            " ERROR",
                            errorCount > 1 ? "S " : " "),
                        mainErrorText)),
                React.createElement("button", { id: "details-button", className: css.collapseButton, "aria-label": expanded ? "hide details" : "show details", onClick: function (event) { return _this.handleCollapseButton(event); } }, expanded ? collapseButtonDisplay : expandButtonDisplay)),
            expanded ? (React.createElement("div", { id: "error-details" }, expandedDisplay)) : null)) : null;
        return display;
    };
    CollapsibleErrorDisplay.defaultProps = {
        expandButtonDisplay: (React.createElement("span", null,
            React.createElement("span", { className: collapsible_error_display_style_1.default.collapseButtonText }, "SHOW DETAILS"),
            React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faAngleDown }))),
        collapseButtonDisplay: (React.createElement("span", null,
            React.createElement("span", { className: collapsible_error_display_style_1.default.collapseButtonText }, "HIDE DETAILS"),
            React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faAngleUp }))),
    };
    return CollapsibleErrorDisplay;
}(React.Component));
exports.CollapsibleErrorDisplay = CollapsibleErrorDisplay;
exports.default = react_styleable_1.default(collapsible_error_display_style_1.default)(CollapsibleErrorDisplay);


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var collapsible_error_display_1 = __webpack_require__(309);
exports.CollapsibleErrorDisplay = collapsible_error_display_1.default;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
/**
 * Class that stores the inline errors and their ids that will be displayed on each element.
 */
var ElementErrorDisplay = /** @class */ (function () {
    function ElementErrorDisplay(displayErrors, errorIds) {
        var displayErrorsList = immutable_1.List(displayErrors);
        this.displayErrors = displayErrorsList;
        this.hasDisplayErrors = !displayErrorsList.isEmpty();
        this.errorIds = errorIds;
    }
    return ElementErrorDisplay;
}());
exports.default = ElementErrorDisplay;


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ssg_forms_processing_1 = __webpack_require__(7);
var immutable_1 = __webpack_require__(2);
exports.defaultValues = {
    id: '',
    sourceId: '',
    subSection: '',
    type: ssg_forms_processing_1.validation.errorTypes.inline,
    context: '',
    errorMessage: '',
    display: null,
};
exports.FormErrorRecord = immutable_1.Record(exports.defaultValues);
var FormError = /** @class */ (function (_super) {
    __extends(FormError, _super);
    function FormError(props) {
        return _super.call(this, props) || this;
    }
    return FormError;
}(exports.FormErrorRecord));
exports.FormError = FormError;
;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var form_validation_control_style_1 = __webpack_require__(52);
var react_fontawesome_1 = __webpack_require__(14);
var free_solid_svg_icons_1 = __webpack_require__(13);
var utilities_1 = __webpack_require__(9);
/**
 * Control that displays all validation errors for each element in the form. This control
 * is displayed at the top of the form and only appears after the user submits the form. If
 * there are errors after submitting, each error disappears after it is fixed.
 */
var FormValidationControl = /** @class */ (function (_super) {
    __extends(FormValidationControl, _super);
    function FormValidationControl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * returns an error message to be read by the accessibility notifications
     */
    FormValidationControl.prototype.getErrorMessage = function () {
        var _a = this.props, errors = _a.errors, errorsTitle = _a.errorsTitle, getErrorText = _a.getErrorText;
        var message = errorsTitle;
        message += '\n';
        errors && errors.forEach(function (error) {
            message += getErrorText(error);
            message += '\n';
        });
        return message;
    };
    /**
     * compares two arrays of errors to see if they are the same
     * @param array1 the first array
     * @param array2 the second array
     */
    FormValidationControl.prototype.compareErrors = function (array1, array2) {
        return !!array1 && !!array2 &&
            Array.isArray(array1) && Array.isArray(array2) &&
            (array1.length === array2.length) &&
            array1.every(function (error1, index) {
                var error2 = array2[index];
                return error1.equals(error2);
            });
    };
    ;
    FormValidationControl.prototype.componentWillMount = function () {
        utilities_1.accessibilityNotificationsEmitter.polite(this.getErrorMessage());
    };
    FormValidationControl.prototype.componentDidUpdate = function (prevProps) {
        var prevErrors = prevProps.errors;
        var errors = this.props.errors;
        if (!this.compareErrors(errors, prevErrors)) {
            utilities_1.accessibilityNotificationsEmitter.polite(this.getErrorMessage());
        }
    };
    FormValidationControl.prototype.render = function () {
        var _a = this.props, isValid = _a.isValid, errors = _a.errors, errorsTitle = _a.errorsTitle, getErrorText = _a.getErrorText, css = _a.css;
        var errorList = errors && errors.map(function (error, i) { return (React.createElement("li", { role: "presentation", key: i }, getErrorText(error))); });
        var errorDisplay = null;
        if (!isValid) {
            errorDisplay =
                (React.createElement("div", { className: css.errorWrapper },
                    React.createElement("div", { className: css.errorSection },
                        React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "lg", icon: free_solid_svg_icons_1.faExclamationCircle }),
                        React.createElement("span", { id: 'form-validation-title' }, errorsTitle),
                        React.createElement("ul", { className: css.errorList }, errorList))));
        }
        return (React.createElement("div", null, errorDisplay));
    };
    FormValidationControl.defaultProps = {
        errorsTitle: 'The following validation errors occured:',
        getErrorText: function (error) { return error.errorMessage + (error.context ? ": " + error.context : ""); },
    };
    return FormValidationControl;
}(React.Component));
exports.FormValidationControl = FormValidationControl;
exports.default = react_styleable_1.default(form_validation_control_style_1.default)(FormValidationControl);


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var form_validation_control_1 = __webpack_require__(313);
exports.FormValidationControl = form_validation_control_1.default;
var form_validation_control_style_1 = __webpack_require__(52);
exports.defaultStyle = form_validation_control_style_1.default;


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var inline_warning_style_1 = __webpack_require__(53);
var InlineWarningList = /** @class */ (function (_super) {
    __extends(InlineWarningList, _super);
    function InlineWarningList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineWarningList.prototype.render = function () {
        var _a = this.props, show = _a.show, warningMain = _a.warningMain, warningList = _a.warningList, css = _a.css;
        var count = -1;
        var listDisplay = (warningList.map(function (warning) {
            count++;
            return (React.createElement("li", { key: count, role: "presentation", className: css.warning }, warning));
        }));
        return show ? (React.createElement("ul", { role: "alert", className: css.warningList, "aria-live": "assertive" },
            warningMain,
            listDisplay)) : null;
    };
    return InlineWarningList;
}(React.Component));
exports.InlineWarningList = InlineWarningList;
exports.default = react_styleable_1.default(inline_warning_style_1.default)(InlineWarningList);


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var inline_warning_style_1 = __webpack_require__(53);
var react_fontawesome_1 = __webpack_require__(14);
var free_solid_svg_icons_1 = __webpack_require__(13);
var InlineWarning = /** @class */ (function (_super) {
    __extends(InlineWarning, _super);
    function InlineWarning() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineWarning.prototype.render = function () {
        var _a = this.props, warning = _a.warning, css = _a.css;
        return !!warning ? (React.createElement("div", { role: "alert", "aria-live": "assertive", className: css.warningMessage },
            React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "lg", icon: free_solid_svg_icons_1.faExclamationCircle }),
            React.createElement("span", { id: warning.id, className: css.warningText }, !warning.display ? warning.errorMessage : warning.display))) : null;
    };
    return InlineWarning;
}(React.Component));
exports.InlineWarning = InlineWarning;
exports.default = react_styleable_1.default(inline_warning_style_1.default)(InlineWarning);


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ssg_forms_processing_1 = __webpack_require__(7);
var immutable_1 = __webpack_require__(2);
var react_styleable_1 = __webpack_require__(1);
var attachment_element_style_1 = __webpack_require__(54);
var utilities_1 = __webpack_require__(9);
var classnames_1 = __webpack_require__(6);
var error_reporting_1 = __webpack_require__(10);
var react_fontawesome_1 = __webpack_require__(14);
var free_solid_svg_icons_1 = __webpack_require__(13);
var form_error_utils_1 = __webpack_require__(11);
var fileLoaderId = function (id) { return id + '-file-loader'; };
/**
 * This element renders an input that allows the user to upload attachment files
 */
var AttachmentElement = /** @class */ (function (_super) {
    __extends(AttachmentElement, _super);
    function AttachmentElement(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            downloadDisabled: false
        };
        return _this;
    }
    /**
     * @hidden Called upon onChange of the underlying file input control.
     * @param e The file change event. The file list (e.target.files) is passed along to the
     * onChange function supplied during component creation.
     */
    AttachmentElement.prototype.handleInput = function (e) {
        var onChange = this.props.onChange;
        var formFiles = e.target.files;
        onChange(formFiles);
    };
    /**
     * This resets the selected file value, so that the onChange event with trigger,
     * even if the same file is selected again.
     * @param e on click event
     */
    AttachmentElement.prototype.handleClick = function (e) {
        e.target.value = null;
    };
    AttachmentElement.prototype.handleDownload = function (e, fileId, fileName) {
        var _this = this;
        e.preventDefault();
        var onDownload = this.props.onDownload;
        if (!onDownload)
            return;
        this.setState({ downloadDisabled: true });
        onDownload(fileId, fileName)
            .then(function (blob) { return _this.setState({ downloadDisabled: false }); })
            .catch(function (err) { return _this.setState({ downloadDisabled: false }); });
    };
    AttachmentElement.prototype.handleFileSelect = function (e) {
        e.preventDefault();
        var id = this.props.element.id;
        var fileInput = document.getElementById(fileLoaderId(id));
        fileInput.click();
    };
    AttachmentElement.prototype.getValue = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        return !!value ? value : !!defaultValue ? defaultValue :
            new ssg_forms_processing_1.formDefinition.AttachmentResponseState({ files: immutable_1.List([]), fileCount: 0 });
    };
    AttachmentElement.prototype.removeFile = function (e, elementId, fileId) {
        e.preventDefault();
        var _a = this.props, value = _a.value, onRemove = _a.onRemove;
        onRemove(elementId, fileId);
    };
    /**
     * Renders the file display, including the following.
     * an icon to indicate if it has finished uploading,
     * the name of the file
     * a button to remove the attachment
     * @param key a key to be used to distinguish items in a list
     * @param file the file information
     */
    AttachmentElement.prototype.renderFile = function (key, file, showDelete) {
        var _this = this;
        var _a = this.props, element = _a.element, css = _a.css;
        var id = element.id;
        var fileNameId = id + '-' + file.get('id') + '-fileName';
        var isUploading = file && file.get('isUploading');
        return (React.createElement("div", { key: key, className: css.fileDisplay },
            React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: isUploading ? free_solid_svg_icons_1.faSpinner : free_solid_svg_icons_1.faCheck, className: isUploading ? css.uploadingIcon : css.uploadedIcon, size: "xs" }),
            React.createElement("span", { id: fileNameId, className: css.fileName }, file.get('fileName')),
            showDelete ? (React.createElement("button", { title: 'delete', "aria-label": 'delete', className: css.deleteButton, "aria-describedby": fileNameId, onClick: function (e) { return _this.removeFile(e, id, file.get('id')); } },
                React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: css.deleteIcon, icon: free_solid_svg_icons_1.faTrash, size: "xs" }))) : null));
    };
    AttachmentElement.prototype.render = function () {
        var _this = this;
        var downloadDisabled = this.state.downloadDisabled;
        var _a = this.props, showErrors = _a.showErrors, element = _a.element, errors = _a.errors, css = _a.css, value = _a.value, onDownload = _a.onDownload;
        var isRequired = element.isRequired, hidden = element.hidden, label = element.label, ariaLabel = element.ariaLabel, id = element.id, disabled = element.disabled, readOnly = element.readOnly, allowMultipleFiles = element.allowMultipleFiles, imageAttachment = element.imageAttachment, tooltip = element.tooltip, autoComplete = element.autoComplete;
        if (hidden)
            return null;
        var currentValue = this.getValue();
        var currentFiles = currentValue && currentValue.files && currentValue.files.toArray();
        var showDelete = !!value || element.allowRemoveExisting;
        var inlineDisplay = form_error_utils_1.getElementErrorDisplay(errors, showErrors, !!currentValue);
        var inputDisplay;
        if (readOnly) {
            inputDisplay =
                React.createElement("ul", { id: "file-list", className: css.inputWrapper }, currentFiles && currentFiles.length > 0 ? currentFiles.map(function (file, index) {
                    var fileObject = file.toObject();
                    return (React.createElement("li", { id: id + "-list-file-" + index, key: index, className: css.link }, !!downloadDisabled || !onDownload ?
                        React.createElement("a", { id: id + "-file-link-" + index, href: "#file-link-" + index, className: "disabled-link", "aria-label": label + ", " + (isRequired ? "required " : "") + fileObject.fileName + "." }, fileObject.fileName)
                        : React.createElement("a", { id: id + "-file-link-" + index, href: "#file-link-" + index, onClick: function (e) { return _this.handleDownload(e, fileObject.id, fileObject.fileName); }, "aria-label": label + ", " + (isRequired ? "required " : "") + fileObject.fileName + ": Click to download." }, fileObject.fileName)));
                }) : (React.createElement("div", { className: css.emptyText },
                    React.createElement("p", { id: id + "-empty-list" }, "No file selected!"))));
        }
        else {
            // for ARIA
            var files = currentValue.files, fileCount = currentValue.fileCount;
            var selectedFilesNames = fileCount === 0 ? "" : (files && files.map(function (file) { return file.get('fileName') + ' '; }));
            var acceptFiles = imageAttachment !== null && imageAttachment !== undefined && imageAttachment ? ".png,.jpg,.jpeg,.svg,.gif" : "*";
            inputDisplay =
                React.createElement("div", { className: css.inputWrapper },
                    React.createElement("div", { className: css.inlineErrorDisplay }, inlineDisplay.displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); })),
                    React.createElement("input", { id: fileLoaderId(id), tabIndex: -1, className: "ssg-forms-skip", type: "file", onChange: function (e) { return _this.handleInput(e); }, onClick: function (e) { return _this.handleClick(e); }, accept: acceptFiles, autoComplete: autoComplete, "aria-label": "File Upload", multiple: allowMultipleFiles === null || allowMultipleFiles === undefined || allowMultipleFiles }),
                    files && files.map(function (file, index) { return _this.renderFile(index.toString(), file, showDelete); }),
                    React.createElement("button", { id: id + "-select-file", type: "button", className: css.attachButton, onClick: function (e) { return _this.handleFileSelect(e); }, disabled: disabled, "aria-label": "File Upload", "aria-invalid": inlineDisplay.hasDisplayErrors, "aria-describedby": inlineDisplay.errorIds + ' file-details' + id }, "SELECT FILE"),
                    React.createElement("div", { id: "file-details" + id, className: "ssg-forms-skip" },
                        "Selected Files: ",
                        selectedFilesNames));
        }
        return (React.createElement("fieldset", { id: id, className: css.group },
            React.createElement(utilities_1.descriptors.RequiredLegend, { hasErrors: inlineDisplay.hasDisplayErrors, htmlFor: id, content: label, ariaLabel: ariaLabel, isRequired: isRequired, css: {
                    requiredLegend: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                    requiredIndicator: css.requiredIndicator,
                    tooltipGroup: css.labelWrapper,
                }, tooltip: tooltip }),
            inputDisplay));
    };
    return AttachmentElement;
}(React.Component));
exports.AttachmentElement = AttachmentElement;
exports.default = react_styleable_1.default(attachment_element_style_1.default)(AttachmentElement);


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ssg_forms_processing_1 = __webpack_require__(7);
var react_styleable_1 = __webpack_require__(1);
var checkbox_element_style_1 = __webpack_require__(56);
var multiple_choice_input_1 = __webpack_require__(24);
var classnames_1 = __webpack_require__(6);
var descriptors_1 = __webpack_require__(19);
var form_error_utils_1 = __webpack_require__(11);
var error_reporting_1 = __webpack_require__(10);
/** The implementation for the Checkbox element. This element is a type of the [[formDefinition.formElementTypes.MultipleChoiceElement]] form element.  */
var CheckboxElement = /** @class */ (function (_super) {
    __extends(CheckboxElement, _super);
    function CheckboxElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** Function that executes after the Checkbox is updated
     * @param inputValue The newly selected value. This is the 'value' property of the object
     * @param checked Value for whether the choice is selected or cleared.
     */
    CheckboxElement.prototype.handleInput = function (inputValue, checked) {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange;
        var modifiedValue = multiple_choice_input_1.handleMultipleChoiceInput(value, defaultValue, inputValue, checked, false);
        onChange(modifiedValue);
    };
    /**
     * If the checkbox element has a selected value, this will return true. Otherwise, this will be false.
     * @returns True if this element has a value, false otherwise.
     */
    CheckboxElement.prototype.hasValue = function () {
        var _a = this.props, element = _a.element, value = _a.value, defaultValue = _a.defaultValue;
        var currentValue = multiple_choice_input_1.getCurrentValue(value, defaultValue);
        return !ssg_forms_processing_1.formDefinition.hasEmptyValue(element, currentValue);
    };
    CheckboxElement.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, element = _b.element, value = _b.value, defaultValue = _b.defaultValue, errors = _b.errors, showErrors = _b.showErrors, css = _b.css;
        var isRequired = element.isRequired, label = element.label, ariaLabel = element.ariaLabel, id = element.id, disabled = element.disabled, readOnly = element.readOnly, options = element.options, hidden = element.hidden, tooltip = element.tooltip, autoComplete = element.autoComplete;
        var display = form_error_utils_1.getElementErrorDisplay(errors, showErrors, !!value);
        if (hidden)
            return null;
        return (React.createElement("fieldset", { id: id, role: "group", className: css.group, "aria-invalid": display.hasDisplayErrors, "aria-describedby": display.errorIds },
            React.createElement(descriptors_1.RequiredLegend, { hasErrors: display.hasDisplayErrors, content: label, ariaLabel: ariaLabel, isRequired: isRequired, css: {
                    requiredLegend: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                    requiredIndicator: css.requiredIndicator,
                    tooltipGroup: css.labelWrapper,
                }, tooltip: tooltip }),
            React.createElement("div", { className: css.inputWrapper },
                React.createElement("div", { className: css.inlineErrorDisplay }, display.displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); })),
                React.createElement("div", { className: classnames_1.default(css.checkOptionWrapperContent, (_a = {}, _a[css.emptyValue] = !this.hasValue(), _a)) }, options.map(function (option) {
                    var optionCss = Object.assign(checkbox_element_style_1.defaultOptionStyle, css, option.css);
                    return (React.createElement("div", { key: id + "-" + option.value, className: optionCss.checkOptionWrapper },
                        React.createElement("label", { className: classnames_1.default(optionCss.checkboxChoice, { disabled: disabled }, readOnly ? css.readOnly : ''), htmlFor: id + "_" + option.value },
                            React.createElement("input", { name: 'group' + id, id: id + "_" + option.value, className: classnames_1.default(optionCss.checkbox, readOnly ? css.readOnly : '', { disabled: disabled }), type: "checkbox", disabled: disabled, value: option.value, autoComplete: autoComplete, onChange: function (e) {
                                    if (readOnly)
                                        return false;
                                    return _this.handleInput(e.target.value, e.target.checked);
                                }, checked: multiple_choice_input_1.isChecked(value, defaultValue, option.value) }),
                            option.label)));
                })))));
    };
    return CheckboxElement;
}(React.Component));
exports.CheckboxElement = CheckboxElement;
exports.default = react_styleable_1.default(checkbox_element_style_1.default)(CheckboxElement);


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var date_element_style_1 = __webpack_require__(58);
var text_input_1 = __webpack_require__(16);
var date_utilities_1 = __webpack_require__(47);
var react_dates_1 = __webpack_require__(486);
var utilities_1 = __webpack_require__(9);
var classnames_1 = __webpack_require__(6);
var error_reporting_1 = __webpack_require__(10);
var react_fontawesome_1 = __webpack_require__(14);
var free_solid_svg_icons_1 = __webpack_require__(13);
var form_error_utils_1 = __webpack_require__(11);
var date_enum_1 = __webpack_require__(105);
var DateElement = /** @class */ (function (_super) {
    __extends(DateElement, _super);
    function DateElement(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showCalendar: false,
            inFocus: false,
            currentValue: "",
            isView: location.pathname.includes('view'),
        };
        return _this;
    }
    /** initially sets currentValue to what is in the store */
    DateElement.prototype.componentWillMount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue, country = _a.country;
        var displayResponse = defaultValue;
        if (!this.state.isView) {
            displayResponse = text_input_1.getCurrentValue(value, defaultValue);
        }
        var usDateFormat = new RegExp("^(0?[1-9]|1[012])[/](0?[1-9]|[12][0-9]|3[01])[/]\\d{4}");
        if (usDateFormat.test(displayResponse)) {
            var formattedDate = this.formatFromUS(displayResponse, country);
            this.setState({ currentValue: formattedDate });
        }
        else {
            this.setState({ currentValue: displayResponse });
        }
    };
    /** formatting from US format for viewing and editing touchpoint responses */
    DateElement.prototype.formatFromUS = function (date, country) {
        var dateString = new Date(date);
        var dateFormatter;
        if (!!country) {
            dateFormatter = new Intl.DateTimeFormat(["en-" + country, 'en-US']);
        }
        else {
            dateFormatter = new Intl.DateTimeFormat(["en-US", 'en-US']);
        }
        return dateFormatter.format(dateString);
    };
    /**
     * handles updates to the value in the store (form reset or conditional rules changes)
     * @param nextProps
     * @param nextState
     */
    DateElement.prototype.componentWillUpdate = function (nextProps, nextState) {
        var _a = this.props, prevValue = _a.value, prevDefaultValue = _a.defaultValue;
        var prevDisplayValue = text_input_1.getCurrentValue(prevValue, prevDefaultValue);
        var value = nextProps.value, defaultValue = nextProps.defaultValue;
        var displayValue = text_input_1.getCurrentValue(value, defaultValue);
        if (prevDisplayValue !== displayValue) {
            this.setState({ currentValue: displayValue });
        }
    };
    /** save vaule to store before the state is lost */
    DateElement.prototype.componentWillUnmount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var _b = this.state, currentValue = _b.currentValue, isView = _b.isView;
        // let storedValue = defaultValue;
        // if(isView) {
        var storedValue = text_input_1.getCurrentValue(value, defaultValue);
        // }
        if (currentValue !== storedValue) {
            this.saveToStore();
        }
    };
    /** @hidden
     * Gets the current value of the date picked from the calendar
     */
    DateElement.prototype.dateValue = function () {
        var currentValue = this.state.currentValue;
        return currentValue;
    };
    /**
     * handle change to the value of the input
     * @param event
     */
    DateElement.prototype.handleInput = function (event) {
        // debugger;
        var currentValue = this.state.currentValue;
        var country = this.props.country;
        var value = event.target.value;
        var dateInputsOnly = value.replace(/[^0-9/]/g, '');
        var array;
        var year;
        var month;
        var day;
        var format;
        switch (country) {
            case date_enum_1.default.Canada:
                array = dateInputsOnly.split('');
                year = "" + (array[0] || '') + (array[1] || '') + (array[2] || '') + (array[3] || '');
                month = "" + (array[4] || '') + (array[5] || '');
                day = "" + (array[6] || '') + (array[7] || '');
                format = year + "-" + month + "-" + day;
                break;
            case date_enum_1.default.UnitedKingdom:
                format = dateInputsOnly;
                break;
            case date_enum_1.default.UnitedStates:
            default:
                array = dateInputsOnly.split('').filter(function (c) { return c !== '/'; });
                year = "" + (array[4] || '') + (array[5] || '') + (array[6] || '') + (array[7] || '');
                month = "" + (array[0] || '') + (array[1] || '');
                day = "" + (array[2] || '') + (array[3] || '');
                format = month + "/" + day + "/" + year;
                break;
        }
        if (dateInputsOnly !== currentValue) {
            this.setState({ currentValue: format });
        }
    };
    /**
     * handle losing focus
     * @param event
     */
    DateElement.prototype.handleBlur = function (event) {
        event.preventDefault();
        this.saveToStore();
        this.setState({
            inFocus: false
        });
    };
    /** @hidden
     * What happens when the control is currently in focus
     */
    DateElement.prototype.handleFocus = function (event) {
        event.preventDefault();
        this.setState({
            inFocus: true,
            showCalendar: false
        });
    };
    /**
     * Saves to the store in the even that the form might be submitted
     * @param event
     */
    DateElement.prototype.handleKeyDown = function (event) {
        if (event.key === "Enter" || event.keyCode === 13) {
            this.saveToStore();
        }
    };
    /** calls the onChange function to update the store with the currentValue */
    DateElement.prototype.saveToStore = function () {
        var onChange = this.props.onChange;
        var currentValue = this.state.currentValue;
        onChange && onChange(currentValue);
    };
    /** @hidden
     * opens or closes the calendar
     */
    DateElement.prototype.toggleCalendar = function (show) {
        this.setState({ showCalendar: show });
    };
    DateElement.prototype.formatDate = function (date, country) {
        if (country === void 0) { country = 'US'; }
        var newDate = new Date(date.format('MM/DD/YYYY'));
        var dateFormatter = new Intl.DateTimeFormat(["en-" + country, 'en-US']);
        return dateFormatter.format(newDate);
    };
    // Functions for DayPickerSingleDateController
    DateElement.prototype.handleDayClicked = function (value) {
        var _a = this.props, onChange = _a.onChange, country = _a.country;
        var dateString = this.formatDate(value, country);
        onChange(dateString);
    };
    /** @hidden
     * Checks to see if the current day is blocked or not
     */
    DateElement.prototype.isDayBlocked = function (value) {
        var _a = this.props.element, minDate = _a.minDate, maxDate = _a.maxDate;
        var dateString = value && value.format('MM/DD/YYYY');
        var validDate = date_utilities_1.isDateInRange(dateString, minDate, maxDate);
        return !validDate;
    };
    DateElement.prototype.render = function () {
        var _this = this;
        var _a = this.state, showCalendar = _a.showCalendar, inFocus = _a.inFocus;
        var _b = this.props, element = _b.element, errors = _b.errors, showErrors = _b.showErrors, css = _b.css, country = _b.country;
        var isRequired = element.isRequired, hidden = element.hidden, label = element.label, ariaLabel = element.ariaLabel, id = element.id, minDate = element.minDate, maxDate = element.maxDate, disabled = element.disabled, readOnly = element.readOnly, tooltip = element.tooltip, autoComplete = element.autoComplete;
        var inlineDisplay = form_error_utils_1.getElementErrorDisplay(errors, showErrors, !!this.dateValue() && this.dateValue() !== "" && !inFocus);
        // debugger;
        if (hidden)
            return null;
        var moment;
        var placeHolderFormat;
        var dateStringReformat = "";
        var array;
        var d;
        var year;
        var month;
        var day;
        var yyyyMMddFormat = new RegExp("^\\d{4}[-](0?[1-9]|1[012])[-](0?[1-9]|[12][0-9]|3[01])");
        var ddMMyyyyFormat = new RegExp("^(0?[1-9]|[12][0-9]|3[01])[/](0?[1-9]|1[012])[/]\\d{4}");
        var mmDDyyyyFormat = new RegExp("^(0?[1-9]|1[012])[/](0?[1-9]|[12][0-9]|3[01])[/]\\d{4}");
        // catches cases where the date is US format despite different setting
        if ((mmDDyyyyFormat.test(this.dateValue()) && !ddMMyyyyFormat.test(this.dateValue())) && country !== date_enum_1.default.UnitedStates) {
            array = this.dateValue().split('/');
            month = array[0];
            day = array[1];
            year = array[2];
        }
        var datePuzzle = !year && !month && !day;
        switch (country) {
            case date_enum_1.default.Canada:
                placeHolderFormat = 'yyyy-mm-dd';
                if (this.dateValue() !== "") {
                    if (datePuzzle) {
                        array = this.dateValue().split('-');
                        month = array[1];
                        day = array[2];
                        year = array[0];
                    }
                    d = this.dateValue();
                    moment = react_dates_1.toMomentObject(d);
                    dateStringReformat = yyyyMMddFormat.test(this.dateValue()) ? this.dateValue() : year + "-" + month + "-" + day;
                }
                break;
            case date_enum_1.default.UnitedKingdom:
                placeHolderFormat = 'dd/mm/yyyy';
                if (this.dateValue() !== "") {
                    if (datePuzzle) {
                        array = this.dateValue().split('').filter(function (c) { return c !== '/'; });
                        year = "" + (array[4] || '') + (array[5] || '') + (array[6] || '') + (array[7] || '');
                        month = "" + (array[2] || '') + (array[3] || '');
                        day = "" + (array[0] || '') + (array[1] || '');
                    }
                    d = month + "/" + day + "/" + year;
                    moment = react_dates_1.toMomentObject(d);
                    dateStringReformat = ddMMyyyyFormat.test(this.dateValue()) ? this.dateValue() : day + "/" + month + "/" + year;
                }
                break;
            case date_enum_1.default.UnitedStates:
            default:
                moment = react_dates_1.toMomentObject(this.dateValue());
                placeHolderFormat = 'mm/dd/yyyy';
                dateStringReformat = this.dateValue();
                break;
        }
        return (React.createElement("div", { className: css.group },
            React.createElement(utilities_1.descriptors.RequiredLabel, { hasErrors: inlineDisplay.hasDisplayErrors, htmlFor: id, content: label, ariaLabel: ariaLabel, isRequired: isRequired, css: {
                    requiredLabel: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                    requiredIndicator: css.requiredIndicator,
                    tooltipGroup: css.labelWrapper,
                } }),
            React.createElement("div", { className: css.inputWrapper },
                React.createElement("div", { className: css.tooltipGroup },
                    React.createElement("div", { className: classnames_1.default(inlineDisplay.hasDisplayErrors ? css.dateWrapperError : css.dateWrapper, { readonly: readOnly }) },
                        React.createElement("input", { "aria-describedby": inlineDisplay.errorIds + ' format', "aria-invalid": inlineDisplay.hasDisplayErrors, "aria-required": isRequired, autoComplete: autoComplete, className: css.date + ' validated-input', disabled: disabled, id: id, max: maxDate, min: minDate, onChange: function (e) { return _this.handleInput(e); }, onFocus: function (e) { return _this.handleFocus(e); }, onBlur: function (e) { return _this.handleBlur(e); }, onKeyDown: function (e) { return _this.handleKeyDown(e); }, placeholder: (!readOnly && !disabled) && placeHolderFormat, readOnly: readOnly, type: "text", value: dateStringReformat }),
                        !readOnly ? (React.createElement("button", { "aria-expanded": showCalendar, "aria-label": 'Select a date', className: css.calendarButton, disabled: disabled || readOnly, onClick: function (e) { return _this.toggleCalendar(!showCalendar); }, tabIndex: 0, type: "button" },
                            React.createElement("span", { className: css.calendarIcon },
                                React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faCalendar })))) : null),
                    tooltip ? React.createElement(utilities_1.TooltipDisplay, { text: tooltip, context: label }) : null),
                showCalendar && !readOnly ? (React.createElement("div", { className: css.calendarAnchor },
                    React.createElement("div", { className: css.calendarWrapper },
                        React.createElement(react_dates_1.DayPickerSingleDateController, { date: moment, onDateChange: function (e) { return _this.handleDayClicked(e); }, focused: showCalendar, onFocusChange: function (e) { return _this.toggleCalendar(e.focused); }, numberOfMonths: 1, isDayBlocked: function (e) { return _this.isDayBlocked(e); } })))) : null,
                React.createElement("div", { className: css.inlineErrorDisplay }, inlineDisplay.displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); })))));
    };
    return DateElement;
}(React.Component));
exports.DateElement = DateElement;
exports.default = react_styleable_1.default(date_element_style_1.default)(DateElement);


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var descriptors_1 = __webpack_require__(19);
var ssg_forms_processing_1 = __webpack_require__(7);
var multi_section_input_1 = __webpack_require__(75);
var react_styleable_1 = __webpack_require__(1);
var React = __webpack_require__(0);
var immutable_1 = __webpack_require__(2);
var classnames_1 = __webpack_require__(6);
var electronic_signature_element_style_1 = __webpack_require__(60);
var error_reporting_1 = __webpack_require__(10);
var form_error_utils_1 = __webpack_require__(11);
var canvasBackgroundColor = '#ffffff'; // white background for image exports (Apricot)
var canvasPenColor = '#000000'; // black pen color for image exports (Apricot);
;
;
/**
 * Capture a user's signature electronically. Supports mouse and touch input.
 */
var ElectronicSignatureElement = /** @class */ (function (_super) {
    __extends(ElectronicSignatureElement, _super);
    function ElectronicSignatureElement(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            signButtonClicked: false,
            lines: immutable_1.List(),
            isDrawing: false,
            showSignPad: false,
            completed: false,
            widthInPixels: 100,
            heightInPixels: 100,
            primed: false
        };
        _this.handleMouseDown = _this.handleMouseDown.bind(_this);
        _this.handleMouseMove = _this.handleMouseMove.bind(_this);
        _this.handleMouseUp = _this.handleMouseUp.bind(_this);
        _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
        _this.handleTouchStart = _this.handleTouchStart.bind(_this);
        _this.handleTouchMove = _this.handleTouchMove.bind(_this);
        _this.handleTouchEnd = _this.handleTouchEnd.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.relativeCoordinatesForMouseEvent = _this.relativeCoordinatesForMouseEvent.bind(_this);
        _this.createDrawing = _this.createDrawing.bind(_this);
        _this.createDrawingLine = _this.createDrawingLine.bind(_this);
        return _this;
    }
    /**
     * Take the internal state and translate the appropriate fields into
     * a format that the store wants.
     * @param localState The state to capture.
     */
    ElectronicSignatureElement.prototype.convertStateToResponse = function (localState) {
        var retVal = new ssg_forms_processing_1.formDefinition.ElectronicSignatureResponseState();
        retVal.set('signInProgress', !localState.completed && localState.showSignPad).
            set('etoCoords', immutable_1.List(this.allEtoCoords(localState.lines))).
            set('signPadWidth', localState.widthInPixels).
            set('signPadHeight', localState.heightInPixels);
        return retVal;
    };
    /**
     * @hidden
     * Soft reset of the local state. Sets signButtonClicked to true, lines to an empty list,
     * isDrawing to false, and completed to false. All other internal properties are left alone.
     * This is used when clicking the start over button.
     */
    ElectronicSignatureElement.prototype.resetState = function () {
        // The following state members are left alone:
        // showSignPad, widthInPixels, heightInPixels, primed.
        this.setState({
            signButtonClicked: true,
            lines: immutable_1.List(),
            isDrawing: false,
            completed: false
        });
    };
    /**
     * @hidden
     * Erase the html canvas that holds the image for generating Apricot output.
     */
    ElectronicSignatureElement.prototype.clearApricotImageFromDisplay = function () {
        var canvas = document.getElementById('mycanv-' + this.props.element.id);
        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    };
    /**
     * @hidden
     * Get an object representing the store data for this element at a starting state,
     * except for the signPadWidth and signPadHeight, as they are already correct.
     */
    ElectronicSignatureElement.prototype.getEmptyStoreData = function () {
        var retVal = new ssg_forms_processing_1.formDefinition.ElectronicSignatureResponseState();
        retVal.set('signInProgress', false).
            set('etoCoords', immutable_1.List()).
            set('imageUrl', null);
        return retVal;
    };
    /**
     * @hidden
     * Initialize the parts of the state that determine the size of the sign pad.
     */
    ElectronicSignatureElement.prototype.componentDidMount = function () {
        this.handleWindowResize();
        document.addEventListener("mouseup", this.handleMouseUp);
        document.addEventListener("mouseleave", this.handleMouseLeave);
        window.addEventListener("resize", this.handleWindowResize);
        // Touch-specific events
        var signPad = document.getElementById("signPad-" + this.props.element.id.toString());
        if (signPad) {
            signPad.addEventListener("touchstart", this.handleTouchStart);
            signPad.addEventListener("touchmove", this.handleTouchMove);
            signPad.addEventListener("touchend", this.handleTouchEnd);
        }
    };
    /**
     * @hidden
     * Stop listening to events.
     */
    ElectronicSignatureElement.prototype.componentWillUnmount = function () {
        document.removeEventListener("mouseup", this.handleMouseUp);
        document.removeEventListener("mouseleave", this.handleMouseLeave);
        window.removeEventListener("resize", this.handleWindowResize);
        // Touch-specific events
        var signPad = document.getElementById('signPad-' + this.props.element.id.toString());
        if (signPad) {
            signPad.removeEventListener("touchstart", this.handleTouchStart);
            signPad.removeEventListener("touchmove", this.handleTouchMove);
            signPad.removeEventListener("touchend", this.handleTouchEnd);
        }
    };
    /**
     * @hidden
     * If applicable, prime the element with a default value, and move
     * keyboard focus if needed.
     *
     * @param prevProps Previous set of properties.
     * @param prevState Previous state of the component
     */
    ElectronicSignatureElement.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue, element = _a.element;
        var targetWidth = element.targetWidth, targetHeight = element.targetHeight, mode = element.mode;
        // This code is used for loading the signPad with a previously existing signature,
        // such as for the case of displaying an existing touchpoint response.
        if ((!this.state.completed && !this.state.primed && (!this.state.lines || this.state.lines.size === 0)) && defaultValue) {
            this.setState({ showSignPad: true });
            if (mode === ssg_forms_processing_1.formDefinition.electronicSignatureModes.ETO) {
                this.initializeLines(defaultValue.get('etoCoords'), targetWidth, targetHeight);
            }
            else {
                // apricot assumed
                this.initializeCanvas(defaultValue.get('imageUrl'));
            }
            this.setState({ completed: true, primed: true });
        }
        // Move the focus to the clear button, since the begin drawing button will be hidden once
        // it is clicked.  Only do this if the sign pad is visible and the sign button has been clicked.
        var id = element.id;
        if (this.state.showSignPad && this.state.signButtonClicked) {
            var buttonToFocus = null;
            buttonToFocus = document.getElementById('clear-button-' + id.toString());
            if (buttonToFocus) {
                buttonToFocus.focus();
                this.setState({ signButtonClicked: false });
            }
        }
        if (!prevState.completed && this.state.completed && (prevState.primed || !this.state.primed)) {
            var buttonToFocus = null;
            buttonToFocus = document.getElementById('start-over-button-' + id.toString());
            if (buttonToFocus) {
                buttonToFocus.focus();
            }
        }
        var prevResponse = prevProps.value;
        if (!!prevResponse && !value) {
            this.resetSignPad();
        }
    };
    /**
     * @hidden
     * Handle the mouse leaving this element.
     * If the point of the event is within bounds of the element, no state change happens.
     * If the point of the event is within bounds of the element, isDrawing is set to false.
     * @param {event} mouseEvent The event.
     */
    ElectronicSignatureElement.prototype.handleMouseLeave = function (mouseEvent) {
        if (!this.state.isDrawing) {
            // do nothing if we weren't actually drawing
            return;
        }
        var point = this.relativeCoordinatesForMouseEvent(mouseEvent);
        if (point && this.pointAtBoundary(point)) {
            // we are at or beyond the boundary.  Stop drawing.
            this.setState({ isDrawing: false });
        }
    };
    /**
     * @hidden
     * Handle the mouse button down within this element.
     * isDrawing will be set to true if completed is false, and a point will be added to the lines list.
     * If completed is true, nothing is done.
     * @param {event} mouseEvent The event.
     */
    ElectronicSignatureElement.prototype.handleMouseDown = function (mouseEvent) {
        mouseEvent.preventDefault();
        if (mouseEvent.button !== 0) {
            return;
        }
        if (!this.state.completed) {
            var point_1 = this.relativeCoordinatesForMouseEvent(mouseEvent);
            if (point_1) {
                this.setState(function (prevState) { return ({
                    lines: prevState.lines.push(immutable_1.List([point_1])),
                    isDrawing: true
                }); });
            }
        }
    };
    /**
     * @hidden
     * Handle the mouse movement within this element.
     * If completed is true, or if isDrawing is false, nothing happens.
     * If completed is false, and isDrawing is true, add a point to the lines list.
     * @param {event} mouseEvent The event.
     */
    ElectronicSignatureElement.prototype.handleMouseMove = function (mouseEvent) {
        // if we aren't actually drawing, ignore this event
        if (!this.state.isDrawing || this.state.completed) {
            return;
        }
        mouseEvent.preventDefault();
        var point = this.relativeCoordinatesForMouseEvent(mouseEvent);
        // If problems exist in the future, a call to pointAtBoundary can be added here.
        // As of now the mouse move events are being processed as expected.
        if (point) {
            this.setState(function (prevState) { return ({
                lines: prevState.lines.updateIn([prevState.lines.size - 1], function (line) { return line.push(point); })
            }); });
        }
    };
    /**
     * @hidden
     * Handle the mouse button up event.
     * If drawing has completed already, do nothing.
     * Otherwise, when the mouse button goes up, set isDrawing to false.
     * Drawing can be resumed again later as long as completed is set to false.
     */
    ElectronicSignatureElement.prototype.handleMouseUp = function () {
        if (!this.state.completed) {
            this.setState({ isDrawing: false });
        }
    };
    /**
     * @hidden
     * Handle the beginning of a touch input.  Scrolling is prevented if this signature is not complete.
     * @param {event} touchEvent Event containing the touch information.  Only the first touch is supported; in the case of
     * multi-touch, only the first touch in sequence is processed.
     */
    ElectronicSignatureElement.prototype.handleTouchStart = function (touchEvent) {
        if (!this.state.completed) {
            // default must be prevented, otherwise unintended scrolling may occur
            // (If drawing is completed already, scrolling is fine.)
            touchEvent.preventDefault();
            var point_2 = this.relativeCoordinatesForTouchEvent(touchEvent);
            if (point_2) {
                this.setState(function (prevState) { return ({
                    lines: prevState.lines.push(immutable_1.List([point_2])),
                    isDrawing: true
                }); });
            }
        }
    };
    /**
     * @hidden
     * Handle the touch movement within this element, which can be used to add to the drawing.
     * If completed is true, or if isDrawing is false, nothing happens.
     * If completed is false, and isDrawing is true, and the touched point is in bounds,
     * add a point to the lines list.
     * @param {event} touchEvent The event containing the Touch details.  Note that we only
     * care about single touch; in the event of a multi-touch, only the first one in sequence
     * is processed.
     */
    ElectronicSignatureElement.prototype.handleTouchMove = function (touchEvent) {
        // if we aren't actually drawing, ignore this event
        if (!this.state.isDrawing || this.state.completed) {
            return;
        }
        // default must be prevented, otherwise unintended scrolling may occur.
        // (If drawing is completed already, scrolling is fine.)
        touchEvent.preventDefault();
        var point = this.relativeCoordinatesForTouchEvent(touchEvent);
        // Do a bounds check before adding the point to our set.
        if (point) {
            if (!this.pointAtBoundary(point)) {
                this.setState(function (prevState) { return ({
                    lines: prevState.lines.updateIn([prevState.lines.size - 1], function (line) { return line.push(point); })
                }); });
            }
            else {
                this.setState({ isDrawing: false });
            }
        }
    };
    /**
     * @hidden
     * Handle the end of a touch input for this element.
     */
    ElectronicSignatureElement.prototype.handleTouchEnd = function () {
        if (!this.state.isDrawing) {
            // do nothing if we weren't actually drawing
            return;
        }
        // All we need to do is set isDrawing to false, and we're done.
        this.setState({ isDrawing: false });
    };
    /**
     * @hidden
     * Calculate how large the sign pad should be when it is shown to the user.
     * These dimensions are based on the current size of the window and must
     * be recomputed during resize.
     */
    ElectronicSignatureElement.prototype.handleWindowResize = function () {
        var element = this.props.element;
        var targetWidth = element.targetWidth, targetHeight = element.targetHeight, id = element.id;
        if (!this.state.showSignPad && !this.state.completed) {
            var domElement = document.getElementById("mycanv-size" + id);
            if (domElement) {
                var boundingRect = domElement.getBoundingClientRect();
                if (boundingRect) {
                    var aspect = targetWidth / targetHeight;
                    // Sign pad may be shown no smaller than 100 pixels across
                    var x = Math.round(Math.max(boundingRect.width, 100));
                    // calculate y using the same aspect ratio as the target sign pad
                    // Sign pad must be at least 28 pixels high
                    var y = Math.round(Math.max((x / aspect), 28));
                    // save our internal state to have the calculated width and height
                    this.setState({ widthInPixels: x, heightInPixels: y });
                }
            }
        }
    };
    /**
     * @hidden
     * Handle a click on the sign button.
     * If drawing has completed already, do nothing.
     * Otherwise, show the signing pad.  Also, set signButtonClicked to true
     * so that focus can be changed if needed.
     */
    ElectronicSignatureElement.prototype.signButtonClicked = function () {
        var _a = this.props, onChange = _a.onChange, value = _a.value;
        if (!this.state.completed) {
            this.setState({ signButtonClicked: true, showSignPad: true });
            var convertedState = this.convertStateToResponse(this.state);
            var handledValue = multi_section_input_1.handleInput(convertedState, null, true, "signInProgress");
            onChange(new ssg_forms_processing_1.formDefinition.ElectronicSignatureResponseState(handledValue));
        }
    };
    /**
     * @hidden
     * Clear the sign pad. Used when clicking the clear button.
     * (To start over, use the start over button.)
     * Clearing is only possible if drawing is not yet complete.
     * If drawing has completed already, do nothing.
     * Otherwise, clear out the lines list, which will erase the signing pad.
     */
    ElectronicSignatureElement.prototype.clearSignPad = function () {
        if (!this.state.completed) {
            this.setState({ lines: immutable_1.List() });
        }
    };
    /**
     * @hidden
     * Resets the sign pad to its starting state
     * This happens if the component goes from having a response to having no response
     */
    ElectronicSignatureElement.prototype.resetSignPad = function () {
        this.setState({
            signButtonClicked: false,
            isDrawing: false,
            showSignPad: false,
            completed: false,
            lines: immutable_1.List(),
        });
        this.clearApricotImageFromDisplay();
    };
    /**
     * @hidden
     * Save the sign pad.
     * Set drawing to completed.  Add the ETO coordinates to the store,
     * or add the Apricot image data to the store, as appropriate.
     * We also need to store the width and height of the signPad, so that scaling
     * can be performed if necessary on the ETO side.
     */
    ElectronicSignatureElement.prototype.saveSignPad = function () {
        var _a = this.props, onChange = _a.onChange, element = _a.element;
        var mode = element.mode;
        this.setState({ completed: true });
        var convertedState = this.convertStateToResponse(this.state);
        var handledValue;
        if (mode === ssg_forms_processing_1.formDefinition.electronicSignatureModes.ETO) {
            handledValue = multi_section_input_1.handleInput(convertedState, null, this.allEtoCoords(this.state.lines), "etoCoords");
        }
        else {
            this.drawLinesToCanvas(this.state.lines);
            handledValue = multi_section_input_1.handleInput(convertedState, null, this.state.lines.size > 0 ? this.getApricotImageUrl() : null, "imageUrl");
        }
        onChange(new ssg_forms_processing_1.formDefinition.ElectronicSignatureResponseState(handledValue));
        var signPad = document.getElementById('signPad-' + this.props.element.id.toString());
        if (signPad) {
            var boundingRect = signPad.getBoundingClientRect();
            if (boundingRect) {
                handledValue = multi_section_input_1.handleInput(handledValue, null, boundingRect.width, "signPadWidth");
                handledValue = multi_section_input_1.handleInput(handledValue, null, boundingRect.height, "signPadHeight");
                onChange(new ssg_forms_processing_1.formDefinition.ElectronicSignatureResponseState(handledValue));
            }
        }
        handledValue = multi_section_input_1.handleInput(handledValue, null, false, "signInProgress");
        onChange(new ssg_forms_processing_1.formDefinition.ElectronicSignatureResponseState(handledValue));
    };
    /**
     * @hidden
     * If the element has loaded a default value, or if the user has previously clicked
     * save, this is used to wipe the value out of the store, and to reset the local
     * state to look like the user had just clicked the sign button.
     */
    ElectronicSignatureElement.prototype.startOverSignPad = function () {
        var onChange = this.props.onChange;
        this.resetState();
        var convertedState = this.getEmptyStoreData();
        this.clearApricotImageFromDisplay();
        onChange(new ssg_forms_processing_1.formDefinition.ElectronicSignatureResponseState(convertedState));
    };
    /**
     * @hidden
     * Get the coordinates for the given touch event relative to the bounding box of the element.
     * @param {event} touchEvent The touch event for which we need a relative point.  If the event contains
     * multi-touch data, we only care about the first touch in sequence.
     * @returns {Map} Returns a Map with x and y entries corresponding to the touchEvent, offset by the bounding
     * rect of the element.  Returns null if unable to perform the operation.
     */
    ElectronicSignatureElement.prototype.relativeCoordinatesForTouchEvent = function (touchEvent) {
        var signPad = document.getElementById('signPad-' + this.props.element.id.toString());
        if (signPad) {
            if (touchEvent.targetTouches && touchEvent.targetTouches.length > 0) {
                if (touchEvent.targetTouches[0].clientX != null && touchEvent.targetTouches[0].clientY != null) {
                    var touchX = touchEvent.targetTouches[0].clientX;
                    var touchY = touchEvent.targetTouches[0].clientY;
                    var boundingRect = signPad.getBoundingClientRect();
                    if (boundingRect) {
                        return immutable_1.Map({
                            x: touchX - boundingRect.left,
                            y: touchY - boundingRect.top,
                        });
                    }
                }
            }
        }
        return null;
    };
    /**
     * @hidden
     * Get the coordinates for the given event relative to the bounding box of the element.
     * @param {event} mouseEvent The mouse event for which we need a relative point.
     * @returns {Map} Returns a Map with x and y entries corresponding to the mouseEvent, offset by the bounding
     * rect of the element.  Returns null if unable to perform the operation.
     */
    ElectronicSignatureElement.prototype.relativeCoordinatesForMouseEvent = function (mouseEvent) {
        var signPad = document.getElementById('signPad-' + this.props.element.id.toString());
        if (signPad) {
            var boundingRect = signPad.getBoundingClientRect();
            if (boundingRect) {
                return immutable_1.Map({
                    x: mouseEvent.clientX - boundingRect.left,
                    y: mouseEvent.clientY - boundingRect.top,
                });
            }
        }
        return null;
    };
    /**
     * @hidden
     * Return true if the given point is at or past the bounding box of this element.
     * @param {Map} point A map with two entries:  x and y.
     * @returns True if the point is at or past the bounding box of this element; false otherwise.
     */
    ElectronicSignatureElement.prototype.pointAtBoundary = function (point) {
        var boundingRect = document.getElementById('signPad-' + this.props.element.id.toString()).getBoundingClientRect();
        var pointX = point.get('x');
        var pointY = point.get('y');
        if (pointX <= 0 || pointX >= boundingRect.width) {
            return true;
        }
        if (pointY <= 0 || pointY >= boundingRect.height) {
            return true;
        }
        return false;
    };
    /**
     * @hidden
     * Convert the given array of coordinates into the format expected by ETO, rendered as a string.
     * @param {array} coords An array of coordinates in the format that ETO expects.  [{"lx":204,"ly":105,"mx":201,"my":101},{"lx":208,"ly":110,"mx":204,"my":105}], etc
     * @returns A string of the format '[{"lx":204,"ly":105,"mx":201,"my":101},{"lx":208,"ly":110,"mx":204,"my":105}]', etc
     */
    ElectronicSignatureElement.prototype.allEtoCoordsAsString = function (coords) {
        if (coords) {
            var coordsAsString = "[" +
                coords.map(function (coord) {
                    return "" + ("lx:" + coord.lx + ",\"ly\":" + coord.ly + ",\"mx\":" + coord.mx + ",\"my\":" + coord.my);
                })
                    .join(",") + "]";
            return coordsAsString;
        }
        return "[]";
    };
    /**
     * @hidden
     * Get the entire set of coordinates for the sign pad contents in Eto format.
     * @param {List} lines The entire set of lines comprising the sign pad contents.
     * @returns {array} Calls oneLineEtoCoords in a series, concatenating each result into a singular array of coordinates.
     */
    ElectronicSignatureElement.prototype.allEtoCoords = function (lines) {
        var _this = this;
        var coords = [];
        if (lines) {
            lines.forEach(function (line) {
                coords = coords.concat(_this.oneLineEtoCoords(line));
            });
            return immutable_1.List(coords);
        }
        return immutable_1.List();
    };
    /**
     * @hidden
     * Take the internal state's lines and plot them to the html canvas.
     * This is used so that data can ultimately be saved in a format compatible
     * with Apricot. The canvas dimensions are specified by Apricot.
     * @param lines See [[IElectronicSignatureElementState.lines]] for details on this list.
     */
    ElectronicSignatureElement.prototype.drawLinesToCanvas = function (lines) {
        var element = this.props.element;
        var targetWidth = element.targetWidth, targetHeight = element.targetHeight;
        if (lines) {
            var canvas = document.getElementById('mycanv-' + this.props.element.id);
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = canvasBackgroundColor;
            ctx.fillRect(0, 0, canvas.width, canvas.height); // fill the entire canvas with the background color
            ctx.fillStyle = canvasPenColor; // fill style for all subsequent fills
            var targetArea = targetWidth * targetHeight;
            var stateArea = this.state.widthInPixels * this.state.heightInPixels;
            var ratio = Math.min(this.state.widthInPixels / targetWidth, this.state.heightInPixels / targetHeight);
            if (stateArea > targetArea) {
                ratio = 1 / ratio; // scale down instead of up
            }
            lines.forEach(function (line) {
                // each line is a list of Map(x,y)
                // start at the beginning, draw a point (rectangle of size 1),
                // and then draw lines until we are done.
                if (line != null && line.size > 0) {
                    if (line.size === 1) {
                        // special case; we need to draw, effectively, a point.
                        ctx.fillRect(line.get(0).get('x'), line.get(0).get('y'), 1, 1);
                    }
                    else {
                        ctx.beginPath();
                        var coordIndex = 0;
                        line.forEach(function (coord) {
                            var scaled_x = line.get(coordIndex).get('x') * ratio;
                            var scaled_y = line.get(coordIndex).get('y') * ratio;
                            if (coordIndex === 0) {
                                // first coordinate; must draw a rect of size 1,
                                // or do we use MoveTo?
                                ctx.moveTo(scaled_x, scaled_y);
                            }
                            else {
                                // draw a line between the previous coordinate and this one
                                ctx.lineTo(scaled_x, scaled_y);
                            }
                            coordIndex++;
                        });
                        ctx.strokeStyle = canvasPenColor;
                        ctx.stroke();
                    } // else
                }
            } // one line
            ); // for each line
        } // if there are lines
    };
    /**
     * @hidden
     * Get an imageUrl (string) from the html canvas. This is how Apricot expects signatures to be saved.
     * This will attempt to reduce the size of the signature image to less than 64000 characters,
     * by 10% each time, to be compatible with the backing database field in Apricot.
     * Lowest possible quality is 20% of the original.
     * The dimensions of the canvas are those specified by Apricot.
     */
    ElectronicSignatureElement.prototype.getApricotImageUrl = function () {
        var canvas = document.getElementById('mycanv-' + this.props.element.id);
        var currentQuality = 1.0;
        var dataUrl = canvas.toDataURL("image/jpeg", currentQuality);
        while (dataUrl.length >= 64000 && currentQuality > 0.20) {
            currentQuality -= 0.10;
            dataUrl = canvas.toDataURL("image/jpeg", currentQuality);
        }
        return dataUrl;
    };
    /**
     * @hidden
     * Given one line of an svg path, return an array of coordinates in the ETO format.
     * Eto expects a point and line for each coordinate, so to accomplish this,
     * The line part of the given coordinate is used as the point for the next coordinate.
     * There are special cases for an empty line, and for when a line contains only one x/y pair.
     * @param {List} line One line of the svg path, which is represented as a List of Maps.  The Maps each contain two entries:  x and y.
     * @returns {array} An array of coordinates in the format that ETO expects: [{"lx":204,"ly":105,"mx":201,"my":101},{"lx":208,"ly":110,"mx":204,"my":105}]
     */
    ElectronicSignatureElement.prototype.oneLineEtoCoords = function (line) {
        var curIndex = 0;
        var result = [];
        if (line.size === 0) {
            // No entries in this line, just return an empty array.
            return result;
        }
        else if (line.size === 1) {
            // One entry in this line, we return a coordinate that makes a line to itself.
            var oneCoord = line.get(0);
            result.push({ lx: oneCoord.get('x'), ly: oneCoord.get('y'), mx: oneCoord.get('x'), my: oneCoord.get('y') });
        }
        else {
            // General case -- use the data from the next point to build the data for the current point.
            while (curIndex + 1 < line.size) {
                var curPoint = line.get(curIndex);
                var nextPoint = line.get(curIndex + 1);
                result.push({ lx: nextPoint.get('x'), ly: nextPoint.get('y'), mx: curPoint.get('x'), my: curPoint.get('y') });
                curIndex++;
            }
        }
        return result;
    };
    /**
     * @hidden
     * Build the svg representing the user's signature.
     * @param {object} lines Contains the lines comprising the signature.
     * @returns {object} An svg element.
     */
    ElectronicSignatureElement.prototype.createDrawing = function (_a) {
        var _this = this;
        var lines = _a.lines;
        var x = (React.createElement("svg", { id: 'svg-' + this.props.element.id.toString(), className: "drawing " + (this.state.completed ? 'drawing-completed' : '') }, lines.map(function (line, index) { return (React.createElement(_this.createDrawingLine, { key: index, line: line })); })));
        return x;
    };
    /**
     * @hidden
     * Build a singular path to be used within svg.
     * @param {object} line Contains a singular line comprising the signature.
     * @returns {object} A path element, to be used within svg.
     */
    ElectronicSignatureElement.prototype.createDrawingLine = function (_a) {
        var line = _a.line;
        var pathData = "M " +
            line
                .map(function (p) {
                return p.get('x') + " " + p.get('y');
            })
                .join(" L ");
        return React.createElement("path", { className: "path " + (this.state.completed ? 'drawing-completed' : ''), d: pathData });
    };
    /**
     * @hidden
     * Initialize the internal state of this element with the ETO style coordinates we are given.
     * @param {List} coords Coordinates of the format [{"lx":204,"ly":105,"mx":201,"my":101}, etc]
     * @param {number} padWidth Width of the sign pad, in pixels.  This represents the "original" width (typically from ETO), so we can scale and preserve the original aspect ratio.  If this is zero, this function will exit immediately.
     * @param {number} padHeight Height of the sign pad, in pixels.  This represents the "original" height (typically from ETO), so we can scale and preserve the original aspect ratio.  If this is zero, this function will exit immediately.
     */
    ElectronicSignatureElement.prototype.initializeLines = function (coords, padWidth, padHeight) {
        var _this = this;
        // Must have nonzero padWidth and padHeight to do ratio math later.
        if (padWidth !== 0 && padHeight !== 0) {
            if (coords && coords.size > 0) {
                // compute scaling ratio
                var ratio = Math.min(this.state.widthInPixels / padWidth, this.state.heightInPixels / padHeight);
                // clear out existing data first
                this.setState({ lines: immutable_1.List() });
                coords.forEach(function (coord) {
                    var pointA = immutable_1.Map({
                        x: Math.round(coord.mx * ratio),
                        y: Math.round(coord.my * ratio)
                    });
                    _this.setState(function (prevState) { return ({
                        lines: prevState.lines.push(immutable_1.List([pointA])),
                    }); });
                    var pointB = immutable_1.Map({
                        x: Math.round(coord.lx * ratio),
                        y: Math.round(coord.ly * ratio)
                    });
                    _this.setState(function (prevState) { return ({
                        lines: prevState.lines.updateIn([prevState.lines.size - 1], function (line) { return line.push(pointB); })
                    }); });
                });
            }
            else {
                // empty or null signature.
                // clear out the lines and we are done.
                this.setState({ lines: immutable_1.List() });
            }
        }
    };
    /**
     * @hidden
     * Initialize the canvas with a given image url. This is how previously stored
     * Apricot signature data is loaded into the element. Note that data loaded in
     * this fashion will have an empty lines list (see [[IElectronicSignatureElementState.lines]]),
     * since Apricot does not save or load coordinate data.
     * @param imageUrl Saved image url from Apricot.
     */
    ElectronicSignatureElement.prototype.initializeCanvas = function (imageUrl) {
        var canvas = document.getElementById('mycanv-' + this.props.element.id);
        var ctx = canvas.getContext('2d');
        var that = this;
        var img = new Image;
        img.onload = function () {
            ctx.drawImage(img, 0, 0, img.width, img.height, 0, 0, canvas.width, canvas.height);
            that.setState({ lines: immutable_1.List() });
        };
        img.src = imageUrl;
    };
    ElectronicSignatureElement.prototype.getCurrentValue = function () {
        var _a = this.props, element = _a.element, value = _a.value, defaultValue = _a.defaultValue;
        if (element.mode === ssg_forms_processing_1.formDefinition.electronicSignatureModes.ETO) {
            if (!!value && !!value.etoCoords && value.etoCoords.size > 0) {
                return value;
            }
            else {
                return new ssg_forms_processing_1.formDefinition.ElectronicSignatureResponseState(defaultValue);
            }
        }
        if (element.mode === 'apricot') {
            if (!!value && !!value.imageUrl) {
                return value;
            }
            else {
                return new ssg_forms_processing_1.formDefinition.ElectronicSignatureResponseState(defaultValue);
            }
        }
        else {
            return undefined;
        }
    };
    /**
     * @hidden
     * Draw everything to the screen.
     */
    ElectronicSignatureElement.prototype.render = function () {
        var _this = this;
        var _a = this.state, showSignPad = _a.showSignPad, completed = _a.completed, widthInPixels = _a.widthInPixels, heightInPixels = _a.heightInPixels, lines = _a.lines;
        var _b = this.props, element = _b.element, errors = _b.errors, showErrors = _b.showErrors, css = _b.css;
        var isRequired = element.isRequired, hidden = element.hidden, label = element.label, ariaLabel = element.ariaLabel, tooltip = element.tooltip, id = element.id, disabled = element.disabled, readOnly = element.readOnly, mode = element.mode, targetWidth = element.targetWidth, targetHeight = element.targetHeight;
        var currentValue = this.getCurrentValue();
        var inlineDisplay = form_error_utils_1.getElementErrorDisplay(errors, showErrors, !ssg_forms_processing_1.formDefinition.hasEmptyValue(element, currentValue));
        var fieldsetCompatibilityRole = 'cell';
        var aspect = targetHeight / targetWidth;
        var showCanvas = ((mode === ssg_forms_processing_1.formDefinition.electronicSignatureModes.ETO) || ((mode === ssg_forms_processing_1.formDefinition.electronicSignatureModes.APRICOT) && (!completed)));
        if (hidden)
            return null;
        return (React.createElement("div", { id: id },
            React.createElement("fieldset", { className: css.group },
                React.createElement(descriptors_1.RequiredLegend, { hasErrors: inlineDisplay.hasDisplayErrors, content: label, ariaLabel: ariaLabel, tooltip: tooltip, isRequired: isRequired, css: {
                        requiredLegend: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                        requiredIndicator: css.requiredIndicator,
                        tooltipGroup: css.labelWrapper,
                    } }),
                React.createElement("div", { className: css.inputWrapper },
                    React.createElement("div", { id: 'signButtonArea-' + id, className: classnames_1.default(css.buttonArea, (showSignPad || completed) ? css.hidden : '', readOnly ? css.readOnly : '') },
                        React.createElement("button", { type: "button", role: fieldsetCompatibilityRole, disabled: disabled || completed || showSignPad || readOnly, className: classnames_1.default(css.signButton, completed ? css.complete : ''), id: "sign-button-" + id, onClick: function (e) { return _this.signButtonClicked(); } }, "Sign")),
                    React.createElement("div", { style: { paddingTop: (aspect * 100) + "%", position: "relative" }, className: classnames_1.default(css.signPad, completed ? css.complete : '', (!showSignPad || (mode === 'apricot' && completed)) ? css.hidden : '', showSignPad && !completed ? css.focus : ''), id: "signPad-" + id, tabIndex: completed ? 0 : -1, onMouseDown: this.handleMouseDown, onMouseMove: this.handleMouseMove, onMouseLeave: this.handleMouseLeave, onTouchStart: this.handleTouchStart, onTouchMove: this.handleTouchMove, onTouchEnd: this.handleTouchEnd, role: fieldsetCompatibilityRole, "aria-label": (completed && lines && lines.size > 0 ? "A signature was submitted." : "No signature was submitted.") },
                        React.createElement("div", { className: css.canvasPosition },
                            React.createElement(this.createDrawing, { lines: lines }))),
                    React.createElement("div", { id: "mycanv-size" + id, style: { position: "relative", paddingTop: showCanvas ? "0px" : ((aspect * 100) + "%") } },
                        React.createElement("div", { className: css.canvasPosition },
                            React.createElement("canvas", { id: "mycanv-" + id, width: targetWidth, height: targetHeight, className: classnames_1.default(css.canvasPad, showCanvas ? css.hidden : "", (readOnly ? css.readOnly : ""), (completed ? css.complete : "")), tabIndex: completed ? 0 : -1, "aria-label": (!!currentValue && !!currentValue.imageUrl ? "A signature was submitted." : "No signature was submitted.") }))),
                    React.createElement("div", { id: 'clearAndSaveButtonsArea-' + id, className: classnames_1.default(css.buttonArea, (!showSignPad || completed || readOnly) ? css.hidden : '') },
                        React.createElement("button", { type: "button", role: fieldsetCompatibilityRole, className: css.clearButton, disabled: disabled || completed || readOnly, id: "clear-button-" + id, onClick: function (e) { return _this.clearSignPad(); } }, "Clear"),
                        React.createElement("button", { type: "button", role: fieldsetCompatibilityRole, className: css.saveButton, disabled: disabled || completed || readOnly, id: "save-button-" + id, onClick: function (e) { return _this.saveSignPad(); } }, "Save")),
                    React.createElement("div", { id: 'startOverButtonArea-' + id, className: classnames_1.default(css.buttonArea, (disabled || !completed || readOnly) ? css.hidden : '') },
                        React.createElement("button", { type: "button", role: fieldsetCompatibilityRole, className: css.startOverButton, disabled: disabled || !completed || readOnly, id: "start-over-button-" + id, onClick: function (e) { return _this.startOverSignPad(); } }, "Start Over")))),
            React.createElement("div", { className: css.inlineErrorDisplay }, inlineDisplay.displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); }))));
    };
    return ElectronicSignatureElement;
}(React.Component));
exports.ElectronicSignatureElement = ElectronicSignatureElement;
exports.default = react_styleable_1.default(electronic_signature_element_style_1.default)(ElectronicSignatureElement);


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var classnames_1 = __webpack_require__(6);
var error_reporting_1 = __webpack_require__(10);
var utilities_1 = __webpack_require__(9);
var text_input_1 = __webpack_require__(16);
var email_element_style_1 = __webpack_require__(62);
var form_error_utils_1 = __webpack_require__(11);
/**
 * This element renders a text input that expects to recieve text that is formatted like an email address.
 * An improperly formatted value will result in a validation error when it is processed by [[validation.runValidation]]
 */
var EmailElement = /** @class */ (function (_super) {
    __extends(EmailElement, _super);
    function EmailElement(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentValue: "",
            inFocus: false
        };
        return _this;
    }
    /** initially sets currentValue to what is in the store */
    EmailElement.prototype.componentWillMount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var displayResponse = text_input_1.getCurrentValue(value, defaultValue);
        this.setState({ currentValue: displayResponse });
    };
    /**
     * handles updates to the value in the store (form reset or conditional rules changes)
     * @param nextProps
     * @param nextState
     */
    EmailElement.prototype.componentWillUpdate = function (nextProps, nextState) {
        var _a = this.props, prevValue = _a.value, prevDefaultValue = _a.defaultValue;
        var prevDisplayValue = text_input_1.getCurrentValue(prevValue, prevDefaultValue);
        var value = nextProps.value, defaultValue = nextProps.defaultValue;
        var displayValue = text_input_1.getCurrentValue(value, defaultValue);
        if (prevDisplayValue !== displayValue) {
            this.setState({ currentValue: displayValue });
        }
    };
    /** save vaule to store before the state is lost */
    EmailElement.prototype.componentWillUnmount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var currentValue = this.state.currentValue;
        var storedValue = text_input_1.getCurrentValue(value, defaultValue);
        if (currentValue !== storedValue) {
            this.saveToStore();
        }
    };
    /**
     * handle change to the value of the input
     * @param event
     */
    EmailElement.prototype.handleOnChange = function (event) {
        var currentValue = this.state.currentValue;
        if (event.target.value !== currentValue) {
            this.setState({ currentValue: event.target.value });
        }
    };
    /**
     * saves to the store in the even thtat the form might be submitted
     * @param event
     */
    EmailElement.prototype.handleKeyDown = function (event) {
        if (event.key === "Enter" || event.keyCode === 13) {
            this.saveToStore();
        }
    };
    EmailElement.prototype.onFocus = function () {
        this.setState({
            inFocus: true
        });
    };
    /**
     * when moving on to another element, persist the local state changes to the store
     * @param event
     */
    EmailElement.prototype.onBlur = function (event) {
        this.saveToStore();
        this.setState({
            inFocus: false
        });
    };
    /** calls the onChange function to update the store with the currentValue */
    EmailElement.prototype.saveToStore = function () {
        var onChange = this.props.onChange;
        var currentValue = this.state.currentValue;
        onChange && onChange(currentValue);
    };
    /** @hidden returns the current value based on the value and defaultValue props. */
    EmailElement.prototype.getValue = function () {
        var currentValue = this.state.currentValue;
        return currentValue;
    };
    /** @hidden renders the label and input */
    EmailElement.prototype.render = function () {
        var _this = this;
        var _a = this.props, element = _a.element, onChange = _a.onChange, css = _a.css, showErrors = _a.showErrors, errors = _a.errors;
        var inFocus = this.state.inFocus;
        var isRequired = element.isRequired, label = element.label, ariaLabel = element.ariaLabel, id = element.id, disabled = element.disabled, readOnly = element.readOnly, hidden = element.hidden, tooltip = element.tooltip, autoComplete = element.autoComplete;
        var value = this.getValue();
        var inlineDisplay = form_error_utils_1.getElementErrorDisplay(errors, showErrors, (!!value && !inFocus));
        if (hidden) {
            return null;
        }
        return (React.createElement("div", { className: classnames_1.default(css.group, 'validated-section') },
            React.createElement(utilities_1.descriptors.RequiredLabel, { hasErrors: inlineDisplay.hasDisplayErrors, htmlFor: id, content: label, ariaLabel: ariaLabel, isRequired: isRequired, css: {
                    requiredLabel: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                    requiredIndicator: css.requiredIndicator,
                    tooltipGroup: css.labelWrapper,
                } }),
            React.createElement("div", { className: css.inputWrapper },
                React.createElement("div", { className: css.tooltipGroup },
                    React.createElement("input", { id: id, type: "email", value: value, autoComplete: autoComplete, onChange: function (e) { return _this.handleOnChange(e); }, onFocus: function (e) { return _this.onFocus(); }, onBlur: function (e) { return _this.onBlur(e); }, onKeyDown: function (e) { return _this.handleKeyDown(e); }, className: classnames_1.default(inlineDisplay.hasDisplayErrors ? css.inputError : css.input, 'validated-input'), disabled: disabled, readOnly: readOnly, "aria-required": isRequired, "aria-invalid": inlineDisplay.hasDisplayErrors, "aria-describedby": inlineDisplay.errorIds }),
                    tooltip ? React.createElement(utilities_1.TooltipDisplay, { text: tooltip, context: label }) : null),
                React.createElement("div", { className: css.inlineErrorDisplay }, inlineDisplay.displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); })))));
    };
    return EmailElement;
}(React.Component));
exports.EmailElement = EmailElement;
exports.default = react_styleable_1.default(email_element_style_1.default)(EmailElement);


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var react_fontawesome_1 = __webpack_require__(14);
var free_solid_svg_icons_1 = __webpack_require__(13);
var ssg_forms_processing_1 = __webpack_require__(7);
var utilities_1 = __webpack_require__(9);
var email_notification_element_style_1 = __webpack_require__(64);
var EmailNotificationElement = /** @class */ (function (_super) {
    __extends(EmailNotificationElement, _super);
    function EmailNotificationElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmailNotificationElement.prototype.getValue = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        return value ? value : defaultValue ? defaultValue : undefined;
    };
    EmailNotificationElement.prototype.renderEmailInformation = function () {
        var css = this.props.css;
        var value = this.getValue();
        return (React.createElement("div", { className: css.collapsibleSectionBody },
            React.createElement("div", { className: css.emailComponent },
                "From: ",
                value.from),
            React.createElement("div", { className: css.emailComponent },
                "To: ",
                value.recipients),
            React.createElement("div", { className: css.emailComponent },
                "Subject: ",
                React.createElement("span", { dangerouslySetInnerHTML: { __html: value.subject } })),
            React.createElement("div", { className: css.emailComponent },
                "Body: ",
                React.createElement("span", { dangerouslySetInnerHTML: { __html: value.body } }))));
    };
    EmailNotificationElement.prototype.renderSuccessfulEmailNotification = function () {
        var element = this.props.element;
        var id = element.id;
        return (React.createElement(utilities_1.CollapsibleSection, { id: id, label: 'Email Sent', css: {
                display: 'ssg-forms-collapsible-section-display email-notification-element-collapsible-section',
                label: 'ssg-forms-collapsible-section-label ssg-forms-text normal',
            } }, this.renderEmailInformation()));
    };
    EmailNotificationElement.prototype.renderFailedEmailNotification = function () {
        var _a = this.props, element = _a.element, css = _a.css;
        var id = element.id;
        var value = this.getValue();
        return (React.createElement(utilities_1.CollapsibleSection, { id: id, label: 'Email Failed', css: {
                display: 'ssg-forms-collapsible-section-display email-notification-element-collapsible-section',
                label: 'ssg-forms-collapsible-section-label ssg-forms-text normal',
            } },
            React.createElement("div", { className: css.errorText },
                React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faExclamationCircle }),
                React.createElement("span", null, value.errorMessage)),
            this.renderEmailInformation()));
    };
    EmailNotificationElement.prototype.renderNotSentEmailNotification = function () {
        var css = this.props.css;
        return React.createElement("div", { className: css.notificationText }, "Not Triggered");
    };
    EmailNotificationElement.prototype.renderBody = function () {
        var value = this.getValue();
        switch (value.status) {
            case ssg_forms_processing_1.formDefinition.emailNotificationStatus.sent:
                return this.renderSuccessfulEmailNotification();
            case ssg_forms_processing_1.formDefinition.emailNotificationStatus.failure:
                return this.renderFailedEmailNotification();
            default: return this.renderNotSentEmailNotification();
        }
    };
    EmailNotificationElement.prototype.render = function () {
        var _a = this.props, element = _a.element, css = _a.css;
        var id = element.id, label = element.label, tooltip = element.tooltip;
        var value = this.getValue();
        if (!value)
            return null;
        return (React.createElement("div", { className: css.group },
            React.createElement(utilities_1.descriptors.RequiredLabel, { htmlFor: id, content: label }),
            React.createElement("div", { className: css.inputWrapper },
                React.createElement("div", { className: css.tooltipGroup },
                    this.renderBody(),
                    tooltip ? React.createElement(utilities_1.TooltipDisplay, { text: tooltip, context: label }) : null))));
    };
    return EmailNotificationElement;
}(React.Component));
exports.EmailNotificationElement = EmailNotificationElement;
exports.default = react_styleable_1.default(email_notification_element_style_1.default)(EmailNotificationElement);


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ssg_forms_processing_1 = __webpack_require__(7);
var react_styleable_1 = __webpack_require__(1);
var giscoordinates_element_style_1 = __webpack_require__(67);
var utilities_1 = __webpack_require__(9);
var classnames_1 = __webpack_require__(6);
var error_reporting_1 = __webpack_require__(10);
var form_error_utils_1 = __webpack_require__(11);
var text_input_1 = __webpack_require__(16);
/**
 * This element renders GIS coordinates
 */
var GISCoordinatesElement = /** @class */ (function (_super) {
    __extends(GISCoordinatesElement, _super);
    function GISCoordinatesElement(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentValue: "",
            geolocationError: "",
        };
        return _this;
    }
    /** initially sets currentValue to what is in the store */
    GISCoordinatesElement.prototype.componentWillMount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var displayResponse = text_input_1.getCurrentValue(value, defaultValue);
        this.setState({ currentValue: displayResponse });
    };
    /**
     * handles updates to the value in the store (form reset or conditional rules changes)
     * @param nextProps
     * @param nextState
     */
    GISCoordinatesElement.prototype.componentWillUpdate = function (nextProps) {
        var _a = this.props, prevValue = _a.value, prevDefaultValue = _a.defaultValue;
        var prevDisplayValue = text_input_1.getCurrentValue(prevValue, prevDefaultValue);
        var value = nextProps.value, defaultValue = nextProps.defaultValue;
        var displayValue = text_input_1.getCurrentValue(value, defaultValue);
        if (prevDisplayValue !== displayValue) {
            this.setState({ currentValue: displayValue });
        }
    };
    /** save value to store before the state is lost */
    GISCoordinatesElement.prototype.componentWillUnmount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var currentValue = this.state.currentValue;
        var storedValue = text_input_1.getCurrentValue(value, defaultValue);
        if (currentValue !== storedValue) {
            this.saveToStore();
        }
    };
    /** calls the onChange function to update the store with the currentValue */
    GISCoordinatesElement.prototype.saveToStore = function () {
        var onChange = this.props.onChange;
        var currentValue = this.state.currentValue;
        onChange && onChange(currentValue);
    };
    /** This function gets the lat and long coordinates by using the browser GPS coordinates */
    GISCoordinatesElement.prototype.updateCoordinatesFromLocation = function (e) {
        var _this = this;
        var onChange = this.props.onChange;
        e.preventDefault();
        e.stopPropagation();
        if (!navigator.geolocation) {
            this.setState({ geolocationError: 'Geolocation is not supported by your browser or device.' });
        }
        else {
            var onSuccess = function (position) {
                var latitude = position.coords.latitude.toFixed(7);
                var longitude = position.coords.longitude.toFixed(7);
                var value = latitude + ", " + longitude;
                _this.setState({ currentValue: value, geolocationError: '' });
                onChange && onChange(value);
            };
            var onFailure = function (err) {
                console.error(err.message);
                switch (err.code) {
                    case err.PERMISSION_DENIED:
                        _this.setState({ geolocationError: 'Unable to retrieve your location. You may need to enable Location Services on your device and/or grant access to your location in your browser.' });
                        break;
                    case err.POSITION_UNAVAILABLE:
                        _this.setState({ geolocationError: 'An unexpected error occurred when retrieving the location of your device.' });
                        break;
                    default:
                        _this.setState({ geolocationError: 'Geolocation is not supported by your browser or device.' });
                        break;
                }
            };
            navigator.geolocation.getCurrentPosition(onSuccess, onFailure);
        }
    };
    GISCoordinatesElement.prototype.render = function () {
        var _this = this;
        var _a = this.props, element = _a.element, css = _a.css, showErrors = _a.showErrors, errors = _a.errors;
        var _b = this.state, currentValue = _b.currentValue, geolocationError = _b.geolocationError;
        var isRequired = element.isRequired, label = element.label, ariaLabel = element.ariaLabel, id = element.id, disabled = element.disabled, readOnly = element.readOnly, tooltip = element.tooltip, autoComplete = element.autoComplete;
        var inlineDisplay = form_error_utils_1.getElementErrorDisplay(errors, showErrors, !!currentValue);
        return (React.createElement("div", { className: css.group },
            React.createElement(utilities_1.descriptors.RequiredLabel, { hasErrors: inlineDisplay.hasDisplayErrors, htmlFor: id, content: label, ariaLabel: ariaLabel, isRequired: isRequired, css: {
                    requiredLabel: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                    requiredIndicator: css.requiredIndicator,
                    tooltipGroup: css.labelWrapper,
                } }),
            React.createElement("div", { className: css.inputWrapper },
                React.createElement("div", { className: css.tooltipGroup },
                    !!currentValue ?
                        React.createElement("input", { type: "text", className: inlineDisplay.hasDisplayErrors ? css.textError : css.text, id: id, disabled: true, value: currentValue, autoComplete: autoComplete, "aria-required": isRequired, "aria-invalid": inlineDisplay.hasDisplayErrors, "aria-describedby": inlineDisplay.errorIds })
                        : null,
                    !readOnly && !disabled ?
                        React.createElement("button", { className: css.button, onClick: function (e) { return _this.updateCoordinatesFromLocation(e); } },
                            currentValue ? "UPDATE" : "ADD",
                            " COORDINATES")
                        : null,
                    tooltip ? React.createElement(utilities_1.TooltipDisplay, { text: tooltip, context: label }) : null)),
            React.createElement("div", { className: css.inlineErrorDisplay },
                geolocationError ? React.createElement(error_reporting_1.InlineWarning, { key: 'geolocationError', warning: new ssg_forms_processing_1.formDefinition.Error({
                        errorMessage: geolocationError
                    }) }) : null,
                inlineDisplay.displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); }))));
    };
    return GISCoordinatesElement;
}(React.Component));
exports.GISCoordinatesElement = GISCoordinatesElement;
exports.default = react_styleable_1.default(giscoordinates_element_style_1.default)(GISCoordinatesElement);


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var giscoordinates_element_1 = __webpack_require__(323);
exports.GISCoordinatesElement = giscoordinates_element_1.default;
var giscoordinates_element_style_1 = __webpack_require__(67);
exports.defaultStyle = giscoordinates_element_style_1.default;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var classnames_1 = __webpack_require__(6);
var immutable_1 = __webpack_require__(2);
var group_element_style_1 = __webpack_require__(30);
var ssg_forms_processing_1 = __webpack_require__(7);
var form_element_1 = __webpack_require__(66);
var utilities_1 = __webpack_require__(9);
var ssg_form_component_1 = __webpack_require__(98);
var group_style_templates_1 = __webpack_require__(328);
var form_element_style_1 = __webpack_require__(29);
var error_reporting_1 = __webpack_require__(10);
var form_error_utils_1 = __webpack_require__(11);
/** An element that groups several form elements together, to show that they are related */
var GroupElement = /** @class */ (function (_super) {
    __extends(GroupElement, _super);
    function GroupElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden
     * Converts a subElement of the group into a JSX display with the appropriate styles.
     * @param element the element to render
     * @param styles the style sheet to use for the FormElement
     * @returns a JSX display that represents the element
     */
    GroupElement.prototype.mapElement = function (element, styles) {
        var _a = this.props, groupElement = _a.element, state = _a.state, getOnChange = _a.getOnChange, getOnDownload = _a.getOnDownload, getOnRemove = _a.getOnRemove, getStyleOverride = _a.getStyleOverride, styleSheet = _a.styleSheet, showInlineErrors = _a.showInlineErrors, customValidationErrors = _a.customValidationErrors, customDisplays = _a.customDisplays;
        var modifiedElement = ssg_forms_processing_1.formDefinition.getModifiedSubElement(groupElement, element);
        var returnValues = [];
        var beforeElement = customDisplays && customDisplays.filter(function (val) {
            return val.position.anchor === ssg_form_component_1.SsgFormAnchor.ELEMENT &&
                val.position.relationship == ssg_form_component_1.SsgFormRelation.BEFORE &&
                val.position.elementId === element.id;
        });
        var afterElement = customDisplays && customDisplays.filter(function (val) {
            return val.position.anchor === ssg_form_component_1.SsgFormAnchor.ELEMENT &&
                val.position.relationship == ssg_form_component_1.SsgFormRelation.AFTER &&
                val.position.elementId === element.id;
        });
        beforeElement && returnValues.push.apply(returnValues, beforeElement.map(function (val) { return val.display; }));
        returnValues.push(React.createElement(form_element_1.default, { element: modifiedElement, state: state, getOnChange: getOnChange, getOnDownload: getOnDownload, getOnRemove: getOnRemove, getStyleOverride: getStyleOverride, css: styles, showInlineErrors: showInlineErrors, customValidationErrors: customValidationErrors }));
        afterElement && returnValues.push.apply(returnValues, afterElement.map(function (val) { return val.display; }));
        return returnValues;
    };
    /** @hidden gets the appropriate stylesheet given the groupType on [[IGroupElementProps.element]] */
    GroupElement.prototype.getStyleSheet = function () {
        var element = this.props.element;
        var groupType = element.groupType;
        var defaultStyle;
        switch (groupType) {
            case ssg_forms_processing_1.formDefinition.groupTypes.INDENTED:
                return group_style_templates_1.indentedStyleSheet;
            case ssg_forms_processing_1.formDefinition.groupTypes.INLINE:
                return group_style_templates_1.inlineStyleSheet;
            default:
                return undefined;
        }
    };
    /** @hidden retrieves the appropriate default css based on the groupType on [[IGroupElementProps.element]] */
    GroupElement.prototype.getCss = function () {
        var _a = this.props, element = _a.element, css = _a.css;
        var groupType = element.groupType;
        var defaultStyle;
        switch (groupType) {
            case ssg_forms_processing_1.formDefinition.groupTypes.INDENTED:
                defaultStyle = group_style_templates_1.indentedGroup;
                break;
            case ssg_forms_processing_1.formDefinition.groupTypes.INLINE:
                defaultStyle = group_style_templates_1.inlineGroup;
                break;
            case ssg_forms_processing_1.formDefinition.groupTypes.CUSTOM:
            default:
                defaultStyle = group_element_style_1.default;
                break;
        }
        var style = Object.assign({}, defaultStyle, css);
        return style;
    };
    /** @hidden renders the group with all the subElements */
    GroupElement.prototype.render = function () {
        var _this = this;
        var _a = this.props, element = _a.element, state = _a.state, customValidationErrors = _a.customValidationErrors, showInlineErrors = _a.showInlineErrors, styleSheet = _a.styleSheet;
        var validationResult = state.validationResult;
        var isRequired = element.isRequired, label = element.label, ariaLabel = element.ariaLabel, id = element.id, disabled = element.disabled, readOnly = element.readOnly, hidden = element.hidden, tooltip = element.tooltip, groupType = element.groupType;
        if (hidden)
            return null;
        var errors = !!validationResult ? validationResult.errors.filter(function (error) { return error.sourceId === id; }).toList() : immutable_1.List([]);
        var customElementErrors = !!customValidationErrors ? customValidationErrors.filter(function (error) { return error.sourceId === id; }).toList() : immutable_1.List([]);
        errors = errors.concat(customElementErrors).toList();
        var emptyValue = ssg_forms_processing_1.formDefinition.hasEmptyValue(element, null, state);
        var inlineDisplay = form_error_utils_1.getElementErrorDisplay(errors, showInlineErrors, !emptyValue);
        var styles = form_element_style_1.mergeStyles(styleSheet, this.getStyleSheet());
        var css = this.getCss();
        var subElements = element && element.subElementsList;
        return (React.createElement("fieldset", { id: element.id, role: "group", className: css.group, "data-group-type": groupType.toString() },
            React.createElement(utilities_1.descriptors.RequiredLegend, { content: label, ariaLabel: ariaLabel, isRequired: isRequired, css: {
                    requiredLegend: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                    requiredIndicator: css.requiredIndicator,
                    tooltipGroup: css.labelWrapper,
                }, tooltip: tooltip }),
            React.createElement("div", { id: 'subElements', className: classnames_1.default(css.inputWrapper, { "input-error": inlineDisplay.hasDisplayErrors }) }, subElements && subElements.map(function (subElement) { return _this.mapElement(subElement, styles); })),
            React.createElement("div", { className: css.inlineErrorDisplay }, inlineDisplay.displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); }))));
    };
    return GroupElement;
}(React.Component));
exports.GroupElement = GroupElement;
exports.default = GroupElement;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var group_element_style_1 = __webpack_require__(30);
__webpack_require__(272);
/** The style sheet to be used for the 'indented' groupType */
exports.indentedStyleSheet = {
    group: {
        label: 'ssg-field-label'
    },
    heading: {},
    text: {
        label: 'ssg-field-label'
    },
    textArea: {
        label: 'ssg-field-label'
    },
    email: {
        label: 'ssg-field-label'
    },
    number: {
        label: 'ssg-field-label'
    },
    date: {
        label: 'ssg-field-label'
    },
    tel: {
        label: 'ssg-field-label'
    },
    checkbox: {
        label: 'ssg-field-label'
    },
    select: {
        label: 'ssg-field-label'
    },
    radio: {
        label: 'ssg-field-label'
    },
    nationalId: {
        label: 'ssg-field-label'
    },
    time: {
        label: 'ssg-field-label'
    },
    attachment: {
        label: 'ssg-field-label'
    },
    electronicSignature: {
        label: 'ssg-field-label'
    },
    postalCode: {
        label: 'ssg-field-label'
    },
    specialText: {
        label: 'ssg-field-label'
    }
};
/** The default css to be used for the 'indented' groupType */
exports.indentedGroup = __assign({}, group_element_style_1.default, { group: '', inputWrapper: 'ssg-indented-group' });


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var indented_style_1 = __webpack_require__(326);
exports.indentedGroup = indented_style_1.indentedGroup;
exports.indentedStyleSheet = indented_style_1.indentedStyleSheet;


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var indented_1 = __webpack_require__(327);
exports.indentedGroup = indented_1.indentedGroup;
exports.indentedStyleSheet = indented_1.indentedStyleSheet;
var inline_1 = __webpack_require__(329);
exports.inlineGroup = inline_1.inlineGroup;
exports.inlineStyleSheet = inline_1.inlineStyleSheet;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inline_style_1 = __webpack_require__(330);
exports.inlineGroup = inline_style_1.inlineGroup;
exports.inlineStyleSheet = inline_style_1.inlineStyleSheet;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var group_element_style_1 = __webpack_require__(30);
__webpack_require__(273);
var commonStyles = {
    group: 'ssg-forms-element ssg-forms-inline-element validated-section',
    label: 'ssg-field-label'
};
/** The style sheet to be used for the 'inline' groupType */
exports.inlineStyleSheet = {
    group: __assign({}, commonStyles),
    heading: {},
    text: __assign({}, commonStyles),
    textArea: __assign({}, commonStyles),
    email: __assign({}, commonStyles),
    number: __assign({}, commonStyles),
    date: __assign({}, commonStyles),
    tel: __assign({}, commonStyles),
    checkbox: __assign({}, commonStyles, { group: 'ssg-checkbox-fieldset ssg-forms-inline-element' }),
    select: __assign({}, commonStyles),
    radio: __assign({}, commonStyles, { group: 'ssg-radio-fieldset ssg-forms-inline-element' }),
    nationalId: __assign({}, commonStyles),
    time: __assign({}, commonStyles),
    attachment: __assign({}, commonStyles),
    electronicSignature: __assign({}, commonStyles),
    postalCode: __assign({}, commonStyles),
    specialText: __assign({}, commonStyles)
};
/** The default css to be used for the 'inline' groupType */
exports.inlineGroup = __assign({}, group_element_style_1.default, { group: '', inputWrapper: 'ssg-inline-group' });


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var group_element_1 = __webpack_require__(325);
exports.GroupElement = group_element_1.default;


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var heading_element_style_1 = __webpack_require__(68);
var HeadingElement = /** @class */ (function (_super) {
    __extends(HeadingElement, _super);
    function HeadingElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeadingElement.prototype.render = function () {
        var _a = this.props, element = _a.element, css = _a.css;
        var label = element.label, ariaLabel = element.ariaLabel, id = element.id, hidden = element.hidden;
        if (hidden)
            return null;
        return (React.createElement("div", { className: css.group },
            React.createElement("h3", { tabIndex: 0, role: "presentation", "aria-label": ariaLabel, className: css.heading }, label)));
    };
    return HeadingElement;
}(React.Component));
exports.HeadingElement = HeadingElement;
exports.default = react_styleable_1.default(heading_element_style_1.default)(HeadingElement);


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var help_element_style_1 = __webpack_require__(70);
var classnames_1 = __webpack_require__(6);
/** Component that renders help text for a form */
var HelpElement = /** @class */ (function (_super) {
    __extends(HelpElement, _super);
    function HelpElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** @hidden renders the display of the element */
    HelpElement.prototype.render = function () {
        var _a = this.props, element = _a.element, css = _a.css;
        if (element.hidden)
            return null;
        return (React.createElement("p", { id: element.id, tabIndex: 0, role: "presentation", "aria-label": element.ariaLabel, className: classnames_1.default(css.helpText, { disabled: element.disabled }) }, element.label));
    };
    return HelpElement;
}(React.Component));
exports.HelpElement = HelpElement;
exports.default = react_styleable_1.default(help_element_style_1.default)(HelpElement);


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var html_label_element_style_1 = __webpack_require__(72);
var HtmlLabelElement = /** @class */ (function (_super) {
    __extends(HtmlLabelElement, _super);
    function HtmlLabelElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HtmlLabelElement.prototype.render = function () {
        var _a = this.props, element = _a.element, css = _a.css;
        var label = element.label;
        if (element.hidden)
            return null;
        return (React.createElement("div", { className: css.label, dangerouslySetInnerHTML: { __html: label } }));
    };
    return HtmlLabelElement;
}(React.Component));
exports.HtmlLabelElement = HtmlLabelElement;
exports.default = react_styleable_1.default(html_label_element_style_1.default)(HtmlLabelElement);


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var likert_scale_element_1 = __webpack_require__(336);
exports.LikertScaleElement = likert_scale_element_1.default;
var likert_scale_element_style_1 = __webpack_require__(74);
exports.defaultStyle = likert_scale_element_style_1.default;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var classnames_1 = __webpack_require__(6);
var descriptors_1 = __webpack_require__(19);
var error_reporting_1 = __webpack_require__(10);
var form_error_utils_1 = __webpack_require__(11);
var multiple_choice_input_1 = __webpack_require__(24);
var likert_scale_element_style_1 = __webpack_require__(74);
var LikertScaleElement = /** @class */ (function (_super) {
    __extends(LikertScaleElement, _super);
    function LikertScaleElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Update the likert element to the selected option.
     * @param inputValue The newly selected value. If dealing with MultipleChoiceOptions,
     * this is the value property of the object.
     * @param checked If the current choice is selected ("checked"), this is true.  Otherwise, false.
     */
    LikertScaleElement.prototype.handleInput = function (inputValue, checked) {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange;
        var modifiedValue = multiple_choice_input_1.handleMultipleChoiceInput(value, defaultValue, inputValue, checked, true);
        onChange(modifiedValue);
    };
    LikertScaleElement.prototype.render = function () {
        var _this = this;
        var _a = this.props, element = _a.element, value = _a.value, onChange = _a.onChange, defaultValue = _a.defaultValue, css = _a.css, showErrors = _a.showErrors, errors = _a.errors;
        var isRequired = element.isRequired, label = element.label, ariaLabel = element.ariaLabel, id = element.id, disabled = element.disabled, readOnly = element.readOnly, options = element.options, hidden = element.hidden, tooltip = element.tooltip, autoComplete = element.autoComplete;
        var inlineDisplay = form_error_utils_1.getElementErrorDisplay(errors, showErrors, !!value);
        if (hidden)
            return null;
        return (React.createElement("fieldset", { id: id, role: "radiogroup", className: css.group, "aria-invalid": inlineDisplay.hasDisplayErrors, "aria-describedby": inlineDisplay.errorIds },
            React.createElement(descriptors_1.RequiredLegend, { hasErrors: inlineDisplay.hasDisplayErrors, content: label, ariaLabel: ariaLabel, isRequired: isRequired, css: {
                    requiredLegend: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                    requiredIndicator: css.requiredIndicator,
                    tooltipGroup: css.labelWrapper,
                }, tooltip: tooltip }),
            React.createElement("div", { className: css.inputWrapper },
                React.createElement("div", { className: css.inlineErrorDisplay }, inlineDisplay.displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); })),
                React.createElement("div", { className: classnames_1.default(css.radioGroup) }, options.map(function (option) { return (React.createElement("div", { key: id + "-" + option.value, className: classnames_1.default(css.optionWrapper, { disabled: disabled }, { readonly: readOnly }) },
                    React.createElement("label", { className: classnames_1.default(css.radioChoice, { disabled: disabled }, readOnly ? css.readOnly : ''), htmlFor: id + "_" + option.value },
                        React.createElement("input", { name: 'group' + id, id: id + "_" + option.value, className: classnames_1.default(css.radio, readOnly ? css.readOnly : '', { disabled: disabled }), value: option.value, autoComplete: autoComplete, type: "radio", readOnly: readOnly, disabled: disabled, onChange: function (selected) {
                                if (readOnly)
                                    return false;
                                return _this.handleInput(selected.target.value, !multiple_choice_input_1.isChecked(value, defaultValue, option.value));
                            }, checked: multiple_choice_input_1.isChecked(value, defaultValue, option.value) }),
                        option.label))); })))));
    };
    return LikertScaleElement;
}(React.Component));
exports.LikertScaleElement = LikertScaleElement;
exports.default = react_styleable_1.default(likert_scale_element_style_1.default)(LikertScaleElement);


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var national_id_element_style_1 = __webpack_require__(77);
var ssg_forms_processing_1 = __webpack_require__(7);
var masked_input_1 = __webpack_require__(23);
var utilities_1 = __webpack_require__(9);
var error_reporting_1 = __webpack_require__(10);
var nationalIdTypes = ssg_forms_processing_1.formDefinition.nationalIdTypes;
var text_input_1 = __webpack_require__(16);
var classnames_1 = __webpack_require__(6);
var form_error_utils_1 = __webpack_require__(11);
/** The implementation for the NationalIdElement. This element is of type [[formDefinition.NationalIdElement]] */
var NationalIdElement = /** @class */ (function (_super) {
    __extends(NationalIdElement, _super);
    function NationalIdElement(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentValue: "",
            inFocus: false,
            start: 0,
            end: 0,
            changeValue: '',
        };
        return _this;
    }
    /** initially sets currentValue to what is in the store */
    NationalIdElement.prototype.componentWillMount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var displayResponse = text_input_1.getCurrentValue(value, defaultValue);
        this.setState({ currentValue: displayResponse });
    };
    /**
     * handles updates to the value in the store (form reset or conditional rules changes)
     * @param nextProps
     * @param nextState
     */
    NationalIdElement.prototype.componentWillUpdate = function (nextProps, nextState) {
        var _a = this.props, prevValue = _a.value, prevDefaultValue = _a.defaultValue;
        var prevDisplayValue = text_input_1.getCurrentValue(prevValue, prevDefaultValue);
        var value = nextProps.value, defaultValue = nextProps.defaultValue;
        var displayValue = text_input_1.getCurrentValue(value, defaultValue);
        if (prevDisplayValue !== displayValue) {
            this.setState({ currentValue: displayValue });
        }
    };
    /**
     * Component lifecycle function that executes after props have changed. This function
     * applies the masking and formatting to the control value
     * @param prevProps The components props before the update
     * @param prevState The components current props (after the update)
     */
    NationalIdElement.prototype.componentDidUpdate = function (prevProps, prevState) {
        var element = this.props.element;
        var currentValue = this.state.currentValue;
        var id = element.id, readOnly = element.readOnly, disabled = element.disabled;
        var oldElement = prevProps.element;
        var oldValue = prevState.currentValue;
        var inFocus = this.state.inFocus;
        var wasInFocus = prevState.inFocus;
        if (inFocus) {
            var oldResponseFormatted = this.getCurrentFormattedValue(oldValue, oldElement.nationalIdType, wasInFocus, (readOnly || disabled));
            var newValue = this.getCurrentFormattedValue(currentValue, element.nationalIdType, inFocus, (readOnly || disabled));
            var newSelection = masked_input_1.handleSelection(/\D/, this.state, oldResponseFormatted, newValue);
            var input = document.getElementById(id);
            if (input && newSelection) {
                input.selectionStart = newSelection.start;
                input.selectionEnd = newSelection.end;
            }
        }
    };
    /** save vaule to store before the state is lost */
    NationalIdElement.prototype.componentWillUnmount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var currentValue = this.state.currentValue;
        var storedValue = text_input_1.getCurrentValue(value, defaultValue);
        if (currentValue !== storedValue) {
            this.saveToStore();
        }
    };
    /**
     * Returns the formatted text that will appear when the user is entering the
     * numbers into the element
     * @param input The value that is entered into the text box
     * @param idType The National ID type (SSN/SIN)
     */
    NationalIdElement.prototype.getFormattedString = function (input, idType) {
        if (input === undefined)
            return undefined;
        else if (!input)
            return "";
        var digits = input.replace(/\D/g, '');
        var formattedString = "";
        var first, second, third;
        switch (idType) {
            case nationalIdTypes.SSN:
                first = digits.slice(0, 3);
                second = digits.slice(3, 5);
                third = digits.slice(5, 9);
                break;
            case nationalIdTypes.SIN:
                first = digits.slice(0, 3);
                second = digits.slice(3, 6);
                third = digits.slice(6, 9);
                break;
            default:
                break;
        }
        formattedString += !!first ? first : "";
        formattedString += !!second ? "-" + second : "";
        formattedString += !!third ? "-" + third : "";
        return formattedString;
    };
    /**
     * The function that is executed after the user changes the value of the input.
     * The provided elements onChange function is executed during this event.
     * @param event The change event information
     */
    NationalIdElement.prototype.handleInput = function (event) {
        var value = event.target.value;
        var numbersOnly = value.replace(/\D/g, '');
        if (numbersOnly.length <= 9) {
            this.setState({
                start: event.target.selectionStart,
                end: event.target.selectionEnd,
                changeValue: event.target.value,
                currentValue: numbersOnly.substr(0, 9),
            });
        }
    };
    /**
     * saves to the store in the even thtat the form might be submitted
     * @param event
     */
    NationalIdElement.prototype.handleKeyDown = function (event) {
        if (event.key === "Enter" || event.keyCode === 13) {
            this.saveToStore();
        }
    };
    /**
     * The function that is executed after the element loses focus
     * @param event The focus event information
     */
    NationalIdElement.prototype.handleBlur = function (event) {
        event.preventDefault();
        this.saveToStore();
        this.setState({
            inFocus: false
        });
    };
    /**
     * The function that is executed after the element gains focus
     * @param event The focus event information
     */
    NationalIdElement.prototype.handleFocus = function (event) {
        event.preventDefault();
        this.setState({
            inFocus: true
        });
    };
    /** calls the onChange function to update the store with the currentValue */
    NationalIdElement.prototype.saveToStore = function () {
        var onChange = this.props.onChange;
        var currentValue = this.state.currentValue;
        onChange && onChange(currentValue);
    };
    /**
     * Returns the masked value for the given National ID depending on which type
     * it is
     */
    NationalIdElement.prototype.getMask = function () {
        var element = this.props.element;
        var mask = "";
        switch (element.nationalIdType) {
            case nationalIdTypes.SSN:
                mask = "xxx-xx-xxxx";
                break;
            case nationalIdTypes.SIN:
                mask = "xxx-xxx-xxx";
                break;
            default:
                break;
        }
        return mask;
    };
    /**
     * The masked value that is displayed when the element is read-only
     * @param value The National ID that is to be masked
     */
    NationalIdElement.prototype.getReadOnlyMask = function (value) {
        var element = this.props.element;
        if (value === undefined)
            return undefined;
        else if (!value)
            return "";
        var digits = value.toString().replace(/\D/g, "");
        var mask = "";
        switch (element.nationalIdType) {
            case nationalIdTypes.SSN:
                mask = "***-**-" + digits.slice(5, 9);
                break;
            case nationalIdTypes.SIN:
                mask = "***-***-" + digits.slice(6, 9);
                break;
            default:
                break;
        }
        return mask;
    };
    /**
     * Returns the formatted value that will be displayed in the element. This may be the masked
     * value or just a formatted value depending if read-only or not.
     * @param currentValue The value of the input element
     * @param type The type of NationalID (SSN/SIN)
     * @param inFocus If the control has focus
     * @param readOnly If the control is read-only/disabled
     */
    NationalIdElement.prototype.getCurrentFormattedValue = function (currentValue, type, inFocus, readOnly) {
        if (readOnly) {
            return this.getReadOnlyMask(currentValue);
        }
        else {
            var formattedValue = (inFocus === null || inFocus) ?
                this.getFormattedString(currentValue, type) : this.getMask().replace(/x/g, '*');
            return formattedValue;
        }
    };
    /**
     * Returns the value that will be displayed in the element.
     */
    NationalIdElement.prototype.getValue = function () {
        var _a = this.state, inFocus = _a.inFocus, currentValue = _a.currentValue;
        var element = this.props.element;
        var currentFormattedFalue = this.getCurrentFormattedValue(currentValue, element.nationalIdType, inFocus, (element.readOnly || element.disabled));
        return currentFormattedFalue;
    };
    NationalIdElement.prototype.render = function () {
        var _this = this;
        var _a = this.state, inFocus = _a.inFocus, currentValue = _a.currentValue;
        var _b = this.props, errors = _b.errors, showErrors = _b.showErrors, css = _b.css, element = _b.element;
        var isRequired = element.isRequired, hidden = element.hidden, label = element.label, ariaLabel = element.ariaLabel, id = element.id, disabled = element.disabled, readOnly = element.readOnly, tooltip = element.tooltip, autoComplete = element.autoComplete;
        var inlineDisplay = form_error_utils_1.getElementErrorDisplay(errors, showErrors, !!currentValue && !inFocus);
        if (hidden) {
            return null;
        }
        var placeholder = !!readOnly || !!disabled ? "" : this.getMask();
        return (React.createElement("div", { className: css.group },
            React.createElement(utilities_1.descriptors.RequiredLabel, { hasErrors: inlineDisplay.hasDisplayErrors, htmlFor: id, content: label, ariaLabel: ariaLabel, isRequired: isRequired, css: {
                    requiredLabel: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                    requiredIndicator: css.requiredIndicator,
                    tooltipGroup: css.labelWrapper,
                } }),
            React.createElement("div", { className: css.inputWrapper },
                React.createElement("div", { className: css.tooltipGroup },
                    React.createElement("input", { className: inlineDisplay.hasDisplayErrors ? css.inputError : css.input, id: id, type: "text", onChange: function (e) { return _this.handleInput(e); }, onBlur: function (e) { return _this.handleBlur(e); }, onFocus: function (e) { return _this.handleFocus(e); }, onKeyDown: function (e) { return _this.handleKeyDown(e); }, disabled: disabled, readOnly: readOnly, "aria-required": isRequired, "aria-invalid": inlineDisplay.hasDisplayErrors, "aria-describedby": inlineDisplay.errorIds, placeholder: !readOnly && !disabled ? placeholder : "", value: this.getValue(), autoComplete: autoComplete }),
                    tooltip ? React.createElement(utilities_1.TooltipDisplay, { text: tooltip, context: label }) : null),
                React.createElement("div", { className: css.inlineErrorDisplay }, inlineDisplay.displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); })))));
    };
    return NationalIdElement;
}(React.Component));
exports.NationalIdElement = NationalIdElement;
exports.default = react_styleable_1.default(national_id_element_style_1.default)(NationalIdElement);


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var detect_browser_1 = __webpack_require__(483);
var ssg_forms_processing_1 = __webpack_require__(7);
var error_reporting_1 = __webpack_require__(10);
var utilities_1 = __webpack_require__(9);
var react_styleable_1 = __webpack_require__(1);
var numeric_element_style_1 = __webpack_require__(79);
var numericElementTypes = ssg_forms_processing_1.formDefinition.numericElementTypes;
var numberUtilities = ssg_forms_processing_1.utilities.numberUtilities;
var classnames_1 = __webpack_require__(6);
var form_error_utils_1 = __webpack_require__(11);
var text_input_1 = __webpack_require__(16);
var NumericElement = /** @class */ (function (_super) {
    __extends(NumericElement, _super);
    function NumericElement(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentValue: "",
            inFocus: false
        };
        return _this;
    }
    /** initially sets currentValue to what is in the store */
    NumericElement.prototype.componentWillMount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var displayResponse = text_input_1.getCurrentValue(value, defaultValue);
        this.setState({ currentValue: displayResponse });
    };
    /**
     * handles updates to the value in the store (form reset or conditional rules changes)
     * @param nextProps
     * @param nextState
     */
    NumericElement.prototype.componentWillUpdate = function (nextProps, nextState) {
        var _a = this.props, prevValue = _a.value, prevDefaultValue = _a.defaultValue;
        var prevDisplayValue = text_input_1.getCurrentValue(prevValue, prevDefaultValue);
        var value = nextProps.value, defaultValue = nextProps.defaultValue;
        var displayValue = text_input_1.getCurrentValue(value, defaultValue);
        if (prevDisplayValue !== displayValue) {
            this.setState({ currentValue: displayValue });
        }
    };
    /** save vaule to store before the state is lost */
    NumericElement.prototype.componentWillUnmount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange, element = _a.element;
        var currentValue = this.state.currentValue;
        var decLimit = element.decLimit;
        var storedValue = text_input_1.getCurrentValue(value, defaultValue);
        var modifiedVal = currentValue && numberUtilities.removeCommas(currentValue, decLimit);
        var finalValue = modifiedVal === null || modifiedVal === undefined ? null : modifiedVal.toString();
        if (finalValue !== storedValue) {
            onChange(finalValue);
        }
    };
    /**
     * handle losing focus
     * @param event
     * @param decimalLimit
     */
    NumericElement.prototype.handleBlur = function (event, decimalLimit) {
        var onChange = this.props.onChange;
        var currentValue = this.state.currentValue;
        event.preventDefault();
        var modifiedVal = numberUtilities.removeCommas(currentValue, decimalLimit);
        var finalValue = modifiedVal === null || modifiedVal === undefined ? null : modifiedVal.toString();
        onChange(finalValue);
        this.setState({
            inFocus: false,
            currentValue: finalValue,
        });
    };
    /**
     * handle gaining focus
     * @param event
     * @param decimalLimit
     */
    NumericElement.prototype.handleFocus = function (event, decimalLimit) {
        event.preventDefault();
        this.setState({
            inFocus: true
        });
    };
    /**
     * Handle changes to the value of the input
     * @param event
     */
    NumericElement.prototype.handleChange = function (event) {
        var value = event.target.value;
        var verifiedValue = value.replace(/[^\b\-0-9\.]/g, '');
        this.setState({ currentValue: verifiedValue });
    };
    /**
     * saves to the store in the even thtat the form might be submitted
     * @param event
     */
    NumericElement.prototype.handleKeyDown = function (event) {
        if (event.key === "Enter" || event.keyCode === 13) {
            var onChange = this.props.onChange;
            var currentValue = this.state.currentValue;
            onChange && onChange(currentValue);
        }
    };
    NumericElement.prototype.getValue = function () {
        var _a = this.state, inFocus = _a.inFocus, currentValue = _a.currentValue;
        var element = this.props.element;
        var decLimit = element.decLimit, readOnly = element.readOnly;
        var maskedValue = currentValue;
        if (currentValue) {
            var number = Number(currentValue);
            maskedValue = decLimit === null || decLimit === undefined ? number.toString(10) : number.toFixed(decLimit);
        }
        if (!currentValue)
            return "";
        return readOnly || (inFocus !== null && !inFocus) ? maskedValue : currentValue;
    };
    NumericElement.prototype.render = function () {
        var _this = this;
        var inFocus = this.state.inFocus;
        var _a = this.props, element = _a.element, errors = _a.errors, showErrors = _a.showErrors, css = _a.css;
        var isRequired = element.isRequired, hidden = element.hidden, label = element.label, ariaLabel = element.ariaLabel, id = element.id, type = element.type, disabled = element.disabled, readOnly = element.readOnly, minVal = element.minVal, maxVal = element.maxVal, decLimit = element.decLimit, numericNumberType = element.numericNumberType, tooltip = element.tooltip, autoComplete = element.autoComplete;
        var valueId = id + '-value';
        var currentValue = this.getValue();
        var dollars = numericNumberType === numericElementTypes.MONEY ? '$' : '';
        var percent = numericNumberType === numericElementTypes.PERCENTAGE ? '%' : '';
        var inlineDisplay = form_error_utils_1.getElementErrorDisplay(errors, showErrors, !!currentValue && currentValue !== "" && !inFocus);
        var stepValue = decLimit != null ? Math.pow(10, (-1 * decLimit)) : 1;
        if (hidden)
            return null;
        var addonClass = classnames_1.default(css.inputGroupAddon, { focus: inFocus }, { disabled: disabled }, { readonly: readOnly });
        var isGroupType = numericNumberType === numericElementTypes.PERCENTAGE || numericNumberType === numericElementTypes.MONEY;
        var dollarSign = numericNumberType === numericElementTypes.MONEY ?
            React.createElement("div", { className: addonClass }, dollars)
            : null;
        var percentSign = numericNumberType === numericElementTypes.PERCENTAGE ?
            React.createElement("div", { className: addonClass }, percent) :
            null;
        // The following is a result of lack of support for the number element type in several browsers
        var inputType;
        var browser = detect_browser_1.detect();
        if (browser === 'ie' || browser === 'edge' || browser === 'firefox') {
            inputType = "text";
        }
        else {
            inputType = "number";
        }
        var numberDisplay = readOnly ? (React.createElement("div", { id: id, tabIndex: 0, role: 'textbox', className: classnames_1.default(css.input, { focus: inFocus }, { disabled: disabled }, { readonly: readOnly }), "aria-label": label, "aria-required": isRequired, "aria-invalid": inlineDisplay.hasDisplayErrors, "aria-readonly": true, "aria-valuemin": minVal, "aria-valuemax": maxVal, "aria-describedby": inlineDisplay.errorIds },
            dollarSign,
            currentValue,
            percentSign)) :
            (React.createElement("div", { className: (dollarSign || percentSign) ? classnames_1.default(css.inputGroup, { 'input-error': inlineDisplay.hasDisplayErrors }, { focus: inFocus }, { disabled: disabled }, { readonly: readOnly }) : css.noInputGroup },
                dollarSign,
                React.createElement("input", { type: inputType, className: classnames_1.default("validated-input", css.input, { 'input-error': inlineDisplay.hasDisplayErrors && !isGroupType }), id: id, onChange: function (e) {
                        if (readOnly)
                            return false;
                        _this.handleChange(e);
                    }, onBlur: function (e) {
                        if (readOnly)
                            return false;
                        _this.handleBlur(e, decLimit);
                    }, onFocus: function (e) {
                        if (readOnly)
                            return false;
                        _this.handleFocus(e, decLimit);
                    }, onKeyDown: function (e) { return _this.handleKeyDown(e); }, disabled: disabled, "aria-required": isRequired, "aria-invalid": inlineDisplay.hasDisplayErrors, "aria-describedby": inlineDisplay.errorIds, readOnly: readOnly, min: minVal, "aria-valuemin": minVal, max: maxVal, "aria-valuemax": maxVal, step: stepValue, required: isRequired, value: currentValue, autoComplete: autoComplete, onInvalid: function (e) {
                        e.preventDefault();
                    } }),
                percentSign));
        return (React.createElement("div", { className: css.group },
            React.createElement(utilities_1.descriptors.RequiredLabel, { hasErrors: inlineDisplay.hasDisplayErrors, htmlFor: id, content: label, ariaLabel: ariaLabel, isRequired: isRequired, css: {
                    requiredLabel: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                    requiredIndicator: css.requiredIndicator,
                    tooltipGroup: css.labelWrapper,
                } }),
            React.createElement("div", { className: css.inputWrapper },
                React.createElement("div", { className: css.tooltipGroup },
                    numberDisplay,
                    tooltip ? React.createElement(utilities_1.TooltipDisplay, { text: tooltip, context: label }) : null),
                React.createElement("div", { className: css.inlineErrorDisplay }, inlineDisplay.displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); })))));
    };
    return NumericElement;
}(React.Component));
exports.NumericElement = NumericElement;
exports.default = react_styleable_1.default(numeric_element_style_1.default)(NumericElement);


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var phone_element_style_1 = __webpack_require__(81);
var text_input_1 = __webpack_require__(16);
var masked_input_1 = __webpack_require__(23);
var utilities_1 = __webpack_require__(9);
var error_reporting_1 = __webpack_require__(10);
var classnames_1 = __webpack_require__(6);
var form_error_utils_1 = __webpack_require__(11);
/**
 * This element renders an input that allows the user to input a phone number.
 * Ten digits are expected in order to pass validation.
 * Currently, only US format numbers are accepted.
 */
var PhoneElement = /** @class */ (function (_super) {
    __extends(PhoneElement, _super);
    /** @hidden initializes the state */
    function PhoneElement(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentValue: "",
            inFocus: false,
            start: 0,
            end: 0,
            changeValue: '',
        };
        return _this;
    }
    /** initially sets currentValue to what is in the store */
    PhoneElement.prototype.componentWillMount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var displayResponse = text_input_1.getCurrentValue(value, defaultValue);
        this.setState({ currentValue: displayResponse });
    };
    /**
     * handles updates to the value in the store (form reset or conditional rules changes)
     * @param nextProps
     * @param nextState
     */
    PhoneElement.prototype.componentWillUpdate = function (nextProps, nextState) {
        var _a = this.props, prevValue = _a.value, prevDefaultValue = _a.defaultValue;
        var prevDisplayValue = text_input_1.getCurrentValue(prevValue, prevDefaultValue);
        var value = nextProps.value, defaultValue = nextProps.defaultValue;
        var displayValue = text_input_1.getCurrentValue(value, defaultValue);
        if (prevDisplayValue !== displayValue) {
            this.setState({ currentValue: displayValue });
        }
    };
    /**
     * @hidden handles changes in the selection of the phone number due to value masking
     * @param prevProps the props before this update
     * @param prevState the state before this update
     */
    PhoneElement.prototype.componentDidUpdate = function (prevProps, prevState) {
        var oldResponse = prevState.currentValue;
        var element = this.props.element;
        var currentValue = this.state.currentValue;
        var inFocus = this.state.inFocus;
        var id = element.id;
        if (inFocus) {
            var oldValue = this.getCurrentFormattedValue(oldResponse);
            var newValue = this.getCurrentFormattedValue(currentValue);
            var newSelection = masked_input_1.handleSelection(/\D/, this.state, oldValue, newValue);
            var input = document.getElementById(id);
            if (input && newSelection) {
                input.selectionStart = newSelection.start;
                input.selectionEnd = newSelection.end;
            }
        }
    };
    /** save vaule to store before the state is lost */
    PhoneElement.prototype.componentWillUnmount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var currentValue = this.state.currentValue;
        var storedValue = text_input_1.getCurrentValue(value, defaultValue);
        if (currentValue !== storedValue) {
            this.saveToStore();
        }
    };
    /**
     * @hidden converts the numbers entered by the user into user friendly format
     * @param input phone number value
     */
    PhoneElement.prototype.getFormattedString = function (input) {
        if (input === undefined)
            return undefined;
        else if (!input)
            return "";
        var digits = input.replace(/\D/g, '');
        var first = digits.slice(0, 3);
        var second = digits.slice(3, 6);
        var third = digits.slice(6, 10);
        var formattedString = "";
        formattedString += !!first ? "(" + first : "";
        formattedString += !!second ? ") " + second : "";
        formattedString += !!third ? "-" + third : "";
        return formattedString;
    };
    /**
     * @hidden Changes inFocus to false; used when this component loses focus.
     * @param event focus change event
     */
    PhoneElement.prototype.handleBlur = function (event) {
        event.preventDefault();
        this.saveToStore();
        this.setState({
            inFocus: false
        });
    };
    /**
     * @hidden Changes inFocus to true; used when this component gains focus.
     * @param event focus change event
     */
    PhoneElement.prototype.handleFocus = function (event) {
        event.preventDefault();
        this.setState({
            inFocus: true,
        });
    };
    /** saves to the store in the even thtat the form might be submitted */
    PhoneElement.prototype.handleKeyDown = function (event) {
        if (event.key === "Enter" || event.keyCode === 13) {
            this.saveToStore();
        }
    };
    /**
     * Handles user input for the phone number display.
     * Limits the input to only numbers and prevents inputting values after 10 numbers.
     * @param event change event
     */
    PhoneElement.prototype.handleInput = function (event) {
        var value = event.target.value;
        var numbersOnly = value.replace(/\D/g, '');
        if (numbersOnly.length <= 10) {
            this.setState({
                start: event.target.selectionStart,
                end: event.target.selectionEnd,
                changeValue: event.target.value,
                currentValue: numbersOnly.substr(0, 10)
            });
        }
    };
    /** calls the onChange function to update the store with the currentValue */
    PhoneElement.prototype.saveToStore = function () {
        var onChange = this.props.onChange;
        var currentValue = this.state.currentValue;
        onChange && onChange(currentValue);
    };
    /**
     * @hidden Retrieves whatever the current value is for this element, in a user friendly format.
     * @param value the current [[IPhoneElementProps.value]]
     */
    PhoneElement.prototype.getCurrentFormattedValue = function (currentValue) {
        return currentValue ? this.getFormattedString(currentValue) : "";
    };
    /** @hidden renders the component */
    PhoneElement.prototype.render = function () {
        var _this = this;
        var _a = this.state, inFocus = _a.inFocus, currentValue = _a.currentValue;
        var _b = this.props, element = _b.element, errors = _b.errors, showErrors = _b.showErrors, css = _b.css;
        var isRequired = element.isRequired, hidden = element.hidden, label = element.label, ariaLabel = element.ariaLabel, id = element.id, disabled = element.disabled, readOnly = element.readOnly, tooltip = element.tooltip, autoComplete = element.autoComplete;
        var inlineDisplay = form_error_utils_1.getElementErrorDisplay(errors, showErrors, !!currentValue && !inFocus);
        if (hidden)
            return null;
        var phoneValue = this.getCurrentFormattedValue(currentValue);
        return (React.createElement("div", { className: css.group + ' validated-section' },
            React.createElement(utilities_1.descriptors.RequiredLabel, { hasErrors: inlineDisplay.hasDisplayErrors, htmlFor: id, content: label, ariaLabel: ariaLabel, isRequired: isRequired, css: {
                    requiredLabel: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                    requiredIndicator: css.requiredIndicator,
                    tooltipGroup: css.labelWrapper,
                } }),
            React.createElement("div", { className: css.inputWrapper },
                React.createElement("div", { className: css.tooltipGroup },
                    React.createElement("input", { id: id, type: "text", value: phoneValue, autoComplete: autoComplete, onChange: function (e) { return _this.handleInput(e); }, onFocus: function (e) { return _this.handleFocus(e); }, onBlur: function (e) { return _this.handleBlur(e); }, onKeyDown: function (e) { return _this.handleKeyDown(e); }, className: inlineDisplay.hasDisplayErrors ? css.phoneError + ' validated-input' : css.phone + ' validated-input', placeholder: !readOnly && !disabled ? "(xxx) xxx-xxxx" : "", disabled: disabled, readOnly: readOnly, "aria-required": isRequired, "aria-invalid": inlineDisplay.hasDisplayErrors, "aria-describedby": inlineDisplay.errorIds }),
                    tooltip ? React.createElement(utilities_1.TooltipDisplay, { text: tooltip, context: label }) : null),
                React.createElement("div", { className: css.inlineErrorDisplay }, inlineDisplay.displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); })))));
    };
    return PhoneElement;
}(React.Component));
exports.PhoneElement = PhoneElement;
exports.default = react_styleable_1.default(phone_element_style_1.default)(PhoneElement);


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var postal_code_element_style_1 = __webpack_require__(83);
var masked_input_1 = __webpack_require__(23);
var text_input_1 = __webpack_require__(16);
var utilities_1 = __webpack_require__(9);
var error_reporting_1 = __webpack_require__(10);
var form_definition_1 = __webpack_require__(17);
var classnames_1 = __webpack_require__(6);
var form_error_utils_1 = __webpack_require__(11);
/**
 * This element renders an input that captures a postal code.
 * Currently, supports US and Canadian postal codes, and validation is made on country-specific basis.
 */
var PostalCodeElement = /** @class */ (function (_super) {
    __extends(PostalCodeElement, _super);
    function PostalCodeElement(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentValue: "",
            inFocus: false,
            start: 0,
            end: 0,
            changeValue: '',
        };
        return _this;
    }
    /** initially sets currentValue to what is in the store */
    PostalCodeElement.prototype.componentWillMount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var displayResponse = text_input_1.getCurrentValue(value, defaultValue);
        this.setState({ currentValue: displayResponse });
    };
    /**
     * handles updates to the value in the store (form reset or conditional rules changes)
     * @param nextProps
     * @param nextState
     */
    PostalCodeElement.prototype.componentWillUpdate = function (nextProps, nextState) {
        var _a = this.props, prevValue = _a.value, prevDefaultValue = _a.defaultValue;
        var prevDisplayValue = text_input_1.getCurrentValue(prevValue, prevDefaultValue);
        var value = nextProps.value, defaultValue = nextProps.defaultValue;
        var displayValue = text_input_1.getCurrentValue(value, defaultValue);
        if (prevDisplayValue !== displayValue) {
            this.setState({ currentValue: displayValue });
        }
    };
    /**
     * @hidden handles changes in the selection of the postal code due to value formatting
     * @param prevProps the props before this update
     * @param prevState the state before this update
     */
    PostalCodeElement.prototype.componentDidUpdate = function (prevProps, prevState) {
        var oldResponse = prevState.currentValue;
        var element = this.props.element;
        var currentValue = this.state.currentValue;
        var inFocus = this.state.inFocus;
        var country = element.country, id = element.id;
        if (inFocus) {
            var oldValue = this.getFormattedString(oldResponse);
            var newValue = this.getFormattedString(currentValue);
            var maskChars;
            switch (country) {
                case form_definition_1.countryCodes.UnitedKingdom:
                    maskChars = /[^a-zA-Z0-9 ]/;
                    break;
                case form_definition_1.countryCodes.Canada:
                    maskChars = /[^a-zA-Z0-9]/;
                    break;
                case form_definition_1.countryCodes.UnitedStates:
                default:
                    maskChars = /\D/;
                    break;
            }
            var newSelection = masked_input_1.handleSelection(maskChars, this.state, oldValue, newValue);
            var input = document.getElementById(id);
            if (input && newSelection) {
                input.selectionStart = newSelection.start;
                input.selectionEnd = newSelection.end;
            }
        }
    };
    /** save vaule to store before the state is lost */
    PostalCodeElement.prototype.componentWillUnmount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var currentValue = this.state.currentValue;
        var storedValue = text_input_1.getCurrentValue(value, defaultValue);
        if (currentValue !== storedValue) {
            this.saveToStore();
        }
    };
    /** returns the current value of the element
     * the value is formatted based on the country's postal code signature.
     * if no new value has been entered, the default value will be returned.
     */
    PostalCodeElement.prototype.getValue = function () {
        var currentValue = this.state.currentValue;
        return currentValue ? this.getFormattedString(currentValue) : "";
    };
    /**
     * @hidden converts the characters entered by the user into formatted value.
     * Prevents user from entering values exceeding particular postal code length
     * @param val postal code value
     */
    PostalCodeElement.prototype.getFormattedString = function (val) {
        var element = this.props.element;
        var country = element.country;
        if (val === undefined) {
            return undefined;
        }
        else if (!val) {
            return "";
        }
        var formattedString;
        switch (country) {
            case form_definition_1.countryCodes.UnitedKingdom:
                {
                    formattedString = val.replace(/[^a-zA-Z0-9 ]/g, '');
                }
                break;
            case form_definition_1.countryCodes.Canada:
                {
                    var chars = val.replace(/[^a-zA-Z0-9]/g, '');
                    var first = chars.slice(0, 3);
                    var second = chars.slice(3, 6);
                    formattedString = "";
                    formattedString += !!first ? first : "";
                    formattedString += !!second ? " " + second : "";
                }
                break;
            case form_definition_1.countryCodes.UnitedStates:
            default:
                formattedString = val.replace(/\D/g, '');
                formattedString = formattedString.substr(0, 5);
                break;
        }
        return formattedString;
    };
    /**
     * @hidden Changes inFocus to false; used when this component loses focus.
     * @param event focus change event
     */
    PostalCodeElement.prototype.handleBlur = function (event) {
        event.preventDefault();
        this.saveToStore();
        this.setState({
            inFocus: false
        });
    };
    /**
     * @hidden Changes inFocus to true; used when this component gains focus.
     * @param event focus change event
     */
    PostalCodeElement.prototype.handleFocus = function (event) {
        event.preventDefault();
        this.setState({
            inFocus: true,
        });
    };
    /**
     * saves to the store in the even thtat the form might be submitted
     * @param event
     */
    PostalCodeElement.prototype.handleKeyDown = function (event) {
        if (event.key === "Enter" || event.keyCode === 13) {
            this.saveToStore();
        }
    };
    /**
     * @hidden Handles user input for the postal code. Limits the input to only letters and/or numbers.
     * @param event change event
     */
    PostalCodeElement.prototype.handleInput = function (event) {
        var _a = this.props, element = _a.element, onChange = _a.onChange, value = _a.value, defaultValue = _a.defaultValue;
        var country = element.country;
        var targetValue = event.target.value;
        // verify not exceeding length or allowed characters
        var maskChars;
        switch (country) {
            case form_definition_1.countryCodes.UnitedKingdom:
                maskChars = /^[a-zA-Z0-9 ]{0,9}$/;
                if (targetValue.length > 9 || !maskChars.test(targetValue)) {
                    this.setState({
                        start: event.target.selectionStart - 1,
                        end: event.target.selectionEnd - 1,
                        changeValue: event.target.value,
                    });
                    return;
                }
                break;
            case form_definition_1.countryCodes.Canada:
                maskChars = /^[a-zA-Z0-9 ]{0,7}$/;
                if (targetValue.length > 7 || !maskChars.test(targetValue)) {
                    this.setState({
                        start: event.target.selectionStart - 1,
                        end: event.target.selectionEnd - 1,
                        changeValue: event.target.value,
                    });
                    return;
                }
                break;
            case form_definition_1.countryCodes.UnitedStates:
            default:
                maskChars = /^\d{0,5}$/;
                if (targetValue.length > 5 || !maskChars.test(targetValue)) {
                    this.setState({
                        start: event.target.selectionStart - 1,
                        end: event.target.selectionEnd - 1,
                        changeValue: event.target.value,
                    });
                    return;
                }
                break;
        }
        // verify valid entry
        var newValue = this.getFormattedString(targetValue);
        if (!this.verifyValidInput(newValue)) {
            this.setState({
                start: event.target.selectionStart - 1,
                end: event.target.selectionEnd - 1,
                changeValue: event.target.value,
            });
            return;
        }
        var currentValue = this.getFormattedString(text_input_1.getCurrentValue(value, defaultValue));
        if (newValue !== currentValue) {
            this.setState({
                start: event.target.selectionStart,
                end: event.target.selectionEnd,
                changeValue: event.target.value,
                currentValue: event.target.value
            });
        }
    };
    /** verifies input string matches format of country's postal code */
    PostalCodeElement.prototype.verifyValidInput = function (input) {
        var element = this.props.element;
        var country = element.country;
        var maskChars;
        switch (country) {
            case form_definition_1.countryCodes.UnitedKingdom:
                maskChars = /^[a-zA-Z0-9]{0,8}$|^[a-zA-Z0-9]{0,4} [a-zA-Z0-9]{0,4}$/;
                break;
            case form_definition_1.countryCodes.Canada:
                maskChars = /^[a-zA-Z0-9]{0,6}$|^[a-zA-Z0-9]{3} [a-zA-Z0-9]{0,3}$/;
                break;
            case form_definition_1.countryCodes.UnitedStates:
            default:
                maskChars = /^\d{0,5}$/;
                break;
        }
        var passed = maskChars.test(input);
        return passed;
    };
    /** calls the onChange function to update the store with the currentValue */
    PostalCodeElement.prototype.saveToStore = function () {
        var onChange = this.props.onChange;
        var currentValue = this.state.currentValue;
        onChange && onChange(currentValue);
    };
    PostalCodeElement.prototype.render = function () {
        var _this = this;
        var inFocus = this.state.inFocus;
        var _a = this.props, errors = _a.errors, showErrors = _a.showErrors, css = _a.css, element = _a.element;
        var isRequired = element.isRequired, hidden = element.hidden, label = element.label, ariaLabel = element.ariaLabel, id = element.id, disabled = element.disabled, readOnly = element.readOnly, tooltip = element.tooltip, autoComplete = element.autoComplete;
        var currentValue = this.getValue();
        var inlineDisplay = form_error_utils_1.getElementErrorDisplay(errors, showErrors, !!currentValue && currentValue !== "" && !inFocus);
        if (hidden) {
            return null;
        }
        return (React.createElement("div", { className: css.group },
            React.createElement(utilities_1.descriptors.RequiredLabel, { hasErrors: inlineDisplay.hasDisplayErrors, htmlFor: id, content: label, ariaLabel: ariaLabel, isRequired: isRequired, css: {
                    requiredLabel: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                    requiredIndicator: css.requiredIndicator,
                    tooltipGroup: css.labelWrapper,
                } }),
            React.createElement("div", { className: css.inputWrapper },
                React.createElement("div", { className: css.tooltipGroup },
                    React.createElement("input", { className: classnames_1.default(css.input, { 'input-error': inlineDisplay.hasDisplayErrors }), id: id, type: "text", onChange: function (e) { return _this.handleInput(e); }, onFocus: function (e) { return _this.handleFocus(e); }, onBlur: function (e) { return _this.handleBlur(e); }, onKeyDown: function (e) { return _this.handleKeyDown(e); }, disabled: disabled, readOnly: readOnly, "aria-required": isRequired, "aria-invalid": inlineDisplay.hasDisplayErrors, "aria-describedby": inlineDisplay.errorIds, value: currentValue, autoComplete: autoComplete }),
                    tooltip ? React.createElement(utilities_1.TooltipDisplay, { text: tooltip, context: label }) : null),
                React.createElement("div", { className: css.inlineErrorDisplay }, inlineDisplay.displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); })))));
    };
    return PostalCodeElement;
}(React.Component));
exports.PostalCodeElement = PostalCodeElement;
exports.default = react_styleable_1.default(postal_code_element_style_1.default)(PostalCodeElement);


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var descriptors_1 = __webpack_require__(19);
var ssg_forms_processing_1 = __webpack_require__(7);
var react_styleable_1 = __webpack_require__(1);
var radio_element_style_1 = __webpack_require__(85);
var multiple_choice_input_1 = __webpack_require__(24);
var classnames_1 = __webpack_require__(6);
var error_reporting_1 = __webpack_require__(10);
var form_error_utils_1 = __webpack_require__(11);
/** RadioElements are a type of exclusive choice selection element.  Once a selection
 * has been made, the choices cannot be deselected.
  */
var RadioElement = /** @class */ (function (_super) {
    __extends(RadioElement, _super);
    function RadioElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Update the radio element to the selected option.
     * @param inputValue The newly selected value. If dealing with MultipleChoiceOptions,
     * this is the value property of the object.
     * @param checked If the current choice is selected ("checked"), this is true.  Otherwise, false.
     */
    RadioElement.prototype.handleInput = function (inputValue, checked) {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange;
        var modifiedValue = multiple_choice_input_1.handleMultipleChoiceInput(value, defaultValue, inputValue, checked, true);
        onChange(modifiedValue);
    };
    /**
     * If the radio element has a selected value, this will return true. Otherwise, this will be false.
     * @returns True if this element has a value, false otherwise.
     */
    RadioElement.prototype.hasValue = function () {
        var _a = this.props, element = _a.element, value = _a.value, defaultValue = _a.defaultValue;
        var currentValue = multiple_choice_input_1.getCurrentValue(value, defaultValue);
        return !ssg_forms_processing_1.formDefinition.hasEmptyValue(element, currentValue);
    };
    RadioElement.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, element = _b.element, value = _b.value, onChange = _b.onChange, defaultValue = _b.defaultValue, css = _b.css, showErrors = _b.showErrors, errors = _b.errors;
        var isRequired = element.isRequired, label = element.label, ariaLabel = element.ariaLabel, id = element.id, disabled = element.disabled, readOnly = element.readOnly, options = element.options, hidden = element.hidden, tooltip = element.tooltip, autoComplete = element.autoComplete;
        var inlineDisplay = form_error_utils_1.getElementErrorDisplay(errors, showErrors, !!value);
        if (hidden)
            return null;
        return (React.createElement("fieldset", { id: id, role: "radiogroup", className: css.group, "aria-invalid": inlineDisplay.hasDisplayErrors, "aria-describedby": inlineDisplay.errorIds },
            React.createElement(descriptors_1.RequiredLegend, { hasErrors: inlineDisplay.hasDisplayErrors, content: label, ariaLabel: ariaLabel, isRequired: isRequired, css: {
                    requiredLegend: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                    requiredIndicator: css.requiredIndicator,
                    tooltipGroup: css.labelWrapper,
                }, tooltip: tooltip }),
            React.createElement("div", { className: css.inputWrapper },
                React.createElement("div", { className: css.inlineErrorDisplay }, inlineDisplay.displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); })),
                React.createElement("div", { className: classnames_1.default(css.radioGroup, (_a = {}, _a[css.emptyValue] = !this.hasValue(), _a)) }, options.map(function (option) { return (React.createElement("div", { key: id + "-" + option.value, className: css.optionWrapper },
                    React.createElement("label", { className: classnames_1.default(css.radioChoice, { disabled: disabled }, readOnly ? css.readOnly : ''), htmlFor: id + "_" + option.value },
                        React.createElement("input", { name: 'group' + id, id: id + "_" + option.value, className: classnames_1.default(css.radio, readOnly ? css.readOnly : '', { disabled: disabled }), value: option.value, autoComplete: autoComplete, type: "radio", readOnly: readOnly, disabled: disabled, onChange: function (selected) {
                                if (readOnly)
                                    return false;
                                return _this.handleInput(selected.target.value, !multiple_choice_input_1.isChecked(value, defaultValue, option.value));
                            }, checked: multiple_choice_input_1.isChecked(value, defaultValue, option.value) }),
                        option.label),
                    React.createElement("br", null))); })))));
    };
    return RadioElement;
}(React.Component));
exports.RadioElement = RadioElement;
exports.default = react_styleable_1.default(radio_element_style_1.default)(RadioElement);


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var utilities_1 = __webpack_require__(9);
var react_styleable_1 = __webpack_require__(1);
var select_element_style_1 = __webpack_require__(87);
var multiple_choice_input_1 = __webpack_require__(24);
var classnames_1 = __webpack_require__(6);
__webpack_require__(285);
var error_reporting_1 = __webpack_require__(10);
var form_error_utils_1 = __webpack_require__(11);
/**
 * An exclusive-choice drop-down list
 */
var SelectElement = /** @class */ (function (_super) {
    __extends(SelectElement, _super);
    function SelectElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Updates the element to the selected option
     * @param selection the selected option from the drop-down list
     */
    SelectElement.prototype.handleInput = function (selectedValue) {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange;
        var modifiedValue = multiple_choice_input_1.handleMultipleChoiceInput(value, defaultValue, selectedValue, true, true);
        onChange(modifiedValue);
    };
    /**
     * @returns the selected item as an option in the drop-down list
     */
    SelectElement.prototype.getValueAsOption = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue, element = _a.element;
        var options = element.options;
        var selectionsList = multiple_choice_input_1.getCurrentSelection(value, defaultValue, options);
        if (!selectionsList || selectionsList.size === 0) {
            return null;
        }
        else if (selectionsList.size === 1) {
            return selectionsList.get(0);
        }
        else {
            return null;
        }
    };
    /**
         * @hidden
         * This returns a display that distinguishes a portion of text
         * @param text text that will be shown in the display
         * @param key a key to be provided to the JSX if this is used as part of a list
         */
    SelectElement.prototype.getHighlightedText = function (text, key) {
        if (key === void 0) { key = null; }
        var css = this.props.css;
        return React.createElement("span", { key: key, className: css.matchingText }, text);
    };
    /**
     * @hidden
     * This gets the JSX display that should be used as the children of an individual select option
     * @param match the string that has been entered into the select search box,
     * if the matching string is found in the option's text it should be highlighted in this display
     * @param option the string that is displayed as an option in the select
     */
    SelectElement.prototype.getStyledOption = function (match, option) {
        var segments = option.split(match);
        var styledDisplay = [];
        for (var i = 0; i < segments.length; i += 1) {
            styledDisplay.push(segments[i]);
            if (i < segments.length - 1) {
                styledDisplay.push(this.getHighlightedText(match, i.toString()));
            }
        }
        return React.createElement("div", null, styledDisplay);
    };
    SelectElement.prototype.render = function () {
        var _this = this;
        var _a = this.props, css = _a.css, defaultValue = _a.defaultValue, disableEmptyOption = _a.disableEmptyOption, element = _a.element, errors = _a.errors, _b = _a.idAddOn, idAddOn = _b === void 0 ? "" : _b, showErrors = _a.showErrors, value = _a.value;
        var ariaLabel = element.ariaLabel, autoComplete = element.autoComplete, disabled = element.disabled, hidden = element.hidden, id = element.id, isRequired = element.isRequired, label = element.label, options = element.options, readOnly = element.readOnly, tooltip = element.tooltip;
        var hasValue = value !== undefined ? !!value : defaultValue ? !!defaultValue : false;
        var _c = form_error_utils_1.getElementErrorDisplay(errors, showErrors, hasValue), displayErrors = _c.displayErrors, errorIds = _c.errorIds, hasDisplayErrors = _c.hasDisplayErrors;
        var idWithAppendedValue = id + idAddOn;
        var valueId = idWithAppendedValue + "-value";
        var labelId = idWithAppendedValue + "-select-label";
        if (hidden)
            return null;
        var selectDisplay = null;
        var currentValue = this.getValueAsOption();
        if (readOnly) {
            selectDisplay = (React.createElement("input", { "aria-describedby": errorIds + " " + valueId, "aria-invalid": hasDisplayErrors, "aria-labelledby": labelId, "aria-required": isRequired, className: css.readOnlySelect, disabled: disabled, id: idWithAppendedValue, readOnly: readOnly, type: "text", value: !!currentValue ? currentValue.label : "" }));
        }
        else {
            selectDisplay = (React.createElement("select", { "aria-describedby": errorIds + " " + valueId, "aria-invalid": hasDisplayErrors, "aria-labelledby": labelId, "aria-required": isRequired, autoComplete: autoComplete, className: css.select, disabled: disabled || readOnly, id: idWithAppendedValue, onChange: function (e) {
                    if (disabled || readOnly) {
                        return false;
                    }
                    return _this.handleInput(e.target.value);
                }, value: !!currentValue ? currentValue.value : "" },
                disableEmptyOption ? null : React.createElement("option", { className: css.dropdownOption, value: "" }, "-- Select --"),
                options && options.map(function (option) { return (React.createElement("option", { className: css.dropdownOption, key: idWithAppendedValue + "-" + option.value, value: option.value }, option.label)); })));
        }
        return (React.createElement("div", { className: classnames_1.default(css.group, { disabled: disabled }, { readOnly: readOnly }) },
            React.createElement(utilities_1.descriptors.RequiredLabel, { ariaLabel: ariaLabel, content: label, css: {
                    requiredLabel: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                    requiredIndicator: css.requiredIndicator,
                    tooltipGroup: css.labelWrapper
                }, hasErrors: hasDisplayErrors, htmlFor: idWithAppendedValue, id: labelId, isRequired: isRequired }),
            React.createElement("div", { className: css.inputWrapper },
                React.createElement("div", { className: css.tooltipGroup },
                    selectDisplay,
                    tooltip ? React.createElement(utilities_1.TooltipDisplay, { text: tooltip, context: label }) : null),
                React.createElement("div", { className: css.inlineErrorDisplay }, displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); })))));
    };
    return SelectElement;
}(React.Component));
exports.SelectElement = SelectElement;
exports.default = react_styleable_1.default(select_element_style_1.default)(SelectElement);


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var single_checkbox_input_1 = __webpack_require__(344);
exports.SingleCheckboxInput = single_checkbox_input_1.default;
var single_checkbox_input_style_1 = __webpack_require__(88);
exports.defaultStyle = single_checkbox_input_style_1.default;


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var single_checkbox_input_style_1 = __webpack_require__(88);
var classnames_1 = __webpack_require__(6);
var SingleCheckboxInput = /** @class */ (function (_super) {
    __extends(SingleCheckboxInput, _super);
    function SingleCheckboxInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SingleCheckboxInput.prototype.handleInput = function (checked) {
        var onChange = this.props.onChange;
        onChange(checked);
    };
    SingleCheckboxInput.prototype.getCurrentValue = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        return (value === undefined || value === null) ? defaultValue : value;
    };
    SingleCheckboxInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, label = _a.label, ariaLabel = _a.ariaLabel, disabled = _a.disabled, readOnly = _a.readOnly, css = _a.css;
        var currentValue = this.getCurrentValue();
        return (React.createElement("div", { id: id, className: css.inputWrapper },
            React.createElement("label", { className: classnames_1.default(css.label, { disabled: disabled }, readOnly ? css.readOnly : ''), htmlFor: id + "_input", "aria-label": ariaLabel },
                React.createElement("input", { id: id + "_input", className: classnames_1.default(css.input, readOnly ? css.readOnly : '', { disabled: disabled }), type: "checkbox", disabled: disabled, onChange: function (e) {
                        if (readOnly)
                            return false;
                        return _this.handleInput(e.target.checked);
                    }, checked: currentValue }),
                label)));
    };
    return SingleCheckboxInput;
}(React.Component));
exports.SingleCheckboxInput = SingleCheckboxInput;
exports.default = react_styleable_1.default(single_checkbox_input_style_1.default)(SingleCheckboxInput);


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var single_radio_input_1 = __webpack_require__(346);
exports.SingleRadioInput = single_radio_input_1.default;
var single_radio_input_style_1 = __webpack_require__(89);
exports.defaultStyle = single_radio_input_style_1.default;


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var single_radio_input_style_1 = __webpack_require__(89);
var classnames_1 = __webpack_require__(6);
/**
 * This component represents a single radio button,
 * rather than all the radio buttons that would make up a multiple choice question.
 **/
var SingleRadioInput = /** @class */ (function (_super) {
    __extends(SingleRadioInput, _super);
    function SingleRadioInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SingleRadioInput.prototype.handleInput = function (checked) {
        var onChange = this.props.onChange;
        onChange(checked);
    };
    SingleRadioInput.prototype.getCurrentValue = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        return (value === undefined || value === null) ? defaultValue : value;
    };
    SingleRadioInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, label = _a.label, ariaLabel = _a.ariaLabel, disabled = _a.disabled, readOnly = _a.readOnly, css = _a.css;
        var currentValue = this.getCurrentValue();
        return (React.createElement("div", { id: id, className: css.inputWrapper },
            React.createElement("label", { className: classnames_1.default(css.label, { disabled: disabled }, readOnly ? css.readOnly : ''), htmlFor: id + "_input", "aria-label": ariaLabel },
                React.createElement("input", { id: id + "_input", className: classnames_1.default(css.input, readOnly ? css.readOnly : '', { disabled: disabled }), type: "radio", disabled: disabled, onChange: function (e) {
                        if (readOnly)
                            return false;
                        return _this.handleInput(e.target.checked);
                    }, checked: currentValue }),
                label)));
    };
    return SingleRadioInput;
}(React.Component));
exports.SingleRadioInput = SingleRadioInput;
exports.default = react_styleable_1.default(single_radio_input_style_1.default)(SingleRadioInput);


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var utilities_1 = __webpack_require__(9);
var error_reporting_1 = __webpack_require__(10);
var masked_input_1 = __webpack_require__(23);
var ssg_forms_processing_1 = __webpack_require__(7);
var specialized_text_element_style_1 = __webpack_require__(91);
var text_input_1 = __webpack_require__(16);
var classnames_1 = __webpack_require__(6);
var form_error_utils_1 = __webpack_require__(11);
var SpecializedTextElement = /** @class */ (function (_super) {
    __extends(SpecializedTextElement, _super);
    function SpecializedTextElement(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentValue: "",
            inFocus: false,
            start: 0,
            end: 0,
            changeValue: '',
        };
        return _this;
    }
    /** initially sets currentValue to what is in the store */
    SpecializedTextElement.prototype.componentWillMount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var displayResponse = text_input_1.getCurrentValue(value, defaultValue);
        this.setState({ currentValue: displayResponse });
    };
    /**
     * handles updates to the value in the store (form reset or conditional rules changes)
     * @param nextProps
     * @param nextState
     */
    SpecializedTextElement.prototype.componentWillUpdate = function (nextProps, nextState) {
        var _a = this.props, prevValue = _a.value, prevDefaultValue = _a.defaultValue;
        var prevDisplayValue = text_input_1.getCurrentValue(prevValue, prevDefaultValue);
        var value = nextProps.value, defaultValue = nextProps.defaultValue;
        var displayValue = text_input_1.getCurrentValue(value, defaultValue);
        if (prevDisplayValue !== displayValue) {
            this.setState({ currentValue: displayValue });
        }
    };
    /**
     * @hidden handles changes in the selection of the special text element due to value formatting
     * @param prevProps the props before this update
     * @param prevState the state before this update
     */
    SpecializedTextElement.prototype.componentDidUpdate = function (prevProps, prevState) {
        var oldResponse = prevState.currentValue;
        var element = this.props.element;
        var currentValue = this.state.currentValue;
        var inFocus = this.state.inFocus;
        if (inFocus) {
            var oldValue = oldResponse;
            var newValue = currentValue;
            var maskChars = this.getMaskRegex();
            if (!!maskChars) {
                var newSelection = masked_input_1.handleSelection(maskChars, this.state, oldValue, newValue);
                var input = document.getElementById(element.id);
                if (input && newSelection) {
                    input.selectionStart = newSelection.start;
                    input.selectionEnd = newSelection.end;
                }
            }
        }
    };
    /** save vaule to store before the state is lost */
    SpecializedTextElement.prototype.componentWillUnmount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var currentValue = this.state.currentValue;
        var storedValue = text_input_1.getCurrentValue(value, defaultValue);
        if (currentValue !== storedValue) {
            this.saveToStore();
        }
    };
    /**
     * @hidden Changes inFocus to false; used when this component loses focus.
     * @param event focus change event
     */
    SpecializedTextElement.prototype.handleBlur = function (event) {
        event.preventDefault();
        this.saveToStore();
        this.setState({
            inFocus: false
        });
    };
    /**
     * @hidden Changes inFocus to true; used when this component gains focus.
     * @param event focus change event
     */
    SpecializedTextElement.prototype.handleFocus = function (event) {
        event.preventDefault();
        this.setState({
            inFocus: true,
        });
    };
    /**
     * saves to the store in the even thtat the form might be submitted
     * @param event
     */
    SpecializedTextElement.prototype.handleKeyDown = function (event) {
        if (event.key === "Enter" || event.keyCode === 13) {
            this.saveToStore();
        }
    };
    /** returns the regular expression that should be used to identify characters that aren't allowed */
    SpecializedTextElement.prototype.getMaskRegex = function () {
        var element = this.props.element;
        var textType = element.textType;
        switch (textType) {
            case ssg_forms_processing_1.formDefinition.specialTextTypes.ALPHA:
                return /[^a-zA-Z]/g;
            case ssg_forms_processing_1.formDefinition.specialTextTypes.ALPHA_NUMERIC:
                return /[^A-Za-z0-9_]/g;
            case ssg_forms_processing_1.formDefinition.specialTextTypes.NUMERIC:
                return /[^0-9]/g;
            case ssg_forms_processing_1.formDefinition.specialTextTypes.ANY:
            default:
                return null;
        }
    };
    /**
     * @hidden Handles user input for specialized text. Prevents entry of invalid characters
     * @param event change event
     */
    SpecializedTextElement.prototype.handleInput = function (event) {
        var targetValue = event.target.value;
        // verify not exceeding length or allowed characters
        var maskChars = this.getMaskRegex();
        if (!!maskChars && maskChars.test(targetValue)) {
            this.setState({
                start: event.target.selectionStart - 1,
                end: event.target.selectionEnd - 1,
                changeValue: event.target.value,
            });
            return;
        }
        this.setState({
            start: event.target.selectionStart,
            end: event.target.selectionEnd,
            changeValue: event.target.value,
            currentValue: targetValue
        });
    };
    /** calls the onChange function to update the store with the currentValue */
    SpecializedTextElement.prototype.saveToStore = function () {
        var onChange = this.props.onChange;
        var currentValue = this.state.currentValue;
        onChange && onChange(currentValue);
    };
    SpecializedTextElement.prototype.render = function () {
        var _this = this;
        var _a = this.props, element = _a.element, css = _a.css, showErrors = _a.showErrors, errors = _a.errors;
        var currentValue = this.state.currentValue;
        var isRequired = element.isRequired, label = element.label, ariaLabel = element.ariaLabel, id = element.id, disabled = element.disabled, maxCharLength = element.maxCharLength, readOnly = element.readOnly, tooltip = element.tooltip, autoComplete = element.autoComplete, isPassword = element.isPassword;
        var inFocus = this.state.inFocus;
        var displayResponse = currentValue;
        var maxLengthId = id + '-maxLength';
        var inlineDisplay = form_error_utils_1.getElementErrorDisplay(errors, showErrors, !!displayResponse && displayResponse !== "" && !inFocus);
        return (React.createElement("div", { className: css.group },
            React.createElement(utilities_1.descriptors.RequiredLabel, { hasErrors: inlineDisplay.hasDisplayErrors, htmlFor: id, content: label, ariaLabel: ariaLabel, isRequired: isRequired, css: {
                    requiredLabel: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                    requiredIndicator: css.requiredIndicator,
                    tooltipGroup: css.labelWrapper,
                } }),
            React.createElement("div", { className: css.inputWrapper },
                React.createElement("div", { className: css.tooltipGroup },
                    React.createElement("input", { type: isPassword ? "password" : "text", className: classnames_1.default(css.text, { 'input-error': inlineDisplay.hasDisplayErrors }), id: id, maxLength: maxCharLength, onChange: function (e) {
                            if (readOnly)
                                return false;
                            _this.handleInput(e);
                        }, onBlur: function (e) { return _this.handleBlur(e); }, onFocus: function (e) { return _this.handleFocus(e); }, onKeyDown: function (e) { return _this.handleKeyDown(e); }, disabled: disabled, value: displayResponse, autoComplete: autoComplete, "aria-required": isRequired, "aria-invalid": inlineDisplay.hasDisplayErrors, "aria-describedby": inlineDisplay.errorIds + ' ' + maxLengthId, readOnly: readOnly }),
                    tooltip ? React.createElement(utilities_1.TooltipDisplay, { text: tooltip, context: label }) : null),
                React.createElement("div", { className: css.inlineErrorDisplay }, inlineDisplay.displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); })))));
    };
    return SpecializedTextElement;
}(React.Component));
exports.SpecializedTextElement = SpecializedTextElement;
exports.default = react_styleable_1.default(specialized_text_element_style_1.default)(SpecializedTextElement);


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var spin_button_input_1 = __webpack_require__(350);
exports.SpinButtonInput = spin_button_input_1.default;
var time_ranges_1 = __webpack_require__(351);
exports.militaryHourRange = time_ranges_1.militaryHourRange;
exports.standardHourRange = time_ranges_1.standardHourRange;
exports.minuteRange = time_ranges_1.minuteRange;
exports.getTimeFormattedString = time_ranges_1.getTimeFormattedString;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var defaultStyle = {
    input: 'ssg-forms-input'
};
exports.default = defaultStyle;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var spin_button_input_style_1 = __webpack_require__(349);
/**
 * An input display that allows the user to "spin" between a range of values using the
 * up and down arrows.
 */
var SpinButtonInput = /** @class */ (function (_super) {
    __extends(SpinButtonInput, _super);
    function SpinButtonInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** @hidden returns the sorted range */
    SpinButtonInput.prototype.getOrderedRange = function () {
        var range = this.props.range;
        return range.sort(function (val1, val2) { return val1.value - val2.value; });
    };
    /**
     * Handles the use of the spin controls (Up/Down) arrows.
     * If the spin controls are used onSpin will be called, but onChange will not.
     * @param event keyboard event
     */
    SpinButtonInput.prototype.handleKeyDown = function (event) {
        var _a = this.props, value = _a.value, wrap = _a.wrap, onKeyDown = _a.onKeyDown, onSpin = _a.onSpin;
        var range = this.getOrderedRange();
        var validRange = range.filter(function (val) { return !val.ignore; });
        if (validRange.length > 0) {
            var valueIndex = value === undefined ? -1 : validRange.findIndex(function (val) { return val.value === value; });
            if (event.key === "ArrowUp" || event.keyCode === 38) {
                event.preventDefault();
                if (valueIndex === validRange.length - 1) {
                    if (wrap) {
                        onSpin && onSpin(event, validRange[0]);
                    }
                }
                else if (valueIndex >= 0) {
                    onSpin && onSpin(event, validRange[valueIndex + 1]);
                }
                else {
                    onSpin && onSpin(event, validRange[0]);
                }
            }
            else if (event.key === "ArrowDown" || event.keyCode === 40) {
                event.preventDefault();
                if (valueIndex === 0) {
                    if (wrap) {
                        onSpin && onSpin(event, validRange[validRange.length - 1]);
                    }
                }
                else if (valueIndex >= 1) {
                    onSpin && onSpin(event, validRange[valueIndex - 1]);
                }
                else {
                    onSpin && onSpin(event, validRange[validRange.length - 1]);
                }
            }
        }
        onKeyDown && onKeyDown(event);
    };
    /** @hidden renders the input */
    SpinButtonInput.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, value = _a.value, requried = _a.requried, disabled = _a.disabled, readonly = _a.readonly, placeholder = _a.placeholder, ariaLabel = _a.ariaLabel, ariaInvalid = _a.ariaInvalid, ariaDescribedBy = _a.ariaDescribedBy, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, css = _a.css;
        var range = this.getOrderedRange();
        var validRange = range.filter(function (val) { return !val.ignore; });
        if (range.length < 1)
            return null;
        var min = validRange.length > 0 ? validRange[0].value : undefined;
        var max = validRange.length > 0 ? validRange[validRange.length - 1].value : undefined;
        var spinValue = value !== undefined ? range.find(function (val) { return val.value === value; }) : undefined;
        return (React.createElement("input", { id: id, type: "text", role: "spinbutton", className: css.input, required: requried, disabled: disabled, readOnly: readonly, value: spinValue ? spinValue.label : value ? value : "", placeholder: !readonly && !disabled ? placeholder : "", min: min, max: max, "aria-valuemin": min, "aria-valuemax": max, "aria-valuenow": value, "aria-label": ariaLabel, "aria-invalid": ariaInvalid, "aria-describedby": ariaDescribedBy, onChange: function (e) { return onChange && onChange(e); }, onKeyDown: function (e) { return _this.handleKeyDown(e); }, onBlur: function (e) { return onBlur && onBlur(e); }, onFocus: function (e) { return onFocus && onFocus(e); } }));
    };
    return SpinButtonInput;
}(React.Component));
exports.SpinButtonInput = SpinButtonInput;
exports.default = react_styleable_1.default(spin_button_input_style_1.default)(SpinButtonInput);


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Converts a number into a valid string representation of a time.
 * @param number the number to be converted into a formatted string
 */
function getTimeFormattedString(number) {
    if (number < 10)
        return '0' + number;
    else
        return number.toString().substr(0, 2);
}
exports.getTimeFormattedString = getTimeFormattedString;
/**
 * Adds a list of spin values with time formatted strings for the label and a the unformatted number as the value.
 * @param start starting number of range
 * @param end ending number of range (should be larger than start)
 */
function getSpinRange(start, end) {
    var array = [];
    for (var i = start; i <= end; i++) {
        array.push({
            label: getTimeFormattedString(i),
            value: i
        });
    }
    return array;
}
/** the range of valid inputs for a 24hr clock's hours section */
exports.militaryHourRange = getSpinRange(0, 23);
/** the range of valid inputs for a 12hr clock's hours section */
exports.standardHourRange = getSpinRange(1, 12).concat({ label: "00", value: 0, ignore: true });
/** the range of valid inputs for the minute section of a clock */
exports.minuteRange = getSpinRange(0, 59);


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var immutable_1 = __webpack_require__(2);
var utilities_1 = __webpack_require__(9);
var react_styleable_1 = __webpack_require__(1);
var text_area_element_style_1 = __webpack_require__(93);
var text_input_1 = __webpack_require__(16);
var ssg_forms_processing_1 = __webpack_require__(7);
var classnames_1 = __webpack_require__(6);
var error_reporting_1 = __webpack_require__(10);
var form_error_utils_1 = __webpack_require__(11);
// Build the text for the character countdown label.
var characterCountText = function (characterCount) { return characterCount + " character" + (Math.abs(characterCount) !== 1 ? "s" : "") + " remaining"; };
var wordCountText = function (wordCount) { return wordCount + " word" + (Math.abs(wordCount) !== 1 ? "s" : "") + " remaining"; };
var TextAreaElement = /** @class */ (function (_super) {
    __extends(TextAreaElement, _super);
    function TextAreaElement(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentValue: "",
        };
        return _this;
    }
    /** initially sets currentValue to what is in the store */
    TextAreaElement.prototype.componentWillMount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var displayResponse = text_input_1.getCurrentValue(value, defaultValue);
        this.setState({ currentValue: displayResponse });
    };
    /**
     * handles updates to the value in the store (form reset or conditional rules changes)
     * @param nextProps
     * @param nextState
     */
    TextAreaElement.prototype.componentWillUpdate = function (nextProps, nextState) {
        var _a = this.props, prevValue = _a.value, prevDefaultValue = _a.defaultValue;
        var prevDisplayValue = text_input_1.getCurrentValue(prevValue, prevDefaultValue);
        var value = nextProps.value, defaultValue = nextProps.defaultValue;
        var displayValue = text_input_1.getCurrentValue(value, defaultValue);
        if (prevDisplayValue !== displayValue) {
            this.setState({ currentValue: displayValue });
        }
    };
    /** save vaule to store before the state is lost */
    TextAreaElement.prototype.componentWillUnmount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var currentValue = this.state.currentValue;
        var storedValue = text_input_1.getCurrentValue(value, defaultValue);
        if (currentValue !== storedValue) {
            this.saveToStore();
        }
    };
    /**
     * changes the currentValue in the state
     * @param event
     */
    TextAreaElement.prototype.handleOnChange = function (event) {
        var currentValue = this.state.currentValue;
        if (event.target.value !== currentValue) {
            this.setState({ currentValue: event.target.value });
        }
    };
    /**
     * when moving on to another element, persist the local state changes to the store
     * @param event
     */
    TextAreaElement.prototype.handleBlur = function (event) {
        this.saveToStore();
    };
    /** calls the onChange function to update the store with the currentValue */
    TextAreaElement.prototype.saveToStore = function () {
        var onChange = this.props.onChange;
        var currentValue = this.state.currentValue;
        onChange && onChange(currentValue);
    };
    TextAreaElement.prototype.render = function () {
        var _this = this;
        var _a = this.props, element = _a.element, onChange = _a.onChange, showErrors = _a.showErrors, errors = _a.errors, rows = _a.rows, css = _a.css;
        var currentValue = this.state.currentValue;
        var id = element.id, maxCharLength = element.maxCharLength, wordLimit = element.wordLimit, isRequired = element.isRequired, hidden = element.hidden, label = element.label, ariaLabel = element.ariaLabel, disabled = element.disabled, readOnly = element.readOnly, tooltip = element.tooltip, autoComplete = element.autoComplete, placeholder = element.placeholder;
        var maxLengthId = id + '-maxCharLength';
        var wordLimitId = id + '-wordLimit';
        var inlineDisplay = form_error_utils_1.getElementErrorDisplay(errors, showErrors, !!currentValue);
        // use 0 if response is null, otherwise use the actual length of the response
        var currentLength = currentValue ? currentValue.length : 0;
        var charsRemaining = maxCharLength - currentLength;
        var charCountdownClass = currentLength > maxCharLength
            ? css.countdownInvalid : css.countdownValid;
        var wordCount = ssg_forms_processing_1.utilities.textUtilities.getWordCount(currentValue);
        var wordsRemaining = wordLimit - wordCount;
        var wordCountdownClass = wordCount > wordLimit
            ? css.countdownInvalid : css.countdownValid;
        if (hidden)
            return null;
        var textDisplay = readOnly ? (React.createElement("p", { id: id, tabIndex: 0, className: classnames_1.default(css.textarea, { disabled: disabled }, { readonly: readOnly }), role: "textbox", "aria-label": label, "aria-required": isRequired, "aria-invalid": inlineDisplay.hasDisplayErrors, "aria-describedby": inlineDisplay.errorIds + ' ' + maxLengthId + ' ' + wordLimitId, "aria-multiline": "true", "aria-readonly": "true" }, currentValue)) : (React.createElement("textarea", { id: id, maxLength: maxCharLength, rows: rows, onChange: function (e) { return _this.handleOnChange(e); }, onBlur: function (e) { return _this.handleBlur(e); }, disabled: disabled, value: currentValue, autoComplete: autoComplete, className: inlineDisplay.hasDisplayErrors ? css.textareaError : css.textarea, "aria-required": isRequired, "aria-invalid": inlineDisplay.hasDisplayErrors, "aria-describedby": inlineDisplay.errorIds + ' ' + maxLengthId + ' ' + wordLimitId, readOnly: readOnly, placeholder: placeholder }));
        // The text element has the following parts, from top to bottom:
        // - Question Text
        // - Multiline Text Area
        // - Character countdown text (example:  "19 characters remaining")
        return (React.createElement("div", { className: css.group },
            React.createElement(utilities_1.descriptors.RequiredLabel, { hasErrors: inlineDisplay.hasDisplayErrors, htmlFor: id, content: label, ariaLabel: ariaLabel, isRequired: isRequired, css: {
                    requiredLabel: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                    requiredIndicator: css.requiredIndicator,
                    tooltipGroup: css.labelWrapper,
                } }),
            React.createElement("div", { className: css.inputWrapper },
                React.createElement("div", { className: css.tooltipGroup },
                    textDisplay,
                    tooltip ? React.createElement(utilities_1.TooltipDisplay, { text: tooltip, context: label }) : null),
                readOnly ? null :
                    React.createElement("div", null,
                        React.createElement("span", { id: maxLengthId, className: "ssg-forms-skip" }, maxCharLength ? maxCharLength + ' characters max' : ''),
                        React.createElement("span", { id: wordLimitId, className: "ssg-forms-skip" }, wordLimit ? wordLimit + ' words max' : ''),
                        maxCharLength ? React.createElement("label", { id: 'char-length', "aria-hidden": 'true', className: classnames_1.default(charCountdownClass, { disabled: disabled }) }, characterCountText(charsRemaining)) : null,
                        wordLimit ? React.createElement("label", { id: 'word-length', "aria-hidden": 'true', className: classnames_1.default(wordCountdownClass, { disabled: disabled }) }, wordCountText(wordsRemaining)) : null)),
            React.createElement("div", { className: css.inlineErrorDisplay }, inlineDisplay.displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); }))));
    };
    TextAreaElement.defaultProps = {
        rows: 6,
        errors: immutable_1.List([]),
        readOnly: false,
        showErrors: false,
    };
    return TextAreaElement;
}(React.Component));
exports.TextAreaElement = TextAreaElement;
exports.default = react_styleable_1.default(text_area_element_style_1.default)(TextAreaElement);


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var utilities_1 = __webpack_require__(9);
var react_styleable_1 = __webpack_require__(1);
var text_element_style_1 = __webpack_require__(95);
var text_input_1 = __webpack_require__(16);
var classnames_1 = __webpack_require__(6);
var error_reporting_1 = __webpack_require__(10);
var form_error_utils_1 = __webpack_require__(11);
var TextElement = /** @class */ (function (_super) {
    __extends(TextElement, _super);
    function TextElement(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentValue: "",
        };
        return _this;
    }
    /** initially sets currentValue to what is in the store */
    TextElement.prototype.componentWillMount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var displayResponse = text_input_1.getCurrentValue(value, defaultValue);
        this.setState({ currentValue: displayResponse });
    };
    /**
     * handles updates to the value in the store (form reset or conditional rules changes)
     * @param nextProps
     * @param nextState
     */
    TextElement.prototype.componentWillUpdate = function (nextProps, nextState) {
        var _a = this.props, prevValue = _a.value, prevDefaultValue = _a.defaultValue;
        var prevDisplayValue = text_input_1.getCurrentValue(prevValue, prevDefaultValue);
        var value = nextProps.value, defaultValue = nextProps.defaultValue;
        var displayValue = text_input_1.getCurrentValue(value, defaultValue);
        if (prevDisplayValue !== displayValue) {
            this.setState({ currentValue: displayValue });
        }
    };
    /** save vaule to store before the state is lost */
    TextElement.prototype.componentWillUnmount = function () {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var currentValue = this.state.currentValue;
        var storedValue = text_input_1.getCurrentValue(value, defaultValue);
        if (currentValue !== storedValue) {
            this.saveToStore();
        }
    };
    /**
     * changes the currentValue in the state
     * @param event
     */
    TextElement.prototype.handleOnChange = function (event) {
        var _a = this.props, onChange = _a.onChange, updateInPlace = _a.updateInPlace;
        var currentValue = this.state.currentValue;
        if (event.target.value !== currentValue) {
            this.setState({ currentValue: event.target.value });
            if (updateInPlace) {
                onChange && onChange(event.target.value);
            }
        }
    };
    /**
     * saves to the store in the even thtat the form might be submitted
     * @param event
     */
    TextElement.prototype.handleKeyDown = function (event) {
        if (event.key === "Enter" || event.keyCode === 13) {
            this.saveToStore();
        }
    };
    /**
     * when moving on to another element, persist the local state changes to the store
     * @param event
     */
    TextElement.prototype.handleBlur = function (event) {
        this.saveToStore();
    };
    /** calls the onChange function to update the store with the currentValue */
    TextElement.prototype.saveToStore = function () {
        var onChange = this.props.onChange;
        var currentValue = this.state.currentValue;
        onChange && onChange(currentValue);
    };
    TextElement.prototype.render = function () {
        var _this = this;
        var _a = this.props, element = _a.element, css = _a.css, showErrors = _a.showErrors, errors = _a.errors, _b = _a.idAddOn, idAddOn = _b === void 0 ? "" : _b;
        var currentValue = this.state.currentValue;
        var ariaLabel = element.ariaLabel, autoComplete = element.autoComplete, disabled = element.disabled, id = element.id, isRequired = element.isRequired, label = element.label, maxCharLength = element.maxCharLength, placeholder = element.placeholder, readOnly = element.readOnly, subText = element.subText, tooltip = element.tooltip;
        var idWithAppendedValue = id + idAddOn;
        var _c = form_error_utils_1.getElementErrorDisplay(errors, showErrors, !!currentValue), displayErrors = _c.displayErrors, errorIds = _c.errorIds, hasDisplayErrors = _c.hasDisplayErrors;
        var maxLengthId = idWithAppendedValue + '-maxLength';
        // The text element has the following parts, from top to bottom:
        // - Field Label
        // - Single-line text input
        // - SubText - the text directly below the text input
        return (React.createElement("div", { className: css.group },
            React.createElement(utilities_1.descriptors.RequiredLabel, { ariaLabel: ariaLabel, content: label, css: {
                    requiredLabel: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                    requiredIndicator: css.requiredIndicator,
                    tooltipGroup: css.labelWrapper,
                }, hasErrors: hasDisplayErrors, htmlFor: idWithAppendedValue, isRequired: isRequired }),
            React.createElement("div", { className: css.inputWrapper },
                React.createElement("div", { className: css.tooltipGroup },
                    React.createElement("input", { className: hasDisplayErrors ? css.textError : css.text, id: idWithAppendedValue, maxLength: maxCharLength, type: "text", "aria-describedby": errorIds + ' ' + maxLengthId, "aria-invalid": hasDisplayErrors, "aria-required": isRequired, autoComplete: autoComplete, disabled: disabled, onBlur: function (e) { return _this.handleBlur(e); }, onChange: function (e) {
                            if (readOnly)
                                return false;
                            _this.handleOnChange(e);
                        }, onKeyDown: function (e) { return _this.handleKeyDown(e); }, placeholder: placeholder, readOnly: readOnly, value: currentValue }),
                    tooltip ? React.createElement(utilities_1.TooltipDisplay, { text: tooltip, context: label }) : null)),
            !subText ? null :
                React.createElement("label", { "aria-hidden": 'true', className: css.subText + (disabled ? (' ' + css.disabled) : ''), "aria-label": subText }, subText),
            React.createElement("div", { className: css.inlineErrorDisplay }, displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); }))));
    };
    return TextElement;
}(React.Component));
exports.TextElement = TextElement;
exports.default = react_styleable_1.default(text_element_style_1.default)(TextElement);


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.sections = {
    hour: 'hour',
    minute: 'minute',
    period: 'period',
};
/**
 * @hidden this function allows us to have a type safe way of accessing the ids of the various parts of the display
 * @param id id of the display
 * @returns the ids that should be used for sub elements, given the primary id
 */
function htmlElementIds(id) {
    return {
        input: id + "-input",
        hour: id + "-hour",
        minute: id + "-minute",
        period: id + "-period",
    };
}
exports.htmlElementIds = htmlElementIds;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var error_reporting_1 = __webpack_require__(10);
var utilities_1 = __webpack_require__(9);
var time_element_style_1 = __webpack_require__(97);
var ssg_forms_processing_1 = __webpack_require__(7);
var classnames_1 = __webpack_require__(6);
var multi_section_input_1 = __webpack_require__(75);
var spin_button_input_1 = __webpack_require__(348);
var time_element_constants_1 = __webpack_require__(354);
var form_error_utils_1 = __webpack_require__(11);
/**
 * This element renders an input that allows the user to input a particular time of day.
 * It can be configured to support a 12hr or 24hr clock.
 */
var TimeElement = /** @class */ (function (_super) {
    __extends(TimeElement, _super);
    function TimeElement(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            inFocus: false
        };
        return _this;
    }
    /** @hidden initializes the period value of the element */
    TimeElement.prototype.componentWillMount = function () {
        var element = this.props.element;
        var isMilitaryTime = element.isMilitaryTime;
        var periodValue = this.getValue(time_element_constants_1.sections.period);
        var editable = !element.readOnly && !element.disabled;
        if (!isMilitaryTime && !periodValue && editable) {
            this.changeValue(ssg_forms_processing_1.formDefinition.timePeriod.AM, time_element_constants_1.sections.period);
        }
    };
    /** @hidden add the event listener to allow for navigation between sub elements using right and left arrows */
    TimeElement.prototype.componentDidMount = function () {
        var element = this.props.element;
        var id = element.id;
        var input = document.getElementById(time_element_constants_1.htmlElementIds(id).input);
        input && input.addEventListener('keydown', function (event) { return utilities_1.subElementNavigation(input, event); });
    };
    /** @hidden remove the event listener when the component is unmounted */
    TimeElement.prototype.componentDidUnMount = function () {
        var element = this.props.element;
        var id = element.id;
        var input = document.getElementById(time_element_constants_1.htmlElementIds(id).input);
        input && input.removeEventListener('keydown', function (event) { return utilities_1.subElementNavigation(input, event); });
    };
    /** @hidden initializing the component with a default period value, if the props change */
    TimeElement.prototype.componentDidUpdate = function () {
        var element = this.props.element;
        var isMilitaryTime = element.isMilitaryTime;
        var periodValue = this.getValue(time_element_constants_1.sections.period);
        var editable = !element.readOnly && !element.disabled;
        if (!isMilitaryTime && !periodValue && editable) {
            this.changeValue(ssg_forms_processing_1.formDefinition.timePeriod.AM, time_element_constants_1.sections.period);
        }
    };
    /**
     * @hidden changes the status of inFocus to false
     * @param event focus change event
     */
    TimeElement.prototype.handleBlur = function (event) {
        this.setState({
            inFocus: false
        });
    };
    /**
     * @hidden changes the status of inFocus to true,
     * selects the input that was focused
     * @param event focus change event
     */
    TimeElement.prototype.handleFocus = function (event) {
        this.setState({
            inFocus: true
        });
        event.target.select();
    };
    /**
     * Handles changes to the period spinner.
     * Only accepts "a" and "p" as text input, and will change to AM or PM respectively.
     * @param event input change event
     */
    TimeElement.prototype.handlePeriodInput = function (event) {
        var verifiedValue = event.target.value;
        verifiedValue = verifiedValue.replace(/[^\bAaPp]/g, '');
        var lastChar = verifiedValue.charAt(verifiedValue.length - 1);
        if (lastChar === "A" || lastChar === "a") {
            verifiedValue = ssg_forms_processing_1.formDefinition.timePeriod.AM;
        }
        else if (lastChar === "P" || lastChar === "p") {
            verifiedValue = ssg_forms_processing_1.formDefinition.timePeriod.PM;
        }
        else {
            return;
        }
        this.changeValue(verifiedValue, time_element_constants_1.sections.period);
    };
    /**
     * Handles input to the hour or minute spinners.
     * Only accepts numbers as input.
     * Will automatically navigate to the next input when a valid time has been entered.
     * @param event the input change event
     * @param section the section being updated (hours or minutes)
     */
    TimeElement.prototype.handleNumberInput = function (event, section) {
        var _a = this.props, element = _a.element, value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange;
        var id = element.id, isMilitaryTime = element.isMilitaryTime;
        var ids = time_element_constants_1.htmlElementIds(id);
        var eventValue = event.target.value;
        var verifiedValue = eventValue;
        var min = parseInt(event.target.min, 10);
        var max = parseInt(event.target.max, 10);
        verifiedValue = eventValue.replace(/[^0-9]/g, '');
        // if the value is empty we should clear the value
        if (!verifiedValue) {
            this.changeValue(verifiedValue, section);
            return;
        }
        var numberValue = parseInt(verifiedValue, 10);
        var autoTabThreshold = section === time_element_constants_1.sections.hour ? isMilitaryTime ? 2 : 1 : 5;
        if (numberValue > autoTabThreshold || verifiedValue.length > 1) {
            var validTime = numberValue <= max && numberValue >= min;
            if (!validTime)
                return;
            var focusTarget = document.getElementById(section === time_element_constants_1.sections.hour ? (ids.minute) : (ids.period));
            focusTarget && focusTarget.focus();
        }
        verifiedValue = spin_button_input_1.getTimeFormattedString(numberValue);
        this.changeValue(verifiedValue, section);
    };
    /**
     * Clears out the whole section when pressing backspace on the hour or minute sections
     * @param event keyboard event
     * @param section section that is selected when this input occurs
     */
    TimeElement.prototype.handleKeyDown = function (event, section) {
        var _a = this.props, element = _a.element, value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange;
        var id = element.id;
        if ((event.key === "Backspace" || event.keyCode === 8) && (section === time_element_constants_1.sections.hour || section === time_element_constants_1.sections.minute)) {
            event.preventDefault();
            var returnValue = multi_section_input_1.handleInput(value, defaultValue, "", section);
            onChange(new ssg_forms_processing_1.formDefinition.TimeResponseState(returnValue));
            return;
        }
    };
    /**
     * @hidden changes the value of a section and calls the onChange function
     * @param newValue the new value for the section
     * @param section the section to update
     */
    TimeElement.prototype.changeValue = function (newValue, section) {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange;
        var returnValue = multi_section_input_1.handleInput(value, defaultValue, newValue, section);
        onChange(new ssg_forms_processing_1.formDefinition.TimeResponseState(returnValue));
    };
    /**
     * @hidden returns the value of a particular section of the response
     * @param section the section, who's value will be returned
     * @returns the string value of the given section
     */
    TimeElement.prototype.getValue = function (section) {
        var _a = this.props, value = _a.value, defaultValue = _a.defaultValue;
        var currentValue = multi_section_input_1.getSectionValue(value, defaultValue, section);
        return currentValue;
    };
    /** @hidden renders the component */
    TimeElement.prototype.render = function () {
        var _this = this;
        var _a = this.props, element = _a.element, errors = _a.errors, value = _a.value, showErrors = _a.showErrors, css = _a.css;
        var isRequired = element.isRequired, hidden = element.hidden, label = element.label, ariaLabel = element.ariaLabel, id = element.id, type = element.type, disabled = element.disabled, readOnly = element.readOnly, isMilitaryTime = element.isMilitaryTime, tooltip = element.tooltip;
        var inFocus = this.state.inFocus;
        var ids = time_element_constants_1.htmlElementIds(id);
        if (hidden)
            return null;
        var inlineDisplay = form_error_utils_1.getElementErrorDisplay(errors, showErrors, !!value && !inFocus);
        var hourValue = this.getValue(time_element_constants_1.sections.hour);
        var hourNum = hourValue && parseInt(hourValue, 10);
        var minuteValue = this.getValue(time_element_constants_1.sections.minute);
        var minuteNum = minuteValue && parseInt(minuteValue, 10);
        var periodValue = this.getValue(time_element_constants_1.sections.period);
        var periodNum = periodValue && periodValue === ssg_forms_processing_1.formDefinition.timePeriod.AM ? 0 : 1;
        var timeValue = hourValue || minuteValue || periodValue ? hourValue + ':' + minuteValue + periodValue.toLowerCase() : undefined;
        var display = readOnly ? (React.createElement("p", { id: id, tabIndex: 0, className: classnames_1.default(css.input, { disabled: disabled }, { readonly: readOnly }), role: "textbox", "aria-required": isRequired, "aria-invalid": inlineDisplay.hasDisplayErrors, "aria-describedby": inlineDisplay.errorIds, "aria-readonly": "true" }, timeValue)) : (React.createElement("div", { id: ids.input, className: classnames_1.default(inlineDisplay.hasDisplayErrors ? css.inputGroupError : css.inputGroup, { focus: inFocus }, { disabled: disabled }, { readonly: readOnly }) },
            React.createElement(spin_button_input_1.SpinButtonInput, { id: ids.hour, value: hourNum, range: isMilitaryTime ? spin_button_input_1.militaryHourRange : spin_button_input_1.standardHourRange, wrap: true, required: isRequired, disabled: disabled, readOnly: readOnly, placeholder: "--", ariaLabel: 'hours', ariaInvalid: inlineDisplay.hasDisplayErrors, ariaDescribedBy: inlineDisplay.errorIds, onSpin: function (e, val) { return _this.changeValue(val.label, time_element_constants_1.sections.hour); }, onChange: function (e) { return _this.handleNumberInput(e, time_element_constants_1.sections.hour); }, onKeyDown: function (e) { return _this.handleKeyDown(e, time_element_constants_1.sections.hour); }, onBlur: function (e) { return _this.handleBlur(e); }, onFocus: function (e) { return _this.handleFocus(e); }, css: { input: css.section } }),
            React.createElement("span", { className: css.displayText }, ":"),
            React.createElement(spin_button_input_1.SpinButtonInput, { id: ids.minute, value: minuteNum, range: spin_button_input_1.minuteRange, wrap: true, required: isRequired, disabled: disabled, readOnly: readOnly, placeholder: "--", ariaLabel: 'minutes', ariaInvalid: inlineDisplay.hasDisplayErrors, ariaDescribedBy: inlineDisplay.errorIds, onSpin: function (e, val) { return _this.changeValue(val.label, time_element_constants_1.sections.minute); }, onChange: function (e) { return _this.handleNumberInput(e, time_element_constants_1.sections.minute); }, onKeyDown: function (e) { return _this.handleKeyDown(e, time_element_constants_1.sections.minute); }, onBlur: function (e) { return _this.handleBlur(e); }, onFocus: function (e) { return _this.handleFocus(e); }, css: { input: css.section } }),
            isMilitaryTime ? null : (React.createElement(spin_button_input_1.SpinButtonInput, { id: ids.period, value: periodNum, range: [
                    { label: ssg_forms_processing_1.formDefinition.timePeriod.AM, value: 0 },
                    { label: ssg_forms_processing_1.formDefinition.timePeriod.PM, value: 1 },
                ], wrap: true, required: isRequired, disabled: disabled, readOnly: readOnly, placeholder: "--", ariaLabel: 'period', ariaInvalid: inlineDisplay.hasDisplayErrors, ariaDescribedBy: inlineDisplay.errorIds, onSpin: function (e, val) { return _this.changeValue(val.label, time_element_constants_1.sections.period); }, onChange: function (e) { return _this.handlePeriodInput(e); }, onBlur: function (e) { return _this.handleBlur(e); }, onFocus: function (e) { return _this.handleFocus(e); }, css: { input: css.periodSection } }))));
        return (React.createElement("fieldset", { id: id, role: "group", className: css.group + ' validated-section', "aria-invalid": inlineDisplay.hasDisplayErrors, "aria-describedby": inlineDisplay.errorIds },
            React.createElement(utilities_1.descriptors.RequiredLegend, { hasErrors: inlineDisplay.hasDisplayErrors, content: label, ariaLabel: ariaLabel, isRequired: isRequired, css: {
                    requiredLegend: classnames_1.default(css.label, { disabled: disabled }, { readonly: readOnly }),
                    requiredIndicator: css.requiredIndicator,
                    tooltipGroup: css.labelWrapper,
                } }),
            React.createElement("div", { className: css.inputWrapper },
                React.createElement("div", { className: css.tooltipGroup },
                    display,
                    tooltip ? React.createElement(utilities_1.TooltipDisplay, { text: tooltip, context: label }) : null),
                React.createElement("div", { className: css.inlineErrorDisplay }, inlineDisplay.displayErrors.map(function (warn) { return (React.createElement(error_reporting_1.InlineWarning, { key: warn.id, warning: warn })); })))));
    };
    return TimeElement;
}(React.Component));
exports.TimeElement = TimeElement;
exports.default = react_styleable_1.default(time_element_style_1.default)(TimeElement);


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var immutable_1 = __webpack_require__(2);
var redux_1 = __webpack_require__(490);
var react_redux_1 = __webpack_require__(488);
var react_google_recaptcha_1 = __webpack_require__(487);
var react_styleable_1 = __webpack_require__(1);
var classnames_1 = __webpack_require__(6);
var ssg_form_component_style_1 = __webpack_require__(99);
var formElements = __webpack_require__(20);
var ssg_form_actions_1 = __webpack_require__(31);
var ssg_forms_processing_1 = __webpack_require__(7);
var number_utilities_1 = __webpack_require__(48);
var utilities_1 = __webpack_require__(9);
var descriptors_1 = __webpack_require__(19);
var form_validation_control_1 = __webpack_require__(314);
var error_reporting_1 = __webpack_require__(10);
var ssg_form_position_1 = __webpack_require__(100);
var form_definition_1 = __webpack_require__(17);
/** React component for rendering forms */
var SsgFormComponent = /** @class */ (function (_super) {
    __extends(SsgFormComponent, _super);
    function SsgFormComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            changeMade: false
        };
        return _this;
    }
    SsgFormComponent.prototype.componentWillMount = function () {
        var ssgFormActions = this.props.ssgFormActions;
        var uniqueId = this.getId(this.props);
        this.initializeState(this.props);
        ssgFormActions.updateShowValidation(uniqueId, false);
    };
    SsgFormComponent.prototype.componentDidMount = function () {
        this.captcha && this.captcha.reset();
    };
    SsgFormComponent.prototype.componentWillUpdate = function (nextProps, nextState) {
        var _a = this.props, id = _a.id, defaultValue = _a.defaultValue, defaultSelectedPrograms = _a.defaultSelectedPrograms, allPrograms = _a.allPrograms, ssgForms = _a.ssgForms;
        var nextId = nextProps.id, nextform = nextProps.form, nextDefaultValues = nextProps.defaultValue, nextDefaultPrograms = nextProps.defaultSelectedPrograms, nextAllPrograms = nextProps.allPrograms, onChange = nextProps.onChange;
        var uniqueId = this.getId(this.props);
        var forms = ssgForms.forms;
        var formState = forms && forms.get(uniqueId);
        var convertedForm = formState ? formState.form : new ssg_forms_processing_1.formDefinition.Form({});
        var convertedNewForm = ssg_forms_processing_1.adapters.convertJsonForm(nextform);
        var defaultValuesChanged = (!!defaultValue && !nextDefaultValues) ||
            (!!nextDefaultValues && !defaultValue) ||
            (!!defaultValue && !!nextDefaultValues && !defaultValue.equals(nextDefaultValues));
        var convertedAllPrograms = allPrograms ? immutable_1.List(allPrograms.map(function (program) { return new ssg_forms_processing_1.formDefinition.Program(program); })) : immutable_1.List([]);
        var convertedNextAllPrograms = nextAllPrograms ? immutable_1.List(nextAllPrograms.map(function (program) { return new ssg_forms_processing_1.formDefinition.Program(program); })) : immutable_1.List([]);
        var convertedDefaultPrograms = defaultSelectedPrograms ? immutable_1.List(defaultSelectedPrograms) : immutable_1.List([]);
        var convertedNewDefaultPrograms = nextDefaultPrograms ? immutable_1.List(nextDefaultPrograms) : immutable_1.List([]);
        var defaultProgramsChanged = !convertedDefaultPrograms.equals(convertedNewDefaultPrograms);
        var allProgramsChanged = !convertedAllPrograms.equals(convertedNextAllPrograms);
        if (id !== nextId || !convertedForm.equals(convertedNewForm) || defaultValuesChanged || defaultProgramsChanged || allProgramsChanged) {
            this.initializeState(nextProps);
            this.captcha && this.captcha.reset();
        }
        if (nextState.changeMade) {
            onChange && onChange(this.getProcessedForm(nextProps));
            this.setState({ changeMade: false });
        }
    };
    SsgFormComponent.prototype.initializeState = function (props) {
        var id = props.id, form = props.form, defaultValue = props.defaultValue, defaultSelectedPrograms = props.defaultSelectedPrograms, allPrograms = props.allPrograms, ssgFormActions = props.ssgFormActions, country = props.country;
        var uniqueId = this.getId(props);
        ssgFormActions.initializeFormState(uniqueId, form, defaultValue, allPrograms, defaultSelectedPrograms);
        ssgFormActions.processForm(uniqueId, country);
        this.setState({ changeMade: true });
    };
    /**
     * Gets the id of the SsgFormComponent. If the id prop is not set, it uses the id on the form definition.
     * @param props the props provided to the component
     * @returns the id of the SsgFormComponent.
     */
    SsgFormComponent.prototype.getId = function (props) {
        var id = props.id, form = props.form;
        return id ? id : form.id;
    };
    SsgFormComponent.prototype.getProcessedForm = function (props) {
        var ssgForms = props.ssgForms;
        var uniqueId = this.getId(props);
        var processedForms = ssgForms.processedForms;
        return processedForms && processedForms.get(uniqueId);
    };
    /**
     * Function that triggers the answers to be cleared, and the recaptcha to be reset
     * @param e the html event when a button is clicked/pressed
     */
    SsgFormComponent.prototype.handleReset = function (e) {
        e.preventDefault();
        var _a = this.props, ssgFormActions = _a.ssgFormActions, country = _a.country;
        var uniqueId = this.getId(this.props);
        ssgFormActions.resetForm(uniqueId);
        ssgFormActions.processForm(uniqueId, country);
        this.setState({ changeMade: true });
        this.captcha && this.captcha.reset();
    };
    /**
     * Function that calls causes validation to be shown if there are errors present
     * @param e the html event when a button is clicked/pressed
     */
    SsgFormComponent.prototype.handleSave = function (e) {
        e.preventDefault();
        var ssgFormActions = this.props.ssgFormActions;
        var formState = this.getProcessedForm(this.props);
        var updateShowValidation = ssgFormActions.updateShowValidation;
        if (!this.passedValidation()) {
            var uniqueId = this.getId(this.props);
            updateShowValidation(uniqueId, true);
        }
    };
    /**
     * Function that calls the passed-in onSave function if validation was
     * successfull. If not, the passed-in onSaveWithErrors will be executed.
     * This is only called for the default button layout.
     * @param e the html event when save button is clicked/pressed
     */
    SsgFormComponent.prototype.handleDefaultSave = function (e) {
        e.preventDefault();
        this.handleSave(e);
        var _a = this.props, onSave = _a.onSave, onSaveWithErrors = _a.onSaveWithErrors, customValidationErrors = _a.customValidationErrors, blockSaveForCustomError = _a.blockSaveForCustomError;
        var formState = this.getProcessedForm(this.props);
        if (formState.validationResult.passedValidation && (!blockSaveForCustomError || !customValidationErrors || customValidationErrors.length === 0)) {
            onSave && onSave(formState);
        }
        else {
            onSaveWithErrors && onSaveWithErrors(formState);
        }
    };
    /**
     * This calls the onCancel prop.
     * This is only called for the default button layout.
     */
    SsgFormComponent.prototype.handleCancel = function () {
        var onCancel = this.props.onCancel;
        var formState = this.getProcessedForm(this.props);
        onCancel && onCancel(formState);
    };
    SsgFormComponent.prototype.onCaptchaChange = function (value) {
        var _a = this.props, ssgFormActions = _a.ssgFormActions, country = _a.country;
        var uniqueId = this.getId(this.props);
        ssgFormActions.updateRecaptcha(uniqueId, value);
        ssgFormActions.processForm(uniqueId, country);
        this.setState({ changeMade: true });
    };
    SsgFormComponent.prototype.updateScalarAnswer = function (elementId) {
        var _this = this;
        var _a = this.props, ssgFormActions = _a.ssgFormActions, form = _a.form, country = _a.country;
        var uniqueId = this.getId(this.props);
        return function (value) {
            ssgFormActions.updateScalarAnswer(uniqueId, elementId, value);
            ssgFormActions.processForm(uniqueId, country);
            _this.setState({ changeMade: true });
        };
    };
    /**
     * This function is used to determine if there are any custom styles defined for an element.
     * See [[FormProps.styleoverride]]
     * @param elementId identifier of the element
     */
    SsgFormComponent.prototype.overrideStyle = function (elementId) {
        var styleOverride = this.props.styleOverride;
        return styleOverride && styleOverride.get(elementId);
    };
    /**This function is used to update the store with the attachment information */
    SsgFormComponent.prototype.updateAttachmentAnswerHandler = function (elementId) {
        var _this = this;
        var _a = this.props, form = _a.form, ssgFormActions = _a.ssgFormActions, country = _a.country;
        var uniqueId = this.getId(this.props);
        var flagChange = function () { return _this.setState({ changeMade: true }); };
        return function (files) {
            if (files) {
                ssgFormActions.updateAttachmentElementBegin(uniqueId, elementId, files.length);
                var readers = [];
                var _loop_1 = function (i) {
                    ssgFormActions.addAttachmentInfo(uniqueId, elementId, number_utilities_1.convertIntToGuid(i), // fileid
                    files[i].name, // filename
                    files[i].type, // type
                    files[i].size);
                    readers.push(new FileReader());
                    readers[i].onload = function () {
                        var dataURL = readers[i].result;
                        var base64 = dataURL;
                        if (dataURL.indexOf(',') !== -1) {
                            base64 = dataURL.substring(dataURL.indexOf(',') + 1);
                        }
                        else {
                            // handles the empty file case
                            base64 = "";
                        }
                        // The first part of the dataURL contains MIME type information and a designation for base64 string
                        ssgFormActions.addAttachmentContent(uniqueId, elementId, number_utilities_1.convertIntToGuid(i), // fileid
                        base64);
                        ssgFormActions.processForm(uniqueId, country);
                        flagChange();
                    };
                    readers[i].onerror = function () {
                        var err = {
                            errorCode: 'attachment-upload',
                            errorMessage: 'There was an error uploading the attachment'
                        };
                        ssgFormActions.updateAttachmentElementFailure(uniqueId, elementId, err);
                        ssgFormActions.processForm(uniqueId, country);
                        flagChange();
                    };
                    readers[i].onabort = function () {
                        var err = {
                            errorCode: 'attachment-upload',
                            errorMessage: 'The attachment upload was cancelled'
                        };
                        ssgFormActions.updateAttachmentElementFailure(uniqueId, elementId, err);
                        ssgFormActions.processForm(uniqueId, country);
                        flagChange();
                    };
                    readers[i].readAsDataURL(files[i]);
                };
                for (var i = 0; i < files.length; i++) {
                    _loop_1(i);
                }
                ssgFormActions.processForm(uniqueId, country);
                flagChange();
            }
        };
    };
    /** This method is used to remove the attachment */
    SsgFormComponent.prototype.removeAttachmentHandler = function (elementId, fileId) {
        var _this = this;
        var _a = this.props, form = _a.form, ssgFormActions = _a.ssgFormActions, ssgForms = _a.ssgForms, onChange = _a.onChange, country = _a.country;
        var uniqueId = this.getId(this.props);
        var flagChange = function () { return _this.setState({ changeMade: true }); };
        ssgFormActions.removeAttachment(uniqueId, elementId, fileId);
        var readers = [];
        readers.push(new FileReader());
        readers[0].onload = function () {
            var dataURL = readers[0].result;
            ssgFormActions.processForm(uniqueId, country);
            flagChange();
        };
        readers[0].onerror = function () {
            var err = {
                errorCode: 'attachment-remove-update',
                errorMessage: 'There was an error removing the attachment'
            };
            ssgFormActions.updateAttachmentRemoveFailure(uniqueId, elementId, err);
            ssgFormActions.processForm(uniqueId, country);
            flagChange();
        };
        readers[0].onabort = function () {
            var err = {
                errorCode: 'attachment-remove',
                errorMessage: 'The attachment remove update was cancelled'
            };
            ssgFormActions.updateAttachmentRemoveFailure(uniqueId, elementId, err);
            ssgFormActions.processForm(uniqueId, country);
            flagChange();
        };
        ssgFormActions.processForm(uniqueId, country);
        flagChange();
    };
    /**
     * This returns a function that will trigger an attachment to be downloaded.
     * A onDownloadAttachment function must be provided via props for this to work.
     * @param elementId
     */
    SsgFormComponent.prototype.downloadAttachmentHandler = function (elementId) {
        var _a = this.props, onDownloadAttachment = _a.onDownloadAttachment, form = _a.form;
        var formId = form.id;
        return function (fileId, fileName) {
            if (!onDownloadAttachment) {
                console.error('No onDownloadAttachment function was provided to the SsgFormComponent.');
                return new Promise(function (resolve, reject) {
                    resolve(null);
                });
            }
            return onDownloadAttachment(formId, elementId, fileId)
                .then(function (blob) { return utilities_1.processDownloadedAttachment(fileName, blob); });
        };
    };
    SsgFormComponent.prototype.updateElement = function (element) {
        if (element.type !== 'attachment') {
            return this.updateScalarAnswer(element.id);
        }
        else {
            return this.updateAttachmentAnswerHandler(element.id);
        }
    };
    /**
     * returns the function that should be triggered when a custom button is clicked
     * @param button custom button definition
     */
    SsgFormComponent.prototype.getCustomButtonOnClick = function (button) {
        var _this = this;
        return function (e) {
            switch (button.functionType) {
                case 'reset':
                    _this.handleReset(e);
                    break;
                case 'submit':
                    _this.handleSave(e);
                    break;
                default: break;
            }
            button.onClick(_this.getProcessedForm(_this.props));
        };
    };
    /**
     * This function will use the [[formElements.FormElement]] component to render an element
     * from the form definition in [[FormProps.form]].
     * @param element element to be rendered
     */
    SsgFormComponent.prototype.mapElement = function (element) {
        var _this = this;
        var _a = this.props, country = _a.country, customDisplays = _a.customDisplays, customValidationErrors = _a.customValidationErrors, elementStyles = _a.elementStyles, _b = _a.idAddOn, idAddOn = _b === void 0 ? "" : _b, readOnly = _a.readOnly, showUnsupported = _a.showUnsupported, ssgForms = _a.ssgForms;
        var processedForm = this.getProcessedForm(this.props);
        var uniqueId = this.getId(this.props);
        var showFormValidation = ssgForms && ssgForms.showFormValidation.get(uniqueId);
        var customElementErrors = !!customValidationErrors ?
            immutable_1.List(customValidationErrors.map(function (error) { return new error_reporting_1.FormError(error); })) :
            immutable_1.List([]);
        var modifiedElement = element;
        if (ssg_forms_processing_1.formDefinition.elementStoresData(element.type)) {
            var inputElement = element;
            modifiedElement = element.set('readOnly', readOnly ? readOnly : inputElement.readOnly);
        }
        var returnValues = [];
        var beforeElement = customDisplays && customDisplays.filter(function (val) {
            return val.position.anchor === ssg_form_position_1.SsgFormAnchor.ELEMENT &&
                val.position.relationship == ssg_form_position_1.SsgFormRelation.BEFORE &&
                val.position.elementId === element.id;
        });
        var afterElement = customDisplays && customDisplays.filter(function (val) {
            return val.position.anchor === ssg_form_position_1.SsgFormAnchor.ELEMENT &&
                val.position.relationship == ssg_form_position_1.SsgFormRelation.AFTER &&
                val.position.elementId === element.id;
        });
        beforeElement && returnValues.push.apply(returnValues, beforeElement.map(function (val) { return val.display; }));
        returnValues.push(React.createElement(formElements.FormElement, { country: element.type === form_definition_1.elementTypes.date && country, css: elementStyles, customDisplays: customDisplays, customValidationErrors: customElementErrors, element: modifiedElement, getOnChange: function (element) { return _this.updateElement(element); }, getOnDownload: function (id) { return _this.downloadAttachmentHandler(id); }, getOnRemove: function (elementId, fileId) { return _this.removeAttachmentHandler(elementId, fileId); }, getStyleOverride: function (id) { return _this.overrideStyle(id); }, idAddOn: idAddOn, showInlineErrors: showFormValidation, showUnsupported: showUnsupported, state: processedForm }));
        afterElement && returnValues.push.apply(returnValues, afterElement.map(function (val) { return val.display; }));
        return returnValues;
    };
    /**
     * Renders a SaveButton based on custom button layout
     * @param button the custom button configuration
     */
    SsgFormComponent.prototype.mapCustomButton = function (button) {
        var css = this.props.css;
        var buttonClass;
        switch (button.buttonType) {
            case 'primary':
                buttonClass = css.primaryButton;
                break;
            case 'secondary':
                buttonClass = css.secondaryButton;
                break;
            case 'default':
            default:
                buttonClass = css.defaultButton;
                break;
        }
        var buttonCss = Object.assign({
            button: buttonClass,
            buttonSaving: classnames_1.default(buttonClass, { disabled: button.disabled })
        }, button.css);
        return (React.createElement(utilities_1.SaveButton, { id: button.id, type: button.type, display: button.display, ariaLabel: button.ariaLabel, disabled: button.disabled, saving: button.spinnerOn, savingDisplay: button.spinnerDisplay, onClick: this.getCustomButtonOnClick(button), css: buttonCss }));
    };
    SsgFormComponent.prototype.passedValidation = function () {
        var customValidationErrors = this.props.customValidationErrors;
        var formState = this.getProcessedForm(this.props);
        var validationResult = formState && formState.validationResult;
        return (!validationResult || validationResult.passedValidation) && (!customValidationErrors || customValidationErrors.length === 0);
    };
    SsgFormComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, saving = _a.saving, disableSave = _a.disableSave, recaptchaKey = _a.recaptchaKey, buttonLayout = _a.buttonLayout, disableValidationResultList = _a.disableValidationResultList, css = _a.css, ssgForms = _a.ssgForms, customValidationErrors = _a.customValidationErrors, customDisplays = _a.customDisplays, subTitleDisplay = _a.subTitleDisplay, showRequiredKey = _a.showRequiredKey;
        var formState = this.getProcessedForm(this.props);
        var _b = formState || { form: null, recaptchaValue: null }, form = _b.form, recaptchaValue = _b.recaptchaValue;
        var _c = form ||
            { name: '', heading: '', elements: immutable_1.List(), includeRecaptcha: false }, name = _c.name, heading = _c.heading, elements = _c.elements, includeRecaptcha = _c.includeRecaptcha;
        var validationResult = formState && formState.validationResult;
        var errors = validationResult ? validationResult.errors.toArray() : [];
        if (customValidationErrors)
            errors = errors.concat(customValidationErrors);
        var uniqueId = this.getId(this.props);
        var showFormValidation = ssgForms && ssgForms.showFormValidation.get(uniqueId);
        var validationControl = !this.passedValidation() && showFormValidation ?
            React.createElement(form_validation_control_1.FormValidationControl, { isValid: validationResult.passedValidation && (!customValidationErrors || customValidationErrors.length === 0), errors: errors, css: css && css.errorStyle }) :
            null;
        var defaultActionsBar = (React.createElement("div", { className: css.actions },
            React.createElement("button", { className: css.defaultButton, type: "button", onClick: function () { return _this.handleCancel(); } }, "CANCEL"),
            React.createElement(utilities_1.SaveButton, { id: "submitButton", type: "submit", ariaLabel: "Save", disabled: (includeRecaptcha && !recaptchaValue) || disableSave, onClick: function (e) { return _this.handleDefaultSave(e); }, saving: saving, css: { button: css.primaryButton } })));
        var beforeBody = customDisplays && customDisplays.filter(function (val) { return val.position.anchor === ssg_form_position_1.SsgFormAnchor.BODY && val.position.relationship == ssg_form_position_1.SsgFormRelation.BEFORE; });
        var afterBody = customDisplays && customDisplays.filter(function (val) { return val.position.anchor === ssg_form_position_1.SsgFormAnchor.BODY && val.position.relationship == ssg_form_position_1.SsgFormRelation.AFTER; });
        var beforeInnerBody = customDisplays && customDisplays.filter(function (val) { return val.position.anchor === ssg_form_position_1.SsgFormAnchor.INNER_BODY && val.position.relationship == ssg_form_position_1.SsgFormRelation.BEFORE; });
        var afterInnerBody = customDisplays && customDisplays.filter(function (val) { return val.position.anchor === ssg_form_position_1.SsgFormAnchor.INNER_BODY && val.position.relationship == ssg_form_position_1.SsgFormRelation.AFTER; });
        var beforeActions = customDisplays && customDisplays.filter(function (val) { return val.position.anchor === ssg_form_position_1.SsgFormAnchor.ACTIONS && val.position.relationship == ssg_form_position_1.SsgFormRelation.BEFORE; });
        var afterActions = customDisplays && customDisplays.filter(function (val) { return val.position.anchor === ssg_form_position_1.SsgFormAnchor.ACTIONS && val.position.relationship == ssg_form_position_1.SsgFormRelation.AFTER; });
        var title = !!heading ? heading : (!!name && name === 'Personal Information') ? 'Personal Information' : null;
        return (React.createElement("form", { className: css.form },
            beforeBody && beforeBody.map(function (val) { return val.display; }),
            React.createElement("div", { id: "ssg-form-body", className: css.formBody },
                beforeInnerBody && beforeInnerBody.map(function (val) { return val.display; }),
                React.createElement("div", null,
                    showRequiredKey ? (React.createElement("span", { className: css.requiredKey },
                        React.createElement(descriptors_1.RequiredIndicator, { css: { requiredIndicator: css.requiredIndicator }, isRequired: true }),
                        "Required")) : null,
                    !!name && name !== 'Personal Information' ? React.createElement("h1", { className: css.title }, name) : null,
                    !!title ? React.createElement("h2", { className: css.title }, title) : null,
                    subTitleDisplay),
                !disableValidationResultList ? validationControl : null,
                elements && elements.map(function (element) { return _this.mapElement(element); }),
                includeRecaptcha ? (React.createElement("div", { className: css.reCaptcha },
                    React.createElement(react_google_recaptcha_1.default, { ref: function (el) { return _this.captcha = el; }, sitekey: recaptchaKey, onChange: function (value) { return _this.onCaptchaChange(value); } }))) : null,
                afterInnerBody && afterInnerBody.map(function (val) { return val.display; })),
            afterBody && afterBody.map(function (val) { return val.display; }),
            !!buttonLayout && beforeActions && beforeActions.map(function (val) { return val.display; }),
            !!buttonLayout ? (React.createElement("div", { className: css.actions }, buttonLayout && buttonLayout.map(function (button) { return _this.mapCustomButton(button); }))) : defaultActionsBar,
            !!buttonLayout && afterActions && afterActions.map(function (val) { return val.display; })));
    };
    return SsgFormComponent;
}(React.Component));
exports.SsgFormComponent = SsgFormComponent;
var mapStateToProps = function (_a) {
    var ssgForms = _a.ssgForms;
    return {
        ssgForms: ssgForms
    };
};
var mapDispatchToProps = function (dispatch) {
    return {
        ssgFormActions: redux_1.bindActionCreators(ssg_form_actions_1.default, dispatch),
    };
};
exports.default = react_styleable_1.default(ssg_form_component_style_1.default)(react_redux_1.connect(mapStateToProps, mapDispatchToProps)(SsgFormComponent));


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ssg_forms_processing_1 = __webpack_require__(7);
/**
 * Based on the state of the form this function will find the first element on the form that has
 * a corresponding validation error in the state and focus that element (for accessbility purposes)
 * @param state the form state
 */
function focusFirstError(state) {
    if (!state)
        return;
    var form = state.form, validationResult = state.validationResult;
    if (!form || !validationResult)
        return;
    var elements = form.elements;
    var errors = validationResult.errors;
    if (!elements || !errors)
        return;
    var firstErrorElement = findFirstErrorElement(elements, errors);
    if (!firstErrorElement)
        return;
    var errorElement = document.getElementById(firstErrorElement.id);
    errorElement && errorElement.focus();
}
exports.focusFirstError = focusFirstError;
function findFirstErrorElement(elements, errors) {
    var errorElement = elements.find(function (element) { return !!errors.find(function (error) { return error.sourceId === element.id; }); });
    if (!errorElement) {
        var groupElements = elements.filter(function (element) { return element.type === ssg_forms_processing_1.formDefinition.elementTypes.group; });
        groupElements.forEach(function (element) {
            if (!errorElement && element.type === ssg_forms_processing_1.formDefinition.elementTypes.group) {
                errorElement = findFirstErrorElement(element.subElementsList, errors);
            }
        });
    }
    return errorElement;
}


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
var ssg_form_actions_1 = __webpack_require__(31);
var ssg_forms_processing_1 = __webpack_require__(7);
/** This is an immutable record that is structured in the format that desired for the state of the ssgFormsReducer. */
exports.SsgFormsStateRecord = immutable_1.Record({
    forms: immutable_1.Map({}),
    processedForms: immutable_1.Map({}),
    attachments: immutable_1.Map({}),
    showFormValidation: immutable_1.Map({}),
});
/** This is a class that defines the structure of the ssgFormsReducer's state
 * Extending SsgFormsStateRecord allows us to treat our strongly typed class like an immutable object,
 * giving us access to all the functions associated with an Immutable Record
*/
var SsgFormsState = /** @class */ (function (_super) {
    __extends(SsgFormsState, _super);
    function SsgFormsState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SsgFormsState;
}(exports.SsgFormsStateRecord));
exports.SsgFormsState = SsgFormsState;
;
/** The reducer that manages state for all SsgFormComponents used in an application */
exports.ssgFormsReducer = function (state, reduxAction) {
    if (state === void 0) { state = new SsgFormsState(); }
    var action = reduxAction;
    switch (action.type) {
        case ssg_form_actions_1.ssgFormActionTypes.INIT_FORM:
            return state.setIn(['forms', action.id], action.state)
                .setIn(['processedForms', action.id], undefined);
        case ssg_form_actions_1.ssgFormActionTypes.UPDATE_SCALAR_ANSWER:
            return state.setIn(['forms', action.id, 'value', action.elementId], action.value);
        case ssg_form_actions_1.ssgFormActionTypes.UPDATE_SELECTED_PROGRAMS:
            return state.setIn(['forms', action.id, 'selectedPrograms'], immutable_1.List(action.value));
        case ssg_form_actions_1.ssgFormActionTypes.PROCESS_FORM:
            return state.setIn(['processedForms', action.id], action.state);
        case ssg_form_actions_1.ssgFormActionTypes.UPDATE_ATTACHMENT_ELEMENT_BEGIN:
            return state.setIn(['forms', action.id, 'value', action.elementId], new ssg_forms_processing_1.formDefinition.AttachmentResponseState({
                fileCount: action.fileCount
            }));
        case ssg_form_actions_1.ssgFormActionTypes.ADD_ATTACHMENT_INFO:
            return state.updateIn(['forms', action.id, 'value', action.elementId, 'files'], function (value) {
                var ssgFormAction = action;
                value = value || immutable_1.List();
                var index = value.findIndex(function (val) { return val.get("id") === ssgFormAction.fileId; });
                if (index === -1) {
                    var newMapValue = immutable_1.Map({ id: ssgFormAction.fileId });
                    value = value.push(newMapValue);
                    index = value.findIndex(function (val) { return val.get("id") === ssgFormAction.fileId; });
                }
                return value.setIn([index, 'fileName'], ssgFormAction.name)
                    .setIn([index, 'contentType'], ssgFormAction.contentType)
                    .setIn([index, 'size'], ssgFormAction.size)
                    .setIn([index, 'isUploading'], true);
            });
        case ssg_form_actions_1.ssgFormActionTypes.ADD_ATTACHMENT_CONTENT:
            var uploadCount = state.getIn(['forms', action.id, 'value', action.elementId, 'completedUploads']);
            return state.updateIn(['forms', action.id, 'value', action.elementId, 'files'], function (value) {
                var ssgFormAction = action;
                value = value || immutable_1.List();
                var index = value.findIndex(function (val) { return val.get("id") === ssgFormAction.fileId; });
                if (index === -1) {
                    var newMapValue = immutable_1.Map({ id: ssgFormAction.fileId });
                    value = value.push(newMapValue);
                    index = value.findIndex(function (val) { return val.get("id") === ssgFormAction.fileId; });
                }
                var path = [index, 'content'];
                return value.setIn(path, ssgFormAction.content)
                    .setIn([index, 'isUploading'], false);
            })
                .setIn(['forms', action.id, 'value', action.elementId, 'completedUploads'], uploadCount + 1); // previously this was adding 1
        case ssg_form_actions_1.ssgFormActionTypes.UPDATE_ATTACHMENT_ELEMENT_FAILURE:
            return state.updateIn(['forms', action.id, 'value', action.elementId, 'files'], function (value) {
                value = value || immutable_1.List();
                var updatedValue = value;
                value.foreach(function (file, index) {
                    updatedValue = updatedValue.setIn([index, 'isUploading'], false);
                });
                return updatedValue;
            })
                .setIn(['forms', action.id, 'value', action.elementId], new ssg_forms_processing_1.formDefinition.AttachmentResponseState({
                err: new Error(action.err)
            }));
        case ssg_form_actions_1.ssgFormActionTypes.REMOVE_ATTACHMENT:
            var ssgFormAction = action;
            var elementPath = ['forms', action.id, 'value', action.elementId];
            var elementValue = state.getIn(elementPath);
            var elementDefaultValue = state.getIn(['forms', action.id, 'defaultValue', action.elementId]);
            var modifiedState = state;
            if (!elementValue) {
                if (!!elementDefaultValue) {
                    elementValue = elementDefaultValue;
                    modifiedState = modifiedState.setIn(elementPath, elementValue);
                }
                else {
                    return modifiedState;
                }
            }
            var file = elementValue.files.find(function (val) { return val.get('id') === ssgFormAction.fileId; });
            modifiedState = modifiedState.updateIn(elementPath.concat(['files']), function (value) {
                value = value || immutable_1.List();
                var index = value.findIndex(function (val) { return val.get("id") === ssgFormAction.fileId; });
                if (index !== -1) {
                    value = value.remove(index);
                }
                var updatedValue = value;
                return updatedValue;
            });
            modifiedState = modifiedState.setIn(elementPath.concat(['fileCount']), elementValue.get('fileCount') - 1);
            if (!file.get('isUploading')) {
                modifiedState = modifiedState.setIn(elementPath.concat(['completedUploads']), elementValue.get('completedUploads') - 1);
            }
            return modifiedState;
        case ssg_form_actions_1.ssgFormActionTypes.REMOVE_ATTACHMENT_ELEMENT_FAILURE:
            return state.updateIn(['forms', action.id, 'value', action.elementId, 'files'], function (value) {
                value = value || immutable_1.List();
                var updatedValue = value;
                value.foreach(function (file, index) {
                    updatedValue = updatedValue.setIn([index, 'isUploading'], false);
                });
                return updatedValue;
            })
                .setIn(['forms', action.id, 'value', action.elementId], new ssg_forms_processing_1.formDefinition.AttachmentResponseState({
                err: new Error(action.err)
            }));
        case ssg_form_actions_1.ssgFormActionTypes.UPDATE_RECAPTCHA:
            return state.setIn(['forms', action.id, 'recaptchaValue'], action.value);
        case ssg_form_actions_1.ssgFormActionTypes.UPDATE_SHOW_VALIDATION:
            return state.setIn(['showFormValidation', action.id], action.showFormValidation);
        case ssg_form_actions_1.ssgFormActionTypes.RESET:
            return !!state.getIn(['forms', action.id]) ?
                state.setIn(['forms', action.id, 'value'], immutable_1.Map({}))
                    .setIn(['forms', action.id, 'recaptchaValue'], null)
                    .setIn(['showFormValidation', action.id], false) : state;
        case ssg_form_actions_1.ssgFormActionTypes.HARD_RESET:
            return state.setIn(['forms', action.id], new ssg_forms_processing_1.formDefinition.FormState({}))
                .setIn(['processedForms', action.id], new ssg_forms_processing_1.formDefinition.FormState({}));
        default:
            return state;
    }
};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var immutable_1 = __webpack_require__(2);
var accessibility_notifications_emitter_1 = __webpack_require__(101);
var uuid = __webpack_require__(491);
/** A component that displays a list of notifications inside aria-live regions so that they are read by screen readers */
var AccessibilityNotifications = /** @class */ (function (_super) {
    __extends(AccessibilityNotifications, _super);
    /** initializes the notifications with an empty list */
    function AccessibilityNotifications(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            notifications: immutable_1.List([])
        };
        return _this;
    }
    /** sets the component reference on the [[accessibilityNotificationsEmitter]] to reference this component */
    AccessibilityNotifications.prototype.componentWillMount = function () {
        accessibility_notifications_emitter_1.accessibilityNotificationsEmitter.componentRef = this;
    };
    /**
     * This is a public function that allows notifications to be added to the state
     * @param message message to be read
     * @param alertLevel priority level of message
     */
    AccessibilityNotifications.prototype.addNotification = function (message, alertLevel) {
        var _this = this;
        var displayTime = this.props.displayTime;
        var notification = {
            id: uuid(),
            message: message,
            alertLevel: alertLevel,
        };
        this.setState(function (prevState) {
            var newNotifications = prevState.notifications.push(notification);
            return { notifications: newNotifications };
        });
        setTimeout(function () {
            _this.setState(function (prevState) {
                var newNotifications = prevState.notifications.filter(function (val) { return val.id !== notification.id; }).toList();
                return { notifications: newNotifications };
            });
        }, displayTime);
    };
    /**
     * @hidden
     * this function converts a notification from the state to a JSX element that can be rendered
     * @param notification notification to be rendered
     */
    AccessibilityNotifications.prototype.mapNotification = function (notification) {
        return React.createElement("span", { id: "message", key: notification.id }, notification.message);
    };
    /** @hidden renders aria live regions with the appropriate notifications inside */
    AccessibilityNotifications.prototype.render = function () {
        var notifications = this.state.notifications;
        var politeNotifications = notifications &&
            notifications.filter(function (notification) { return notification.alertLevel === 'polite'; });
        var assertiveNotifications = notifications &&
            notifications.filter(function (notification) { return notification.alertLevel === 'assertive'; });
        return (React.createElement("div", { className: 'ssg-forms-skip' },
            React.createElement("div", { "aria-live": "polite" }, politeNotifications && politeNotifications.map(this.mapNotification)),
            React.createElement("div", { "aria-live": "assertive" }, assertiveNotifications && assertiveNotifications.map(this.mapNotification))));
    };
    /** the default value for the props, if none are provided */
    AccessibilityNotifications.defaultProps = {
        displayTime: 300
    };
    return AccessibilityNotifications;
}(React.Component));
exports.AccessibilityNotifications = AccessibilityNotifications;
exports.default = AccessibilityNotifications;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * After an attachment has been retrieved from the api, cause it to be downloaded in the browser
 * @param fileName the name of the file
 * @param blob the file
 */
function processDownloadedAttachment(fileName, blob) {
    if (navigator.appVersion.indexOf('.NET') > 0 || navigator.appVersion.indexOf('Edge') > 0) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
    }
    else {
        var anchor = document.createElement("a");
        document.body.appendChild(anchor);
        anchor.setAttribute("style", "display: none");
        var url = window.URL.createObjectURL(blob);
        anchor.href = url;
        anchor.download = fileName;
        anchor.click();
        window.URL.revokeObjectURL(url);
    }
    return blob;
}
exports.processDownloadedAttachment = processDownloadedAttachment;
;
/**
 * Converts a blob of attachment data into a base64 string
 * @param blob raw attachment data
 */
function getAttachmentData(blob) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    var reader = new FileReader();
                    reader.onloadend = function () { return resolve(reader.result); };
                    reader.onerror = function (event) { return reject(reader.error); };
                    reader.readAsDataURL(blob);
                })];
        });
    });
}
exports.getAttachmentData = getAttachmentData;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(287);
var defaultStyle = {
    button: "ssg-forms-btn ssg-forms-btn",
    buttonCancel: "ssg-forms-btn ssg-forms-btn disabled",
    spin: "ssg-forms-cancel-icon ssg-forms-spin",
};
exports.default = defaultStyle;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var cancel_button_style_1 = __webpack_require__(361);
var react_fontawesome_1 = __webpack_require__(14);
var free_solid_svg_icons_1 = __webpack_require__(13);
/** This component represents a button that will will close or back out of a form
 */
var CancelButton = /** @class */ (function (_super) {
    __extends(CancelButton, _super);
    function CancelButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden handle click input on the button
     * should call onCancel callback if one is provided, so long as the button is not disabled
     * @param event click mouse event
     */
    CancelButton.prototype.handleCancel = function (event) {
        var _a = this.props, disabled = _a.disabled, onCancel = _a.onCancel;
        if (!disabled && onCancel) {
            onCancel(event);
        }
    };
    CancelButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, type = _a.type, display = _a.display, ariaLabel = _a.ariaLabel, disabled = _a.disabled, cancelling = _a.cancelling, cancelDisplay = _a.cancelDisplay, css = _a.css;
        if (cancelling) {
            return (React.createElement("button", { className: css.buttonCancel, id: id, type: "button", "aria-label": ariaLabel },
                React.createElement("span", { id: "cancel-display" }, cancelDisplay),
                React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: css.spin, icon: free_solid_svg_icons_1.faSpinner })));
        }
        return (React.createElement("button", { id: id, disabled: !!disabled, onClick: function (e) { return _this.handleCancel(e); }, className: css.button, type: type, "aria-label": ariaLabel }, display));
    };
    /** default values for props, if none are provided */
    CancelButton.defaultProps = {
        type: 'button',
        display: "Cancel",
        cancelDisplay: "Cancelling..."
    };
    return CancelButton;
}(React.Component));
exports.CancelButton = CancelButton;
exports.default = react_styleable_1.default(cancel_button_style_1.default)(CancelButton);


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var cancel_button_1 = __webpack_require__(362);
exports.CancelButton = cancel_button_1.default;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var collapsible_section_style_1 = __webpack_require__(103);
var __1 = __webpack_require__(9);
var custom_icon_1 = __webpack_require__(18);
var CollapsibleSection = /** @class */ (function (_super) {
    __extends(CollapsibleSection, _super);
    function CollapsibleSection(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            expanded: !!props.defaultExpanded,
        };
        return _this;
    }
    /** determines if the display should be expanded based on the expanded prop and the expanded state */
    CollapsibleSection.prototype.isExpanded = function () {
        var expandedProp = this.props.expanded;
        var expanded = this.state.expanded;
        return (expandedProp !== undefined && expandedProp !== null) ? expandedProp : expanded;
    };
    /** handles setting the state and calling onCollapse/onExpand as appropriate */
    CollapsibleSection.prototype.handleCollapseButton = function (event) {
        event.preventDefault();
        var _a = this.props, onExpand = _a.onExpand, onCollapse = _a.onCollapse;
        var currentlyExpanded = this.isExpanded();
        this.setState({ expanded: !currentlyExpanded });
        if (currentlyExpanded) {
            onCollapse && onCollapse();
        }
        else {
            onExpand && onExpand();
        }
    };
    CollapsibleSection.prototype.getId = function (elementId) {
        var id = this.props.id;
        return id ? id + "-" + elementId : elementId;
    };
    CollapsibleSection.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, label = _a.label, expandIconDisplay = _a.expandIconDisplay, collapseIconDisplay = _a.collapseIconDisplay, children = _a.children, css = _a.css;
        var expanded = this.isExpanded();
        return (React.createElement("div", { id: id, className: css.display },
            React.createElement("button", { id: this.getId('collapse-toggle'), className: css.collapseToggle, "aria-label": expanded ? "collapse " + name : "expand " + name, onClick: function (event) { return _this.handleCollapseButton(event); } },
                React.createElement("span", { id: this.getId('icon'), className: css.icon }, expanded ? collapseIconDisplay : expandIconDisplay),
                React.createElement("span", { id: this.getId('label'), className: css.label }, label)),
            expanded ? (React.createElement("div", { id: this.getId('content'), className: css.content }, children)) : null));
    };
    CollapsibleSection.defaultProps = {
        expandIconDisplay: React.createElement(__1.CustomIcon, { iconChoice: custom_icon_1.CustomIconSet.ic_expand_18x18, css: { ssgCustomIconContainer: 'ssg-custom-icon-container-inline' } }),
        collapseIconDisplay: React.createElement(__1.CustomIcon, { iconChoice: custom_icon_1.CustomIconSet.ic_collapse_18x18, css: { ssgCustomIconContainer: 'ssg-custom-icon-container-inline' } }),
    };
    return CollapsibleSection;
}(React.Component));
exports.CollapsibleSection = CollapsibleSection;
exports.default = react_styleable_1.default(collapsible_section_style_1.default)(CollapsibleSection);


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var collapsible_section_1 = __webpack_require__(364);
exports.CollapsibleSection = collapsible_section_1.default;
var collapsible_section_style_1 = __webpack_require__(103);
exports.defaultStyle = collapsible_section_style_1.default;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(283);
var modal_style_1 = __webpack_require__(107);
var defaultStyle = __assign({}, modal_style_1.default, { noButton: "ssg-forms-btn", yesButton: "ssg-forms-btn ssg-forms-btn-primary", actions: "modal-actions" });
exports.default = defaultStyle;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var modal_window_1 = __webpack_require__(106);
var confirm_modal_window_style_1 = __webpack_require__(366);
/**
 * The component class that renders and defines component actions for the ConfirmModalWindow. This component
 * is a wrapper of the ModalWindow and passes through most props with the exception of the footer definition.
 */
var ConfirmModalWindow = /** @class */ (function (_super) {
    __extends(ConfirmModalWindow, _super);
    function ConfirmModalWindow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Function called when clicking either the OK or Cancel buttons. This hides and also calls the provided onClose function.
     * @param e The event that triggers this function.
     * @param confirmed Defines whether the ConfirmModal was confirmed or not. If true, then the user clicked 'Yes'. If false,
     * the user clicked 'No'.
     */
    ConfirmModalWindow.prototype.confirmOnClose = function (e, confirmed) {
        var modalRefState = this.state.modalRef;
        var onClose = this.props.onClose;
        modalRefState && modalRefState.hide();
        onClose && onClose(e, confirmed);
    };
    /**
     * The ref function that returns the base ref function for the ModalWindow.
     * @param refWindow The ref that is attached to the ModalWindow.
     */
    ConfirmModalWindow.prototype.getModalRef = function (refWindow) {
        var modalRef = this.props.modalRef;
        modalRef && modalRef(refWindow);
        this.setState({
            modalRef: refWindow
        });
    };
    ConfirmModalWindow.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, overrideShow = _a.overrideShow, children = _a.children, css = _a.css, id = _a.id, hideCloseButton = _a.hideCloseButton, pageElementId = _a.pageElementId, yesButtonText = _a.yesButtonText, noButtonText = _a.noButtonText, disableConfirm = _a.disableConfirm;
        var footer = React.createElement("div", null,
            React.createElement("div", { className: css.actions },
                React.createElement("button", { id: 'cancel', className: css.noButton, onClick: function (e) { return _this.confirmOnClose(e, false); } }, noButtonText || "NO"),
                React.createElement("button", { id: 'confirm', className: css.yesButton, onClick: function (e) { return _this.confirmOnClose(e, true); }, disabled: disableConfirm }, yesButtonText || "YES")));
        return (React.createElement(modal_window_1.ModalWindow, { id: id, title: title, footer: footer, css: css, pageElementId: pageElementId, hideCloseButton: hideCloseButton, overrideShow: overrideShow, modalRef: function (ref) { return _this.getModalRef(ref); }, children: children, onClose: function (e) { return _this.confirmOnClose(e, false); } }));
    };
    return ConfirmModalWindow;
}(React.Component));
exports.ConfirmModalWindow = ConfirmModalWindow;
exports.default = react_styleable_1.default(confirm_modal_window_style_1.default)(ConfirmModalWindow);


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var confirm_modal_window_1 = __webpack_require__(367);
exports.ConfirmModalWindow = confirm_modal_window_1.default;


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    button: "ssg-forms-btn ssg-forms-btn-primary",
    disabled: 'disabled',
};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var copy_button_style_1 = __webpack_require__(369);
/**The copy button allows users to take text from another element on the page
 * and copy it to the clipboard. */
var CopyButton = /** @class */ (function (_super) {
    __extends(CopyButton, _super);
    function CopyButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** Handles the event where user clicks (or presses) the copy button.
     * @ param e the button event that was triggered on button click
     */
    CopyButton.prototype.handleOnClick = function (e) {
        var _a = this.props, copyTarget = _a.copyTarget, onError = _a.onError, disabled = _a.disabled;
        if (!disabled && copyTarget) {
            var copyNode = document.querySelector("#" + copyTarget);
            var range = document.createRange();
            try {
                range.selectNode(copyNode);
                //remove all ranges makes copying work the first time
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
                document.execCommand('copy');
            }
            catch (err) {
                onError(err);
            }
            window.getSelection().removeAllRanges();
        }
    };
    CopyButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, value = _a.value, disabled = _a.disabled, css = _a.css;
        var disabledCss = !!disabled ? css.disabled : '';
        return (React.createElement("button", { id: id, disabled: !!disabled, className: css.button + ' ' + disabledCss, "aria-label": value, onClick: function (e) { return _this.handleOnClick(e); } }, value || 'Copy'));
    };
    return CopyButton;
}(React.Component));
exports.CopyButton = CopyButton;
exports.default = react_styleable_1.default(copy_button_style_1.default)(CopyButton);


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var copy_button_1 = __webpack_require__(370);
exports.CopyButton = copy_button_1.default;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var custom_icon_style_1 = __webpack_require__(374);
var react_svg_inline_1 = __webpack_require__(489);
var CustomImports = __webpack_require__(373);
/** Display custom icons. The supported set of icons can be found in [[CustomIconSet]]. */
var CustomIcon = /** @class */ (function (_super) {
    __extends(CustomIcon, _super);
    function CustomIcon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Test if the given icon selection is of type SVG.
     * @param iconChoice The icon to display.  See [[CustomIconSet]] for more detail.
     * @returns True if the given icon is in SVG format, false otherwise.
     */
    CustomIcon.prototype.isSvg = function (iconChoice) {
        if (iconChoice.endsWith(".svg")) {
            return true;
        }
        return false;
    };
    /**
     * @hidden Draw everything to the screen.
     */
    CustomIcon.prototype.render = function () {
        var _a = this.props, iconChoice = _a.iconChoice, css = _a.css, id = _a.id;
        if (this.isSvg(iconChoice)) {
            return React.createElement("div", { className: css.ssgCustomIconContainer, id: id },
                React.createElement(react_svg_inline_1.default, { className: css.ssgCustomIcon, svg: CustomImports.getMyIcon(iconChoice) }));
        }
        return React.createElement("div", { className: css.ssgCustomIconContainer, id: id },
            React.createElement("img", { className: css.ssgCustomIcon, src: CustomImports.getMyIcon(iconChoice) }));
    };
    return CustomIcon;
}(React.Component));
exports.CustomIcon = CustomIcon;
exports.default = react_styleable_1.default(custom_icon_style_1.default)(CustomIcon);


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var custom_icon_set_1 = __webpack_require__(104);
var ic_bonterra_logo_purple = __webpack_require__(214);
var ic_bonterra_logo_white = __webpack_require__(215);
var ic_calendar_14x14 = __webpack_require__(216);
var ic_calendar_14x14_1x = __webpack_require__(422);
var ic_calendar_14x14_2x = __webpack_require__(423);
var ic_calendar_18x18 = __webpack_require__(217);
var ic_calendar_18x18_1x = __webpack_require__(424);
var ic_calendar_18x18_2x = __webpack_require__(425);
var ic_check_14x14 = __webpack_require__(218);
var ic_collapse_18x18 = __webpack_require__(219);
var ic_dashboard_16x12 = __webpack_require__(220);
var ic_dashboard_16x12_1x = __webpack_require__(426);
var ic_dashboard_16x12_2x = __webpack_require__(427);
var ic_desktop_switch_16x14 = __webpack_require__(221);
var ic_disclaim_msg_14x14 = __webpack_require__(222);
var ic_disclaim_msg_14x14_1x = __webpack_require__(428);
var ic_disclaim_msg_14x14_2x = __webpack_require__(429);
var ic_down_arrow_14x14 = __webpack_require__(223);
var ic_down_arrow_14x14_1x = __webpack_require__(430);
var ic_down_arrow_14x14_2x = __webpack_require__(431);
var ic_down_arrow_18x18 = __webpack_require__(224);
var ic_down_arrow_18x18_1x = __webpack_require__(432);
var ic_down_arrow_18x18_2x = __webpack_require__(433);
var ic_edit_14x14 = __webpack_require__(225);
var ic_edit_14x14_1x = __webpack_require__(434);
var ic_edit_14x14_2x = __webpack_require__(435);
var ic_edit_18x18 = __webpack_require__(226);
var ic_edit_18x18_1x = __webpack_require__(436);
var ic_edit_18x18_2x = __webpack_require__(437);
var ic_expand_18x18 = __webpack_require__(227);
var ic_form_submit_16x16 = __webpack_require__(228);
var ic_home_16x16 = __webpack_require__(229);
var ic_info_18x18 = __webpack_require__(230);
var ic_info_18x18_1x = __webpack_require__(438);
var ic_info_18x18_2x = __webpack_require__(439);
var ic_left_arrow_14x14 = __webpack_require__(231);
var ic_left_arrow_14x14_1x = __webpack_require__(440);
var ic_left_arrow_14x14_2x = __webpack_require__(441);
var ic_left_arrow_18x18 = __webpack_require__(232);
var ic_left_arrow_18x18_1x = __webpack_require__(442);
var ic_left_arrow_18x18_2x = __webpack_require__(443);
var ic_link_14x14 = __webpack_require__(233);
var ic_link_14x14_1x = __webpack_require__(444);
var ic_link_14x14_2x = __webpack_require__(445);
var ic_link_18x18 = __webpack_require__(234);
var ic_link_18x18_1x = __webpack_require__(446);
var ic_link_18x18_2x = __webpack_require__(447);
var ic_lock_14x16 = __webpack_require__(235);
var ic_logout_14x16 = __webpack_require__(236);
var ic_magnifying_glass_14x14 = __webpack_require__(237);
var ic_magnifying_glass_14x14_1x = __webpack_require__(448);
var ic_magnifying_glass_14x14_2x = __webpack_require__(449);
var ic_magnifying_glass_18x18 = __webpack_require__(238);
var ic_magnifying_glass_18x18_1x = __webpack_require__(450);
var ic_magnifying_glass_18x18_2x = __webpack_require__(451);
var ic_menu_18x12 = __webpack_require__(239);
var ic_menu_18x12_1x = __webpack_require__(452);
var ic_menu_18x12_2x = __webpack_require__(453);
var ic_message_18x13 = __webpack_require__(240);
var ic_message_18x13_1x = __webpack_require__(454);
var ic_message_18x13_2x = __webpack_require__(455);
var ic_paper_clip_14x14 = __webpack_require__(241);
var ic_paper_clip_14x14_1x = __webpack_require__(456);
var ic_paper_clip_14x14_2x = __webpack_require__(457);
var ic_paper_clip_18x18 = __webpack_require__(242);
var ic_paper_clip_18x18_1x = __webpack_require__(458);
var ic_paper_clip_18x18_2x = __webpack_require__(459);
var ic_portal_participants_36x36_1x = __webpack_require__(460);
var ic_portal_participants_36x36_2x = __webpack_require__(461);
var ic_portal_participants_36x36_3x = __webpack_require__(243);
var ic_publish_14x14 = __webpack_require__(244);
var ic_publish_14x14_1x = __webpack_require__(462);
var ic_publish_14x14_2x = __webpack_require__(463);
var ic_publish_18x18 = __webpack_require__(245);
var ic_publish_18x18_1x = __webpack_require__(464);
var ic_publish_18x18_2x = __webpack_require__(465);
var ic_remove_14x14 = __webpack_require__(246);
var ic_remove_14x14_1x = __webpack_require__(466);
var ic_remove_14x14_2x = __webpack_require__(467);
var ic_remove_18x18 = __webpack_require__(247);
var ic_remove_18x18_1x = __webpack_require__(468);
var ic_remove_18x18_2x = __webpack_require__(469);
var ic_retract_14x14 = __webpack_require__(248);
var ic_retract_14x14_1x = __webpack_require__(470);
var ic_retract_14x14_2x = __webpack_require__(471);
var ic_retract_18x18 = __webpack_require__(249);
var ic_retract_18x18_1x = __webpack_require__(472);
var ic_retract_18x18_2x = __webpack_require__(473);
var ic_right_arrow_14x14 = __webpack_require__(250);
var ic_right_arrow_14x14_1x = __webpack_require__(474);
var ic_right_arrow_14x14_2x = __webpack_require__(475);
var ic_right_arrow_18x18 = __webpack_require__(251);
var ic_right_arrow_18x18_1x = __webpack_require__(476);
var ic_right_arrow_18x18_2x = __webpack_require__(477);
var ic_site_16x16 = __webpack_require__(252);
var ic_spinner_18x18_1x = __webpack_require__(253);
var ic_spinner_36x36_2x = __webpack_require__(254);
var ic_sprocket_14x14 = __webpack_require__(255);
var ic_ssg_logo_grey_green_leaf = __webpack_require__(256);
var ic_user_pref_16x16 = __webpack_require__(257);
var ic_x_14x14 = __webpack_require__(258);
var ic_x_14x14_1x = __webpack_require__(478);
var ic_x_14x14_2x = __webpack_require__(479);
var ic_x_18x18 = __webpack_require__(259);
var ic_x_18x18_1x = __webpack_require__(480);
var ic_x_18x18_2x = __webpack_require__(481);
/**
 * Return the loaded icon corresponding to the iconChoice.
 * The actual contents vary based on the underlying loader used.
 * @param iconChoice The icon to display. See[[CustomIconSet]] for more detail.
 * @returns A loaded image to be used as src for an html image(non - svg),
 * or as svg for an SVGInline object.
 */
function getMyIcon(iconChoice) {
    switch (iconChoice) {
        case custom_icon_set_1.default.ic_bonterra_logo_purple:
            return ic_bonterra_logo_purple;
        case custom_icon_set_1.default.ic_bonterra_logo_white:
            return ic_bonterra_logo_white;
        case custom_icon_set_1.default.ic_calendar_14x14:
            return ic_calendar_14x14;
        case custom_icon_set_1.default.ic_calendar_14x14_1x:
            return ic_calendar_14x14_1x;
        case custom_icon_set_1.default.ic_calendar_14x14_2x:
            return ic_calendar_14x14_2x;
        case custom_icon_set_1.default.ic_calendar_18x18:
            return ic_calendar_18x18;
        case custom_icon_set_1.default.ic_calendar_18x18_1x:
            return ic_calendar_18x18_1x;
        case custom_icon_set_1.default.ic_calendar_18x18_2x:
            return ic_calendar_18x18_2x;
        case custom_icon_set_1.default.ic_check_14x14:
            return ic_check_14x14;
        case custom_icon_set_1.default.ic_collapse_18x18:
            return ic_collapse_18x18;
        case custom_icon_set_1.default.ic_dashboard_16x12:
            return ic_dashboard_16x12;
        case custom_icon_set_1.default.ic_dashboard_16x12_1x:
            return ic_dashboard_16x12_1x;
        case custom_icon_set_1.default.ic_dashboard_16x12_2x:
            return ic_dashboard_16x12_2x;
        case custom_icon_set_1.default.ic_desktop_switch_16x14:
            return ic_desktop_switch_16x14;
        case custom_icon_set_1.default.ic_disclaim_msg_14x14:
            return ic_disclaim_msg_14x14;
        case custom_icon_set_1.default.ic_disclaim_msg_14x14_1x:
            return ic_disclaim_msg_14x14_1x;
        case custom_icon_set_1.default.ic_disclaim_msg_14x14_2x:
            return ic_disclaim_msg_14x14_2x;
        case custom_icon_set_1.default.ic_down_arrow_14x14:
            return ic_down_arrow_14x14;
        case custom_icon_set_1.default.ic_down_arrow_14x14_1x:
            return ic_down_arrow_14x14_1x;
        case custom_icon_set_1.default.ic_down_arrow_14x14_2x:
            return ic_down_arrow_14x14_2x;
        case custom_icon_set_1.default.ic_down_arrow_18x18:
            return ic_down_arrow_18x18;
        case custom_icon_set_1.default.ic_down_arrow_18x18_1x:
            return ic_down_arrow_18x18_1x;
        case custom_icon_set_1.default.ic_down_arrow_18x18_2x:
            return ic_down_arrow_18x18_2x;
        case custom_icon_set_1.default.ic_edit_14x14:
            return ic_edit_14x14;
        case custom_icon_set_1.default.ic_edit_14x14_1x:
            return ic_edit_14x14_1x;
        case custom_icon_set_1.default.ic_edit_14x14_2x:
            return ic_edit_14x14_2x;
        case custom_icon_set_1.default.ic_edit_18x18:
            return ic_edit_18x18;
        case custom_icon_set_1.default.ic_edit_18x18_1x:
            return ic_edit_18x18_1x;
        case custom_icon_set_1.default.ic_edit_18x18_2x:
            return ic_edit_18x18_2x;
        case custom_icon_set_1.default.ic_expand_18x18:
            return ic_expand_18x18;
        case custom_icon_set_1.default.ic_form_submit_16x16:
            return ic_form_submit_16x16;
        case custom_icon_set_1.default.ic_home_16x16:
            return ic_home_16x16;
        case custom_icon_set_1.default.ic_info_18x18:
            return ic_info_18x18;
        case custom_icon_set_1.default.ic_info_18x18_1x:
            return ic_info_18x18_1x;
        case custom_icon_set_1.default.ic_info_18x18_2x:
            return ic_info_18x18_2x;
        case custom_icon_set_1.default.ic_left_arrow_14x14:
            return ic_left_arrow_14x14;
        case custom_icon_set_1.default.ic_left_arrow_14x14_1x:
            return ic_left_arrow_14x14_1x;
        case custom_icon_set_1.default.ic_left_arrow_14x14_2x:
            return ic_left_arrow_14x14_2x;
        case custom_icon_set_1.default.ic_left_arrow_18x18:
            return ic_left_arrow_18x18;
        case custom_icon_set_1.default.ic_left_arrow_18x18_1x:
            return ic_left_arrow_18x18_1x;
        case custom_icon_set_1.default.ic_left_arrow_18x18_2x:
            return ic_left_arrow_18x18_2x;
        case custom_icon_set_1.default.ic_link_14x14:
            return ic_link_14x14;
        case custom_icon_set_1.default.ic_link_14x14_1x:
            return ic_link_14x14_1x;
        case custom_icon_set_1.default.ic_link_14x14_2x:
            return ic_link_14x14_2x;
        case custom_icon_set_1.default.ic_link_18x18:
            return ic_link_18x18;
        case custom_icon_set_1.default.ic_link_18x18_1x:
            return ic_link_18x18_1x;
        case custom_icon_set_1.default.ic_link_18x18_2x:
            return ic_link_18x18_2x;
        case custom_icon_set_1.default.ic_lock_14x16:
            return ic_lock_14x16;
        case custom_icon_set_1.default.ic_logout_14x16:
            return ic_logout_14x16;
        case custom_icon_set_1.default.ic_magnifying_glass_14x14:
            return ic_magnifying_glass_14x14;
        case custom_icon_set_1.default.ic_magnifying_glass_14x14_1x:
            return ic_magnifying_glass_14x14_1x;
        case custom_icon_set_1.default.ic_magnifying_glass_14x14_2x:
            return ic_magnifying_glass_14x14_2x;
        case custom_icon_set_1.default.ic_magnifying_glass_18x18:
            return ic_magnifying_glass_18x18;
        case custom_icon_set_1.default.ic_magnifying_glass_18x18_1x:
            return ic_magnifying_glass_18x18_1x;
        case custom_icon_set_1.default.ic_magnifying_glass_18x18_2x:
            return ic_magnifying_glass_18x18_2x;
        case custom_icon_set_1.default.ic_menu_18x12:
            return ic_menu_18x12;
        case custom_icon_set_1.default.ic_menu_18x12_1x:
            return ic_menu_18x12_1x;
        case custom_icon_set_1.default.ic_menu_18x12_2x:
            return ic_menu_18x12_2x;
        case custom_icon_set_1.default.ic_message_18x13:
            return ic_message_18x13;
        case custom_icon_set_1.default.ic_message_18x13_1x:
            return ic_message_18x13_1x;
        case custom_icon_set_1.default.ic_message_18x13_2x:
            return ic_message_18x13_2x;
        case custom_icon_set_1.default.ic_paper_clip_14x14:
            return ic_paper_clip_14x14;
        case custom_icon_set_1.default.ic_paper_clip_14x14_1x:
            return ic_paper_clip_14x14_1x;
        case custom_icon_set_1.default.ic_paper_clip_14x14_2x:
            return ic_paper_clip_14x14_2x;
        case custom_icon_set_1.default.ic_paper_clip_18x18:
            return ic_paper_clip_18x18;
        case custom_icon_set_1.default.ic_paper_clip_18x18_1x:
            return ic_paper_clip_18x18_1x;
        case custom_icon_set_1.default.ic_paper_clip_18x18_2x:
            return ic_paper_clip_18x18_2x;
        case custom_icon_set_1.default.ic_portal_participants_36x36_1x:
            return ic_portal_participants_36x36_1x;
        case custom_icon_set_1.default.ic_portal_participants_36x36_2x:
            return ic_portal_participants_36x36_2x;
        case custom_icon_set_1.default.ic_portal_participants_36x36_3x:
            return ic_portal_participants_36x36_3x;
        case custom_icon_set_1.default.ic_publish_14x14:
            return ic_publish_14x14;
        case custom_icon_set_1.default.ic_publish_14x14_1x:
            return ic_publish_14x14_1x;
        case custom_icon_set_1.default.ic_publish_14x14_2x:
            return ic_publish_14x14_2x;
        case custom_icon_set_1.default.ic_publish_18x18:
            return ic_publish_18x18;
        case custom_icon_set_1.default.ic_publish_18x18_1x:
            return ic_publish_18x18_1x;
        case custom_icon_set_1.default.ic_publish_18x18_2x:
            return ic_publish_18x18_2x;
        case custom_icon_set_1.default.ic_remove_14x14:
            return ic_remove_14x14;
        case custom_icon_set_1.default.ic_remove_14x14_1x:
            return ic_remove_14x14_1x;
        case custom_icon_set_1.default.ic_remove_14x14_2x:
            return ic_remove_14x14_2x;
        case custom_icon_set_1.default.ic_remove_18x18:
            return ic_remove_18x18;
        case custom_icon_set_1.default.ic_remove_18x18_1x:
            return ic_remove_18x18_1x;
        case custom_icon_set_1.default.ic_remove_18x18_2x:
            return ic_remove_18x18_2x;
        case custom_icon_set_1.default.ic_retract_14x14:
            return ic_retract_14x14;
        case custom_icon_set_1.default.ic_retract_14x14_1x:
            return ic_retract_14x14_1x;
        case custom_icon_set_1.default.ic_retract_14x14_2x:
            return ic_retract_14x14_2x;
        case custom_icon_set_1.default.ic_retract_18x18:
            return ic_retract_18x18;
        case custom_icon_set_1.default.ic_retract_18x18_1x:
            return ic_retract_18x18_1x;
        case custom_icon_set_1.default.ic_retract_18x18_2x:
            return ic_retract_18x18_2x;
        case custom_icon_set_1.default.ic_right_arrow_14x14:
            return ic_right_arrow_14x14;
        case custom_icon_set_1.default.ic_right_arrow_14x14_1x:
            return ic_right_arrow_14x14_1x;
        case custom_icon_set_1.default.ic_right_arrow_14x14_2x:
            return ic_right_arrow_14x14_2x;
        case custom_icon_set_1.default.ic_right_arrow_18x18:
            return ic_right_arrow_18x18;
        case custom_icon_set_1.default.ic_right_arrow_18x18_1x:
            return ic_right_arrow_18x18_1x;
        case custom_icon_set_1.default.ic_right_arrow_18x18_2x:
            return ic_right_arrow_18x18_2x;
        case custom_icon_set_1.default.ic_site_16x16:
            return ic_site_16x16;
        case custom_icon_set_1.default.ic_spinner_18x18_1x:
            return ic_spinner_18x18_1x;
        case custom_icon_set_1.default.ic_spinner_36x36_2x:
            return ic_spinner_36x36_2x;
        case custom_icon_set_1.default.ic_sprocket_14x14:
            return ic_sprocket_14x14;
        case custom_icon_set_1.default.ic_ssg_logo_grey_green_leaf:
            return ic_ssg_logo_grey_green_leaf;
        case custom_icon_set_1.default.ic_user_pref_16x16:
            return ic_user_pref_16x16;
        case custom_icon_set_1.default.ic_x_14x14:
            return ic_x_14x14;
        case custom_icon_set_1.default.ic_x_14x14_1x:
            return ic_x_14x14_1x;
        case custom_icon_set_1.default.ic_x_14x14_2x:
            return ic_x_14x14_2x;
        case custom_icon_set_1.default.ic_x_18x18:
            return ic_x_18x18;
        case custom_icon_set_1.default.ic_x_18x18_1x:
            return ic_x_18x18_1x;
        case custom_icon_set_1.default.ic_x_18x18_2x:
            return ic_x_18x18_2x;
        default:
            return null;
    }
}
exports.getMyIcon = getMyIcon;


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(289);
var defaultStyle = {
    ssgCustomIconContainer: 'ssg-custom-icon-container',
    ssgCustomIcon: 'ssg-custom-icon'
};
exports.default = defaultStyle;


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var required_indicator_1 = __webpack_require__(34);
var react_styleable_1 = __webpack_require__(1);
var descriptors_style_1 = __webpack_require__(33);
var __1 = __webpack_require__(9);
var classnames_1 = __webpack_require__(6);
var RequiredLabel = /** @class */ (function (_super) {
    __extends(RequiredLabel, _super);
    function RequiredLabel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RequiredLabel.prototype.render = function () {
        var _a = this.props, id = _a.id, hasErrors = _a.hasErrors, isRequired = _a.isRequired, content = _a.content, ariaLabel = _a.ariaLabel, htmlFor = _a.htmlFor, css = _a.css, tooltip = _a.tooltip;
        return (React.createElement("div", { className: css.tooltipGroup },
            React.createElement("label", { id: id, className: classnames_1.default(css.requiredLabel, !!content ? "" : css.noContent), "aria-label": !!ariaLabel ? ariaLabel : content, htmlFor: htmlFor }, !!content ? (React.createElement("span", null,
                hasErrors ? React.createElement("span", { className: css.errorIndicator, "aria-hidden": 'true' }) : null,
                content,
                React.createElement(required_indicator_1.default, { css: css, isRequired: isRequired }))) : null),
            tooltip ? React.createElement(__1.TooltipDisplay, { text: tooltip, context: content }) : null));
    };
    RequiredLabel.defaultProps = {
        isRequired: false,
    };
    return RequiredLabel;
}(React.Component));
exports.RequiredLabel = RequiredLabel;
exports.default = react_styleable_1.default(descriptors_style_1.default)(RequiredLabel);


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var required_indicator_1 = __webpack_require__(34);
var react_styleable_1 = __webpack_require__(1);
var descriptors_style_1 = __webpack_require__(33);
var __1 = __webpack_require__(9);
var classnames_1 = __webpack_require__(6);
var RequiredLegend = /** @class */ (function (_super) {
    __extends(RequiredLegend, _super);
    function RequiredLegend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RequiredLegend.prototype.render = function () {
        var _a = this.props, hasErrors = _a.hasErrors, isRequired = _a.isRequired, content = _a.content, ariaLabel = _a.ariaLabel, css = _a.css, tooltip = _a.tooltip;
        return (React.createElement("legend", { className: classnames_1.default(css.requiredLegend, !!content ? "" : css.noContent), "aria-label": !!ariaLabel ? ariaLabel : content },
            React.createElement("div", { className: css.tooltipGroup },
                !!content ? (React.createElement("div", { className: classnames_1.default(css.legendWrapper, css.centeredTextWrapper) },
                    hasErrors ? React.createElement("span", { className: classnames_1.default(css.errorIndicator), "aria-hidden": 'true' }) : null,
                    React.createElement("span", null,
                        content,
                        React.createElement(required_indicator_1.default, { css: css, isRequired: isRequired })))) : null,
                tooltip ? React.createElement(__1.TooltipDisplay, { text: tooltip, context: content }) : null)));
    };
    return RequiredLegend;
}(React.Component));
exports.RequiredLegend = RequiredLegend;
exports.default = react_styleable_1.default(descriptors_style_1.default)(RequiredLegend);


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var image_display_style_1 = __webpack_require__(378);
/** A display that show an image along with some description text
 * Commonly used to show that there are no results on a page.
 */
var ImageDisplay = /** @class */ (function (_super) {
    __extends(ImageDisplay, _super);
    function ImageDisplay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ImageDisplay.prototype.render = function () {
        var _a = this.props, src = _a.src, primaryText = _a.primaryText, secondaryText = _a.secondaryText, css = _a.css;
        return (React.createElement("div", { className: css.display },
            React.createElement("div", { className: css.image },
                React.createElement("img", { src: src })),
            primaryText ? React.createElement("div", { className: css.primaryText }, primaryText) : null,
            secondaryText ? React.createElement("div", { className: css.secondaryText }, secondaryText) : null));
    };
    return ImageDisplay;
}(React.Component));
exports.ImageDisplay = ImageDisplay;
exports.default = react_styleable_1.default(image_display_style_1.default)(ImageDisplay);


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(291);
var defaultStyle = {
    display: 'ssg-forms-image-display',
    image: 'ssg-forms-image-display-container',
    primaryText: 'ssg-forms-text ssg-forms-image-display-primary-text',
    secondaryText: 'ssg-forms-text ssg-forms-image-display-secondary-text',
};
exports.default = defaultStyle;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var image_display_component_1 = __webpack_require__(377);
exports.ImageDisplay = image_display_component_1.default;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var loading_pane_1 = __webpack_require__(382);
exports.LoadingPane = loading_pane_1.default;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(292);
var defaultStyle = {
    loadingPane: 'ssg-loading-pane',
    coverContent: 'ssg-display-over-content',
    spinnerDisplay: 'ssg-loading-display spinner',
    loadingBarDisplay: 'ssg-loading-display loading-bar',
    loadingText: 'ssg-loading-text ssg-forms-text normal',
    customIconWrapper: 'ssg-loading-spinner',
    spinner: 'ssg-forms-spin',
    errorIcon: 'ssg-forms-error-icon',
    warningIcon: 'ssg-forms-warning-icon',
    loadingBar: 'ssg-loading-bar',
    loadingBarBackground: 'ssg-loading-bar-background',
    fadeOut: 'ssg-forms-fade-out',
    content: '',
};
exports.default = defaultStyle;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var react_fontawesome_1 = __webpack_require__(14);
var free_solid_svg_icons_1 = __webpack_require__(13);
var classnames_1 = __webpack_require__(6);
var loading_pane_style_1 = __webpack_require__(381);
var accessibility_notifications_1 = __webpack_require__(102);
var custom_icon_1 = __webpack_require__(18);
/**
 * @hidden returns the ids to be used by a particular loading pane
 * @param id id of the loading pane
 */
exports.loadingPaneElementsIds = function (id) {
    var idString = !!id ? (id + '-') : '';
    return {
        content: idString + "content",
        loadingDisplay: idString + "loading-display",
        message: idString + "loading-message",
        spinner: idString + "spinner",
        errorIcon: idString + "error-icon",
        loadingBar: idString + "loading-bar",
    };
};
/**
 * This component is designed to indicate to the user that information is being loaded.
 * If any of the information that the child display relies on hasn't been loaded yet, the child display will be hidden.
 * Once some data has been loaded for all the content the child display is shown.
 * If additional data is loaded once all the data has been loaded, a loading display will be rendered above the child display.
 */
var LoadingPane = /** @class */ (function (_super) {
    __extends(LoadingPane, _super);
    /**
     * @hidden initializes the state
     * @param props the props that define the display
     */
    function LoadingPane(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            warningDismissed: false,
            fadeOutTimer: null
        };
        return _this;
    }
    /**
     * @hidden returns an array of ILoadingState, based on the [[ILoadingPaneProps.loadingState]] prop.
     * this allows us to work within a consistent format, instead of checking to see if it is a single object or an array.
     * @param loadingState the loadingState prop
     */
    LoadingPane.prototype.getLoadingStates = function (loadingState) {
        var loadingStates = [];
        if (!!loadingState && Array.isArray(loadingState)) {
            loadingStates.push.apply(loadingStates, loadingState);
        }
        else {
            loadingStates.push(loadingState);
        }
        return loadingStates;
    };
    /**
     * @hidden gets common information
     * @param loadingStates all the loadingStates passed to the LoadingPane
     */
    LoadingPane.prototype.getLoadingStatesInfo = function (loadingStates) {
        var contentLoaded = !!loadingStates ? loadingStates.some(function (val) { return !!val && !!val.data; }) : false;
        var isLoading = !!loadingStates ? loadingStates.some(function (val) { return !!val && val.isLoading; }) : false;
        var errorState = !!loadingStates ? loadingStates.find(function (val) { return !!val && !!val.error && val.error.alertLevel === 'error'; }) : null;
        var warningState = !!loadingStates ? loadingStates.find(function (val) { return !!val && !!val.error && val.error.alertLevel === 'warning'; }) : null;
        return {
            contentLoaded: contentLoaded,
            isLoading: isLoading,
            error: errorState && errorState.error,
            warning: warningState && warningState.error,
        };
    };
    /** @hidden starts the warning fade out timer if needed */
    LoadingPane.prototype.componentDidMount = function () {
        this.manageWarningTimer(this.props, this.state);
    };
    /**
     * @hidden Reads if there has been a change to the loading state (when loading starts and ends)
     * Determines if there have been changes to the warning that require the state to be changed.
     * @param nextProps the new props
     * @param nextState the new state
     */
    LoadingPane.prototype.componentWillUpdate = function (nextProps, nextState) {
        var _a = this.props, prevLoadingState = _a.loadingState, loadingMessage = _a.loadingMessage, contentLoadedMessage = _a.contentLoadedMessage;
        var loadingState = nextProps.loadingState;
        var prevLoadingStates = this.getLoadingStates(prevLoadingState);
        var loadingStates = this.getLoadingStates(loadingState);
        var prevLoadingInfo = this.getLoadingStatesInfo(prevLoadingStates);
        var loadingInfo = this.getLoadingStatesInfo(loadingStates);
        if (loadingInfo.error && !prevLoadingInfo.error) {
            accessibility_notifications_1.accessibilityNotificationsEmitter.polite(loadingInfo.error.errorMessage);
        }
        else if (loadingInfo.warning && !prevLoadingInfo.warning) {
            accessibility_notifications_1.accessibilityNotificationsEmitter.polite(loadingInfo.warning.errorMessage);
        }
        else if (!loadingInfo.isLoading && prevLoadingInfo.isLoading) {
            accessibility_notifications_1.accessibilityNotificationsEmitter.polite(contentLoadedMessage);
        }
        else if (!prevLoadingInfo.isLoading && loadingInfo.isLoading) {
            accessibility_notifications_1.accessibilityNotificationsEmitter.polite(loadingMessage);
        }
        var warningDismissed = nextState.warningDismissed, fadeOutTimer = nextState.fadeOutTimer;
        if (prevLoadingInfo.warning !== loadingInfo.warning) {
            clearTimeout(fadeOutTimer);
            this.setState({
                warningDismissed: false,
                fadeOutTimer: null
            });
        }
        this.manageWarningTimer(nextProps, nextState);
    };
    /**
     * @hidden Determines if the timer to trigger the warning display to fade out should be started.
     * @param props the loading props
     * @param state the loading state
     */
    LoadingPane.prototype.manageWarningTimer = function (props, state) {
        var _this = this;
        var loadingState = props.loadingState, warningDisplayTime = props.warningDisplayTime;
        var warningDismissed = state.warningDismissed, fadeOutTimer = state.fadeOutTimer;
        var loadingStates = this.getLoadingStates(loadingState);
        var loadingInfo = this.getLoadingStatesInfo(loadingStates);
        if (!loadingInfo.error && !!loadingInfo.warning && !warningDismissed && fadeOutTimer === null) {
            this.setState({
                fadeOutTimer: setTimeout(function () {
                    _this.setState({
                        warningDismissed: true,
                        fadeOutTimer: null
                    });
                }, warningDisplayTime)
            });
        }
    };
    /**
     * @hidden returns the display of the loading bar, the color of the bar changes based on the error/warning props
     * @param error if true the loading pane should change color to red (takes priority over warning)
     * @param warning if true the loading pane should change color to yellow
     */
    LoadingPane.prototype.renderLoadingBar = function (error, warning) {
        if (error === void 0) { error = false; }
        if (warning === void 0) { warning = false; }
        var _a = this.props, id = _a.id, percentComplete = _a.percentComplete, css = _a.css;
        var ids = exports.loadingPaneElementsIds(id);
        return (React.createElement("div", { className: classnames_1.default(css.loadingBarBackground, { error: error }, { warning: warning }) },
            React.createElement("div", { id: ids.loadingBar, className: classnames_1.default(css.loadingBar, { error: error }, { warning: warning }), style: { width: percentComplete + '%' } })));
    };
    /** @hidden displays the loading pane */
    LoadingPane.prototype.render = function () {
        var _a = this.props, id = _a.id, loadingState = _a.loadingState, loadingMessage = _a.loadingMessage, percentComplete = _a.percentComplete, children = _a.children, css = _a.css;
        var warningDismissed = this.state.warningDismissed;
        var ids = exports.loadingPaneElementsIds(id);
        var loadingStates = this.getLoadingStates(loadingState);
        var loadingInfo = this.getLoadingStatesInfo(loadingStates);
        var coverContent = {};
        coverContent[css.coverContent] = loadingInfo.contentLoaded;
        var warningFade = {};
        warningFade[css.fadeOut] = !loadingInfo.error && !!loadingInfo.warning && warningDismissed;
        var loadingDisplayClass = classnames_1.default(percentComplete !== undefined ? css.loadingBarDisplay : css.spinnerDisplay, coverContent, warningFade);
        var icon = null;
        var text = loadingMessage;
        if (!!loadingInfo.error) {
            icon = React.createElement("span", { id: ids.errorIcon },
                React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: css.errorIcon, icon: free_solid_svg_icons_1.faExclamationCircle }));
            text = loadingInfo.error.errorMessage;
        }
        else if (!!loadingInfo.warning) {
            icon = React.createElement("span", { id: ids.errorIcon },
                React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: css.warningIcon, icon: free_solid_svg_icons_1.faExclamationCircle }));
            text = loadingInfo.warning.errorMessage;
        }
        else if (percentComplete === undefined) {
            icon = (React.createElement(custom_icon_1.CustomIcon, { id: ids.spinner, iconChoice: custom_icon_1.CustomIconSet.ic_spinner_18x18_1x, css: {
                    ssgCustomIconContainer: css.customIconWrapper,
                    ssgCustomIcon: css.spinner
                } }));
        }
        var loadingDisplay = loadingInfo.isLoading || loadingInfo.error || loadingInfo.warning ? (React.createElement("div", { id: ids.loadingDisplay, className: loadingDisplayClass },
            icon,
            React.createElement("span", { id: ids.message, className: css.loadingText }, text),
            percentComplete !== undefined ? this.renderLoadingBar(!!loadingInfo.error, !!loadingInfo.warning) : null)) : null;
        return (React.createElement("div", { id: id, className: css.loadingPane },
            loadingDisplay,
            loadingInfo.contentLoaded ? (React.createElement("div", { id: ids.content, className: css.content }, children)) : null));
    };
    /** the defaults for the loading display */
    LoadingPane.defaultProps = {
        loadingMessage: 'Loading',
        contentLoadedMessage: 'Content Loaded',
        warningDisplayTime: 4000,
    };
    return LoadingPane;
}(React.Component));
exports.LoadingPane = LoadingPane;
exports.default = react_styleable_1.default(loading_pane_style_1.default)(LoadingPane);


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var menu_component_1 = __webpack_require__(386);
exports.Menu = menu_component_1.default;
var menu_button_component_1 = __webpack_require__(384);
exports.MenuButton = menu_button_component_1.default;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var menu_button_style_1 = __webpack_require__(385);
var save_button_1 = __webpack_require__(35);
/** A Save Button with different default css, so it looks right in the Menu component */
var MenuButton = /** @class */ (function (_super) {
    __extends(MenuButton, _super);
    function MenuButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuButton.prototype.render = function () {
        return (React.createElement(save_button_1.SaveButton, __assign({}, this.props)));
    };
    return MenuButton;
}(React.Component));
exports.MenuButton = MenuButton;
exports.default = react_styleable_1.default(menu_button_style_1.default)(MenuButton);


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(293);
var save_button_1 = __webpack_require__(35);
var defaultStyle = __assign({}, save_button_1.defaultSaveButtonStyle, { button: 'ssg-forms-menu-btn', buttonSaving: 'ssg-forms-menu-btn' });
exports.default = defaultStyle;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var menu_style_1 = __webpack_require__(387);
var react_fontawesome_1 = __webpack_require__(14);
var free_solid_svg_icons_1 = __webpack_require__(13);
var accessibility_helper_functions_1 = __webpack_require__(32);
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            menuOpen: false,
        };
        _this.handleClickAway = _this.handleClickAway.bind(_this);
        return _this;
    }
    Menu.prototype.componentDidMount = function () {
        document.body.addEventListener('click', this.handleClickAway);
    };
    Menu.prototype.componentDidUpdate = function (prevProps, prevState) {
        var isOpen = this.isMenuOpen();
        var wasOpen = this.wasMenuOpen(prevProps, prevState);
        if (isOpen && !wasOpen) {
            var menu = document.getElementById(this.getElementId('menu-list'));
            var menuItems = accessibility_helper_functions_1.getFocusableChildren(menu);
            if (menuItems && menuItems.length > 0) {
                menuItems[0].focus();
            }
        }
    };
    Menu.prototype.componentWillUnmount = function () {
        document.body.removeEventListener('click', this.handleClickAway);
    };
    /** combines the Menu's id with the desired id of the element */
    Menu.prototype.getElementId = function (elementId) {
        var id = this.props.id;
        return id ? (id + '-' + elementId) : elementId;
    };
    Menu.prototype.handleClickAway = function (e) {
        var id = this.props.id;
        if (!accessibility_helper_functions_1.isInsideElement(e.srcElement, id)) {
            this.setOpen(false);
        }
    };
    /** opens or closes the menu depending on its current state */
    Menu.prototype.toggleMenu = function () {
        var open = !this.isMenuOpen();
        this.setOpen(open);
    };
    Menu.prototype.setOpen = function (open) {
        var onToggleOpen = this.props.onToggleOpen;
        onToggleOpen && onToggleOpen(open);
        this.setState({ menuOpen: open });
    };
    /** determines if the menu should be open based on current props and state */
    Menu.prototype.isMenuOpen = function () {
        return this.wasMenuOpen(this.props, this.state);
    };
    Menu.prototype.wasMenuOpen = function (props, state) {
        var open = props.open;
        var menuOpen = state.menuOpen;
        return open !== null && open !== undefined ? open : menuOpen;
    };
    /**
     * Renders an individual menuItem from the list of menuItems
     * @param key unique to use for list item
     * @param item item from menuItems prop
     */
    Menu.prototype.renderMenuItem = function (key, item) {
        var css = this.props.css;
        return (React.createElement("div", { id: this.getElementId('menu-item' + key), key: key, className: css.menuItem }, item));
    };
    Menu.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, menuItems = _a.menuItems, menuButtonDisplay = _a.menuButtonDisplay, css = _a.css;
        return (React.createElement("div", { id: id, className: css.menu },
            React.createElement("button", { id: this.getElementId('toggle-menu'), className: css.menuBtn, title: "menu", "aria-label": "menu", onClick: function () { return _this.toggleMenu(); } }, menuButtonDisplay ? menuButtonDisplay : React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faEllipsisV, size: 'lg' })),
            React.createElement("div", { id: this.getElementId('menu-list'), className: this.isMenuOpen() ? css.menuList : css.menuHidden }, menuItems && menuItems.map(function (item, index) { return _this.renderMenuItem(index.toString(), item); }))));
    };
    return Menu;
}(React.Component));
exports.Menu = Menu;
exports.default = react_styleable_1.default(menu_style_1.default)(Menu);


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(294);
var defaultStyle = {
    menu: "ssg-forms-menu",
    menuBtn: "ssg-forms-icon-btn",
    menuList: "ssg-forms-menu-list",
    menuHidden: "ssg-forms-hidden",
    menuItem: "ssg-forms-menu-item",
};
exports.default = defaultStyle;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var modal_window_1 = __webpack_require__(106);
exports.ModalWindow = modal_window_1.default;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(296);
var defaultStyle = {
    application: 'ssg-forms-scrollable ssg-forms-app-page',
    content: 'ssg-forms-app-content ssg-forms-no-focus',
    collapsedNav: 'ssg-forms-app-hide-nav',
};
exports.default = defaultStyle;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var classnames_1 = __webpack_require__(6);
var application_style_1 = __webpack_require__(389);
var header_component_1 = __webpack_require__(108);
var nav_component_1 = __webpack_require__(109);
/**
 * React Component that displays child content, with a header and a side nav.
 * The component internally handles collapsing and expanding the side navigation when the hamburger menu is clicked in the Header.
 */
var Application = /** @class */ (function (_super) {
    __extends(Application, _super);
    function Application(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            expandNav: false,
        };
        return _this;
    }
    Application.prototype.componentDidMount = function () {
        this.setState({ expandNav: document.body.clientWidth > 768 });
    };
    /** determines if the nav should be expanded based on the props and state */
    Application.prototype.isNavExpanded = function () {
        var sideNavProps = this.props.sideNavProps;
        var expanded = sideNavProps.expanded;
        var expandNav = this.state.expandNav;
        return expanded !== null && expanded !== undefined ? expanded : expandNav;
    };
    /** handes the hamburger button being clicked (toggles the side nav) */
    Application.prototype.handleMenuClicked = function () {
        var headerProps = this.props.headerProps;
        var expanded = this.isNavExpanded();
        this.setState({ expandNav: !expanded });
        headerProps.onMenuClicked && headerProps.onMenuClicked();
    };
    Application.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, headerProps = _b.headerProps, sideNavProps = _b.sideNavProps, children = _b.children, css = _b.css;
        var contentElementId = headerProps.contentElementId || 'view';
        var navigationElementId = sideNavProps.id || 'side-nav';
        var expanded = this.isNavExpanded();
        return (React.createElement("div", { className: css.application },
            React.createElement(header_component_1.default, __assign({}, headerProps, { contentElementId: contentElementId, navigationElementId: headerProps.navigationElementId || navigationElementId, onMenuClicked: function () { return _this.handleMenuClicked(); }, navigationOpen: expanded })),
            React.createElement(nav_component_1.default, __assign({}, sideNavProps, { id: navigationElementId, expanded: expanded })),
            React.createElement("div", { tabIndex: -1, id: contentElementId, className: classnames_1.default(css.content, (_a = {}, _a[css.collapsedNav] = !expanded, _a)) }, children)));
    };
    return Application;
}(React.Component));
exports.Application = Application;
exports.default = react_styleable_1.default(application_style_1.default)(Application);


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(297);
var defaultStyle = {
    header: 'ssg-forms-nav-header',
    screenReaderOnly: 'ssg-forms-skip',
    headerMenuItems: 'ssg-forms-nav-header-menu-items',
    headerItem: 'ssg-forms-nav-header-item',
    headerButton: 'ssg-forms-nav-header-button',
    headerButtonText: 'ssg-forms-text ssg-forms-nav-header-button-text',
    alternateHeaderMenuBtn: 'ssg-forms-alt-header-button',
};
exports.default = defaultStyle;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var header_component_1 = __webpack_require__(108);
exports.Header = header_component_1.default;
var nav_component_1 = __webpack_require__(109);
exports.Nav = nav_component_1.default;
var nav_style_1 = __webpack_require__(110);
exports.navIconStyle = nav_style_1.navIconStyle;
var nav_section_component_1 = __webpack_require__(393);
exports.NavSection = nav_section_component_1.default;
var ssg_nav_link_component_1 = __webpack_require__(395);
exports.SsgNavLink = ssg_nav_link_component_1.default;
var application_1 = __webpack_require__(390);
exports.Application = application_1.default;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var classnames_1 = __webpack_require__(6);
var nav_section_style_1 = __webpack_require__(394);
var custom_icon_1 = __webpack_require__(18);
/** Section of the Nav component that can be expanded to show a list of navLinks. */
var NavSection = /** @class */ (function (_super) {
    __extends(NavSection, _super);
    function NavSection(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            expanded: false,
        };
        return _this;
    }
    /** determines if the section is currently expanded based on props and state */
    NavSection.prototype.isSectionExpanded = function () {
        return this.wasSectionExpanded(this.props, this.state);
    };
    /**
     * determines if the section is expanded baed on given props and state
     * @param props props at a given point in time
     * @param state state at a given point in time
     */
    NavSection.prototype.wasSectionExpanded = function (props, state) {
        var expanded = props.expanded;
        var expandedState = state.expanded;
        return expanded !== null && expanded !== undefined ? expanded : expandedState;
    };
    /** opens or closes the section depending on its current state */
    NavSection.prototype.toggleSection = function () {
        var expanded = !this.isSectionExpanded();
        this.setOpen(expanded);
    };
    /**
     * sets the state to be expanded or not,
     * calls the onClick callback
     * @param expanded
     */
    NavSection.prototype.setOpen = function (expanded) {
        var onClick = this.props.onClick;
        onClick && onClick(expanded);
        this.setState({ expanded: expanded });
    };
    NavSection.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, id = _b.id, title = _b.title, navLinks = _b.navLinks, css = _b.css;
        var expanded = this.isSectionExpanded();
        return (React.createElement("div", { id: id, className: classnames_1.default(css.section, (_a = {}, _a[css.expanded] = expanded, _a)) },
            React.createElement("div", { id: id ? (id + 'section-toggle') : 'section-toggle', className: css.item, onClick: function () { return _this.toggleSection(); }, onKeyDown: function (e) { return e.keyCode === 13 ? _this.toggleSection() : {}; }, tabIndex: 0 },
                expanded ? (React.createElement("div", { className: css.logoWrapper },
                    React.createElement(custom_icon_1.CustomIcon, { iconChoice: custom_icon_1.CustomIconSet.ic_down_arrow_14x14, css: { ssgCustomIconContainer: css.iconContainer, ssgCustomIcon: css.icon } }))) : (React.createElement("div", { className: css.logoWrapper },
                    React.createElement(custom_icon_1.CustomIcon, { iconChoice: custom_icon_1.CustomIconSet.ic_right_arrow_14x14, css: { ssgCustomIconContainer: css.iconContainer, ssgCustomIcon: css.icon } }))),
                React.createElement("div", { className: css.title }, title)),
            expanded ? (React.createElement("div", { className: css.links }, navLinks)) : null));
    };
    return NavSection;
}(React.Component));
exports.NavSection = NavSection;
exports.default = react_styleable_1.default(nav_section_style_1.default)(NavSection);


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(28);
var defaultStyle = {
    section: 'ssg-forms-nav-section',
    expanded: 'zone-expanded',
    item: 'ssg-forms-nav-item',
    logoWrapper: 'ssg-forms-nav-logo-wrapper',
    iconContainer: 'ssg-forms-nav-icon-container',
    icon: 'ssg-forms-nav-icon',
    title: 'ssg-forms-section-title ssg-forms-nav-label',
    links: 'ssg-forms-nav-section-links',
};
exports.default = defaultStyle;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(116);
var react_styleable_1 = __webpack_require__(1);
var ssg_nav_link_style_1 = __webpack_require__(396);
/** A wrapper for NavLink that uses css expeced in the side nav of an application. */
var SsgNavLink = /** @class */ (function (_super) {
    __extends(SsgNavLink, _super);
    function SsgNavLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SsgNavLink.prototype.render = function () {
        var _a = this.props, className = _a.className, activeClassName = _a.activeClassName, icon = _a.icon, linkText = _a.linkText, css = _a.css, other = __rest(_a, ["className", "activeClassName", "icon", "linkText", "css"]);
        return (React.createElement(react_router_dom_1.NavLink, __assign({}, other, { className: className ? className : css.link, activeClassName: activeClassName ? activeClassName : css.active }),
            React.createElement("div", { className: icon ? css.iconWrapper : "ssg-forms-hidden" }, icon),
            React.createElement("div", { className: css.title }, linkText)));
    };
    return SsgNavLink;
}(React.Component));
exports.SsgNavLink = SsgNavLink;
exports.default = react_styleable_1.default(ssg_nav_link_style_1.default)(SsgNavLink);


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(28);
var defaultStyle = {
    link: 'ssg-forms-nav-item',
    active: 'router-link-active',
    iconWrapper: 'ssg-forms-nav-logo-wrapper',
    title: 'ssg-forms-nav-label',
};
exports.default = defaultStyle;


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var paged_list_1 = __webpack_require__(398);
exports.PagedList = paged_list_1.default;
var paging_actions_1 = __webpack_require__(399);
exports.pagingActions = paging_actions_1.default;
var paging_reducer_1 = __webpack_require__(400);
exports.pagingReducer = paging_reducer_1.default;


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var paging_control_1 = __webpack_require__(111);
var table_1 = __webpack_require__(114);
/** React component for displaying one or more pages of information in the form of a table */
var PagedList = /** @class */ (function (_super) {
    __extends(PagedList, _super);
    function PagedList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PagedList.prototype.render = function () {
        var _a = this.props, pagination = _a.pagination, displayPage = _a.displayPage;
        return (React.createElement(paging_control_1.PagingControl, __assign({}, pagination),
            React.createElement(table_1.Table, __assign({}, displayPage))));
    };
    return PagedList;
}(React.Component));
exports.PagedList = PagedList;
exports.default = PagedList;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var charsToReplace = /[^\w]/g;
/**
 * this function can be used to instantiate a local variable in an action file that can represent the action types that are commonly used with a paging display
 *
 * the types of actions that are supported by this are as follows:
 * - page: this is an action that changes the currently selected page in the reducer
 * - perPage: this is an action that changes the current number of items that should be displayed on an individual page
 * - sort: this is an action that changes how a paged list is sorted
 * @param {string} namespace This string corresponds to the namespace associated with the actions file that calls this
 * @param {string} actionPrefix This string represents provides a way to distinguish between multiple different pagingActions in the same namespace
 * @returns a structure that contains the action type names, an array of all the action type names, and an actionTypes object has the action type names
 *          associated with variable names that are in standard Participant Portal format for the actionTypes structure
 */
exports.getPagingActions = function (namespace, actionPrefix) {
    var _a;
    var changePageValue = namespace + "." + actionPrefix + "-change-page-number";
    var changePerPageValue = namespace + "." + actionPrefix + "-change-per-page-number";
    var changeSortValue = namespace + "." + actionPrefix + "-change-sort";
    var changePageName = (actionPrefix + "-change-page-number").replace(charsToReplace, "_").toUpperCase();
    var changePerPageName = (actionPrefix + "-change-per-page-number").replace(charsToReplace, "_").toUpperCase();
    var changeSortName = (actionPrefix + "-change-sort").replace(charsToReplace, "_").toUpperCase();
    return {
        page: changePageValue,
        perPage: changePerPageValue,
        sort: changeSortValue,
        allTypes: [changePageValue, changePerPageValue, changeSortValue],
        actionTypes: (_a = {},
            _a[changePageName] = changePageValue,
            _a[changePerPageName] = changePerPageValue,
            _a[changeSortName] = changeSortValue,
            _a)
    };
};
/**
 * this function dispatches a standardized action for changing the page number of a paged list display
 * @param {number} page the page number to set in the reducer
 * @param {object} actions an object expected to be in the format that is produced by the pagingActions function
 * @returns an action formatted in the way that the paging reducer expects
 */
exports.changePage = function (page, actions) {
    return {
        type: actions.page,
        page: page
    };
};
/**
 * this function dispatches a standardized action for changing the number of items that should be displayed on one page of a paged list
 * @param {number} perPage the number of items per page to set in the reducer
 * @param {object} actions an object expected to be in the format that is produced by the pagingActions function
 * @returns an action formatted in the way that the paging reducer expects
 */
exports.changePerPage = function (perPage, actions) {
    return {
        type: actions.perPage,
        perPage: perPage
    };
};
/**
 * this function dispatches a standardized action for managing how a paged list is sorted,
 * this manages both what aspect of the list is being sorted and whether or not it should be sorted in ascending or descending order
 * @param sortBy this is the aspect of the list to base the sorting on
 * @param sortAsc this determines if that aspect is sorted in ascending or descending order
 * @param actions an object expected to be in the format that is produced by the pagingActions function
 */
exports.changeSort = function (sortBy, sortAsc, actions) {
    return {
        type: actions.sort,
        sortBy: sortBy,
        sortAsc: sortAsc
    };
};
exports.default = {
    getPagingActions: exports.getPagingActions,
    changePage: exports.changePage,
    changePerPage: exports.changePerPage,
    changeSort: exports.changeSort,
};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = __webpack_require__(2);
/** Immutable record that the [[PagingState]] is based on*/
exports.PagingRecord = immutable_1.Record({
    currentPage: 1,
    itemsPerPage: 25,
    sortTarget: 'name',
    sortAsc: true,
});
/**
 * This is the standardized format to represent paging information in a reducer.
 * paging information that is needed in any reducer can innitialize their information using this structure
 */
var PagingState = /** @class */ (function (_super) {
    __extends(PagingState, _super);
    function PagingState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PagingState;
}(exports.PagingRecord));
exports.PagingState = PagingState;
/**
 * This function acts as a helper to a parent reducer.
 * It manages the state of paging information of the parent, specifically currentPage, itemsPerPage, sortBy, and sortAsc information.
 * The result of this function should be used to set the subsection of the parent's state that this is supposed to manage
 * @param {object} state this is the subsection of the parent reducer that deals specifically with paging
 * @param {object} action this is the action that the parent reducer is currently processing
 * @param {object} pagingActions an object expected to be in the format that is produced by the pagingActions function in paging.actions.js
 * @returns a modified version of the given state
 */
exports.pagingReducer = function (state, action, pagingActions) {
    if (state === void 0) { state = new PagingState(); }
    switch (action.type) {
        case pagingActions.page:
            return state.set('currentPage', action.page);
        case pagingActions.perPage:
            return state.set('itemsPerPage', action.perPage);
        case pagingActions.sort:
            return state.set('sortTarget', action.sortBy).set('sortAsc', action.sortAsc);
        default:
            return state;
    }
};
exports.default = exports.pagingReducer;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var paging_control_style_1 = __webpack_require__(112);
var react_fontawesome_1 = __webpack_require__(14);
var free_solid_svg_icons_1 = __webpack_require__(13);
var form_elements_1 = __webpack_require__(20);
var immutable_1 = __webpack_require__(2);
var ssg_forms_processing_1 = __webpack_require__(7);
var PagingControl = /** @class */ (function (_super) {
    __extends(PagingControl, _super);
    /**
     *  @hidden sets the initial state
     * @param props
     */
    function PagingControl(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentPage: 1
        };
        return _this;
    }
    /** @hidden
     * Handles the event that the component is updating.
     * This specifically checks for the case where the the page count has changed and caused the current page to be invalid.
     * @param nextProps the props that the component is updating to
     * @param nextState the state that the component is updating to
     */
    PagingControl.prototype.componentWillUpdate = function (nextProps, nextState) {
        var pageCount = this.getPageCount(this.props);
        var nextPageCount = this.getPageCount(nextProps);
        var page = nextState.currentPage;
        if (pageCount !== nextPageCount && (page > nextPageCount || page < 1)) {
            this.setPage(page, nextProps);
        }
    };
    /** @hidden gets the current page number, by checking the override page prop and the internal page prop */
    PagingControl.prototype.getCurrentPage = function () {
        var overridePage = this.props.currentPage;
        var internalPage = this.state.currentPage;
        return !!overridePage ? overridePage : internalPage;
    };
    /** @hidden
     * Calculates the page count based on the [[PagingControlProps.itemsPerPage]] and [[PagingControlProps.totalItemCount]] props
     * @param props
     */
    PagingControl.prototype.getPageCount = function (props) {
        var itemsPerPage = props.itemsPerPage, totalItemCount = props.totalItemCount;
        return Math.ceil(totalItemCount / itemsPerPage);
    };
    /** @hidden
     * Handles changing the page number. This will make sure that the page number is valid based on the given props,
     * set the state to the valid page number, and return the valid page number.
     * @param page the page number that we are trying to change to
     * @param props the props to use when computing the page count for validation
     */
    PagingControl.prototype.setPage = function (page, props) {
        var pageCount = this.getPageCount(props);
        var adjustedPage = (page > pageCount) ? pageCount : (page < 1) ? 1 : page;
        this.setState({
            selectedPage: undefined,
            currentPage: adjustedPage,
        });
        return adjustedPage;
    };
    /** @hidden
     * Handles the previous button being clicked.
     * The page should be set and the onChangePage function should be called.
     * @param event button clicked event
     */
    PagingControl.prototype.handlePrevClicked = function (event) {
        var onChangePage = this.props.onChangePage;
        var currentPage = this.getCurrentPage();
        var adjustedPage = this.setPage(currentPage - 1, this.props);
        !!onChangePage && onChangePage(adjustedPage);
    };
    /** @hidden
     * Handles the next button being clicked.
     * The page should be set and the onChangePage function should be called.
     * @param event button clicked event
     */
    PagingControl.prototype.handleNextClicked = function (event) {
        var onChangePage = this.props.onChangePage;
        var currentPage = this.getCurrentPage();
        var adjustedPage = this.setPage(currentPage + 1, this.props);
        !!onChangePage && onChangePage(adjustedPage);
    };
    /** @hidden
     * Handles a button being clicked while the page text input is active.
     * When enter is clicked we should set the page number and inform the user.
     * @param event button clicked event
     */
    PagingControl.prototype.handlePageKeyboardInput = function (event) {
        var onChangePage = this.props.onChangePage;
        var selectedPage = this.state.selectedPage;
        if (selectedPage === undefined || selectedPage === null || typeof (selectedPage) === typeof (String)) {
            return;
        }
        var selectedPageNumber = selectedPage;
        if (event.key === "Enter" || event.keyCode === 13) {
            var adjustedPage = this.setPage(selectedPageNumber, this.props);
            !!onChangePage && onChangePage(adjustedPage);
        }
    };
    /** @hidden
     * Handles a change in the text on the page input.
     * Should change the [[PagingControlState.selectedPage]], but not change the [[PagingControlState.currentPage]]
     * @param event change event
     */
    PagingControl.prototype.handlePageInput = function (event) {
        var value = event.target.value;
        var selectedPage = !!value ? parseInt(value, 10) : "";
        this.setState({
            selectedPage: selectedPage
        });
    };
    /** @hidden
     * Handles the event that the per page dropdown has an option selected.
     * Will automatically adjust the page number, if changing the per page value causes the page number to become invalid.
     * @param value the new value of the select dropdown
     */
    PagingControl.prototype.handlePerPageInput = function (value) {
        var _a = this.props, onChangePerPage = _a.onChangePerPage, totalItemCount = _a.totalItemCount;
        var selectedValue = value && value.first();
        var numberValue = !!selectedValue ? parseInt(selectedValue, 10) : undefined;
        var currentPage = this.getCurrentPage();
        var pageCount = Math.max(numberValue !== undefined && numberValue >= 1 ? Math.ceil(totalItemCount / numberValue) : 1, 1);
        var adjustedPage = (currentPage > pageCount) ? pageCount : (currentPage < 1) ? 1 : currentPage;
        this.setState({
            selectedPage: undefined,
            currentPage: adjustedPage,
        });
        onChangePerPage(numberValue, adjustedPage);
    };
    /** @hidden renders the per page dropdown */
    PagingControl.prototype.renderPerPageOptions = function () {
        var _this = this;
        var _a = this.props, id = _a.id, itemsPerPage = _a.itemsPerPage, perPageOptions = _a.perPageOptions, css = _a.css;
        if (!perPageOptions || perPageOptions.length === 0) {
            return null;
        }
        // needs to be in correct format
        var mcOptions = perPageOptions.map(function (val) { return { label: val.label, value: val.value.toString() }; });
        return (React.createElement("div", { className: css.perPage },
            React.createElement(form_elements_1.SelectElement, { element: {
                    id: id + '-per-page',
                    type: ssg_forms_processing_1.formDefinition.elementTypes.select,
                    options: mcOptions,
                    label: "View",
                    ariaLabel: "Items Per Page"
                }, disableEmptyOption: true, value: immutable_1.List([itemsPerPage.toString()]), onChange: function (value) { return _this.handlePerPageInput(value); }, css: {
                    inputWrapper: css.perPage,
                    label: css.perPageLabel,
                    group: "",
                    tooltipGroup: css.perPageTooltipGroup,
                    labelWrapper: css.perPageTooltipGroup,
                    select: css.perPageDropdown,
                } })));
    };
    /** @hidden renders the pagination controls. (Prev/Next button and Page input) */
    PagingControl.prototype.renderPagination = function () {
        var _this = this;
        var css = this.props.css;
        var selectedPage = this.state.selectedPage;
        var pageCount = this.getPageCount(this.props);
        if (pageCount <= 1) {
            return null;
        }
        var currentPage = this.getCurrentPage();
        var value = selectedPage !== undefined && selectedPage !== null ? selectedPage : currentPage ? currentPage : "";
        return (React.createElement("div", { className: css.paginationDisplay },
            React.createElement("button", { id: "prev", className: css.paginationButton, disabled: currentPage === 1, "aria-label": "Previous Page", onClick: function (e) { return _this.handlePrevClicked(e); } },
                React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faChevronLeft })),
            React.createElement("input", { type: "number", value: value, className: css.paginationInput, onChange: function (event) { return _this.handlePageInput(event); }, onKeyDown: function (event) { return _this.handlePageKeyboardInput(event); }, "aria-label": "Page Number", max: pageCount, min: 1 }),
            React.createElement("span", { className: css.paginationText },
                "OF ",
                pageCount),
            React.createElement("button", { id: "next", className: css.paginationButton, disabled: currentPage === pageCount, "aria-label": "Next Page", onClick: function (e) { return _this.handleNextClicked(e); } },
                React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faChevronRight }))));
    };
    /** @hidden renders the main display */
    PagingControl.prototype.render = function () {
        var _a = this.props, id = _a.id, title = _a.title, children = _a.children, css = _a.css, additionalHeaderContent = _a.additionalHeaderContent, hideTopPagingButtonGroup = _a.hideTopPagingButtonGroup;
        var pageCount = this.getPageCount(this.props);
        var paginationGroup = (React.createElement("div", { className: css.paginationGroup },
            this.renderPerPageOptions(),
            this.renderPagination()));
        var titleText = !title ? null :
            React.createElement("div", { className: css.titleText }, title);
        // if the control has a title or should show the top paging control then show div
        var titleBar = titleText || !hideTopPagingButtonGroup ?
            React.createElement("div", { className: css.title },
                titleText,
                !hideTopPagingButtonGroup ? paginationGroup : null) : null;
        var addContent = !additionalHeaderContent ? null :
            React.createElement("div", { className: css.additionalHeaderContent }, additionalHeaderContent);
        // build header from title/paging/addl content elements
        var headerContent = !titleBar && !addContent ? null :
            React.createElement("div", { id: id + "-header", className: css.header },
                titleBar,
                addContent);
        return (React.createElement("div", { id: id, className: css.display },
            headerContent,
            React.createElement("div", { id: id + "-body", className: css.body }, children),
            React.createElement("div", { id: id + "-footer", className: css.footer }, paginationGroup)));
    };
    return PagingControl;
}(React.Component));
exports.PagingControl = PagingControl;
exports.default = react_styleable_1.default(paging_control_style_1.default)(PagingControl);


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var save_button_style_1 = __webpack_require__(113);
var react_fontawesome_1 = __webpack_require__(14);
var free_solid_svg_icons_1 = __webpack_require__(13);
/** This component represents a button that will cause something to occur that the user will have to wait on.
 * It has a built in display to indicate that the user must way for an operation to complete.
 */
var SaveButton = /** @class */ (function (_super) {
    __extends(SaveButton, _super);
    function SaveButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @hidden handle click input on the button
     * should call onClick callback if one is provided, so long as the button is not disabled
     * @param event click mouse event
     */
    SaveButton.prototype.handleOnClick = function (event) {
        var _a = this.props, disabled = _a.disabled, onClick = _a.onClick;
        if (!disabled && onClick) {
            onClick(event);
        }
    };
    SaveButton.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, type = _a.type, display = _a.display, ariaLabel = _a.ariaLabel, disabled = _a.disabled, saving = _a.saving, savingDisplay = _a.savingDisplay, css = _a.css;
        if (saving) {
            return (React.createElement("button", { className: css.buttonSaving, id: id, type: 'button', "aria-label": ariaLabel },
                React.createElement("span", { id: "saving-display" }, savingDisplay),
                React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: css.spin, icon: free_solid_svg_icons_1.faSpinner })));
        }
        return (React.createElement("button", { id: id, disabled: !!disabled, onClick: function (e) { return _this.handleOnClick(e); }, className: css.button, type: type, "aria-label": ariaLabel }, display));
    };
    /** default values for props, if none are provided */
    SaveButton.defaultProps = {
        type: 'button',
        display: "SAVE",
        savingDisplay: "SAVING..."
    };
    return SaveButton;
}(React.Component));
exports.SaveButton = SaveButton;
exports.default = react_styleable_1.default(save_button_style_1.default)(SaveButton);


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(300);
var defaultStyle = {
    text: 'ssg-forms-text normal',
    matchingText: 'ssg-forms-highlighted-text',
};
exports.default = defaultStyle;


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var highlight_text_style_1 = __webpack_require__(403);
var HighlightText = /** @class */ (function (_super) {
    __extends(HighlightText, _super);
    function HighlightText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * returns a jsx element representing highlighted search text
     * @param text the text that is highlighted
     * @param key an optional key for the element
     */
    HighlightText.prototype.getHighlightedText = function (text, key) {
        if (key === void 0) { key = null; }
        var css = this.props.css;
        return React.createElement("span", { key: key, className: css.matchingText }, text);
    };
    HighlightText.prototype.render = function () {
        var _a = this.props, text = _a.text, searchValue = _a.searchValue, css = _a.css;
        if (!text) {
            return null;
        }
        if (!searchValue) {
            return React.createElement("span", { className: css.text }, text);
        }
        var lowercaseText = text.toLocaleLowerCase();
        var lowercaseSearchValue = searchValue.toLocaleLowerCase();
        var segments = lowercaseText.split(lowercaseSearchValue);
        var styledDisplay = [];
        var position = 0;
        for (var i = 0; i < segments.length; i += 1) {
            styledDisplay.push(text.substr(position, segments[i].length));
            position += segments[i].length;
            if (i < segments.length - 1) {
                styledDisplay.push(this.getHighlightedText(text.substr(position, searchValue.length), i.toString()));
                position += searchValue.length;
            }
        }
        return React.createElement("span", { className: css.text }, styledDisplay);
    };
    return HighlightText;
}(React.Component));
exports.HighlightText = HighlightText;
exports.default = react_styleable_1.default(highlight_text_style_1.default)(HighlightText);


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var highlight_text_1 = __webpack_require__(404);
exports.HighlightText = highlight_text_1.default;
var search_bar_1 = __webpack_require__(407);
exports.SearchBar = search_bar_1.default;
var searchUtilities = __webpack_require__(408);
exports.searchUtilities = searchUtilities;


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(301);
var defaultStyle = {
    group: '',
    searchIcon: 'ssg-forms-addon',
    inputGroup: 'ssg-forms-input-group',
    input: 'ssg-forms-input',
    clearBtn: 'ssg-forms-icon-btn ssg-forms-addon',
    clearIcon: 'ssg-custom-icon-container-inline ssg-forms-search-bar-clear-icon',
};
exports.default = defaultStyle;


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var classnames_1 = __webpack_require__(6);
var text_input_1 = __webpack_require__(16);
var custom_icon_1 = __webpack_require__(18);
var search_bar_style_1 = __webpack_require__(406);
var SearchBar = /** @class */ (function (_super) {
    __extends(SearchBar, _super);
    function SearchBar(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            inFocus: false,
        };
        return _this;
    }
    SearchBar.prototype.handleClear = function () {
        var onClear = this.props.onClear;
        onClear && onClear();
    };
    SearchBar.prototype.handleKeyUp = function (event) {
        var onEnter = this.props.onEnter;
        if (event.keyCode === 13) {
            onEnter && onEnter();
        }
    };
    SearchBar.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, value = _a.value, defaultValue = _a.defaultValue, ariaLabel = _a.ariaLabel, placeholder = _a.placeholder, showClearButton = _a.showClearButton, clearAriaLabel = _a.clearAriaLabel, onChange = _a.onChange, onClear = _a.onClear, css = _a.css, hideSearchIcon = _a.hideSearchIcon;
        var inFocus = this.state.inFocus;
        var searchValue = text_input_1.getCurrentValue(value, defaultValue);
        return (React.createElement("div", { id: id, className: classnames_1.default(css.group) },
            React.createElement("div", { className: classnames_1.default(css.inputGroup, { focus: inFocus }) },
                hideSearchIcon ? null : (React.createElement(custom_icon_1.CustomIcon, { iconChoice: custom_icon_1.CustomIconSet.ic_magnifying_glass_18x18, css: { ssgCustomIconContainer: css.searchIcon } })),
                React.createElement("input", { type: 'search', className: classnames_1.default(css.input), onChange: function (e) { onChange && onChange(e.target.value); }, onKeyUp: function (e) { return _this.handleKeyUp(e); }, onBlur: function (e) { _this.setState({ inFocus: false }); }, onFocus: function (e) { _this.setState({ inFocus: true }); }, value: searchValue, "aria-label": ariaLabel, placeholder: placeholder }),
                showClearButton ? (React.createElement("button", { type: 'button', "aria-label": clearAriaLabel, className: css.clearBtn, onClick: function () { return _this.handleClear(); } },
                    React.createElement(custom_icon_1.CustomIcon, { iconChoice: custom_icon_1.CustomIconSet.ic_x_18x18, css: { ssgCustomIconContainer: css.clearIcon } }))) : null)));
    };
    SearchBar.defaultProps = {
        placeholder: 'Search...',
        clearAriaLabel: 'clear search',
    };
    return SearchBar;
}(React.Component));
exports.SearchBar = SearchBar;
exports.default = react_styleable_1.default(search_bar_style_1.default)(SearchBar);


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function matchSearchValue(text, searchValue) {
    var lowercaseText = text.toLocaleLowerCase();
    var searchValue = searchValue.toLocaleLowerCase();
    return lowercaseText.includes(searchValue);
}
exports.matchSearchValue = matchSearchValue;


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var table_style_1 = __webpack_require__(115);
var react_fontawesome_1 = __webpack_require__(14);
var free_solid_svg_icons_1 = __webpack_require__(13);
var classnames_1 = __webpack_require__(6);
var form_elements_1 = __webpack_require__(20);
var immutable_1 = __webpack_require__(2);
var ssg_forms_processing_1 = __webpack_require__(7);
var ascendingSuffix = '-ASC';
var descendingSuffix = '-DSC';
/** React component for rending a table */
var Table = /** @class */ (function (_super) {
    __extends(Table, _super);
    /** @hidden initializes sorting options in the internal state */
    function Table(props) {
        var _this = _super.call(this, props) || this;
        _this.renderRow = function (headers, css, sortBy, item) {
            var header = headers[0];
            return ([
                React.createElement("tr", { className: css.row }, headers.map(function (header, index) { return (React.createElement("td", { key: index, className: css.dataCell, "data-th": header.label, "data-selected": sortBy === header.id }, header.renderCol(item))); })),
                header.renderChildRow && header.renderChildRow(item)
            ]);
        };
        var headers = props.headers;
        var firstHeader = headers && headers.find(function (header) { return header.sortable; });
        _this.state = {
            sortBy: !!firstHeader ? firstHeader.id : "",
            sortAsc: !!firstHeader ? firstHeader.defaultAsc : true
        };
        return _this;
    }
    /** @hidden used to get a property that is managed by the internal state, that may be overwritten by the props */
    Table.prototype.getProperty = function (name) {
        var override = this.props[name];
        var internal = this.state[name];
        return override === undefined || override === null ? internal : override;
    };
    /**
     * @hidden event handling for the sorting dropdown
     * checks which sort option was selected and changes the sort state accordingly
     * @param value the new value of the select dropdown
     */
    Table.prototype.handleSortDropdownChange = function (value) {
        var _a = this.props, headers = _a.headers, onChangeSort = _a.onChangeSort;
        var selectedValue = value && value.first();
        var sortOptions = this.getSortOptions();
        var selectedOption = sortOptions.find(function (option) { return option.value === selectedValue; });
        this.setState({
            sortBy: selectedOption.headerId,
            sortAsc: selectedOption.sortAsc
        });
        onChangeSort(selectedOption.headerId, selectedOption.sortAsc);
    };
    /**
     * @hidden event handling for the sorting changes made by clicking the headers
     * @param header the header that was clicked on
     */
    Table.prototype.handleSortChange = function (header) {
        var onChangeSort = this.props.onChangeSort;
        var sortBy = this.getProperty("sortBy");
        var sortAsc = this.getProperty("sortAsc");
        if (!header.sortable) {
            return;
        }
        var ascending = sortBy === header.id ? !sortAsc : header.defaultAsc !== undefined ? header.defaultAsc : true;
        this.setState({
            sortBy: header.id,
            sortAsc: ascending
        });
        onChangeSort(header.id, ascending);
    };
    /**
     * @hidden method for calculating the sort options based on the header props
     */
    Table.prototype.getSortOptions = function () {
        var _this = this;
        var headers = this.props.headers;
        var sortOptions = [];
        var sortableHeaders = headers.filter(function (header) { return header.sortable; });
        sortableHeaders.forEach(function (header) {
            sortOptions.push({
                label: header.label + " " + _this.getSortText(header, true),
                value: header.id + ascendingSuffix,
                headerId: header.id,
                sortAsc: true,
            });
            sortOptions.push({
                label: header.label + " " + _this.getSortText(header, false),
                value: header.id + descendingSuffix,
                headerId: header.id,
                sortAsc: false,
            });
        });
        return sortOptions;
    };
    /**
     * @hidden method for getting custom text to display in the sorting dropdown, based on data type
     * @param header the header we are getting sort text for
     * @param sortAsc the ascending/descending context
     */
    Table.prototype.getSortText = function (header, sortAsc) {
        if (!header.sortable) {
            return "";
        }
        switch (header.dataType) {
            case 'alpha': return sortAsc ? "(A to Z)" : "(Z to A)";
            case 'numeric': return sortAsc ? "(low to high)" : "(high to low)";
            case 'date': return sortAsc ? "(earlier to later)" : "(later to earlier)";
            default: return sortAsc ? "(Ascending)" : "(Descending)";
        }
    };
    /**
     * @hidden gets an icon for the header based on if it is sortable,
     * if we are currently sorting by it, and whether or not we are sorting in acending or descending order.
     * @param header header that we are getting an icon for
     */
    Table.prototype.getSortIcon = function (header) {
        var sortBy = this.getProperty("sortBy");
        var sortAsc = this.getProperty("sortAsc");
        if (!header.sortable) {
            return null;
        }
        var selected = sortBy === header.id;
        if (!selected) {
            return free_solid_svg_icons_1.faSort;
        }
        switch (header.dataType) {
            case 'alpha': return sortAsc ? free_solid_svg_icons_1.faSortAlphaDown : free_solid_svg_icons_1.faSortAlphaUp;
            case 'numeric': return sortAsc ? free_solid_svg_icons_1.faSortNumericDown : free_solid_svg_icons_1.faSortNumericUp;
            default: return sortAsc ? free_solid_svg_icons_1.faSortAmountUp : free_solid_svg_icons_1.faSortAmountDown;
        }
    };
    /**
     * @hidden renders a display of an individual header, based on props
     * @param header the header we are rendering
     */
    Table.prototype.renderHeader = function (header) {
        var _this = this;
        var css = this.props.css;
        var sortBy = this.getProperty("sortBy");
        var sortAsc = this.getProperty("sortAsc");
        var selected = sortBy === header.id;
        var icon = this.getSortIcon(header);
        return (React.createElement("th", { key: header.id, scope: "col", "aria-sort": selected ? sortAsc ? "ascending" : "descending" : "none", className: classnames_1.default(css.header, header.css, { selected: selected }), onClick: function (evt) { return _this.handleSortChange(header); }, "aria-label": header.ariaLabel },
            !!header.label ? (React.createElement("span", { className: css.headerLabel }, header.label)) : null,
            header.display,
            !!icon ? React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: icon, size: "lg" }) : null));
    };
    /**
     * @hidden renders the display of all the headers provided in the headers prop
     */
    Table.prototype.renderHeaders = function () {
        var _this = this;
        var _a = this.props, headers = _a.headers, css = _a.css;
        if (!headers || headers.length === 0) {
            return null;
        }
        return (React.createElement("thead", { className: css.heading }, headers.map(function (header, index) { return (_this.renderHeader(header)); })));
    };
    /** @hidden renders the body of the table based on the items passed in props, and the [[Header<T>.renderCol]] functions*/
    Table.prototype.renderBody = function () {
        var _this = this;
        var _a = this.props, headers = _a.headers, items = _a.items, emptyMessage = _a.emptyMessage, css = _a.css;
        var sortBy = this.getProperty("sortBy");
        if (!items || items.length === 0) {
            return React.createElement("td", { id: "emptyMessage", className: css.empty, colSpan: headers.length }, emptyMessage);
        }
        return (React.createElement("tbody", { className: css.body }, items.map(function (item, index) { return (_this.renderRow(headers, css, sortBy, item)); })));
    };
    /** @hidden main render method */
    Table.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, css = _a.css;
        var sortOptions = this.getSortOptions();
        var sortBy = this.getProperty('sortBy');
        var sortAsc = this.getProperty('sortAsc');
        var sortOption = sortBy + (sortAsc ? ascendingSuffix : descendingSuffix);
        return (React.createElement("table", { id: id, className: css.table },
            sortOptions && sortOptions.length > 0 ? (React.createElement("div", { className: css.sortDisplay },
                React.createElement(form_elements_1.SelectElement, { element: {
                        id: id + '-sorting',
                        label: '',
                        ariaLabel: "Select Sort Option",
                        type: ssg_forms_processing_1.formDefinition.elementTypes.select,
                        options: sortOptions,
                    }, value: immutable_1.List([sortOption]), onChange: function (value) { return _this.handleSortDropdownChange(value); } }))) : null,
            this.renderHeaders(),
            this.renderBody()));
    };
    return Table;
}(React.Component));
exports.Table = Table;
exports.default = react_styleable_1.default(table_style_1.default)(Table);


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var tabs_style_1 = __webpack_require__(36);
var classnames_1 = __webpack_require__(6);
/**
 * A component that displays tabs and their contents.
 * Unlike the standard TabsComponent, this component does not utilize React router,
 * and thus will not automatically redirect the user based on clicks.
 */
var InPlaceTabsComponent = /** @class */ (function (_super) {
    __extends(InPlaceTabsComponent, _super);
    function InPlaceTabsComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            selectedTabId: undefined
        };
        return _this;
    }
    /** @hidden gets the id of the tab content */
    InPlaceTabsComponent.prototype.getContentId = function () {
        var id = this.props.id;
        return id + '-tab-content';
    };
    /**
     * @hidden Handles the event of a user clicking on a tab.
     * If the tab is disabled it will not have any affect.
     * Otherwise it should change focus to the content of the tab.
     * @param event Contains data about what got clicked
     * @param disabled True if the clicked-on tab is disabled
     */
    InPlaceTabsComponent.prototype.handleClick = function (event, disabled) {
        if (disabled) {
            event.preventDefault();
            return;
        }
        var selectedTab = event.currentTarget.id;
        // update local state
        this.setState({ selectedTabId: selectedTab });
        // set focus to the selected tab's content
        var element = document.getElementById(this.getContentId());
        element && element.focus();
    };
    /** @hidden function that renders the tabs */
    InPlaceTabsComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, tabs = _a.tabs, title = _a.title, css = _a.css;
        var tabsId = id + '-tabs';
        var titleId = id + '-title';
        var contentId = this.getContentId();
        var activeTab = '';
        var tabIdToShow = this.state.selectedTabId || id + '-' + 0; // default to tab 0 if no tab is selected
        var tabLinks = tabs.map(function (tab, index) {
            var tabId = id + '-' + index;
            var descriptionId = id + '-' + index + '-description';
            if (tabIdToShow === tabId) {
                activeTab = tabId;
            }
            var isSelected = activeTab === tabId;
            return (React.createElement("li", { key: tabId + '_key', className: css.tabListItem },
                React.createElement("div", { id: tabId, className: classnames_1.default(isSelected ? css.activeTab : css.inactiveTab, { disabled: tab.disabled }), role: "tab", "aria-selected": isSelected, "aria-posinset": index + 1, "aria-setsize": tabs.length, "aria-controls": contentId, "aria-label": tab.ariaLabel, "aria-describedby": descriptionId, title: " ", tabIndex: tab.disabled ? -1 : 0, onClick: function (e) { return _this.handleClick(e, tab.disabled); } },
                    tab.label,
                    tab.notificationIcon),
                React.createElement("div", { id: descriptionId, className: "ssg-forms-skip" }, tab.description)));
        });
        var guts = tabs.map(function (tab, index) {
            var tabId = id + '-' + index;
            var tabIdToShow = _this.state.selectedTabId || id + '-' + 0; // default to tab 0 if no tab is selected
            return tabIdToShow === tabId ? tab.render() : null;
        });
        return (React.createElement("div", { id: id, className: css.tabsDisplay },
            title ? (React.createElement("h1", { id: titleId, className: css.header }, title)) : null,
            React.createElement("ul", { id: tabsId, className: css.tabList, role: "tablist" }, tabLinks),
            React.createElement("div", { tabIndex: -1, id: contentId, role: "tabpanel", className: classnames_1.default("ssg-forms-no-focus", css.tabPanel) }, guts)));
    };
    return InPlaceTabsComponent;
}(React.Component));
exports.InPlaceTabsComponent = InPlaceTabsComponent;
exports.default = react_styleable_1.default(tabs_style_1.default)(InPlaceTabsComponent);


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tabs_component_1 = __webpack_require__(412);
exports.TabsComponent = tabs_component_1.default;
var in_place_tabs_component_1 = __webpack_require__(410);
exports.InPlaceTabsComponent = in_place_tabs_component_1.default;
var tabs_style_1 = __webpack_require__(36);
exports.defaultTabsStyle = tabs_style_1.default;


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_router_dom_1 = __webpack_require__(116);
var react_styleable_1 = __webpack_require__(1);
var tabs_style_1 = __webpack_require__(36);
var classnames_1 = __webpack_require__(6);
/** A component that displays tabs and their contents.
 * This component relies on React Router 4, to render the routes that will display the contents of the tab on a certain path.
 */
var TabsComponent = /** @class */ (function (_super) {
    __extends(TabsComponent, _super);
    function TabsComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** @hidden gets the id of the tab content */
    TabsComponent.prototype.getContentId = function () {
        var id = this.props.id;
        return id + '-tab-content';
    };
    /** @hidden
     * Handles the event of a user clicking on a tab.
     * If the tab is disabled it should not have any affect.
     * Otherwise it should change focus to the content of the tab.
     */
    TabsComponent.prototype.handleClick = function (event, disabled) {
        if (disabled) {
            event.preventDefault();
            return;
        }
        var element = document.getElementById(this.getContentId());
        element && element.focus();
    };
    /** @hidden function that renders the tabs */
    TabsComponent.prototype.render = function () {
        var _this = this;
        var _a = this.props, id = _a.id, tabs = _a.tabs, location = _a.location, title = _a.title, css = _a.css;
        var pathname = location.pathname;
        var tabsId = id + '-tabs';
        var titleId = id + '-title';
        var contentId = this.getContentId();
        var activeTab = '';
        var tabLinks = tabs.map(function (tab, index) {
            var tabId = id + '-' + index;
            var descriptionId = id + '-' + index + '-description';
            if (pathname === tab.url) {
                activeTab = tabId;
            }
            return (React.createElement("li", { key: tab.url, className: css.tabListItem },
                React.createElement(react_router_dom_1.Link, { id: tabId, className: classnames_1.default(pathname === tab.url ? css.activeTab : css.inactiveTab, { disabled: tab.disabled }), to: tab.url, role: "tab", "aria-selected": pathname === tab.url, "aria-posinset": index + 1, "aria-setsize": tabs.length, "aria-controls": contentId, "aria-label": tab.ariaLabel, "aria-describedby": descriptionId, title: " ", tabIndex: tab.disabled ? -1 : 0, onClick: function (e) { return _this.handleClick(e, tab.disabled); } },
                    tab.label,
                    tab.notificationIcon),
                React.createElement("div", { id: descriptionId, className: "ssg-forms-skip" }, tab.description)));
        });
        var routeList = tabs.map(function (tab, index) { return (tab.disabled ? null : React.createElement(react_router_dom_1.Route, __assign({ key: tab.routeProps.path + index.toString() }, tab.routeProps))); });
        return (React.createElement("div", { id: id, className: css.tabsDisplay },
            title ? (React.createElement("h1", { id: titleId, className: css.header }, title)) : null,
            React.createElement("ul", { id: tabsId, className: css.tabList, role: "tablist" }, tabLinks),
            React.createElement("div", { tabIndex: -1, id: contentId, role: "tabpanel", className: classnames_1.default("ssg-forms-no-focus", css.tabPanel) },
                React.createElement(react_router_dom_1.Switch, null, routeList))));
    };
    return TabsComponent;
}(React.Component));
exports.TabsComponent = TabsComponent;
exports.default = react_styleable_1.default(tabs_style_1.default)(react_router_dom_1.withRouter(TabsComponent));


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tooltip_display_1 = __webpack_require__(414);
exports.TooltipDisplay = tooltip_display_1.default;


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var tooltip_style_1 = __webpack_require__(415);
var react_fontawesome_1 = __webpack_require__(14);
var free_solid_svg_icons_1 = __webpack_require__(13);
var tooltipArrowHeight = 14;
var tooltipIconWidth = 36;
var tooltipDefaultMaxWidth = 320;
var arrowMargin = 15;
/** Tooltip that can be applied to some context to provide further details or help for a user.
 * The text box is toggled by clicking on the icon or open tooltip, and oriented based on the window size and position.
 */
var TooltipDisplay = /** @class */ (function (_super) {
    __extends(TooltipDisplay, _super);
    function TooltipDisplay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            style: {
                maxWidth: tooltipDefaultMaxWidth > (window.outerWidth / 2) ? window.outerWidth / 2 : tooltipDefaultMaxWidth
            },
            classes: "",
            showTooltip: false,
            anchor: undefined,
            anchorId: "anchor-" + Math.random().toString(36).substr(2, 9),
            tooltip: undefined,
            tooltipId: "tooltip-" + Math.random().toString(36).substr(2, 9),
            icon: undefined,
            iconId: "icon-" + Math.random().toString(36).substr(2, 9)
        };
        _this.toggleTooltip = _this.toggleTooltip.bind(_this);
        _this.handleResize = _this.handleResize.bind(_this);
        _this.updateTooltipPosition = _this.updateTooltipPosition.bind(_this);
        _this.handleKeyboardInput = _this.handleKeyboardInput.bind(_this);
        document.addEventListener("scroll", _this.handleResize);
        document.body.addEventListener("click", _this.toggleTooltip);
        window.addEventListener("resize", _this.handleResize);
        return _this;
    }
    TooltipDisplay.prototype.componentDidUpdate = function (prevProps, prevState) {
        var prevShowTooltip = prevState.showTooltip, prevStyle = prevState.style;
        var _a = this.state, showTooltip = _a.showTooltip, style = _a.style;
        if ((showTooltip && !prevShowTooltip) || (showTooltip && prevStyle.maxWidth !== style.maxWidth)) {
            this.updateTooltipPosition(style);
        }
    };
    TooltipDisplay.prototype.componentDidMount = function () {
        var _a = this.state, anchorId = _a.anchorId, iconId = _a.iconId, tooltipId = _a.tooltipId;
        var a = document.getElementById(anchorId);
        var i = document.getElementById(iconId);
        var t = document.getElementById(tooltipId);
        this.setState({
            anchor: a,
            icon: i,
            tooltip: t
        });
    };
    /** @internal triggered when the window resizes */
    TooltipDisplay.prototype.handleResize = function () {
        var style = this.state.style;
        this.updateTooltipPosition(style);
    };
    /** @internal used to maintain tooltip text orientation and size, relative to the page position */
    TooltipDisplay.prototype.updateTooltipPosition = function (currentStyle) {
        var _a = this.state, anchor = _a.anchor, tooltip = _a.tooltip, icon = _a.icon;
        // if these items have not been rendered yet, then we cannot properly calculate position
        if (!tooltip || !anchor) {
            return;
        }
        var style = currentStyle;
        var classes = "";
        var posTop, posLeft, posRight, maxWidth;
        document.body.offsetTop;
        // if putting the tooltip above the anchor causes it to go off the screen put it below
        var fromTop = anchor.offsetTop;
        if (fromTop === 0) {
            var parent = anchor.offsetParent;
            fromTop = parent ? parent.offsetTop : 0;
        }
        if (fromTop - tooltip.clientHeight - tooltipArrowHeight - arrowMargin < window.pageYOffset) {
            classes += " top";
            posTop = icon.offsetHeight + tooltipArrowHeight;
        }
        else {
            classes += " bottom";
            posTop = -(tooltip.clientHeight + tooltipArrowHeight + arrowMargin);
        }
        // default tooltip pop up to left of icon
        var spaceToLeft = anchor.offsetLeft + anchor.offsetWidth;
        var spaceToRight = anchor.offsetParent ?
            anchor.offsetParent.clientWidth - anchor.offsetLeft :
            anchor.parentElement ? anchor.parentElement.clientWidth - anchor.offsetLeft : 0;
        if (spaceToLeft >= spaceToRight) {
            classes += " left";
            posRight = -tooltipIconWidth / 2;
            if (spaceToLeft < tooltipDefaultMaxWidth) {
                maxWidth = spaceToLeft;
            }
            else {
                maxWidth = tooltipDefaultMaxWidth;
            }
        }
        else {
            classes += " right";
            posLeft = -tooltipIconWidth / 2;
            if (spaceToRight < tooltipDefaultMaxWidth) {
                maxWidth = spaceToRight;
            }
            else {
                maxWidth = tooltipDefaultMaxWidth;
            }
        }
        style.top = posTop;
        style.left = posLeft;
        style.right = posRight;
        style.maxWidth = maxWidth;
        this.setState({
            style: style,
            classes: classes
        });
    };
    /** @internal handles when a user actually clicks on an element's tooltip or icon */
    TooltipDisplay.prototype.handleTooltipToggle = function (e) {
        var showTooltip = this.state.showTooltip;
        this.toggleTooltip(e, !showTooltip);
    };
    /** @internal show or hide the tooltip
     * this catches any external click as well, so that the tooltip can be closed in those cases
     */
    TooltipDisplay.prototype.toggleTooltip = function (e, show) {
        var _a = this.state, iconId = _a.iconId, style = _a.style;
        if (!!show) {
            this.setState({
                showTooltip: true
            });
            // need to check for the icon id because of mouse click events happening twice
            // (whole html document is also tied to this by an event listener)
        }
        else if (show === false || document.activeElement.id !== iconId) {
            this.setState({
                showTooltip: false
            });
        }
    };
    /** @internal for accessibility, to show and hide the tooltip */
    TooltipDisplay.prototype.handleKeyboardInput = function (e) {
        var showTooltip = this.state.showTooltip;
        // toggle the tooltip on Enter or Space
        if (e.keyCode === 13 || e.keyCode === 32) {
            this.toggleTooltip(e, !showTooltip);
        }
    };
    TooltipDisplay.prototype.render = function () {
        var _this = this;
        var _a = this.props, context = _a.context, text = _a.text, css = _a.css;
        var _b = this.state, anchorId = _b.anchorId, classes = _b.classes, iconId = _b.iconId, style = _b.style, showTooltip = _b.showTooltip, tooltipId = _b.tooltipId;
        var showClass = showTooltip ? ' shown' : '';
        var ariaLabel = !!context ? context + ': ' : '';
        ariaLabel += showTooltip ? 'Hide Tooltip' : 'Show Tooltip';
        return (React.createElement("div", { id: anchorId, "aria-label": ariaLabel, className: css.tooltip },
            React.createElement("p", { id: tooltipId, onClick: function (e) { return _this.toggleTooltip(e, false); }, style: style, className: css.tooltipText + classes + showClass }, text),
            React.createElement("span", { id: iconId, onClick: function (e) { return _this.handleTooltipToggle(e); }, tabIndex: 0, role: "button", onKeyDown: function (e) { return _this.handleKeyboardInput(e); }, className: css.iconWrapper },
                React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: css.iconHighlight, icon: free_solid_svg_icons_1.faCircle, size: "2x" }),
                React.createElement(react_fontawesome_1.FontAwesomeIcon, { className: css.icon, icon: free_solid_svg_icons_1.faQuestionCircle }))));
    };
    return TooltipDisplay;
}(React.Component));
exports.TooltipDisplay = TooltipDisplay;
exports.default = react_styleable_1.default(tooltip_style_1.default)(TooltipDisplay);


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(304);
var defaultStyle = {
    tooltip: "ssg-tooltip",
    tooltipText: "ssg-tooltip-text ssg-forms-text normal",
    icon: "ssg-tooltip-icon",
    iconWrapper: "ssg-tooltip-icon-wrapper fa-layers fa-fw",
    iconHighlight: "ssg-tooltip-icon-highlight",
};
exports.default = defaultStyle;


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var widget_1 = __webpack_require__(418);
exports.Widget = widget_1.default;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(305);
var defaultStyle = {
    widgetDisplay: 'ssg-forms-widget',
    anchorDisplay: 'ssg-forms-widget-anchor',
    content: '',
};
exports.default = defaultStyle;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var widget_style_1 = __webpack_require__(417);
/** provides a generic styled widget display that displays the children as the widget's content */
var Widget = /** @class */ (function (_super) {
    __extends(Widget, _super);
    function Widget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Widget.prototype.render = function () {
        var _a = this.props, anchorDisplay = _a.anchorDisplay, children = _a.children, css = _a.css;
        return (React.createElement("div", { className: css.widgetDisplay },
            !!anchorDisplay ? (React.createElement("div", { className: css.anchorDisplay }, anchorDisplay)) : null,
            React.createElement("div", { className: css.content }, children)));
    };
    return Widget;
}(React.Component));
exports.Widget = Widget;
exports.default = react_styleable_1.default(widget_style_1.default)(Widget);


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var wizard_component_1 = __webpack_require__(420);
exports.Wizard = wizard_component_1.default;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var react_styleable_1 = __webpack_require__(1);
var classnames_1 = __webpack_require__(6);
var custom_icon_1 = __webpack_require__(18);
var wizard_style_1 = __webpack_require__(421);
var Wizard = /** @class */ (function (_super) {
    __extends(Wizard, _super);
    function Wizard(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            currentPage: 1,
        };
        return _this;
    }
    Wizard.prototype.componentWillMount = function () {
        var wizardRef = this.props.wizardRef;
        wizardRef && wizardRef(this);
    };
    Wizard.prototype.nextPage = function () {
        var pages = this.props.pages;
        var nextPage = Math.min(pages.length, Math.max(1, this.currentPageNumber() + 1));
        this.setState({ currentPage: nextPage });
        return nextPage;
    };
    Wizard.prototype.previousPage = function () {
        var pages = this.props.pages;
        var previousPage = Math.min(pages.length, Math.max(1, this.currentPageNumber() - 1));
        this.setState({ currentPage: previousPage });
        return previousPage;
    };
    Wizard.prototype.currentPageNumber = function () {
        var _a = this.props, pageNumber = _a.pageNumber, pages = _a.pages;
        var currentPage = this.state.currentPage;
        var givenPage = pageNumber !== undefined && pageNumber !== null ? pageNumber : currentPage;
        var page = Math.min(pages.length, Math.max(1, givenPage));
        return page;
    };
    /** returns the definition of the current page */
    Wizard.prototype.currentPage = function () {
        var pages = this.props.pages;
        var page = this.currentPageNumber();
        return pages[page - 1];
    };
    /**
     * Renders a display to indicate the existance of a page in the wizard.
     * Renders the display for the current page differently.
     * Renders an arrow to indicate the flow of the wizard for all pages other than the last.
     * @param page the page to render a marker for
     * @param index the position of the page
     */
    Wizard.prototype.renderPageMarker = function (page, index) {
        var _a, _b;
        var _c = this.props, pages = _c.pages, css = _c.css;
        var pageMarker = [];
        var currentPage = this.currentPageNumber();
        pageMarker.push((React.createElement("div", { id: "page-marker-" + (index + 1).toString(), className: classnames_1.default(css.pageTitle, (_a = {}, _a[css.completedPage] = page.completed, _a), (_b = {}, _b[css.activePage] = index === currentPage - 1, _b)) },
            React.createElement("span", { className: css.pageNumberIndicator }, index + 1),
            page.title)));
        if (index < pages.length - 1) {
            pageMarker.push((React.createElement("span", { className: css.navIndicator },
                React.createElement(custom_icon_1.CustomIcon, { iconChoice: custom_icon_1.CustomIconSet.ic_right_arrow_14x14, css: { ssgCustomIcon: css.navIndicatorIcon } }))));
        }
        return pageMarker;
    };
    Wizard.prototype.render = function () {
        var _this = this;
        var _a = this.props, title = _a.title, pages = _a.pages, css = _a.css;
        var currentPage = this.currentPage();
        var currentPageNum = this.currentPageNumber();
        return (React.createElement("div", { id: currentPage && currentPage.id ? currentPage.id : "wizard-page-" + currentPageNum.toString(), className: css.wizard },
            title ? React.createElement("div", { id: "title", className: css.title }, title) : null,
            React.createElement("div", { className: css.pageMarkers }, pages && pages.map(function (page, index) { return _this.renderPageMarker(page, index); })),
            React.createElement("div", { className: css.content }, currentPage && currentPage.content)));
    };
    return Wizard;
}(React.Component));
exports.Wizard = Wizard;
exports.default = react_styleable_1.default(wizard_style_1.default)(Wizard);


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(306);
var defaultStyle = {
    wizard: "",
    title: "ssg-forms-text xl ssg-forms-wizard-title",
    pageMarkers: "ssg-forms-wizard-page-markers",
    pageTitle: "ssg-forms-text normal ssg-forms-wizard-page-title",
    pageNumberIndicator: "ssg-forms-wizard-page-number",
    completedPage: "ssg-forms-wizard-completed-page",
    activePage: "ssg-forms-wizard-active-page",
    navIndicator: "",
    navIndicatorIcon: "ssg-forms-wizard-nav-icon",
    content: "",
};
exports.default = defaultStyle;


/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAOZJREFUKBXtkTEPwVAQx+9eX2wmJFZfopPNRJBYVUpX3fkMDDbWisSqid3me1hsmGzVvtNrXpVEOpjd8N79f/f/v+Eegi7LGo0J1AwBT4WCaHied+GR4ziVIFAHAqohiOl2u14xF3wkheQawmjH/fnxUE1NIQigxUyg6EDsSTlag+GOiHoMUGIdIpjEupsaEo64BwPmFNJRa1+mIQakwASCKvfvRcx4poszMhXJrWjxoV+CzPcg4yQojWJ5s1neXr6cxrbdUhjdr9lycszfRv/gt61o9vNyJCL6/C99y855PxvFXuDMEwujUAVpXT15AAAAAElFTkSuQmCC"

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAcZJREFUSA3tVj1LA0EQndk7IyR2gqVWISI2dqKgINb5AeYSPyDBP6CiYGWl/oMEREO0VVJbCXaCmjRKREgnYjqxiN6Oc5sz2VwuVmcKyTYz+/a92ZmXCyyCZxERWqmVPSBKE8EIItQIRGEoHNrIZrOfHrraZjKZgfeP+iGCtFgzzJpXQMwV8se7iEi6xtA3Tv70XF0nSfucRtyzMABN1227Xi7dX7lYW4hNTO5wg9sMMletCBDMnV8UX8qluxsXU0HoGyfnCReciIAHZ6d5RIFbai9B4U7uXeieCRSbSsNah/NTS+d3XIgAg4ogoKaixDcVkRq4rm7lISdlOxsaV9us1eKBmUyuzttS5pgebYjaLG9SudjMUiLle0jsn9/iCeMtDVYMIdKmJDvP5FE/QbAYRaW0TwR33oPLGq2zD2PYGtkzD8KtAFFkWxbZslnPqe+WP7Rr/htcSpBxdnnKj2T6gQpjAQt9Rd00TmPc4K/NdXyl3YoFhTcnFGiOFwpHj0EV1utY1lpM0teDg/V8wv6F+k8RSN63NBAb9SJ9S3U3Asn7lgZio17k/1uKCStV7dW7hp+NVSHQSPGzt6L7/Dc5VoQwlr8BmzCU8sdtO54AAAAASUVORK5CYII="

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAUxJREFUOBHtVLFKxEAQndkEG1sLSwURFY7UfoKN1neBkA8QzsJGBQmCqJ36ARKEaK21tvoJishZ2F5roZfscya5mJxwkGvFKXZn5715OzvZDdPQoigyL69vZwSERNxnh/eSy/iqxHX2g7CDDIdEmCHmeHFhvit5VjGjg1qv9+6JyCaT2WXCgyQcF0g1akwx5Sg3zxnCHIbh7FeGdSZahsWWYXcJnG0IcZ9gdioZ8dgeSSUHDOfGIn1mw6cgeppy+NYdpLiXpBUJjBhA00T2fDQoWrJjabqx+gNQ10BESqCYM09E5kZj1arAMq+KSMdEgzt+8LuYOqex7yqTma8J/Ng4q05krEpF7VxIRO6SJL6o40193w8/5HDtn8/fNHEc719oXGeq+B/ukV7IlAxafhCsVSeewANaZCl15VdwIg9xWxb5S55AoqAyfarGN0vrgOega0wxAAAAAElFTkSuQmCC"

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAm9JREFUWAntVz1s01AQvjMuNQOgqKIICQkpghUkFgaQkGCgElPEBMYhSBSxZAHB0oWlExJDWbqRNjWwQCd+FpCQWBgY6MrKVFRFlAGEEh/fc+K/OPXzkKgMz5Lj9+77vrvzvXuxzbTD4Xl3Znvy+xGTzInQLDP/IZKvJLzg+yvvd5BlzK574yKxLBLxKRFxmGlTiN/t4X332+3lzQx5MOFRxkaj4fztymcSOTmMI7HAYutCu/304zCWnnvezfOBBB+QiJW2h2Pmjb02n2m1WrjJ7JEnA+92aS5OBmK26Akxv1BSFaAnwb2sm/xMceJkoB342AiZuNEwRl5G9gibMp2I7Czy0F9bXVfza279Ei4VkgSPeLlrwuk8W1u5qnDXrdeE6NWAG8dIa0dWSFjipcQS9SIBeiBQY07hETZ8jTiRpq9LfKVjpLV2s9mc3ur8XGDiy1iQAyEoUkmT8mOuutfr3/L2tIWPwV/akB2LPICP+b6Rt4Xk9Uzl4KK91dlegu42DFlBwQy9MQX4eAEFULE/7NwZkNSJI+SeRi6HLaxNuL59YHd/VS4W7nb/7qaRRFe5MHZOYW3R1OvI/KUIHxIKHkMeN3ziqnCEHWLdRZP/QKArCForYmsTKhJPAhu57ScRqKzP+I9x8Kz6XlY4Xh4fxVI6ymecEHbeF99fPTfeQOW84SH8Ccyziv3fLZlJSLeIpkKmQroK6HDTQ6ZCugrocNNDpkK6Cuhw00OmQroK6HBbvdyHL9gsVderL+kEE8FFquprWuWiXvLf4qzhW/sIjM2JBCzrVOSN5Uzbt5DZc5y/yurGzVOxVQ6OMzX/DzYAxXEGI5fAAAAAAElFTkSuQmCC"

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAMCAYAAABr5z2BAAAAAXNSR0IArs4c6QAAAPxJREFUKBWFkMEKQUEYhbGx8iKytWIhj0CRhZVH8AT2dpIHYGMnG5bKUlmy0k0plJ0UKdd3rpnu7TY49d2Z+c/5/2ZuIhGT7/tZ6MEWroaNqWVj8fBIIA0deID0gopBe0meMumwk50KsIKjgcW/QcagvWR9ZcMhHLrwreGEJ8X9bnALjCLoivbKVbNnCbTkazN6kvWVL+j6Q/ilNmbzS2CoAXvwYAxPiCtHYRQpKqOsB3sNuENZ72GdQFQLDkk4R4oTky1Tu6vJgym04AJW/eAnfQYPbJFVGWXV42nAHFxqRAaowaWZBtRdDrUdlCAPB3CppgEpWLvcPzX1pN7M83061UAZ7QAAAABJRU5ErkJggg=="

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAYAAACbU/80AAAAAXNSR0IArs4c6QAAAnpJREFUSA21lr1PFUEUxd8aGqNIQ2EMFCRAiCZURBsSIxJsLFRCIFRa+SdQ8R9YaCWSWJnYE200WkggQWikwEJsaPjUxi+MGp+/s2/uZt74dt7uI9zk7L1z555zZ9/M7r6kUtCq1epJSkfBdXAenHXAVXYd3uOfg1dJkhzij2407gVPwA9Q1FQrTl/LK4DcCR6D36CRvSE55qC4kYkrjc5SC4EwBLZAnu0xccpEFQPl8kxaQ1Yf9RROgJ95Si6/FIqQX2rCkeZEyKsbUzAMrPln4nsOin3THmf7qxiEZ6QRX9rDdU1twEQP+ARkrTaoseN89eixvpknuWBsfCs/sUdvyl/IGiuAOeKzicsestdw2oG2TFaEP5ItAsJySqu/6NFq9pgZ46a7kUlL4Jvxl9MFUNgN/nrEsqGe9TNuAXMlyOrZfQLiOEjS1bR2WeG1+8VRx0pIqOe4FqD3+1HshcjcTT/u/9MdVx7VArpcjT4ed0Ev0AtjHxSxdAEUXosUS0ua0lYP+1B1aeUHbt9mmciM3JTLx5yead2EdJ5FCqcy4VrtrKs9ELnDTW76RcQfg7E/rDJ4CqbZfx0m6Vz2C4I41LZxh1ZuH5GXxG1GJJ4HeXbb6sxTeCevmPy8V9fGWL1ke1rAehrWLhu4h2DFy4XhqomFnsK3YbE3lqa01cNsXXe8BgadmP7pCDHbiEy+Y+5izvwl8oJvq9q7RT9TIB6I1FyIzDWaWtQW6B3+zX6Tgv5WqAbvRkGulX0lOJ3qEDyybEGv7/oDcBVcAffBH1DG5tQ8fQXDOkf8AWR/szR5jPYd7T4e4R2dgQrBNm4G/NL4mE09ZtRcff4B7y6cndL5ccMAAAAASUVORK5CYII="

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAOCAYAAAAmL5yKAAAAAXNSR0IArs4c6QAAAZhJREFUKBWNU7FKA0EQndm7SCAQIaayCAaTWMjFFNpoIwg2IkoaQWMQ0UP8BotU/oCQTkyMEQyIprCysxA7EVIJNtoJQooYvODdOHshx3okkG3u7bw3b3dm9hD6rM3tnSw6Tp4A5wAoighNxi+AcJWajJ8VCgWnl4Y9IL/5vBmzHatIRCtqXMWI+CRQ369UThsy7hnkcrtTDtmPfGJETeiLES3QYPmyXH5wDWq1mlav3z0TkOFPQMASH7PFtwqoHJf1CTSa1GQwGAxtOESHqkBiFr1Xq+eLhpFZ4+24jCkrJNBqCRmwibIK4UEidJvFRl7TPJKBQ5h1DZAgqRLDYjZOuQaERMMm+XVuD4x0ZomJaT/JIwsb6RkdCNaZ+9fErhYb3RKEuPYnyz1f62tEF0Wewkc/nkd44xqA7SQGCMY6v3TMo4z5eXeMED5B0zSj3+2fN+5C2C8auFcekmi1O0dqMtfdHJjIhHzKGuqz8hVKnUCgeY7eMjiAYGDiolKKoKatcn11rv2VOcu9LuI9q/eSifhC7z+QBn/fGHnLzfu8TgAAAABJRU5ErkJggg=="

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAcCAYAAAAAwr0iAAAAAXNSR0IArs4c6QAAA1BJREFUSA29V11IFFEUPufOum4raQRFkkEF1kuJQYViSKI99IMQxBauuy3bD0S9WT3Ui0QQFBURWG1g7uDugwSCWEoEPkSmQS9JECoG9oMZhUbKurszt3ON+TNldhbXgeGee+d83/nm3Hvu3EFwcHV0dEjd3b2VCk8fBo4VALyYc9xArRsRJjiHCUD8wACfFRZ6X7a0tPyxo0c7B/E8ELhYoPDJCwDYBJyvywRDPkkij0qS57osR8aXwtgK8AdDDaCqd+nt1i9FYjOepOzcK/B6rkYikdRC3yUFNDc3u0dGPt3hwM8vBGXTR8DX+fmSr7W19ZsZz8wdzRZzPTw61rlcwQUvcVUl5pSBYDC4UYsjWsnc0Wy3e9Ujsk9o/WVsi1TAurKd1fGhobdzgve/DDQEQiEOcGYZg1qpOC8DmH6gDVrWQDgcXj2XVIY551Ra9hciqsD4EY44CQr0OKgQYChVtbc/6bdkIJFMX8o0uJBHvoMxWe6JR6PviKjLXrLhwUG9LXoWAbS5BAwXe4syMD+PwpPKNGGPMDxIfEUoFCrVBQQC4d1Es9lwyb2VUvgxXQDnak3uQ1ojUNZqTAJ4ifVx7nsIvEQXQOlfcQH0bTEEUClR+a/8pWeAjHGn4Wl7NfYRNNkZE/EvLs2XvuskwFkS6AOzp7HxbLHXC9Mzs4lajSvTlgMaAhjDN4qaKfSfH9WyF3BubGYWErSi1zhD0wpA6DNSSOgG/8lhykJpxkSIP9wurCb/qVSK99CUlGeMJUd3HtumrwEBZIhxJwSkvq+tre0j3ROE63SERRwg3Ii+BgSY3mCXExJKe53YQZU8+AVJ5biTJYTAmkQsfQqCwfC+tJJ+5URAtr4UNB6LyX6B16eAgt/MltARDvE9QNE5DTMvwO8PHqWBSm0wdy1+djF+KBa7/1uLwejw6aKJuKEN5Kqlkuv35EsVsix/Ncdgo6Njp2gxbTcPWm38QOCf1jFHPXEsv0XH8v0LT8SChdHed8VMR4eMKbqfUk2eRnBviseiO4AXbUWG12jNfjf72tjix+SxS/KUxtrly4v9Ewg8+htDDwHUchLygoHUW19/cNDn8ymLkYvjelfX8wNUsLWUtb2E2ULfsLVk0xaS3a/ZXyCoKWXrDay6AAAAAElFTkSuQmCC"

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAATxJREFUKBXVkMFKw0AQhmdGqqAH0V69CCKoD6BvoIJQEE+macTUQJGigje9iOADmJN4SGyTemn1VGifx5sHBTXSGJtxtrhoFb2KC8vM/vP9/MMC/JuDhmkdAcPaYIaWPM+7+W1zwyhOMCQtQqwTp1Bk5tmXpNsuFLazPxlt2x4HTNoAPJcyb9EA0SYiJsww000fm6a5P/LV7DjOcCd+baoAxUqiTdWq10YAS2DRYb6b3jYEzGiz6qMorstwQTFAuBEEfosUEAQXlwi08w4vRlHHFxDVfXqOPQZeVjNC2Asrfk31EvZxDMM6FuhQKQh4CgQpp7zbI5BOaoF/oOk+oxLX89aZLO1oQFWBzsOw0qf1Vv0MTU9NlgS80pp8xnUut1LSb12/JapBuVweurt/aMjamB0bXXVdN9aGv6tv+AN7dDPPKREAAAAASUVORK5CYII="

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAvtJREFUSA3tVE1IFGEYft+Z0Y0yMfo52A8VLhbhKkVFaAcPHZIOeQqaZvaHWGJFIgg6VLDRqWvEEpSu+9MiVlodCkWESLwkoW5d/Ck9dNqLlEb7M/P1fquzzuy6toKHCD8Yvud93p/nnXe+bwA21+YE/vUJiIwxnJ6efeSob+h21DWUxePj7zeyaVl23qbab6h29cTEWL84MzN3lwG7RSI2eprr6hsW4xPjIxshellx3gDGHlCtLfSc7ut9nRbrHPUxMipNAuccjuOz8fjYuIlbN5Rl9QoweEyJaCQjYq3AAD4axPKODLSnsuq+kMeXbCqKq4XqBikhJ5ZNZmxUEMDmQ4RvedUkpmk9stPZmMf/1VRVzxmdsecUKJmDSXnOZpN82Q5cLpc9ndGHGYM9liDEeQGls5FIx2czXww7nc5j6Qz7QP4dlhjEhCSUN4XDTyYF7ujq6ppCEM/TjH+aA+kEV2l6pp8aOmjmV8Oq6j2Q0aCffFYxgAURxRYuxvOyghxEo8FPAgoXATHJ7ZXFqlNpNuB2u3evcFbk9Xp3afrvAWpwr9UDKRCl1kikc9Tgc4KciESCQ0TI9Ka6EbC0M3sypb/zeDzbrTyAz+erWPyVfEufo9bs4zUERCUW7hw08xZB7ohGQy8RmM8ctITZiWRK6/P7/eWGj+P5H4u99GYnDS63M2ynWj05exlYj63JS5f2DujsvonKQur8hb3m0CVuTE19jdHxz2JLHII/Fg3fs3DLRlFB7pcV9SHToT0/EQH5hdboD9VW4EMIPIuGC3gjrmCkhoPv0XDoOh2ibjPHMQldW10Me+w1hwsaNOevKUjjYxVbbSrtA+akIniQRq3Qd807cNboNUdqhCrKzW2anhiidztlcJYdYbSqsqI5EAgsWPhVjJIEeZ6qtu3MaAvDJHrEUgdh0lYmNgWDwYSFL2KULMjz6fLvT6W1Ebpz+7hNo/7ObFJjrKNjjtulrHUJ8oKKcvWoxlKvgCGWSdAaCoW+lCK0GfP/TOAPKR//vWzIbJAAAAAASUVORK5CYII="

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAc9JREFUOBHlUDFIW1EUvfd9PxJRcXEpRapGN4mKRTJ2ESRi7Gp+fv63JWq2uLp06e6UqmA/JmncFIxQXB3sGlKIg1ioS4cuLc2izX/X957/yVeRtmt9w7v3nHvuefc+gP/2YMq2p4HDOiG+rZS2N/9lU8uyX3PCVYOxJaZMCPqQ4J1lOXN/azRvu0kC3ACgZ5z7GwwAa7KZiBgnXrHthfifzNJpdxJ8f0f2qF7EOjPbMIOIjaA50vJb+47jDD1kZlmvoj7xqqhHpAYRTqCrI4MS2Ha2r+VffBJzPZFYVM/aTRb3PO+7wsHlum7v5W//mAii1zL4Ru1mvLK19VWNVixunoOJCTHZL9VDNHhxyQ+y2WyHNsrn8xFhUtUmgm8azExIE2WqhTKmUpkpQDgQu5uKR6zOzSZeNhoNOj39sksAyUDfMpgxUyp5hwEWbXfOfNpxgHNP0wi4DkhcTJLTHENcKJe3bzSSN3RRx8/1Wi0WG+ME9CLgJkR8ruvi6TcfysW1Gxwk94wkX6/XjkZio09FOh7oVEAG7yvl4kqY07n6bA3CcTjavyzW+hjiDocGBxZD+FZ674/C1Vwu1/njZ3NPrMN6ujuThUKhGa4/kvwKJG6ftYR+n/8AAAAASUVORK5CYII="

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAABB5JREFUWAntVl9sU1UYP9+5HdlGNAoRJEZkcfgvsa3zH8uMYAyJyAOoRM263jZdHRJ9qcH4ZJzvGkl8MWNj7b1t1YgvA4Ro1GjGJCYkW6tmcUHQB0U0iwQGZb29x98Ztr27PXeUmb71vPQ7v9/353e/c+53y1hzNTvQ7EBjO0AyfTgcv9cW8x/CXMc4T2SMZLaxZa9m7+uLPC+Y2CcE/e7TVvQaxv6fSdf126wSfceYuP0/ESXStJ0ZY/RwI0WFdH2bKLEx1PDJOujMr0St3dyy2ZBDjOQ0Ztsfh0LRh+WmEas3EnmQ2ewT5F4QI2sIxu4QojDEoWyzu6gQop2RfTgSidzp5v7vPhqNbmAWOyIEW1mTi9gTHOBUDQEAAWuKFjuq66+sVvHLwfr7+1cVLfsYsq9Vx1Oec2rZjRM8r3YQG63ShUOJRKJNzdePojOthYI1hge9WxVFRBc0LnZz0xz5QeP8WTjNqxyBdZ/7azYzODgou7msJWOLljDxRvWoEkBMkRg9ZxhGbqGIaY5+xYlicMbdql24U8/MnPplXy1THzJz6vS7yLHL01vwl9Lp5BeS18pOudxU3h8MzkPSk2Vs0a9gj94fCM7lc1MTi/BrbHrDkQSzxVuebpzezKaT75f5iiAJoNi43x+8FeZDZQfX71b/A13T+anJH124chsK6btwFPtBLgzgGiei4Ww69boTr7kXO3Zsf5URHXI6OWwStp3CHHncgSlNXY89hjwmjqqmhgyA0KN3dXbscQcrlQ8MDLRfnLvyNa7UI+6AhWRE/zDBezKZ0Z9UPN6oe+aL4jjiV6l4yDmp8Vs2m+Y7c25eKUg6hcMvrymJyxMYSMrhSMR+I9a6KZ0e+sOZNB6Pr710uXgCYjY48apNZ9rbWjYNDw//WcWqlrKdkjbND86t8NE2mH9X3asW5sl6Ia58FovFbiij4fDelRBzZAkxs5y0p7zEyDyeHSoXwV3otkrWl9grhyNmyOcbOzu2S/+ZmdNjmDXyIWoW/Aoa17YaxoHxGtIBXFOQ9O3ri+5EoU+XuKBJQfhCCRF35K6YEGODeyGTMQ5WQA9j0Wvv4cNyucnpgD8wi6n5tIdPEHiXB4dj4K9lMqkDXrwTr0uQDMDg/N4fCMgvtHL8O5M6bXwB3oOYt53YUrbnpVYFpc3UG5gtH6k4FYajOtjZ2bFXxXlh1yUIBcTqm2+M4gy+8UpYwYmNt/gojA+rXcHqMOq61O48GHw34et9HJf8Pjd3dU/Tba2+npGRkVk1740uS5BMp+sD60t24QTm0TpnenTxLDrTnUwmzzjxeu1lC5IFeqPRIFniW3SqPBwvMh9tyaZSJ+sV4Par+y1zB8p9fnLybDDQNYEubcGTncefmRezhnFdf09UeZtYswPNDjSyA/8CF2hasQ+bwmMAAAAASUVORK5CYII="

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAWhJREFUKBWNkT1Lw0AYx5+7C3aIddBNoW5urQVxcHIQi+DkG0JzMa24+v4pHBRxcBDEtEkdXVREB5XOgm+jH6Noa2ru8U5qjCXVHiT3vPx/9/yTY9DmyprWSjKZPkml093PT4/XpB2Oc2tSIJ4FWkK3WJC0CAwjb+l6x039w++VklRD1v8naJjWJqLY9+r+mMY6uYB6HyFkQNrMtrTKeW5DoNgOjBC402h8AqCWKBYP7yNB+SPWQeBOAKmAkHdgkDkuFMoqpeoVXoaRW4uCCMWpb0jpf30j5wurCLgbPkhNYoRMu07hIlwPrMpJywhiL9yUsUcV5BbOm+rwBZpmftQX/m1T0yOMzZSKRz/3FxIwzhcHYzH64vsiLuvDjZ7HKJ11HTsSUhoN0Z+v1iADXfo4VN6ItLAknznHsU8bh0RumjQ7AohDUHm9griewWr1oGTbD5HqUFFOhITML+W9lKHi9bju/5DiPwEEnHnbv5dTdAAAAABJRU5ErkJggg=="

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAyhJREFUSA21lktME0EYx+eb3YIK6EkvXkSpiR7QqwdDi5oYqRI1ktjdbUsFNU30ohcvhoMHD16Q+ODRB1sgsR5M9OBJDejBo/HiA3kqPkKkaoIYQ2f8pry23W67LbjJttNv5vv/5vu+eRTIf3hU1a8wTq4RwiuBQqdzR/XVtrY2JlCw1jyv5r9IGG836iIk7nRuDwjomgIVJXCBE3bTCFtuA+g7a6qbpWXDKhs4ezqTTF5HmW0WUnu+J5NV1KKzKLPP59sq0kVhsweLNGjlDARaVw3ENIbmU2TY6wsejMdvzEqwpQGFhyygr1ZVQ0ULnOeM3VkUn0PQ0f7+3ieadrmC8enHnPP9S2AAMibRda6SI1RV3zmE3V4SxO/1nPBHiuI/ICLdtLHiCKb3xUI/jAuYrndNlhQhLv2zuPTvolgu/zmJSp54PPo0FApV/vw128XL5SsD4fCEgOdyWJiUxSemsRUj68znCwC/OeWeAV1/li1TVEoxjS2FYAKAtdsAjNwSWyUbaDtCTOMZTGM3ChT0wQUy6ZBpXSwWG88G2tr4uPSDOO0euzAKZbhAIiaYgBcEerVAAEgaZkqPEMh84CMpl939veGxTPvKr7zpUZRmPwEWwZoUhGEaP/EyuW4gEhldkTe3LCPEK8ZHgEftwmQJXH2xWF6YwOcEYho17IvZg8EUEIcb992IOR6zxQRUFJ+Kee61D5NdfX3hD2bp3JaM2oibmgDYguHu+OyQwV0MTEwhA8gJOWwnMgGTpTI37rPh3HFYW9PAYDBYJYY0HmvALUDuWQ9HFJAvAqbr3e/zjbPqSwP//E3pqho41NTUlGps9Ch4FiZyOaD9KxC5ZJjQpJhCnDRx4dXyUFyiAuqsqRa1vG+ECthCzSLvjPZi29Lo6NQuxlOX0FEmnJ2qrd37sqOjfeTkieMPZpI/dqMdX/gmUUc9HldviwVkj6eMze8zGNOXqKY11+NJP4+RngagnQjDfdbzxjCu5CZ4VX83HswtRoV895lxXCltSjgxRriowScII55EImE6GEqBGH0A/4O8RkMK3yFOYbBchufRaHTaOGgt2/8AQSQngduGNSIAAAAASUVORK5CYII="

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAgJJREFUOBGdk01rE0EYx59nZjcJ4kk9VNRDIYIi6Ll4yctJY40iXky6bm+e/AB6EW+eiyelzWYTFevLF2hF/QqCGo2ItNRGMK1QAi27M/5Xu9nF7WrqXGb2P8/zm+dtmf5j1etXzytNd4j0smnwNcdxPvFuOYBcUlo/gp/x25eXKCsLYrcgRHEAPjLy00do03+4TY3ktFOtZl0k5sv5/LjV7X4WiOoubH9lxEwcI6chiOp1+wJcHmutT31fWz9+ND9+s9//0UN0FUCWDcmT/wRdsaarpPU8IOb2Uyf6a+vHqtXKjU6n+4XZuO26c38vdtAdTfQkBhmGzYJm2m7zeiik1mhqyp70lZqHYRhJ6IOdV0zJMzEhXv1IrlnT55RST6FkIjU88YohM0XHmf0YKsGemCOkU0FHnuEuAUFhv0qRLTSb9z7EIQkQ0jmLdJ7vDOFVJllotWY7f0KC7+FA1izrjJ8aCa/iVyimQYYgdIW1z7fQ5mzyNe4FkEaj8T55Fyls2/aYUvJgLieXNgabi4CdjF33pDCLrnv/XaTtfBKep097vrewsbV1eO+ebBnT/iYwRWG/MYnSKJDAXmhNExj1feyphcHAO5TJiDJ6+QJjX2q3594GRqMsg1hPEMYXwP3E3qLvU+lBq1kexTluY6DOY0jjJaJ4LUi8yuXMbtxg1PNPPba3de3eV00AAAAASUVORK5CYII="

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAABExJREFUWAm9mE1sG0UUx+etk6aKSwWIL/Eh0RC34SN2IBI0IG4lB0DKocWN/LHe2m0glCDEgXOuqAeKBARCRex416CKFipOqF9pxAnkQxsJCVWABEJwoWnTEki8u8P/ma5xbK+/nZHWM/Nmdt5v33sz+9YkNrFEIol+KcyjQshnofZ3EvS2rqfmihE8xZ1OtlU18bhl576BDj+uHlx3SCHGAoGhbZcuXTzt6N4UoJCmDdmmfRZKb3cUOzWgnvYHAt6lm1AdB2IYkZOAkWUwDhTqZ/z+od6lpYtnuoqEHWkqpnjQFnJ7rcWlkG+ForHfqNbEdoxHIrG9tpSfYa2qBiDiQO9AUVXVb9l0RN7SO56ZmVlmFeGwug/x8imarlBE9IfSbp6wpg2aljgrpRyl66tnQpOTt7EOw5j/XChKCE3TTSeOgSNttVA0mnjMkuY5IeWd/yul7JZu2pNMJq+yDO4Lwn0ZNDdsKIXoHZxJb7bNQrFY7NFyGEaQw+umfVrTtFu5B6XHyeMJo2lxnwspdJRh8u28pMUfhjEteU5KcZfbUoiP77q7aNSxVDSqjVu2rYPmvYyefMO5r2WXhcMHHhFkna8GU1AGKG9vz3Ozs7PXWBaKxYYzqVTWGee6JaBo9ODDeB2ch1vuLl60epu+3ebtGXWgSuc2HUOIiYHGYVi9fPLG32vxUhCn35SFGCZnSrhJ3uMsVG+Nrf2+YaRec5vfMFAkEt8lhbXQFAyJDwx9/rAbDMsbcpmqHtqJfKYpywiiGT3tbhkHcsPh5Agr1QxjWusIYHFvpfFqMrjpQ0NPHsbWx9ujeqkLCDHjy5nWAgKycRhSPtL15Kv1wDBqzRi6mXZyzNxX/dkqjBLNGunkK/XC1ARqBQZP+rGup15uBIaBXF2G18FDtuTdJO6v8OzVRUTHjCZgXIFC8XifnZMLmPBAdc3lo6SIT4x06lCjlnFWKoshhhFr+QBuGAZbew4xk2gWhqE2nEMTExPdtG5+jd3UMAy2dnJn/46DrcAw0IYYymaz9uDQE7/AbHtLx3iyW0EunPL5+hLT09O225x65XkLhcNT26empvjjTWTm507haYN40lxdixDN+/r74u2AYX15IKlc3/Pn8rWTDhQOsi+Rhu6vBQVLpuGmA+2CKQApUo4IKZ6/srxyAotv4QEk5V9IonE0KyblgNXhJq2dMAUgnDUj3MFp/MLlyz8VoDLp5Ekk3+VQRIavf0es3TDMQLyz/lpdWwHMVhbkC9FXcMU+KFznfvE3FdyUGRt7UQ0Gg4Uk/b+b2vPrGRgYHMZn7GTJcruuLF8NjOx+6gTvPHxzf49/KX7AnH8Ao3UKhhkI39OvC1u+WwKU78Iap7zerS8h/61vx1VapEGZgmDOx0+l+5C8jN1YXTvObq003glZF4B2ly9MvyIxWeRLkZ4Lm2mhLihdged+BNQiSeWCongW0+ljP5dDbo7kX9Oeple0OWLCAAAAAElFTkSuQmCC"

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAehJREFUOBGtVD1PG0EQnTkfEsLOLwiNUVKSNk1iISW96ZC4wz5B4sYFoPwB/4EoadI4EMXmDskVkDqRIpMqJRQ0UdLEDS3Civyxk3ln7nQ+TGFgpL3dnXnzdnZ25pgmiOOUXxDJCjEVROghIMzUIaG2rlpB0PiWduOkwnU3HgkNPorIkupFnU+E+A8wTJJX0idYqnxnsl/7/u4v2CAxUam0/mwwHHxRUE61H8jMvA2Cnb8j2OjrOK/myeq/0ciqSnphZzLFZvPTj5gIkRjp/9QITMaylyMjAJVKZQ5zvV7vYoa4rvdcyByIxmyx/RSRWTDgOogkTVKr1ezL7r8zDKyBhfj+52Ng9eAH8IWOkVgh+arU74O9xjaUSVl1S2Fi9/2mPsC4OGvld2Jki4lf6in6OghKczIOG+0mEcS40Ke3CQ5LE1vA66QTG4E9z3uMHEb75Bz6MJ+Cw0KdRE+cBEXrXt809CGa0X7C/BsccQInAEYq5uyNtoTB1mt19I75hG7a5QI4LE1zGxUbFtuUFKGPyCI4tI64pf4cVuyURFc+2h3csgJtQPSOslbRJte4RM4JIyUhVn3gC46wstGA6J2hGRymyXLZ2SJGkgcYYOEDX9jipkX/GDFHd2ra6LR7+Y1EZJhv82P7D6a59l0Y5bPCAAAAAElFTkSuQmCC"

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAABGdJREFUWAnNWElok0EUnjeJlFoXFCxYxLuIC17EFVcQq+2tSltTFa14EXqoVvAoKHgoeBGKRruJ9tZoRdCDiEs9KFoQ7y4VKihtbdySjO+b/G/yp80qpmQgvDdv3vL9s74XUkW2xpMnF9HEVK0h2k1KLTfK1CijaqwbUqOkaNQo9Z6MeWAWVA3dvHLlWzEh2GdhrTF0pF4l4qc4+Fa2CBZmpWKK1GOlA5dv9lwfLMQmL6BQ6OiGeDx+iWdiUyEOs+nwzD0NBALtPT3h59l0IM8KaGBgIBCJDF1KGNOWwYH9cjL0gsiMJkiPQkebRI0xVGPIrM82k5qos66utr2hoSGewW9mQK2trQunor9uGWP2+I2I1Dv+0ouJ+XPv5Nsb2Gt6MrqfZ7bDGLUi3Q/dr5pbcbCrq2vcLwc/Y4YA5vvUr6dKmZWizEDGFOlz9fv3hrN9mehOp5jpwTv3jiqTOM/AqlPj9HZeVcWm6aDSAFnjyNBd/8wQ0Stl5tT391/9mHJWPNfUdGyZoj+D7HudWLPv+/V1tfv8H6llEBR7ZhqYSPWSxZtzgWF9agyFtuMH3u/Pz8MHL9MWBhEROWIhpvRBnQOcplg89kwGMTMA09nZ+UNkmWhTc8ttdtyAMbYZ6O/rPpBJT2RtbW2VY1++PmEbN1PBQHCjnD43QzjaYmT3DC9TXjC8DAIGtuDt0oijDNT6ZN82hjfuj20B4dJLu2d4A+daJolTUZEY51n5KX3wkEk/G7W+OYaMI7a9eFmQnCHcwF7D0cZpkn4uGg6HJ3nNWxjIJ/tjHrJcNjKGGIglffsKcIdwX6iJqTHm7XPAF1dLX193j1MsIdPc3BLii7fbCxFTC6qqNR5KAcM0hkuvhBjSXHuxYp4wCCwar7bT4ocw3w3sdP8DY2Ph8fUasAR5D3AKkWx4m2SwUGrTkckfF6Bv5leeLfaDEJM39Q7YA0uQO8lcBgJ+KDFQTKOJaAf7OAEb5nHCzhRlzzH5SbENWLRLrlgkr3YxDnlelqb0/XxKmotLi8mJXvLY57KYxTG+OozmhXPLhHxmFuPbUP6YvGSfNXJgAYHkSvjZov6YwKKRkEtwm+lJZ5aoPyawaFQHLjYn8PbmdoLSMjZWsmiwgYBFo1ThnrstkXaWFkbKuxdLKpgYsOgZtyXnwMgcU2al4RCDN3GH8+69Esljz3WTDCAhtzmwCEpEESMt+fcwWEAo4lA3udickOdLtESX3x95eZSfl/FM1PrmGDKG2FJIuouRSJ8WBVsdcEKOdFNk2Sg7eCRjfl5k06n1aZP9VAWCAlL03F4ZGXn9Yc2atQv5czd4g0uj0Z+rdu3cMTg8PCybXuwcHRl583r1urUPSVO4v7fbJfBOwcd4+TTqvW0iRuHY23vjmvT5gU21siuDUB+houR3+63AtNUB/X7ZdOjw8X85fbCBrWIf1pc45hiI5a/JMJQ2Q6JbVqW0gMKXlc2fDQIKtGz+jvGDAl82f1jNAFbiv/T+Akw1Xpi7Ap1WAAAAAElFTkSuQmCC"

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAXdJREFUKBVjZiACxMYmuuvo6h/SMzDgv3zp4gGQFiZC+mJi4iP//f+3mYHhvxTDf4YQmHq8GqOjE3L//f+/9P///6yMjAzX2ViZPAhqjI6Ob/7P8G8SUCEjUNNJZiZe2/nz5z+GaWSGMWB0Q0MDk5SM/Ayg0wqhYjuZmcS8Fy+e+BGmBkQzInNyc3PZ3737uOw/A0MQVHIZNzdHwqxZs34jqwOxWZAF3r3/tBaoyRskxsjAOGnJkgUFQHcChTABSuD8Z/gPd8F/HBpgRqBoFBbkDwLasB4s+f9ffnRswuK0tDRWmGJkGm4DTHDVqlXMGzZtncHw/38KSAzo5O3c3OwhQH9+g6mBiCPzkNhRMQmtDP//VYEVMTKe4GBn8Z47d+47mBKM6IBJXL50YZ++vv4HYMi4A8Vk//7976una7rp8uVzn0BqUPwI0wSjlyxZNJGJkTEW6O/fwNSj9Z/h9w6YHF6NIEVLlixcCvSnH9C3z4CGrIFpBAB11HO1n1X7mAAAAABJRU5ErkJggg=="

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAA0VJREFUSA2tVk1ME0EUnumvAUNIjCYGfwmgxtCCgomJFzxAqgcDalCy3bZi6gGPajyY2IPRi/FgQlUS29Jte0BDPHFANEQJIUETaDUxwYBeuODBaEX7szu+IWwzne3SH5jLzvfevO+bN/NmZjHawiYI3t0KSvkxQu0Y4WeSFLyHMSasBPi2prnd7sZ0howjRA6ojCA6GI0OX1cx/RpYUGlfEDzHMlllihVb48JI5Dk3Leh0ek4TpEwSgnbx5Iigh7zNyBvKwYLgOq8gMooIqeLiCML4Viw6/ICzV76kgiBeg2oYATErR5rFyOiJRYY12dFxFWXY53TdgSV8BPF80f3FRuOFaCT4gptEDpYlSAjBXxeXHiMF3c4xrHeg/H9iE3ZEw6E3vI/F/AxZX17f6/Wak6upMCzhpTzHGsDLRoOpS5Kef9L68i0lCTqdN6oVsjIKGXbmh1OEFyxm3BkKhb5pfVpLUUFRHNiRlZNjcMZOFAj/aLUYHMFgcEXrK2zZ8Bx6PJ69IEYPtFYMo7fbrMaOcsToFHQFnc6rR9IZeRrEDvNzhQJ52dRQ7wgEAr95XzGsKyiT9Cso/T08AdyPTxsbDvb6fL407ysF6woigvX2Vy6FWG+MrqDZhLqhApf5QILIwMLCYgwytPC+UrBeFmuxff39+1EqMw6XcJOGDOPXtTXVPX6/P6nxbWDYUJDGQaXuTGXkMRBt43mgeGarq6xnhoaGfvA+Pay7pGoALfvamu0dgCdUm/qFi6D9z+q/KVH07lNtxb5FBSkBXbamxvqzkNEITwiVfEhWUtMul+so7yuESxKkgfQYwHG4DLXr54kg07pMFr0TxSsneR+Pi+4hH0CxILh9ClHu8j5YgVUDxhclKQRXYeFW1vOkUsTjc5M2W+sKZOsAGztpM2Tba7PZlxKJ+bg6nv1WJEgJEom5Wbut5Qu8+ucAsjx0m7qbW1p+JeLzM3Qs29iBrL2kfjw+/7m59fgMIkoPBLAXAYZj1GW32zMw5j1LVnLRsEFsPxYOTMDj2wE/TZonCv6kbrJjaX/TgpREkgIfTAbLKdjM7xTnGkHhXH+9w2447ysbi6JYJ8toELJtgyV9EomE7kPl5v3q/we5RAaBulx2mwAAAABJRU5ErkJggg=="

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAf9JREFUOBGVk89rE0EUx9+bzTZYU+nFi4gFQQ+eelXBg4pS/JFb0PxyIiIleAkeRczFfyG0gdhtuvEgpYoVSk8e/XHxFg+tQvEgWAUDtVKazPNN7aQzIZvSOex777vf99mdN7sIB1hSytHtNs0C0DgImGzU60umPWaS/WI+f//EdntriYjOaC8qmOIwZvqESQbFtJTj7c7Wuy4EURHiU7sH7aJfnsncuQII8wwZ2b3/V6BIh2HwyvYPfKN0TkqGvLEgPxHExV6IBkaCsln5GJSaYYi/82TEL0O+ONdoBO936p6L11NDuVyOHTs+Ns2Ah3v38GN8SFwKguDbnuZmzoyKxWKi1frzgoAmujbExcRw/Fa1Wt3san0S5/h/tzZesuey8SHgVPLmtQepVKpjtKjozogn6RiRVLPZJEeLKJzG0SOJJPuWjZcIiisrXxdKpdIho0VFB1SpVDZOnzp5HQU8Mw38Oskf67/eFgqFo0brF51h2wY+/rIi9cRoiLCK4E+EYW3VaHaMBGlTJiPvEqhpTv8fCuK6h+LG3NzMBxui84EgbcjlClc7qjPPaULXiLjJTbfDcPa1rs1yZmREO/LTl2Oef4G39l3r/KEOK6KFbDZ/z/btC9Lmer32ieL+WYZ93m32+Pd/dGCQbnheq63RyOHzvLdF3tqaJ8SkDfoHtgeiSN+YM6YAAAAASUVORK5CYII="

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAABE9JREFUWAm1V11oHFUUvmdmf7KxUlu1KqIkmtBSTNNYEItiqD5oiNqqQSU7s7utsvpgwIeq+CAEfRIqeRAFdbPZ/2qw/tRKpSDVIq0gJdvEvxLoj6Ki0BpqbUx2Zo7nGjfJbubMzs4m+7J3vnPudz7mnnPuGRAr/NP1J26xsPQWhelEIb70KSKeyWR+4cICZ1gOXNd33m1a1gdC4OoFPvhZVfz3ZrOJHxawhZWysFzeVTgc0UzLPFgpRsbAGyyc3ctFWxFBYT36Ih1PhoIGmMDXMbhQOYMXfHR0VA0Emt9ExBdoP5cOpgLw1Pj4iW/tYnCb7HwdsXg83nzx0sy7AvEBzhEALglFeSyfGTnA+nCGenBdf3qdaU1/QvlxG7cPQPwhULk/n099w/lIvOEji8Vi7YZVOkxiOvhAMCmCvm2FzMh3vM+cpaGkjkR2bZ0tWUfpmG52CHTMp67aWkgmTzn4zJs8C9K02A7DND4npqvm2aoWlDMfXrPuynsymTfOVZnYR0+CNC3yDArcR6whjhkU8Xp7W2vf0NDQNOdjh9dVZVTOoOnRVxHFc3Zk/2MoAJ4v5NJ7HHxYk2tBAwMDwXN/XkhRvjzOs8EMKEqUyvo91qeGwZUgqqQrZg3rI4Gim+OjfJlCVWwvpNNHOB83eE1BkUj8RtOaOUjHtZEjpB7zk0C1J58f+Z7zcYs79qH+WGwzmqXDlDM3cYQgoAjQtC2fHz7N+dSDs1VGo0M3GHiExLAXIR3ToWBQvSuXe/u3eoI6+bKCaI5J0TFdzm2mN5Oisu5NJpN/cT5ecFYQCHTML7IaXgLW2sMKoorZSZsvsgSIT05Ont6v67svY308GBzfQn80ugVMcYCO7lqeG443h/y9iUTid97HvcVRkKShHtQyW0I5im7gaeGMAup9uVzyJO/jzsIeWXl7KpU6E2ry3UHz31dlbOk/tlhoHqXb/86ltvoQxz5UphobG5vecmvXXguFfEtcgwzRhdu/qaPz5MTECc8N0pUgKaxYLBqPPPzQvvNTU6vpCrm9LLbq30e9qW9TR9eFiYni11U2V481c8iOJRyOPSsAX6NkZ4+cBvmhtrbW3YODg5YdB4d5EiTJ6Lurj8aMLIlqYskB3vf7QKc8/IfzqcY9C5JEMokN0/yYKnBtNfH8MxVDKOjfPjw8fH4ec1g0JEjyatqu9VRhn5GoFj4O/BjwQ4+sWN5nzsLmQK2NZbvsPdQYKcnheBlb+o8bSgYek412qa0SaViQpJNdWlWu7qYLlxqo/e+/bm/gF+FIpMfeYw5dFkGSKpvd83d7e+uDlOgJh4Cr0BT7NS36KOfTcA7ZEdMn0ksWWi/b2eYw+LWQT19vZ1+2N7SYPJdLvQJCjVGTLC3GF63ZgW5FBMnANF+nKad6SVTFAEdHctanBvoXiatYur46Kna5fBgfL57q2tz5KX2oddGHwBoSc4jm7x3Z7DtnOYp/AZS3XdYBQd74AAAAAElFTkSuQmCC"

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAclJREFUKBWFks9LVFEUx7/nvJlItIw2QZsWKoKBTJArrVYtqoXgJhhH36NioNm2CvoHgoJamAvj4bx5M8vQlQtBA3VViqgLNxIhpIt+Em7y3Xs617qh1OR5i/vjnA/fc773EY6JUulup8X+cwIGtHQHxE/rtckJPTePkZE7l62YWRFpB2EJQj2AnCXmMjfDPKT5gImvNdLkypn21gsAfYbYB/9ULEZRgTKZd5B+N+rV6pIXKJZGFxTq/UuxXC7nKbMNbS8XcHDzCBSGVyHoF2DxiGIYhhe1/kRm9lcI9Ags51Rpr15LHg6HYT8MZvRsCLm+P6CbyVgzrSqDxmZv1L3HakQ3RAaRoz4ySBQ6zxRcr9XitweteiOIcIqo5R2Itgj2PoNeaLFuoS3Kpof0DhxFUZezXPcHRiTJ2Cfd3dY5XopY16oGfZTTrfec0q+zgj8y+8y9k850yxvRqFaXKaBXqqyKtH0yz1ON8fEvHnIr65AD7nHTdHLBJw4boTMPxXH83ef8ytrSrvsjKpVKm7ssOst/u3d4Jg/4lYn4ifuNvn7be+8eF5m81qT5H+TgYH1tdaW3cOmDwgVtu0PbnmPkh9I03nAFzeInrzO6I1uO8xgAAAAASUVORK5CYII="

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAA+FJREFUSA2tVl1oVFcQnrmJm7goaNTkoTQQdKV98Af/HqpIW0jB0Bafk8VsaIhCG2MQFAQxhb61NdpQIqGBxWQj5MlYxZ+gKOhDW0sTo1CsD75m0U1ifsyazT1+c3dnd7O5d12Tnpczd2bOfHe+M3POYfqfRjAYqjbGPmKI9xKZtcwUJeK7ZPiXSCT8l8KwCkudW1tbV0ajL38zRLVeMZj450Cg6kRbW5td5OVUiL6pqck/NjF5Fb5fv8P/k1hsfNXIyPCtJWcoYFMzs7+Toc8VzKGR+Rxofca22UpMLcaY1Wk7WXuWBOgGhuAPV/lLD3R1db1QgFAoFJhLmL8VlJl735tSLzBfsVXd3d0dUzCZh4aGYlu3bPdD3C/fYKDMEqHQkQ8sHA6Pu8UxFj9SvTFUXjAgKqx4aiZ+OXvPhEbJzAtMgJjMJgXE11jBgE+fPf+BjKlOLy4ADIysx5pjugbgDwoCbGxsrIBziy7Eb/8jmdXU1EymdTkCCmYNqvi60KgmZutCXsD+/n6nqGZn52pQaaWphW8AVuv3+xMDA9fu1QbrO5DJCg0qs4C9SdiDoH+X6tEOfb294UFPQCmQy1eudcgC/OVH6YXMw9izfycmpk8bMnth/G76dfyM2t3AwMid8vJ1jeLjCihg09Pxq2xonxPIolkNCPg5R2ZToTpjm5PBYMMO+UZmkezMBAz9+VV7e/trsS8CVDD8/Wc4Hz9IOvFDmZODdzQ0NHxY4is+hb56mVIWG57/NmUfTemkRB0wHAYzqlsAmA2WdDBloChAVPoHujYuOtnL+Nx8X2VlZRT7clYDIaudIlvEjx2dC1jS7liJFoPBIKXv80V7ei5Ekc33KVeg0r6no6Orbavoieqwzx8nZfuVW2bq52QoV4wcxEKjGhwwlD7omBBdYGPVj9DdFxln4u2+zs4xyzab5dsZzI4fc9GI7Fk2jeoiM1ghqqs7FFlwn3k0dXNzc0ksNtlaUmL9mkis9CXmp5BhsngQaCASuXhQ4uUbXFdX/wUyu5l28gBL2yG4lb7F1gH02Y1sPzcZlJrDasA+ReWKyXc2uoGB4kuFgAmOlXyDpCBxeWbfZ/ojOruBSYGUbyj7Rn3eNUuGa9NOtvkvLecIXmDZTZ2zxPXTEhozFt6WkTNSPjCvasysXighQzzldOANguBo9MxAf67PPYiFxnyln1m9WEKVhnYbsv9UEwpgEo19HlQPk8UBuc+yr5jlgAlGqg/rf0JrHFdQz3kZmWlM56SRR6o8VlXpNuPP+io2rPvyffcsN5aToSqFXmJzFHR+mqSRx+RZIDc1+mxQ/ZYzvwUpRsZvejuicwAAAABJRU5ErkJggg=="

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAkBJREFUOBGVlD1oVEEQx2dm1wPBxELtVNDYKphGEbU3lZWF7+5yHFioKIholCR4QhTFRkxn9LzcRxQsBCH2NgoWIlxtYbCQ+FEkVfS9GWfey5O75z2MW9zuzs7+duY/8w7hP0axWDnGwDUEHBWA74jyCnjrVKczu4Ib5SjkCgvfVf/+O4gfUYZH3UZAp4vlCRGJIUqZc7SpQgiLIHJU7+9BWtvSTx9ANQgI3LEjJLzVac1PpW6lUmUsYl4EjYpS46DZ0smDJP5uyWaNZlsuKAgqhwVkYCTpo8y/Ltpa/d7nggR5WnUhQnwsBT8XBOViCrA5KI3PaOXOGMeTv/GXRqaJp6FHEa9+EIGd3sGhkPG6CnsSiE4ttBrPYwjLpAEJ6Wq73bjXF1EqrIZc0MyXzZEZR/TRrq2B5X6tViPN5Xy8R7hmEFv/iSiFmNE7fyTk8IRemEbEL4Q79kW8/FWPNjsq7GX5+ULTerrQblpLxCOOKFudZrP+tuDptnawRfLDuW+RAuNHESlS+2QvxEgYt73wa1tn+6RarQ6FYTis6V1mkUuK+txpN3fZxewgrcxNNeoj+LC32cyxXq+vRoJnDWJ7dUq0sU1mkJ4eNJtDP5s5S0q8Xh31U2HnX2Z90j3ZV5xsot2p0ebeEhskq0mvr60xKJUfCMMFVfITEZ3T2JasY9ebzfL5J8RA3v5PAFfGVKuR+AMENrsN0WabSPskMeX/um733dqB/ccb9legz2/XKptub7SXxlutJ8/yr/af/Aa/d/h2fQNA7AAAAABJRU5ErkJggg=="

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAABQBJREFUWAm1WF1MXEUUnjO7YIuV4l+iMSZNo8ZUEXzVaE1fTBolNiZE2V9tIWkMUpo0akyUGB80/kRcfSjYsLC78Nhon3yqjT751EJTNTWoqS+GgoilImXn+J273GUue+9yd13mYefMOWfOfDtzzpkzl9Q2tv7+/psWFv9OKsOHWKkOpfgOpehPUuoSa3WGTOupQiGzZEOAbHtaIvHS00VjRgHi3qAViNQ8kx6czGVzrk7EJRrZxxKpV4wxskjbFnZbFPOhRzo79cz0hW9Et+GA4vHkALP6FLa1LBCqsdrf3vno7Mz0+emGHpmAMaw+2QyCFM3Ad0ZxRD8qZfayohgzP2HryfEp3r23YYCCwCjSw7tamk+MjIzccAEADMWT6SE2/JbLc3pNxxsCqAqY9yfz2dc9i64PHFCJ9Dl7p7CTZ8Ofs59V8OoBI6aIiElxwTaL1LDvfwGqF8wGCD27QQvFt9YNKB5PHfVzYPhM4DF5F8fyrB708uhqXYCQ9A4Y5ozXGEY1gOnr62sCpF7bBhz6Qs2AhoaGooaLJ2HIm8NqACMgrl1f/YAVt9uAlKbTNQO6PPvb89jq+zyGiD5zoymdTt/lkfkMeuLp9xSbAa+IrtzWdstEzYCUMc/YhpDQfmqO0gnhxWKpN1dvmNlYLP2yrWPT62Bes3mgixGtezOZzL+hAEk0xeN9dztGWD1sG0OoTmWz2ZVEIn0QR/AuZDtZmVPi9Lae0AFg4Ho0kMuNfS06WwJyQ5uo1SkTAMBzYWpFP4shY/iA9G6D3nAqlXrIHQeB0aSOFXLjn7t6VQG5YErK1252euKr7mTpkd0ekB55DvfURkMGblpb43eEA7/aAc1jG9ISJWDy+Ylhmx8IyAtGFry+RyYiv160DbBRLw4ODu6E4S+QffO2DJOeRXjvliNFSH9vy/zAiNwX0GYwolgs6sekx6JfSr/R+P65uYWM3E3NTfo4+DitUpNdWl5ZceaBWf4jQWBkVgUgPzCiiGhydLu6Dp4B/YPw3IYkeTiZPHrn2NjYHDQdn3JlwLleMfIfwqsGxpG7E6UPAiMZOJ/Pfiw63d3dRU0RiaA1GUvDrqG02LVcojnqMNd/NONQ0fAndmwFRvTKO+SUnT7Fld91gBA9RypyBPNXxYgi9UYu9+FyMpm8h1ntcXjlH/27kE0RfXKzA5dVLMIBJAU5iiWPtzs6Va6DQmFsPKKjj+MMBhC2H4l+sagkfMs1luxca2vLdyKDY/8q/VaN5Kkyv7B0Gb7ofR1UAeNn1C/PANBUIT/e46cfxNPzi0spHzDD7t0UNNHm+4GB/J+mKL1t64WhNRn1nK0oBbnUwDavGh0ARlFEH8ExYedra8j83OmdQqN2Qe6VeUdBYCSaChPZSa92uBGiUt1uqyI8PVeALbPpamDCRJNty6Y1ACzaDHk3eceVo+0CIysh7OmSveT6I64curZM6O0EI/ajuK2/wu3zlAykyTvJecQxDyFsy/eS1MBSdlZWeltfByXL4X4pFutvVfTXbKUv0bcAm9dMv0CG1wH3VtTAWCPMdRAOSknLOZqeRDqBCmuilomi22gwYtN5OchXh/aODqH3CzNEK6LsfLWQn6h8CoWYXE2l/JTB95mz8kkEz9snMaEleBJdiejIC/lcdipYp35JRTSJT7FeOgx37oLf7IP/tCE14FMJnccZnZanirwO6l+y+sz/AGNEIPq1zGYBAAAAAElFTkSuQmCC"

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAd5JREFUKBV9UT1IHFEQnnlrFMEzEIiYJgYOEhV0o52FiI1lgoUp3IXbHJriosETYiV4TQpRvEIxVbjftRAtbGyEcKaJFop3Vib+ERs5iRhBJF7cybzDARXxFTuz3/e+N9/7HsLVikQipT939gaAoIMImhg+RaB1MozkTDK2IPukom4s6209gTcLQPWIuMziNULwsbCVD6ljbLbq8SMnGo2ei7AkHA6X549+zyFgpUKjPZWKLQvJLtT29m4/AUzk88dHjPcJZ/j9L0YAsZMMeOUm49+E0DWTyVAul11tNM1ynjxoms1LudzGgeYUIb1ha99nEokbIk3KemCoUe6J0OsSTAFgDSBlBbirxuPxEw7jF3j0VHjF006KYkHuqDpxQqzmwPaFVojwlV202va7JwLerj929l+z0TJAtSKcolJjmC+uCP6mgsGgTwipjuPUgudNs6u15/5n84IX39G2AxZHHuMDDvlZJqiE1tUl+AiojQA/6Gls7Us6nei5IdQ/luM0QIE+A0ILEXFoPAOxwBm4fJUCH9zL4nEWfyxy+nN9hUKhij9nZyb8wwsA35brTp5qvtsOTPLkPs5kzE0nh4pWrwvv6y0rMMX236PCT8Z9G29zm5vZRdN8+ZDtd/wHq72xA0FgE3kAAAAASUVORK5CYII="

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAABCFJREFUSA21V1toXGUQnvnPZrdNtKUNtRUv2GJLEZJNK5IKLTT1hkQiolK7u0mOedOY4oOg6EtAqBWFCK5YJY17ObtKvNCkiS0WNI8SKzVVXzR4eYi2SBptWk10zxnn3935e3qyNuli/oedb+7nv838i3CFEY/bdwBQGyDtYbMbCXA9Al1g/CsAfoUAR8Nh69jAwMDsFcJcpmKfhSORsHd54B0Agp0LtUEJnlOIB9etW5Ps6+v7K6gN8pZfMDg4aNVE6l4i8g6z/Ga/roz/ZnqZD/MrCeiePy/OtW3f3vTJxMTETAU/I1KCdLKh4dGPgLxnRYYIF1HB65ay7oJVdWvzuUykfu3qFQpDWxXC0wj4tdhy0oZ/CvRFzLabRFaJmiWNxzuT7NRtjBA/rF1R093f33/WyAKgt7dXTU7+2EkASSKq1WpEnLIUNWcymamAeZEtJox3dNxPLnxsDFC9nHdSzxl+EZBIdEU9KnzGZmu0KScdzTnpByq5Kb2U4OGrRon4/tUk036OMzDBy/4IQ54s/xC1xjq67tY4ONSRkeMtbHBbWXEhHML9QaOl8NnsO5/y1LJii27hKcF+qtB1HxYBHwInlUqdEf5qqYWhV8SHp3pve/szdcIL1ad0hzBg0bDBVYBs9vA3vIM/lF1XEk1Hg2EUIdwgwhDid4Krp/S9+HpIJrbI9AxXGUap84KrpogmhiJvdTCO4nPFdbE0XNe9XnC1lO/ZBvH1lPWbYKGKC/PPwrikmgVXQ3t6eiLsZypNDXqTwTh6SY+JkGvoY4KrodO/z7byFbu25Iu/pNPpb4NxVI2FH7CweGH5d89/XdigY5DXBQSJXhQ5L+27gv3U0tW9Idq0iYWlI0zUEo02v3f69Je67y15hMO1r3EtLpUzxHmFkb2VYuglhZCi5/n+/FGKTjd5NH8i1tWlP2LRoQt4LGEf5GSmQnGXecFx3jaH0R+k2Nt4lrMN224/ya0pxkr9EdeB63U0Nm6b371716nx8XHX7ySYXwQ7pmfO5bl4ar/ywJ+23Lpx39jYWGmbRCxaPx9rtx/lfUhJqynrZrj6H+eyd4q3+iwRXoNIG4ngPt0D/f6C2faQ46SeZL8FSYvtSQw11a2GwM37CrpfXRFz4Dm25w+CO40B4pu5bKo7mLS4h8aIgW41D7a1NoJSj/s7ut9GMO/VeUT1FkVCW7ds3rSTgzui42V+ItHemTR8GSyYYdDAtu1bCgVq4UPFrzZvA6/RnAJ1xlPeyfX19Z/7H076ahwZHk1zsrjE4Y9+I5dLm1a1aEJxXCotvo2GRjL8YZcOEmIy76R7dIz/PaEOWkw6PJrlfd2neT30YyyXzexfloQ6QXl5HV7eS+USoXfZEkrSoaGRHC/vXs3zoZpa1oSSlA/SIf6L8BCCOvAvG3R2STUcrhMAAAAASUVORK5CYII="

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAoxJREFUOBGdVE9IU3Ec/35/7z1dTTRYGB0WKFNWqC0QdshOgd1KCDIabzmjVUgRdC7MW4eQCjrskK5tQRM6CB0K7FapUNoSIg0ipIMXSdPnbG/v2/f33JuvEQ58h33/fb6f933fP0NwPdlsVhkff3neAuhFoE4i8CHiMhDMIMJYINCUGhwcNF0pZRUdra+vL1gwrTFObnN8nLzKdr1jA8K8APVcOv3kU9lXUoSUkUjsSMGk9zYJg0GIszWaOJhJP21QxN4DihCnEfAzV9ZKYL7V9f7OSiKMx+PampGfkyAuL6VpIj46OpqvBErc+vrmQwK6CoCLdd7aYCKRMBycMIx8v02C8KWx0XflfyQSzEkFr7f2BpN8ACC/YfwZcEikFETYazuEcnd4eHjDHazUJRkqdFv6LaKtvBJIcKntUidNTJZ8OwqPpk3ZANweirQFj7eOJdUUi0s2oMqP3+//xZANIFJ4FVQHzhXBTzawUICQ49xJLiz8CHJ8D6d8de+UHP+ETCSEHimrPYhFG8cL+9GNFQKUx/x5FpB1S9djYXewUtf1S20W4B32m6qK99xxJZebWepoD8nt7SKinlDo2GIuNzvnBkn9QjR2Bsh8zquyjxv7IJVKpt0Y+0T4W8X8t+8j3MDoVhCnUcA72QciqwUJwzzd49uJOM0L2c3rsOL4yrcmHXwqFwGLQ3wqhxxAWcrTQbzPTbjGpCG+wymghu5M5tGqxNi35oAzmZFkS6C5CVXsEgg3UeAQy8uqop5oDTQffpZKJjwe9STf3Sy/LAy48joSuW4f9T8VOYTVZDQ64CtavyeY7CgPahKo/tSuiOSLJJlprb3hvnaw+WrXRJKM/xH2rxubL3ip838B1wjn34AJ2zgAAAAASUVORK5CYII="

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAABW9JREFUWAnFWG1sU1UYPufcfuBaGEgWXNQsW5gmGlYQITFgxCiwzQkJagJ0bS2Z+7FkCYvoH/8s4g+ImBEmiy5s67qWxIEG2ZJuJiZ+TNQ/ZGxGRwZijLpEJpNuY6Nr7/E5hVvObe+FslW4yXLez+c855z3fHSUZPF1d3crPT2RjZyrVSrh65BSSAl5CK2CvzFC6BjhZIgx1rN0qfOr5ubm61nAGoYA1/yrq6tz/js5vZeopIEQ/qB5pM4zxSj9iDHngWDw6D86TxaKKaHqap9fJeQg4bwgC5yMEEpJlBL2XldXxyFKKc8IMDFkEGpsbLSNjv76IRDeMMkhojP4xFIlOOeFkJeZxSL41CKb4m1vb580jZEcOkL19fX2KxPRPnSySYq5IVIywAgJMUZ6g8Hgn7Lf7/cXxGKkklB1J3LLZZ+QKaHDDof92dbW1qvpvnRdR2h3tS+EJXLLQZiN85j6vaFQoE+2m8le755n4mr8CIr8aTkGy/Zl6cricqxAXLanyxj0jc/t8b2ZQYaQzwnPX58tGYEUDLZ/v3xZ/kYs1bGb0MkGM/fC6MVL78s2Izk5QzU1NStmZudGkbRYC4Kjt7S0ZDtGhNqe3+d2e1vTajGuMFtZV9exX8wQkzN0bXbuXZkMVn0kP9+5ayFkRIcYUB0KaEDq3JLgsUOSniFScdZcjU5fBqFFmpcqpDIcDEY0fSFtdfUeFyeJs8BPlYfNyooDgcBvRrgsGp2u1JGh5EyuyIgOQ6H2c2hOyp3H42SHrMsyQ4Fskw2onW5Zz4WcjqkSVden3AfD9iyVDYRYstre+pzba0uWOPp1EZym9XnLi2uHPHxLJaSgIP93Wc+F3NLSMoV+pHuNrxAXthE2Q/2k7iokTTc1Nc0YBebANi5hKJFIxPCyFjOUYs45cYjrQ0rMmQjs5TJYUVGR4TXCcHDp7qWJiWuPyom5kBsaGh4AjkxoAmdczAib4WFwUe+Ib9brC9fGxydeBEryVhBouNd+MkPFktEe2YmpfU3WcyGrqqrH5ES/66ROWF6evRd6avo44c97PP7npJgFiTipH0dZ7NKBWOlpnS4pTLxRMJefSDaCER3ORXGjTlCjiSPAtkj4/eFAYFjSdWLyfrHZlHdgTW13zNJqPNQ6dJHzUC5cuHQQx8oWOZVa6H5ZT5eTh9Pg4GB0lcslRrFJClhV5nIVr31qTR/8t31USTlJURx6NlveAQzsLdmHl+PRcFfnx7ItXU7dwI+tLNmPAtetLQrcF5vjA16vd316opnudvufOHW69wuQeVuOAfbPVivdJ9uM5NRWFE6PZ58joV7+Gj951qYHC7Kc0hBVF/eHw81R2S/OGbG1UXs7safFuzo1UC1O3AJ4CleEQoFvNZtRqyMkAm6+jzoA+qpRAmxYPvoHSI/hZElALoTtETx/73jCZ0Mqg5BGQryxucoboTs12122MdTMcU6x5fVkpyyKpQJv7wEjvIyp1YJQfB/YbUoJZfQwlmtWs9+xpfQ6RnmcUeuT4XCnX6F0B3JS5xxkZzwRj7h9vg1GWKYzJAeL2lLVv7cQRqqIStehYMUyibtJ5M+gbv6inP+IJfnGbreeaGtruyLn41fwSyrnn8Fm0+wY5CT+M1AR7uz8TrOJNitCcoIm19bWWh0OhyXb54rb66/iicSnyNeRQqGXh0IdZzTceRPSAO6m9XhefzmhquJ9rSOlMGWr+D0nsO4pIdGhMSn8r4CzreFw4Id7TkiQQk1tw4V7EkeLVejiQ/1FFUY23xdCgsBur387VdUTMinQGjF8aIuE//sbPjd43lW2ZhhF8wr6SvLALKn3jZAY8NDQ4IirbPVZiBtAZgY/yer+AxZD4xQATk9AAAAAAElFTkSuQmCC"

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAMCAYAAABvEu28AAAAAXNSR0IArs4c6QAAACZJREFUKBVjjIqOP8nA8N+MgSLAeIqJIv0jQzPjaGDTL6IHX2ADAGItC6GcTUiUAAAAAElFTkSuQmCC"

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAYCAYAAACSuF9OAAAAAXNSR0IArs4c6QAAAHdJREFUSA3t1LEOgCAMBNA7YuJHuvgDjq4Mrn6xiycksMGILNeFpB1oXpPjtu2HqBvSiplFPhTPRXgjhLnLZIgEIiiGmSitvwMRLiSu1vDXXj5Z3sVlAQsMFqCTuifspO7J1L6Tukr4tcBgASd1F9hJ3aUpg5LUH6QeOqsZSMYKAAAAAElFTkSuQmCC"

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAANCAYAAACkTj4ZAAAAAXNSR0IArs4c6QAAAYJJREFUKBWdk7FKw1AUhs9Jo4iIQxEcFEGkD6BDcRGK0E18gYQ0OIgdfAUp+AYuioNtQ+JaB8HBQdFVcHMpLjo5WKSiKJQcz39tFWKUYOAm5/7nOz/3npvLruuXY5JdEpmj/zzMtxZx1RaSuppMwYOZL0XkNYufsqPKLmEBwnJg68SYoFhNx+zciBsE+3d/mXne+kwvfjsaMCI0bX1OuM1Ex+o034vfr3S7pQGU/CIHBqypIW6DMUYqvIRhc5WYtnWpE7HEp47jbyZNoCEHBixqUAvOHsC6Z9F4y3G8a21WUyTecZzKQj4/vgGm0+nuCcW+cs9qVInCoHUYBqSMsehvzcTmFUVBi8Ra1Na3tWf+Y6d7gYEYGnKG+S4x0Q8jqFFUvxke4iITn+gRFDEQQ0Mu4fG7ETKNRuOpUJhdoRwtYyCGlmYC7atHaUCtVotVP0vLJbXUrSWhLHN2XO9emzipR3aup4EVZH+YLT3+kvbwwWay1vp3rZzdoU/qLy3mrlnVD6zponUdn001AAAAAElFTkSuQmCC"

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAaCAYAAADfcP5FAAAAAXNSR0IArs4c6QAAAzVJREFUSA3tV0toE1EUfXeStkqh1dbaLkRQF65cKAUV0YK2btwqaP52ETcurO1KEBcuLS2lCFoI+XSahbgSxE39IIKg1UJx48KFqKBtcWXRkGSu96QdfUknySS11YUPkvfm3HPPPfPmzZsZUtKi0ei2paXMdUXcy6z2CETAN6AxkXqnmKabm5uuTkxMLFIkEunK5niWmbs2wEDZEkT0ucFL+71iZuRvm4FLeMjm1IhXhiecbBMZt5n4rVNsrRgx7WW2LpTqyHI57pW/7aUBHIvjs4ZSftNM3neK14sFAuFTFvM153zulJrlGreyUvcCgdCVcoxacWhBU063tVwu+fwh4aw0UjOkaEfpmpIFd9egjsjk5PCSTa2lDwaHmi1eSIjuaT0PC5kVf1Ssum28aIbk2r7xGCxBemET0EPIshae+/r7d+u4mzFykFtqBjVQCzV1nSJDCKRSqU/tbS3HFFFcJ8qZ7FOZ/MtAINKn45XGBa7kFHJ1omijBmrpMMarDAEcHx/PpM1kPxl0UaY1C2y5cZvF1gN/MDxoI+V6cMCV+W2zOdCCJrRRw8b13tGQTZiaTN5kj+qV3XTexqT3sMXDfn9oamBgYLOGF4bAEAMHXDsODWhB08ac+oqGkJBOJp82Nni65WEyowvIneCbX/j6LBSK7rRxjIEhZmOFXnKhAa0i3OGgqiHkxOPxD41e46isq5SuIQv1QM7KzASD53vwwxiYzkEOcqFRhJc5kJ3aXUskEj+EGZa95LXFCpdjOZe5I8/56RUVXS9nkBoyzeSYuwrLLFczpAuaZmpMVsZJwRY1HEZ0M4sGGX0FrkZyM6zZEETTqdRjtakB62p2VRFgEjPNxJNVMRdAXYagm47F3nd2tB+Ry3JJdvdb+GEMDDEXtR0p+jQ7EiqBo6Oj3yVe0xqppIdY3TNUTbje+H9D1Wbun5shb+EZY781Evf4AuEhuZ3z1c7kj8QZzzrukfehlUZf5C6jhwKeAyKvs7vk/8Zvgk1cv/6XFykhk/NIto6mQby5rV9Jd8rwIJ9Blz1zc6++HT50MJnN5lvE4RZJ3wqz7mTWzCp8KMqmekc+FM/EYrH5n7LpNjkgdEuYAAAAAElFTkSuQmCC"

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAASJJREFUKBVjYBgygBHk0tmb7BR//PnXw8jAaP///39hXK5nZGR4z/CfYTUfD1cR48zNLnK/f/88B9Q0g5np/zJmRra3uDT++vtb6D/D/z6g5vtMv3797GL4/396dtChGiFViTs///yq//n35w4gvQsZ//j7KxCo5jorI2sOAyNDKAuQsGNhZaoF2fLq5ssYBsb/ZkD3V/5nZPqLbDMz29+7IP4/pj98DH8ZvjMhSwL9APYzshiM/e8Xs/LUDXbhf//8Wwx06gwWIHHo72+GeKCCGlE18cWvbrww/s/4v53h/z8UQ0EG/PvH8J6RkWl6duDBaUQHDjsH85c4911fYS5gSvfd84idhdH0H8M/zT//GA79+PPzBTb88cuPUpimIUYDAG1vl/OAYAoRAAAAAElFTkSuQmCC"

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAkhJREFUSA3tVU1oE0EUft9mWzTQQ48qFIoXCfjbg1hMKNRr1STgwaKIVIqpRRC8ePDiTW82Ci0GwR/0YNOWCnrQKiZCT7WoBxGU4lmI0Fpok8zzm7Wm6RZkoyn0kA3ZmXnvzfe9+d7MrEjjaSiw2RWAP8Fb47FONdqnKl0iuoP+Zn9MoDFQgsqcQp80N7Ve6++ZXLTzKoTDkz3hYvHHiKr2BgKsIQjA55CEkucTrz96hHdfdW35WShPkeyQlwXwlO1DqPMFrlmqAXs1tBQKG5gOEXOFam2n49POrS37XBuxUCjfFJIBMu8AqVQ892B15n/1ptPZ7seC5Vni7/q6tHAJQ+Ox3VI2s4R1HEdODsTzj6opMhNHWxZLhTOs514IAtXzQjJ3uhojnY2dVTUZAaZcGOlTkrGaz/xkw6PRbSR7S7J2C6D8BXzWELqOThfLdsPofpcgRywIFFk/WBFyg1K0s+jfSTfKFc77Y4KMFdLqxakUXG7dtpW8Z9ZNVum2NmZ2aiCRf77OH9BQLmncCwVmnIBz/jksPRY7ocBFC8DEMy6X+42liXB8gP+1q4S8pK9XBffT2cM1SWqAMIx2qDEHLRnZ7lmVXNblBesY4Y2QoPmO51x5NalcXhZ08nzaTdNfw6ZhySvRhmTXm9siV0XygtsT0T3U+B0B63YsvHwhJbZz6mBs8PibD56NL++mGcpGR5jRuQ04+H94Ku2GXG2pY7n3FQZfxyO0tnpe3oPJfAXXx/db0mpjPT5PfyOs5mr0GwpsTgV+AX2P9ZIlawQtAAAAAElFTkSuQmCC"

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAX1JREFUOBHdkz9IQlEUxs95PnlZkNHQFrTVEkSzOVXUoClNNbRUBKFF0daSu0ggDs39gwYrAkMKgkdTg7Q4W0s12ZNIpaf3dK5whawkGz3D+9757rk/7jnvPoC2DWzs7CA13V2wS32NfmMuwFkMz1w9Kb8Oip9550HQNhAN8aKmCpoq4jNouBUOmEc1UCLp2RUE64h4SBqmdAEvTQG8SESuKlCQXxcRwYeJU++kECKNGiyEgrf7ErB34ev8qFpjSOiW+bdwOLIh/01W+vGk54SlXxdEa4BwqSByRlb59Q4IBokfP4aACPs1EJ/mmsuiOhuj3F9UbSiU3ucIccCJ+oiB9Kj8L9oDZZWTwGGGPUhQ62FBR/x8olerlAJ86hWe7aYEZbiBcdaYJLpdXcdW+W3DJvve/qUzWQeiAoTcFEFsNWAm/jdsCSJRJIcro+4Sjweg1c+v65Bb9ps5uVdFDSST1i6kFgnPmjsKIrUOUuZffhHDMPJLU+m82tPm+gkqJaGKvrGkEQAAAABJRU5ErkJggg=="

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAzJJREFUWAntVl1IFFEUvufOqNmCSPRSCEm1UJFB0VO1thLYD9TqbvsQQeCDlOuqUBH9IEQP6UMP5U+WCEFQD/uwi0mEQbjtmkREQeCDFSRErJnYD9nfzszp3JEZ1mV20XbXiHZg5tw597vf+c6Z+zOM5a98BfIV+M8qAOnyDaBXmrobW6WpvIxrYEuHnW8fooocYHoJk17W1YY/JY+zFHR9wLkuHldPELgGEZcnD8rKO4BCPIOyBK0Nrshzg3OOoKEhpzw6rbQjQAtDlA1QLi0wUIFhc6Nn+KqIYwq6OVht+zzzPUhCqg0BBP5KiAd0v2HIvhn+jCwSG+AaMtsoVpnJJfHDTTWR26agzuCOAAX1CoAQAhzOLy3l3XVV4R/moCw2AqPewsmx2AWiPIW6SPYFWNFqXVB30FGvIfbq8QBiksT2+FzRF1mMn5KqM+jopUrVCwBw3gqBEW/x5ETsNalcSerinMmVPk/4sRVDd7ByPfldGsNNgKzQCpPO5/dEDyb33wg5S2c0dQoZSgzgifxh4r1biNGBwHp97hRiQg4/VfESZVMksJjM/IfvYulTlcaIcANNbruMTDtgcMkF/IrRTrQ9/Y7tqoodNMicc4n9GbeRfdQ5EIplRNgs8gWA8WP7I6+syFWFnaWK6GI48DMgSaECUH9ZYRfqo30OukKOClFyBHwnU5QVs+XH8TRkW0QfYZ82uiPtaXAL7urq33mIxJToA5GF+YIZsjigJ+jcyFS8bFBKTO6jOcRi5LBT/uVkU13PqGMfYbfSSjudySeL06GIcb4WNXQqTD1OH0pfJDRlbokFJQPgc1pldvqW5dcGKu1W80iS2UVVZXvFBqah1sYUrU1NJX1efm0WNTtXxEY8UmIrPiqcHBi/Y3Aoca3FaCfaBlf0EWXQTDP/Z6I/4zYdsAC8w7ZM2nVk9/0ZwbeoG6ORAAKbpuRGqRrBxprIW8OvCxKPv3l0JIoxBYnGYh+uyUKMd3PnXYzfD787es4InMqaggQg1z9oTZ7hOfGsRM3ZGKuqworfM3yysECqoFXVR/eU1aBc+tIqzvZPvq/24b1cJpPnzlcgX4F/sgK/AVrPS/X0yQHuAAAAAElFTkSuQmCC"

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAAXNSR0IArs4c6QAAEqxJREFUeAHtXQl0VNd5/t+MRhptaGUkVskCI7EJMHYwYIEgXggOTuzYThOfpqep3Zh4qVvic9yeJnWbkzbnZDlt8BbHiVuf+rixYzAm3jFmBy8YLAmQZElmFYN2oW00w8zr/93Re/Pem+290Qhh43uOeHf57/J/c5f//ve/F4nG0f12a3WhzycvkqRAeSBA5ZIklxNJxdykbPzJsowvSZLUx5+RP9kty1KDzUYNsmxrcDikQz9Yt6MDdOPhpItZ6Yv77khvb2u7XpYDqylAq0mS58syjaoNkkQyyVIt2Wi7JNm2T3S5tt257KWhi8XXqBpvppHci6QnN69YESD5ezLR7czuBDP5EqaR6Dwz9ScbSc+tv3XXLu69XO3YuTED8PXXv5bW7On/a0mWH2YOysaOheglM3MtsiT9YoYz69m1a98Yjk6ZeErSARTD1O2+l8fVj3h4To7TtECqI70hL3NqR2H+LH9x7rz0gtwZeWmOnIxUR1aGMzUzC/k93oF+r69/cNjXO9jZ09zt7qkb6uhqtHcPnC70+oZ43uQBHMPxMG+VSPrlxOLip5I9vJMK4OOvrFwnBwK/4WFbGo0fu93uLi6obKiYeqNzxpSVFamO7JxotGbivb6+3uYzO+vrT7/tcXfWlPv9fixCER0P5+OSzfbgfd/cuTUiQQKRSQHwsddWl9CwD8DdEqkNEtk8BbmlB6+u+CvnzMmrFzFNzB4TqQxzcXKgqfW9Qx/V/4+ns+f4YpkCzkj5GMhXHY60B36wbtvJSOlW4kYN4OObVtzGC8TvSZZzjRXbJFv/dNfij1Yt/qc5mc5ClzF9LMMDno629w7++9GTbQevDsgBMRXo6pOkHl5o/ua+23Zt0sVbDCQM4ItH7khta3T/Ug7ID4TVKdkulLgW77n+mkcr01Mn5IelX8SIIe/5rm0fPlpzou3gdSQHUoxVSzZpo2tW8Y/unPuS15hmJpwQgM+8eVO+Z2BwKy8Uy4yVOFOza75R9WvnxJyKWca08Qy399Y3btn9Dx6Pt6/S2A5eYPY5MzPW3b3mrS5jWrywZQB/93L1VI/kf4uH7Bxd4RJ5F8y4c39V5QMrON5yubqyxi4g767ZuOuT5heXsjyaqqtGko46ZftN93xrx2ldfJyAJUaf2LKqPOC/8A4vFtO05drtjpO3Vv3nQHF+5Wxt/KXqd3fVHNu8+6FMv983XdtGXlxO2ewpN/zwG+81aONj+U0DiJ43LPn3GcFLd+Yd+t5NL5Q57JmjEkdiNXIs0nz+gd7n3vpOy5CnG1KB6gBimmxfZrYnmhInxJzHw9YIXk7W1P3fX7t57ucNPKCFNqPt4EFFjz3gEVMUeNbGR/PHBRCrLRYM45xXlD9791/e+MISiez6uSRaTZdgPNoOHsCLrnk8v4Nn8K6LjxCIC6AQVQyrLX61O6qfXs7lxc0foc5LLcoGXsJ6IvMM3uM1NuYcKIRkOfCythDMeej6n+eep+VH8cvk9/7h9VuPGOdE3gx8K5awHRVAbM/kYd9h7Q4Dq+3dX9+a83mc8xSgYn2xsDzz53W9utWZdyypjrQF0bZ90Ycg72214LFk54Wo8kUFD8CCN/AIXlWgeYvq8w1vVMMGT0QAhVbFoBiAkPx5kfMMPFoKgkfwqs3EK/MtwEQbp/jDAIQ+DyophQBfbM9Gdhja6C+sH7yCZy2DwATYaOPgDwOwzX12PSNeqhKyYgB7Ww5HnS9V2i+ORxI8M+8KS8CknRXFSlj56gCEGp4TNiiJ+EKrcqkpBrTtGys/eAbv2vKhZR/BSI3WAYgzDK0aHvo8qKRU6svMA96BgcI2sAFGShhfFUDuonx+JT+sTYQydLz1edr2XGw/eAcG2nrFIRljpcSpAOLoUXt6BjU8NMkK4eX6BQbAQuEfGAErJawCiHNbJRJfnGFcbDW8tv5LxQ8MgIW2PVqsBIBCdMGht8bhAEgTvKy9Riy4F96uiDQCQJhbaC0GcPQ4cnp2WQOnMA8sgIkSBlYCM44QAApbFTWVCOe2Spom+nL22kYwUTFQMAueUsHQR+Mqpq0Z1fA903GYPj29jc60H6YBT7soOdM5kaZMXEhXTr2ephQu1NSWPK+o99Q7hO/AUEew3vRCUd+V01CvTvlsqWIYApxpOxTKM4KZFDQxu9CmsZIK/O261/sSsRjoH2qjdw/+B51q0638oUpHfNNcV9NXF/8jZaUn56jYSr2rFz9C2elFYW2KFwELiKe3rs1mOjFqYRXmcKS4bLDP04BHsFVJBLz2ngb64/a744KHhgJg0CLPaJ3Vel/cfg+1JVAvMAE2SnuBGbCz8ViuUCLxhaGPNmzGP+DppD/vf4SGhrvNkAsa0CIPWxCYzmMkTLTe1xKs14gNDENtQavQUNNgJRUKmfPtrX1MnXPM5QhSYZ7aU/OYlSw62r21j1/Ueo3Y8O6tgnsgwTxMdTAxUwMmPD39p3jBeNcEZWSSpjPbCWVYdcF6t1nNptInUq8RG2DH9jWkMweDfZ5aiwlPc+tOHAWaoIxMgrzNZ3ZETowROx71GrHhM+QiG9uFZGnbCeNGbTiev71bnVfjkUZNT2RSb+9pjFqe2QSr9UbAJhtLMpZm1cEyVA2Y8Ax4LNvjhJU6mEAZ/MOHlWM1YtBjftFD2RGwyU7hIaQDUDGrNduYVIclvCMWO3PKKjV+aLiHjp14jY679/HceJqGvecpPS2X8rJL6YpJy2l2yVpypGTQDdf8mNIcWVT32atqXque1BRL0z0fbQRNjpV6gF2YvZySaPY7IWOSWdKIdNWLNtC8K74p0j5ufJ4+qn+OvBcGdbT9vFrjD/Ljh/X/Tcvm/VAAWb3oYe4VmfRx4ws6erOBCZmTzZJGpWMxRlxiUQlg0K0GTHhKiq81QRWZZE7pzQI8NsWlNz/4Ce2reyoMPGPOoeFesdvZUxM891o2bz0l2gar+YzYADvMgbgBpDpYw6sBE57pRV+hnAR+yQxnHq1Y8JCoYU/NRmo6/Z6J2kIkh5teokOf/h9HSLSKe6Ld5gglmvChzWi7FRcBm3AAcZXASqE2KYWWz7/fShZBu3DmtynF7qRzXUfpk6Y/Wc6PDAeOPE19g2fFnnp26VpLZSyffx+h7VZcBGz6WJCWz2kLwT0MbdiMv2xyFS0uv8sMqUqDxQDug/pn1TirHn/ARwd53oSbW3qL6exoa9lkVStvOl84NrKb50DSCXK4xGK6RA3h0rn38uR+L18MFMoKTUq4t2DCFbyy5vF8N0Cn42huwnPrY1pad3GETIW5M3l1jr2qom1oI9qaiDNig0uPLMZIDGBoJ4EbQIkUjjxXzbqLSouX0fvHnqHjZ/cTeojW2dmUsHzaDbToyu+I6M7eFqZRz661pKb9kOX6h9rFMJ5b+nUh1lzwD+vyY34snbSUlsy+m/L5x0vUGbHBjdEU/lXqZTmkP8D1qUQrQD408GtLfka+C0Pk7qoT2hbMNblZU1mWKxEynFL+IGtxkuFQDnSL11U+SEvmsLqq+xj1sW4SHQOK3OL8uXF7p5l2GLHBddsU3Lf1+cR2Voj2uHsG5aFZnWCAwT/V9iF91rpb6NmgYvKwqKHt1cbGzeGesnLhBnIkQQhH2RCs4V7du4G14B8Lf/g/EjnTchjQAnLlVbBQfh1Nc13DC4m5AQdMRu7liaKDClXpUAouKz/2clUtM6xYINiaW3fX8yS/JLwR+phGVtsfOPI7Oj/Qqk+IE+ruOyEoEhF/jEXbbCmUleES0b28c4k1JUB9hr823r/XtWwhCNLXzr2HZvExQzyH+3hME8KE7ygDu+CMz5eVtQXUn4x9NfSC30NvvP/P9PYH/2oZPNTT0dtE6Lk5mVPF0NbWbdU/uXAB2/Wl843OHhZpdAJF3KLww4MH8AKeYjlcZtSlj2AmAMRNb22iu6t2FocD2jjF7/MP0aZd97MKaqcSZfnLt4XEsEfGeWXBbZzlQkYyzB/ZBjZxe/CjJOLAC3gCb1FcADdBtWkKZgJAXJNngf68QoAro02t2zVHUEqKTO98+G9iCCgxiX5rml8WWSvLbuPFZXpCxeB0b8aUal4qAjwkNydUhpIJwxq8RZq7gYXuGi1jJTBjagEgLiHzCqLbDuDKqFK48j124g1qad2jBEf1PeE+QCfc+8nGIsbNS38OI05L5WVnFNGaJWCY6AhrZDp6my3lj0QM3upPvhmWZMQCWCkXtwWAyIE3BrQ5cd8WV0aVOH/Ay/Ld75VgUr7vfvxznrfcPA9Oo9urnzLdE4vy5zD9b4UwDsXq3tonktIeFHLg6DO8EIVMpIEBsNBWoMVKBVA80MBvDCiEuKyM+7ZKGD2mf1DFU4ke1XfY18+6vzdEGblZ0+kvvvos76vXE3pXJIehvuqqh+n2lU8IcQQ0dZ9tIb8/xHCkfFbiwCN4VRww0F7c5t7XAqyUdHU3zaoZeeOmql+wRPikkojLyrhvCzu5FpbzkuVS7Gm8a/kuLZh5BytFQ0PXbkvlXcp3xV8nD0kcHA37+nh457KAXip6qrEN0MQsmf193hP/L9W2vEKBUe5sUD54xV4ZvAMDbZ14xAJYKXEqgIjA6xYtnr4f8zmP0DTipjdfVt6xbvmvq5NxCI46JhXMoxu/8qhqHQCQsJ89ycI4hjN2FbFkuRTeDrLJmZDhSoquZUarxC6kqvLvhEIBesWu88dRVcJO4RUXtRmDaqUgPF5RxhgpYXx1Yvjzzzf5b/52Cc7YblKIegfdU6+YvLSptmVzwYVRDpWKkjW09tqfkdMxQciPOw7/inbyHzTN5wfOsvq+T/QgPuzngRD5D/trj7eXIDSfOHeAalo2ie2iK7dcgFoxfQ119HxKvQNnFBYsf7G1nVa0uHFv3dMLeFVWpznWvPzLXbe8q1tFeUjrHeze2tzuo6zmKlVSYPLPQ2lUrwzxCx28R/4pFymJY8xtB7FfDlvolSotf3FusobLh2iDReCV3Q/R2U7eYCXgsE3jqaVWe7udh+1xV3HxHGX1VYpV0VUihEjDT4MoYXxREJuCqBOnNs2MH/PXjdf8hEklnqc2C/V9MsFDG3AYtWXP34v5C3MpRKMMZ76Z5oXRgFcteCDAcylG8BAfBiAi8a4KI/4q/CEnL+Vf5lgobM4HHdzqqx5hlXsqz3Mf0O5P/mtUB/GxasUC8s5HPxVbRWfqBPXIIFYeY1qQR3mpNh5YRHtrJiKAInOa40HWjvaoBfEbA2ybnsnnsVC1mHaY5KFOgo5uO5u+JbrdMlsh1GiYHrCjwHFpEWtezDrwBh45a+ieMGOAN2ailREVwPtv3n4C76roMgZoOi8wkBVNC14LZ94pijjc9EdxNKkrb4wCHT1N1HDqbVH6gpH6TVTlFbwxj1paYBDtpiboogKIRNyTxbsq8IecvIifrTvI4UAoLrIPurdJBUEt2dHPtkYmGqNYbO/gMALsrPKK4wJBnpg3jQPvse4KgzQmgCDAozTctffBrzpZWsrrwV4OxwRxysSrRJaO3k/pPMt4F9Od7awTCwtO/lx5s2NVzeAxL+BJ48AzeNdERfTGBRAv+uBRGp4P1W2dKEmmKv7V3md/1OGM1RcuGYZAoiAL/0COhN4RDodYUZxX8ABetA5vyDDPZl4zigsgysWLPniUhlejU9p6gr+adCTawpLBJ29wisG3Lu9FCCjWrzgBNLpgm6UjYT2PeQSvZl8xMgUgKsc7KniUJgxEYhtrm9wbScSB3Qqch/ez4+Gws4EzGkChrWgzr9T6OW/k4R2zb8agbNMAghgv+uBRmrDhHFydZ3D8Tm4cL2ZGFyHKSDKm4eCGS7SN28itmcGzt261BU/gzcqrRWiyJQCRAb9OekZGVfjCwrKTLK9kgbl2SmFlY2HOTF790pBl3B1O3pxp2Y18abAWbdTJedw68AKerPQ8hSnLACIj5gdXRfGqcBGHWGD2Vp7prCvLdObtKC6Y36VUNF5foZI6d2AHW1aVsWZFOXlUmwMewIvZOU/NOOIJUyYYCeKFzTzAmJkxaQ7LZa54ZSUznRlry59QcrS779Sl+QCjltn4T4BKHh4nLHzLTtaVYeJOqOdr64ziD/A8d4gHpYeHKT8BKjsj0WFve8k8AaptoJlHaLnxbmasgRl1ygGJN6pyjrYM636pV7LJbJ4iebjXlbMarjhaGVz3pfkIrbbBQX3i2fUct0HRbGvTDX70mAZmvIO3NH5WlKfzCslCm8S2GjLsNbJG6NlqVhrkuEGm7eYN/xB3YTvTFnIdOK+N2aO5DphO/MpVPOnJSCqpkToS+nB7xsZ9+RB3knDlIfXlU/BJwpIwvL/8zwiShSaXo/x3GLgxikuPmM94osehMM46I/53GNyjz2HehGEoa7vrx/u/w/h/7tsdX6ZwLMcAAAAASUVORK5CYII="

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAR1JREFUKBWFUsFKw0AQndkGQfoNiv8gqBcDIt6l0IuRiCcPyQ/ozYtfkNy1Bw89VL0XhPon+gNa0ArFfc6krmzSbTswmTdv3tsJ7BItiOJh/1JzwZg4NCgGcQbYQmfMJs87o7KpmzOWgzgF2Vtgdigzgcici/nONxu/6aPbsky7APcdrxhMOzpznNa5jUqWj/GG/bGvik3LbGbHozfFftQ2+oNVOEpOz4YiasPg6r7Xe15mOEnTA7Z8I5rPCMChio3lLa0aUXttPB1/Tx2uSPmoxgJ72gd/9eJo+CH30NWssHN6NfJwDeadl6ca0WiCGxuaYPu/US58O0nS96Dqj1SNm6txIrkOQiZVc0nII5rFxMgTuGbmL8esqpVWPL+qG1oCDfHTFgAAAABJRU5ErkJggg=="

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAidJREFUSA3tVr9PFEEUfm/mgqcxkpgYE1qN/AU2wJ4FBcklCnKFiW68aDQQDgMFjZ295d3R2HjhGgu41UYtTJQDCyu1VGoTA5WNHnHn+QZyy+yxt8zcUREnmeR7P77v29kfswPQw6g0vMd69kAFdCVV1nIlIlXRPEQxPz+9XnXRcDKsruXuEqjnRPsXiggEIO6xac3W1Nqw3PAKqOAFAUlTHAFDEnDr0c3mqpnvhq0My4E3ASG9YpGBLkK7AmGyNL3xpks9Sh9puBxc88IwfMuM0xErGfyWUk7MTX1oJpf3s6mGz16OX/wTtr7xkzqXJhLVEH5l5akrDyff/YxyHUB0xLHwwQ1vG2RmHFGO6ClAzMYaOEABM+267t3jdDYZceoKjb49WA1yIypUm2ZeSDFamlr/aObScOoK04i91k6+Yea2X1ziZQ4Zt2izXq9ZfcQGJxH6frHAhdF2UQH8yADRUwYHA+EqB8diqIAW+ZMaOxDnjdAMjsKkkPfO+MBQxK43Xj0cORmeyaot/kX8jWQYywHYimIL4GR4P9/cFkQLbNrSU+OZ6+93LHyiFidDzSoVNpYvZc8O6qlxpGQJMpZ9sbZ8/nUrlnAInFfooJ3Y+t8w8bb0k0x4aXD4jl9c6Ue0zeVdYhj0OcsYhw2JLnCLb/QcKxR81HPaKfpx116CEMv9iLhwtZf8+uXzp6AR7BDCZSaf5+l07LAw1Mfm73yMfFJfqVX+AegwjtldLCUjAAAAAElFTkSuQmCC"

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAU5JREFUOBFjYCAApqy3rQRhAsoYGPEpmLLOLvv//39TQGoYGZlycoIOTcWlHqdBU9fZxf1n+Lfg/3+IZYyMDP8ZGJgSgYYtxGYYVoMmr7cNZvzHsPI/w39mZE2MDIx//zMxhOcGHl6LLA5iM6ELgPiM//5bMjD8Xwl0xVmYPIQNFAPLwUQRNFYXwaSnrLPJA3ptIogPNCg/J+jIJJgcOo3VReiKiOFTzSCW6Jj4r////+diZGT8zcQoKrh4cc9XYlwQG1vC/e//6/dAvaxAvd+YQIaANIIEmJnfsCIbAoz5XzA+MhskBlIL0gNig8zA7zVmjk3AQL4JwgxANkgTLsCCSwIknuu/+xmQ0sCnBiaH30UwVUTQg88gxqhoYN5EgD8IJlEseBgDGYwPgBGoANUGlyDKGKgiYKzeZ2Jg/p8EzEh3SdGIohaoF1giJAMAjhZko8J15CEAAAAASUVORK5CYII="

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAnlJREFUWAntWL9rFEEUfm920SgaEYuIpWKjbUjlJQaLdCYmSMCI4pXeXa+gnf/BbYJNDgMipMglplJEND86bVLERgxI8FehhRaJsrPjm7sEZrMzNzu3FwvZheFmv/fNN9++3X1zswAdOIL5wl3ZOiAFmFUkqPeXhIgCqYPIyuXR5cksmpkMTdb7bwiIHgnRvDBEEADsFpmaaddU24aq84UxjGBWgPDUyRGQCwbjlSsrcyqett+WoepCYQi4WKRJDhgm+sMQhkujq88McSPsbGhqYaDAOX9OioeMqs3Alud5Q7dHllYsvFjYyVD16cVe4OFLelK6YyqmE4Sf4PmXKsOv35ooe/HUhoLFwfMQhktCiBN7RVqdI+J38P2B8uVX6614uzG227H+hmHd1YzUbIyhsVb9HYKflojojQOLTsX4XEzTW3ZSxegt+8oYK6oYVYUv6nmrfupbphMJ5i58oMJzWo2R4EZ5bPWMirn0098yF9UM3NyQLXl5hmwZ8ieu31ynWnEuTsRvXQe9s7Va7Vcc78xZsVg8uv2bv6cq1aMqUhF9x5JmJEX0RFHkVJFVYVu/qR0305iVEvOfPUMInxPZ0GEJkhnIliHEJwlpHZYgmYFMhkojyw+Rsfu0XHySjf7I3pOYeTp7JPXiqpOit4KWMniw0xqUSsZ9Q6YM6UxmxXJDtgzmGcozZMuALY7XJmh7rjmoxmzTwquNaehOEGkjSXfpBhkLo2mATsQVa3WdtAWHj66C+8WXXphAfLFfE7jqSi/MZ0fu0KemTdfBnefjpvTira292err653hoThGn8CO00SyUfb+yUGbWtygNgvdh68+np768ReXaLDGOMUZwAAAAABJRU5ErkJggg=="

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAOlJREFUKBWFkUsSATEQhrsjHhs7B5hrsLR0AAtFcQKHcQKKcgHFkp0buIUdC4Z0mwzdNZkSskg//v/rpBKEzxqNJj1CbOYluSkzdHyOCEcwlZnPDfNluZzvfG795pcj2r6zcM8HOJcPcW8JfVAQjOmHyO9KwVoFNo+Hbf2yV6vPs+gKpkRtgHQvwreYEnSz/sFrRgzozFXyWCx6FDTG/gWLHgWtdX9BIrjIbRTk7I+kGYvZ4+hwBZMk0WYMLHryzxTjYDi+AXNd6iAi3terRUN6eqJvIHD01LIWgMAQBctaADLCSa5SjmXtBUt1SgNnHFhsAAAAAElFTkSuQmCC"

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAXtJREFUSA3dljFOxDAQRWccVsoRVqLhDBR7gpRQ0KQAAaHkAtDQIRpusBVhpVSUcAok7kCDxFYUIIFkksFhKTb2jMFxtiFVZvLnv4w8joPwx2vv4GiL6vqWk2OSbFezqzvumZ1DO7G7f3iGBJt2ngjWAWhi5xcx3iPCk/OM4KGqri+W82vLwfd9Q+fkJH9L0MS8EHftmGQHqDjVKnNuh4g3qwT+f29nStuWi6LY0BrGMe2PRvBcluWj7eGuoVFoTccEdGKLQ2Kt8dLoT+0adkoR8c0WhsaSBws0e+o1FGDrJQ8WiNgM0CHvIQDVAEDegwU2A6yh5MECsaH4DgUPFtgkFD00kgcLVHUS3aHkwQPVZzxQ8GCBaZpGAyUPFphlWTRQ8mCBeZ7X5tP0YX89AuL31oPTs8BWaP4Y+k+qZx+LQIT+e9FXKwKBIk4MT60INOdh78Hx1YpA8KwDNwydnKdWBJp/j5eOSUDgqxWBCtUUAOcBnB8pzhe1fOUX5dx0Ze1fER4AAAAASUVORK5CYII="

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAQBJREFUOBGtlMENwjAMRe1SIThxZSCmAAl1AMZhgCIhpmADhuDKFbiACP0kEgn5VhEFkUvt7++X1I2q8lxVVY2dK0Yxh94naLCMeXhqoQtFbxu1smyOdV0fQl5G8eawB9wg5oIUpSCAIS7lN6cXnwyDUEQVwAsSxQ/PX3o+IP9Y1pw1nc2vPu/n2ttY9bpZr9I40oyeDae3jbYAnHOJQKpCxdxoY+slEEQ7g6yXQIruJxIBjYFA/vhUtK+T5wo+PYO+mJEYL4H8Xeg8I+slEMwu+au0xDQGAnkzFVuak2Q3JRC++GrWS6BC+Lam7VsC6yWQSG/nf1/Hlj4jBU/wvtYDX5BS5taYdhsAAAAASUVORK5CYII="

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAclJREFUWAntl0FOwzAQRT1uJSq2XKAcA45SUHoADsABWHEADtAIuucSsOEAXbJjxQYqBFKTYSJkKWpnvl2UkViQjWPP+Od5PJk4FH5xzc7ni8BcwalE9fJ2MYc+ipG2x6rq4qgJHyfUtnHblvoc+JI5nKa+1hKFBwp0rdm6MY6xHYXDx7q+ee37jPud7n7TrJ/Efcrbhj37HbCA35vTmiZswvpZ7Md9HyUKPO07+N7vPksB8kXIqf85oBzwv/0/ArkI7BTGNEGq8adU44PUH7Ql+pIqPtE07beM+V2bMMgY0DaBpPS7ASFtE0gi8TZINHQRU9sEkm+ZW4SQtglETG5ASNsECo45hLRNIAmruc96WpSPIm0TSAxuW4a0TSB23DKkbQOxX4TkNGlG3wSSxHPLIaRtAkWwivL01T2RtgkkfwVmWPXHlI8ibRMIraL80bon0jaBiKJbDiFtE6ht7TdBX3f5KNI2gSYTv28Z0jaBomNSI23zCNttwOys2kgzKt+MIs9meVfv/MKnmWaEOgei4bctpwmBUIlPK9q3zWlCIHT23Rck+ec0IZCIeNQiqJkDekkrG7CFmhBoFMdXktqr4WBo9aNpK34DhimCuEn6aNcAAAAASUVORK5CYII="

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAStJREFUKBVjYMAB3kZ77QZhHNIMjNgk3sT5SDP8/fsELMfMLCOyaMtTdHVM6AIgPiMzM1wcmY2sFq4AWZAYNobG/1mhPAy/GHjhmoHs/7Gx3HA+lIGi8f+qUOZ3n74e+c/w6ypMIYj97v/boyA5mBiIZomOid8DpLn/M/2vYgxbtP9Lip/7j+9/DjMw/FeFKGS8zc7B4s4YtvpvVFycI+M/xjag+Fem////OwOxBdM/RgWQQp45m14yMTO7MDIyPgJhEBskBpIDqQGpBelBcSpIEgSEFm1+xMLC5ALCIDZEFJVkQeUiePwLttxG8DBZWG3EVIYpArfx/38G4+jouA+YShAiIDUwHkjjdyDm/M/wPxtIgzAe8B8m950JmFobgaH3DSZCiAarBeoBAEa1YrvOATzrAAAAAElFTkSuQmCC"

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAhZJREFUSA3tVT1PFFEUvfcBIXyY6KAiJBYmJusfsNI/IBQa6eDFXX6AhsIGKjtNbEz8KKzAGSrCRyHDL6ChUltIqAQLwJiIGxZmrvcOzu7b2ZlhZthY8ZLduffcc895eXvnLULOta9HxgDozWkbTg047mIeCcxD/ll5dNk7qX0Hot6gD/GP6u0btj4u/Mqqo7IShed5tVLdTAA29quHdyTMunIZImFHVDgOi3LMPJeh2Vg0vjAsenKJff/9SDsTt/Kv8LsycuMIu7okpZo3GOUr8K/vTz68KXg3HR/3z7o/ohwzT33xD/XjoSpUt4Gg22xKjBGOeqDnVp+ztJvEST3SoBHVOAJ6SQIhHnCYm2YmXBzX5efsOhw28nPdceaa7sc9/eAJEswS8w1ePWSQCKFy1Vn7VAc50LrM9y7cCzEfYKeTqa85aCyEu5w0GYrQwcRoP4H/vkFsRKjw6YDtNplJ1Qea4p/jfoMJkHqkJtGaX/2gAKdNTGLBLNuN3UiUe8qPQxMwa959xQYvw7LEgoV5lueZr0VUhA1mDvToJcEtZ3UmWj8rz20oglfsz88CYSd2hlI9Cxki8swWXJmHpqB+S9uFYcuRnBeIGRosTeiyfV5h6efJKgXfhlirIdE1JmqD09ZQIcJWWxVTxMRLEeLbFE5bS+LV8e3rl42V5ZU9/nu5zeoWf/JfH+nbIlbcVAgvHHvu3V9uf4mHpH87aAAAAABJRU5ErkJggg=="

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAU1JREFUOBHNUj9Lw0AUf+9iCloQ1Djo5NZV6DdwU6GrYJoW6+zW7+DS1VXU2MFVaN1cnfwADqKTDo04xaIpfb6XmD8tzVnBoQe5+93vH5dcEDTDb1TW+1/BrVjmC+ZW8fT6Jc+u8gThP4NBBQhK8oRYY9YWDQEKcTaLYy67aouyxt/w7BXhpCO/2bstAlpjrQRA5ciD97w+IODrSrvTHM/NjRPhHukOCa64zEh1KnPJJiDtpVyK0K7WfSJaQMRA4eqS67Z8kb3qdo3LzgggPDVPRKAOrHbnXHTHaRaH1HvnrMnZDyUlIghhGJ4pWIZ1eXOBCo+iHbcxjkuEE69kBEvH5FcTlcey2z3xnJ3FGIdkzqQtkozldo9zsiP07P1H/3Yi3LdrfMPJGCRoOpB8Ywb4zBe48ZNLhOl6IhciPCkwqAGIj38Jjng5SwoOvwFw02VEFk8ergAAAABJRU5ErkJggg=="

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAntJREFUWAntVr9rFEEUfm82YBQTzV0gYq+ClUVIZ2UhXCoDFt7FKGujgr1gL/4DJlUO422KFFp5q0GsLLUwhRYKgqRQi5yiRaJk5/neyYadvZ3sLyMpdmCZed/73ptv3wwzg1CiERFuzE3fQYLrkobNhbr35C4iIwUbFozrh/Vmp29o0vPRHArVzZrXXYhiecYqDznOJdDNLFics5tdShAQHh9InoQNkOxAOUH2vIU9laC00lUVqiqUVoE0/77bQ5mvjm9XG2coUMZByNfGIl9gx4y/RvyiFLlRDBV+Hnvgv4litvGQzRHHg21YAQpOxvEBmwXqAHwD1/Ce7VMGZjEyLxk6zgwibFjyWGGJkVgrIebIvGQS9/1yYzIgekEEo7E8iSaL+eEgnjva8V8nEhJAbM1eecvvmtOmD78OH3BOtNvtnyYOwE+Os5polV8/B+M+08ZNhXienyIvTRzAdd2RrV/BB84xEfXxO+qdGhQjFJrQWtej5HAsE/AmvYCAv0Ms3ouPqzOTJEa4f3ObYgQXLZn3kASErd7prpLCSzxxEGJh38cQmnXPfxZiefpCgmSC8U73MSG5vAl3nqsyJsBrLOZRHhFRbmFBfVHe04e8fLfChDIeX+4uhXaRPvM5ZEte6/j3e63GiFaAMrbxsuKlBclEtWX/XtYJ03illiwteRF/JSitalWFqgqlVSDNj83W3M7RHyXzzbvFl12iL8orMubcyKmHk2KtB6MtIClJXmy3/1R8IX7Km3Cv+KJFEeLzvZogb17RoobU4dsAuJ43+N/zcV20OGtrrzanpiaXgm06AohjPJF8XL3/0vj5hB/5W4HRQxe9xfneH/H9uAoTPzrLAAAAAElFTkSuQmCC"

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAXVJREFUKBVtUTFLw1AQvnu2DgpKs9pFEIcOpW4OgqOKoosUbBIaiBQdFAQ3l7o4K91EaLVpcag6SKGd/AuVDv4HRyHQWpvzXmtCXuwNue+7+753714QQqGb+UsgsAUKu1ott0Otf1AoFYJ9IlrwyHs1jPyB0osQxTgdF5uI8MHmuEdU03XrJKIP6FSAGHQ6na+VzNojwfc60yQAbaXTmVi3+/4W1kmM0YLkpnk+O/Q+nxhujPqIt8tLi8fFYtEbcf5MNMpmoVCIu26vQgA5yVn4rGnzuVKp1P/jMk0O3hUNw7omoFOpQMRmzbnfkVh5HFmIBiHy0HHwAcENY34xmuVVddMqA5EuezztRUvMBb9oopFNM67bb8hXHR2IeLe3u32UzWaH/oBgtF+wbVvr9X+avN/q2CSu6k7lwu/7WTHq+mEScNBmU4oFJBDOHOfhxheHs3JVgkGLd0rxPgMQaDkPlXpYHMaKUSA2PIIEAtpsaoWFUfwL06l6EFzmPRIAAAAASUVORK5CYII="

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAA0JJREFUSA2lVU1oE0EUntlNGimh9KAe/MOW/ok2SVMURC8VFIxFsAq1NrtJVCIERDyIIB7iVXpTgwSa1E0iotIiSqVF/C09aMX8HAq2SHtRpCiiTbH52fFND2F2N5tu4kDgvfe9+b6Zl/dmMdJZhBAsCL7rBJELBKEPHLIE4vHwN510w2FeL3N+fuE2iF0FvAF+HQgX+rqdXePJZPKn3h4jcU43CSORxQhBTfmCPOV2+5xsvFpbX5CgITUZiG4mSH4NpT6kxoz6uiXNZFJvOu2OLBAdhh9mCC3wn5622xyz6XRqlokbMnUF6e5MOjVtszkXECK94LLVMCGMT9lt9u8g+pHmGl0VBSlJJpNM2bqcnxAhJ8A1M8QYbtrb6XAU4WBvmXhFky1VxcRBj+cAKqJnMC6N6kTMoVtx6d4ljOkZKi/DgpRGEM7tKcqFCSjxFg0txg+s9RYxHA7nNRgTqEqQ7vN6vTtzeTIJoq0Mz5oJN5zk8Ka+WGyINlvZVbUgZfH5fJtWc/JzEO3WsuL3Jt7qkqQ7P7SYsvPK4WVj0Wh0aYOF74FhealNIPsKxeUpONR2LVajICWKRCJ/2lqaj0IZH2uJSUcuX5wWhPO71Bg7W2psXT8YDOZaW5r6McJ31cnwKm2TSW5MHf8vQYasyNglEz44Gn5TCa3BgBvWzc19kWD4+rXb8VezCdHHQrFq6lLKEAgErL9+Z0fhBaJvrXJh9BlZzEfuDw8vKgHlo6zGdH2/378xu7I6Dq/OXk0SRjMWM++inazBIKCpcbkkNiaK/h3Zlb9TZcUQetHYYO3RE6M8VQl6PJ7dRXl1GjqwnT0EtWE8Hra1Nh8LhULLaoz1DQuK4tn9+QJ5BzfbyhJQG2MUgvEYoGOixtS+oaYRBK9LJuQRiNWrCTjM3YjHR4LquJ6/ruDgoOiGto8CgWKEoIQyIvhiIjES0iMvF69Y0jOC5zKISWox8HNw0oFElWL0ALpffLdbvAbNcRNy1FVYRrzpeCI28pQSVLsUZWI3E4SvwOeHDdHuWOIx74pJkRklYNzTLylZK2WJCa65aOLqDsZitYtRMt2SptPJibHRJ3lojnYQe8Xz6KQkRRdKJ6jR+AfH7Q0LvNcZPwAAAABJRU5ErkJggg=="

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAhNJREFUOBGFU89rE1EQnnmbKLXWFqHXghJ78FJLQRFvgof+sI1QPMTNuouy6DFnL/HgvxAkmJq229aDYLGFohdBFI+GFuKhIBQEwR9QMRRikzfOi9nlvWYTBzYz38w3H5N57yFodstxJkHCYwCsJBN4u1wu72vlnqEwqixCBCNENHvYoPeO448Y9R7AECLER4goFZ/Fzjea9Q8Z173Qoz8qYRS1A9t205LkKsM+lWLh30Awv7Ky+LpNiXXGRIoRBOV1BHGVwx8K82QDgLCZybquwt3Miivs7FS+TEyMrzcJprh+mj+LFdNjY+Nye7vyNq6n46/pJM/zhut/5CbPdTHKIz4ZTZ25n8/nG1GOg55Ciuj7/onaQf0ZT3Q9bETArcHB/puFQqEW5jp2FBZCXywWD9Kz0ze4me/XPyOgyf1ftRchVv6/QopUrVYJkFrXQuGW8YmEofIJHcTFuVyub3f38xoBzGn1V0OnTs5r2FTVCypWy/72/ecbXQQFLIyeOzuj70dxuy7btu+kCA63+MmkFFGZQPGQ71m+BY78xApls96lJskNPqnhNr8hEP0gWHx6pD+CHRcy43hzQPIliwy1WTVLWGme5HnUFRMYQrbt3OV3FfCzOKa4iPA1YSWvLS8vvIvpNVLGEUrCByzSyrHIJzqevLy0VPpodHQBhpAlxD1e2h6PskED/VdWS6W9Ln0d6b+Fta1WGF9BHwAAAABJRU5ErkJggg=="

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAABC1JREFUWAm1WF1oFFcUPmdms5vEaNvYGlQUtUbbPBhBioqiDyIY1NbaEGVnd3byA30NKJS+SKDQh/6AEIqyJOvuzq4/URD7Y6zS0pZWF0FpgogSrLYP/QNjxFaT7MzcnmsJbnTO7Gx2vS975zvf/e6Xs/eePRMEj6Hr+kLLgTgCbCbakIJV75pm/zWPJWWHaC/3EY12vW47+a8BxKInDLyvKspu0zzy7ROssjOFk3PE5LHpZiRTvGA79qCm6RFuXbk4a0gALmDEgwIgrUVj7zPxsmDWECrYTco2o47CER9qWuzQwMCAynBmBLNnSKppevsOcJwTQohaVh3xi7ra0N54PP6Q5ZQQ8DQkdTTNeAPQ+VIImMfr4mVVqdlpmof/5jn+IkUNSZlwR8cymLDP0aFuZGURbwUD2JJMJkdYjo8Ae4YK1x5NJH4JqHXrCbtUiE+bC/HqZN65qOsdkjfj4cuQVE+nP7vbMG/uFkQ87bHby5ZtfROJGLs8OJ6hkm5ILpez3tn99snRsXv1IGAto1wFCG3Nq5pHh4eHLjMcFvZ1htxWhyOx/SDERxRjNRDh44yZeo+ySqXL32DF/CynsrBHOE6KjIVYPuLxuS/NMXp7eydYTkGgLENSJxyLbUIbzlCterFAd/oU4ftgQNlFN3BseuDZp7INSUlNa28CtAepVi1+dov/EfrarqtKqCWdjv/GcSTu+5Z5iWSzR64jVK9DwJ85HmWwyXbGc2HDWM1xJF4RQ1Iok4n/EQqpmygT5+Wz26AMzkdL/BCNtsv+ynVUzJBUTyQSDxqXL91OmUq67kYgZWq27ThsvKKGpkwIBGtq7vaJQAxmBBh8RnA0un/WyMjtk5SHFg+Bf4QK7Vycdcot4PCurq6Gh4/yX5GZNRyHztefZGbH0VTqCsvhAqXgkUjHSkc87gaW8OvwRrDqcTdwh+dU4JbRr/tGMnORMsObQfixpjqwgQqjpxlptKxDTc1+KzX9F8hMvRRzG/Q1naIqvbW/v3/ULf40NmND1El2A6Jsb6ufFp16pr78IJWBPZSZ8Sms2GfJh7qnp0cZuXX7U2ryuzlxyopDN3tfNps8yHE4vCRDhmFU5y1hUlZaWUHEcap+0Ww2fYrjeOG+61BnZ2f9o4n8GWrMNvKCOAoqvJlNpX/iOd4RXxmizCyZzItBOryv8XJ4R0F1WyaTuMlzikeKHmrqd9aQmVwRM1dqa6rWlWtG2vU0pOl6C1jiOzLTwP5tCGdV5ZXNfX19f7GcEgKsoUgk1iZs+Jy06lg9xL4Vy5e9ZZqf/MtySgywh1qAkFeWjSuoHMhkkh+UuF9ROpshIfB3t9VUY/IIqvE8zMj9WEMBNRimK/hroSky84Car+3UsqYK8UrO2RfFoaGrd5ub154AsFbS+9VCMnNVVQT99yzFv05XwNl/6OVT/iPZU50AAAAASUVORK5CYII="

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAMxJREFUKBWdkj0OwjAMhe2IqUMlzsIJGDgBW4XE3BP1BmxcAAZOwFmQOnRCMn5GRmnzU4kMiRS/L36Ozd3pfGOhjbTN8TIML6qsru+3PE5XYXoHg0j2NE53BEqcxVQjqgUTkImIn0SyK8EOmUa1YBgZlgFqm4PbLsUMLMFmW+15pvjBH5iFjdQSUErkAtczMIVNkkC4Ddj+WbOMyUfYiytWE0hrMq72OTlotR01yGvPaQJmL9cnh3BadrP+nTAwAQPLxI9ln2IwhqEF8wH5A7Mgp1L/NwAAAABJRU5ErkJggg=="

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAeFJREFUSA2tlj1OAzEQhceGJsoF6LkIBRWRAjWKEEJQhAtRgBCKovRQ0IAEF6GHA0RLAWvmOZrgRDNeb7IushvvzPvmedc/bjQ6PwkUbgLR3JO7nE4f3qnDxvoHNYU7R9R35MY+wkLYoxD261A/n55dHHbFgxY0oR2YARYDaZ4AevT789QFNGqwFmv3RH8xij5ccUclnTFgS6gGc859E7P8bDJ5o53dYVdQC8bvbwgWv8tF0wJjEVzMbHL/KnG5q6YBZ4Dxx/iC3CUQf7QE7q4wAk1QLXcdBobHj7QousHwajDWrFJnwlhxKJ2WgObUivXOH8swii6uKw7lQalTC4bCNBj0VYcCzgnGmLV5xn2N7zsLhKgJjcT/SV0CQ0ojEEEGFI+kNTqTwCIggjPQYhh01I8GD9o0X9fFhRcBM+5QV493hMcYU1BlY2UGTBb75U7ArMqae2kdWYcmDKuRsiKVODUd5mCyrpbEpO5wrwLbCLWJVYFtBSDSJmfFYZtEgNJWmrsEWgklX56ALY10l4lALVDbPEU4d9W0OH65Grl4bsRRLjldbQqTQmwoDTwOqV3CADX309rdeh7TvlS2rTPRsaBgMdCNGfRJzn0EH46snToVK71fOKUBtHnKf/EJ/PoP3k913AC/raUAAAAASUVORK5CYII="

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAQxJREFUOBGtlDFuAjEQRWfccA5OA0gUoYZdhZbjpEjaCEFNkBLBbXIOCjzhWVq0Btu7K2WK1crz//PM2LIuq/pNTOYqbrPbfZ5lQKxWr1MT/y4q3w6ImYy92Neyrmd9OWjx4IXhqERUL2I2Mq+HPjA0aPHghaFU8JRwtthvt6dUdTltAPWF5SD476AuWAnyBMrBWI9mkmg9qggD8bh7WGwGm4CQT4JIRLCgvJ1OBkLa8fmPSFYUVcMdI4a29gihncBpX8BEi1FFKUhzMUs5NrqDuoSIS5oAKgkAtCOn1apaT67mj13DLMGc6Ivzdv0YAgHI3MIhNK/G7U1yJvqjKr9Qm8G2d8/9o8WDF8YffIwqLSvJ3REAAAAASUVORK5CYII="

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAAkxJREFUWAnVmE1OwkAUx2dGBBeeAaOHcIHRIAu9AwkswHgnP2BD4iFcGKOJCw6hUa/ggu/x/RsGSpnOVynGWTDt9L33//HmdTotr7fbB2w47jLJjjnnb7JUuH7odD7ZFlqkPRjfkNQJ46xfLIi2mMPUaHBfSnnBh+OXRuPqMG8eaECLdC6hTQmpjSazjkBm4uJSsvJMjp7zhEJsaEArrg0WgWlaGaSTPKFSYUgXLAI1wzn72gaUCYZwvsEiUMCCF6t5Q9lgWGmnChauMmNyACyge737D2Xv05tiIzMRTLf7jpgLIJyYHEOhTDGTMGtAm4byhdECbQoqBAbaAj/JhlrJUugmmOjmQQHPayapvVJDyYu2wLpCt/nIYuE8DQb6RiAY2ATiUD62iK1rViA4uQjBTvs4oHGfO9QJCGI2KNisPZtozAcGMZyBYGyCwvVk84WBvxcQHFyhQmCCgFygQmEQW7sO4cJftf89Za71o7IbMnXOU1ZvtY5M6wzEFYjqQ3aeTlNmyozKAiBMwPEVXQHreiuQC4zauPnY6mAwZgQKEQjxicOlAmUJnMVXC5QloPq3oTHWgEIDKZB4HxJrBSgkQBxAd+wbc7EO2Ryx01N3k044bcx3OxxlyARDN+LKe1OasG3cpKHWMsDzZvO6PJ0NXnWbq03BKFgblCztnonpbHi3DRhA2aaPDye3gr4JVdQ/WPabmaZlvOWRGUpWBK3V/aU5jvKDUTqpUMQi8BmNoJ7I+Ie+zzyyvcKp6b1JBc3aAwo1E2mSNhjA8gsmUHzBskGNUAAAAABJRU5ErkJggg=="

/***/ }),
/* 482 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = require("detect-browser");

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = require("iconv-lite");

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = require("react-dates");

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = require("react-google-recaptcha");

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports = require("react-redux");

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports = require("react-svg-inline");

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = require("redux");

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = require("uuid");

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(117);


/***/ })
/******/ ])));


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms/dist/index.js
// module id = 720
// module chunks = 0